// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23dee2e6%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27m6 10 3 3 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%280, 0, 0, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%2386b7fe%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28255, 255, 255, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23198754%27 d=%27M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23dc3545%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23dc3545%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%2833, 37, 41, 0.75%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27none%27 stroke=%27%23212529%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpath d=%27M2 5L8 11L14 5%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27none%27 stroke=%27%23052c65%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpath d=%27M2 5L8 11L14 5%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%236ea8fe%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";

.rate-calculator {
    --bs-blue: #0d6efd;
    --bs-indigo: #6610f2;
    --bs-purple: #6f42c1;
    --bs-pink: #d63384;
    --bs-red: #dc3545;
    --bs-orange: #fd7e14;
    --bs-yellow: #ffc107;
    --bs-green: #198754;
    --bs-teal: #20c997;
    --bs-cyan: #0dcaf0;
    --bs-black: #000;
    --bs-white: #fff;
    --bs-gray: #6c757d;
    --bs-gray-dark: #343a40;
    --bs-gray-100: #f8f9fa;
    --bs-gray-200: #e9ecef;
    --bs-gray-300: #dee2e6;
    --bs-gray-400: #ced4da;
    --bs-gray-500: #adb5bd;
    --bs-gray-600: #6c757d;
    --bs-gray-700: #495057;
    --bs-gray-800: #343a40;
    --bs-gray-900: #212529;
    --bs-primary: #0d6efd;
    --bs-secondary: #6c757d;
    --bs-success: #198754;
    --bs-info: #0dcaf0;
    --bs-warning: #ffc107;
    --bs-danger: #dc3545;
    --bs-light: #f8f9fa;
    --bs-dark: #212529;
    --bs-primary-rgb: 13, 110, 253;
    --bs-secondary-rgb: 108, 117, 125;
    --bs-success-rgb: 25, 135, 84;
    --bs-info-rgb: 13, 202, 240;
    --bs-warning-rgb: 255, 193, 7;
    --bs-danger-rgb: 220, 53, 69;
    --bs-light-rgb: 248, 249, 250;
    --bs-dark-rgb: 33, 37, 41;
    --bs-primary-text-emphasis: #052c65;
    --bs-secondary-text-emphasis: #2b2f32;
    --bs-success-text-emphasis: #0a3622;
    --bs-info-text-emphasis: #055160;
    --bs-warning-text-emphasis: #664d03;
    --bs-danger-text-emphasis: #58151c;
    --bs-light-text-emphasis: #495057;
    --bs-dark-text-emphasis: #495057;
    --bs-primary-bg-subtle: #cfe2ff;
    --bs-secondary-bg-subtle: #e2e3e5;
    --bs-success-bg-subtle: #d1e7dd;
    --bs-info-bg-subtle: #cff4fc;
    --bs-warning-bg-subtle: #fff3cd;
    --bs-danger-bg-subtle: #f8d7da;
    --bs-light-bg-subtle: #fcfcfd;
    --bs-dark-bg-subtle: #ced4da;
    --bs-primary-border-subtle: #9ec5fe;
    --bs-secondary-border-subtle: #c4c8cb;
    --bs-success-border-subtle: #a3cfbb;
    --bs-info-border-subtle: #9eeaf9;
    --bs-warning-border-subtle: #ffe69c;
    --bs-danger-border-subtle: #f1aeb5;
    --bs-light-border-subtle: #e9ecef;
    --bs-dark-border-subtle: #adb5bd;
    --bs-white-rgb: 255, 255, 255;
    --bs-black-rgb: 0, 0, 0;
    --bs-font-sans-serif: system-ui, -apple-system, 'Segoe UI', Roboto,
        'Helvetica Neue', 'Noto Sans', 'Liberation Sans', Arial, sans-serif,
        'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
        'Noto Color Emoji';
    --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas,
        'Liberation Mono', 'Courier New', monospace;
    --bs-gradient: linear-gradient(
        180deg,
        rgba(255, 255, 255, 0.15),
        rgba(255, 255, 255, 0)
    );
    --bs-body-font-family: var(--bs-font-sans-serif);
    --bs-body-font-size: 1rem;
    --bs-body-font-weight: 400;
    --bs-body-line-height: 1.5;
    --bs-body-color: #212529;
    --bs-body-color-rgb: 33, 37, 41;
    --bs-body-bg: #fff;
    --bs-body-bg-rgb: 255, 255, 255;
    --bs-emphasis-color: #000;
    --bs-emphasis-color-rgb: 0, 0, 0;
    --bs-secondary-color: rgba(33, 37, 41, 0.75);
    --bs-secondary-color-rgb: 33, 37, 41;
    --bs-secondary-bg: #e9ecef;
    --bs-secondary-bg-rgb: 233, 236, 239;
    --bs-tertiary-color: rgba(33, 37, 41, 0.5);
    --bs-tertiary-color-rgb: 33, 37, 41;
    --bs-tertiary-bg: #f8f9fa;
    --bs-tertiary-bg-rgb: 248, 249, 250;
    --bs-heading-color: inherit;
    --bs-link-color: #0d6efd;
    --bs-link-color-rgb: 13, 110, 253;
    --bs-link-decoration: underline;
    --bs-link-hover-color: #0a58ca;
    --bs-link-hover-color-rgb: 10, 88, 202;
    --bs-code-color: #d63384;
    --bs-highlight-color: #212529;
    --bs-highlight-bg: #fff3cd;
    --bs-border-width: 1px;
    --bs-border-style: solid;
    --bs-border-color: #dee2e6;
    --bs-border-color-translucent: rgba(0, 0, 0, 0.175);
    --bs-border-radius: 0.375rem;
    --bs-border-radius-sm: 0.25rem;
    --bs-border-radius-lg: 0.5rem;
    --bs-border-radius-xl: 1rem;
    --bs-border-radius-xxl: 2rem;
    --bs-border-radius-2xl: var(--bs-border-radius-xxl);
    --bs-border-radius-pill: 50rem;
    --bs-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
    --bs-box-shadow-sm: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
    --bs-box-shadow-lg: 0 1rem 3rem rgba(0, 0, 0, 0.175);
    --bs-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);
    --bs-focus-ring-width: 0.25rem;
    --bs-focus-ring-opacity: 0.25;
    --bs-focus-ring-color: rgba(13, 110, 253, 0.25);
    --bs-form-valid-color: #198754;
    --bs-form-valid-border-color: #198754;
    --bs-form-invalid-color: #dc3545;
    --bs-form-invalid-border-color: #dc3545;

    *,
    *::before,
    *::after {
        box-sizing: border-box;
    }

    @media (prefers-reduced-motion: no-preference) {
        :root {
            scroll-behavior: smooth;
        }
    }

    body {
        margin: 0;
        font-family: var(--bs-body-font-family);
        font-size: var(--bs-body-font-size);
        font-weight: var(--bs-body-font-weight);
        line-height: var(--bs-body-line-height);
        color: var(--bs-body-color);
        text-align: var(--bs-body-text-align);
        background-color: var(--bs-body-bg);
        -webkit-text-size-adjust: 100%;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    }

    hr {
        margin: 1rem 0;
        color: inherit;
        border: 0;
        border-top: var(--bs-border-width) solid;
        opacity: 0.25;
    }

    h6,
    .h6,
    h5,
    .h5,
    h4,
    .h4,
    h3,
    .h3,
    h2,
    .h2,
    h1,
    .h1 {
        margin-top: 0;
        margin-bottom: 0.5rem;
        font-weight: 500;
        line-height: 1.2;
        color: var(--bs-heading-color);
    }

    h1,
    .h1 {
        font-size: calc(1.375rem + 1.5vw);
    }
    @media (min-width: 1200px) {
        h1,
        .h1 {
            font-size: 2.5rem;
        }
    }

    h2,
    .h2 {
        font-size: calc(1.325rem + 0.9vw);
    }
    @media (min-width: 1200px) {
        h2,
        .h2 {
            font-size: 2rem;
        }
    }

    h3,
    .h3 {
        font-size: calc(1.3rem + 0.6vw);
    }
    @media (min-width: 1200px) {
        h3,
        .h3 {
            font-size: 1.75rem;
        }
    }

    h4,
    .h4 {
        font-size: calc(1.275rem + 0.3vw);
    }
    @media (min-width: 1200px) {
        h4,
        .h4 {
            font-size: 1.5rem;
        }
    }

    h5,
    .h5 {
        font-size: 1.25rem;
    }

    h6,
    .h6 {
        font-size: 1rem;
    }

    p {
        margin-top: 0;
        margin-bottom: 1rem;
    }

    abbr[title] {
        -webkit-text-decoration: underline dotted;
        text-decoration: underline dotted;
        cursor: help;
        -webkit-text-decoration-skip-ink: none;
        text-decoration-skip-ink: none;
    }

    address {
        margin-bottom: 1rem;
        font-style: normal;
        line-height: inherit;
    }

    ol,
    ul {
        padding-left: 2rem;
    }

    ol,
    ul,
    dl {
        margin-top: 0;
        margin-bottom: 1rem;
    }

    ol ol,
    ul ul,
    ol ul,
    ul ol {
        margin-bottom: 0;
    }

    dt {
        font-weight: 700;
    }

    dd {
        margin-bottom: 0.5rem;
        margin-left: 0;
    }

    blockquote {
        margin: 0 0 1rem;
    }

    b,
    strong {
        font-weight: bolder;
    }

    small,
    .small {
        font-size: 0.875em;
    }

    mark,
    .mark {
        padding: 0.1875em;
        color: var(--bs-highlight-color);
        background-color: var(--bs-highlight-bg);
    }

    sub,
    sup {
        position: relative;
        font-size: 0.75em;
        line-height: 0;
        vertical-align: baseline;
    }

    sub {
        bottom: -0.25em;
    }

    sup {
        top: -0.5em;
    }

    a {
        color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));
        text-decoration: underline;
    }
    a:hover {
        --bs-link-color-rgb: var(--bs-link-hover-color-rgb);
    }

    a:not([href]):not([class]),
    a:not([href]):not([class]):hover {
        color: inherit;
        text-decoration: none;
    }

    pre,
    code,
    kbd,
    samp {
        font-family: var(--bs-font-monospace);
        font-size: 1em;
    }

    pre {
        display: block;
        margin-top: 0;
        margin-bottom: 1rem;
        overflow: auto;
        font-size: 0.875em;
    }
    pre code {
        font-size: inherit;
        color: inherit;
        word-break: normal;
    }

    code {
        font-size: 0.875em;
        color: var(--bs-code-color);
        word-wrap: break-word;
    }
    a > code {
        color: inherit;
    }

    kbd {
        padding: 0.1875rem 0.375rem;
        font-size: 0.875em;
        color: var(--bs-body-bg);
        background-color: var(--bs-body-color);
        border-radius: 0.25rem;
    }
    kbd kbd {
        padding: 0;
        font-size: 1em;
    }

    figure {
        margin: 0 0 1rem;
    }

    img,
    svg {
        vertical-align: middle;
    }

    table {
        caption-side: bottom;
        border-collapse: collapse;
    }

    caption {
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
        color: var(--bs-secondary-color);
        text-align: left;
    }

    th {
        text-align: inherit;
        text-align: -webkit-match-parent;
    }

    thead,
    tbody,
    tfoot,
    tr,
    td,
    th {
        border-color: inherit;
        border-style: solid;
        border-width: 0;
    }

    label {
        display: inline-block;
    }

    button {
        border-radius: 0;
    }

    button:focus:not(:focus-visible) {
        outline: 0;
    }

    input,
    button,
    select,
    optgroup,
    textarea {
        margin: 0;
        font-family: inherit;
        font-size: inherit;
        line-height: inherit;
    }

    button,
    select {
        text-transform: none;
    }

    [role='button'] {
        cursor: pointer;
    }

    select {
        word-wrap: normal;
    }
    select:disabled {
        opacity: 1;
    }

    [list]:not([type='date']):not([type='datetime-local']):not(
            [type='month']
        ):not([type='week']):not(
            [type='time']
        )::-webkit-calendar-picker-indicator {
        display: none !important;
    }

    button,
    [type='button'],
    [type='reset'],
    [type='submit'] {
        -webkit-appearance: button;
    }
    button:not(:disabled),
    [type='button']:not(:disabled),
    [type='reset']:not(:disabled),
    [type='submit']:not(:disabled) {
        cursor: pointer;
    }

    ::-moz-focus-inner {
        padding: 0;
        border-style: none;
    }

    textarea {
        resize: vertical;
    }

    fieldset {
        min-width: 0;
        padding: 0;
        margin: 0;
        border: 0;
    }

    legend {
        float: left;
        width: 100%;
        padding: 0;
        margin-bottom: 0.5rem;
        font-size: calc(1.275rem + 0.3vw);
        line-height: inherit;
    }
    @media (min-width: 1200px) {
        legend {
            font-size: 1.5rem;
        }
    }
    legend + * {
        clear: left;
    }

    ::-webkit-datetime-edit-fields-wrapper,
    ::-webkit-datetime-edit-text,
    ::-webkit-datetime-edit-minute,
    ::-webkit-datetime-edit-hour-field,
    ::-webkit-datetime-edit-day-field,
    ::-webkit-datetime-edit-month-field,
    ::-webkit-datetime-edit-year-field {
        padding: 0;
    }

    ::-webkit-inner-spin-button {
        height: auto;
    }

    [type='search'] {
        -webkit-appearance: textfield;
        outline-offset: -2px;
    }

    /* rtl:raw:
    [type="tel"],
    [type="url"],
    [type="email"],
    [type="number"] {
    direction: ltr;
    }
    */
    ::-webkit-search-decoration {
        -webkit-appearance: none;
    }

    ::-webkit-color-swatch-wrapper {
        padding: 0;
    }

    ::-webkit-file-upload-button {
        font: inherit;
        -webkit-appearance: button;
    }

    ::file-selector-button {
        font: inherit;
        -webkit-appearance: button;
    }

    output {
        display: inline-block;
    }

    iframe {
        border: 0;
    }

    summary {
        display: list-item;
        cursor: pointer;
    }

    progress {
        vertical-align: baseline;
    }

    [hidden] {
        display: none !important;
    }

    .lead {
        font-size: 1.25rem;
        font-weight: 300;
    }

    .display-1 {
        font-size: calc(1.625rem + 4.5vw);
        font-weight: 300;
        line-height: 1.2;
    }
    @media (min-width: 1200px) {
        .display-1 {
            font-size: 5rem;
        }
    }

    .display-2 {
        font-size: calc(1.575rem + 3.9vw);
        font-weight: 300;
        line-height: 1.2;
    }
    @media (min-width: 1200px) {
        .display-2 {
            font-size: 4.5rem;
        }
    }

    .display-3 {
        font-size: calc(1.525rem + 3.3vw);
        font-weight: 300;
        line-height: 1.2;
    }
    @media (min-width: 1200px) {
        .display-3 {
            font-size: 4rem;
        }
    }

    .display-4 {
        font-size: calc(1.475rem + 2.7vw);
        font-weight: 300;
        line-height: 1.2;
    }
    @media (min-width: 1200px) {
        .display-4 {
            font-size: 3.5rem;
        }
    }

    .display-5 {
        font-size: calc(1.425rem + 2.1vw);
        font-weight: 300;
        line-height: 1.2;
    }
    @media (min-width: 1200px) {
        .display-5 {
            font-size: 3rem;
        }
    }

    .display-6 {
        font-size: calc(1.375rem + 1.5vw);
        font-weight: 300;
        line-height: 1.2;
    }
    @media (min-width: 1200px) {
        .display-6 {
            font-size: 2.5rem;
        }
    }

    .list-unstyled {
        padding-left: 0;
        list-style: none;
    }

    .list-inline {
        padding-left: 0;
        list-style: none;
    }

    .list-inline-item {
        display: inline-block;
    }
    .list-inline-item:not(:last-child) {
        margin-right: 0.5rem;
    }

    .initialism {
        font-size: 0.875em;
        text-transform: uppercase;
    }

    .blockquote {
        margin-bottom: 1rem;
        font-size: 1.25rem;
    }
    .blockquote > :last-child {
        margin-bottom: 0;
    }

    .blockquote-footer {
        margin-top: -1rem;
        margin-bottom: 1rem;
        font-size: 0.875em;
        color: #6c757d;
    }
    .blockquote-footer::before {
        content: '— ';
    }

    .img-fluid {
        max-width: 100%;
        height: auto;
    }

    .img-thumbnail {
        padding: 0.25rem;
        background-color: var(--bs-body-bg);
        border: var(--bs-border-width) solid var(--bs-border-color);
        border-radius: var(--bs-border-radius);
        max-width: 100%;
        height: auto;
    }

    .figure {
        display: inline-block;
    }

    .figure-img {
        margin-bottom: 0.5rem;
        line-height: 1;
    }

    .figure-caption {
        font-size: 0.875em;
        color: var(--bs-secondary-color);
    }

    .container,
    .container-fluid,
    .container-xxl,
    .container-xl,
    .container-lg,
    .container-md,
    .container-sm {
        --bs-gutter-x: 1.5rem;
        --bs-gutter-y: 0;
        width: 100%;
        padding-right: calc(var(--bs-gutter-x) * 0.5);
        padding-left: calc(var(--bs-gutter-x) * 0.5);
        margin-right: auto;
        margin-left: auto;
    }

    @media (min-width: 576px) {
        .container-sm,
        .container {
            max-width: 540px;
        }
    }
    @media (min-width: 768px) {
        .container-md,
        .container-sm,
        .container {
            max-width: 720px;
        }
    }
    @media (min-width: 992px) {
        .container-lg,
        .container-md,
        .container-sm,
        .container {
            max-width: 960px;
        }
    }
    @media (min-width: 1200px) {
        .container-xl,
        .container-lg,
        .container-md,
        .container-sm,
        .container {
            max-width: 1140px;
        }
    }
    @media (min-width: 1400px) {
        .container-xxl,
        .container-xl,
        .container-lg,
        .container-md,
        .container-sm,
        .container {
            max-width: 1320px;
        }
    }
    :root {
        --bs-breakpoint-xs: 0;
        --bs-breakpoint-sm: 576px;
        --bs-breakpoint-md: 768px;
        --bs-breakpoint-lg: 992px;
        --bs-breakpoint-xl: 1200px;
        --bs-breakpoint-xxl: 1400px;
    }

    .row {
        --bs-gutter-x: 1.5rem;
        --bs-gutter-y: 0;
        display: flex;
        flex-wrap: wrap;
        margin-top: calc(-1 * var(--bs-gutter-y));
        margin-right: calc(-0.5 * var(--bs-gutter-x));
        margin-left: calc(-0.5 * var(--bs-gutter-x));
    }
    .row > * {
        flex-shrink: 0;
        width: 100%;
        max-width: 100%;
        padding-right: calc(var(--bs-gutter-x) * 0.5);
        padding-left: calc(var(--bs-gutter-x) * 0.5);
        margin-top: var(--bs-gutter-y);
    }

    .col {
        flex: 1 0 0%;
    }

    .row-cols-auto > * {
        flex: 0 0 auto;
        width: auto;
    }

    .row-cols-1 > * {
        flex: 0 0 auto;
        width: 100%;
    }

    .row-cols-2 > * {
        flex: 0 0 auto;
        width: 50%;
    }

    .row-cols-3 > * {
        flex: 0 0 auto;
        width: 33.33333333%;
    }

    .row-cols-4 > * {
        flex: 0 0 auto;
        width: 25%;
    }

    .row-cols-5 > * {
        flex: 0 0 auto;
        width: 20%;
    }

    .row-cols-6 > * {
        flex: 0 0 auto;
        width: 16.66666667%;
    }

    .col-auto {
        flex: 0 0 auto;
        width: auto;
    }

    .col-1 {
        flex: 0 0 auto;
        width: 8.33333333%;
    }

    .col-2 {
        flex: 0 0 auto;
        width: 16.66666667%;
    }

    .col-3 {
        flex: 0 0 auto;
        width: 25%;
    }

    .col-4 {
        flex: 0 0 auto;
        width: 33.33333333%;
    }

    .col-5 {
        flex: 0 0 auto;
        width: 41.66666667%;
    }

    .col-6 {
        flex: 0 0 auto;
        width: 50%;
    }

    .col-7 {
        flex: 0 0 auto;
        width: 58.33333333%;
    }

    .col-8 {
        flex: 0 0 auto;
        width: 66.66666667%;
    }

    .col-9 {
        flex: 0 0 auto;
        width: 75%;
    }

    .col-10 {
        flex: 0 0 auto;
        width: 83.33333333%;
    }

    .col-11 {
        flex: 0 0 auto;
        width: 91.66666667%;
    }

    .col-12 {
        flex: 0 0 auto;
        width: 100%;
    }

    .offset-1 {
        margin-left: 8.33333333%;
    }

    .offset-2 {
        margin-left: 16.66666667%;
    }

    .offset-3 {
        margin-left: 25%;
    }

    .offset-4 {
        margin-left: 33.33333333%;
    }

    .offset-5 {
        margin-left: 41.66666667%;
    }

    .offset-6 {
        margin-left: 50%;
    }

    .offset-7 {
        margin-left: 58.33333333%;
    }

    .offset-8 {
        margin-left: 66.66666667%;
    }

    .offset-9 {
        margin-left: 75%;
    }

    .offset-10 {
        margin-left: 83.33333333%;
    }

    .offset-11 {
        margin-left: 91.66666667%;
    }

    .g-0,
    .gx-0 {
        --bs-gutter-x: 0;
    }

    .g-0,
    .gy-0 {
        --bs-gutter-y: 0;
    }

    .g-1,
    .gx-1 {
        --bs-gutter-x: 0.25rem;
    }

    .g-1,
    .gy-1 {
        --bs-gutter-y: 0.25rem;
    }

    .g-2,
    .gx-2 {
        --bs-gutter-x: 0.5rem;
    }

    .g-2,
    .gy-2 {
        --bs-gutter-y: 0.5rem;
    }

    .g-3,
    .gx-3 {
        --bs-gutter-x: 1rem;
    }

    .g-3,
    .gy-3 {
        --bs-gutter-y: 1rem;
    }

    .g-4,
    .gx-4 {
        --bs-gutter-x: 1.5rem;
    }

    .g-4,
    .gy-4 {
        --bs-gutter-y: 1.5rem;
    }

    .g-5,
    .gx-5 {
        --bs-gutter-x: 3rem;
    }

    .g-5,
    .gy-5 {
        --bs-gutter-y: 3rem;
    }

    @media (min-width: 576px) {
        .col-sm {
            flex: 1 0 0%;
        }
        .row-cols-sm-auto > * {
            flex: 0 0 auto;
            width: auto;
        }
        .row-cols-sm-1 > * {
            flex: 0 0 auto;
            width: 100%;
        }
        .row-cols-sm-2 > * {
            flex: 0 0 auto;
            width: 50%;
        }
        .row-cols-sm-3 > * {
            flex: 0 0 auto;
            width: 33.33333333%;
        }
        .row-cols-sm-4 > * {
            flex: 0 0 auto;
            width: 25%;
        }
        .row-cols-sm-5 > * {
            flex: 0 0 auto;
            width: 20%;
        }
        .row-cols-sm-6 > * {
            flex: 0 0 auto;
            width: 16.66666667%;
        }
        .col-sm-auto {
            flex: 0 0 auto;
            width: auto;
        }
        .col-sm-1 {
            flex: 0 0 auto;
            width: 8.33333333%;
        }
        .col-sm-2 {
            flex: 0 0 auto;
            width: 16.66666667%;
        }
        .col-sm-3 {
            flex: 0 0 auto;
            width: 25%;
        }
        .col-sm-4 {
            flex: 0 0 auto;
            width: 33.33333333%;
        }
        .col-sm-5 {
            flex: 0 0 auto;
            width: 41.66666667%;
        }
        .col-sm-6 {
            flex: 0 0 auto;
            width: 50%;
        }
        .col-sm-7 {
            flex: 0 0 auto;
            width: 58.33333333%;
        }
        .col-sm-8 {
            flex: 0 0 auto;
            width: 66.66666667%;
        }
        .col-sm-9 {
            flex: 0 0 auto;
            width: 75%;
        }
        .col-sm-10 {
            flex: 0 0 auto;
            width: 83.33333333%;
        }
        .col-sm-11 {
            flex: 0 0 auto;
            width: 91.66666667%;
        }
        .col-sm-12 {
            flex: 0 0 auto;
            width: 100%;
        }
        .offset-sm-0 {
            margin-left: 0;
        }
        .offset-sm-1 {
            margin-left: 8.33333333%;
        }
        .offset-sm-2 {
            margin-left: 16.66666667%;
        }
        .offset-sm-3 {
            margin-left: 25%;
        }
        .offset-sm-4 {
            margin-left: 33.33333333%;
        }
        .offset-sm-5 {
            margin-left: 41.66666667%;
        }
        .offset-sm-6 {
            margin-left: 50%;
        }
        .offset-sm-7 {
            margin-left: 58.33333333%;
        }
        .offset-sm-8 {
            margin-left: 66.66666667%;
        }
        .offset-sm-9 {
            margin-left: 75%;
        }
        .offset-sm-10 {
            margin-left: 83.33333333%;
        }
        .offset-sm-11 {
            margin-left: 91.66666667%;
        }
        .g-sm-0,
        .gx-sm-0 {
            --bs-gutter-x: 0;
        }
        .g-sm-0,
        .gy-sm-0 {
            --bs-gutter-y: 0;
        }
        .g-sm-1,
        .gx-sm-1 {
            --bs-gutter-x: 0.25rem;
        }
        .g-sm-1,
        .gy-sm-1 {
            --bs-gutter-y: 0.25rem;
        }
        .g-sm-2,
        .gx-sm-2 {
            --bs-gutter-x: 0.5rem;
        }
        .g-sm-2,
        .gy-sm-2 {
            --bs-gutter-y: 0.5rem;
        }
        .g-sm-3,
        .gx-sm-3 {
            --bs-gutter-x: 1rem;
        }
        .g-sm-3,
        .gy-sm-3 {
            --bs-gutter-y: 1rem;
        }
        .g-sm-4,
        .gx-sm-4 {
            --bs-gutter-x: 1.5rem;
        }
        .g-sm-4,
        .gy-sm-4 {
            --bs-gutter-y: 1.5rem;
        }
        .g-sm-5,
        .gx-sm-5 {
            --bs-gutter-x: 3rem;
        }
        .g-sm-5,
        .gy-sm-5 {
            --bs-gutter-y: 3rem;
        }
    }
    @media (min-width: 768px) {
        .col-md {
            flex: 1 0 0%;
        }
        .row-cols-md-auto > * {
            flex: 0 0 auto;
            width: auto;
        }
        .row-cols-md-1 > * {
            flex: 0 0 auto;
            width: 100%;
        }
        .row-cols-md-2 > * {
            flex: 0 0 auto;
            width: 50%;
        }
        .row-cols-md-3 > * {
            flex: 0 0 auto;
            width: 33.33333333%;
        }
        .row-cols-md-4 > * {
            flex: 0 0 auto;
            width: 25%;
        }
        .row-cols-md-5 > * {
            flex: 0 0 auto;
            width: 20%;
        }
        .row-cols-md-6 > * {
            flex: 0 0 auto;
            width: 16.66666667%;
        }
        .col-md-auto {
            flex: 0 0 auto;
            width: auto;
        }
        .col-md-1 {
            flex: 0 0 auto;
            width: 8.33333333%;
        }
        .col-md-2 {
            flex: 0 0 auto;
            width: 16.66666667%;
        }
        .col-md-3 {
            flex: 0 0 auto;
            width: 25%;
        }
        .col-md-4 {
            flex: 0 0 auto;
            width: 33.33333333%;
        }
        .col-md-5 {
            flex: 0 0 auto;
            width: 41.66666667%;
        }
        .col-md-6 {
            flex: 0 0 auto;
            width: 50%;
        }
        .col-md-7 {
            flex: 0 0 auto;
            width: 58.33333333%;
        }
        .col-md-8 {
            flex: 0 0 auto;
            width: 66.66666667%;
        }
        .col-md-9 {
            flex: 0 0 auto;
            width: 75%;
        }
        .col-md-10 {
            flex: 0 0 auto;
            width: 83.33333333%;
        }
        .col-md-11 {
            flex: 0 0 auto;
            width: 91.66666667%;
        }
        .col-md-12 {
            flex: 0 0 auto;
            width: 100%;
        }
        .offset-md-0 {
            margin-left: 0;
        }
        .offset-md-1 {
            margin-left: 8.33333333%;
        }
        .offset-md-2 {
            margin-left: 16.66666667%;
        }
        .offset-md-3 {
            margin-left: 25%;
        }
        .offset-md-4 {
            margin-left: 33.33333333%;
        }
        .offset-md-5 {
            margin-left: 41.66666667%;
        }
        .offset-md-6 {
            margin-left: 50%;
        }
        .offset-md-7 {
            margin-left: 58.33333333%;
        }
        .offset-md-8 {
            margin-left: 66.66666667%;
        }
        .offset-md-9 {
            margin-left: 75%;
        }
        .offset-md-10 {
            margin-left: 83.33333333%;
        }
        .offset-md-11 {
            margin-left: 91.66666667%;
        }
        .g-md-0,
        .gx-md-0 {
            --bs-gutter-x: 0;
        }
        .g-md-0,
        .gy-md-0 {
            --bs-gutter-y: 0;
        }
        .g-md-1,
        .gx-md-1 {
            --bs-gutter-x: 0.25rem;
        }
        .g-md-1,
        .gy-md-1 {
            --bs-gutter-y: 0.25rem;
        }
        .g-md-2,
        .gx-md-2 {
            --bs-gutter-x: 0.5rem;
        }
        .g-md-2,
        .gy-md-2 {
            --bs-gutter-y: 0.5rem;
        }
        .g-md-3,
        .gx-md-3 {
            --bs-gutter-x: 1rem;
        }
        .g-md-3,
        .gy-md-3 {
            --bs-gutter-y: 1rem;
        }
        .g-md-4,
        .gx-md-4 {
            --bs-gutter-x: 1.5rem;
        }
        .g-md-4,
        .gy-md-4 {
            --bs-gutter-y: 1.5rem;
        }
        .g-md-5,
        .gx-md-5 {
            --bs-gutter-x: 3rem;
        }
        .g-md-5,
        .gy-md-5 {
            --bs-gutter-y: 3rem;
        }
    }
    @media (min-width: 992px) {
        .col-lg {
            flex: 1 0 0%;
        }
        .row-cols-lg-auto > * {
            flex: 0 0 auto;
            width: auto;
        }
        .row-cols-lg-1 > * {
            flex: 0 0 auto;
            width: 100%;
        }
        .row-cols-lg-2 > * {
            flex: 0 0 auto;
            width: 50%;
        }
        .row-cols-lg-3 > * {
            flex: 0 0 auto;
            width: 33.33333333%;
        }
        .row-cols-lg-4 > * {
            flex: 0 0 auto;
            width: 25%;
        }
        .row-cols-lg-5 > * {
            flex: 0 0 auto;
            width: 20%;
        }
        .row-cols-lg-6 > * {
            flex: 0 0 auto;
            width: 16.66666667%;
        }
        .col-lg-auto {
            flex: 0 0 auto;
            width: auto;
        }
        .col-lg-1 {
            flex: 0 0 auto;
            width: 8.33333333%;
        }
        .col-lg-2 {
            flex: 0 0 auto;
            width: 16.66666667%;
        }
        .col-lg-3 {
            flex: 0 0 auto;
            width: 25%;
        }
        .col-lg-4 {
            flex: 0 0 auto;
            width: 33.33333333%;
        }
        .col-lg-5 {
            flex: 0 0 auto;
            width: 41.66666667%;
        }
        .col-lg-6 {
            flex: 0 0 auto;
            width: 50%;
        }
        .col-lg-7 {
            flex: 0 0 auto;
            width: 58.33333333%;
        }
        .col-lg-8 {
            flex: 0 0 auto;
            width: 66.66666667%;
        }
        .col-lg-9 {
            flex: 0 0 auto;
            width: 75%;
        }
        .col-lg-10 {
            flex: 0 0 auto;
            width: 83.33333333%;
        }
        .col-lg-11 {
            flex: 0 0 auto;
            width: 91.66666667%;
        }
        .col-lg-12 {
            flex: 0 0 auto;
            width: 100%;
        }
        .offset-lg-0 {
            margin-left: 0;
        }
        .offset-lg-1 {
            margin-left: 8.33333333%;
        }
        .offset-lg-2 {
            margin-left: 16.66666667%;
        }
        .offset-lg-3 {
            margin-left: 25%;
        }
        .offset-lg-4 {
            margin-left: 33.33333333%;
        }
        .offset-lg-5 {
            margin-left: 41.66666667%;
        }
        .offset-lg-6 {
            margin-left: 50%;
        }
        .offset-lg-7 {
            margin-left: 58.33333333%;
        }
        .offset-lg-8 {
            margin-left: 66.66666667%;
        }
        .offset-lg-9 {
            margin-left: 75%;
        }
        .offset-lg-10 {
            margin-left: 83.33333333%;
        }
        .offset-lg-11 {
            margin-left: 91.66666667%;
        }
        .g-lg-0,
        .gx-lg-0 {
            --bs-gutter-x: 0;
        }
        .g-lg-0,
        .gy-lg-0 {
            --bs-gutter-y: 0;
        }
        .g-lg-1,
        .gx-lg-1 {
            --bs-gutter-x: 0.25rem;
        }
        .g-lg-1,
        .gy-lg-1 {
            --bs-gutter-y: 0.25rem;
        }
        .g-lg-2,
        .gx-lg-2 {
            --bs-gutter-x: 0.5rem;
        }
        .g-lg-2,
        .gy-lg-2 {
            --bs-gutter-y: 0.5rem;
        }
        .g-lg-3,
        .gx-lg-3 {
            --bs-gutter-x: 1rem;
        }
        .g-lg-3,
        .gy-lg-3 {
            --bs-gutter-y: 1rem;
        }
        .g-lg-4,
        .gx-lg-4 {
            --bs-gutter-x: 1.5rem;
        }
        .g-lg-4,
        .gy-lg-4 {
            --bs-gutter-y: 1.5rem;
        }
        .g-lg-5,
        .gx-lg-5 {
            --bs-gutter-x: 3rem;
        }
        .g-lg-5,
        .gy-lg-5 {
            --bs-gutter-y: 3rem;
        }
    }
    @media (min-width: 1200px) {
        .col-xl {
            flex: 1 0 0%;
        }
        .row-cols-xl-auto > * {
            flex: 0 0 auto;
            width: auto;
        }
        .row-cols-xl-1 > * {
            flex: 0 0 auto;
            width: 100%;
        }
        .row-cols-xl-2 > * {
            flex: 0 0 auto;
            width: 50%;
        }
        .row-cols-xl-3 > * {
            flex: 0 0 auto;
            width: 33.33333333%;
        }
        .row-cols-xl-4 > * {
            flex: 0 0 auto;
            width: 25%;
        }
        .row-cols-xl-5 > * {
            flex: 0 0 auto;
            width: 20%;
        }
        .row-cols-xl-6 > * {
            flex: 0 0 auto;
            width: 16.66666667%;
        }
        .col-xl-auto {
            flex: 0 0 auto;
            width: auto;
        }
        .col-xl-1 {
            flex: 0 0 auto;
            width: 8.33333333%;
        }
        .col-xl-2 {
            flex: 0 0 auto;
            width: 16.66666667%;
        }
        .col-xl-3 {
            flex: 0 0 auto;
            width: 25%;
        }
        .col-xl-4 {
            flex: 0 0 auto;
            width: 33.33333333%;
        }
        .col-xl-5 {
            flex: 0 0 auto;
            width: 41.66666667%;
        }
        .col-xl-6 {
            flex: 0 0 auto;
            width: 50%;
        }
        .col-xl-7 {
            flex: 0 0 auto;
            width: 58.33333333%;
        }
        .col-xl-8 {
            flex: 0 0 auto;
            width: 66.66666667%;
        }
        .col-xl-9 {
            flex: 0 0 auto;
            width: 75%;
        }
        .col-xl-10 {
            flex: 0 0 auto;
            width: 83.33333333%;
        }
        .col-xl-11 {
            flex: 0 0 auto;
            width: 91.66666667%;
        }
        .col-xl-12 {
            flex: 0 0 auto;
            width: 100%;
        }
        .offset-xl-0 {
            margin-left: 0;
        }
        .offset-xl-1 {
            margin-left: 8.33333333%;
        }
        .offset-xl-2 {
            margin-left: 16.66666667%;
        }
        .offset-xl-3 {
            margin-left: 25%;
        }
        .offset-xl-4 {
            margin-left: 33.33333333%;
        }
        .offset-xl-5 {
            margin-left: 41.66666667%;
        }
        .offset-xl-6 {
            margin-left: 50%;
        }
        .offset-xl-7 {
            margin-left: 58.33333333%;
        }
        .offset-xl-8 {
            margin-left: 66.66666667%;
        }
        .offset-xl-9 {
            margin-left: 75%;
        }
        .offset-xl-10 {
            margin-left: 83.33333333%;
        }
        .offset-xl-11 {
            margin-left: 91.66666667%;
        }
        .g-xl-0,
        .gx-xl-0 {
            --bs-gutter-x: 0;
        }
        .g-xl-0,
        .gy-xl-0 {
            --bs-gutter-y: 0;
        }
        .g-xl-1,
        .gx-xl-1 {
            --bs-gutter-x: 0.25rem;
        }
        .g-xl-1,
        .gy-xl-1 {
            --bs-gutter-y: 0.25rem;
        }
        .g-xl-2,
        .gx-xl-2 {
            --bs-gutter-x: 0.5rem;
        }
        .g-xl-2,
        .gy-xl-2 {
            --bs-gutter-y: 0.5rem;
        }
        .g-xl-3,
        .gx-xl-3 {
            --bs-gutter-x: 1rem;
        }
        .g-xl-3,
        .gy-xl-3 {
            --bs-gutter-y: 1rem;
        }
        .g-xl-4,
        .gx-xl-4 {
            --bs-gutter-x: 1.5rem;
        }
        .g-xl-4,
        .gy-xl-4 {
            --bs-gutter-y: 1.5rem;
        }
        .g-xl-5,
        .gx-xl-5 {
            --bs-gutter-x: 3rem;
        }
        .g-xl-5,
        .gy-xl-5 {
            --bs-gutter-y: 3rem;
        }
    }
    @media (min-width: 1400px) {
        .col-xxl {
            flex: 1 0 0%;
        }
        .row-cols-xxl-auto > * {
            flex: 0 0 auto;
            width: auto;
        }
        .row-cols-xxl-1 > * {
            flex: 0 0 auto;
            width: 100%;
        }
        .row-cols-xxl-2 > * {
            flex: 0 0 auto;
            width: 50%;
        }
        .row-cols-xxl-3 > * {
            flex: 0 0 auto;
            width: 33.33333333%;
        }
        .row-cols-xxl-4 > * {
            flex: 0 0 auto;
            width: 25%;
        }
        .row-cols-xxl-5 > * {
            flex: 0 0 auto;
            width: 20%;
        }
        .row-cols-xxl-6 > * {
            flex: 0 0 auto;
            width: 16.66666667%;
        }
        .col-xxl-auto {
            flex: 0 0 auto;
            width: auto;
        }
        .col-xxl-1 {
            flex: 0 0 auto;
            width: 8.33333333%;
        }
        .col-xxl-2 {
            flex: 0 0 auto;
            width: 16.66666667%;
        }
        .col-xxl-3 {
            flex: 0 0 auto;
            width: 25%;
        }
        .col-xxl-4 {
            flex: 0 0 auto;
            width: 33.33333333%;
        }
        .col-xxl-5 {
            flex: 0 0 auto;
            width: 41.66666667%;
        }
        .col-xxl-6 {
            flex: 0 0 auto;
            width: 50%;
        }
        .col-xxl-7 {
            flex: 0 0 auto;
            width: 58.33333333%;
        }
        .col-xxl-8 {
            flex: 0 0 auto;
            width: 66.66666667%;
        }
        .col-xxl-9 {
            flex: 0 0 auto;
            width: 75%;
        }
        .col-xxl-10 {
            flex: 0 0 auto;
            width: 83.33333333%;
        }
        .col-xxl-11 {
            flex: 0 0 auto;
            width: 91.66666667%;
        }
        .col-xxl-12 {
            flex: 0 0 auto;
            width: 100%;
        }
        .offset-xxl-0 {
            margin-left: 0;
        }
        .offset-xxl-1 {
            margin-left: 8.33333333%;
        }
        .offset-xxl-2 {
            margin-left: 16.66666667%;
        }
        .offset-xxl-3 {
            margin-left: 25%;
        }
        .offset-xxl-4 {
            margin-left: 33.33333333%;
        }
        .offset-xxl-5 {
            margin-left: 41.66666667%;
        }
        .offset-xxl-6 {
            margin-left: 50%;
        }
        .offset-xxl-7 {
            margin-left: 58.33333333%;
        }
        .offset-xxl-8 {
            margin-left: 66.66666667%;
        }
        .offset-xxl-9 {
            margin-left: 75%;
        }
        .offset-xxl-10 {
            margin-left: 83.33333333%;
        }
        .offset-xxl-11 {
            margin-left: 91.66666667%;
        }
        .g-xxl-0,
        .gx-xxl-0 {
            --bs-gutter-x: 0;
        }
        .g-xxl-0,
        .gy-xxl-0 {
            --bs-gutter-y: 0;
        }
        .g-xxl-1,
        .gx-xxl-1 {
            --bs-gutter-x: 0.25rem;
        }
        .g-xxl-1,
        .gy-xxl-1 {
            --bs-gutter-y: 0.25rem;
        }
        .g-xxl-2,
        .gx-xxl-2 {
            --bs-gutter-x: 0.5rem;
        }
        .g-xxl-2,
        .gy-xxl-2 {
            --bs-gutter-y: 0.5rem;
        }
        .g-xxl-3,
        .gx-xxl-3 {
            --bs-gutter-x: 1rem;
        }
        .g-xxl-3,
        .gy-xxl-3 {
            --bs-gutter-y: 1rem;
        }
        .g-xxl-4,
        .gx-xxl-4 {
            --bs-gutter-x: 1.5rem;
        }
        .g-xxl-4,
        .gy-xxl-4 {
            --bs-gutter-y: 1.5rem;
        }
        .g-xxl-5,
        .gx-xxl-5 {
            --bs-gutter-x: 3rem;
        }
        .g-xxl-5,
        .gy-xxl-5 {
            --bs-gutter-y: 3rem;
        }
    }
    .table {
        --bs-table-color-type: initial;
        --bs-table-bg-type: initial;
        --bs-table-color-state: initial;
        --bs-table-bg-state: initial;
        --bs-table-color: var(--bs-emphasis-color);
        --bs-table-bg: var(--bs-body-bg);
        --bs-table-border-color: var(--bs-border-color);
        --bs-table-accent-bg: transparent;
        --bs-table-striped-color: var(--bs-emphasis-color);
        --bs-table-striped-bg: rgba(var(--bs-emphasis-color-rgb), 0.05);
        --bs-table-active-color: var(--bs-emphasis-color);
        --bs-table-active-bg: rgba(var(--bs-emphasis-color-rgb), 0.1);
        --bs-table-hover-color: var(--bs-emphasis-color);
        --bs-table-hover-bg: rgba(var(--bs-emphasis-color-rgb), 0.075);
        width: 100%;
        margin-bottom: 1rem;
        vertical-align: top;
        border-color: var(--bs-table-border-color);
    }
    .table > :not(caption) > * > * {
        padding: 0.5rem 0.5rem;
        color: var(
            --bs-table-color-state,
            var(--bs-table-color-type, var(--bs-table-color))
        );
        background-color: var(--bs-table-bg);
        border-bottom-width: var(--bs-border-width);
        box-shadow: inset 0 0 0 9999px
            var(
                --bs-table-bg-state,
                var(--bs-table-bg-type, var(--bs-table-accent-bg))
            );
    }
    .table > tbody {
        vertical-align: inherit;
    }
    .table > thead {
        vertical-align: bottom;
    }

    .table-group-divider {
        border-top: calc(var(--bs-border-width) * 2) solid currentcolor;
    }

    .caption-top {
        caption-side: top;
    }

    .table-sm > :not(caption) > * > * {
        padding: 0.25rem 0.25rem;
    }

    .table-bordered > :not(caption) > * {
        border-width: var(--bs-border-width) 0;
    }
    .table-bordered > :not(caption) > * > * {
        border-width: 0 var(--bs-border-width);
    }

    .table-borderless > :not(caption) > * > * {
        border-bottom-width: 0;
    }
    .table-borderless > :not(:first-child) {
        border-top-width: 0;
    }

    .table-striped > tbody > tr:nth-of-type(odd) > * {
        --bs-table-color-type: var(--bs-table-striped-color);
        --bs-table-bg-type: var(--bs-table-striped-bg);
    }

    .table-striped-columns > :not(caption) > tr > :nth-child(even) {
        --bs-table-color-type: var(--bs-table-striped-color);
        --bs-table-bg-type: var(--bs-table-striped-bg);
    }

    .table-active {
        --bs-table-color-state: var(--bs-table-active-color);
        --bs-table-bg-state: var(--bs-table-active-bg);
    }

    .table-hover > tbody > tr:hover > * {
        --bs-table-color-state: var(--bs-table-hover-color);
        --bs-table-bg-state: var(--bs-table-hover-bg);
    }

    .table-primary {
        --bs-table-color: #000;
        --bs-table-bg: #cfe2ff;
        --bs-table-border-color: #a6b5cc;
        --bs-table-striped-bg: #c5d7f2;
        --bs-table-striped-color: #000;
        --bs-table-active-bg: #bacbe6;
        --bs-table-active-color: #000;
        --bs-table-hover-bg: #bfd1ec;
        --bs-table-hover-color: #000;
        color: var(--bs-table-color);
        border-color: var(--bs-table-border-color);
    }

    .table-secondary {
        --bs-table-color: #000;
        --bs-table-bg: #e2e3e5;
        --bs-table-border-color: #b5b6b7;
        --bs-table-striped-bg: #d7d8da;
        --bs-table-striped-color: #000;
        --bs-table-active-bg: #cbccce;
        --bs-table-active-color: #000;
        --bs-table-hover-bg: #d1d2d4;
        --bs-table-hover-color: #000;
        color: var(--bs-table-color);
        border-color: var(--bs-table-border-color);
    }

    .table-success {
        --bs-table-color: #000;
        --bs-table-bg: #d1e7dd;
        --bs-table-border-color: #a7b9b1;
        --bs-table-striped-bg: #c7dbd2;
        --bs-table-striped-color: #000;
        --bs-table-active-bg: #bcd0c7;
        --bs-table-active-color: #000;
        --bs-table-hover-bg: #c1d6cc;
        --bs-table-hover-color: #000;
        color: var(--bs-table-color);
        border-color: var(--bs-table-border-color);
    }

    .table-info {
        --bs-table-color: #000;
        --bs-table-bg: #cff4fc;
        --bs-table-border-color: #a6c3ca;
        --bs-table-striped-bg: #c5e8ef;
        --bs-table-striped-color: #000;
        --bs-table-active-bg: #badce3;
        --bs-table-active-color: #000;
        --bs-table-hover-bg: #bfe2e9;
        --bs-table-hover-color: #000;
        color: var(--bs-table-color);
        border-color: var(--bs-table-border-color);
    }

    .table-warning {
        --bs-table-color: #000;
        --bs-table-bg: #fff3cd;
        --bs-table-border-color: #ccc2a4;
        --bs-table-striped-bg: #f2e7c3;
        --bs-table-striped-color: #000;
        --bs-table-active-bg: #e6dbb9;
        --bs-table-active-color: #000;
        --bs-table-hover-bg: #ece1be;
        --bs-table-hover-color: #000;
        color: var(--bs-table-color);
        border-color: var(--bs-table-border-color);
    }

    .table-danger {
        --bs-table-color: #000;
        --bs-table-bg: #f8d7da;
        --bs-table-border-color: #c6acae;
        --bs-table-striped-bg: #eccccf;
        --bs-table-striped-color: #000;
        --bs-table-active-bg: #dfc2c4;
        --bs-table-active-color: #000;
        --bs-table-hover-bg: #e5c7ca;
        --bs-table-hover-color: #000;
        color: var(--bs-table-color);
        border-color: var(--bs-table-border-color);
    }

    .table-light {
        --bs-table-color: #000;
        --bs-table-bg: #f8f9fa;
        --bs-table-border-color: #c6c7c8;
        --bs-table-striped-bg: #ecedee;
        --bs-table-striped-color: #000;
        --bs-table-active-bg: #dfe0e1;
        --bs-table-active-color: #000;
        --bs-table-hover-bg: #e5e6e7;
        --bs-table-hover-color: #000;
        color: var(--bs-table-color);
        border-color: var(--bs-table-border-color);
    }

    .table-dark {
        --bs-table-color: #fff;
        --bs-table-bg: #212529;
        --bs-table-border-color: #4d5154;
        --bs-table-striped-bg: #2c3034;
        --bs-table-striped-color: #fff;
        --bs-table-active-bg: #373b3e;
        --bs-table-active-color: #fff;
        --bs-table-hover-bg: #323539;
        --bs-table-hover-color: #fff;
        color: var(--bs-table-color);
        border-color: var(--bs-table-border-color);
    }

    .table-responsive {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
    }

    @media (max-width: 575.98px) {
        .table-responsive-sm {
            overflow-x: auto;
            -webkit-overflow-scrolling: touch;
        }
    }
    @media (max-width: 767.98px) {
        .table-responsive-md {
            overflow-x: auto;
            -webkit-overflow-scrolling: touch;
        }
    }
    @media (max-width: 991.98px) {
        .table-responsive-lg {
            overflow-x: auto;
            -webkit-overflow-scrolling: touch;
        }
    }
    @media (max-width: 1199.98px) {
        .table-responsive-xl {
            overflow-x: auto;
            -webkit-overflow-scrolling: touch;
        }
    }
    @media (max-width: 1399.98px) {
        .table-responsive-xxl {
            overflow-x: auto;
            -webkit-overflow-scrolling: touch;
        }
    }
    .form-label {
        margin-bottom: 0.5rem;
    }

    .col-form-label {
        padding-top: calc(0.375rem + var(--bs-border-width));
        padding-bottom: calc(0.375rem + var(--bs-border-width));
        margin-bottom: 0;
        font-size: inherit;
        line-height: 1.5;
    }

    .col-form-label-lg {
        padding-top: calc(0.5rem + var(--bs-border-width));
        padding-bottom: calc(0.5rem + var(--bs-border-width));
        font-size: 1.25rem;
    }

    .col-form-label-sm {
        padding-top: calc(0.25rem + var(--bs-border-width));
        padding-bottom: calc(0.25rem + var(--bs-border-width));
        font-size: 0.875rem;
    }

    .form-text {
        margin-top: 0.25rem;
        font-size: 0.875em;
        color: var(--bs-secondary-color);
    }

    .form-control {
        display: block;
        width: 100%;
        padding: 0.375rem 0.75rem;
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.5;
        color: var(--bs-body-color);
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        background-color: var(--bs-body-bg);
        background-clip: padding-box;
        border: var(--bs-border-width) solid var(--bs-border-color);
        border-radius: var(--bs-border-radius);
        transition:
            border-color 0.15s ease-in-out,
            box-shadow 0.15s ease-in-out;
    }
    @media (prefers-reduced-motion: reduce) {
        .form-control {
            transition: none;
        }
    }
    .form-control[type='file'] {
        overflow: hidden;
    }
    .form-control[type='file']:not(:disabled):not([readonly]) {
        cursor: pointer;
    }
    .form-control:focus {
        color: var(--bs-body-color);
        background-color: var(--bs-body-bg);
        border-color: #86b7fe;
        outline: 0;
        box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
    }
    .form-control::-webkit-date-and-time-value {
        min-width: 85px;
        height: 1.5em;
        margin: 0;
    }
    .form-control::-webkit-datetime-edit {
        display: block;
        padding: 0;
    }
    .form-control::-moz-placeholder {
        color: var(--bs-secondary-color);
        opacity: 1;
    }
    .form-control::placeholder {
        color: var(--bs-secondary-color);
        opacity: 1;
    }
    .form-control:disabled {
        background-color: var(--bs-secondary-bg);
        opacity: 1;
    }
    .form-control::-webkit-file-upload-button {
        padding: 0.375rem 0.75rem;
        margin: -0.375rem -0.75rem;
        -webkit-margin-end: 0.75rem;
        margin-inline-end: 0.75rem;
        color: var(--bs-body-color);
        background-color: var(--bs-tertiary-bg);
        pointer-events: none;
        border-color: inherit;
        border-style: solid;
        border-width: 0;
        border-inline-end-width: var(--bs-border-width);
        border-radius: 0;
        -webkit-transition:
            color 0.15s ease-in-out,
            background-color 0.15s ease-in-out,
            border-color 0.15s ease-in-out,
            box-shadow 0.15s ease-in-out;
        transition:
            color 0.15s ease-in-out,
            background-color 0.15s ease-in-out,
            border-color 0.15s ease-in-out,
            box-shadow 0.15s ease-in-out;
    }
    .form-control::file-selector-button {
        padding: 0.375rem 0.75rem;
        margin: -0.375rem -0.75rem;
        -webkit-margin-end: 0.75rem;
        margin-inline-end: 0.75rem;
        color: var(--bs-body-color);
        background-color: var(--bs-tertiary-bg);
        pointer-events: none;
        border-color: inherit;
        border-style: solid;
        border-width: 0;
        border-inline-end-width: var(--bs-border-width);
        border-radius: 0;
        transition:
            color 0.15s ease-in-out,
            background-color 0.15s ease-in-out,
            border-color 0.15s ease-in-out,
            box-shadow 0.15s ease-in-out;
    }
    @media (prefers-reduced-motion: reduce) {
        .form-control::-webkit-file-upload-button {
            -webkit-transition: none;
            transition: none;
        }
        .form-control::file-selector-button {
            transition: none;
        }
    }
    .form-control:hover:not(:disabled):not(
            [readonly]
        )::-webkit-file-upload-button {
        background-color: var(--bs-secondary-bg);
    }
    .form-control:hover:not(:disabled):not([readonly])::file-selector-button {
        background-color: var(--bs-secondary-bg);
    }

    .form-control-plaintext {
        display: block;
        width: 100%;
        padding: 0.375rem 0;
        margin-bottom: 0;
        line-height: 1.5;
        color: var(--bs-body-color);
        background-color: transparent;
        border: solid transparent;
        border-width: var(--bs-border-width) 0;
    }
    .form-control-plaintext:focus {
        outline: 0;
    }
    .form-control-plaintext.form-control-sm,
    .form-control-plaintext.form-control-lg {
        padding-right: 0;
        padding-left: 0;
    }

    .form-control-sm {
        min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
        border-radius: var(--bs-border-radius-sm);
    }
    .form-control-sm::-webkit-file-upload-button {
        padding: 0.25rem 0.5rem;
        margin: -0.25rem -0.5rem;
        -webkit-margin-end: 0.5rem;
        margin-inline-end: 0.5rem;
    }
    .form-control-sm::file-selector-button {
        padding: 0.25rem 0.5rem;
        margin: -0.25rem -0.5rem;
        -webkit-margin-end: 0.5rem;
        margin-inline-end: 0.5rem;
    }

    .form-control-lg {
        min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
        padding: 0.5rem 1rem;
        font-size: 1.25rem;
        border-radius: var(--bs-border-radius-lg);
    }
    .form-control-lg::-webkit-file-upload-button {
        padding: 0.5rem 1rem;
        margin: -0.5rem -1rem;
        -webkit-margin-end: 1rem;
        margin-inline-end: 1rem;
    }
    .form-control-lg::file-selector-button {
        padding: 0.5rem 1rem;
        margin: -0.5rem -1rem;
        -webkit-margin-end: 1rem;
        margin-inline-end: 1rem;
    }

    textarea.form-control {
        min-height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2));
    }
    textarea.form-control-sm {
        min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
    }
    textarea.form-control-lg {
        min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
    }

    .form-control-color {
        width: 3rem;
        height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2));
        padding: 0.375rem;
    }
    .form-control-color:not(:disabled):not([readonly]) {
        cursor: pointer;
    }
    .form-control-color::-moz-color-swatch {
        border: 0 !important;
        border-radius: var(--bs-border-radius);
    }
    .form-control-color::-webkit-color-swatch {
        border: 0 !important;
        border-radius: var(--bs-border-radius);
    }
    .form-control-color.form-control-sm {
        height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
    }
    .form-control-color.form-control-lg {
        height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
    }

    .form-select {
        --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
        display: block;
        width: 100%;
        padding: 0.375rem 2.25rem 0.375rem 0.75rem;
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.5;
        color: var(--bs-body-color);
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        background-color: var(--bs-body-bg);
        background-image: var(--bs-form-select-bg-img),
            var(--bs-form-select-bg-icon, none);
        background-repeat: no-repeat;
        background-position: right 0.75rem center;
        background-size: 16px 12px;
        border: var(--bs-border-width) solid var(--bs-border-color);
        border-radius: var(--bs-border-radius);
        transition:
            border-color 0.15s ease-in-out,
            box-shadow 0.15s ease-in-out;
    }
    @media (prefers-reduced-motion: reduce) {
        .form-select {
            transition: none;
        }
    }
    .form-select:focus {
        border-color: #86b7fe;
        outline: 0;
        box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
    }
    .form-select[multiple],
    .form-select[size]:not([size='1']) {
        padding-right: 0.75rem;
        background-image: none;
    }
    .form-select:disabled {
        background-color: var(--bs-secondary-bg);
    }
    .form-select:-moz-focusring {
        color: transparent;
        text-shadow: 0 0 0 var(--bs-body-color);
    }

    .form-select-sm {
        padding-top: 0.25rem;
        padding-bottom: 0.25rem;
        padding-left: 0.5rem;
        font-size: 0.875rem;
        border-radius: var(--bs-border-radius-sm);
    }

    .form-select-lg {
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
        padding-left: 1rem;
        font-size: 1.25rem;
        border-radius: var(--bs-border-radius-lg);
    }

    [data-bs-theme='dark'] .form-select {
        --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    }

    .form-check {
        display: block;
        min-height: 1.5rem;
        padding-left: 1.5em;
        margin-bottom: 0.125rem;
    }
    .form-check .form-check-input {
        float: left;
        margin-left: -1.5em;
    }

    .form-check-reverse {
        padding-right: 1.5em;
        padding-left: 0;
        text-align: right;
    }
    .form-check-reverse .form-check-input {
        float: right;
        margin-right: -1.5em;
        margin-left: 0;
    }

    .form-check-input {
        --bs-form-check-bg: var(--bs-body-bg);
        flex-shrink: 0;
        width: 1em;
        height: 1em;
        margin-top: 0.25em;
        vertical-align: top;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        background-color: var(--bs-form-check-bg);
        background-image: var(--bs-form-check-bg-image);
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        border: var(--bs-border-width) solid var(--bs-border-color);
        -webkit-print-color-adjust: exact;
        color-adjust: exact;
        print-color-adjust: exact;
    }
    .form-check-input[type='checkbox'] {
        border-radius: 0.25em;
    }
    .form-check-input[type='radio'] {
        border-radius: 50%;
    }
    .form-check-input:active {
        filter: brightness(90%);
    }
    .form-check-input:focus {
        border-color: #86b7fe;
        outline: 0;
        box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
    }
    .form-check-input:checked {
        background-color: #0d6efd;
        border-color: #0d6efd;
    }
    .form-check-input:checked[type='checkbox'] {
        --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    }
    .form-check-input:checked[type='radio'] {
        --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    }
    .form-check-input[type='checkbox']:indeterminate {
        background-color: #0d6efd;
        border-color: #0d6efd;
        --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    }
    .form-check-input:disabled {
        pointer-events: none;
        filter: none;
        opacity: 0.5;
    }
    .form-check-input[disabled] ~ .form-check-label,
    .form-check-input:disabled ~ .form-check-label {
        cursor: default;
        opacity: 0.5;
    }

    .form-switch {
        padding-left: 2.5em;
    }
    .form-switch .form-check-input {
        --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
        width: 2em;
        margin-left: -2.5em;
        background-image: var(--bs-form-switch-bg);
        background-position: left center;
        border-radius: 2em;
        transition: background-position 0.15s ease-in-out;
    }
    @media (prefers-reduced-motion: reduce) {
        .form-switch .form-check-input {
            transition: none;
        }
    }
    .form-switch .form-check-input:focus {
        --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
    }
    .form-switch .form-check-input:checked {
        background-position: right center;
        --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
    }
    .form-switch.form-check-reverse {
        padding-right: 2.5em;
        padding-left: 0;
    }
    .form-switch.form-check-reverse .form-check-input {
        margin-right: -2.5em;
        margin-left: 0;
    }

    .form-check-inline {
        display: inline-block;
        margin-right: 1rem;
    }

    .btn-check {
        position: absolute;
        clip: rect(0, 0, 0, 0);
        pointer-events: none;
    }
    .btn-check[disabled] + .btn,
    .btn-check:disabled + .btn {
        pointer-events: none;
        filter: none;
        opacity: 0.65;
    }

    [data-bs-theme='dark']
        .form-switch
        .form-check-input:not(:checked):not(:focus) {
        --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
    }

    .form-range {
        width: 100%;
        height: 1.5rem;
        padding: 0;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        background-color: transparent;
    }
    .form-range:focus {
        outline: 0;
    }
    .form-range:focus::-webkit-slider-thumb {
        box-shadow:
            0 0 0 1px #fff,
            0 0 0 0.25rem rgba(13, 110, 253, 0.25);
    }
    .form-range:focus::-moz-range-thumb {
        box-shadow:
            0 0 0 1px #fff,
            0 0 0 0.25rem rgba(13, 110, 253, 0.25);
    }
    .form-range::-moz-focus-outer {
        border: 0;
    }
    .form-range::-webkit-slider-thumb {
        width: 1rem;
        height: 1rem;
        margin-top: -0.25rem;
        -webkit-appearance: none;
        appearance: none;
        background-color: #0d6efd;
        border: 0;
        border-radius: 1rem;
        -webkit-transition:
            background-color 0.15s ease-in-out,
            border-color 0.15s ease-in-out,
            box-shadow 0.15s ease-in-out;
        transition:
            background-color 0.15s ease-in-out,
            border-color 0.15s ease-in-out,
            box-shadow 0.15s ease-in-out;
    }
    @media (prefers-reduced-motion: reduce) {
        .form-range::-webkit-slider-thumb {
            -webkit-transition: none;
            transition: none;
        }
    }
    .form-range::-webkit-slider-thumb:active {
        background-color: #b6d4fe;
    }
    .form-range::-webkit-slider-runnable-track {
        width: 100%;
        height: 0.5rem;
        color: transparent;
        cursor: pointer;
        background-color: var(--bs-secondary-bg);
        border-color: transparent;
        border-radius: 1rem;
    }
    .form-range::-moz-range-thumb {
        width: 1rem;
        height: 1rem;
        -moz-appearance: none;
        appearance: none;
        background-color: #0d6efd;
        border: 0;
        border-radius: 1rem;
        -moz-transition:
            background-color 0.15s ease-in-out,
            border-color 0.15s ease-in-out,
            box-shadow 0.15s ease-in-out;
        transition:
            background-color 0.15s ease-in-out,
            border-color 0.15s ease-in-out,
            box-shadow 0.15s ease-in-out;
    }
    @media (prefers-reduced-motion: reduce) {
        .form-range::-moz-range-thumb {
            -moz-transition: none;
            transition: none;
        }
    }
    .form-range::-moz-range-thumb:active {
        background-color: #b6d4fe;
    }
    .form-range::-moz-range-track {
        width: 100%;
        height: 0.5rem;
        color: transparent;
        cursor: pointer;
        background-color: var(--bs-secondary-bg);
        border-color: transparent;
        border-radius: 1rem;
    }
    .form-range:disabled {
        pointer-events: none;
    }
    .form-range:disabled::-webkit-slider-thumb {
        background-color: var(--bs-secondary-color);
    }
    .form-range:disabled::-moz-range-thumb {
        background-color: var(--bs-secondary-color);
    }

    .form-floating {
        position: relative;
    }
    .form-floating > .form-control,
    .form-floating > .form-control-plaintext,
    .form-floating > .form-select {
        height: calc(3.5rem + calc(var(--bs-border-width) * 2));
        min-height: calc(3.5rem + calc(var(--bs-border-width) * 2));
        line-height: 1.25;
    }
    .form-floating > label {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
        height: 100%;
        padding: 1rem 0.75rem;
        overflow: hidden;
        text-align: start;
        text-overflow: ellipsis;
        white-space: nowrap;
        pointer-events: none;
        border: var(--bs-border-width) solid transparent;
        transform-origin: 0 0;
        transition:
            opacity 0.1s ease-in-out,
            transform 0.1s ease-in-out;
    }
    @media (prefers-reduced-motion: reduce) {
        .form-floating > label {
            transition: none;
        }
    }
    .form-floating > .form-control,
    .form-floating > .form-control-plaintext {
        padding: 1rem 0.75rem;
    }
    .form-floating > .form-control::-moz-placeholder,
    .form-floating > .form-control-plaintext::-moz-placeholder {
        color: transparent;
    }
    .form-floating > .form-control::placeholder,
    .form-floating > .form-control-plaintext::placeholder {
        color: transparent;
    }
    .form-floating > .form-control:not(:-moz-placeholder-shown),
    .form-floating > .form-control-plaintext:not(:-moz-placeholder-shown) {
        padding-top: 1.625rem;
        padding-bottom: 0.625rem;
    }
    .form-floating > .form-control:focus,
    .form-floating > .form-control:not(:placeholder-shown),
    .form-floating > .form-control-plaintext:focus,
    .form-floating > .form-control-plaintext:not(:placeholder-shown) {
        padding-top: 1.625rem;
        padding-bottom: 0.625rem;
    }
    .form-floating > .form-control:-webkit-autofill,
    .form-floating > .form-control-plaintext:-webkit-autofill {
        padding-top: 1.625rem;
        padding-bottom: 0.625rem;
    }
    .form-floating > .form-select {
        padding-top: 1.625rem;
        padding-bottom: 0.625rem;
    }
    .form-floating > .form-control:not(:-moz-placeholder-shown) ~ label {
        color: rgba(var(--bs-body-color-rgb), 0.65);
        transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
    }
    .form-floating > .form-control:focus ~ label,
    .form-floating > .form-control:not(:placeholder-shown) ~ label,
    .form-floating > .form-control-plaintext ~ label,
    .form-floating > .form-select ~ label {
        color: rgba(var(--bs-body-color-rgb), 0.65);
        transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
    }
    .form-floating > .form-control:not(:-moz-placeholder-shown) ~ label::after {
        position: absolute;
        inset: 1rem 0.375rem;
        z-index: -1;
        height: 1.5em;
        content: '';
        background-color: var(--bs-body-bg);
        border-radius: var(--bs-border-radius);
    }
    .form-floating > .form-control:focus ~ label::after,
    .form-floating > .form-control:not(:placeholder-shown) ~ label::after,
    .form-floating > .form-control-plaintext ~ label::after,
    .form-floating > .form-select ~ label::after {
        position: absolute;
        inset: 1rem 0.375rem;
        z-index: -1;
        height: 1.5em;
        content: '';
        background-color: var(--bs-body-bg);
        border-radius: var(--bs-border-radius);
    }
    .form-floating > .form-control:-webkit-autofill ~ label {
        color: rgba(var(--bs-body-color-rgb), 0.65);
        transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
    }
    .form-floating > .form-control-plaintext ~ label {
        border-width: var(--bs-border-width) 0;
    }
    .form-floating > :disabled ~ label,
    .form-floating > .form-control:disabled ~ label {
        color: #6c757d;
    }
    .form-floating > :disabled ~ label::after,
    .form-floating > .form-control:disabled ~ label::after {
        background-color: var(--bs-secondary-bg);
    }

    .input-group {
        position: relative;
        display: flex;
        flex-wrap: wrap;
        align-items: stretch;
        width: 100%;
    }
    .input-group > .form-control,
    .input-group > .form-select,
    .input-group > .form-floating {
        position: relative;
        flex: 1 1 auto;
        width: 1%;
        min-width: 0;
    }
    .input-group > .form-control:focus,
    .input-group > .form-select:focus,
    .input-group > .form-floating:focus-within {
        z-index: 5;
    }
    .input-group .btn {
        position: relative;
        z-index: 2;
    }
    .input-group .btn:focus {
        z-index: 5;
    }

    .input-group-text {
        display: flex;
        align-items: center;
        padding: 0.375rem 0.75rem;
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.5;
        color: var(--bs-body-color);
        text-align: center;
        white-space: nowrap;
        background-color: var(--bs-tertiary-bg);
        border: var(--bs-border-width) solid var(--bs-border-color);
        border-radius: var(--bs-border-radius);
    }

    .input-group-lg > .form-control,
    .input-group-lg > .form-select,
    .input-group-lg > .input-group-text,
    .input-group-lg > .btn {
        padding: 0.5rem 1rem;
        font-size: 1.25rem;
        border-radius: var(--bs-border-radius-lg);
    }

    .input-group-sm > .form-control,
    .input-group-sm > .form-select,
    .input-group-sm > .input-group-text,
    .input-group-sm > .btn {
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
        border-radius: var(--bs-border-radius-sm);
    }

    .input-group-lg > .form-select,
    .input-group-sm > .form-select {
        padding-right: 3rem;
    }

    .input-group:not(.has-validation)
        > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(
            .form-floating
        ),
    .input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n + 3),
    .input-group:not(.has-validation)
        > .form-floating:not(:last-child)
        > .form-control,
    .input-group:not(.has-validation)
        > .form-floating:not(:last-child)
        > .form-select {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
    }
    .input-group.has-validation
        > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(
            .form-floating
        ),
    .input-group.has-validation > .dropdown-toggle:nth-last-child(n + 4),
    .input-group.has-validation
        > .form-floating:nth-last-child(n + 3)
        > .form-control,
    .input-group.has-validation
        > .form-floating:nth-last-child(n + 3)
        > .form-select {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
    }
    .input-group
        > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(
            .valid-feedback
        ):not(.invalid-tooltip):not(.invalid-feedback) {
        margin-left: calc(var(--bs-border-width) * -1);
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }
    .input-group > .form-floating:not(:first-child) > .form-control,
    .input-group > .form-floating:not(:first-child) > .form-select {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }

    .valid-feedback {
        display: none;
        width: 100%;
        margin-top: 0.25rem;
        font-size: 0.875em;
        color: var(--bs-form-valid-color);
    }

    .valid-tooltip {
        position: absolute;
        top: 100%;
        z-index: 5;
        display: none;
        max-width: 100%;
        padding: 0.25rem 0.5rem;
        margin-top: 0.1rem;
        font-size: 0.875rem;
        color: #fff;
        background-color: var(--bs-success);
        border-radius: var(--bs-border-radius);
    }

    .was-validated :valid ~ .valid-feedback,
    .was-validated :valid ~ .valid-tooltip,
    .is-valid ~ .valid-feedback,
    .is-valid ~ .valid-tooltip {
        display: block;
    }

    .was-validated .form-control:valid,
    .form-control.is-valid {
        border-color: var(--bs-form-valid-border-color);
        padding-right: calc(1.5em + 0.75rem);
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
        background-repeat: no-repeat;
        background-position: right calc(0.375em + 0.1875rem) center;
        background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
    }
    .was-validated .form-control:valid:focus,
    .form-control.is-valid:focus {
        border-color: var(--bs-form-valid-border-color);
        box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
    }

    .was-validated textarea.form-control:valid,
    textarea.form-control.is-valid {
        padding-right: calc(1.5em + 0.75rem);
        background-position: top calc(0.375em + 0.1875rem) right
            calc(0.375em + 0.1875rem);
    }

    .was-validated .form-select:valid,
    .form-select.is-valid {
        border-color: var(--bs-form-valid-border-color);
    }
    .was-validated .form-select:valid:not([multiple]):not([size]),
    .was-validated .form-select:valid:not([multiple])[size='1'],
    .form-select.is-valid:not([multiple]):not([size]),
    .form-select.is-valid:not([multiple])[size='1'] {
        --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
        padding-right: 4.125rem;
        background-position:
            right 0.75rem center,
            center right 2.25rem;
        background-size:
            16px 12px,
            calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
    }
    .was-validated .form-select:valid:focus,
    .form-select.is-valid:focus {
        border-color: var(--bs-form-valid-border-color);
        box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
    }

    .was-validated .form-control-color:valid,
    .form-control-color.is-valid {
        width: calc(3rem + calc(1.5em + 0.75rem));
    }

    .was-validated .form-check-input:valid,
    .form-check-input.is-valid {
        border-color: var(--bs-form-valid-border-color);
    }
    .was-validated .form-check-input:valid:checked,
    .form-check-input.is-valid:checked {
        background-color: var(--bs-form-valid-color);
    }
    .was-validated .form-check-input:valid:focus,
    .form-check-input.is-valid:focus {
        box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
    }
    .was-validated .form-check-input:valid ~ .form-check-label,
    .form-check-input.is-valid ~ .form-check-label {
        color: var(--bs-form-valid-color);
    }

    .form-check-inline .form-check-input ~ .valid-feedback {
        margin-left: 0.5em;
    }

    .was-validated .input-group > .form-control:not(:focus):valid,
    .input-group > .form-control:not(:focus).is-valid,
    .was-validated .input-group > .form-select:not(:focus):valid,
    .input-group > .form-select:not(:focus).is-valid,
    .was-validated .input-group > .form-floating:not(:focus-within):valid,
    .input-group > .form-floating:not(:focus-within).is-valid {
        z-index: 3;
    }

    .invalid-feedback {
        display: none;
        width: 100%;
        margin-top: 0.25rem;
        font-size: 0.875em;
        color: var(--bs-form-invalid-color);
    }

    .invalid-tooltip {
        position: absolute;
        top: 100%;
        z-index: 5;
        display: none;
        max-width: 100%;
        padding: 0.25rem 0.5rem;
        margin-top: 0.1rem;
        font-size: 0.875rem;
        color: #fff;
        background-color: var(--bs-danger);
        border-radius: var(--bs-border-radius);
    }

    .was-validated :invalid ~ .invalid-feedback,
    .was-validated :invalid ~ .invalid-tooltip,
    .is-invalid ~ .invalid-feedback,
    .is-invalid ~ .invalid-tooltip {
        display: block;
    }

    .was-validated .form-control:invalid,
    .form-control.is-invalid {
        border-color: var(--bs-form-invalid-border-color);
        padding-right: calc(1.5em + 0.75rem);
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
        background-repeat: no-repeat;
        background-position: right calc(0.375em + 0.1875rem) center;
        background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
    }
    .was-validated .form-control:invalid:focus,
    .form-control.is-invalid:focus {
        border-color: var(--bs-form-invalid-border-color);
        box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
    }

    .was-validated textarea.form-control:invalid,
    textarea.form-control.is-invalid {
        padding-right: calc(1.5em + 0.75rem);
        background-position: top calc(0.375em + 0.1875rem) right
            calc(0.375em + 0.1875rem);
    }

    .was-validated .form-select:invalid,
    .form-select.is-invalid {
        border-color: var(--bs-form-invalid-border-color);
    }
    .was-validated .form-select:invalid:not([multiple]):not([size]),
    .was-validated .form-select:invalid:not([multiple])[size='1'],
    .form-select.is-invalid:not([multiple]):not([size]),
    .form-select.is-invalid:not([multiple])[size='1'] {
        --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
        padding-right: 4.125rem;
        background-position:
            right 0.75rem center,
            center right 2.25rem;
        background-size:
            16px 12px,
            calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
    }
    .was-validated .form-select:invalid:focus,
    .form-select.is-invalid:focus {
        border-color: var(--bs-form-invalid-border-color);
        box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
    }

    .was-validated .form-control-color:invalid,
    .form-control-color.is-invalid {
        width: calc(3rem + calc(1.5em + 0.75rem));
    }

    .was-validated .form-check-input:invalid,
    .form-check-input.is-invalid {
        border-color: var(--bs-form-invalid-border-color);
    }
    .was-validated .form-check-input:invalid:checked,
    .form-check-input.is-invalid:checked {
        background-color: var(--bs-form-invalid-color);
    }
    .was-validated .form-check-input:invalid:focus,
    .form-check-input.is-invalid:focus {
        box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
    }
    .was-validated .form-check-input:invalid ~ .form-check-label,
    .form-check-input.is-invalid ~ .form-check-label {
        color: var(--bs-form-invalid-color);
    }

    .form-check-inline .form-check-input ~ .invalid-feedback {
        margin-left: 0.5em;
    }

    .was-validated .input-group > .form-control:not(:focus):invalid,
    .input-group > .form-control:not(:focus).is-invalid,
    .was-validated .input-group > .form-select:not(:focus):invalid,
    .input-group > .form-select:not(:focus).is-invalid,
    .was-validated .input-group > .form-floating:not(:focus-within):invalid,
    .input-group > .form-floating:not(:focus-within).is-invalid {
        z-index: 4;
    }

    .btn {
        --bs-btn-padding-x: 0.75rem;
        --bs-btn-padding-y: 0.375rem;
        --bs-btn-font-size: 1rem;
        --bs-btn-font-weight: 400;
        --bs-btn-line-height: 1.5;
        --bs-btn-color: var(--bs-body-color);
        --bs-btn-bg: transparent;
        --bs-btn-border-width: var(--bs-border-width);
        --bs-btn-border-color: transparent;
        --bs-btn-border-radius: var(--bs-border-radius);
        --bs-btn-hover-border-color: transparent;
        --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15),
            0 1px 1px rgba(0, 0, 0, 0.075);
        --bs-btn-disabled-opacity: 0.65;
        --bs-btn-focus-box-shadow: 0 0 0 0.25rem
            rgba(var(--bs-btn-focus-shadow-rgb), 0.5);
        display: inline-block;
        padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);
        font-family: var(--bs-btn-font-family);
        font-size: var(--bs-btn-font-size);
        font-weight: var(--bs-btn-font-weight);
        line-height: var(--bs-btn-line-height);
        color: var(--bs-btn-color);
        text-align: center;
        text-decoration: none;
        vertical-align: middle;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        user-select: none;
        border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);
        border-radius: var(--bs-btn-border-radius);
        background-color: var(--bs-btn-bg);
        transition:
            color 0.15s ease-in-out,
            background-color 0.15s ease-in-out,
            border-color 0.15s ease-in-out,
            box-shadow 0.15s ease-in-out;
    }
    @media (prefers-reduced-motion: reduce) {
        .btn {
            transition: none;
        }
    }
    .btn:hover {
        color: var(--bs-btn-hover-color);
        background-color: var(--bs-btn-hover-bg);
        border-color: var(--bs-btn-hover-border-color);
    }
    .btn-check + .btn:hover {
        color: var(--bs-btn-color);
        background-color: var(--bs-btn-bg);
        border-color: var(--bs-btn-border-color);
    }
    .btn:focus-visible {
        color: var(--bs-btn-hover-color);
        background-color: var(--bs-btn-hover-bg);
        border-color: var(--bs-btn-hover-border-color);
        outline: 0;
        box-shadow: var(--bs-btn-focus-box-shadow);
    }
    .btn-check:focus-visible + .btn {
        border-color: var(--bs-btn-hover-border-color);
        outline: 0;
        box-shadow: var(--bs-btn-focus-box-shadow);
    }
    .btn-check:checked + .btn,
    :not(.btn-check) + .btn:active,
    .btn:first-child:active,
    .btn.active,
    .btn.show {
        color: var(--bs-btn-active-color);
        background-color: var(--bs-btn-active-bg);
        border-color: var(--bs-btn-active-border-color);
    }
    .btn-check:checked + .btn:focus-visible,
    :not(.btn-check) + .btn:active:focus-visible,
    .btn:first-child:active:focus-visible,
    .btn.active:focus-visible,
    .btn.show:focus-visible {
        box-shadow: var(--bs-btn-focus-box-shadow);
    }
    .btn-check:checked:focus-visible + .btn {
        box-shadow: var(--bs-btn-focus-box-shadow);
    }
    .btn:disabled,
    .btn.disabled,
    fieldset:disabled .btn {
        color: var(--bs-btn-disabled-color);
        pointer-events: none;
        background-color: var(--bs-btn-disabled-bg);
        border-color: var(--bs-btn-disabled-border-color);
        opacity: var(--bs-btn-disabled-opacity);
    }

    .btn-primary {
        --bs-btn-color: #fff;
        --bs-btn-bg: #0d6efd;
        --bs-btn-border-color: #0d6efd;
        --bs-btn-hover-color: #fff;
        --bs-btn-hover-bg: #0b5ed7;
        --bs-btn-hover-border-color: #0a58ca;
        --bs-btn-focus-shadow-rgb: 49, 132, 253;
        --bs-btn-active-color: #fff;
        --bs-btn-active-bg: #0a58ca;
        --bs-btn-active-border-color: #0a53be;
        --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
        --bs-btn-disabled-color: #fff;
        --bs-btn-disabled-bg: #0d6efd;
        --bs-btn-disabled-border-color: #0d6efd;
    }

    .btn-secondary {
        --bs-btn-color: #fff;
        --bs-btn-bg: #6c757d;
        --bs-btn-border-color: #6c757d;
        --bs-btn-hover-color: #fff;
        --bs-btn-hover-bg: #5c636a;
        --bs-btn-hover-border-color: #565e64;
        --bs-btn-focus-shadow-rgb: 130, 138, 145;
        --bs-btn-active-color: #fff;
        --bs-btn-active-bg: #565e64;
        --bs-btn-active-border-color: #51585e;
        --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
        --bs-btn-disabled-color: #fff;
        --bs-btn-disabled-bg: #6c757d;
        --bs-btn-disabled-border-color: #6c757d;
    }

    .btn-success {
        --bs-btn-color: #fff;
        --bs-btn-bg: #198754;
        --bs-btn-border-color: #198754;
        --bs-btn-hover-color: #fff;
        --bs-btn-hover-bg: #157347;
        --bs-btn-hover-border-color: #146c43;
        --bs-btn-focus-shadow-rgb: 60, 153, 110;
        --bs-btn-active-color: #fff;
        --bs-btn-active-bg: #146c43;
        --bs-btn-active-border-color: #13653f;
        --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
        --bs-btn-disabled-color: #fff;
        --bs-btn-disabled-bg: #198754;
        --bs-btn-disabled-border-color: #198754;
    }

    .btn-info {
        --bs-btn-color: #000;
        --bs-btn-bg: #0dcaf0;
        --bs-btn-border-color: #0dcaf0;
        --bs-btn-hover-color: #000;
        --bs-btn-hover-bg: #31d2f2;
        --bs-btn-hover-border-color: #25cff2;
        --bs-btn-focus-shadow-rgb: 11, 172, 204;
        --bs-btn-active-color: #000;
        --bs-btn-active-bg: #3dd5f3;
        --bs-btn-active-border-color: #25cff2;
        --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
        --bs-btn-disabled-color: #000;
        --bs-btn-disabled-bg: #0dcaf0;
        --bs-btn-disabled-border-color: #0dcaf0;
    }

    .btn-warning {
        --bs-btn-color: #000;
        --bs-btn-bg: #ffc107;
        --bs-btn-border-color: #ffc107;
        --bs-btn-hover-color: #000;
        --bs-btn-hover-bg: #ffca2c;
        --bs-btn-hover-border-color: #ffc720;
        --bs-btn-focus-shadow-rgb: 217, 164, 6;
        --bs-btn-active-color: #000;
        --bs-btn-active-bg: #ffcd39;
        --bs-btn-active-border-color: #ffc720;
        --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
        --bs-btn-disabled-color: #000;
        --bs-btn-disabled-bg: #ffc107;
        --bs-btn-disabled-border-color: #ffc107;
    }

    .btn-danger {
        --bs-btn-color: #fff;
        --bs-btn-bg: #dc3545;
        --bs-btn-border-color: #dc3545;
        --bs-btn-hover-color: #fff;
        --bs-btn-hover-bg: #bb2d3b;
        --bs-btn-hover-border-color: #b02a37;
        --bs-btn-focus-shadow-rgb: 225, 83, 97;
        --bs-btn-active-color: #fff;
        --bs-btn-active-bg: #b02a37;
        --bs-btn-active-border-color: #a52834;
        --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
        --bs-btn-disabled-color: #fff;
        --bs-btn-disabled-bg: #dc3545;
        --bs-btn-disabled-border-color: #dc3545;
    }

    .btn-light {
        --bs-btn-color: #000;
        --bs-btn-bg: #f8f9fa;
        --bs-btn-border-color: #f8f9fa;
        --bs-btn-hover-color: #000;
        --bs-btn-hover-bg: #d3d4d5;
        --bs-btn-hover-border-color: #c6c7c8;
        --bs-btn-focus-shadow-rgb: 211, 212, 213;
        --bs-btn-active-color: #000;
        --bs-btn-active-bg: #c6c7c8;
        --bs-btn-active-border-color: #babbbc;
        --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
        --bs-btn-disabled-color: #000;
        --bs-btn-disabled-bg: #f8f9fa;
        --bs-btn-disabled-border-color: #f8f9fa;
    }

    .btn-dark {
        --bs-btn-color: #fff;
        --bs-btn-bg: #212529;
        --bs-btn-border-color: #212529;
        --bs-btn-hover-color: #fff;
        --bs-btn-hover-bg: #424649;
        --bs-btn-hover-border-color: #373b3e;
        --bs-btn-focus-shadow-rgb: 66, 70, 73;
        --bs-btn-active-color: #fff;
        --bs-btn-active-bg: #4d5154;
        --bs-btn-active-border-color: #373b3e;
        --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
        --bs-btn-disabled-color: #fff;
        --bs-btn-disabled-bg: #212529;
        --bs-btn-disabled-border-color: #212529;
    }

    .btn-outline-primary {
        --bs-btn-color: #0d6efd;
        --bs-btn-border-color: #0d6efd;
        --bs-btn-hover-color: #fff;
        --bs-btn-hover-bg: #0d6efd;
        --bs-btn-hover-border-color: #0d6efd;
        --bs-btn-focus-shadow-rgb: 13, 110, 253;
        --bs-btn-active-color: #fff;
        --bs-btn-active-bg: #0d6efd;
        --bs-btn-active-border-color: #0d6efd;
        --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
        --bs-btn-disabled-color: #0d6efd;
        --bs-btn-disabled-bg: transparent;
        --bs-btn-disabled-border-color: #0d6efd;
        --bs-gradient: none;
    }

    .btn-outline-secondary {
        --bs-btn-color: #6c757d;
        --bs-btn-border-color: #6c757d;
        --bs-btn-hover-color: #fff;
        --bs-btn-hover-bg: #6c757d;
        --bs-btn-hover-border-color: #6c757d;
        --bs-btn-focus-shadow-rgb: 108, 117, 125;
        --bs-btn-active-color: #fff;
        --bs-btn-active-bg: #6c757d;
        --bs-btn-active-border-color: #6c757d;
        --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
        --bs-btn-disabled-color: #6c757d;
        --bs-btn-disabled-bg: transparent;
        --bs-btn-disabled-border-color: #6c757d;
        --bs-gradient: none;
    }

    .btn-outline-success {
        --bs-btn-color: #198754;
        --bs-btn-border-color: #198754;
        --bs-btn-hover-color: #fff;
        --bs-btn-hover-bg: #198754;
        --bs-btn-hover-border-color: #198754;
        --bs-btn-focus-shadow-rgb: 25, 135, 84;
        --bs-btn-active-color: #fff;
        --bs-btn-active-bg: #198754;
        --bs-btn-active-border-color: #198754;
        --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
        --bs-btn-disabled-color: #198754;
        --bs-btn-disabled-bg: transparent;
        --bs-btn-disabled-border-color: #198754;
        --bs-gradient: none;
    }

    .btn-outline-info {
        --bs-btn-color: #0dcaf0;
        --bs-btn-border-color: #0dcaf0;
        --bs-btn-hover-color: #000;
        --bs-btn-hover-bg: #0dcaf0;
        --bs-btn-hover-border-color: #0dcaf0;
        --bs-btn-focus-shadow-rgb: 13, 202, 240;
        --bs-btn-active-color: #000;
        --bs-btn-active-bg: #0dcaf0;
        --bs-btn-active-border-color: #0dcaf0;
        --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
        --bs-btn-disabled-color: #0dcaf0;
        --bs-btn-disabled-bg: transparent;
        --bs-btn-disabled-border-color: #0dcaf0;
        --bs-gradient: none;
    }

    .btn-outline-warning {
        --bs-btn-color: #ffc107;
        --bs-btn-border-color: #ffc107;
        --bs-btn-hover-color: #000;
        --bs-btn-hover-bg: #ffc107;
        --bs-btn-hover-border-color: #ffc107;
        --bs-btn-focus-shadow-rgb: 255, 193, 7;
        --bs-btn-active-color: #000;
        --bs-btn-active-bg: #ffc107;
        --bs-btn-active-border-color: #ffc107;
        --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
        --bs-btn-disabled-color: #ffc107;
        --bs-btn-disabled-bg: transparent;
        --bs-btn-disabled-border-color: #ffc107;
        --bs-gradient: none;
    }

    .btn-outline-danger {
        --bs-btn-color: #dc3545;
        --bs-btn-border-color: #dc3545;
        --bs-btn-hover-color: #fff;
        --bs-btn-hover-bg: #dc3545;
        --bs-btn-hover-border-color: #dc3545;
        --bs-btn-focus-shadow-rgb: 220, 53, 69;
        --bs-btn-active-color: #fff;
        --bs-btn-active-bg: #dc3545;
        --bs-btn-active-border-color: #dc3545;
        --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
        --bs-btn-disabled-color: #dc3545;
        --bs-btn-disabled-bg: transparent;
        --bs-btn-disabled-border-color: #dc3545;
        --bs-gradient: none;
    }

    .btn-outline-light {
        --bs-btn-color: #f8f9fa;
        --bs-btn-border-color: #f8f9fa;
        --bs-btn-hover-color: #000;
        --bs-btn-hover-bg: #f8f9fa;
        --bs-btn-hover-border-color: #f8f9fa;
        --bs-btn-focus-shadow-rgb: 248, 249, 250;
        --bs-btn-active-color: #000;
        --bs-btn-active-bg: #f8f9fa;
        --bs-btn-active-border-color: #f8f9fa;
        --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
        --bs-btn-disabled-color: #f8f9fa;
        --bs-btn-disabled-bg: transparent;
        --bs-btn-disabled-border-color: #f8f9fa;
        --bs-gradient: none;
    }

    .btn-outline-dark {
        --bs-btn-color: #212529;
        --bs-btn-border-color: #212529;
        --bs-btn-hover-color: #fff;
        --bs-btn-hover-bg: #212529;
        --bs-btn-hover-border-color: #212529;
        --bs-btn-focus-shadow-rgb: 33, 37, 41;
        --bs-btn-active-color: #fff;
        --bs-btn-active-bg: #212529;
        --bs-btn-active-border-color: #212529;
        --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
        --bs-btn-disabled-color: #212529;
        --bs-btn-disabled-bg: transparent;
        --bs-btn-disabled-border-color: #212529;
        --bs-gradient: none;
    }

    .btn-link {
        --bs-btn-font-weight: 400;
        --bs-btn-color: var(--bs-link-color);
        --bs-btn-bg: transparent;
        --bs-btn-border-color: transparent;
        --bs-btn-hover-color: var(--bs-link-hover-color);
        --bs-btn-hover-border-color: transparent;
        --bs-btn-active-color: var(--bs-link-hover-color);
        --bs-btn-active-border-color: transparent;
        --bs-btn-disabled-color: #6c757d;
        --bs-btn-disabled-border-color: transparent;
        --bs-btn-box-shadow: 0 0 0 #000;
        --bs-btn-focus-shadow-rgb: 49, 132, 253;
        text-decoration: underline;
    }
    .btn-link:focus-visible {
        color: var(--bs-btn-color);
    }
    .btn-link:hover {
        color: var(--bs-btn-hover-color);
    }

    .btn-lg,
    .btn-group-lg > .btn {
        --bs-btn-padding-y: 0.5rem;
        --bs-btn-padding-x: 1rem;
        --bs-btn-font-size: 1.25rem;
        --bs-btn-border-radius: var(--bs-border-radius-lg);
    }

    .btn-sm,
    .btn-group-sm > .btn {
        --bs-btn-padding-y: 0.25rem;
        --bs-btn-padding-x: 0.5rem;
        --bs-btn-font-size: 0.875rem;
        --bs-btn-border-radius: var(--bs-border-radius-sm);
    }

    .fade {
        transition: opacity 0.15s linear;
    }
    @media (prefers-reduced-motion: reduce) {
        .fade {
            transition: none;
        }
    }
    .fade:not(.show) {
        opacity: 0;
    }

    .collapse:not(.show) {
        display: none;
    }

    .collapsing {
        height: 0;
        overflow: hidden;
        transition: height 0.35s ease;
    }
    @media (prefers-reduced-motion: reduce) {
        .collapsing {
            transition: none;
        }
    }
    .collapsing.collapse-horizontal {
        width: 0;
        height: auto;
        transition: width 0.35s ease;
    }
    @media (prefers-reduced-motion: reduce) {
        .collapsing.collapse-horizontal {
            transition: none;
        }
    }

    .dropup,
    .dropend,
    .dropdown,
    .dropstart,
    .dropup-center,
    .dropdown-center {
        position: relative;
    }

    .dropdown-toggle {
        white-space: nowrap;
    }
    .dropdown-toggle::after {
        display: inline-block;
        margin-left: 0.255em;
        vertical-align: 0.255em;
        content: '';
        border-top: 0.3em solid;
        border-right: 0.3em solid transparent;
        border-bottom: 0;
        border-left: 0.3em solid transparent;
    }
    .dropdown-toggle:empty::after {
        margin-left: 0;
    }

    .dropdown-menu {
        --bs-dropdown-zindex: 1000;
        --bs-dropdown-min-width: 10rem;
        --bs-dropdown-padding-x: 0;
        --bs-dropdown-padding-y: 0.5rem;
        --bs-dropdown-spacer: 0.125rem;
        --bs-dropdown-font-size: 1rem;
        --bs-dropdown-color: var(--bs-body-color);
        --bs-dropdown-bg: var(--bs-body-bg);
        --bs-dropdown-border-color: var(--bs-border-color-translucent);
        --bs-dropdown-border-radius: var(--bs-border-radius);
        --bs-dropdown-border-width: var(--bs-border-width);
        --bs-dropdown-inner-border-radius: calc(
            var(--bs-border-radius) - var(--bs-border-width)
        );
        --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
        --bs-dropdown-divider-margin-y: 0.5rem;
        --bs-dropdown-box-shadow: var(--bs-box-shadow);
        --bs-dropdown-link-color: var(--bs-body-color);
        --bs-dropdown-link-hover-color: var(--bs-body-color);
        --bs-dropdown-link-hover-bg: var(--bs-tertiary-bg);
        --bs-dropdown-link-active-color: #fff;
        --bs-dropdown-link-active-bg: #0d6efd;
        --bs-dropdown-link-disabled-color: var(--bs-tertiary-color);
        --bs-dropdown-item-padding-x: 1rem;
        --bs-dropdown-item-padding-y: 0.25rem;
        --bs-dropdown-header-color: #6c757d;
        --bs-dropdown-header-padding-x: 1rem;
        --bs-dropdown-header-padding-y: 0.5rem;
        position: absolute;
        z-index: var(--bs-dropdown-zindex);
        display: none;
        min-width: var(--bs-dropdown-min-width);
        padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);
        margin: 0;
        font-size: var(--bs-dropdown-font-size);
        color: var(--bs-dropdown-color);
        text-align: left;
        list-style: none;
        background-color: var(--bs-dropdown-bg);
        background-clip: padding-box;
        border: var(--bs-dropdown-border-width) solid
            var(--bs-dropdown-border-color);
        border-radius: var(--bs-dropdown-border-radius);
    }
    .dropdown-menu[data-bs-popper] {
        top: 100%;
        left: 0;
        margin-top: var(--bs-dropdown-spacer);
    }

    .dropdown-menu-start {
        --bs-position: start;
    }
    .dropdown-menu-start[data-bs-popper] {
        right: auto;
        left: 0;
    }

    .dropdown-menu-end {
        --bs-position: end;
    }
    .dropdown-menu-end[data-bs-popper] {
        right: 0;
        left: auto;
    }

    @media (min-width: 576px) {
        .dropdown-menu-sm-start {
            --bs-position: start;
        }
        .dropdown-menu-sm-start[data-bs-popper] {
            right: auto;
            left: 0;
        }
        .dropdown-menu-sm-end {
            --bs-position: end;
        }
        .dropdown-menu-sm-end[data-bs-popper] {
            right: 0;
            left: auto;
        }
    }
    @media (min-width: 768px) {
        .dropdown-menu-md-start {
            --bs-position: start;
        }
        .dropdown-menu-md-start[data-bs-popper] {
            right: auto;
            left: 0;
        }
        .dropdown-menu-md-end {
            --bs-position: end;
        }
        .dropdown-menu-md-end[data-bs-popper] {
            right: 0;
            left: auto;
        }
    }
    @media (min-width: 992px) {
        .dropdown-menu-lg-start {
            --bs-position: start;
        }
        .dropdown-menu-lg-start[data-bs-popper] {
            right: auto;
            left: 0;
        }
        .dropdown-menu-lg-end {
            --bs-position: end;
        }
        .dropdown-menu-lg-end[data-bs-popper] {
            right: 0;
            left: auto;
        }
    }
    @media (min-width: 1200px) {
        .dropdown-menu-xl-start {
            --bs-position: start;
        }
        .dropdown-menu-xl-start[data-bs-popper] {
            right: auto;
            left: 0;
        }
        .dropdown-menu-xl-end {
            --bs-position: end;
        }
        .dropdown-menu-xl-end[data-bs-popper] {
            right: 0;
            left: auto;
        }
    }
    @media (min-width: 1400px) {
        .dropdown-menu-xxl-start {
            --bs-position: start;
        }
        .dropdown-menu-xxl-start[data-bs-popper] {
            right: auto;
            left: 0;
        }
        .dropdown-menu-xxl-end {
            --bs-position: end;
        }
        .dropdown-menu-xxl-end[data-bs-popper] {
            right: 0;
            left: auto;
        }
    }
    .dropup .dropdown-menu[data-bs-popper] {
        top: auto;
        bottom: 100%;
        margin-top: 0;
        margin-bottom: var(--bs-dropdown-spacer);
    }
    .dropup .dropdown-toggle::after {
        display: inline-block;
        margin-left: 0.255em;
        vertical-align: 0.255em;
        content: '';
        border-top: 0;
        border-right: 0.3em solid transparent;
        border-bottom: 0.3em solid;
        border-left: 0.3em solid transparent;
    }
    .dropup .dropdown-toggle:empty::after {
        margin-left: 0;
    }

    .dropend .dropdown-menu[data-bs-popper] {
        top: 0;
        right: auto;
        left: 100%;
        margin-top: 0;
        margin-left: var(--bs-dropdown-spacer);
    }
    .dropend .dropdown-toggle::after {
        display: inline-block;
        margin-left: 0.255em;
        vertical-align: 0.255em;
        content: '';
        border-top: 0.3em solid transparent;
        border-right: 0;
        border-bottom: 0.3em solid transparent;
        border-left: 0.3em solid;
    }
    .dropend .dropdown-toggle:empty::after {
        margin-left: 0;
    }
    .dropend .dropdown-toggle::after {
        vertical-align: 0;
    }

    .dropstart .dropdown-menu[data-bs-popper] {
        top: 0;
        right: 100%;
        left: auto;
        margin-top: 0;
        margin-right: var(--bs-dropdown-spacer);
    }
    .dropstart .dropdown-toggle::after {
        display: inline-block;
        margin-left: 0.255em;
        vertical-align: 0.255em;
        content: '';
    }
    .dropstart .dropdown-toggle::after {
        display: none;
    }
    .dropstart .dropdown-toggle::before {
        display: inline-block;
        margin-right: 0.255em;
        vertical-align: 0.255em;
        content: '';
        border-top: 0.3em solid transparent;
        border-right: 0.3em solid;
        border-bottom: 0.3em solid transparent;
    }
    .dropstart .dropdown-toggle:empty::after {
        margin-left: 0;
    }
    .dropstart .dropdown-toggle::before {
        vertical-align: 0;
    }

    .dropdown-divider {
        height: 0;
        margin: var(--bs-dropdown-divider-margin-y) 0;
        overflow: hidden;
        border-top: 1px solid var(--bs-dropdown-divider-bg);
        opacity: 1;
    }

    .dropdown-item {
        display: block;
        width: 100%;
        padding: var(--bs-dropdown-item-padding-y)
            var(--bs-dropdown-item-padding-x);
        clear: both;
        font-weight: 400;
        color: var(--bs-dropdown-link-color);
        text-align: inherit;
        text-decoration: none;
        white-space: nowrap;
        background-color: transparent;
        border: 0;
        border-radius: var(--bs-dropdown-item-border-radius, 0);
    }
    .dropdown-item:hover,
    .dropdown-item:focus {
        color: var(--bs-dropdown-link-hover-color);
        background-color: var(--bs-dropdown-link-hover-bg);
    }
    .dropdown-item.active,
    .dropdown-item:active {
        color: var(--bs-dropdown-link-active-color);
        text-decoration: none;
        background-color: var(--bs-dropdown-link-active-bg);
    }
    .dropdown-item.disabled,
    .dropdown-item:disabled {
        color: var(--bs-dropdown-link-disabled-color);
        pointer-events: none;
        background-color: transparent;
    }

    .dropdown-menu.show {
        display: block;
    }

    .dropdown-header {
        display: block;
        padding: var(--bs-dropdown-header-padding-y)
            var(--bs-dropdown-header-padding-x);
        margin-bottom: 0;
        font-size: 0.875rem;
        color: var(--bs-dropdown-header-color);
        white-space: nowrap;
    }

    .dropdown-item-text {
        display: block;
        padding: var(--bs-dropdown-item-padding-y)
            var(--bs-dropdown-item-padding-x);
        color: var(--bs-dropdown-link-color);
    }

    .dropdown-menu-dark {
        --bs-dropdown-color: #dee2e6;
        --bs-dropdown-bg: #343a40;
        --bs-dropdown-border-color: var(--bs-border-color-translucent);
        --bs-dropdown-box-shadow: ;
        --bs-dropdown-link-color: #dee2e6;
        --bs-dropdown-link-hover-color: #fff;
        --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
        --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);
        --bs-dropdown-link-active-color: #fff;
        --bs-dropdown-link-active-bg: #0d6efd;
        --bs-dropdown-link-disabled-color: #adb5bd;
        --bs-dropdown-header-color: #adb5bd;
    }

    .btn-group,
    .btn-group-vertical {
        position: relative;
        display: inline-flex;
        vertical-align: middle;
    }
    .btn-group > .btn,
    .btn-group-vertical > .btn {
        position: relative;
        flex: 1 1 auto;
    }
    .btn-group > .btn-check:checked + .btn,
    .btn-group > .btn-check:focus + .btn,
    .btn-group > .btn:hover,
    .btn-group > .btn:focus,
    .btn-group > .btn:active,
    .btn-group > .btn.active,
    .btn-group-vertical > .btn-check:checked + .btn,
    .btn-group-vertical > .btn-check:focus + .btn,
    .btn-group-vertical > .btn:hover,
    .btn-group-vertical > .btn:focus,
    .btn-group-vertical > .btn:active,
    .btn-group-vertical > .btn.active {
        z-index: 1;
    }

    .btn-toolbar {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
    }
    .btn-toolbar .input-group {
        width: auto;
    }

    .btn-group {
        border-radius: var(--bs-border-radius);
    }
    .btn-group > :not(.btn-check:first-child) + .btn,
    .btn-group > .btn-group:not(:first-child) {
        margin-left: calc(var(--bs-border-width) * -1);
    }
    .btn-group > .btn:not(:last-child):not(.dropdown-toggle),
    .btn-group > .btn.dropdown-toggle-split:first-child,
    .btn-group > .btn-group:not(:last-child) > .btn {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
    }
    .btn-group > .btn:nth-child(n + 3),
    .btn-group > :not(.btn-check) + .btn,
    .btn-group > .btn-group:not(:first-child) > .btn {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }

    .dropdown-toggle-split {
        padding-right: 0.5625rem;
        padding-left: 0.5625rem;
    }
    .dropdown-toggle-split::after,
    .dropup .dropdown-toggle-split::after,
    .dropend .dropdown-toggle-split::after {
        margin-left: 0;
    }
    .dropstart .dropdown-toggle-split::before {
        margin-right: 0;
    }

    .btn-sm + .dropdown-toggle-split,
    .btn-group-sm > .btn + .dropdown-toggle-split {
        padding-right: 0.375rem;
        padding-left: 0.375rem;
    }

    .btn-lg + .dropdown-toggle-split,
    .btn-group-lg > .btn + .dropdown-toggle-split {
        padding-right: 0.75rem;
        padding-left: 0.75rem;
    }

    .btn-group-vertical {
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
    }
    .btn-group-vertical > .btn,
    .btn-group-vertical > .btn-group {
        width: 100%;
    }
    .btn-group-vertical > .btn:not(:first-child),
    .btn-group-vertical > .btn-group:not(:first-child) {
        margin-top: calc(var(--bs-border-width) * -1);
    }
    .btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
    .btn-group-vertical > .btn-group:not(:last-child) > .btn {
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
    }
    .btn-group-vertical > .btn ~ .btn,
    .btn-group-vertical > .btn-group:not(:first-child) > .btn {
        border-top-left-radius: 0;
        border-top-right-radius: 0;
    }

    .nav {
        --bs-nav-link-padding-x: 1rem;
        --bs-nav-link-padding-y: 0.5rem;
        --bs-nav-link-font-weight: ;
        --bs-nav-link-color: var(--bs-link-color);
        --bs-nav-link-hover-color: var(--bs-link-hover-color);
        --bs-nav-link-disabled-color: var(--bs-secondary-color);
        display: flex;
        flex-wrap: wrap;
        padding-left: 0;
        margin-bottom: 0;
        list-style: none;
    }

    .nav-link {
        display: block;
        padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);
        font-size: var(--bs-nav-link-font-size);
        font-weight: var(--bs-nav-link-font-weight);
        color: var(--bs-nav-link-color);
        text-decoration: none;
        background: none;
        border: 0;
        transition:
            color 0.15s ease-in-out,
            background-color 0.15s ease-in-out,
            border-color 0.15s ease-in-out;
    }
    @media (prefers-reduced-motion: reduce) {
        .nav-link {
            transition: none;
        }
    }
    .nav-link:hover,
    .nav-link:focus {
        color: var(--bs-nav-link-hover-color);
    }
    .nav-link:focus-visible {
        outline: 0;
        box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
    }
    .nav-link.disabled,
    .nav-link:disabled {
        color: var(--bs-nav-link-disabled-color);
        pointer-events: none;
        cursor: default;
    }

    .nav-tabs {
        --bs-nav-tabs-border-width: var(--bs-border-width);
        --bs-nav-tabs-border-color: var(--bs-border-color);
        --bs-nav-tabs-border-radius: var(--bs-border-radius);
        --bs-nav-tabs-link-hover-border-color: var(--bs-secondary-bg)
            var(--bs-secondary-bg) var(--bs-border-color);
        --bs-nav-tabs-link-active-color: var(--bs-emphasis-color);
        --bs-nav-tabs-link-active-bg: var(--bs-body-bg);
        --bs-nav-tabs-link-active-border-color: var(--bs-border-color)
            var(--bs-border-color) var(--bs-body-bg);
        border-bottom: var(--bs-nav-tabs-border-width) solid
            var(--bs-nav-tabs-border-color);
    }
    .nav-tabs .nav-link {
        margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));
        border: var(--bs-nav-tabs-border-width) solid transparent;
        border-top-left-radius: var(--bs-nav-tabs-border-radius);
        border-top-right-radius: var(--bs-nav-tabs-border-radius);
    }
    .nav-tabs .nav-link:hover,
    .nav-tabs .nav-link:focus {
        isolation: isolate;
        border-color: var(--bs-nav-tabs-link-hover-border-color);
    }
    .nav-tabs .nav-link.active,
    .nav-tabs .nav-item.show .nav-link {
        color: var(--bs-nav-tabs-link-active-color);
        background-color: var(--bs-nav-tabs-link-active-bg);
        border-color: var(--bs-nav-tabs-link-active-border-color);
    }
    .nav-tabs .dropdown-menu {
        margin-top: calc(-1 * var(--bs-nav-tabs-border-width));
        border-top-left-radius: 0;
        border-top-right-radius: 0;
    }

    .nav-pills {
        --bs-nav-pills-border-radius: var(--bs-border-radius);
        --bs-nav-pills-link-active-color: #fff;
        --bs-nav-pills-link-active-bg: #0d6efd;
    }
    .nav-pills .nav-link {
        border-radius: var(--bs-nav-pills-border-radius);
    }
    .nav-pills .nav-link.active,
    .nav-pills .show > .nav-link {
        color: var(--bs-nav-pills-link-active-color);
        background-color: var(--bs-nav-pills-link-active-bg);
    }

    .nav-underline {
        --bs-nav-underline-gap: 1rem;
        --bs-nav-underline-border-width: 0.125rem;
        --bs-nav-underline-link-active-color: var(--bs-emphasis-color);
        gap: var(--bs-nav-underline-gap);
    }
    .nav-underline .nav-link {
        padding-right: 0;
        padding-left: 0;
        border-bottom: var(--bs-nav-underline-border-width) solid transparent;
    }
    .nav-underline .nav-link:hover,
    .nav-underline .nav-link:focus {
        border-bottom-color: currentcolor;
    }
    .nav-underline .nav-link.active,
    .nav-underline .show > .nav-link {
        font-weight: 700;
        color: var(--bs-nav-underline-link-active-color);
        border-bottom-color: currentcolor;
    }

    .nav-fill > .nav-link,
    .nav-fill .nav-item {
        flex: 1 1 auto;
        text-align: center;
    }

    .nav-justified > .nav-link,
    .nav-justified .nav-item {
        flex-basis: 0;
        flex-grow: 1;
        text-align: center;
    }

    .nav-fill .nav-item .nav-link,
    .nav-justified .nav-item .nav-link {
        width: 100%;
    }

    .tab-content > .tab-pane {
        display: none;
    }
    .tab-content > .active {
        display: block;
    }

    .navbar {
        --bs-navbar-padding-x: 0;
        --bs-navbar-padding-y: 0.5rem;
        --bs-navbar-color: rgba(var(--bs-emphasis-color-rgb), 0.65);
        --bs-navbar-hover-color: rgba(var(--bs-emphasis-color-rgb), 0.8);
        --bs-navbar-disabled-color: rgba(var(--bs-emphasis-color-rgb), 0.3);
        --bs-navbar-active-color: rgba(var(--bs-emphasis-color-rgb), 1);
        --bs-navbar-brand-padding-y: 0.3125rem;
        --bs-navbar-brand-margin-end: 1rem;
        --bs-navbar-brand-font-size: 1.25rem;
        --bs-navbar-brand-color: rgba(var(--bs-emphasis-color-rgb), 1);
        --bs-navbar-brand-hover-color: rgba(var(--bs-emphasis-color-rgb), 1);
        --bs-navbar-nav-link-padding-x: 0.5rem;
        --bs-navbar-toggler-padding-y: 0.25rem;
        --bs-navbar-toggler-padding-x: 0.75rem;
        --bs-navbar-toggler-font-size: 1.25rem;
        --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
        --bs-navbar-toggler-border-color: rgba(
            var(--bs-emphasis-color-rgb),
            0.15
        );
        --bs-navbar-toggler-border-radius: var(--bs-border-radius);
        --bs-navbar-toggler-focus-width: 0.25rem;
        --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
        position: relative;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);
    }
    .navbar > .container,
    .navbar > .container-fluid,
    .navbar > .container-sm,
    .navbar > .container-md,
    .navbar > .container-lg,
    .navbar > .container-xl,
    .navbar > .container-xxl {
        display: flex;
        flex-wrap: inherit;
        align-items: center;
        justify-content: space-between;
    }
    .navbar-brand {
        padding-top: var(--bs-navbar-brand-padding-y);
        padding-bottom: var(--bs-navbar-brand-padding-y);
        margin-right: var(--bs-navbar-brand-margin-end);
        font-size: var(--bs-navbar-brand-font-size);
        color: var(--bs-navbar-brand-color);
        text-decoration: none;
        white-space: nowrap;
    }
    .navbar-brand:hover,
    .navbar-brand:focus {
        color: var(--bs-navbar-brand-hover-color);
    }

    .navbar-nav {
        --bs-nav-link-padding-x: 0;
        --bs-nav-link-padding-y: 0.5rem;
        --bs-nav-link-font-weight: ;
        --bs-nav-link-color: var(--bs-navbar-color);
        --bs-nav-link-hover-color: var(--bs-navbar-hover-color);
        --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);
        display: flex;
        flex-direction: column;
        padding-left: 0;
        margin-bottom: 0;
        list-style: none;
    }
    .navbar-nav .nav-link.active,
    .navbar-nav .nav-link.show {
        color: var(--bs-navbar-active-color);
    }
    .navbar-nav .dropdown-menu {
        position: static;
    }

    .navbar-text {
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
        color: var(--bs-navbar-color);
    }
    .navbar-text a,
    .navbar-text a:hover,
    .navbar-text a:focus {
        color: var(--bs-navbar-active-color);
    }

    .navbar-collapse {
        flex-basis: 100%;
        flex-grow: 1;
        align-items: center;
    }

    .navbar-toggler {
        padding: var(--bs-navbar-toggler-padding-y)
            var(--bs-navbar-toggler-padding-x);
        font-size: var(--bs-navbar-toggler-font-size);
        line-height: 1;
        color: var(--bs-navbar-color);
        background-color: transparent;
        border: var(--bs-border-width) solid
            var(--bs-navbar-toggler-border-color);
        border-radius: var(--bs-navbar-toggler-border-radius);
        transition: var(--bs-navbar-toggler-transition);
    }
    @media (prefers-reduced-motion: reduce) {
        .navbar-toggler {
            transition: none;
        }
    }
    .navbar-toggler:hover {
        text-decoration: none;
    }
    .navbar-toggler:focus {
        text-decoration: none;
        outline: 0;
        box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);
    }

    .navbar-toggler-icon {
        display: inline-block;
        width: 1.5em;
        height: 1.5em;
        vertical-align: middle;
        background-image: var(--bs-navbar-toggler-icon-bg);
        background-repeat: no-repeat;
        background-position: center;
        background-size: 100%;
    }

    .navbar-nav-scroll {
        max-height: var(--bs-scroll-height, 75vh);
        overflow-y: auto;
    }

    @media (min-width: 576px) {
        .navbar-expand-sm {
            flex-wrap: nowrap;
            justify-content: flex-start;
        }
        .navbar-expand-sm .navbar-nav {
            flex-direction: row;
        }
        .navbar-expand-sm .navbar-nav .dropdown-menu {
            position: absolute;
        }
        .navbar-expand-sm .navbar-nav .nav-link {
            padding-right: var(--bs-navbar-nav-link-padding-x);
            padding-left: var(--bs-navbar-nav-link-padding-x);
        }
        .navbar-expand-sm .navbar-nav-scroll {
            overflow: visible;
        }
        .navbar-expand-sm .navbar-collapse {
            display: flex !important;
            flex-basis: auto;
        }
        .navbar-expand-sm .navbar-toggler {
            display: none;
        }
        .navbar-expand-sm .offcanvas {
            position: static;
            z-index: auto;
            flex-grow: 1;
            width: auto !important;
            height: auto !important;
            visibility: visible !important;
            background-color: transparent !important;
            border: 0 !important;
            transform: none !important;
            transition: none;
        }
        .navbar-expand-sm .offcanvas .offcanvas-header {
            display: none;
        }
        .navbar-expand-sm .offcanvas .offcanvas-body {
            display: flex;
            flex-grow: 0;
            padding: 0;
            overflow-y: visible;
        }
    }
    @media (min-width: 768px) {
        .navbar-expand-md {
            flex-wrap: nowrap;
            justify-content: flex-start;
        }
        .navbar-expand-md .navbar-nav {
            flex-direction: row;
        }
        .navbar-expand-md .navbar-nav .dropdown-menu {
            position: absolute;
        }
        .navbar-expand-md .navbar-nav .nav-link {
            padding-right: var(--bs-navbar-nav-link-padding-x);
            padding-left: var(--bs-navbar-nav-link-padding-x);
        }
        .navbar-expand-md .navbar-nav-scroll {
            overflow: visible;
        }
        .navbar-expand-md .navbar-collapse {
            display: flex !important;
            flex-basis: auto;
        }
        .navbar-expand-md .navbar-toggler {
            display: none;
        }
        .navbar-expand-md .offcanvas {
            position: static;
            z-index: auto;
            flex-grow: 1;
            width: auto !important;
            height: auto !important;
            visibility: visible !important;
            background-color: transparent !important;
            border: 0 !important;
            transform: none !important;
            transition: none;
        }
        .navbar-expand-md .offcanvas .offcanvas-header {
            display: none;
        }
        .navbar-expand-md .offcanvas .offcanvas-body {
            display: flex;
            flex-grow: 0;
            padding: 0;
            overflow-y: visible;
        }
    }
    @media (min-width: 992px) {
        .navbar-expand-lg {
            flex-wrap: nowrap;
            justify-content: flex-start;
        }
        .navbar-expand-lg .navbar-nav {
            flex-direction: row;
        }
        .navbar-expand-lg .navbar-nav .dropdown-menu {
            position: absolute;
        }
        .navbar-expand-lg .navbar-nav .nav-link {
            padding-right: var(--bs-navbar-nav-link-padding-x);
            padding-left: var(--bs-navbar-nav-link-padding-x);
        }
        .navbar-expand-lg .navbar-nav-scroll {
            overflow: visible;
        }
        .navbar-expand-lg .navbar-collapse {
            display: flex !important;
            flex-basis: auto;
        }
        .navbar-expand-lg .navbar-toggler {
            display: none;
        }
        .navbar-expand-lg .offcanvas {
            position: static;
            z-index: auto;
            flex-grow: 1;
            width: auto !important;
            height: auto !important;
            visibility: visible !important;
            background-color: transparent !important;
            border: 0 !important;
            transform: none !important;
            transition: none;
        }
        .navbar-expand-lg .offcanvas .offcanvas-header {
            display: none;
        }
        .navbar-expand-lg .offcanvas .offcanvas-body {
            display: flex;
            flex-grow: 0;
            padding: 0;
            overflow-y: visible;
        }
    }
    @media (min-width: 1200px) {
        .navbar-expand-xl {
            flex-wrap: nowrap;
            justify-content: flex-start;
        }
        .navbar-expand-xl .navbar-nav {
            flex-direction: row;
        }
        .navbar-expand-xl .navbar-nav .dropdown-menu {
            position: absolute;
        }
        .navbar-expand-xl .navbar-nav .nav-link {
            padding-right: var(--bs-navbar-nav-link-padding-x);
            padding-left: var(--bs-navbar-nav-link-padding-x);
        }
        .navbar-expand-xl .navbar-nav-scroll {
            overflow: visible;
        }
        .navbar-expand-xl .navbar-collapse {
            display: flex !important;
            flex-basis: auto;
        }
        .navbar-expand-xl .navbar-toggler {
            display: none;
        }
        .navbar-expand-xl .offcanvas {
            position: static;
            z-index: auto;
            flex-grow: 1;
            width: auto !important;
            height: auto !important;
            visibility: visible !important;
            background-color: transparent !important;
            border: 0 !important;
            transform: none !important;
            transition: none;
        }
        .navbar-expand-xl .offcanvas .offcanvas-header {
            display: none;
        }
        .navbar-expand-xl .offcanvas .offcanvas-body {
            display: flex;
            flex-grow: 0;
            padding: 0;
            overflow-y: visible;
        }
    }
    @media (min-width: 1400px) {
        .navbar-expand-xxl {
            flex-wrap: nowrap;
            justify-content: flex-start;
        }
        .navbar-expand-xxl .navbar-nav {
            flex-direction: row;
        }
        .navbar-expand-xxl .navbar-nav .dropdown-menu {
            position: absolute;
        }
        .navbar-expand-xxl .navbar-nav .nav-link {
            padding-right: var(--bs-navbar-nav-link-padding-x);
            padding-left: var(--bs-navbar-nav-link-padding-x);
        }
        .navbar-expand-xxl .navbar-nav-scroll {
            overflow: visible;
        }
        .navbar-expand-xxl .navbar-collapse {
            display: flex !important;
            flex-basis: auto;
        }
        .navbar-expand-xxl .navbar-toggler {
            display: none;
        }
        .navbar-expand-xxl .offcanvas {
            position: static;
            z-index: auto;
            flex-grow: 1;
            width: auto !important;
            height: auto !important;
            visibility: visible !important;
            background-color: transparent !important;
            border: 0 !important;
            transform: none !important;
            transition: none;
        }
        .navbar-expand-xxl .offcanvas .offcanvas-header {
            display: none;
        }
        .navbar-expand-xxl .offcanvas .offcanvas-body {
            display: flex;
            flex-grow: 0;
            padding: 0;
            overflow-y: visible;
        }
    }
    .navbar-expand {
        flex-wrap: nowrap;
        justify-content: flex-start;
    }
    .navbar-expand .navbar-nav {
        flex-direction: row;
    }
    .navbar-expand .navbar-nav .dropdown-menu {
        position: absolute;
    }
    .navbar-expand .navbar-nav .nav-link {
        padding-right: var(--bs-navbar-nav-link-padding-x);
        padding-left: var(--bs-navbar-nav-link-padding-x);
    }
    .navbar-expand .navbar-nav-scroll {
        overflow: visible;
    }
    .navbar-expand .navbar-collapse {
        display: flex !important;
        flex-basis: auto;
    }
    .navbar-expand .navbar-toggler {
        display: none;
    }
    .navbar-expand .offcanvas {
        position: static;
        z-index: auto;
        flex-grow: 1;
        width: auto !important;
        height: auto !important;
        visibility: visible !important;
        background-color: transparent !important;
        border: 0 !important;
        transform: none !important;
        transition: none;
    }
    .navbar-expand .offcanvas .offcanvas-header {
        display: none;
    }
    .navbar-expand .offcanvas .offcanvas-body {
        display: flex;
        flex-grow: 0;
        padding: 0;
        overflow-y: visible;
    }

    .navbar-dark,
    .navbar[data-bs-theme='dark'] {
        --bs-navbar-color: rgba(255, 255, 255, 0.55);
        --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);
        --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);
        --bs-navbar-active-color: #fff;
        --bs-navbar-brand-color: #fff;
        --bs-navbar-brand-hover-color: #fff;
        --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
        --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
    }

    [data-bs-theme='dark'] .navbar-toggler-icon {
        --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
    }

    .card {
        --bs-card-spacer-y: 1rem;
        --bs-card-spacer-x: 1rem;
        --bs-card-title-spacer-y: 0.5rem;
        --bs-card-title-color: ;
        --bs-card-subtitle-color: ;
        --bs-card-border-width: var(--bs-border-width);
        --bs-card-border-color: var(--bs-border-color-translucent);
        --bs-card-border-radius: var(--bs-border-radius);
        --bs-card-box-shadow: ;
        --bs-card-inner-border-radius: calc(
            var(--bs-border-radius) - (var(--bs-border-width))
        );
        --bs-card-cap-padding-y: 0.5rem;
        --bs-card-cap-padding-x: 1rem;
        --bs-card-cap-bg: rgba(var(--bs-body-color-rgb), 0.03);
        --bs-card-cap-color: ;
        --bs-card-height: ;
        --bs-card-color: ;
        --bs-card-bg: var(--bs-body-bg);
        --bs-card-img-overlay-padding: 1rem;
        --bs-card-group-margin: 0.75rem;
        position: relative;
        display: flex;
        flex-direction: column;
        min-width: 0;
        height: var(--bs-card-height);
        color: var(--bs-body-color);
        word-wrap: break-word;
        background-color: var(--bs-card-bg);
        background-clip: border-box;
        border: var(--bs-card-border-width) solid var(--bs-card-border-color);
        border-radius: var(--bs-card-border-radius);
    }
    .card > hr {
        margin-right: 0;
        margin-left: 0;
    }
    .card > .list-group {
        border-top: inherit;
        border-bottom: inherit;
    }
    .card > .list-group:first-child {
        border-top-width: 0;
        border-top-left-radius: var(--bs-card-inner-border-radius);
        border-top-right-radius: var(--bs-card-inner-border-radius);
    }
    .card > .list-group:last-child {
        border-bottom-width: 0;
        border-bottom-right-radius: var(--bs-card-inner-border-radius);
        border-bottom-left-radius: var(--bs-card-inner-border-radius);
    }
    .card > .card-header + .list-group,
    .card > .list-group + .card-footer {
        border-top: 0;
    }

    .card-body {
        flex: 1 1 auto;
        padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);
        color: var(--bs-card-color);
    }

    .card-title {
        margin-bottom: var(--bs-card-title-spacer-y);
        color: var(--bs-card-title-color);
    }

    .card-subtitle {
        margin-top: calc(-0.5 * var(--bs-card-title-spacer-y));
        margin-bottom: 0;
        color: var(--bs-card-subtitle-color);
    }

    .card-text:last-child {
        margin-bottom: 0;
    }

    .card-link + .card-link {
        margin-left: var(--bs-card-spacer-x);
    }

    .card-header {
        padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
        margin-bottom: 0;
        color: var(--bs-card-cap-color);
        background-color: var(--bs-card-cap-bg);
        border-bottom: var(--bs-card-border-width) solid
            var(--bs-card-border-color);
    }
    .card-header:first-child {
        border-radius: var(--bs-card-inner-border-radius)
            var(--bs-card-inner-border-radius) 0 0;
    }

    .card-footer {
        padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
        color: var(--bs-card-cap-color);
        background-color: var(--bs-card-cap-bg);
        border-top: var(--bs-card-border-width) solid
            var(--bs-card-border-color);
    }
    .card-footer:last-child {
        border-radius: 0 0 var(--bs-card-inner-border-radius)
            var(--bs-card-inner-border-radius);
    }

    .card-header-tabs {
        margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
        margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));
        margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
        border-bottom: 0;
    }
    .card-header-tabs .nav-link.active {
        background-color: var(--bs-card-bg);
        border-bottom-color: var(--bs-card-bg);
    }

    .card-header-pills {
        margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
        margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
    }

    .card-img-overlay {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        padding: var(--bs-card-img-overlay-padding);
        border-radius: var(--bs-card-inner-border-radius);
    }

    .card-img,
    .card-img-top,
    .card-img-bottom {
        width: 100%;
    }

    .card-img,
    .card-img-top {
        border-top-left-radius: var(--bs-card-inner-border-radius);
        border-top-right-radius: var(--bs-card-inner-border-radius);
    }

    .card-img,
    .card-img-bottom {
        border-bottom-right-radius: var(--bs-card-inner-border-radius);
        border-bottom-left-radius: var(--bs-card-inner-border-radius);
    }

    .card-group > .card {
        margin-bottom: var(--bs-card-group-margin);
    }
    @media (min-width: 576px) {
        .card-group {
            display: flex;
            flex-flow: row wrap;
        }
        .card-group > .card {
            flex: 1 0 0%;
            margin-bottom: 0;
        }
        .card-group > .card + .card {
            margin-left: 0;
            border-left: 0;
        }
        .card-group > .card:not(:last-child) {
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
        }
        .card-group > .card:not(:last-child) .card-img-top,
        .card-group > .card:not(:last-child) .card-header {
            border-top-right-radius: 0;
        }
        .card-group > .card:not(:last-child) .card-img-bottom,
        .card-group > .card:not(:last-child) .card-footer {
            border-bottom-right-radius: 0;
        }
        .card-group > .card:not(:first-child) {
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
        }
        .card-group > .card:not(:first-child) .card-img-top,
        .card-group > .card:not(:first-child) .card-header {
            border-top-left-radius: 0;
        }
        .card-group > .card:not(:first-child) .card-img-bottom,
        .card-group > .card:not(:first-child) .card-footer {
            border-bottom-left-radius: 0;
        }
    }

    .accordion {
        --bs-accordion-color: var(--bs-body-color);
        --bs-accordion-bg: var(--bs-body-bg);
        --bs-accordion-transition: color 0.15s ease-in-out,
            background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
            box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
        --bs-accordion-border-color: var(--bs-border-color);
        --bs-accordion-border-width: var(--bs-border-width);
        --bs-accordion-border-radius: var(--bs-border-radius);
        --bs-accordion-inner-border-radius: calc(
            var(--bs-border-radius) - (var(--bs-border-width))
        );
        --bs-accordion-btn-padding-x: 1.25rem;
        --bs-accordion-btn-padding-y: 1rem;
        --bs-accordion-btn-color: var(--bs-body-color);
        --bs-accordion-btn-bg: var(--bs-accordion-bg);
        --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
        --bs-accordion-btn-icon-width: 1.25rem;
        --bs-accordion-btn-icon-transform: rotate(-180deg);
        --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;
        --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
        --bs-accordion-btn-focus-box-shadow: 0 0 0 0.25rem
            rgba(13, 110, 253, 0.25);
        --bs-accordion-body-padding-x: 1.25rem;
        --bs-accordion-body-padding-y: 1rem;
        --bs-accordion-active-color: var(--bs-primary-text-emphasis);
        --bs-accordion-active-bg: var(--bs-primary-bg-subtle);
    }

    .accordion-button {
        position: relative;
        display: flex;
        align-items: center;
        width: 100%;
        padding: var(--bs-accordion-btn-padding-y)
            var(--bs-accordion-btn-padding-x);
        font-size: 1rem;
        color: var(--bs-accordion-btn-color);
        text-align: left;
        background-color: var(--bs-accordion-btn-bg);
        border: 0;
        border-radius: 0;
        overflow-anchor: none;
        transition: var(--bs-accordion-transition);
    }
    @media (prefers-reduced-motion: reduce) {
        .accordion-button {
            transition: none;
        }
    }
    .accordion-button:not(.collapsed) {
        color: var(--bs-accordion-active-color);
        background-color: var(--bs-accordion-active-bg);
        box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0
            var(--bs-accordion-border-color);
    }
    .accordion-button:not(.collapsed)::after {
        background-image: var(--bs-accordion-btn-active-icon);
        transform: var(--bs-accordion-btn-icon-transform);
    }
    .accordion-button::after {
        flex-shrink: 0;
        width: var(--bs-accordion-btn-icon-width);
        height: var(--bs-accordion-btn-icon-width);
        margin-left: auto;
        content: '';
        background-image: var(--bs-accordion-btn-icon);
        background-repeat: no-repeat;
        background-size: var(--bs-accordion-btn-icon-width);
        transition: var(--bs-accordion-btn-icon-transition);
    }
    @media (prefers-reduced-motion: reduce) {
        .accordion-button::after {
            transition: none;
        }
    }
    .accordion-button:hover {
        z-index: 2;
    }
    .accordion-button:focus {
        z-index: 3;
        outline: 0;
        box-shadow: var(--bs-accordion-btn-focus-box-shadow);
    }

    .accordion-header {
        margin-bottom: 0;
    }

    .accordion-item {
        color: var(--bs-accordion-color);
        background-color: var(--bs-accordion-bg);
        border: var(--bs-accordion-border-width) solid
            var(--bs-accordion-border-color);
    }
    .accordion-item:first-of-type {
        border-top-left-radius: var(--bs-accordion-border-radius);
        border-top-right-radius: var(--bs-accordion-border-radius);
    }
    .accordion-item:first-of-type > .accordion-header .accordion-button {
        border-top-left-radius: var(--bs-accordion-inner-border-radius);
        border-top-right-radius: var(--bs-accordion-inner-border-radius);
    }
    .accordion-item:not(:first-of-type) {
        border-top: 0;
    }
    .accordion-item:last-of-type {
        border-bottom-right-radius: var(--bs-accordion-border-radius);
        border-bottom-left-radius: var(--bs-accordion-border-radius);
    }
    .accordion-item:last-of-type
        > .accordion-header
        .accordion-button.collapsed {
        border-bottom-right-radius: var(--bs-accordion-inner-border-radius);
        border-bottom-left-radius: var(--bs-accordion-inner-border-radius);
    }
    .accordion-item:last-of-type > .accordion-collapse {
        border-bottom-right-radius: var(--bs-accordion-border-radius);
        border-bottom-left-radius: var(--bs-accordion-border-radius);
    }

    .accordion-body {
        padding: var(--bs-accordion-body-padding-y)
            var(--bs-accordion-body-padding-x);
    }

    .accordion-flush > .accordion-item {
        border-right: 0;
        border-left: 0;
        border-radius: 0;
    }
    .accordion-flush > .accordion-item:first-child {
        border-top: 0;
    }
    .accordion-flush > .accordion-item:last-child {
        border-bottom: 0;
    }
    .accordion-flush > .accordion-item > .accordion-header .accordion-button,
    .accordion-flush
        > .accordion-item
        > .accordion-header
        .accordion-button.collapsed {
        border-radius: 0;
    }
    .accordion-flush > .accordion-item > .accordion-collapse {
        border-radius: 0;
    }

    [data-bs-theme='dark'] .accordion-button::after {
        --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
        --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
    }

    .breadcrumb {
        --bs-breadcrumb-padding-x: 0;
        --bs-breadcrumb-padding-y: 0;
        --bs-breadcrumb-margin-bottom: 1rem;
        --bs-breadcrumb-bg: ;
        --bs-breadcrumb-border-radius: ;
        --bs-breadcrumb-divider-color: var(--bs-secondary-color);
        --bs-breadcrumb-item-padding-x: 0.5rem;
        --bs-breadcrumb-item-active-color: var(--bs-secondary-color);
        display: flex;
        flex-wrap: wrap;
        padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);
        margin-bottom: var(--bs-breadcrumb-margin-bottom);
        font-size: var(--bs-breadcrumb-font-size);
        list-style: none;
        background-color: var(--bs-breadcrumb-bg);
        border-radius: var(--bs-breadcrumb-border-radius);
    }

    .breadcrumb-item + .breadcrumb-item {
        padding-left: var(--bs-breadcrumb-item-padding-x);
    }
    .breadcrumb-item + .breadcrumb-item::before {
        float: left;
        padding-right: var(--bs-breadcrumb-item-padding-x);
        color: var(--bs-breadcrumb-divider-color);
        content: var(--bs-breadcrumb-divider, '/')
            /* rtl: var(--bs-breadcrumb-divider, "/") */;
    }
    .breadcrumb-item.active {
        color: var(--bs-breadcrumb-item-active-color);
    }

    .pagination {
        --bs-pagination-padding-x: 0.75rem;
        --bs-pagination-padding-y: 0.375rem;
        --bs-pagination-font-size: 1rem;
        --bs-pagination-color: var(--bs-link-color);
        --bs-pagination-bg: var(--bs-body-bg);
        --bs-pagination-border-width: var(--bs-border-width);
        --bs-pagination-border-color: var(--bs-border-color);
        --bs-pagination-border-radius: var(--bs-border-radius);
        --bs-pagination-hover-color: var(--bs-link-hover-color);
        --bs-pagination-hover-bg: var(--bs-tertiary-bg);
        --bs-pagination-hover-border-color: var(--bs-border-color);
        --bs-pagination-focus-color: var(--bs-link-hover-color);
        --bs-pagination-focus-bg: var(--bs-secondary-bg);
        --bs-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
        --bs-pagination-active-color: #fff;
        --bs-pagination-active-bg: #0d6efd;
        --bs-pagination-active-border-color: #0d6efd;
        --bs-pagination-disabled-color: var(--bs-secondary-color);
        --bs-pagination-disabled-bg: var(--bs-secondary-bg);
        --bs-pagination-disabled-border-color: var(--bs-border-color);
        display: flex;
        padding-left: 0;
        list-style: none;
    }

    .page-link {
        position: relative;
        display: block;
        padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);
        font-size: var(--bs-pagination-font-size);
        color: var(--bs-pagination-color);
        text-decoration: none;
        background-color: var(--bs-pagination-bg);
        border: var(--bs-pagination-border-width) solid
            var(--bs-pagination-border-color);
        transition:
            color 0.15s ease-in-out,
            background-color 0.15s ease-in-out,
            border-color 0.15s ease-in-out,
            box-shadow 0.15s ease-in-out;
    }
    @media (prefers-reduced-motion: reduce) {
        .page-link {
            transition: none;
        }
    }
    .page-link:hover {
        z-index: 2;
        color: var(--bs-pagination-hover-color);
        background-color: var(--bs-pagination-hover-bg);
        border-color: var(--bs-pagination-hover-border-color);
    }
    .page-link:focus {
        z-index: 3;
        color: var(--bs-pagination-focus-color);
        background-color: var(--bs-pagination-focus-bg);
        outline: 0;
        box-shadow: var(--bs-pagination-focus-box-shadow);
    }
    .page-link.active,
    .active > .page-link {
        z-index: 3;
        color: var(--bs-pagination-active-color);
        background-color: var(--bs-pagination-active-bg);
        border-color: var(--bs-pagination-active-border-color);
    }
    .page-link.disabled,
    .disabled > .page-link {
        color: var(--bs-pagination-disabled-color);
        pointer-events: none;
        background-color: var(--bs-pagination-disabled-bg);
        border-color: var(--bs-pagination-disabled-border-color);
    }

    .page-item:not(:first-child) .page-link {
        margin-left: calc(var(--bs-border-width) * -1);
    }
    .page-item:first-child .page-link {
        border-top-left-radius: var(--bs-pagination-border-radius);
        border-bottom-left-radius: var(--bs-pagination-border-radius);
    }
    .page-item:last-child .page-link {
        border-top-right-radius: var(--bs-pagination-border-radius);
        border-bottom-right-radius: var(--bs-pagination-border-radius);
    }

    .pagination-lg {
        --bs-pagination-padding-x: 1.5rem;
        --bs-pagination-padding-y: 0.75rem;
        --bs-pagination-font-size: 1.25rem;
        --bs-pagination-border-radius: var(--bs-border-radius-lg);
    }

    .pagination-sm {
        --bs-pagination-padding-x: 0.5rem;
        --bs-pagination-padding-y: 0.25rem;
        --bs-pagination-font-size: 0.875rem;
        --bs-pagination-border-radius: var(--bs-border-radius-sm);
    }

    .badge {
        --bs-badge-padding-x: 0.65em;
        --bs-badge-padding-y: 0.35em;
        --bs-badge-font-size: 0.75em;
        --bs-badge-font-weight: 700;
        --bs-badge-color: #fff;
        --bs-badge-border-radius: var(--bs-border-radius);
        display: inline-block;
        padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);
        font-size: var(--bs-badge-font-size);
        font-weight: var(--bs-badge-font-weight);
        line-height: 1;
        color: var(--bs-badge-color);
        text-align: center;
        white-space: nowrap;
        vertical-align: baseline;
        border-radius: var(--bs-badge-border-radius);
    }
    .badge:empty {
        display: none;
    }

    .btn .badge {
        position: relative;
        top: -1px;
    }

    .alert {
        --bs-alert-bg: transparent;
        --bs-alert-padding-x: 1rem;
        --bs-alert-padding-y: 1rem;
        --bs-alert-margin-bottom: 1rem;
        --bs-alert-color: inherit;
        --bs-alert-border-color: transparent;
        --bs-alert-border: var(--bs-border-width) solid
            var(--bs-alert-border-color);
        --bs-alert-border-radius: var(--bs-border-radius);
        --bs-alert-link-color: inherit;
        position: relative;
        padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);
        margin-bottom: var(--bs-alert-margin-bottom);
        color: var(--bs-alert-color);
        background-color: var(--bs-alert-bg);
        border: var(--bs-alert-border);
        border-radius: var(--bs-alert-border-radius);
    }

    .alert-heading {
        color: inherit;
    }

    .alert-link {
        font-weight: 700;
        color: var(--bs-alert-link-color);
    }

    .alert-dismissible {
        padding-right: 3rem;
    }
    .alert-dismissible .btn-close {
        position: absolute;
        top: 0;
        right: 0;
        z-index: 2;
        padding: 1.25rem 1rem;
    }

    .alert-primary {
        --bs-alert-color: var(--bs-primary-text-emphasis);
        --bs-alert-bg: var(--bs-primary-bg-subtle);
        --bs-alert-border-color: var(--bs-primary-border-subtle);
        --bs-alert-link-color: var(--bs-primary-text-emphasis);
    }

    .alert-secondary {
        --bs-alert-color: var(--bs-secondary-text-emphasis);
        --bs-alert-bg: var(--bs-secondary-bg-subtle);
        --bs-alert-border-color: var(--bs-secondary-border-subtle);
        --bs-alert-link-color: var(--bs-secondary-text-emphasis);
    }

    .alert-success {
        --bs-alert-color: var(--bs-success-text-emphasis);
        --bs-alert-bg: var(--bs-success-bg-subtle);
        --bs-alert-border-color: var(--bs-success-border-subtle);
        --bs-alert-link-color: var(--bs-success-text-emphasis);
    }

    .alert-info {
        --bs-alert-color: var(--bs-info-text-emphasis);
        --bs-alert-bg: var(--bs-info-bg-subtle);
        --bs-alert-border-color: var(--bs-info-border-subtle);
        --bs-alert-link-color: var(--bs-info-text-emphasis);
    }

    .alert-warning {
        --bs-alert-color: var(--bs-warning-text-emphasis);
        --bs-alert-bg: var(--bs-warning-bg-subtle);
        --bs-alert-border-color: var(--bs-warning-border-subtle);
        --bs-alert-link-color: var(--bs-warning-text-emphasis);
    }

    .alert-danger {
        --bs-alert-color: var(--bs-danger-text-emphasis);
        --bs-alert-bg: var(--bs-danger-bg-subtle);
        --bs-alert-border-color: var(--bs-danger-border-subtle);
        --bs-alert-link-color: var(--bs-danger-text-emphasis);
    }

    .alert-light {
        --bs-alert-color: var(--bs-light-text-emphasis);
        --bs-alert-bg: var(--bs-light-bg-subtle);
        --bs-alert-border-color: var(--bs-light-border-subtle);
        --bs-alert-link-color: var(--bs-light-text-emphasis);
    }

    .alert-dark {
        --bs-alert-color: var(--bs-dark-text-emphasis);
        --bs-alert-bg: var(--bs-dark-bg-subtle);
        --bs-alert-border-color: var(--bs-dark-border-subtle);
        --bs-alert-link-color: var(--bs-dark-text-emphasis);
    }

    @keyframes progress-bar-stripes {
        0% {
            background-position-x: 1rem;
        }
    }
    .progress,
    .progress-stacked {
        --bs-progress-height: 1rem;
        --bs-progress-font-size: 0.75rem;
        --bs-progress-bg: var(--bs-secondary-bg);
        --bs-progress-border-radius: var(--bs-border-radius);
        --bs-progress-box-shadow: var(--bs-box-shadow-inset);
        --bs-progress-bar-color: #fff;
        --bs-progress-bar-bg: #0d6efd;
        --bs-progress-bar-transition: width 0.6s ease;
        display: flex;
        height: var(--bs-progress-height);
        overflow: hidden;
        font-size: var(--bs-progress-font-size);
        background-color: var(--bs-progress-bg);
        border-radius: var(--bs-progress-border-radius);
    }

    .progress-bar {
        display: flex;
        flex-direction: column;
        justify-content: center;
        overflow: hidden;
        color: var(--bs-progress-bar-color);
        text-align: center;
        white-space: nowrap;
        background-color: var(--bs-progress-bar-bg);
        transition: var(--bs-progress-bar-transition);
    }
    @media (prefers-reduced-motion: reduce) {
        .progress-bar {
            transition: none;
        }
    }

    .progress-bar-striped {
        background-image: linear-gradient(
            45deg,
            rgba(255, 255, 255, 0.15) 25%,
            transparent 25%,
            transparent 50%,
            rgba(255, 255, 255, 0.15) 50%,
            rgba(255, 255, 255, 0.15) 75%,
            transparent 75%,
            transparent
        );
        background-size: var(--bs-progress-height) var(--bs-progress-height);
    }

    .progress-stacked > .progress {
        overflow: visible;
    }

    .progress-stacked > .progress > .progress-bar {
        width: 100%;
    }

    .progress-bar-animated {
        animation: 1s linear infinite progress-bar-stripes;
    }
    @media (prefers-reduced-motion: reduce) {
        .progress-bar-animated {
            animation: none;
        }
    }

    .list-group {
        --bs-list-group-color: var(--bs-body-color);
        --bs-list-group-bg: var(--bs-body-bg);
        --bs-list-group-border-color: var(--bs-border-color);
        --bs-list-group-border-width: var(--bs-border-width);
        --bs-list-group-border-radius: var(--bs-border-radius);
        --bs-list-group-item-padding-x: 1rem;
        --bs-list-group-item-padding-y: 0.5rem;
        --bs-list-group-action-color: var(--bs-secondary-color);
        --bs-list-group-action-hover-color: var(--bs-emphasis-color);
        --bs-list-group-action-hover-bg: var(--bs-tertiary-bg);
        --bs-list-group-action-active-color: var(--bs-body-color);
        --bs-list-group-action-active-bg: var(--bs-secondary-bg);
        --bs-list-group-disabled-color: var(--bs-secondary-color);
        --bs-list-group-disabled-bg: var(--bs-body-bg);
        --bs-list-group-active-color: #fff;
        --bs-list-group-active-bg: #0d6efd;
        --bs-list-group-active-border-color: #0d6efd;
        display: flex;
        flex-direction: column;
        padding-left: 0;
        margin-bottom: 0;
        border-radius: var(--bs-list-group-border-radius);
    }

    .list-group-numbered {
        list-style-type: none;
        counter-reset: section;
    }
    .list-group-numbered > .list-group-item::before {
        content: counters(section, '.') '. ';
        counter-increment: section;
    }

    .list-group-item-action {
        width: 100%;
        color: var(--bs-list-group-action-color);
        text-align: inherit;
    }
    .list-group-item-action:hover,
    .list-group-item-action:focus {
        z-index: 1;
        color: var(--bs-list-group-action-hover-color);
        text-decoration: none;
        background-color: var(--bs-list-group-action-hover-bg);
    }
    .list-group-item-action:active {
        color: var(--bs-list-group-action-active-color);
        background-color: var(--bs-list-group-action-active-bg);
    }

    .list-group-item {
        position: relative;
        display: block;
        padding: var(--bs-list-group-item-padding-y)
            var(--bs-list-group-item-padding-x);
        color: var(--bs-list-group-color);
        text-decoration: none;
        background-color: var(--bs-list-group-bg);
        border: var(--bs-list-group-border-width) solid
            var(--bs-list-group-border-color);
    }
    .list-group-item:first-child {
        border-top-left-radius: inherit;
        border-top-right-radius: inherit;
    }
    .list-group-item:last-child {
        border-bottom-right-radius: inherit;
        border-bottom-left-radius: inherit;
    }
    .list-group-item.disabled,
    .list-group-item:disabled {
        color: var(--bs-list-group-disabled-color);
        pointer-events: none;
        background-color: var(--bs-list-group-disabled-bg);
    }
    .list-group-item.active {
        z-index: 2;
        color: var(--bs-list-group-active-color);
        background-color: var(--bs-list-group-active-bg);
        border-color: var(--bs-list-group-active-border-color);
    }
    .list-group-item + .list-group-item {
        border-top-width: 0;
    }
    .list-group-item + .list-group-item.active {
        margin-top: calc(-1 * var(--bs-list-group-border-width));
        border-top-width: var(--bs-list-group-border-width);
    }

    .list-group-horizontal {
        flex-direction: row;
    }
    .list-group-horizontal > .list-group-item:first-child:not(:last-child) {
        border-bottom-left-radius: var(--bs-list-group-border-radius);
        border-top-right-radius: 0;
    }
    .list-group-horizontal > .list-group-item:last-child:not(:first-child) {
        border-top-right-radius: var(--bs-list-group-border-radius);
        border-bottom-left-radius: 0;
    }
    .list-group-horizontal > .list-group-item.active {
        margin-top: 0;
    }
    .list-group-horizontal > .list-group-item + .list-group-item {
        border-top-width: var(--bs-list-group-border-width);
        border-left-width: 0;
    }
    .list-group-horizontal > .list-group-item + .list-group-item.active {
        margin-left: calc(-1 * var(--bs-list-group-border-width));
        border-left-width: var(--bs-list-group-border-width);
    }

    @media (min-width: 576px) {
        .list-group-horizontal-sm {
            flex-direction: row;
        }
        .list-group-horizontal-sm
            > .list-group-item:first-child:not(:last-child) {
            border-bottom-left-radius: var(--bs-list-group-border-radius);
            border-top-right-radius: 0;
        }
        .list-group-horizontal-sm
            > .list-group-item:last-child:not(:first-child) {
            border-top-right-radius: var(--bs-list-group-border-radius);
            border-bottom-left-radius: 0;
        }
        .list-group-horizontal-sm > .list-group-item.active {
            margin-top: 0;
        }
        .list-group-horizontal-sm > .list-group-item + .list-group-item {
            border-top-width: var(--bs-list-group-border-width);
            border-left-width: 0;
        }
        .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
            margin-left: calc(-1 * var(--bs-list-group-border-width));
            border-left-width: var(--bs-list-group-border-width);
        }
    }
    @media (min-width: 768px) {
        .list-group-horizontal-md {
            flex-direction: row;
        }
        .list-group-horizontal-md
            > .list-group-item:first-child:not(:last-child) {
            border-bottom-left-radius: var(--bs-list-group-border-radius);
            border-top-right-radius: 0;
        }
        .list-group-horizontal-md
            > .list-group-item:last-child:not(:first-child) {
            border-top-right-radius: var(--bs-list-group-border-radius);
            border-bottom-left-radius: 0;
        }
        .list-group-horizontal-md > .list-group-item.active {
            margin-top: 0;
        }
        .list-group-horizontal-md > .list-group-item + .list-group-item {
            border-top-width: var(--bs-list-group-border-width);
            border-left-width: 0;
        }
        .list-group-horizontal-md > .list-group-item + .list-group-item.active {
            margin-left: calc(-1 * var(--bs-list-group-border-width));
            border-left-width: var(--bs-list-group-border-width);
        }
    }
    @media (min-width: 992px) {
        .list-group-horizontal-lg {
            flex-direction: row;
        }
        .list-group-horizontal-lg
            > .list-group-item:first-child:not(:last-child) {
            border-bottom-left-radius: var(--bs-list-group-border-radius);
            border-top-right-radius: 0;
        }
        .list-group-horizontal-lg
            > .list-group-item:last-child:not(:first-child) {
            border-top-right-radius: var(--bs-list-group-border-radius);
            border-bottom-left-radius: 0;
        }
        .list-group-horizontal-lg > .list-group-item.active {
            margin-top: 0;
        }
        .list-group-horizontal-lg > .list-group-item + .list-group-item {
            border-top-width: var(--bs-list-group-border-width);
            border-left-width: 0;
        }
        .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
            margin-left: calc(-1 * var(--bs-list-group-border-width));
            border-left-width: var(--bs-list-group-border-width);
        }
    }
    @media (min-width: 1200px) {
        .list-group-horizontal-xl {
            flex-direction: row;
        }
        .list-group-horizontal-xl
            > .list-group-item:first-child:not(:last-child) {
            border-bottom-left-radius: var(--bs-list-group-border-radius);
            border-top-right-radius: 0;
        }
        .list-group-horizontal-xl
            > .list-group-item:last-child:not(:first-child) {
            border-top-right-radius: var(--bs-list-group-border-radius);
            border-bottom-left-radius: 0;
        }
        .list-group-horizontal-xl > .list-group-item.active {
            margin-top: 0;
        }
        .list-group-horizontal-xl > .list-group-item + .list-group-item {
            border-top-width: var(--bs-list-group-border-width);
            border-left-width: 0;
        }
        .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
            margin-left: calc(-1 * var(--bs-list-group-border-width));
            border-left-width: var(--bs-list-group-border-width);
        }
    }
    @media (min-width: 1400px) {
        .list-group-horizontal-xxl {
            flex-direction: row;
        }
        .list-group-horizontal-xxl
            > .list-group-item:first-child:not(:last-child) {
            border-bottom-left-radius: var(--bs-list-group-border-radius);
            border-top-right-radius: 0;
        }
        .list-group-horizontal-xxl
            > .list-group-item:last-child:not(:first-child) {
            border-top-right-radius: var(--bs-list-group-border-radius);
            border-bottom-left-radius: 0;
        }
        .list-group-horizontal-xxl > .list-group-item.active {
            margin-top: 0;
        }
        .list-group-horizontal-xxl > .list-group-item + .list-group-item {
            border-top-width: var(--bs-list-group-border-width);
            border-left-width: 0;
        }
        .list-group-horizontal-xxl
            > .list-group-item
            + .list-group-item.active {
            margin-left: calc(-1 * var(--bs-list-group-border-width));
            border-left-width: var(--bs-list-group-border-width);
        }
    }
    .list-group-flush {
        border-radius: 0;
    }
    .list-group-flush > .list-group-item {
        border-width: 0 0 var(--bs-list-group-border-width);
    }
    .list-group-flush > .list-group-item:last-child {
        border-bottom-width: 0;
    }

    .list-group-item-primary {
        --bs-list-group-color: var(--bs-primary-text-emphasis);
        --bs-list-group-bg: var(--bs-primary-bg-subtle);
        --bs-list-group-border-color: var(--bs-primary-border-subtle);
        --bs-list-group-action-hover-color: var(--bs-emphasis-color);
        --bs-list-group-action-hover-bg: var(--bs-primary-border-subtle);
        --bs-list-group-action-active-color: var(--bs-emphasis-color);
        --bs-list-group-action-active-bg: var(--bs-primary-border-subtle);
        --bs-list-group-active-color: var(--bs-primary-bg-subtle);
        --bs-list-group-active-bg: var(--bs-primary-text-emphasis);
        --bs-list-group-active-border-color: var(--bs-primary-text-emphasis);
    }

    .list-group-item-secondary {
        --bs-list-group-color: var(--bs-secondary-text-emphasis);
        --bs-list-group-bg: var(--bs-secondary-bg-subtle);
        --bs-list-group-border-color: var(--bs-secondary-border-subtle);
        --bs-list-group-action-hover-color: var(--bs-emphasis-color);
        --bs-list-group-action-hover-bg: var(--bs-secondary-border-subtle);
        --bs-list-group-action-active-color: var(--bs-emphasis-color);
        --bs-list-group-action-active-bg: var(--bs-secondary-border-subtle);
        --bs-list-group-active-color: var(--bs-secondary-bg-subtle);
        --bs-list-group-active-bg: var(--bs-secondary-text-emphasis);
        --bs-list-group-active-border-color: var(--bs-secondary-text-emphasis);
    }

    .list-group-item-success {
        --bs-list-group-color: var(--bs-success-text-emphasis);
        --bs-list-group-bg: var(--bs-success-bg-subtle);
        --bs-list-group-border-color: var(--bs-success-border-subtle);
        --bs-list-group-action-hover-color: var(--bs-emphasis-color);
        --bs-list-group-action-hover-bg: var(--bs-success-border-subtle);
        --bs-list-group-action-active-color: var(--bs-emphasis-color);
        --bs-list-group-action-active-bg: var(--bs-success-border-subtle);
        --bs-list-group-active-color: var(--bs-success-bg-subtle);
        --bs-list-group-active-bg: var(--bs-success-text-emphasis);
        --bs-list-group-active-border-color: var(--bs-success-text-emphasis);
    }

    .list-group-item-info {
        --bs-list-group-color: var(--bs-info-text-emphasis);
        --bs-list-group-bg: var(--bs-info-bg-subtle);
        --bs-list-group-border-color: var(--bs-info-border-subtle);
        --bs-list-group-action-hover-color: var(--bs-emphasis-color);
        --bs-list-group-action-hover-bg: var(--bs-info-border-subtle);
        --bs-list-group-action-active-color: var(--bs-emphasis-color);
        --bs-list-group-action-active-bg: var(--bs-info-border-subtle);
        --bs-list-group-active-color: var(--bs-info-bg-subtle);
        --bs-list-group-active-bg: var(--bs-info-text-emphasis);
        --bs-list-group-active-border-color: var(--bs-info-text-emphasis);
    }

    .list-group-item-warning {
        --bs-list-group-color: var(--bs-warning-text-emphasis);
        --bs-list-group-bg: var(--bs-warning-bg-subtle);
        --bs-list-group-border-color: var(--bs-warning-border-subtle);
        --bs-list-group-action-hover-color: var(--bs-emphasis-color);
        --bs-list-group-action-hover-bg: var(--bs-warning-border-subtle);
        --bs-list-group-action-active-color: var(--bs-emphasis-color);
        --bs-list-group-action-active-bg: var(--bs-warning-border-subtle);
        --bs-list-group-active-color: var(--bs-warning-bg-subtle);
        --bs-list-group-active-bg: var(--bs-warning-text-emphasis);
        --bs-list-group-active-border-color: var(--bs-warning-text-emphasis);
    }

    .list-group-item-danger {
        --bs-list-group-color: var(--bs-danger-text-emphasis);
        --bs-list-group-bg: var(--bs-danger-bg-subtle);
        --bs-list-group-border-color: var(--bs-danger-border-subtle);
        --bs-list-group-action-hover-color: var(--bs-emphasis-color);
        --bs-list-group-action-hover-bg: var(--bs-danger-border-subtle);
        --bs-list-group-action-active-color: var(--bs-emphasis-color);
        --bs-list-group-action-active-bg: var(--bs-danger-border-subtle);
        --bs-list-group-active-color: var(--bs-danger-bg-subtle);
        --bs-list-group-active-bg: var(--bs-danger-text-emphasis);
        --bs-list-group-active-border-color: var(--bs-danger-text-emphasis);
    }

    .list-group-item-light {
        --bs-list-group-color: var(--bs-light-text-emphasis);
        --bs-list-group-bg: var(--bs-light-bg-subtle);
        --bs-list-group-border-color: var(--bs-light-border-subtle);
        --bs-list-group-action-hover-color: var(--bs-emphasis-color);
        --bs-list-group-action-hover-bg: var(--bs-light-border-subtle);
        --bs-list-group-action-active-color: var(--bs-emphasis-color);
        --bs-list-group-action-active-bg: var(--bs-light-border-subtle);
        --bs-list-group-active-color: var(--bs-light-bg-subtle);
        --bs-list-group-active-bg: var(--bs-light-text-emphasis);
        --bs-list-group-active-border-color: var(--bs-light-text-emphasis);
    }

    .list-group-item-dark {
        --bs-list-group-color: var(--bs-dark-text-emphasis);
        --bs-list-group-bg: var(--bs-dark-bg-subtle);
        --bs-list-group-border-color: var(--bs-dark-border-subtle);
        --bs-list-group-action-hover-color: var(--bs-emphasis-color);
        --bs-list-group-action-hover-bg: var(--bs-dark-border-subtle);
        --bs-list-group-action-active-color: var(--bs-emphasis-color);
        --bs-list-group-action-active-bg: var(--bs-dark-border-subtle);
        --bs-list-group-active-color: var(--bs-dark-bg-subtle);
        --bs-list-group-active-bg: var(--bs-dark-text-emphasis);
        --bs-list-group-active-border-color: var(--bs-dark-text-emphasis);
    }

    .btn-close {
        --bs-btn-close-color: #000;
        --bs-btn-close-bg: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
        --bs-btn-close-opacity: 0.5;
        --bs-btn-close-hover-opacity: 0.75;
        --bs-btn-close-focus-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
        --bs-btn-close-focus-opacity: 1;
        --bs-btn-close-disabled-opacity: 0.25;
        --bs-btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);
        box-sizing: content-box;
        width: 1em;
        height: 1em;
        padding: 0.25em 0.25em;
        color: var(--bs-btn-close-color);
        background: transparent var(--bs-btn-close-bg) center/1em auto no-repeat;
        border: 0;
        border-radius: 0.375rem;
        opacity: var(--bs-btn-close-opacity);
    }
    .btn-close:hover {
        color: var(--bs-btn-close-color);
        text-decoration: none;
        opacity: var(--bs-btn-close-hover-opacity);
    }
    .btn-close:focus {
        outline: 0;
        box-shadow: var(--bs-btn-close-focus-shadow);
        opacity: var(--bs-btn-close-focus-opacity);
    }
    .btn-close:disabled,
    .btn-close.disabled {
        pointer-events: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        user-select: none;
        opacity: var(--bs-btn-close-disabled-opacity);
    }

    .btn-close-white {
        filter: var(--bs-btn-close-white-filter);
    }

    [data-bs-theme='dark'] .btn-close {
        filter: var(--bs-btn-close-white-filter);
    }

    .toast {
        --bs-toast-zindex: 1090;
        --bs-toast-padding-x: 0.75rem;
        --bs-toast-padding-y: 0.5rem;
        --bs-toast-spacing: 1.5rem;
        --bs-toast-max-width: 350px;
        --bs-toast-font-size: 0.875rem;
        --bs-toast-color: ;
        --bs-toast-bg: rgba(var(--bs-body-bg-rgb), 0.85);
        --bs-toast-border-width: var(--bs-border-width);
        --bs-toast-border-color: var(--bs-border-color-translucent);
        --bs-toast-border-radius: var(--bs-border-radius);
        --bs-toast-box-shadow: var(--bs-box-shadow);
        --bs-toast-header-color: var(--bs-secondary-color);
        --bs-toast-header-bg: rgba(var(--bs-body-bg-rgb), 0.85);
        --bs-toast-header-border-color: var(--bs-border-color-translucent);
        width: var(--bs-toast-max-width);
        max-width: 100%;
        font-size: var(--bs-toast-font-size);
        color: var(--bs-toast-color);
        pointer-events: auto;
        background-color: var(--bs-toast-bg);
        background-clip: padding-box;
        border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);
        box-shadow: var(--bs-toast-box-shadow);
        border-radius: var(--bs-toast-border-radius);
    }
    .toast.showing {
        opacity: 0;
    }
    .toast:not(.show) {
        display: none;
    }

    .toast-container {
        --bs-toast-zindex: 1090;
        position: absolute;
        z-index: var(--bs-toast-zindex);
        width: -webkit-max-content;
        width: -moz-max-content;
        width: max-content;
        max-width: 100%;
        pointer-events: none;
    }
    .toast-container > :not(:last-child) {
        margin-bottom: var(--bs-toast-spacing);
    }

    .toast-header {
        display: flex;
        align-items: center;
        padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);
        color: var(--bs-toast-header-color);
        background-color: var(--bs-toast-header-bg);
        background-clip: padding-box;
        border-bottom: var(--bs-toast-border-width) solid
            var(--bs-toast-header-border-color);
        border-top-left-radius: calc(
            var(--bs-toast-border-radius) - var(--bs-toast-border-width)
        );
        border-top-right-radius: calc(
            var(--bs-toast-border-radius) - var(--bs-toast-border-width)
        );
    }
    .toast-header .btn-close {
        margin-right: calc(-0.5 * var(--bs-toast-padding-x));
        margin-left: var(--bs-toast-padding-x);
    }

    .toast-body {
        padding: var(--bs-toast-padding-x);
        word-wrap: break-word;
    }

    .modal {
        --bs-modal-zindex: 1055;
        --bs-modal-width: 500px;
        --bs-modal-padding: 1rem;
        --bs-modal-margin: 0.5rem;
        --bs-modal-color: ;
        --bs-modal-bg: var(--bs-body-bg);
        --bs-modal-border-color: var(--bs-border-color-translucent);
        --bs-modal-border-width: var(--bs-border-width);
        --bs-modal-border-radius: var(--bs-border-radius-lg);
        --bs-modal-box-shadow: var(--bs-box-shadow-sm);
        --bs-modal-inner-border-radius: calc(
            var(--bs-border-radius-lg) - (var(--bs-border-width))
        );
        --bs-modal-header-padding-x: 1rem;
        --bs-modal-header-padding-y: 1rem;
        --bs-modal-header-padding: 1rem 1rem;
        --bs-modal-header-border-color: var(--bs-border-color);
        --bs-modal-header-border-width: var(--bs-border-width);
        --bs-modal-title-line-height: 1.5;
        --bs-modal-footer-gap: 0.5rem;
        --bs-modal-footer-bg: ;
        --bs-modal-footer-border-color: var(--bs-border-color);
        --bs-modal-footer-border-width: var(--bs-border-width);
        position: fixed;
        top: 0;
        left: 0;
        z-index: var(--bs-modal-zindex);
        display: none;
        width: 100%;
        height: 100%;
        overflow-x: hidden;
        overflow-y: auto;
        outline: 0;
    }

    .modal-dialog {
        position: relative;
        width: auto;
        margin: var(--bs-modal-margin);
        pointer-events: none;
    }
    .modal.fade .modal-dialog {
        transition: transform 0.3s ease-out;
        transform: translate(0, -50px);
    }
    @media (prefers-reduced-motion: reduce) {
        .modal.fade .modal-dialog {
            transition: none;
        }
    }
    .modal.show .modal-dialog {
        transform: none;
    }
    .modal.modal-static .modal-dialog {
        transform: scale(1.02);
    }

    .modal-dialog-scrollable {
        height: calc(100% - var(--bs-modal-margin) * 2);
    }
    .modal-dialog-scrollable .modal-content {
        max-height: 100%;
        overflow: hidden;
    }
    .modal-dialog-scrollable .modal-body {
        overflow-y: auto;
    }

    .modal-dialog-centered {
        display: flex;
        align-items: center;
        min-height: calc(100% - var(--bs-modal-margin) * 2);
    }

    .modal-content {
        position: relative;
        display: flex;
        flex-direction: column;
        width: 100%;
        color: var(--bs-modal-color);
        pointer-events: auto;
        background-color: var(--bs-modal-bg);
        background-clip: padding-box;
        border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);
        border-radius: var(--bs-modal-border-radius);
        outline: 0;
    }

    .modal-backdrop {
        --bs-backdrop-zindex: 1050;
        --bs-backdrop-bg: #000;
        --bs-backdrop-opacity: 0.5;
        position: fixed;
        top: 0;
        left: 0;
        z-index: var(--bs-backdrop-zindex);
        width: 100vw;
        height: 100vh;
        background-color: var(--bs-backdrop-bg);
    }
    .modal-backdrop.fade {
        opacity: 0;
    }
    .modal-backdrop.show {
        opacity: var(--bs-backdrop-opacity);
    }

    .modal-header {
        display: flex;
        flex-shrink: 0;
        align-items: center;
        padding: var(--bs-modal-header-padding);
        border-bottom: var(--bs-modal-header-border-width) solid
            var(--bs-modal-header-border-color);
        border-top-left-radius: var(--bs-modal-inner-border-radius);
        border-top-right-radius: var(--bs-modal-inner-border-radius);
    }
    .modal-header .btn-close {
        padding: calc(var(--bs-modal-header-padding-y) * 0.5)
            calc(var(--bs-modal-header-padding-x) * 0.5);
        margin: calc(-0.5 * var(--bs-modal-header-padding-y))
            calc(-0.5 * var(--bs-modal-header-padding-x))
            calc(-0.5 * var(--bs-modal-header-padding-y)) auto;
    }

    .modal-title {
        margin-bottom: 0;
        line-height: var(--bs-modal-title-line-height);
    }

    .modal-body {
        position: relative;
        flex: 1 1 auto;
        padding: var(--bs-modal-padding);
    }

    .modal-footer {
        display: flex;
        flex-shrink: 0;
        flex-wrap: wrap;
        align-items: center;
        justify-content: flex-end;
        padding: calc(
            var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5
        );
        background-color: var(--bs-modal-footer-bg);
        border-top: var(--bs-modal-footer-border-width) solid
            var(--bs-modal-footer-border-color);
        border-bottom-right-radius: var(--bs-modal-inner-border-radius);
        border-bottom-left-radius: var(--bs-modal-inner-border-radius);
    }
    .modal-footer > * {
        margin: calc(var(--bs-modal-footer-gap) * 0.5);
    }

    @media (min-width: 576px) {
        .modal {
            --bs-modal-margin: 1.75rem;
            --bs-modal-box-shadow: var(--bs-box-shadow);
        }
        .modal-dialog {
            max-width: var(--bs-modal-width);
            margin-right: auto;
            margin-left: auto;
        }
        .modal-sm {
            --bs-modal-width: 300px;
        }
    }
    @media (min-width: 992px) {
        .modal-lg,
        .modal-xl {
            --bs-modal-width: 800px;
        }
    }
    @media (min-width: 1200px) {
        .modal-xl {
            --bs-modal-width: 1140px;
        }
    }
    .modal-fullscreen {
        width: 100vw;
        max-width: none;
        height: 100%;
        margin: 0;
    }
    .modal-fullscreen .modal-content {
        height: 100%;
        border: 0;
        border-radius: 0;
    }
    .modal-fullscreen .modal-header,
    .modal-fullscreen .modal-footer {
        border-radius: 0;
    }
    .modal-fullscreen .modal-body {
        overflow-y: auto;
    }

    @media (max-width: 575.98px) {
        .modal-fullscreen-sm-down {
            width: 100vw;
            max-width: none;
            height: 100%;
            margin: 0;
        }
        .modal-fullscreen-sm-down .modal-content {
            height: 100%;
            border: 0;
            border-radius: 0;
        }
        .modal-fullscreen-sm-down .modal-header,
        .modal-fullscreen-sm-down .modal-footer {
            border-radius: 0;
        }
        .modal-fullscreen-sm-down .modal-body {
            overflow-y: auto;
        }
    }
    @media (max-width: 767.98px) {
        .modal-fullscreen-md-down {
            width: 100vw;
            max-width: none;
            height: 100%;
            margin: 0;
        }
        .modal-fullscreen-md-down .modal-content {
            height: 100%;
            border: 0;
            border-radius: 0;
        }
        .modal-fullscreen-md-down .modal-header,
        .modal-fullscreen-md-down .modal-footer {
            border-radius: 0;
        }
        .modal-fullscreen-md-down .modal-body {
            overflow-y: auto;
        }
    }
    @media (max-width: 991.98px) {
        .modal-fullscreen-lg-down {
            width: 100vw;
            max-width: none;
            height: 100%;
            margin: 0;
        }
        .modal-fullscreen-lg-down .modal-content {
            height: 100%;
            border: 0;
            border-radius: 0;
        }
        .modal-fullscreen-lg-down .modal-header,
        .modal-fullscreen-lg-down .modal-footer {
            border-radius: 0;
        }
        .modal-fullscreen-lg-down .modal-body {
            overflow-y: auto;
        }
    }
    @media (max-width: 1199.98px) {
        .modal-fullscreen-xl-down {
            width: 100vw;
            max-width: none;
            height: 100%;
            margin: 0;
        }
        .modal-fullscreen-xl-down .modal-content {
            height: 100%;
            border: 0;
            border-radius: 0;
        }
        .modal-fullscreen-xl-down .modal-header,
        .modal-fullscreen-xl-down .modal-footer {
            border-radius: 0;
        }
        .modal-fullscreen-xl-down .modal-body {
            overflow-y: auto;
        }
    }
    @media (max-width: 1399.98px) {
        .modal-fullscreen-xxl-down {
            width: 100vw;
            max-width: none;
            height: 100%;
            margin: 0;
        }
        .modal-fullscreen-xxl-down .modal-content {
            height: 100%;
            border: 0;
            border-radius: 0;
        }
        .modal-fullscreen-xxl-down .modal-header,
        .modal-fullscreen-xxl-down .modal-footer {
            border-radius: 0;
        }
        .modal-fullscreen-xxl-down .modal-body {
            overflow-y: auto;
        }
    }
    .tooltip {
        --bs-tooltip-zindex: 1080;
        --bs-tooltip-max-width: 200px;
        --bs-tooltip-padding-x: 0.5rem;
        --bs-tooltip-padding-y: 0.25rem;
        --bs-tooltip-margin: ;
        --bs-tooltip-font-size: 0.875rem;
        --bs-tooltip-color: var(--bs-body-bg);
        --bs-tooltip-bg: var(--bs-emphasis-color);
        --bs-tooltip-border-radius: var(--bs-border-radius);
        --bs-tooltip-opacity: 0.9;
        --bs-tooltip-arrow-width: 0.8rem;
        --bs-tooltip-arrow-height: 0.4rem;
        z-index: var(--bs-tooltip-zindex);
        display: block;
        margin: var(--bs-tooltip-margin);
        font-family: var(--bs-font-sans-serif);
        font-style: normal;
        font-weight: 400;
        line-height: 1.5;
        text-align: left;
        text-align: start;
        text-decoration: none;
        text-shadow: none;
        text-transform: none;
        letter-spacing: normal;
        word-break: normal;
        white-space: normal;
        word-spacing: normal;
        line-break: auto;
        font-size: var(--bs-tooltip-font-size);
        word-wrap: break-word;
        opacity: 0;
    }
    .tooltip.show {
        opacity: var(--bs-tooltip-opacity);
    }
    .tooltip .tooltip-arrow {
        display: block;
        width: var(--bs-tooltip-arrow-width);
        height: var(--bs-tooltip-arrow-height);
    }
    .tooltip .tooltip-arrow::before {
        position: absolute;
        content: '';
        border-color: transparent;
        border-style: solid;
    }

    .bs-tooltip-top .tooltip-arrow,
    .bs-tooltip-auto[data-popper-placement^='top'] .tooltip-arrow {
        bottom: calc(-1 * var(--bs-tooltip-arrow-height));
    }
    .bs-tooltip-top .tooltip-arrow::before,
    .bs-tooltip-auto[data-popper-placement^='top'] .tooltip-arrow::before {
        top: -1px;
        border-width: var(--bs-tooltip-arrow-height)
            calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
        border-top-color: var(--bs-tooltip-bg);
    }

    /* rtl:begin:ignore */
    .bs-tooltip-end .tooltip-arrow,
    .bs-tooltip-auto[data-popper-placement^='right'] .tooltip-arrow {
        left: calc(-1 * var(--bs-tooltip-arrow-height));
        width: var(--bs-tooltip-arrow-height);
        height: var(--bs-tooltip-arrow-width);
    }
    .bs-tooltip-end .tooltip-arrow::before,
    .bs-tooltip-auto[data-popper-placement^='right'] .tooltip-arrow::before {
        right: -1px;
        border-width: calc(var(--bs-tooltip-arrow-width) * 0.5)
            var(--bs-tooltip-arrow-height)
            calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
        border-right-color: var(--bs-tooltip-bg);
    }

    /* rtl:end:ignore */
    .bs-tooltip-bottom .tooltip-arrow,
    .bs-tooltip-auto[data-popper-placement^='bottom'] .tooltip-arrow {
        top: calc(-1 * var(--bs-tooltip-arrow-height));
    }
    .bs-tooltip-bottom .tooltip-arrow::before,
    .bs-tooltip-auto[data-popper-placement^='bottom'] .tooltip-arrow::before {
        bottom: -1px;
        border-width: 0 calc(var(--bs-tooltip-arrow-width) * 0.5)
            var(--bs-tooltip-arrow-height);
        border-bottom-color: var(--bs-tooltip-bg);
    }

    /* rtl:begin:ignore */
    .bs-tooltip-start .tooltip-arrow,
    .bs-tooltip-auto[data-popper-placement^='left'] .tooltip-arrow {
        right: calc(-1 * var(--bs-tooltip-arrow-height));
        width: var(--bs-tooltip-arrow-height);
        height: var(--bs-tooltip-arrow-width);
    }
    .bs-tooltip-start .tooltip-arrow::before,
    .bs-tooltip-auto[data-popper-placement^='left'] .tooltip-arrow::before {
        left: -1px;
        border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) 0
            calc(var(--bs-tooltip-arrow-width) * 0.5)
            var(--bs-tooltip-arrow-height);
        border-left-color: var(--bs-tooltip-bg);
    }

    /* rtl:end:ignore */
    .tooltip-inner {
        max-width: var(--bs-tooltip-max-width);
        padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);
        color: var(--bs-tooltip-color);
        text-align: center;
        background-color: var(--bs-tooltip-bg);
        border-radius: var(--bs-tooltip-border-radius);
    }

    .popover {
        --bs-popover-zindex: 1070;
        --bs-popover-max-width: 276px;
        --bs-popover-font-size: 0.875rem;
        --bs-popover-bg: var(--bs-body-bg);
        --bs-popover-border-width: var(--bs-border-width);
        --bs-popover-border-color: var(--bs-border-color-translucent);
        --bs-popover-border-radius: var(--bs-border-radius-lg);
        --bs-popover-inner-border-radius: calc(
            var(--bs-border-radius-lg) - var(--bs-border-width)
        );
        --bs-popover-box-shadow: var(--bs-box-shadow);
        --bs-popover-header-padding-x: 1rem;
        --bs-popover-header-padding-y: 0.5rem;
        --bs-popover-header-font-size: 1rem;
        --bs-popover-header-color: inherit;
        --bs-popover-header-bg: var(--bs-secondary-bg);
        --bs-popover-body-padding-x: 1rem;
        --bs-popover-body-padding-y: 1rem;
        --bs-popover-body-color: var(--bs-body-color);
        --bs-popover-arrow-width: 1rem;
        --bs-popover-arrow-height: 0.5rem;
        --bs-popover-arrow-border: var(--bs-popover-border-color);
        z-index: var(--bs-popover-zindex);
        display: block;
        max-width: var(--bs-popover-max-width);
        font-family: var(--bs-font-sans-serif);
        font-style: normal;
        font-weight: 400;
        line-height: 1.5;
        text-align: left;
        text-align: start;
        text-decoration: none;
        text-shadow: none;
        text-transform: none;
        letter-spacing: normal;
        word-break: normal;
        white-space: normal;
        word-spacing: normal;
        line-break: auto;
        font-size: var(--bs-popover-font-size);
        word-wrap: break-word;
        background-color: var(--bs-popover-bg);
        background-clip: padding-box;
        border: var(--bs-popover-border-width) solid
            var(--bs-popover-border-color);
        border-radius: var(--bs-popover-border-radius);
    }
    .popover .popover-arrow {
        display: block;
        width: var(--bs-popover-arrow-width);
        height: var(--bs-popover-arrow-height);
    }
    .popover .popover-arrow::before,
    .popover .popover-arrow::after {
        position: absolute;
        display: block;
        content: '';
        border-color: transparent;
        border-style: solid;
        border-width: 0;
    }

    .bs-popover-top > .popover-arrow,
    .bs-popover-auto[data-popper-placement^='top'] > .popover-arrow {
        bottom: calc(
            -1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width)
        );
    }
    .bs-popover-top > .popover-arrow::before,
    .bs-popover-auto[data-popper-placement^='top'] > .popover-arrow::before,
    .bs-popover-top > .popover-arrow::after,
    .bs-popover-auto[data-popper-placement^='top'] > .popover-arrow::after {
        border-width: var(--bs-popover-arrow-height)
            calc(var(--bs-popover-arrow-width) * 0.5) 0;
    }
    .bs-popover-top > .popover-arrow::before,
    .bs-popover-auto[data-popper-placement^='top'] > .popover-arrow::before {
        bottom: 0;
        border-top-color: var(--bs-popover-arrow-border);
    }
    .bs-popover-top > .popover-arrow::after,
    .bs-popover-auto[data-popper-placement^='top'] > .popover-arrow::after {
        bottom: var(--bs-popover-border-width);
        border-top-color: var(--bs-popover-bg);
    }

    /* rtl:begin:ignore */
    .bs-popover-end > .popover-arrow,
    .bs-popover-auto[data-popper-placement^='right'] > .popover-arrow {
        left: calc(
            -1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width)
        );
        width: var(--bs-popover-arrow-height);
        height: var(--bs-popover-arrow-width);
    }
    .bs-popover-end > .popover-arrow::before,
    .bs-popover-auto[data-popper-placement^='right'] > .popover-arrow::before,
    .bs-popover-end > .popover-arrow::after,
    .bs-popover-auto[data-popper-placement^='right'] > .popover-arrow::after {
        border-width: calc(var(--bs-popover-arrow-width) * 0.5)
            var(--bs-popover-arrow-height)
            calc(var(--bs-popover-arrow-width) * 0.5) 0;
    }
    .bs-popover-end > .popover-arrow::before,
    .bs-popover-auto[data-popper-placement^='right'] > .popover-arrow::before {
        left: 0;
        border-right-color: var(--bs-popover-arrow-border);
    }
    .bs-popover-end > .popover-arrow::after,
    .bs-popover-auto[data-popper-placement^='right'] > .popover-arrow::after {
        left: var(--bs-popover-border-width);
        border-right-color: var(--bs-popover-bg);
    }

    /* rtl:end:ignore */
    .bs-popover-bottom > .popover-arrow,
    .bs-popover-auto[data-popper-placement^='bottom'] > .popover-arrow {
        top: calc(
            -1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width)
        );
    }
    .bs-popover-bottom > .popover-arrow::before,
    .bs-popover-auto[data-popper-placement^='bottom'] > .popover-arrow::before,
    .bs-popover-bottom > .popover-arrow::after,
    .bs-popover-auto[data-popper-placement^='bottom'] > .popover-arrow::after {
        border-width: 0 calc(var(--bs-popover-arrow-width) * 0.5)
            var(--bs-popover-arrow-height);
    }
    .bs-popover-bottom > .popover-arrow::before,
    .bs-popover-auto[data-popper-placement^='bottom'] > .popover-arrow::before {
        top: 0;
        border-bottom-color: var(--bs-popover-arrow-border);
    }
    .bs-popover-bottom > .popover-arrow::after,
    .bs-popover-auto[data-popper-placement^='bottom'] > .popover-arrow::after {
        top: var(--bs-popover-border-width);
        border-bottom-color: var(--bs-popover-bg);
    }
    .bs-popover-bottom .popover-header::before,
    .bs-popover-auto[data-popper-placement^='bottom'] .popover-header::before {
        position: absolute;
        top: 0;
        left: 50%;
        display: block;
        width: var(--bs-popover-arrow-width);
        margin-left: calc(-0.5 * var(--bs-popover-arrow-width));
        content: '';
        border-bottom: var(--bs-popover-border-width) solid
            var(--bs-popover-header-bg);
    }

    /* rtl:begin:ignore */
    .bs-popover-start > .popover-arrow,
    .bs-popover-auto[data-popper-placement^='left'] > .popover-arrow {
        right: calc(
            -1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width)
        );
        width: var(--bs-popover-arrow-height);
        height: var(--bs-popover-arrow-width);
    }
    .bs-popover-start > .popover-arrow::before,
    .bs-popover-auto[data-popper-placement^='left'] > .popover-arrow::before,
    .bs-popover-start > .popover-arrow::after,
    .bs-popover-auto[data-popper-placement^='left'] > .popover-arrow::after {
        border-width: calc(var(--bs-popover-arrow-width) * 0.5) 0
            calc(var(--bs-popover-arrow-width) * 0.5)
            var(--bs-popover-arrow-height);
    }
    .bs-popover-start > .popover-arrow::before,
    .bs-popover-auto[data-popper-placement^='left'] > .popover-arrow::before {
        right: 0;
        border-left-color: var(--bs-popover-arrow-border);
    }
    .bs-popover-start > .popover-arrow::after,
    .bs-popover-auto[data-popper-placement^='left'] > .popover-arrow::after {
        right: var(--bs-popover-border-width);
        border-left-color: var(--bs-popover-bg);
    }

    /* rtl:end:ignore */
    .popover-header {
        padding: var(--bs-popover-header-padding-y)
            var(--bs-popover-header-padding-x);
        margin-bottom: 0;
        font-size: var(--bs-popover-header-font-size);
        color: var(--bs-popover-header-color);
        background-color: var(--bs-popover-header-bg);
        border-bottom: var(--bs-popover-border-width) solid
            var(--bs-popover-border-color);
        border-top-left-radius: var(--bs-popover-inner-border-radius);
        border-top-right-radius: var(--bs-popover-inner-border-radius);
    }
    .popover-header:empty {
        display: none;
    }

    .popover-body {
        padding: var(--bs-popover-body-padding-y)
            var(--bs-popover-body-padding-x);
        color: var(--bs-popover-body-color);
    }

    .carousel {
        position: relative;
    }

    .carousel.pointer-event {
        touch-action: pan-y;
    }

    .carousel-inner {
        position: relative;
        width: 100%;
        overflow: hidden;
    }
    .carousel-inner::after {
        display: block;
        clear: both;
        content: '';
    }

    .carousel-item {
        position: relative;
        display: none;
        float: left;
        width: 100%;
        margin-right: -100%;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
        transition: transform 0.6s ease-in-out;
    }
    @media (prefers-reduced-motion: reduce) {
        .carousel-item {
            transition: none;
        }
    }

    .carousel-item.active,
    .carousel-item-next,
    .carousel-item-prev {
        display: block;
    }

    .carousel-item-next:not(.carousel-item-start),
    .active.carousel-item-end {
        transform: translateX(100%);
    }

    .carousel-item-prev:not(.carousel-item-end),
    .active.carousel-item-start {
        transform: translateX(-100%);
    }

    .carousel-fade .carousel-item {
        opacity: 0;
        transition-property: opacity;
        transform: none;
    }
    .carousel-fade .carousel-item.active,
    .carousel-fade .carousel-item-next.carousel-item-start,
    .carousel-fade .carousel-item-prev.carousel-item-end {
        z-index: 1;
        opacity: 1;
    }
    .carousel-fade .active.carousel-item-start,
    .carousel-fade .active.carousel-item-end {
        z-index: 0;
        opacity: 0;
        transition: opacity 0s 0.6s;
    }
    @media (prefers-reduced-motion: reduce) {
        .carousel-fade .active.carousel-item-start,
        .carousel-fade .active.carousel-item-end {
            transition: none;
        }
    }

    .carousel-control-prev,
    .carousel-control-next {
        position: absolute;
        top: 0;
        bottom: 0;
        z-index: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 15%;
        padding: 0;
        color: #fff;
        text-align: center;
        background: none;
        border: 0;
        opacity: 0.5;
        transition: opacity 0.15s ease;
    }
    @media (prefers-reduced-motion: reduce) {
        .carousel-control-prev,
        .carousel-control-next {
            transition: none;
        }
    }
    .carousel-control-prev:hover,
    .carousel-control-prev:focus,
    .carousel-control-next:hover,
    .carousel-control-next:focus {
        color: #fff;
        text-decoration: none;
        outline: 0;
        opacity: 0.9;
    }

    .carousel-control-prev {
        left: 0;
    }

    .carousel-control-next {
        right: 0;
    }

    .carousel-control-prev-icon,
    .carousel-control-next-icon {
        display: inline-block;
        width: 2rem;
        height: 2rem;
        background-repeat: no-repeat;
        background-position: 50%;
        background-size: 100% 100%;
    }

    .carousel-control-prev-icon {
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___})
            /*rtl:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e")*/;
    }

    .carousel-control-next-icon {
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___})
            /*rtl:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e")*/;
    }

    .carousel-indicators {
        position: absolute;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 2;
        display: flex;
        justify-content: center;
        padding: 0;
        margin-right: 15%;
        margin-bottom: 1rem;
        margin-left: 15%;
    }
    .carousel-indicators [data-bs-target] {
        box-sizing: content-box;
        flex: 0 1 auto;
        width: 30px;
        height: 3px;
        padding: 0;
        margin-right: 3px;
        margin-left: 3px;
        text-indent: -999px;
        cursor: pointer;
        background-color: #fff;
        background-clip: padding-box;
        border: 0;
        border-top: 10px solid transparent;
        border-bottom: 10px solid transparent;
        opacity: 0.5;
        transition: opacity 0.6s ease;
    }
    @media (prefers-reduced-motion: reduce) {
        .carousel-indicators [data-bs-target] {
            transition: none;
        }
    }
    .carousel-indicators .active {
        opacity: 1;
    }

    .carousel-caption {
        position: absolute;
        right: 15%;
        bottom: 1.25rem;
        left: 15%;
        padding-top: 1.25rem;
        padding-bottom: 1.25rem;
        color: #fff;
        text-align: center;
    }

    .carousel-dark .carousel-control-prev-icon,
    .carousel-dark .carousel-control-next-icon {
        filter: invert(1) grayscale(100);
    }
    .carousel-dark .carousel-indicators [data-bs-target] {
        background-color: #000;
    }
    .carousel-dark .carousel-caption {
        color: #000;
    }

    [data-bs-theme='dark'] .carousel .carousel-control-prev-icon,
    [data-bs-theme='dark'] .carousel .carousel-control-next-icon,
    [data-bs-theme='dark'].carousel .carousel-control-prev-icon,
    [data-bs-theme='dark'].carousel .carousel-control-next-icon {
        filter: invert(1) grayscale(100);
    }
    [data-bs-theme='dark'] .carousel .carousel-indicators [data-bs-target],
    [data-bs-theme='dark'].carousel .carousel-indicators [data-bs-target] {
        background-color: #000;
    }
    [data-bs-theme='dark'] .carousel .carousel-caption,
    [data-bs-theme='dark'].carousel .carousel-caption {
        color: #000;
    }

    .spinner-grow,
    .spinner-border {
        display: inline-block;
        width: var(--bs-spinner-width);
        height: var(--bs-spinner-height);
        vertical-align: var(--bs-spinner-vertical-align);
        border-radius: 50%;
        animation: var(--bs-spinner-animation-speed) linear infinite
            var(--bs-spinner-animation-name);
    }

    @keyframes spinner-border {
        to {
            transform: rotate(360deg) /* rtl:ignore */;
        }
    }
    .spinner-border {
        --bs-spinner-width: 2rem;
        --bs-spinner-height: 2rem;
        --bs-spinner-vertical-align: -0.125em;
        --bs-spinner-border-width: 0.25em;
        --bs-spinner-animation-speed: 0.75s;
        --bs-spinner-animation-name: spinner-border;
        border: var(--bs-spinner-border-width) solid currentcolor;
        border-right-color: transparent;
    }

    .spinner-border-sm {
        --bs-spinner-width: 1rem;
        --bs-spinner-height: 1rem;
        --bs-spinner-border-width: 0.2em;
    }

    @keyframes spinner-grow {
        0% {
            transform: scale(0);
        }
        50% {
            opacity: 1;
            transform: none;
        }
    }
    .spinner-grow {
        --bs-spinner-width: 2rem;
        --bs-spinner-height: 2rem;
        --bs-spinner-vertical-align: -0.125em;
        --bs-spinner-animation-speed: 0.75s;
        --bs-spinner-animation-name: spinner-grow;
        background-color: currentcolor;
        opacity: 0;
    }

    .spinner-grow-sm {
        --bs-spinner-width: 1rem;
        --bs-spinner-height: 1rem;
    }

    @media (prefers-reduced-motion: reduce) {
        .spinner-border,
        .spinner-grow {
            --bs-spinner-animation-speed: 1.5s;
        }
    }
    .offcanvas,
    .offcanvas-xxl,
    .offcanvas-xl,
    .offcanvas-lg,
    .offcanvas-md,
    .offcanvas-sm {
        --bs-offcanvas-zindex: 1045;
        --bs-offcanvas-width: 400px;
        --bs-offcanvas-height: 30vh;
        --bs-offcanvas-padding-x: 1rem;
        --bs-offcanvas-padding-y: 1rem;
        --bs-offcanvas-color: var(--bs-body-color);
        --bs-offcanvas-bg: var(--bs-body-bg);
        --bs-offcanvas-border-width: var(--bs-border-width);
        --bs-offcanvas-border-color: var(--bs-border-color-translucent);
        --bs-offcanvas-box-shadow: var(--bs-box-shadow-sm);
        --bs-offcanvas-transition: transform 0.3s ease-in-out;
        --bs-offcanvas-title-line-height: 1.5;
    }

    @media (max-width: 575.98px) {
        .offcanvas-sm {
            position: fixed;
            bottom: 0;
            z-index: var(--bs-offcanvas-zindex);
            display: flex;
            flex-direction: column;
            max-width: 100%;
            color: var(--bs-offcanvas-color);
            visibility: hidden;
            background-color: var(--bs-offcanvas-bg);
            background-clip: padding-box;
            outline: 0;
            transition: var(--bs-offcanvas-transition);
        }
    }
    @media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
        .offcanvas-sm {
            transition: none;
        }
    }
    @media (max-width: 575.98px) {
        .offcanvas-sm.offcanvas-start {
            top: 0;
            left: 0;
            width: var(--bs-offcanvas-width);
            border-right: var(--bs-offcanvas-border-width) solid
                var(--bs-offcanvas-border-color);
            transform: translateX(-100%);
        }
        .offcanvas-sm.offcanvas-end {
            top: 0;
            right: 0;
            width: var(--bs-offcanvas-width);
            border-left: var(--bs-offcanvas-border-width) solid
                var(--bs-offcanvas-border-color);
            transform: translateX(100%);
        }
        .offcanvas-sm.offcanvas-top {
            top: 0;
            right: 0;
            left: 0;
            height: var(--bs-offcanvas-height);
            max-height: 100%;
            border-bottom: var(--bs-offcanvas-border-width) solid
                var(--bs-offcanvas-border-color);
            transform: translateY(-100%);
        }
        .offcanvas-sm.offcanvas-bottom {
            right: 0;
            left: 0;
            height: var(--bs-offcanvas-height);
            max-height: 100%;
            border-top: var(--bs-offcanvas-border-width) solid
                var(--bs-offcanvas-border-color);
            transform: translateY(100%);
        }
        .offcanvas-sm.showing,
        .offcanvas-sm.show:not(.hiding) {
            transform: none;
        }
        .offcanvas-sm.showing,
        .offcanvas-sm.hiding,
        .offcanvas-sm.show {
            visibility: visible;
        }
    }
    @media (min-width: 576px) {
        .offcanvas-sm {
            --bs-offcanvas-height: auto;
            --bs-offcanvas-border-width: 0;
            background-color: transparent !important;
        }
        .offcanvas-sm .offcanvas-header {
            display: none;
        }
        .offcanvas-sm .offcanvas-body {
            display: flex;
            flex-grow: 0;
            padding: 0;
            overflow-y: visible;
            background-color: transparent !important;
        }
    }

    @media (max-width: 767.98px) {
        .offcanvas-md {
            position: fixed;
            bottom: 0;
            z-index: var(--bs-offcanvas-zindex);
            display: flex;
            flex-direction: column;
            max-width: 100%;
            color: var(--bs-offcanvas-color);
            visibility: hidden;
            background-color: var(--bs-offcanvas-bg);
            background-clip: padding-box;
            outline: 0;
            transition: var(--bs-offcanvas-transition);
        }
    }
    @media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {
        .offcanvas-md {
            transition: none;
        }
    }
    @media (max-width: 767.98px) {
        .offcanvas-md.offcanvas-start {
            top: 0;
            left: 0;
            width: var(--bs-offcanvas-width);
            border-right: var(--bs-offcanvas-border-width) solid
                var(--bs-offcanvas-border-color);
            transform: translateX(-100%);
        }
        .offcanvas-md.offcanvas-end {
            top: 0;
            right: 0;
            width: var(--bs-offcanvas-width);
            border-left: var(--bs-offcanvas-border-width) solid
                var(--bs-offcanvas-border-color);
            transform: translateX(100%);
        }
        .offcanvas-md.offcanvas-top {
            top: 0;
            right: 0;
            left: 0;
            height: var(--bs-offcanvas-height);
            max-height: 100%;
            border-bottom: var(--bs-offcanvas-border-width) solid
                var(--bs-offcanvas-border-color);
            transform: translateY(-100%);
        }
        .offcanvas-md.offcanvas-bottom {
            right: 0;
            left: 0;
            height: var(--bs-offcanvas-height);
            max-height: 100%;
            border-top: var(--bs-offcanvas-border-width) solid
                var(--bs-offcanvas-border-color);
            transform: translateY(100%);
        }
        .offcanvas-md.showing,
        .offcanvas-md.show:not(.hiding) {
            transform: none;
        }
        .offcanvas-md.showing,
        .offcanvas-md.hiding,
        .offcanvas-md.show {
            visibility: visible;
        }
    }
    @media (min-width: 768px) {
        .offcanvas-md {
            --bs-offcanvas-height: auto;
            --bs-offcanvas-border-width: 0;
            background-color: transparent !important;
        }
        .offcanvas-md .offcanvas-header {
            display: none;
        }
        .offcanvas-md .offcanvas-body {
            display: flex;
            flex-grow: 0;
            padding: 0;
            overflow-y: visible;
            background-color: transparent !important;
        }
    }

    @media (max-width: 991.98px) {
        .offcanvas-lg {
            position: fixed;
            bottom: 0;
            z-index: var(--bs-offcanvas-zindex);
            display: flex;
            flex-direction: column;
            max-width: 100%;
            color: var(--bs-offcanvas-color);
            visibility: hidden;
            background-color: var(--bs-offcanvas-bg);
            background-clip: padding-box;
            outline: 0;
            transition: var(--bs-offcanvas-transition);
        }
    }
    @media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
        .offcanvas-lg {
            transition: none;
        }
    }
    @media (max-width: 991.98px) {
        .offcanvas-lg.offcanvas-start {
            top: 0;
            left: 0;
            width: var(--bs-offcanvas-width);
            border-right: var(--bs-offcanvas-border-width) solid
                var(--bs-offcanvas-border-color);
            transform: translateX(-100%);
        }
        .offcanvas-lg.offcanvas-end {
            top: 0;
            right: 0;
            width: var(--bs-offcanvas-width);
            border-left: var(--bs-offcanvas-border-width) solid
                var(--bs-offcanvas-border-color);
            transform: translateX(100%);
        }
        .offcanvas-lg.offcanvas-top {
            top: 0;
            right: 0;
            left: 0;
            height: var(--bs-offcanvas-height);
            max-height: 100%;
            border-bottom: var(--bs-offcanvas-border-width) solid
                var(--bs-offcanvas-border-color);
            transform: translateY(-100%);
        }
        .offcanvas-lg.offcanvas-bottom {
            right: 0;
            left: 0;
            height: var(--bs-offcanvas-height);
            max-height: 100%;
            border-top: var(--bs-offcanvas-border-width) solid
                var(--bs-offcanvas-border-color);
            transform: translateY(100%);
        }
        .offcanvas-lg.showing,
        .offcanvas-lg.show:not(.hiding) {
            transform: none;
        }
        .offcanvas-lg.showing,
        .offcanvas-lg.hiding,
        .offcanvas-lg.show {
            visibility: visible;
        }
    }
    @media (min-width: 992px) {
        .offcanvas-lg {
            --bs-offcanvas-height: auto;
            --bs-offcanvas-border-width: 0;
            background-color: transparent !important;
        }
        .offcanvas-lg .offcanvas-header {
            display: none;
        }
        .offcanvas-lg .offcanvas-body {
            display: flex;
            flex-grow: 0;
            padding: 0;
            overflow-y: visible;
            background-color: transparent !important;
        }
    }

    @media (max-width: 1199.98px) {
        .offcanvas-xl {
            position: fixed;
            bottom: 0;
            z-index: var(--bs-offcanvas-zindex);
            display: flex;
            flex-direction: column;
            max-width: 100%;
            color: var(--bs-offcanvas-color);
            visibility: hidden;
            background-color: var(--bs-offcanvas-bg);
            background-clip: padding-box;
            outline: 0;
            transition: var(--bs-offcanvas-transition);
        }
    }
    @media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {
        .offcanvas-xl {
            transition: none;
        }
    }
    @media (max-width: 1199.98px) {
        .offcanvas-xl.offcanvas-start {
            top: 0;
            left: 0;
            width: var(--bs-offcanvas-width);
            border-right: var(--bs-offcanvas-border-width) solid
                var(--bs-offcanvas-border-color);
            transform: translateX(-100%);
        }
        .offcanvas-xl.offcanvas-end {
            top: 0;
            right: 0;
            width: var(--bs-offcanvas-width);
            border-left: var(--bs-offcanvas-border-width) solid
                var(--bs-offcanvas-border-color);
            transform: translateX(100%);
        }
        .offcanvas-xl.offcanvas-top {
            top: 0;
            right: 0;
            left: 0;
            height: var(--bs-offcanvas-height);
            max-height: 100%;
            border-bottom: var(--bs-offcanvas-border-width) solid
                var(--bs-offcanvas-border-color);
            transform: translateY(-100%);
        }
        .offcanvas-xl.offcanvas-bottom {
            right: 0;
            left: 0;
            height: var(--bs-offcanvas-height);
            max-height: 100%;
            border-top: var(--bs-offcanvas-border-width) solid
                var(--bs-offcanvas-border-color);
            transform: translateY(100%);
        }
        .offcanvas-xl.showing,
        .offcanvas-xl.show:not(.hiding) {
            transform: none;
        }
        .offcanvas-xl.showing,
        .offcanvas-xl.hiding,
        .offcanvas-xl.show {
            visibility: visible;
        }
    }
    @media (min-width: 1200px) {
        .offcanvas-xl {
            --bs-offcanvas-height: auto;
            --bs-offcanvas-border-width: 0;
            background-color: transparent !important;
        }
        .offcanvas-xl .offcanvas-header {
            display: none;
        }
        .offcanvas-xl .offcanvas-body {
            display: flex;
            flex-grow: 0;
            padding: 0;
            overflow-y: visible;
            background-color: transparent !important;
        }
    }

    @media (max-width: 1399.98px) {
        .offcanvas-xxl {
            position: fixed;
            bottom: 0;
            z-index: var(--bs-offcanvas-zindex);
            display: flex;
            flex-direction: column;
            max-width: 100%;
            color: var(--bs-offcanvas-color);
            visibility: hidden;
            background-color: var(--bs-offcanvas-bg);
            background-clip: padding-box;
            outline: 0;
            transition: var(--bs-offcanvas-transition);
        }
    }
    @media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {
        .offcanvas-xxl {
            transition: none;
        }
    }
    @media (max-width: 1399.98px) {
        .offcanvas-xxl.offcanvas-start {
            top: 0;
            left: 0;
            width: var(--bs-offcanvas-width);
            border-right: var(--bs-offcanvas-border-width) solid
                var(--bs-offcanvas-border-color);
            transform: translateX(-100%);
        }
        .offcanvas-xxl.offcanvas-end {
            top: 0;
            right: 0;
            width: var(--bs-offcanvas-width);
            border-left: var(--bs-offcanvas-border-width) solid
                var(--bs-offcanvas-border-color);
            transform: translateX(100%);
        }
        .offcanvas-xxl.offcanvas-top {
            top: 0;
            right: 0;
            left: 0;
            height: var(--bs-offcanvas-height);
            max-height: 100%;
            border-bottom: var(--bs-offcanvas-border-width) solid
                var(--bs-offcanvas-border-color);
            transform: translateY(-100%);
        }
        .offcanvas-xxl.offcanvas-bottom {
            right: 0;
            left: 0;
            height: var(--bs-offcanvas-height);
            max-height: 100%;
            border-top: var(--bs-offcanvas-border-width) solid
                var(--bs-offcanvas-border-color);
            transform: translateY(100%);
        }
        .offcanvas-xxl.showing,
        .offcanvas-xxl.show:not(.hiding) {
            transform: none;
        }
        .offcanvas-xxl.showing,
        .offcanvas-xxl.hiding,
        .offcanvas-xxl.show {
            visibility: visible;
        }
    }
    @media (min-width: 1400px) {
        .offcanvas-xxl {
            --bs-offcanvas-height: auto;
            --bs-offcanvas-border-width: 0;
            background-color: transparent !important;
        }
        .offcanvas-xxl .offcanvas-header {
            display: none;
        }
        .offcanvas-xxl .offcanvas-body {
            display: flex;
            flex-grow: 0;
            padding: 0;
            overflow-y: visible;
            background-color: transparent !important;
        }
    }

    .offcanvas {
        position: fixed;
        bottom: 0;
        z-index: var(--bs-offcanvas-zindex);
        display: flex;
        flex-direction: column;
        max-width: 100%;
        color: var(--bs-offcanvas-color);
        visibility: hidden;
        background-color: var(--bs-offcanvas-bg);
        background-clip: padding-box;
        outline: 0;
        transition: var(--bs-offcanvas-transition);
    }
    @media (prefers-reduced-motion: reduce) {
        .offcanvas {
            transition: none;
        }
    }
    .offcanvas.offcanvas-start {
        top: 0;
        left: 0;
        width: var(--bs-offcanvas-width);
        border-right: var(--bs-offcanvas-border-width) solid
            var(--bs-offcanvas-border-color);
        transform: translateX(-100%);
    }
    .offcanvas.offcanvas-end {
        top: 0;
        right: 0;
        width: var(--bs-offcanvas-width);
        border-left: var(--bs-offcanvas-border-width) solid
            var(--bs-offcanvas-border-color);
        transform: translateX(100%);
    }
    .offcanvas.offcanvas-top {
        top: 0;
        right: 0;
        left: 0;
        height: var(--bs-offcanvas-height);
        max-height: 100%;
        border-bottom: var(--bs-offcanvas-border-width) solid
            var(--bs-offcanvas-border-color);
        transform: translateY(-100%);
    }
    .offcanvas.offcanvas-bottom {
        right: 0;
        left: 0;
        height: var(--bs-offcanvas-height);
        max-height: 100%;
        border-top: var(--bs-offcanvas-border-width) solid
            var(--bs-offcanvas-border-color);
        transform: translateY(100%);
    }
    .offcanvas.showing,
    .offcanvas.show:not(.hiding) {
        transform: none;
    }
    .offcanvas.showing,
    .offcanvas.hiding,
    .offcanvas.show {
        visibility: visible;
    }

    .offcanvas-backdrop {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1040;
        width: 100vw;
        height: 100vh;
        background-color: #000;
    }
    .offcanvas-backdrop.fade {
        opacity: 0;
    }
    .offcanvas-backdrop.show {
        opacity: 0.5;
    }

    .offcanvas-header {
        display: flex;
        align-items: center;
        padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
    }
    .offcanvas-header .btn-close {
        padding: calc(var(--bs-offcanvas-padding-y) * 0.5)
            calc(var(--bs-offcanvas-padding-x) * 0.5);
        margin: calc(-0.5 * var(--bs-offcanvas-padding-y))
            calc(-0.5 * var(--bs-offcanvas-padding-x))
            calc(-0.5 * var(--bs-offcanvas-padding-y)) auto;
    }

    .offcanvas-title {
        margin-bottom: 0;
        line-height: var(--bs-offcanvas-title-line-height);
    }

    .offcanvas-body {
        flex-grow: 1;
        padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
        overflow-y: auto;
    }

    .placeholder {
        display: inline-block;
        min-height: 1em;
        vertical-align: middle;
        cursor: wait;
        background-color: currentcolor;
        opacity: 0.5;
    }
    .placeholder.btn::before {
        display: inline-block;
        content: '';
    }

    .placeholder-xs {
        min-height: 0.6em;
    }

    .placeholder-sm {
        min-height: 0.8em;
    }

    .placeholder-lg {
        min-height: 1.2em;
    }

    .placeholder-glow .placeholder {
        animation: placeholder-glow 2s ease-in-out infinite;
    }

    @keyframes placeholder-glow {
        50% {
            opacity: 0.2;
        }
    }
    .placeholder-wave {
        -webkit-mask-image: linear-gradient(
            130deg,
            #000 55%,
            rgba(0, 0, 0, 0.8) 75%,
            #000 95%
        );
        mask-image: linear-gradient(
            130deg,
            #000 55%,
            rgba(0, 0, 0, 0.8) 75%,
            #000 95%
        );
        -webkit-mask-size: 200% 100%;
        mask-size: 200% 100%;
        animation: placeholder-wave 2s linear infinite;
    }

    @keyframes placeholder-wave {
        100% {
            -webkit-mask-position: -200% 0%;
            mask-position: -200% 0%;
        }
    }
    .clearfix::after {
        display: block;
        clear: both;
        content: '';
    }

    .text-bg-primary {
        color: #fff !important;
        background-color: RGBA(
            var(--bs-primary-rgb),
            var(--bs-bg-opacity, 1)
        ) !important;
    }

    .text-bg-secondary {
        color: #fff !important;
        background-color: RGBA(
            var(--bs-secondary-rgb),
            var(--bs-bg-opacity, 1)
        ) !important;
    }

    .text-bg-success {
        color: #fff !important;
        background-color: RGBA(
            var(--bs-success-rgb),
            var(--bs-bg-opacity, 1)
        ) !important;
    }

    .text-bg-info {
        color: #000 !important;
        background-color: RGBA(
            var(--bs-info-rgb),
            var(--bs-bg-opacity, 1)
        ) !important;
    }

    .text-bg-warning {
        color: #000 !important;
        background-color: RGBA(
            var(--bs-warning-rgb),
            var(--bs-bg-opacity, 1)
        ) !important;
    }

    .text-bg-danger {
        color: #fff !important;
        background-color: RGBA(
            var(--bs-danger-rgb),
            var(--bs-bg-opacity, 1)
        ) !important;
    }

    .text-bg-light {
        color: #000 !important;
        background-color: RGBA(
            var(--bs-light-rgb),
            var(--bs-bg-opacity, 1)
        ) !important;
    }

    .text-bg-dark {
        color: #fff !important;
        background-color: RGBA(
            var(--bs-dark-rgb),
            var(--bs-bg-opacity, 1)
        ) !important;
    }

    .link-primary {
        color: RGBA(
            var(--bs-primary-rgb),
            var(--bs-link-opacity, 1)
        ) !important;
        -webkit-text-decoration-color: RGBA(
            var(--bs-primary-rgb),
            var(--bs-link-underline-opacity, 1)
        ) !important;
        text-decoration-color: RGBA(
            var(--bs-primary-rgb),
            var(--bs-link-underline-opacity, 1)
        ) !important;
    }
    .link-primary:hover,
    .link-primary:focus {
        color: RGBA(10, 88, 202, var(--bs-link-opacity, 1)) !important;
        -webkit-text-decoration-color: RGBA(
            10,
            88,
            202,
            var(--bs-link-underline-opacity, 1)
        ) !important;
        text-decoration-color: RGBA(
            10,
            88,
            202,
            var(--bs-link-underline-opacity, 1)
        ) !important;
    }

    .link-secondary {
        color: RGBA(
            var(--bs-secondary-rgb),
            var(--bs-link-opacity, 1)
        ) !important;
        -webkit-text-decoration-color: RGBA(
            var(--bs-secondary-rgb),
            var(--bs-link-underline-opacity, 1)
        ) !important;
        text-decoration-color: RGBA(
            var(--bs-secondary-rgb),
            var(--bs-link-underline-opacity, 1)
        ) !important;
    }
    .link-secondary:hover,
    .link-secondary:focus {
        color: RGBA(86, 94, 100, var(--bs-link-opacity, 1)) !important;
        -webkit-text-decoration-color: RGBA(
            86,
            94,
            100,
            var(--bs-link-underline-opacity, 1)
        ) !important;
        text-decoration-color: RGBA(
            86,
            94,
            100,
            var(--bs-link-underline-opacity, 1)
        ) !important;
    }

    .link-success {
        color: RGBA(
            var(--bs-success-rgb),
            var(--bs-link-opacity, 1)
        ) !important;
        -webkit-text-decoration-color: RGBA(
            var(--bs-success-rgb),
            var(--bs-link-underline-opacity, 1)
        ) !important;
        text-decoration-color: RGBA(
            var(--bs-success-rgb),
            var(--bs-link-underline-opacity, 1)
        ) !important;
    }
    .link-success:hover,
    .link-success:focus {
        color: RGBA(20, 108, 67, var(--bs-link-opacity, 1)) !important;
        -webkit-text-decoration-color: RGBA(
            20,
            108,
            67,
            var(--bs-link-underline-opacity, 1)
        ) !important;
        text-decoration-color: RGBA(
            20,
            108,
            67,
            var(--bs-link-underline-opacity, 1)
        ) !important;
    }

    .link-info {
        color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;
        -webkit-text-decoration-color: RGBA(
            var(--bs-info-rgb),
            var(--bs-link-underline-opacity, 1)
        ) !important;
        text-decoration-color: RGBA(
            var(--bs-info-rgb),
            var(--bs-link-underline-opacity, 1)
        ) !important;
    }
    .link-info:hover,
    .link-info:focus {
        color: RGBA(61, 213, 243, var(--bs-link-opacity, 1)) !important;
        -webkit-text-decoration-color: RGBA(
            61,
            213,
            243,
            var(--bs-link-underline-opacity, 1)
        ) !important;
        text-decoration-color: RGBA(
            61,
            213,
            243,
            var(--bs-link-underline-opacity, 1)
        ) !important;
    }

    .link-warning {
        color: RGBA(
            var(--bs-warning-rgb),
            var(--bs-link-opacity, 1)
        ) !important;
        -webkit-text-decoration-color: RGBA(
            var(--bs-warning-rgb),
            var(--bs-link-underline-opacity, 1)
        ) !important;
        text-decoration-color: RGBA(
            var(--bs-warning-rgb),
            var(--bs-link-underline-opacity, 1)
        ) !important;
    }
    .link-warning:hover,
    .link-warning:focus {
        color: RGBA(255, 205, 57, var(--bs-link-opacity, 1)) !important;
        -webkit-text-decoration-color: RGBA(
            255,
            205,
            57,
            var(--bs-link-underline-opacity, 1)
        ) !important;
        text-decoration-color: RGBA(
            255,
            205,
            57,
            var(--bs-link-underline-opacity, 1)
        ) !important;
    }

    .link-danger {
        color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;
        -webkit-text-decoration-color: RGBA(
            var(--bs-danger-rgb),
            var(--bs-link-underline-opacity, 1)
        ) !important;
        text-decoration-color: RGBA(
            var(--bs-danger-rgb),
            var(--bs-link-underline-opacity, 1)
        ) !important;
    }
    .link-danger:hover,
    .link-danger:focus {
        color: RGBA(176, 42, 55, var(--bs-link-opacity, 1)) !important;
        -webkit-text-decoration-color: RGBA(
            176,
            42,
            55,
            var(--bs-link-underline-opacity, 1)
        ) !important;
        text-decoration-color: RGBA(
            176,
            42,
            55,
            var(--bs-link-underline-opacity, 1)
        ) !important;
    }

    .link-light {
        color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;
        -webkit-text-decoration-color: RGBA(
            var(--bs-light-rgb),
            var(--bs-link-underline-opacity, 1)
        ) !important;
        text-decoration-color: RGBA(
            var(--bs-light-rgb),
            var(--bs-link-underline-opacity, 1)
        ) !important;
    }
    .link-light:hover,
    .link-light:focus {
        color: RGBA(249, 250, 251, var(--bs-link-opacity, 1)) !important;
        -webkit-text-decoration-color: RGBA(
            249,
            250,
            251,
            var(--bs-link-underline-opacity, 1)
        ) !important;
        text-decoration-color: RGBA(
            249,
            250,
            251,
            var(--bs-link-underline-opacity, 1)
        ) !important;
    }

    .link-dark {
        color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;
        -webkit-text-decoration-color: RGBA(
            var(--bs-dark-rgb),
            var(--bs-link-underline-opacity, 1)
        ) !important;
        text-decoration-color: RGBA(
            var(--bs-dark-rgb),
            var(--bs-link-underline-opacity, 1)
        ) !important;
    }
    .link-dark:hover,
    .link-dark:focus {
        color: RGBA(26, 30, 33, var(--bs-link-opacity, 1)) !important;
        -webkit-text-decoration-color: RGBA(
            26,
            30,
            33,
            var(--bs-link-underline-opacity, 1)
        ) !important;
        text-decoration-color: RGBA(
            26,
            30,
            33,
            var(--bs-link-underline-opacity, 1)
        ) !important;
    }

    .link-body-emphasis {
        color: RGBA(
            var(--bs-emphasis-color-rgb),
            var(--bs-link-opacity, 1)
        ) !important;
        -webkit-text-decoration-color: RGBA(
            var(--bs-emphasis-color-rgb),
            var(--bs-link-underline-opacity, 1)
        ) !important;
        text-decoration-color: RGBA(
            var(--bs-emphasis-color-rgb),
            var(--bs-link-underline-opacity, 1)
        ) !important;
    }
    .link-body-emphasis:hover,
    .link-body-emphasis:focus {
        color: RGBA(
            var(--bs-emphasis-color-rgb),
            var(--bs-link-opacity, 0.75)
        ) !important;
        -webkit-text-decoration-color: RGBA(
            var(--bs-emphasis-color-rgb),
            var(--bs-link-underline-opacity, 0.75)
        ) !important;
        text-decoration-color: RGBA(
            var(--bs-emphasis-color-rgb),
            var(--bs-link-underline-opacity, 0.75)
        ) !important;
    }

    .focus-ring:focus {
        outline: 0;
        box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0)
            var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width)
            var(--bs-focus-ring-color);
    }

    .icon-link {
        display: inline-flex;
        gap: 0.375rem;
        align-items: center;
        -webkit-text-decoration-color: rgba(
            var(--bs-link-color-rgb),
            var(--bs-link-opacity, 0.5)
        );
        text-decoration-color: rgba(
            var(--bs-link-color-rgb),
            var(--bs-link-opacity, 0.5)
        );
        text-underline-offset: 0.25em;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
    }
    .icon-link > .bi {
        flex-shrink: 0;
        width: 1em;
        height: 1em;
        fill: currentcolor;
        transition: 0.2s ease-in-out transform;
    }
    @media (prefers-reduced-motion: reduce) {
        .icon-link > .bi {
            transition: none;
        }
    }

    .icon-link-hover:hover > .bi,
    .icon-link-hover:focus-visible > .bi {
        transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0));
    }

    .ratio {
        position: relative;
        width: 100%;
    }
    .ratio::before {
        display: block;
        padding-top: var(--bs-aspect-ratio);
        content: '';
    }
    .ratio > * {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    .ratio-1x1 {
        --bs-aspect-ratio: 100%;
    }

    .ratio-4x3 {
        --bs-aspect-ratio: 75%;
    }

    .ratio-16x9 {
        --bs-aspect-ratio: 56.25%;
    }

    .ratio-21x9 {
        --bs-aspect-ratio: 42.8571428571%;
    }

    .fixed-top {
        position: fixed;
        top: 0;
        right: 0;
        left: 0;
        z-index: 1030;
    }

    .fixed-bottom {
        position: fixed;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 1030;
    }

    .sticky-top {
        position: -webkit-sticky;
        position: sticky;
        top: 0;
        z-index: 1020;
    }

    .sticky-bottom {
        position: -webkit-sticky;
        position: sticky;
        bottom: 0;
        z-index: 1020;
    }

    @media (min-width: 576px) {
        .sticky-sm-top {
            position: -webkit-sticky;
            position: sticky;
            top: 0;
            z-index: 1020;
        }
        .sticky-sm-bottom {
            position: -webkit-sticky;
            position: sticky;
            bottom: 0;
            z-index: 1020;
        }
    }
    @media (min-width: 768px) {
        .sticky-md-top {
            position: -webkit-sticky;
            position: sticky;
            top: 0;
            z-index: 1020;
        }
        .sticky-md-bottom {
            position: -webkit-sticky;
            position: sticky;
            bottom: 0;
            z-index: 1020;
        }
    }
    @media (min-width: 992px) {
        .sticky-lg-top {
            position: -webkit-sticky;
            position: sticky;
            top: 0;
            z-index: 1020;
        }
        .sticky-lg-bottom {
            position: -webkit-sticky;
            position: sticky;
            bottom: 0;
            z-index: 1020;
        }
    }
    @media (min-width: 1200px) {
        .sticky-xl-top {
            position: -webkit-sticky;
            position: sticky;
            top: 0;
            z-index: 1020;
        }
        .sticky-xl-bottom {
            position: -webkit-sticky;
            position: sticky;
            bottom: 0;
            z-index: 1020;
        }
    }
    @media (min-width: 1400px) {
        .sticky-xxl-top {
            position: -webkit-sticky;
            position: sticky;
            top: 0;
            z-index: 1020;
        }
        .sticky-xxl-bottom {
            position: -webkit-sticky;
            position: sticky;
            bottom: 0;
            z-index: 1020;
        }
    }
    .hstack {
        display: flex;
        flex-direction: row;
        align-items: center;
        align-self: stretch;
    }

    .vstack {
        display: flex;
        flex: 1 1 auto;
        flex-direction: column;
        align-self: stretch;
    }

    .visually-hidden,
    .visually-hidden-focusable:not(:focus):not(:focus-within) {
        width: 1px !important;
        height: 1px !important;
        padding: 0 !important;
        margin: -1px !important;
        overflow: hidden !important;
        clip: rect(0, 0, 0, 0) !important;
        white-space: nowrap !important;
        border: 0 !important;
    }
    .visually-hidden:not(caption),
    .visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {
        position: absolute !important;
    }

    .stretched-link::after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 1;
        content: '';
    }

    .text-truncate {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .vr {
        display: inline-block;
        align-self: stretch;
        width: var(--bs-border-width);
        min-height: 1em;
        background-color: currentcolor;
        opacity: 0.25;
    }

    .align-baseline {
        vertical-align: baseline !important;
    }

    .align-top {
        vertical-align: top !important;
    }

    .align-middle {
        vertical-align: middle !important;
    }

    .align-bottom {
        vertical-align: bottom !important;
    }

    .align-text-bottom {
        vertical-align: text-bottom !important;
    }

    .align-text-top {
        vertical-align: text-top !important;
    }

    .float-start {
        float: left !important;
    }

    .float-end {
        float: right !important;
    }

    .float-none {
        float: none !important;
    }

    .object-fit-contain {
        -o-object-fit: contain !important;
        object-fit: contain !important;
    }

    .object-fit-cover {
        -o-object-fit: cover !important;
        object-fit: cover !important;
    }

    .object-fit-fill {
        -o-object-fit: fill !important;
        object-fit: fill !important;
    }

    .object-fit-scale {
        -o-object-fit: scale-down !important;
        object-fit: scale-down !important;
    }

    .object-fit-none {
        -o-object-fit: none !important;
        object-fit: none !important;
    }

    .opacity-0 {
        opacity: 0 !important;
    }

    .opacity-25 {
        opacity: 0.25 !important;
    }

    .opacity-50 {
        opacity: 0.5 !important;
    }

    .opacity-75 {
        opacity: 0.75 !important;
    }

    .opacity-100 {
        opacity: 1 !important;
    }

    .overflow-auto {
        overflow: auto !important;
    }

    .overflow-hidden {
        overflow: hidden !important;
    }

    .overflow-visible {
        overflow: visible !important;
    }

    .overflow-scroll {
        overflow: scroll !important;
    }

    .overflow-x-auto {
        overflow-x: auto !important;
    }

    .overflow-x-hidden {
        overflow-x: hidden !important;
    }

    .overflow-x-visible {
        overflow-x: visible !important;
    }

    .overflow-x-scroll {
        overflow-x: scroll !important;
    }

    .overflow-y-auto {
        overflow-y: auto !important;
    }

    .overflow-y-hidden {
        overflow-y: hidden !important;
    }

    .overflow-y-visible {
        overflow-y: visible !important;
    }

    .overflow-y-scroll {
        overflow-y: scroll !important;
    }

    .d-inline {
        display: inline !important;
    }

    .d-inline-block {
        display: inline-block !important;
    }

    .d-block {
        display: block !important;
    }

    .d-grid {
        display: grid !important;
    }

    .d-inline-grid {
        display: inline-grid !important;
    }

    .d-table {
        display: table !important;
    }

    .d-table-row {
        display: table-row !important;
    }

    .d-table-cell {
        display: table-cell !important;
    }

    .d-flex {
        display: flex !important;
    }

    .d-inline-flex {
        display: inline-flex !important;
    }

    .d-none {
        display: none !important;
    }

    .shadow {
        box-shadow: var(--bs-box-shadow) !important;
    }

    .shadow-sm {
        box-shadow: var(--bs-box-shadow-sm) !important;
    }

    .shadow-lg {
        box-shadow: var(--bs-box-shadow-lg) !important;
    }

    .shadow-none {
        box-shadow: none !important;
    }

    .focus-ring-primary {
        --bs-focus-ring-color: rgba(
            var(--bs-primary-rgb),
            var(--bs-focus-ring-opacity)
        );
    }

    .focus-ring-secondary {
        --bs-focus-ring-color: rgba(
            var(--bs-secondary-rgb),
            var(--bs-focus-ring-opacity)
        );
    }

    .focus-ring-success {
        --bs-focus-ring-color: rgba(
            var(--bs-success-rgb),
            var(--bs-focus-ring-opacity)
        );
    }

    .focus-ring-info {
        --bs-focus-ring-color: rgba(
            var(--bs-info-rgb),
            var(--bs-focus-ring-opacity)
        );
    }

    .focus-ring-warning {
        --bs-focus-ring-color: rgba(
            var(--bs-warning-rgb),
            var(--bs-focus-ring-opacity)
        );
    }

    .focus-ring-danger {
        --bs-focus-ring-color: rgba(
            var(--bs-danger-rgb),
            var(--bs-focus-ring-opacity)
        );
    }

    .focus-ring-light {
        --bs-focus-ring-color: rgba(
            var(--bs-light-rgb),
            var(--bs-focus-ring-opacity)
        );
    }

    .focus-ring-dark {
        --bs-focus-ring-color: rgba(
            var(--bs-dark-rgb),
            var(--bs-focus-ring-opacity)
        );
    }

    .position-static {
        position: static !important;
    }

    .position-relative {
        position: relative !important;
    }

    .position-absolute {
        position: absolute !important;
    }

    .position-fixed {
        position: fixed !important;
    }

    .position-sticky {
        position: -webkit-sticky !important;
        position: sticky !important;
    }

    .top-0 {
        top: 0 !important;
    }

    .top-50 {
        top: 50% !important;
    }

    .top-100 {
        top: 100% !important;
    }

    .bottom-0 {
        bottom: 0 !important;
    }

    .bottom-50 {
        bottom: 50% !important;
    }

    .bottom-100 {
        bottom: 100% !important;
    }

    .start-0 {
        left: 0 !important;
    }

    .start-50 {
        left: 50% !important;
    }

    .start-100 {
        left: 100% !important;
    }

    .end-0 {
        right: 0 !important;
    }

    .end-50 {
        right: 50% !important;
    }

    .end-100 {
        right: 100% !important;
    }

    .translate-middle {
        transform: translate(-50%, -50%) !important;
    }

    .translate-middle-x {
        transform: translateX(-50%) !important;
    }

    .translate-middle-y {
        transform: translateY(-50%) !important;
    }

    .border {
        border: var(--bs-border-width) var(--bs-border-style)
            var(--bs-border-color) !important;
    }

    .border-0 {
        border: 0 !important;
    }

    .border-top {
        border-top: var(--bs-border-width) var(--bs-border-style)
            var(--bs-border-color) !important;
    }

    .border-top-0 {
        border-top: 0 !important;
    }

    .border-end {
        border-right: var(--bs-border-width) var(--bs-border-style)
            var(--bs-border-color) !important;
    }

    .border-end-0 {
        border-right: 0 !important;
    }

    .border-bottom {
        border-bottom: var(--bs-border-width) var(--bs-border-style)
            var(--bs-border-color) !important;
    }

    .border-bottom-0 {
        border-bottom: 0 !important;
    }

    .border-start {
        border-left: var(--bs-border-width) var(--bs-border-style)
            var(--bs-border-color) !important;
    }

    .border-start-0 {
        border-left: 0 !important;
    }

    .border-primary {
        --bs-border-opacity: 1;
        border-color: rgba(
            var(--bs-primary-rgb),
            var(--bs-border-opacity)
        ) !important;
    }

    .border-secondary {
        --bs-border-opacity: 1;
        border-color: rgba(
            var(--bs-secondary-rgb),
            var(--bs-border-opacity)
        ) !important;
    }

    .border-success {
        --bs-border-opacity: 1;
        border-color: rgba(
            var(--bs-success-rgb),
            var(--bs-border-opacity)
        ) !important;
    }

    .border-info {
        --bs-border-opacity: 1;
        border-color: rgba(
            var(--bs-info-rgb),
            var(--bs-border-opacity)
        ) !important;
    }

    .border-warning {
        --bs-border-opacity: 1;
        border-color: rgba(
            var(--bs-warning-rgb),
            var(--bs-border-opacity)
        ) !important;
    }

    .border-danger {
        --bs-border-opacity: 1;
        border-color: rgba(
            var(--bs-danger-rgb),
            var(--bs-border-opacity)
        ) !important;
    }

    .border-light {
        --bs-border-opacity: 1;
        border-color: rgba(
            var(--bs-light-rgb),
            var(--bs-border-opacity)
        ) !important;
    }

    .border-dark {
        --bs-border-opacity: 1;
        border-color: rgba(
            var(--bs-dark-rgb),
            var(--bs-border-opacity)
        ) !important;
    }

    .border-black {
        --bs-border-opacity: 1;
        border-color: rgba(
            var(--bs-black-rgb),
            var(--bs-border-opacity)
        ) !important;
    }

    .border-white {
        --bs-border-opacity: 1;
        border-color: rgba(
            var(--bs-white-rgb),
            var(--bs-border-opacity)
        ) !important;
    }

    .border-primary-subtle {
        border-color: var(--bs-primary-border-subtle) !important;
    }

    .border-secondary-subtle {
        border-color: var(--bs-secondary-border-subtle) !important;
    }

    .border-success-subtle {
        border-color: var(--bs-success-border-subtle) !important;
    }

    .border-info-subtle {
        border-color: var(--bs-info-border-subtle) !important;
    }

    .border-warning-subtle {
        border-color: var(--bs-warning-border-subtle) !important;
    }

    .border-danger-subtle {
        border-color: var(--bs-danger-border-subtle) !important;
    }

    .border-light-subtle {
        border-color: var(--bs-light-border-subtle) !important;
    }

    .border-dark-subtle {
        border-color: var(--bs-dark-border-subtle) !important;
    }

    .border-1 {
        border-width: 1px !important;
    }

    .border-2 {
        border-width: 2px !important;
    }

    .border-3 {
        border-width: 3px !important;
    }

    .border-4 {
        border-width: 4px !important;
    }

    .border-5 {
        border-width: 5px !important;
    }

    .border-opacity-10 {
        --bs-border-opacity: 0.1;
    }

    .border-opacity-25 {
        --bs-border-opacity: 0.25;
    }

    .border-opacity-50 {
        --bs-border-opacity: 0.5;
    }

    .border-opacity-75 {
        --bs-border-opacity: 0.75;
    }

    .border-opacity-100 {
        --bs-border-opacity: 1;
    }

    .w-25 {
        width: 25% !important;
    }

    .w-50 {
        width: 50% !important;
    }

    .w-75 {
        width: 75% !important;
    }

    .w-100 {
        width: 100% !important;
    }

    .w-auto {
        width: auto !important;
    }

    .mw-100 {
        max-width: 100% !important;
    }

    .vw-100 {
        width: 100vw !important;
    }

    .min-vw-100 {
        min-width: 100vw !important;
    }

    .h-25 {
        height: 25% !important;
    }

    .h-50 {
        height: 50% !important;
    }

    .h-75 {
        height: 75% !important;
    }

    .h-100 {
        height: 100% !important;
    }

    .h-auto {
        height: auto !important;
    }

    .mh-100 {
        max-height: 100% !important;
    }

    .vh-100 {
        height: 100vh !important;
    }

    .min-vh-100 {
        min-height: 100vh !important;
    }

    .flex-fill {
        flex: 1 1 auto !important;
    }

    .flex-row {
        flex-direction: row !important;
    }

    .flex-column {
        flex-direction: column !important;
    }

    .flex-row-reverse {
        flex-direction: row-reverse !important;
    }

    .flex-column-reverse {
        flex-direction: column-reverse !important;
    }

    .flex-grow-0 {
        flex-grow: 0 !important;
    }

    .flex-grow-1 {
        flex-grow: 1 !important;
    }

    .flex-shrink-0 {
        flex-shrink: 0 !important;
    }

    .flex-shrink-1 {
        flex-shrink: 1 !important;
    }

    .flex-wrap {
        flex-wrap: wrap !important;
    }

    .flex-nowrap {
        flex-wrap: nowrap !important;
    }

    .flex-wrap-reverse {
        flex-wrap: wrap-reverse !important;
    }

    .justify-content-start {
        justify-content: flex-start !important;
    }

    .justify-content-end {
        justify-content: flex-end !important;
    }

    .justify-content-center {
        justify-content: center !important;
    }

    .justify-content-between {
        justify-content: space-between !important;
    }

    .justify-content-around {
        justify-content: space-around !important;
    }

    .justify-content-evenly {
        justify-content: space-evenly !important;
    }

    .align-items-start {
        align-items: flex-start !important;
    }

    .align-items-end {
        align-items: flex-end !important;
    }

    .align-items-center {
        align-items: center !important;
    }

    .align-items-baseline {
        align-items: baseline !important;
    }

    .align-items-stretch {
        align-items: stretch !important;
    }

    .align-content-start {
        align-content: flex-start !important;
    }

    .align-content-end {
        align-content: flex-end !important;
    }

    .align-content-center {
        align-content: center !important;
    }

    .align-content-between {
        align-content: space-between !important;
    }

    .align-content-around {
        align-content: space-around !important;
    }

    .align-content-stretch {
        align-content: stretch !important;
    }

    .align-self-auto {
        align-self: auto !important;
    }

    .align-self-start {
        align-self: flex-start !important;
    }

    .align-self-end {
        align-self: flex-end !important;
    }

    .align-self-center {
        align-self: center !important;
    }

    .align-self-baseline {
        align-self: baseline !important;
    }

    .align-self-stretch {
        align-self: stretch !important;
    }

    .order-first {
        order: -1 !important;
    }

    .order-0 {
        order: 0 !important;
    }

    .order-1 {
        order: 1 !important;
    }

    .order-2 {
        order: 2 !important;
    }

    .order-3 {
        order: 3 !important;
    }

    .order-4 {
        order: 4 !important;
    }

    .order-5 {
        order: 5 !important;
    }

    .order-last {
        order: 6 !important;
    }

    .m-0 {
        margin: 0 !important;
    }

    .m-1 {
        margin: 0.25rem !important;
    }

    .m-2 {
        margin: 0.5rem !important;
    }

    .m-3 {
        margin: 1rem !important;
    }

    .m-4 {
        margin: 1.5rem !important;
    }

    .m-5 {
        margin: 3rem !important;
    }

    .m-auto {
        margin: auto !important;
    }

    .mx-0 {
        margin-right: 0 !important;
        margin-left: 0 !important;
    }

    .mx-1 {
        margin-right: 0.25rem !important;
        margin-left: 0.25rem !important;
    }

    .mx-2 {
        margin-right: 0.5rem !important;
        margin-left: 0.5rem !important;
    }

    .mx-3 {
        margin-right: 1rem !important;
        margin-left: 1rem !important;
    }

    .mx-4 {
        margin-right: 1.5rem !important;
        margin-left: 1.5rem !important;
    }

    .mx-5 {
        margin-right: 3rem !important;
        margin-left: 3rem !important;
    }

    .mx-auto {
        margin-right: auto !important;
        margin-left: auto !important;
    }

    .my-0 {
        margin-top: 0 !important;
        margin-bottom: 0 !important;
    }

    .my-1 {
        margin-top: 0.25rem !important;
        margin-bottom: 0.25rem !important;
    }

    .my-2 {
        margin-top: 0.5rem !important;
        margin-bottom: 0.5rem !important;
    }

    .my-3 {
        margin-top: 1rem !important;
        margin-bottom: 1rem !important;
    }

    .my-4 {
        margin-top: 1.5rem !important;
        margin-bottom: 1.5rem !important;
    }

    .my-5 {
        margin-top: 3rem !important;
        margin-bottom: 3rem !important;
    }

    .my-auto {
        margin-top: auto !important;
        margin-bottom: auto !important;
    }

    .mt-0 {
        margin-top: 0 !important;
    }

    .mt-1 {
        margin-top: 0.25rem !important;
    }

    .mt-2 {
        margin-top: 0.5rem !important;
    }

    .mt-3 {
        margin-top: 1rem !important;
    }

    .mt-4 {
        margin-top: 1.5rem !important;
    }

    .mt-5 {
        margin-top: 3rem !important;
    }

    .mt-auto {
        margin-top: auto !important;
    }

    .me-0 {
        margin-right: 0 !important;
    }

    .me-1 {
        margin-right: 0.25rem !important;
    }

    .me-2 {
        margin-right: 0.5rem !important;
    }

    .me-3 {
        margin-right: 1rem !important;
    }

    .me-4 {
        margin-right: 1.5rem !important;
    }

    .me-5 {
        margin-right: 3rem !important;
    }

    .me-auto {
        margin-right: auto !important;
    }

    .mb-0 {
        margin-bottom: 0 !important;
    }

    .mb-1 {
        margin-bottom: 0.25rem !important;
    }

    .mb-2 {
        margin-bottom: 0.5rem !important;
    }

    .mb-3 {
        margin-bottom: 1rem !important;
    }

    .mb-4 {
        margin-bottom: 1.5rem !important;
    }

    .mb-5 {
        margin-bottom: 3rem !important;
    }

    .mb-auto {
        margin-bottom: auto !important;
    }

    .ms-0 {
        margin-left: 0 !important;
    }

    .ms-1 {
        margin-left: 0.25rem !important;
    }

    .ms-2 {
        margin-left: 0.5rem !important;
    }

    .ms-3 {
        margin-left: 1rem !important;
    }

    .ms-4 {
        margin-left: 1.5rem !important;
    }

    .ms-5 {
        margin-left: 3rem !important;
    }

    .ms-auto {
        margin-left: auto !important;
    }

    .p-0 {
        padding: 0 !important;
    }

    .p-1 {
        padding: 0.25rem !important;
    }

    .p-2 {
        padding: 0.5rem !important;
    }

    .p-3 {
        padding: 1rem !important;
    }

    .p-4 {
        padding: 1.5rem !important;
    }

    .p-5 {
        padding: 3rem !important;
    }

    .px-0 {
        padding-right: 0 !important;
        padding-left: 0 !important;
    }

    .px-1 {
        padding-right: 0.25rem !important;
        padding-left: 0.25rem !important;
    }

    .px-2 {
        padding-right: 0.5rem !important;
        padding-left: 0.5rem !important;
    }

    .px-3 {
        padding-right: 1rem !important;
        padding-left: 1rem !important;
    }

    .px-4 {
        padding-right: 1.5rem !important;
        padding-left: 1.5rem !important;
    }

    .px-5 {
        padding-right: 3rem !important;
        padding-left: 3rem !important;
    }

    .py-0 {
        padding-top: 0 !important;
        padding-bottom: 0 !important;
    }

    .py-1 {
        padding-top: 0.25rem !important;
        padding-bottom: 0.25rem !important;
    }

    .py-2 {
        padding-top: 0.5rem !important;
        padding-bottom: 0.5rem !important;
    }

    .py-3 {
        padding-top: 1rem !important;
        padding-bottom: 1rem !important;
    }

    .py-4 {
        padding-top: 1.5rem !important;
        padding-bottom: 1.5rem !important;
    }

    .py-5 {
        padding-top: 3rem !important;
        padding-bottom: 3rem !important;
    }

    .pt-0 {
        padding-top: 0 !important;
    }

    .pt-1 {
        padding-top: 0.25rem !important;
    }

    .pt-2 {
        padding-top: 0.5rem !important;
    }

    .pt-3 {
        padding-top: 1rem !important;
    }

    .pt-4 {
        padding-top: 1.5rem !important;
    }

    .pt-5 {
        padding-top: 3rem !important;
    }

    .pe-0 {
        padding-right: 0 !important;
    }

    .pe-1 {
        padding-right: 0.25rem !important;
    }

    .pe-2 {
        padding-right: 0.5rem !important;
    }

    .pe-3 {
        padding-right: 1rem !important;
    }

    .pe-4 {
        padding-right: 1.5rem !important;
    }

    .pe-5 {
        padding-right: 3rem !important;
    }

    .pb-0 {
        padding-bottom: 0 !important;
    }

    .pb-1 {
        padding-bottom: 0.25rem !important;
    }

    .pb-2 {
        padding-bottom: 0.5rem !important;
    }

    .pb-3 {
        padding-bottom: 1rem !important;
    }

    .pb-4 {
        padding-bottom: 1.5rem !important;
    }

    .pb-5 {
        padding-bottom: 3rem !important;
    }

    .ps-0 {
        padding-left: 0 !important;
    }

    .ps-1 {
        padding-left: 0.25rem !important;
    }

    .ps-2 {
        padding-left: 0.5rem !important;
    }

    .ps-3 {
        padding-left: 1rem !important;
    }

    .ps-4 {
        padding-left: 1.5rem !important;
    }

    .ps-5 {
        padding-left: 3rem !important;
    }

    .gap-0 {
        gap: 0 !important;
    }

    .gap-1 {
        gap: 0.25rem !important;
    }

    .gap-2 {
        gap: 0.5rem !important;
    }

    .gap-3 {
        gap: 1rem !important;
    }

    .gap-4 {
        gap: 1.5rem !important;
    }

    .gap-5 {
        gap: 3rem !important;
    }

    .row-gap-0 {
        row-gap: 0 !important;
    }

    .row-gap-1 {
        row-gap: 0.25rem !important;
    }

    .row-gap-2 {
        row-gap: 0.5rem !important;
    }

    .row-gap-3 {
        row-gap: 1rem !important;
    }

    .row-gap-4 {
        row-gap: 1.5rem !important;
    }

    .row-gap-5 {
        row-gap: 3rem !important;
    }

    .column-gap-0 {
        -moz-column-gap: 0 !important;
        column-gap: 0 !important;
    }

    .column-gap-1 {
        -moz-column-gap: 0.25rem !important;
        column-gap: 0.25rem !important;
    }

    .column-gap-2 {
        -moz-column-gap: 0.5rem !important;
        column-gap: 0.5rem !important;
    }

    .column-gap-3 {
        -moz-column-gap: 1rem !important;
        column-gap: 1rem !important;
    }

    .column-gap-4 {
        -moz-column-gap: 1.5rem !important;
        column-gap: 1.5rem !important;
    }

    .column-gap-5 {
        -moz-column-gap: 3rem !important;
        column-gap: 3rem !important;
    }

    .font-monospace {
        font-family: var(--bs-font-monospace) !important;
    }

    .fs-1 {
        font-size: calc(1.375rem + 1.5vw) !important;
    }

    .fs-2 {
        font-size: calc(1.325rem + 0.9vw) !important;
    }

    .fs-3 {
        font-size: calc(1.3rem + 0.6vw) !important;
    }

    .fs-4 {
        font-size: calc(1.275rem + 0.3vw) !important;
    }

    .fs-5 {
        font-size: 1.25rem !important;
    }

    .fs-6 {
        font-size: 1rem !important;
    }

    .fst-italic {
        font-style: italic !important;
    }

    .fst-normal {
        font-style: normal !important;
    }

    .fw-lighter {
        font-weight: lighter !important;
    }

    .fw-light {
        font-weight: 300 !important;
    }

    .fw-normal {
        font-weight: 400 !important;
    }

    .fw-medium {
        font-weight: 500 !important;
    }

    .fw-semibold {
        font-weight: 600 !important;
    }

    .fw-bold {
        font-weight: 700 !important;
    }

    .fw-bolder {
        font-weight: bolder !important;
    }

    .lh-1 {
        line-height: 1 !important;
    }

    .lh-sm {
        line-height: 1.25 !important;
    }

    .lh-base {
        line-height: 1.5 !important;
    }

    .lh-lg {
        line-height: 2 !important;
    }

    .text-start {
        text-align: left !important;
    }

    .text-end {
        text-align: right !important;
    }

    .text-center {
        text-align: center !important;
    }

    .text-decoration-none {
        text-decoration: none !important;
    }

    .text-decoration-underline {
        text-decoration: underline !important;
    }

    .text-decoration-line-through {
        text-decoration: line-through !important;
    }

    .text-lowercase {
        text-transform: lowercase !important;
    }

    .text-uppercase {
        text-transform: uppercase !important;
    }

    .text-capitalize {
        text-transform: capitalize !important;
    }

    .text-wrap {
        white-space: normal !important;
    }

    .text-nowrap {
        white-space: nowrap !important;
    }

    /* rtl:begin:remove */
    .text-break {
        word-wrap: break-word !important;
        word-break: break-word !important;
    }

    /* rtl:end:remove */
    .text-primary {
        --bs-text-opacity: 1;
        color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;
    }

    .text-secondary {
        --bs-text-opacity: 1;
        color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;
    }

    .text-success {
        --bs-text-opacity: 1;
        color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;
    }

    .text-info {
        --bs-text-opacity: 1;
        color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;
    }

    .text-warning {
        --bs-text-opacity: 1;
        color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;
    }

    .text-danger {
        --bs-text-opacity: 1;
        color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;
    }

    .text-light {
        --bs-text-opacity: 1;
        color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;
    }

    .text-dark {
        --bs-text-opacity: 1;
        color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;
    }

    .text-black {
        --bs-text-opacity: 1;
        color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;
    }

    .text-white {
        --bs-text-opacity: 1;
        color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
    }

    .text-body {
        --bs-text-opacity: 1;
        color: rgba(
            var(--bs-body-color-rgb),
            var(--bs-text-opacity)
        ) !important;
    }

    .text-muted {
        --bs-text-opacity: 1;
        color: var(--bs-secondary-color) !important;
    }

    .text-black-50 {
        --bs-text-opacity: 1;
        color: rgba(0, 0, 0, 0.5) !important;
    }

    .text-white-50 {
        --bs-text-opacity: 1;
        color: rgba(255, 255, 255, 0.5) !important;
    }

    .text-body-secondary {
        --bs-text-opacity: 1;
        color: var(--bs-secondary-color) !important;
    }

    .text-body-tertiary {
        --bs-text-opacity: 1;
        color: var(--bs-tertiary-color) !important;
    }

    .text-body-emphasis {
        --bs-text-opacity: 1;
        color: var(--bs-emphasis-color) !important;
    }

    .text-reset {
        --bs-text-opacity: 1;
        color: inherit !important;
    }

    .text-opacity-25 {
        --bs-text-opacity: 0.25;
    }

    .text-opacity-50 {
        --bs-text-opacity: 0.5;
    }

    .text-opacity-75 {
        --bs-text-opacity: 0.75;
    }

    .text-opacity-100 {
        --bs-text-opacity: 1;
    }

    .text-primary-emphasis {
        color: var(--bs-primary-text-emphasis) !important;
    }

    .text-secondary-emphasis {
        color: var(--bs-secondary-text-emphasis) !important;
    }

    .text-success-emphasis {
        color: var(--bs-success-text-emphasis) !important;
    }

    .text-info-emphasis {
        color: var(--bs-info-text-emphasis) !important;
    }

    .text-warning-emphasis {
        color: var(--bs-warning-text-emphasis) !important;
    }

    .text-danger-emphasis {
        color: var(--bs-danger-text-emphasis) !important;
    }

    .text-light-emphasis {
        color: var(--bs-light-text-emphasis) !important;
    }

    .text-dark-emphasis {
        color: var(--bs-dark-text-emphasis) !important;
    }

    .link-opacity-10 {
        --bs-link-opacity: 0.1;
    }

    .link-opacity-10-hover:hover {
        --bs-link-opacity: 0.1;
    }

    .link-opacity-25 {
        --bs-link-opacity: 0.25;
    }

    .link-opacity-25-hover:hover {
        --bs-link-opacity: 0.25;
    }

    .link-opacity-50 {
        --bs-link-opacity: 0.5;
    }

    .link-opacity-50-hover:hover {
        --bs-link-opacity: 0.5;
    }

    .link-opacity-75 {
        --bs-link-opacity: 0.75;
    }

    .link-opacity-75-hover:hover {
        --bs-link-opacity: 0.75;
    }

    .link-opacity-100 {
        --bs-link-opacity: 1;
    }

    .link-opacity-100-hover:hover {
        --bs-link-opacity: 1;
    }

    .link-offset-1 {
        text-underline-offset: 0.125em !important;
    }

    .link-offset-1-hover:hover {
        text-underline-offset: 0.125em !important;
    }

    .link-offset-2 {
        text-underline-offset: 0.25em !important;
    }

    .link-offset-2-hover:hover {
        text-underline-offset: 0.25em !important;
    }

    .link-offset-3 {
        text-underline-offset: 0.375em !important;
    }

    .link-offset-3-hover:hover {
        text-underline-offset: 0.375em !important;
    }

    .link-underline-primary {
        --bs-link-underline-opacity: 1;
        -webkit-text-decoration-color: rgba(
            var(--bs-primary-rgb),
            var(--bs-link-underline-opacity)
        ) !important;
        text-decoration-color: rgba(
            var(--bs-primary-rgb),
            var(--bs-link-underline-opacity)
        ) !important;
    }

    .link-underline-secondary {
        --bs-link-underline-opacity: 1;
        -webkit-text-decoration-color: rgba(
            var(--bs-secondary-rgb),
            var(--bs-link-underline-opacity)
        ) !important;
        text-decoration-color: rgba(
            var(--bs-secondary-rgb),
            var(--bs-link-underline-opacity)
        ) !important;
    }

    .link-underline-success {
        --bs-link-underline-opacity: 1;
        -webkit-text-decoration-color: rgba(
            var(--bs-success-rgb),
            var(--bs-link-underline-opacity)
        ) !important;
        text-decoration-color: rgba(
            var(--bs-success-rgb),
            var(--bs-link-underline-opacity)
        ) !important;
    }

    .link-underline-info {
        --bs-link-underline-opacity: 1;
        -webkit-text-decoration-color: rgba(
            var(--bs-info-rgb),
            var(--bs-link-underline-opacity)
        ) !important;
        text-decoration-color: rgba(
            var(--bs-info-rgb),
            var(--bs-link-underline-opacity)
        ) !important;
    }

    .link-underline-warning {
        --bs-link-underline-opacity: 1;
        -webkit-text-decoration-color: rgba(
            var(--bs-warning-rgb),
            var(--bs-link-underline-opacity)
        ) !important;
        text-decoration-color: rgba(
            var(--bs-warning-rgb),
            var(--bs-link-underline-opacity)
        ) !important;
    }

    .link-underline-danger {
        --bs-link-underline-opacity: 1;
        -webkit-text-decoration-color: rgba(
            var(--bs-danger-rgb),
            var(--bs-link-underline-opacity)
        ) !important;
        text-decoration-color: rgba(
            var(--bs-danger-rgb),
            var(--bs-link-underline-opacity)
        ) !important;
    }

    .link-underline-light {
        --bs-link-underline-opacity: 1;
        -webkit-text-decoration-color: rgba(
            var(--bs-light-rgb),
            var(--bs-link-underline-opacity)
        ) !important;
        text-decoration-color: rgba(
            var(--bs-light-rgb),
            var(--bs-link-underline-opacity)
        ) !important;
    }

    .link-underline-dark {
        --bs-link-underline-opacity: 1;
        -webkit-text-decoration-color: rgba(
            var(--bs-dark-rgb),
            var(--bs-link-underline-opacity)
        ) !important;
        text-decoration-color: rgba(
            var(--bs-dark-rgb),
            var(--bs-link-underline-opacity)
        ) !important;
    }

    .link-underline {
        --bs-link-underline-opacity: 1;
        -webkit-text-decoration-color: rgba(
            var(--bs-link-color-rgb),
            var(--bs-link-underline-opacity, 1)
        ) !important;
        text-decoration-color: rgba(
            var(--bs-link-color-rgb),
            var(--bs-link-underline-opacity, 1)
        ) !important;
    }

    .link-underline-opacity-0 {
        --bs-link-underline-opacity: 0;
    }

    .link-underline-opacity-0-hover:hover {
        --bs-link-underline-opacity: 0;
    }

    .link-underline-opacity-10 {
        --bs-link-underline-opacity: 0.1;
    }

    .link-underline-opacity-10-hover:hover {
        --bs-link-underline-opacity: 0.1;
    }

    .link-underline-opacity-25 {
        --bs-link-underline-opacity: 0.25;
    }

    .link-underline-opacity-25-hover:hover {
        --bs-link-underline-opacity: 0.25;
    }

    .link-underline-opacity-50 {
        --bs-link-underline-opacity: 0.5;
    }

    .link-underline-opacity-50-hover:hover {
        --bs-link-underline-opacity: 0.5;
    }

    .link-underline-opacity-75 {
        --bs-link-underline-opacity: 0.75;
    }

    .link-underline-opacity-75-hover:hover {
        --bs-link-underline-opacity: 0.75;
    }

    .link-underline-opacity-100 {
        --bs-link-underline-opacity: 1;
    }

    .link-underline-opacity-100-hover:hover {
        --bs-link-underline-opacity: 1;
    }

    .bg-primary {
        --bs-bg-opacity: 1;
        background-color: rgba(
            var(--bs-primary-rgb),
            var(--bs-bg-opacity)
        ) !important;
    }

    .bg-secondary {
        --bs-bg-opacity: 1;
        background-color: rgba(
            var(--bs-secondary-rgb),
            var(--bs-bg-opacity)
        ) !important;
    }

    .bg-success {
        --bs-bg-opacity: 1;
        background-color: rgba(
            var(--bs-success-rgb),
            var(--bs-bg-opacity)
        ) !important;
    }

    .bg-info {
        --bs-bg-opacity: 1;
        background-color: rgba(
            var(--bs-info-rgb),
            var(--bs-bg-opacity)
        ) !important;
    }

    .bg-warning {
        --bs-bg-opacity: 1;
        background-color: rgba(
            var(--bs-warning-rgb),
            var(--bs-bg-opacity)
        ) !important;
    }

    .bg-danger {
        --bs-bg-opacity: 1;
        background-color: rgba(
            var(--bs-danger-rgb),
            var(--bs-bg-opacity)
        ) !important;
    }

    .bg-light {
        --bs-bg-opacity: 1;
        background-color: rgba(
            var(--bs-light-rgb),
            var(--bs-bg-opacity)
        ) !important;
    }

    .bg-dark {
        --bs-bg-opacity: 1;
        background-color: rgba(
            var(--bs-dark-rgb),
            var(--bs-bg-opacity)
        ) !important;
    }

    .bg-black {
        --bs-bg-opacity: 1;
        background-color: rgba(
            var(--bs-black-rgb),
            var(--bs-bg-opacity)
        ) !important;
    }

    .bg-white {
        --bs-bg-opacity: 1;
        background-color: rgba(
            var(--bs-white-rgb),
            var(--bs-bg-opacity)
        ) !important;
    }

    .bg-body {
        --bs-bg-opacity: 1;
        background-color: rgba(
            var(--bs-body-bg-rgb),
            var(--bs-bg-opacity)
        ) !important;
    }

    .bg-transparent {
        --bs-bg-opacity: 1;
        background-color: transparent !important;
    }

    .bg-body-secondary {
        --bs-bg-opacity: 1;
        background-color: rgba(
            var(--bs-secondary-bg-rgb),
            var(--bs-bg-opacity)
        ) !important;
    }

    .bg-body-tertiary {
        --bs-bg-opacity: 1;
        background-color: rgba(
            var(--bs-tertiary-bg-rgb),
            var(--bs-bg-opacity)
        ) !important;
    }

    .bg-opacity-10 {
        --bs-bg-opacity: 0.1;
    }

    .bg-opacity-25 {
        --bs-bg-opacity: 0.25;
    }

    .bg-opacity-50 {
        --bs-bg-opacity: 0.5;
    }

    .bg-opacity-75 {
        --bs-bg-opacity: 0.75;
    }

    .bg-opacity-100 {
        --bs-bg-opacity: 1;
    }

    .bg-primary-subtle {
        background-color: var(--bs-primary-bg-subtle) !important;
    }

    .bg-secondary-subtle {
        background-color: var(--bs-secondary-bg-subtle) !important;
    }

    .bg-success-subtle {
        background-color: var(--bs-success-bg-subtle) !important;
    }

    .bg-info-subtle {
        background-color: var(--bs-info-bg-subtle) !important;
    }

    .bg-warning-subtle {
        background-color: var(--bs-warning-bg-subtle) !important;
    }

    .bg-danger-subtle {
        background-color: var(--bs-danger-bg-subtle) !important;
    }

    .bg-light-subtle {
        background-color: var(--bs-light-bg-subtle) !important;
    }

    .bg-dark-subtle {
        background-color: var(--bs-dark-bg-subtle) !important;
    }

    .bg-gradient {
        background-image: var(--bs-gradient) !important;
    }

    .user-select-all {
        -webkit-user-select: all !important;
        -moz-user-select: all !important;
        user-select: all !important;
    }

    .user-select-auto {
        -webkit-user-select: auto !important;
        -moz-user-select: auto !important;
        user-select: auto !important;
    }

    .user-select-none {
        -webkit-user-select: none !important;
        -moz-user-select: none !important;
        user-select: none !important;
    }

    .pe-none {
        pointer-events: none !important;
    }

    .pe-auto {
        pointer-events: auto !important;
    }

    .rounded {
        border-radius: var(--bs-border-radius) !important;
    }

    .rounded-0 {
        border-radius: 0 !important;
    }

    .rounded-1 {
        border-radius: var(--bs-border-radius-sm) !important;
    }

    .rounded-2 {
        border-radius: var(--bs-border-radius) !important;
    }

    .rounded-3 {
        border-radius: var(--bs-border-radius-lg) !important;
    }

    .rounded-4 {
        border-radius: var(--bs-border-radius-xl) !important;
    }

    .rounded-5 {
        border-radius: var(--bs-border-radius-xxl) !important;
    }

    .rounded-circle {
        border-radius: 50% !important;
    }

    .rounded-pill {
        border-radius: var(--bs-border-radius-pill) !important;
    }

    .rounded-top {
        border-top-left-radius: var(--bs-border-radius) !important;
        border-top-right-radius: var(--bs-border-radius) !important;
    }

    .rounded-top-0 {
        border-top-left-radius: 0 !important;
        border-top-right-radius: 0 !important;
    }

    .rounded-top-1 {
        border-top-left-radius: var(--bs-border-radius-sm) !important;
        border-top-right-radius: var(--bs-border-radius-sm) !important;
    }

    .rounded-top-2 {
        border-top-left-radius: var(--bs-border-radius) !important;
        border-top-right-radius: var(--bs-border-radius) !important;
    }

    .rounded-top-3 {
        border-top-left-radius: var(--bs-border-radius-lg) !important;
        border-top-right-radius: var(--bs-border-radius-lg) !important;
    }

    .rounded-top-4 {
        border-top-left-radius: var(--bs-border-radius-xl) !important;
        border-top-right-radius: var(--bs-border-radius-xl) !important;
    }

    .rounded-top-5 {
        border-top-left-radius: var(--bs-border-radius-xxl) !important;
        border-top-right-radius: var(--bs-border-radius-xxl) !important;
    }

    .rounded-top-circle {
        border-top-left-radius: 50% !important;
        border-top-right-radius: 50% !important;
    }

    .rounded-top-pill {
        border-top-left-radius: var(--bs-border-radius-pill) !important;
        border-top-right-radius: var(--bs-border-radius-pill) !important;
    }

    .rounded-end {
        border-top-right-radius: var(--bs-border-radius) !important;
        border-bottom-right-radius: var(--bs-border-radius) !important;
    }

    .rounded-end-0 {
        border-top-right-radius: 0 !important;
        border-bottom-right-radius: 0 !important;
    }

    .rounded-end-1 {
        border-top-right-radius: var(--bs-border-radius-sm) !important;
        border-bottom-right-radius: var(--bs-border-radius-sm) !important;
    }

    .rounded-end-2 {
        border-top-right-radius: var(--bs-border-radius) !important;
        border-bottom-right-radius: var(--bs-border-radius) !important;
    }

    .rounded-end-3 {
        border-top-right-radius: var(--bs-border-radius-lg) !important;
        border-bottom-right-radius: var(--bs-border-radius-lg) !important;
    }

    .rounded-end-4 {
        border-top-right-radius: var(--bs-border-radius-xl) !important;
        border-bottom-right-radius: var(--bs-border-radius-xl) !important;
    }

    .rounded-end-5 {
        border-top-right-radius: var(--bs-border-radius-xxl) !important;
        border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
    }

    .rounded-end-circle {
        border-top-right-radius: 50% !important;
        border-bottom-right-radius: 50% !important;
    }

    .rounded-end-pill {
        border-top-right-radius: var(--bs-border-radius-pill) !important;
        border-bottom-right-radius: var(--bs-border-radius-pill) !important;
    }

    .rounded-bottom {
        border-bottom-right-radius: var(--bs-border-radius) !important;
        border-bottom-left-radius: var(--bs-border-radius) !important;
    }

    .rounded-bottom-0 {
        border-bottom-right-radius: 0 !important;
        border-bottom-left-radius: 0 !important;
    }

    .rounded-bottom-1 {
        border-bottom-right-radius: var(--bs-border-radius-sm) !important;
        border-bottom-left-radius: var(--bs-border-radius-sm) !important;
    }

    .rounded-bottom-2 {
        border-bottom-right-radius: var(--bs-border-radius) !important;
        border-bottom-left-radius: var(--bs-border-radius) !important;
    }

    .rounded-bottom-3 {
        border-bottom-right-radius: var(--bs-border-radius-lg) !important;
        border-bottom-left-radius: var(--bs-border-radius-lg) !important;
    }

    .rounded-bottom-4 {
        border-bottom-right-radius: var(--bs-border-radius-xl) !important;
        border-bottom-left-radius: var(--bs-border-radius-xl) !important;
    }

    .rounded-bottom-5 {
        border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
        border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
    }

    .rounded-bottom-circle {
        border-bottom-right-radius: 50% !important;
        border-bottom-left-radius: 50% !important;
    }

    .rounded-bottom-pill {
        border-bottom-right-radius: var(--bs-border-radius-pill) !important;
        border-bottom-left-radius: var(--bs-border-radius-pill) !important;
    }

    .rounded-start {
        border-bottom-left-radius: var(--bs-border-radius) !important;
        border-top-left-radius: var(--bs-border-radius) !important;
    }

    .rounded-start-0 {
        border-bottom-left-radius: 0 !important;
        border-top-left-radius: 0 !important;
    }

    .rounded-start-1 {
        border-bottom-left-radius: var(--bs-border-radius-sm) !important;
        border-top-left-radius: var(--bs-border-radius-sm) !important;
    }

    .rounded-start-2 {
        border-bottom-left-radius: var(--bs-border-radius) !important;
        border-top-left-radius: var(--bs-border-radius) !important;
    }

    .rounded-start-3 {
        border-bottom-left-radius: var(--bs-border-radius-lg) !important;
        border-top-left-radius: var(--bs-border-radius-lg) !important;
    }

    .rounded-start-4 {
        border-bottom-left-radius: var(--bs-border-radius-xl) !important;
        border-top-left-radius: var(--bs-border-radius-xl) !important;
    }

    .rounded-start-5 {
        border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
        border-top-left-radius: var(--bs-border-radius-xxl) !important;
    }

    .rounded-start-circle {
        border-bottom-left-radius: 50% !important;
        border-top-left-radius: 50% !important;
    }

    .rounded-start-pill {
        border-bottom-left-radius: var(--bs-border-radius-pill) !important;
        border-top-left-radius: var(--bs-border-radius-pill) !important;
    }

    .visible {
        visibility: visible !important;
    }

    .invisible {
        visibility: hidden !important;
    }

    .z-n1 {
        z-index: -1 !important;
    }

    .z-0 {
        z-index: 0 !important;
    }

    .z-1 {
        z-index: 1 !important;
    }

    .z-2 {
        z-index: 2 !important;
    }

    .z-3 {
        z-index: 3 !important;
    }

    @media (min-width: 576px) {
        .float-sm-start {
            float: left !important;
        }
        .float-sm-end {
            float: right !important;
        }
        .float-sm-none {
            float: none !important;
        }
        .object-fit-sm-contain {
            -o-object-fit: contain !important;
            object-fit: contain !important;
        }
        .object-fit-sm-cover {
            -o-object-fit: cover !important;
            object-fit: cover !important;
        }
        .object-fit-sm-fill {
            -o-object-fit: fill !important;
            object-fit: fill !important;
        }
        .object-fit-sm-scale {
            -o-object-fit: scale-down !important;
            object-fit: scale-down !important;
        }
        .object-fit-sm-none {
            -o-object-fit: none !important;
            object-fit: none !important;
        }
        .d-sm-inline {
            display: inline !important;
        }
        .d-sm-inline-block {
            display: inline-block !important;
        }
        .d-sm-block {
            display: block !important;
        }
        .d-sm-grid {
            display: grid !important;
        }
        .d-sm-inline-grid {
            display: inline-grid !important;
        }
        .d-sm-table {
            display: table !important;
        }
        .d-sm-table-row {
            display: table-row !important;
        }
        .d-sm-table-cell {
            display: table-cell !important;
        }
        .d-sm-flex {
            display: flex !important;
        }
        .d-sm-inline-flex {
            display: inline-flex !important;
        }
        .d-sm-none {
            display: none !important;
        }
        .flex-sm-fill {
            flex: 1 1 auto !important;
        }
        .flex-sm-row {
            flex-direction: row !important;
        }
        .flex-sm-column {
            flex-direction: column !important;
        }
        .flex-sm-row-reverse {
            flex-direction: row-reverse !important;
        }
        .flex-sm-column-reverse {
            flex-direction: column-reverse !important;
        }
        .flex-sm-grow-0 {
            flex-grow: 0 !important;
        }
        .flex-sm-grow-1 {
            flex-grow: 1 !important;
        }
        .flex-sm-shrink-0 {
            flex-shrink: 0 !important;
        }
        .flex-sm-shrink-1 {
            flex-shrink: 1 !important;
        }
        .flex-sm-wrap {
            flex-wrap: wrap !important;
        }
        .flex-sm-nowrap {
            flex-wrap: nowrap !important;
        }
        .flex-sm-wrap-reverse {
            flex-wrap: wrap-reverse !important;
        }
        .justify-content-sm-start {
            justify-content: flex-start !important;
        }
        .justify-content-sm-end {
            justify-content: flex-end !important;
        }
        .justify-content-sm-center {
            justify-content: center !important;
        }
        .justify-content-sm-between {
            justify-content: space-between !important;
        }
        .justify-content-sm-around {
            justify-content: space-around !important;
        }
        .justify-content-sm-evenly {
            justify-content: space-evenly !important;
        }
        .align-items-sm-start {
            align-items: flex-start !important;
        }
        .align-items-sm-end {
            align-items: flex-end !important;
        }
        .align-items-sm-center {
            align-items: center !important;
        }
        .align-items-sm-baseline {
            align-items: baseline !important;
        }
        .align-items-sm-stretch {
            align-items: stretch !important;
        }
        .align-content-sm-start {
            align-content: flex-start !important;
        }
        .align-content-sm-end {
            align-content: flex-end !important;
        }
        .align-content-sm-center {
            align-content: center !important;
        }
        .align-content-sm-between {
            align-content: space-between !important;
        }
        .align-content-sm-around {
            align-content: space-around !important;
        }
        .align-content-sm-stretch {
            align-content: stretch !important;
        }
        .align-self-sm-auto {
            align-self: auto !important;
        }
        .align-self-sm-start {
            align-self: flex-start !important;
        }
        .align-self-sm-end {
            align-self: flex-end !important;
        }
        .align-self-sm-center {
            align-self: center !important;
        }
        .align-self-sm-baseline {
            align-self: baseline !important;
        }
        .align-self-sm-stretch {
            align-self: stretch !important;
        }
        .order-sm-first {
            order: -1 !important;
        }
        .order-sm-0 {
            order: 0 !important;
        }
        .order-sm-1 {
            order: 1 !important;
        }
        .order-sm-2 {
            order: 2 !important;
        }
        .order-sm-3 {
            order: 3 !important;
        }
        .order-sm-4 {
            order: 4 !important;
        }
        .order-sm-5 {
            order: 5 !important;
        }
        .order-sm-last {
            order: 6 !important;
        }
        .m-sm-0 {
            margin: 0 !important;
        }
        .m-sm-1 {
            margin: 0.25rem !important;
        }
        .m-sm-2 {
            margin: 0.5rem !important;
        }
        .m-sm-3 {
            margin: 1rem !important;
        }
        .m-sm-4 {
            margin: 1.5rem !important;
        }
        .m-sm-5 {
            margin: 3rem !important;
        }
        .m-sm-auto {
            margin: auto !important;
        }
        .mx-sm-0 {
            margin-right: 0 !important;
            margin-left: 0 !important;
        }
        .mx-sm-1 {
            margin-right: 0.25rem !important;
            margin-left: 0.25rem !important;
        }
        .mx-sm-2 {
            margin-right: 0.5rem !important;
            margin-left: 0.5rem !important;
        }
        .mx-sm-3 {
            margin-right: 1rem !important;
            margin-left: 1rem !important;
        }
        .mx-sm-4 {
            margin-right: 1.5rem !important;
            margin-left: 1.5rem !important;
        }
        .mx-sm-5 {
            margin-right: 3rem !important;
            margin-left: 3rem !important;
        }
        .mx-sm-auto {
            margin-right: auto !important;
            margin-left: auto !important;
        }
        .my-sm-0 {
            margin-top: 0 !important;
            margin-bottom: 0 !important;
        }
        .my-sm-1 {
            margin-top: 0.25rem !important;
            margin-bottom: 0.25rem !important;
        }
        .my-sm-2 {
            margin-top: 0.5rem !important;
            margin-bottom: 0.5rem !important;
        }
        .my-sm-3 {
            margin-top: 1rem !important;
            margin-bottom: 1rem !important;
        }
        .my-sm-4 {
            margin-top: 1.5rem !important;
            margin-bottom: 1.5rem !important;
        }
        .my-sm-5 {
            margin-top: 3rem !important;
            margin-bottom: 3rem !important;
        }
        .my-sm-auto {
            margin-top: auto !important;
            margin-bottom: auto !important;
        }
        .mt-sm-0 {
            margin-top: 0 !important;
        }
        .mt-sm-1 {
            margin-top: 0.25rem !important;
        }
        .mt-sm-2 {
            margin-top: 0.5rem !important;
        }
        .mt-sm-3 {
            margin-top: 1rem !important;
        }
        .mt-sm-4 {
            margin-top: 1.5rem !important;
        }
        .mt-sm-5 {
            margin-top: 3rem !important;
        }
        .mt-sm-auto {
            margin-top: auto !important;
        }
        .me-sm-0 {
            margin-right: 0 !important;
        }
        .me-sm-1 {
            margin-right: 0.25rem !important;
        }
        .me-sm-2 {
            margin-right: 0.5rem !important;
        }
        .me-sm-3 {
            margin-right: 1rem !important;
        }
        .me-sm-4 {
            margin-right: 1.5rem !important;
        }
        .me-sm-5 {
            margin-right: 3rem !important;
        }
        .me-sm-auto {
            margin-right: auto !important;
        }
        .mb-sm-0 {
            margin-bottom: 0 !important;
        }
        .mb-sm-1 {
            margin-bottom: 0.25rem !important;
        }
        .mb-sm-2 {
            margin-bottom: 0.5rem !important;
        }
        .mb-sm-3 {
            margin-bottom: 1rem !important;
        }
        .mb-sm-4 {
            margin-bottom: 1.5rem !important;
        }
        .mb-sm-5 {
            margin-bottom: 3rem !important;
        }
        .mb-sm-auto {
            margin-bottom: auto !important;
        }
        .ms-sm-0 {
            margin-left: 0 !important;
        }
        .ms-sm-1 {
            margin-left: 0.25rem !important;
        }
        .ms-sm-2 {
            margin-left: 0.5rem !important;
        }
        .ms-sm-3 {
            margin-left: 1rem !important;
        }
        .ms-sm-4 {
            margin-left: 1.5rem !important;
        }
        .ms-sm-5 {
            margin-left: 3rem !important;
        }
        .ms-sm-auto {
            margin-left: auto !important;
        }
        .p-sm-0 {
            padding: 0 !important;
        }
        .p-sm-1 {
            padding: 0.25rem !important;
        }
        .p-sm-2 {
            padding: 0.5rem !important;
        }
        .p-sm-3 {
            padding: 1rem !important;
        }
        .p-sm-4 {
            padding: 1.5rem !important;
        }
        .p-sm-5 {
            padding: 3rem !important;
        }
        .px-sm-0 {
            padding-right: 0 !important;
            padding-left: 0 !important;
        }
        .px-sm-1 {
            padding-right: 0.25rem !important;
            padding-left: 0.25rem !important;
        }
        .px-sm-2 {
            padding-right: 0.5rem !important;
            padding-left: 0.5rem !important;
        }
        .px-sm-3 {
            padding-right: 1rem !important;
            padding-left: 1rem !important;
        }
        .px-sm-4 {
            padding-right: 1.5rem !important;
            padding-left: 1.5rem !important;
        }
        .px-sm-5 {
            padding-right: 3rem !important;
            padding-left: 3rem !important;
        }
        .py-sm-0 {
            padding-top: 0 !important;
            padding-bottom: 0 !important;
        }
        .py-sm-1 {
            padding-top: 0.25rem !important;
            padding-bottom: 0.25rem !important;
        }
        .py-sm-2 {
            padding-top: 0.5rem !important;
            padding-bottom: 0.5rem !important;
        }
        .py-sm-3 {
            padding-top: 1rem !important;
            padding-bottom: 1rem !important;
        }
        .py-sm-4 {
            padding-top: 1.5rem !important;
            padding-bottom: 1.5rem !important;
        }
        .py-sm-5 {
            padding-top: 3rem !important;
            padding-bottom: 3rem !important;
        }
        .pt-sm-0 {
            padding-top: 0 !important;
        }
        .pt-sm-1 {
            padding-top: 0.25rem !important;
        }
        .pt-sm-2 {
            padding-top: 0.5rem !important;
        }
        .pt-sm-3 {
            padding-top: 1rem !important;
        }
        .pt-sm-4 {
            padding-top: 1.5rem !important;
        }
        .pt-sm-5 {
            padding-top: 3rem !important;
        }
        .pe-sm-0 {
            padding-right: 0 !important;
        }
        .pe-sm-1 {
            padding-right: 0.25rem !important;
        }
        .pe-sm-2 {
            padding-right: 0.5rem !important;
        }
        .pe-sm-3 {
            padding-right: 1rem !important;
        }
        .pe-sm-4 {
            padding-right: 1.5rem !important;
        }
        .pe-sm-5 {
            padding-right: 3rem !important;
        }
        .pb-sm-0 {
            padding-bottom: 0 !important;
        }
        .pb-sm-1 {
            padding-bottom: 0.25rem !important;
        }
        .pb-sm-2 {
            padding-bottom: 0.5rem !important;
        }
        .pb-sm-3 {
            padding-bottom: 1rem !important;
        }
        .pb-sm-4 {
            padding-bottom: 1.5rem !important;
        }
        .pb-sm-5 {
            padding-bottom: 3rem !important;
        }
        .ps-sm-0 {
            padding-left: 0 !important;
        }
        .ps-sm-1 {
            padding-left: 0.25rem !important;
        }
        .ps-sm-2 {
            padding-left: 0.5rem !important;
        }
        .ps-sm-3 {
            padding-left: 1rem !important;
        }
        .ps-sm-4 {
            padding-left: 1.5rem !important;
        }
        .ps-sm-5 {
            padding-left: 3rem !important;
        }
        .gap-sm-0 {
            gap: 0 !important;
        }
        .gap-sm-1 {
            gap: 0.25rem !important;
        }
        .gap-sm-2 {
            gap: 0.5rem !important;
        }
        .gap-sm-3 {
            gap: 1rem !important;
        }
        .gap-sm-4 {
            gap: 1.5rem !important;
        }
        .gap-sm-5 {
            gap: 3rem !important;
        }
        .row-gap-sm-0 {
            row-gap: 0 !important;
        }
        .row-gap-sm-1 {
            row-gap: 0.25rem !important;
        }
        .row-gap-sm-2 {
            row-gap: 0.5rem !important;
        }
        .row-gap-sm-3 {
            row-gap: 1rem !important;
        }
        .row-gap-sm-4 {
            row-gap: 1.5rem !important;
        }
        .row-gap-sm-5 {
            row-gap: 3rem !important;
        }
        .column-gap-sm-0 {
            -moz-column-gap: 0 !important;
            column-gap: 0 !important;
        }
        .column-gap-sm-1 {
            -moz-column-gap: 0.25rem !important;
            column-gap: 0.25rem !important;
        }
        .column-gap-sm-2 {
            -moz-column-gap: 0.5rem !important;
            column-gap: 0.5rem !important;
        }
        .column-gap-sm-3 {
            -moz-column-gap: 1rem !important;
            column-gap: 1rem !important;
        }
        .column-gap-sm-4 {
            -moz-column-gap: 1.5rem !important;
            column-gap: 1.5rem !important;
        }
        .column-gap-sm-5 {
            -moz-column-gap: 3rem !important;
            column-gap: 3rem !important;
        }
        .text-sm-start {
            text-align: left !important;
        }
        .text-sm-end {
            text-align: right !important;
        }
        .text-sm-center {
            text-align: center !important;
        }
    }
    @media (min-width: 768px) {
        .float-md-start {
            float: left !important;
        }
        .float-md-end {
            float: right !important;
        }
        .float-md-none {
            float: none !important;
        }
        .object-fit-md-contain {
            -o-object-fit: contain !important;
            object-fit: contain !important;
        }
        .object-fit-md-cover {
            -o-object-fit: cover !important;
            object-fit: cover !important;
        }
        .object-fit-md-fill {
            -o-object-fit: fill !important;
            object-fit: fill !important;
        }
        .object-fit-md-scale {
            -o-object-fit: scale-down !important;
            object-fit: scale-down !important;
        }
        .object-fit-md-none {
            -o-object-fit: none !important;
            object-fit: none !important;
        }
        .d-md-inline {
            display: inline !important;
        }
        .d-md-inline-block {
            display: inline-block !important;
        }
        .d-md-block {
            display: block !important;
        }
        .d-md-grid {
            display: grid !important;
        }
        .d-md-inline-grid {
            display: inline-grid !important;
        }
        .d-md-table {
            display: table !important;
        }
        .d-md-table-row {
            display: table-row !important;
        }
        .d-md-table-cell {
            display: table-cell !important;
        }
        .d-md-flex {
            display: flex !important;
        }
        .d-md-inline-flex {
            display: inline-flex !important;
        }
        .d-md-none {
            display: none !important;
        }
        .flex-md-fill {
            flex: 1 1 auto !important;
        }
        .flex-md-row {
            flex-direction: row !important;
        }
        .flex-md-column {
            flex-direction: column !important;
        }
        .flex-md-row-reverse {
            flex-direction: row-reverse !important;
        }
        .flex-md-column-reverse {
            flex-direction: column-reverse !important;
        }
        .flex-md-grow-0 {
            flex-grow: 0 !important;
        }
        .flex-md-grow-1 {
            flex-grow: 1 !important;
        }
        .flex-md-shrink-0 {
            flex-shrink: 0 !important;
        }
        .flex-md-shrink-1 {
            flex-shrink: 1 !important;
        }
        .flex-md-wrap {
            flex-wrap: wrap !important;
        }
        .flex-md-nowrap {
            flex-wrap: nowrap !important;
        }
        .flex-md-wrap-reverse {
            flex-wrap: wrap-reverse !important;
        }
        .justify-content-md-start {
            justify-content: flex-start !important;
        }
        .justify-content-md-end {
            justify-content: flex-end !important;
        }
        .justify-content-md-center {
            justify-content: center !important;
        }
        .justify-content-md-between {
            justify-content: space-between !important;
        }
        .justify-content-md-around {
            justify-content: space-around !important;
        }
        .justify-content-md-evenly {
            justify-content: space-evenly !important;
        }
        .align-items-md-start {
            align-items: flex-start !important;
        }
        .align-items-md-end {
            align-items: flex-end !important;
        }
        .align-items-md-center {
            align-items: center !important;
        }
        .align-items-md-baseline {
            align-items: baseline !important;
        }
        .align-items-md-stretch {
            align-items: stretch !important;
        }
        .align-content-md-start {
            align-content: flex-start !important;
        }
        .align-content-md-end {
            align-content: flex-end !important;
        }
        .align-content-md-center {
            align-content: center !important;
        }
        .align-content-md-between {
            align-content: space-between !important;
        }
        .align-content-md-around {
            align-content: space-around !important;
        }
        .align-content-md-stretch {
            align-content: stretch !important;
        }
        .align-self-md-auto {
            align-self: auto !important;
        }
        .align-self-md-start {
            align-self: flex-start !important;
        }
        .align-self-md-end {
            align-self: flex-end !important;
        }
        .align-self-md-center {
            align-self: center !important;
        }
        .align-self-md-baseline {
            align-self: baseline !important;
        }
        .align-self-md-stretch {
            align-self: stretch !important;
        }
        .order-md-first {
            order: -1 !important;
        }
        .order-md-0 {
            order: 0 !important;
        }
        .order-md-1 {
            order: 1 !important;
        }
        .order-md-2 {
            order: 2 !important;
        }
        .order-md-3 {
            order: 3 !important;
        }
        .order-md-4 {
            order: 4 !important;
        }
        .order-md-5 {
            order: 5 !important;
        }
        .order-md-last {
            order: 6 !important;
        }
        .m-md-0 {
            margin: 0 !important;
        }
        .m-md-1 {
            margin: 0.25rem !important;
        }
        .m-md-2 {
            margin: 0.5rem !important;
        }
        .m-md-3 {
            margin: 1rem !important;
        }
        .m-md-4 {
            margin: 1.5rem !important;
        }
        .m-md-5 {
            margin: 3rem !important;
        }
        .m-md-auto {
            margin: auto !important;
        }
        .mx-md-0 {
            margin-right: 0 !important;
            margin-left: 0 !important;
        }
        .mx-md-1 {
            margin-right: 0.25rem !important;
            margin-left: 0.25rem !important;
        }
        .mx-md-2 {
            margin-right: 0.5rem !important;
            margin-left: 0.5rem !important;
        }
        .mx-md-3 {
            margin-right: 1rem !important;
            margin-left: 1rem !important;
        }
        .mx-md-4 {
            margin-right: 1.5rem !important;
            margin-left: 1.5rem !important;
        }
        .mx-md-5 {
            margin-right: 3rem !important;
            margin-left: 3rem !important;
        }
        .mx-md-auto {
            margin-right: auto !important;
            margin-left: auto !important;
        }
        .my-md-0 {
            margin-top: 0 !important;
            margin-bottom: 0 !important;
        }
        .my-md-1 {
            margin-top: 0.25rem !important;
            margin-bottom: 0.25rem !important;
        }
        .my-md-2 {
            margin-top: 0.5rem !important;
            margin-bottom: 0.5rem !important;
        }
        .my-md-3 {
            margin-top: 1rem !important;
            margin-bottom: 1rem !important;
        }
        .my-md-4 {
            margin-top: 1.5rem !important;
            margin-bottom: 1.5rem !important;
        }
        .my-md-5 {
            margin-top: 3rem !important;
            margin-bottom: 3rem !important;
        }
        .my-md-auto {
            margin-top: auto !important;
            margin-bottom: auto !important;
        }
        .mt-md-0 {
            margin-top: 0 !important;
        }
        .mt-md-1 {
            margin-top: 0.25rem !important;
        }
        .mt-md-2 {
            margin-top: 0.5rem !important;
        }
        .mt-md-3 {
            margin-top: 1rem !important;
        }
        .mt-md-4 {
            margin-top: 1.5rem !important;
        }
        .mt-md-5 {
            margin-top: 3rem !important;
        }
        .mt-md-auto {
            margin-top: auto !important;
        }
        .me-md-0 {
            margin-right: 0 !important;
        }
        .me-md-1 {
            margin-right: 0.25rem !important;
        }
        .me-md-2 {
            margin-right: 0.5rem !important;
        }
        .me-md-3 {
            margin-right: 1rem !important;
        }
        .me-md-4 {
            margin-right: 1.5rem !important;
        }
        .me-md-5 {
            margin-right: 3rem !important;
        }
        .me-md-auto {
            margin-right: auto !important;
        }
        .mb-md-0 {
            margin-bottom: 0 !important;
        }
        .mb-md-1 {
            margin-bottom: 0.25rem !important;
        }
        .mb-md-2 {
            margin-bottom: 0.5rem !important;
        }
        .mb-md-3 {
            margin-bottom: 1rem !important;
        }
        .mb-md-4 {
            margin-bottom: 1.5rem !important;
        }
        .mb-md-5 {
            margin-bottom: 3rem !important;
        }
        .mb-md-auto {
            margin-bottom: auto !important;
        }
        .ms-md-0 {
            margin-left: 0 !important;
        }
        .ms-md-1 {
            margin-left: 0.25rem !important;
        }
        .ms-md-2 {
            margin-left: 0.5rem !important;
        }
        .ms-md-3 {
            margin-left: 1rem !important;
        }
        .ms-md-4 {
            margin-left: 1.5rem !important;
        }
        .ms-md-5 {
            margin-left: 3rem !important;
        }
        .ms-md-auto {
            margin-left: auto !important;
        }
        .p-md-0 {
            padding: 0 !important;
        }
        .p-md-1 {
            padding: 0.25rem !important;
        }
        .p-md-2 {
            padding: 0.5rem !important;
        }
        .p-md-3 {
            padding: 1rem !important;
        }
        .p-md-4 {
            padding: 1.5rem !important;
        }
        .p-md-5 {
            padding: 3rem !important;
        }
        .px-md-0 {
            padding-right: 0 !important;
            padding-left: 0 !important;
        }
        .px-md-1 {
            padding-right: 0.25rem !important;
            padding-left: 0.25rem !important;
        }
        .px-md-2 {
            padding-right: 0.5rem !important;
            padding-left: 0.5rem !important;
        }
        .px-md-3 {
            padding-right: 1rem !important;
            padding-left: 1rem !important;
        }
        .px-md-4 {
            padding-right: 1.5rem !important;
            padding-left: 1.5rem !important;
        }
        .px-md-5 {
            padding-right: 3rem !important;
            padding-left: 3rem !important;
        }
        .py-md-0 {
            padding-top: 0 !important;
            padding-bottom: 0 !important;
        }
        .py-md-1 {
            padding-top: 0.25rem !important;
            padding-bottom: 0.25rem !important;
        }
        .py-md-2 {
            padding-top: 0.5rem !important;
            padding-bottom: 0.5rem !important;
        }
        .py-md-3 {
            padding-top: 1rem !important;
            padding-bottom: 1rem !important;
        }
        .py-md-4 {
            padding-top: 1.5rem !important;
            padding-bottom: 1.5rem !important;
        }
        .py-md-5 {
            padding-top: 3rem !important;
            padding-bottom: 3rem !important;
        }
        .pt-md-0 {
            padding-top: 0 !important;
        }
        .pt-md-1 {
            padding-top: 0.25rem !important;
        }
        .pt-md-2 {
            padding-top: 0.5rem !important;
        }
        .pt-md-3 {
            padding-top: 1rem !important;
        }
        .pt-md-4 {
            padding-top: 1.5rem !important;
        }
        .pt-md-5 {
            padding-top: 3rem !important;
        }
        .pe-md-0 {
            padding-right: 0 !important;
        }
        .pe-md-1 {
            padding-right: 0.25rem !important;
        }
        .pe-md-2 {
            padding-right: 0.5rem !important;
        }
        .pe-md-3 {
            padding-right: 1rem !important;
        }
        .pe-md-4 {
            padding-right: 1.5rem !important;
        }
        .pe-md-5 {
            padding-right: 3rem !important;
        }
        .pb-md-0 {
            padding-bottom: 0 !important;
        }
        .pb-md-1 {
            padding-bottom: 0.25rem !important;
        }
        .pb-md-2 {
            padding-bottom: 0.5rem !important;
        }
        .pb-md-3 {
            padding-bottom: 1rem !important;
        }
        .pb-md-4 {
            padding-bottom: 1.5rem !important;
        }
        .pb-md-5 {
            padding-bottom: 3rem !important;
        }
        .ps-md-0 {
            padding-left: 0 !important;
        }
        .ps-md-1 {
            padding-left: 0.25rem !important;
        }
        .ps-md-2 {
            padding-left: 0.5rem !important;
        }
        .ps-md-3 {
            padding-left: 1rem !important;
        }
        .ps-md-4 {
            padding-left: 1.5rem !important;
        }
        .ps-md-5 {
            padding-left: 3rem !important;
        }
        .gap-md-0 {
            gap: 0 !important;
        }
        .gap-md-1 {
            gap: 0.25rem !important;
        }
        .gap-md-2 {
            gap: 0.5rem !important;
        }
        .gap-md-3 {
            gap: 1rem !important;
        }
        .gap-md-4 {
            gap: 1.5rem !important;
        }
        .gap-md-5 {
            gap: 3rem !important;
        }
        .row-gap-md-0 {
            row-gap: 0 !important;
        }
        .row-gap-md-1 {
            row-gap: 0.25rem !important;
        }
        .row-gap-md-2 {
            row-gap: 0.5rem !important;
        }
        .row-gap-md-3 {
            row-gap: 1rem !important;
        }
        .row-gap-md-4 {
            row-gap: 1.5rem !important;
        }
        .row-gap-md-5 {
            row-gap: 3rem !important;
        }
        .column-gap-md-0 {
            -moz-column-gap: 0 !important;
            column-gap: 0 !important;
        }
        .column-gap-md-1 {
            -moz-column-gap: 0.25rem !important;
            column-gap: 0.25rem !important;
        }
        .column-gap-md-2 {
            -moz-column-gap: 0.5rem !important;
            column-gap: 0.5rem !important;
        }
        .column-gap-md-3 {
            -moz-column-gap: 1rem !important;
            column-gap: 1rem !important;
        }
        .column-gap-md-4 {
            -moz-column-gap: 1.5rem !important;
            column-gap: 1.5rem !important;
        }
        .column-gap-md-5 {
            -moz-column-gap: 3rem !important;
            column-gap: 3rem !important;
        }
        .text-md-start {
            text-align: left !important;
        }
        .text-md-end {
            text-align: right !important;
        }
        .text-md-center {
            text-align: center !important;
        }
    }
    @media (min-width: 992px) {
        .float-lg-start {
            float: left !important;
        }
        .float-lg-end {
            float: right !important;
        }
        .float-lg-none {
            float: none !important;
        }
        .object-fit-lg-contain {
            -o-object-fit: contain !important;
            object-fit: contain !important;
        }
        .object-fit-lg-cover {
            -o-object-fit: cover !important;
            object-fit: cover !important;
        }
        .object-fit-lg-fill {
            -o-object-fit: fill !important;
            object-fit: fill !important;
        }
        .object-fit-lg-scale {
            -o-object-fit: scale-down !important;
            object-fit: scale-down !important;
        }
        .object-fit-lg-none {
            -o-object-fit: none !important;
            object-fit: none !important;
        }
        .d-lg-inline {
            display: inline !important;
        }
        .d-lg-inline-block {
            display: inline-block !important;
        }
        .d-lg-block {
            display: block !important;
        }
        .d-lg-grid {
            display: grid !important;
        }
        .d-lg-inline-grid {
            display: inline-grid !important;
        }
        .d-lg-table {
            display: table !important;
        }
        .d-lg-table-row {
            display: table-row !important;
        }
        .d-lg-table-cell {
            display: table-cell !important;
        }
        .d-lg-flex {
            display: flex !important;
        }
        .d-lg-inline-flex {
            display: inline-flex !important;
        }
        .d-lg-none {
            display: none !important;
        }
        .flex-lg-fill {
            flex: 1 1 auto !important;
        }
        .flex-lg-row {
            flex-direction: row !important;
        }
        .flex-lg-column {
            flex-direction: column !important;
        }
        .flex-lg-row-reverse {
            flex-direction: row-reverse !important;
        }
        .flex-lg-column-reverse {
            flex-direction: column-reverse !important;
        }
        .flex-lg-grow-0 {
            flex-grow: 0 !important;
        }
        .flex-lg-grow-1 {
            flex-grow: 1 !important;
        }
        .flex-lg-shrink-0 {
            flex-shrink: 0 !important;
        }
        .flex-lg-shrink-1 {
            flex-shrink: 1 !important;
        }
        .flex-lg-wrap {
            flex-wrap: wrap !important;
        }
        .flex-lg-nowrap {
            flex-wrap: nowrap !important;
        }
        .flex-lg-wrap-reverse {
            flex-wrap: wrap-reverse !important;
        }
        .justify-content-lg-start {
            justify-content: flex-start !important;
        }
        .justify-content-lg-end {
            justify-content: flex-end !important;
        }
        .justify-content-lg-center {
            justify-content: center !important;
        }
        .justify-content-lg-between {
            justify-content: space-between !important;
        }
        .justify-content-lg-around {
            justify-content: space-around !important;
        }
        .justify-content-lg-evenly {
            justify-content: space-evenly !important;
        }
        .align-items-lg-start {
            align-items: flex-start !important;
        }
        .align-items-lg-end {
            align-items: flex-end !important;
        }
        .align-items-lg-center {
            align-items: center !important;
        }
        .align-items-lg-baseline {
            align-items: baseline !important;
        }
        .align-items-lg-stretch {
            align-items: stretch !important;
        }
        .align-content-lg-start {
            align-content: flex-start !important;
        }
        .align-content-lg-end {
            align-content: flex-end !important;
        }
        .align-content-lg-center {
            align-content: center !important;
        }
        .align-content-lg-between {
            align-content: space-between !important;
        }
        .align-content-lg-around {
            align-content: space-around !important;
        }
        .align-content-lg-stretch {
            align-content: stretch !important;
        }
        .align-self-lg-auto {
            align-self: auto !important;
        }
        .align-self-lg-start {
            align-self: flex-start !important;
        }
        .align-self-lg-end {
            align-self: flex-end !important;
        }
        .align-self-lg-center {
            align-self: center !important;
        }
        .align-self-lg-baseline {
            align-self: baseline !important;
        }
        .align-self-lg-stretch {
            align-self: stretch !important;
        }
        .order-lg-first {
            order: -1 !important;
        }
        .order-lg-0 {
            order: 0 !important;
        }
        .order-lg-1 {
            order: 1 !important;
        }
        .order-lg-2 {
            order: 2 !important;
        }
        .order-lg-3 {
            order: 3 !important;
        }
        .order-lg-4 {
            order: 4 !important;
        }
        .order-lg-5 {
            order: 5 !important;
        }
        .order-lg-last {
            order: 6 !important;
        }
        .m-lg-0 {
            margin: 0 !important;
        }
        .m-lg-1 {
            margin: 0.25rem !important;
        }
        .m-lg-2 {
            margin: 0.5rem !important;
        }
        .m-lg-3 {
            margin: 1rem !important;
        }
        .m-lg-4 {
            margin: 1.5rem !important;
        }
        .m-lg-5 {
            margin: 3rem !important;
        }
        .m-lg-auto {
            margin: auto !important;
        }
        .mx-lg-0 {
            margin-right: 0 !important;
            margin-left: 0 !important;
        }
        .mx-lg-1 {
            margin-right: 0.25rem !important;
            margin-left: 0.25rem !important;
        }
        .mx-lg-2 {
            margin-right: 0.5rem !important;
            margin-left: 0.5rem !important;
        }
        .mx-lg-3 {
            margin-right: 1rem !important;
            margin-left: 1rem !important;
        }
        .mx-lg-4 {
            margin-right: 1.5rem !important;
            margin-left: 1.5rem !important;
        }
        .mx-lg-5 {
            margin-right: 3rem !important;
            margin-left: 3rem !important;
        }
        .mx-lg-auto {
            margin-right: auto !important;
            margin-left: auto !important;
        }
        .my-lg-0 {
            margin-top: 0 !important;
            margin-bottom: 0 !important;
        }
        .my-lg-1 {
            margin-top: 0.25rem !important;
            margin-bottom: 0.25rem !important;
        }
        .my-lg-2 {
            margin-top: 0.5rem !important;
            margin-bottom: 0.5rem !important;
        }
        .my-lg-3 {
            margin-top: 1rem !important;
            margin-bottom: 1rem !important;
        }
        .my-lg-4 {
            margin-top: 1.5rem !important;
            margin-bottom: 1.5rem !important;
        }
        .my-lg-5 {
            margin-top: 3rem !important;
            margin-bottom: 3rem !important;
        }
        .my-lg-auto {
            margin-top: auto !important;
            margin-bottom: auto !important;
        }
        .mt-lg-0 {
            margin-top: 0 !important;
        }
        .mt-lg-1 {
            margin-top: 0.25rem !important;
        }
        .mt-lg-2 {
            margin-top: 0.5rem !important;
        }
        .mt-lg-3 {
            margin-top: 1rem !important;
        }
        .mt-lg-4 {
            margin-top: 1.5rem !important;
        }
        .mt-lg-5 {
            margin-top: 3rem !important;
        }
        .mt-lg-auto {
            margin-top: auto !important;
        }
        .me-lg-0 {
            margin-right: 0 !important;
        }
        .me-lg-1 {
            margin-right: 0.25rem !important;
        }
        .me-lg-2 {
            margin-right: 0.5rem !important;
        }
        .me-lg-3 {
            margin-right: 1rem !important;
        }
        .me-lg-4 {
            margin-right: 1.5rem !important;
        }
        .me-lg-5 {
            margin-right: 3rem !important;
        }
        .me-lg-auto {
            margin-right: auto !important;
        }
        .mb-lg-0 {
            margin-bottom: 0 !important;
        }
        .mb-lg-1 {
            margin-bottom: 0.25rem !important;
        }
        .mb-lg-2 {
            margin-bottom: 0.5rem !important;
        }
        .mb-lg-3 {
            margin-bottom: 1rem !important;
        }
        .mb-lg-4 {
            margin-bottom: 1.5rem !important;
        }
        .mb-lg-5 {
            margin-bottom: 3rem !important;
        }
        .mb-lg-auto {
            margin-bottom: auto !important;
        }
        .ms-lg-0 {
            margin-left: 0 !important;
        }
        .ms-lg-1 {
            margin-left: 0.25rem !important;
        }
        .ms-lg-2 {
            margin-left: 0.5rem !important;
        }
        .ms-lg-3 {
            margin-left: 1rem !important;
        }
        .ms-lg-4 {
            margin-left: 1.5rem !important;
        }
        .ms-lg-5 {
            margin-left: 3rem !important;
        }
        .ms-lg-auto {
            margin-left: auto !important;
        }
        .p-lg-0 {
            padding: 0 !important;
        }
        .p-lg-1 {
            padding: 0.25rem !important;
        }
        .p-lg-2 {
            padding: 0.5rem !important;
        }
        .p-lg-3 {
            padding: 1rem !important;
        }
        .p-lg-4 {
            padding: 1.5rem !important;
        }
        .p-lg-5 {
            padding: 3rem !important;
        }
        .px-lg-0 {
            padding-right: 0 !important;
            padding-left: 0 !important;
        }
        .px-lg-1 {
            padding-right: 0.25rem !important;
            padding-left: 0.25rem !important;
        }
        .px-lg-2 {
            padding-right: 0.5rem !important;
            padding-left: 0.5rem !important;
        }
        .px-lg-3 {
            padding-right: 1rem !important;
            padding-left: 1rem !important;
        }
        .px-lg-4 {
            padding-right: 1.5rem !important;
            padding-left: 1.5rem !important;
        }
        .px-lg-5 {
            padding-right: 3rem !important;
            padding-left: 3rem !important;
        }
        .py-lg-0 {
            padding-top: 0 !important;
            padding-bottom: 0 !important;
        }
        .py-lg-1 {
            padding-top: 0.25rem !important;
            padding-bottom: 0.25rem !important;
        }
        .py-lg-2 {
            padding-top: 0.5rem !important;
            padding-bottom: 0.5rem !important;
        }
        .py-lg-3 {
            padding-top: 1rem !important;
            padding-bottom: 1rem !important;
        }
        .py-lg-4 {
            padding-top: 1.5rem !important;
            padding-bottom: 1.5rem !important;
        }
        .py-lg-5 {
            padding-top: 3rem !important;
            padding-bottom: 3rem !important;
        }
        .pt-lg-0 {
            padding-top: 0 !important;
        }
        .pt-lg-1 {
            padding-top: 0.25rem !important;
        }
        .pt-lg-2 {
            padding-top: 0.5rem !important;
        }
        .pt-lg-3 {
            padding-top: 1rem !important;
        }
        .pt-lg-4 {
            padding-top: 1.5rem !important;
        }
        .pt-lg-5 {
            padding-top: 3rem !important;
        }
        .pe-lg-0 {
            padding-right: 0 !important;
        }
        .pe-lg-1 {
            padding-right: 0.25rem !important;
        }
        .pe-lg-2 {
            padding-right: 0.5rem !important;
        }
        .pe-lg-3 {
            padding-right: 1rem !important;
        }
        .pe-lg-4 {
            padding-right: 1.5rem !important;
        }
        .pe-lg-5 {
            padding-right: 3rem !important;
        }
        .pb-lg-0 {
            padding-bottom: 0 !important;
        }
        .pb-lg-1 {
            padding-bottom: 0.25rem !important;
        }
        .pb-lg-2 {
            padding-bottom: 0.5rem !important;
        }
        .pb-lg-3 {
            padding-bottom: 1rem !important;
        }
        .pb-lg-4 {
            padding-bottom: 1.5rem !important;
        }
        .pb-lg-5 {
            padding-bottom: 3rem !important;
        }
        .ps-lg-0 {
            padding-left: 0 !important;
        }
        .ps-lg-1 {
            padding-left: 0.25rem !important;
        }
        .ps-lg-2 {
            padding-left: 0.5rem !important;
        }
        .ps-lg-3 {
            padding-left: 1rem !important;
        }
        .ps-lg-4 {
            padding-left: 1.5rem !important;
        }
        .ps-lg-5 {
            padding-left: 3rem !important;
        }
        .gap-lg-0 {
            gap: 0 !important;
        }
        .gap-lg-1 {
            gap: 0.25rem !important;
        }
        .gap-lg-2 {
            gap: 0.5rem !important;
        }
        .gap-lg-3 {
            gap: 1rem !important;
        }
        .gap-lg-4 {
            gap: 1.5rem !important;
        }
        .gap-lg-5 {
            gap: 3rem !important;
        }
        .row-gap-lg-0 {
            row-gap: 0 !important;
        }
        .row-gap-lg-1 {
            row-gap: 0.25rem !important;
        }
        .row-gap-lg-2 {
            row-gap: 0.5rem !important;
        }
        .row-gap-lg-3 {
            row-gap: 1rem !important;
        }
        .row-gap-lg-4 {
            row-gap: 1.5rem !important;
        }
        .row-gap-lg-5 {
            row-gap: 3rem !important;
        }
        .column-gap-lg-0 {
            -moz-column-gap: 0 !important;
            column-gap: 0 !important;
        }
        .column-gap-lg-1 {
            -moz-column-gap: 0.25rem !important;
            column-gap: 0.25rem !important;
        }
        .column-gap-lg-2 {
            -moz-column-gap: 0.5rem !important;
            column-gap: 0.5rem !important;
        }
        .column-gap-lg-3 {
            -moz-column-gap: 1rem !important;
            column-gap: 1rem !important;
        }
        .column-gap-lg-4 {
            -moz-column-gap: 1.5rem !important;
            column-gap: 1.5rem !important;
        }
        .column-gap-lg-5 {
            -moz-column-gap: 3rem !important;
            column-gap: 3rem !important;
        }
        .text-lg-start {
            text-align: left !important;
        }
        .text-lg-end {
            text-align: right !important;
        }
        .text-lg-center {
            text-align: center !important;
        }
    }
    @media (min-width: 1200px) {
        .float-xl-start {
            float: left !important;
        }
        .float-xl-end {
            float: right !important;
        }
        .float-xl-none {
            float: none !important;
        }
        .object-fit-xl-contain {
            -o-object-fit: contain !important;
            object-fit: contain !important;
        }
        .object-fit-xl-cover {
            -o-object-fit: cover !important;
            object-fit: cover !important;
        }
        .object-fit-xl-fill {
            -o-object-fit: fill !important;
            object-fit: fill !important;
        }
        .object-fit-xl-scale {
            -o-object-fit: scale-down !important;
            object-fit: scale-down !important;
        }
        .object-fit-xl-none {
            -o-object-fit: none !important;
            object-fit: none !important;
        }
        .d-xl-inline {
            display: inline !important;
        }
        .d-xl-inline-block {
            display: inline-block !important;
        }
        .d-xl-block {
            display: block !important;
        }
        .d-xl-grid {
            display: grid !important;
        }
        .d-xl-inline-grid {
            display: inline-grid !important;
        }
        .d-xl-table {
            display: table !important;
        }
        .d-xl-table-row {
            display: table-row !important;
        }
        .d-xl-table-cell {
            display: table-cell !important;
        }
        .d-xl-flex {
            display: flex !important;
        }
        .d-xl-inline-flex {
            display: inline-flex !important;
        }
        .d-xl-none {
            display: none !important;
        }
        .flex-xl-fill {
            flex: 1 1 auto !important;
        }
        .flex-xl-row {
            flex-direction: row !important;
        }
        .flex-xl-column {
            flex-direction: column !important;
        }
        .flex-xl-row-reverse {
            flex-direction: row-reverse !important;
        }
        .flex-xl-column-reverse {
            flex-direction: column-reverse !important;
        }
        .flex-xl-grow-0 {
            flex-grow: 0 !important;
        }
        .flex-xl-grow-1 {
            flex-grow: 1 !important;
        }
        .flex-xl-shrink-0 {
            flex-shrink: 0 !important;
        }
        .flex-xl-shrink-1 {
            flex-shrink: 1 !important;
        }
        .flex-xl-wrap {
            flex-wrap: wrap !important;
        }
        .flex-xl-nowrap {
            flex-wrap: nowrap !important;
        }
        .flex-xl-wrap-reverse {
            flex-wrap: wrap-reverse !important;
        }
        .justify-content-xl-start {
            justify-content: flex-start !important;
        }
        .justify-content-xl-end {
            justify-content: flex-end !important;
        }
        .justify-content-xl-center {
            justify-content: center !important;
        }
        .justify-content-xl-between {
            justify-content: space-between !important;
        }
        .justify-content-xl-around {
            justify-content: space-around !important;
        }
        .justify-content-xl-evenly {
            justify-content: space-evenly !important;
        }
        .align-items-xl-start {
            align-items: flex-start !important;
        }
        .align-items-xl-end {
            align-items: flex-end !important;
        }
        .align-items-xl-center {
            align-items: center !important;
        }
        .align-items-xl-baseline {
            align-items: baseline !important;
        }
        .align-items-xl-stretch {
            align-items: stretch !important;
        }
        .align-content-xl-start {
            align-content: flex-start !important;
        }
        .align-content-xl-end {
            align-content: flex-end !important;
        }
        .align-content-xl-center {
            align-content: center !important;
        }
        .align-content-xl-between {
            align-content: space-between !important;
        }
        .align-content-xl-around {
            align-content: space-around !important;
        }
        .align-content-xl-stretch {
            align-content: stretch !important;
        }
        .align-self-xl-auto {
            align-self: auto !important;
        }
        .align-self-xl-start {
            align-self: flex-start !important;
        }
        .align-self-xl-end {
            align-self: flex-end !important;
        }
        .align-self-xl-center {
            align-self: center !important;
        }
        .align-self-xl-baseline {
            align-self: baseline !important;
        }
        .align-self-xl-stretch {
            align-self: stretch !important;
        }
        .order-xl-first {
            order: -1 !important;
        }
        .order-xl-0 {
            order: 0 !important;
        }
        .order-xl-1 {
            order: 1 !important;
        }
        .order-xl-2 {
            order: 2 !important;
        }
        .order-xl-3 {
            order: 3 !important;
        }
        .order-xl-4 {
            order: 4 !important;
        }
        .order-xl-5 {
            order: 5 !important;
        }
        .order-xl-last {
            order: 6 !important;
        }
        .m-xl-0 {
            margin: 0 !important;
        }
        .m-xl-1 {
            margin: 0.25rem !important;
        }
        .m-xl-2 {
            margin: 0.5rem !important;
        }
        .m-xl-3 {
            margin: 1rem !important;
        }
        .m-xl-4 {
            margin: 1.5rem !important;
        }
        .m-xl-5 {
            margin: 3rem !important;
        }
        .m-xl-auto {
            margin: auto !important;
        }
        .mx-xl-0 {
            margin-right: 0 !important;
            margin-left: 0 !important;
        }
        .mx-xl-1 {
            margin-right: 0.25rem !important;
            margin-left: 0.25rem !important;
        }
        .mx-xl-2 {
            margin-right: 0.5rem !important;
            margin-left: 0.5rem !important;
        }
        .mx-xl-3 {
            margin-right: 1rem !important;
            margin-left: 1rem !important;
        }
        .mx-xl-4 {
            margin-right: 1.5rem !important;
            margin-left: 1.5rem !important;
        }
        .mx-xl-5 {
            margin-right: 3rem !important;
            margin-left: 3rem !important;
        }
        .mx-xl-auto {
            margin-right: auto !important;
            margin-left: auto !important;
        }
        .my-xl-0 {
            margin-top: 0 !important;
            margin-bottom: 0 !important;
        }
        .my-xl-1 {
            margin-top: 0.25rem !important;
            margin-bottom: 0.25rem !important;
        }
        .my-xl-2 {
            margin-top: 0.5rem !important;
            margin-bottom: 0.5rem !important;
        }
        .my-xl-3 {
            margin-top: 1rem !important;
            margin-bottom: 1rem !important;
        }
        .my-xl-4 {
            margin-top: 1.5rem !important;
            margin-bottom: 1.5rem !important;
        }
        .my-xl-5 {
            margin-top: 3rem !important;
            margin-bottom: 3rem !important;
        }
        .my-xl-auto {
            margin-top: auto !important;
            margin-bottom: auto !important;
        }
        .mt-xl-0 {
            margin-top: 0 !important;
        }
        .mt-xl-1 {
            margin-top: 0.25rem !important;
        }
        .mt-xl-2 {
            margin-top: 0.5rem !important;
        }
        .mt-xl-3 {
            margin-top: 1rem !important;
        }
        .mt-xl-4 {
            margin-top: 1.5rem !important;
        }
        .mt-xl-5 {
            margin-top: 3rem !important;
        }
        .mt-xl-auto {
            margin-top: auto !important;
        }
        .me-xl-0 {
            margin-right: 0 !important;
        }
        .me-xl-1 {
            margin-right: 0.25rem !important;
        }
        .me-xl-2 {
            margin-right: 0.5rem !important;
        }
        .me-xl-3 {
            margin-right: 1rem !important;
        }
        .me-xl-4 {
            margin-right: 1.5rem !important;
        }
        .me-xl-5 {
            margin-right: 3rem !important;
        }
        .me-xl-auto {
            margin-right: auto !important;
        }
        .mb-xl-0 {
            margin-bottom: 0 !important;
        }
        .mb-xl-1 {
            margin-bottom: 0.25rem !important;
        }
        .mb-xl-2 {
            margin-bottom: 0.5rem !important;
        }
        .mb-xl-3 {
            margin-bottom: 1rem !important;
        }
        .mb-xl-4 {
            margin-bottom: 1.5rem !important;
        }
        .mb-xl-5 {
            margin-bottom: 3rem !important;
        }
        .mb-xl-auto {
            margin-bottom: auto !important;
        }
        .ms-xl-0 {
            margin-left: 0 !important;
        }
        .ms-xl-1 {
            margin-left: 0.25rem !important;
        }
        .ms-xl-2 {
            margin-left: 0.5rem !important;
        }
        .ms-xl-3 {
            margin-left: 1rem !important;
        }
        .ms-xl-4 {
            margin-left: 1.5rem !important;
        }
        .ms-xl-5 {
            margin-left: 3rem !important;
        }
        .ms-xl-auto {
            margin-left: auto !important;
        }
        .p-xl-0 {
            padding: 0 !important;
        }
        .p-xl-1 {
            padding: 0.25rem !important;
        }
        .p-xl-2 {
            padding: 0.5rem !important;
        }
        .p-xl-3 {
            padding: 1rem !important;
        }
        .p-xl-4 {
            padding: 1.5rem !important;
        }
        .p-xl-5 {
            padding: 3rem !important;
        }
        .px-xl-0 {
            padding-right: 0 !important;
            padding-left: 0 !important;
        }
        .px-xl-1 {
            padding-right: 0.25rem !important;
            padding-left: 0.25rem !important;
        }
        .px-xl-2 {
            padding-right: 0.5rem !important;
            padding-left: 0.5rem !important;
        }
        .px-xl-3 {
            padding-right: 1rem !important;
            padding-left: 1rem !important;
        }
        .px-xl-4 {
            padding-right: 1.5rem !important;
            padding-left: 1.5rem !important;
        }
        .px-xl-5 {
            padding-right: 3rem !important;
            padding-left: 3rem !important;
        }
        .py-xl-0 {
            padding-top: 0 !important;
            padding-bottom: 0 !important;
        }
        .py-xl-1 {
            padding-top: 0.25rem !important;
            padding-bottom: 0.25rem !important;
        }
        .py-xl-2 {
            padding-top: 0.5rem !important;
            padding-bottom: 0.5rem !important;
        }
        .py-xl-3 {
            padding-top: 1rem !important;
            padding-bottom: 1rem !important;
        }
        .py-xl-4 {
            padding-top: 1.5rem !important;
            padding-bottom: 1.5rem !important;
        }
        .py-xl-5 {
            padding-top: 3rem !important;
            padding-bottom: 3rem !important;
        }
        .pt-xl-0 {
            padding-top: 0 !important;
        }
        .pt-xl-1 {
            padding-top: 0.25rem !important;
        }
        .pt-xl-2 {
            padding-top: 0.5rem !important;
        }
        .pt-xl-3 {
            padding-top: 1rem !important;
        }
        .pt-xl-4 {
            padding-top: 1.5rem !important;
        }
        .pt-xl-5 {
            padding-top: 3rem !important;
        }
        .pe-xl-0 {
            padding-right: 0 !important;
        }
        .pe-xl-1 {
            padding-right: 0.25rem !important;
        }
        .pe-xl-2 {
            padding-right: 0.5rem !important;
        }
        .pe-xl-3 {
            padding-right: 1rem !important;
        }
        .pe-xl-4 {
            padding-right: 1.5rem !important;
        }
        .pe-xl-5 {
            padding-right: 3rem !important;
        }
        .pb-xl-0 {
            padding-bottom: 0 !important;
        }
        .pb-xl-1 {
            padding-bottom: 0.25rem !important;
        }
        .pb-xl-2 {
            padding-bottom: 0.5rem !important;
        }
        .pb-xl-3 {
            padding-bottom: 1rem !important;
        }
        .pb-xl-4 {
            padding-bottom: 1.5rem !important;
        }
        .pb-xl-5 {
            padding-bottom: 3rem !important;
        }
        .ps-xl-0 {
            padding-left: 0 !important;
        }
        .ps-xl-1 {
            padding-left: 0.25rem !important;
        }
        .ps-xl-2 {
            padding-left: 0.5rem !important;
        }
        .ps-xl-3 {
            padding-left: 1rem !important;
        }
        .ps-xl-4 {
            padding-left: 1.5rem !important;
        }
        .ps-xl-5 {
            padding-left: 3rem !important;
        }
        .gap-xl-0 {
            gap: 0 !important;
        }
        .gap-xl-1 {
            gap: 0.25rem !important;
        }
        .gap-xl-2 {
            gap: 0.5rem !important;
        }
        .gap-xl-3 {
            gap: 1rem !important;
        }
        .gap-xl-4 {
            gap: 1.5rem !important;
        }
        .gap-xl-5 {
            gap: 3rem !important;
        }
        .row-gap-xl-0 {
            row-gap: 0 !important;
        }
        .row-gap-xl-1 {
            row-gap: 0.25rem !important;
        }
        .row-gap-xl-2 {
            row-gap: 0.5rem !important;
        }
        .row-gap-xl-3 {
            row-gap: 1rem !important;
        }
        .row-gap-xl-4 {
            row-gap: 1.5rem !important;
        }
        .row-gap-xl-5 {
            row-gap: 3rem !important;
        }
        .column-gap-xl-0 {
            -moz-column-gap: 0 !important;
            column-gap: 0 !important;
        }
        .column-gap-xl-1 {
            -moz-column-gap: 0.25rem !important;
            column-gap: 0.25rem !important;
        }
        .column-gap-xl-2 {
            -moz-column-gap: 0.5rem !important;
            column-gap: 0.5rem !important;
        }
        .column-gap-xl-3 {
            -moz-column-gap: 1rem !important;
            column-gap: 1rem !important;
        }
        .column-gap-xl-4 {
            -moz-column-gap: 1.5rem !important;
            column-gap: 1.5rem !important;
        }
        .column-gap-xl-5 {
            -moz-column-gap: 3rem !important;
            column-gap: 3rem !important;
        }
        .text-xl-start {
            text-align: left !important;
        }
        .text-xl-end {
            text-align: right !important;
        }
        .text-xl-center {
            text-align: center !important;
        }
    }
    @media (min-width: 1400px) {
        .float-xxl-start {
            float: left !important;
        }
        .float-xxl-end {
            float: right !important;
        }
        .float-xxl-none {
            float: none !important;
        }
        .object-fit-xxl-contain {
            -o-object-fit: contain !important;
            object-fit: contain !important;
        }
        .object-fit-xxl-cover {
            -o-object-fit: cover !important;
            object-fit: cover !important;
        }
        .object-fit-xxl-fill {
            -o-object-fit: fill !important;
            object-fit: fill !important;
        }
        .object-fit-xxl-scale {
            -o-object-fit: scale-down !important;
            object-fit: scale-down !important;
        }
        .object-fit-xxl-none {
            -o-object-fit: none !important;
            object-fit: none !important;
        }
        .d-xxl-inline {
            display: inline !important;
        }
        .d-xxl-inline-block {
            display: inline-block !important;
        }
        .d-xxl-block {
            display: block !important;
        }
        .d-xxl-grid {
            display: grid !important;
        }
        .d-xxl-inline-grid {
            display: inline-grid !important;
        }
        .d-xxl-table {
            display: table !important;
        }
        .d-xxl-table-row {
            display: table-row !important;
        }
        .d-xxl-table-cell {
            display: table-cell !important;
        }
        .d-xxl-flex {
            display: flex !important;
        }
        .d-xxl-inline-flex {
            display: inline-flex !important;
        }
        .d-xxl-none {
            display: none !important;
        }
        .flex-xxl-fill {
            flex: 1 1 auto !important;
        }
        .flex-xxl-row {
            flex-direction: row !important;
        }
        .flex-xxl-column {
            flex-direction: column !important;
        }
        .flex-xxl-row-reverse {
            flex-direction: row-reverse !important;
        }
        .flex-xxl-column-reverse {
            flex-direction: column-reverse !important;
        }
        .flex-xxl-grow-0 {
            flex-grow: 0 !important;
        }
        .flex-xxl-grow-1 {
            flex-grow: 1 !important;
        }
        .flex-xxl-shrink-0 {
            flex-shrink: 0 !important;
        }
        .flex-xxl-shrink-1 {
            flex-shrink: 1 !important;
        }
        .flex-xxl-wrap {
            flex-wrap: wrap !important;
        }
        .flex-xxl-nowrap {
            flex-wrap: nowrap !important;
        }
        .flex-xxl-wrap-reverse {
            flex-wrap: wrap-reverse !important;
        }
        .justify-content-xxl-start {
            justify-content: flex-start !important;
        }
        .justify-content-xxl-end {
            justify-content: flex-end !important;
        }
        .justify-content-xxl-center {
            justify-content: center !important;
        }
        .justify-content-xxl-between {
            justify-content: space-between !important;
        }
        .justify-content-xxl-around {
            justify-content: space-around !important;
        }
        .justify-content-xxl-evenly {
            justify-content: space-evenly !important;
        }
        .align-items-xxl-start {
            align-items: flex-start !important;
        }
        .align-items-xxl-end {
            align-items: flex-end !important;
        }
        .align-items-xxl-center {
            align-items: center !important;
        }
        .align-items-xxl-baseline {
            align-items: baseline !important;
        }
        .align-items-xxl-stretch {
            align-items: stretch !important;
        }
        .align-content-xxl-start {
            align-content: flex-start !important;
        }
        .align-content-xxl-end {
            align-content: flex-end !important;
        }
        .align-content-xxl-center {
            align-content: center !important;
        }
        .align-content-xxl-between {
            align-content: space-between !important;
        }
        .align-content-xxl-around {
            align-content: space-around !important;
        }
        .align-content-xxl-stretch {
            align-content: stretch !important;
        }
        .align-self-xxl-auto {
            align-self: auto !important;
        }
        .align-self-xxl-start {
            align-self: flex-start !important;
        }
        .align-self-xxl-end {
            align-self: flex-end !important;
        }
        .align-self-xxl-center {
            align-self: center !important;
        }
        .align-self-xxl-baseline {
            align-self: baseline !important;
        }
        .align-self-xxl-stretch {
            align-self: stretch !important;
        }
        .order-xxl-first {
            order: -1 !important;
        }
        .order-xxl-0 {
            order: 0 !important;
        }
        .order-xxl-1 {
            order: 1 !important;
        }
        .order-xxl-2 {
            order: 2 !important;
        }
        .order-xxl-3 {
            order: 3 !important;
        }
        .order-xxl-4 {
            order: 4 !important;
        }
        .order-xxl-5 {
            order: 5 !important;
        }
        .order-xxl-last {
            order: 6 !important;
        }
        .m-xxl-0 {
            margin: 0 !important;
        }
        .m-xxl-1 {
            margin: 0.25rem !important;
        }
        .m-xxl-2 {
            margin: 0.5rem !important;
        }
        .m-xxl-3 {
            margin: 1rem !important;
        }
        .m-xxl-4 {
            margin: 1.5rem !important;
        }
        .m-xxl-5 {
            margin: 3rem !important;
        }
        .m-xxl-auto {
            margin: auto !important;
        }
        .mx-xxl-0 {
            margin-right: 0 !important;
            margin-left: 0 !important;
        }
        .mx-xxl-1 {
            margin-right: 0.25rem !important;
            margin-left: 0.25rem !important;
        }
        .mx-xxl-2 {
            margin-right: 0.5rem !important;
            margin-left: 0.5rem !important;
        }
        .mx-xxl-3 {
            margin-right: 1rem !important;
            margin-left: 1rem !important;
        }
        .mx-xxl-4 {
            margin-right: 1.5rem !important;
            margin-left: 1.5rem !important;
        }
        .mx-xxl-5 {
            margin-right: 3rem !important;
            margin-left: 3rem !important;
        }
        .mx-xxl-auto {
            margin-right: auto !important;
            margin-left: auto !important;
        }
        .my-xxl-0 {
            margin-top: 0 !important;
            margin-bottom: 0 !important;
        }
        .my-xxl-1 {
            margin-top: 0.25rem !important;
            margin-bottom: 0.25rem !important;
        }
        .my-xxl-2 {
            margin-top: 0.5rem !important;
            margin-bottom: 0.5rem !important;
        }
        .my-xxl-3 {
            margin-top: 1rem !important;
            margin-bottom: 1rem !important;
        }
        .my-xxl-4 {
            margin-top: 1.5rem !important;
            margin-bottom: 1.5rem !important;
        }
        .my-xxl-5 {
            margin-top: 3rem !important;
            margin-bottom: 3rem !important;
        }
        .my-xxl-auto {
            margin-top: auto !important;
            margin-bottom: auto !important;
        }
        .mt-xxl-0 {
            margin-top: 0 !important;
        }
        .mt-xxl-1 {
            margin-top: 0.25rem !important;
        }
        .mt-xxl-2 {
            margin-top: 0.5rem !important;
        }
        .mt-xxl-3 {
            margin-top: 1rem !important;
        }
        .mt-xxl-4 {
            margin-top: 1.5rem !important;
        }
        .mt-xxl-5 {
            margin-top: 3rem !important;
        }
        .mt-xxl-auto {
            margin-top: auto !important;
        }
        .me-xxl-0 {
            margin-right: 0 !important;
        }
        .me-xxl-1 {
            margin-right: 0.25rem !important;
        }
        .me-xxl-2 {
            margin-right: 0.5rem !important;
        }
        .me-xxl-3 {
            margin-right: 1rem !important;
        }
        .me-xxl-4 {
            margin-right: 1.5rem !important;
        }
        .me-xxl-5 {
            margin-right: 3rem !important;
        }
        .me-xxl-auto {
            margin-right: auto !important;
        }
        .mb-xxl-0 {
            margin-bottom: 0 !important;
        }
        .mb-xxl-1 {
            margin-bottom: 0.25rem !important;
        }
        .mb-xxl-2 {
            margin-bottom: 0.5rem !important;
        }
        .mb-xxl-3 {
            margin-bottom: 1rem !important;
        }
        .mb-xxl-4 {
            margin-bottom: 1.5rem !important;
        }
        .mb-xxl-5 {
            margin-bottom: 3rem !important;
        }
        .mb-xxl-auto {
            margin-bottom: auto !important;
        }
        .ms-xxl-0 {
            margin-left: 0 !important;
        }
        .ms-xxl-1 {
            margin-left: 0.25rem !important;
        }
        .ms-xxl-2 {
            margin-left: 0.5rem !important;
        }
        .ms-xxl-3 {
            margin-left: 1rem !important;
        }
        .ms-xxl-4 {
            margin-left: 1.5rem !important;
        }
        .ms-xxl-5 {
            margin-left: 3rem !important;
        }
        .ms-xxl-auto {
            margin-left: auto !important;
        }
        .p-xxl-0 {
            padding: 0 !important;
        }
        .p-xxl-1 {
            padding: 0.25rem !important;
        }
        .p-xxl-2 {
            padding: 0.5rem !important;
        }
        .p-xxl-3 {
            padding: 1rem !important;
        }
        .p-xxl-4 {
            padding: 1.5rem !important;
        }
        .p-xxl-5 {
            padding: 3rem !important;
        }
        .px-xxl-0 {
            padding-right: 0 !important;
            padding-left: 0 !important;
        }
        .px-xxl-1 {
            padding-right: 0.25rem !important;
            padding-left: 0.25rem !important;
        }
        .px-xxl-2 {
            padding-right: 0.5rem !important;
            padding-left: 0.5rem !important;
        }
        .px-xxl-3 {
            padding-right: 1rem !important;
            padding-left: 1rem !important;
        }
        .px-xxl-4 {
            padding-right: 1.5rem !important;
            padding-left: 1.5rem !important;
        }
        .px-xxl-5 {
            padding-right: 3rem !important;
            padding-left: 3rem !important;
        }
        .py-xxl-0 {
            padding-top: 0 !important;
            padding-bottom: 0 !important;
        }
        .py-xxl-1 {
            padding-top: 0.25rem !important;
            padding-bottom: 0.25rem !important;
        }
        .py-xxl-2 {
            padding-top: 0.5rem !important;
            padding-bottom: 0.5rem !important;
        }
        .py-xxl-3 {
            padding-top: 1rem !important;
            padding-bottom: 1rem !important;
        }
        .py-xxl-4 {
            padding-top: 1.5rem !important;
            padding-bottom: 1.5rem !important;
        }
        .py-xxl-5 {
            padding-top: 3rem !important;
            padding-bottom: 3rem !important;
        }
        .pt-xxl-0 {
            padding-top: 0 !important;
        }
        .pt-xxl-1 {
            padding-top: 0.25rem !important;
        }
        .pt-xxl-2 {
            padding-top: 0.5rem !important;
        }
        .pt-xxl-3 {
            padding-top: 1rem !important;
        }
        .pt-xxl-4 {
            padding-top: 1.5rem !important;
        }
        .pt-xxl-5 {
            padding-top: 3rem !important;
        }
        .pe-xxl-0 {
            padding-right: 0 !important;
        }
        .pe-xxl-1 {
            padding-right: 0.25rem !important;
        }
        .pe-xxl-2 {
            padding-right: 0.5rem !important;
        }
        .pe-xxl-3 {
            padding-right: 1rem !important;
        }
        .pe-xxl-4 {
            padding-right: 1.5rem !important;
        }
        .pe-xxl-5 {
            padding-right: 3rem !important;
        }
        .pb-xxl-0 {
            padding-bottom: 0 !important;
        }
        .pb-xxl-1 {
            padding-bottom: 0.25rem !important;
        }
        .pb-xxl-2 {
            padding-bottom: 0.5rem !important;
        }
        .pb-xxl-3 {
            padding-bottom: 1rem !important;
        }
        .pb-xxl-4 {
            padding-bottom: 1.5rem !important;
        }
        .pb-xxl-5 {
            padding-bottom: 3rem !important;
        }
        .ps-xxl-0 {
            padding-left: 0 !important;
        }
        .ps-xxl-1 {
            padding-left: 0.25rem !important;
        }
        .ps-xxl-2 {
            padding-left: 0.5rem !important;
        }
        .ps-xxl-3 {
            padding-left: 1rem !important;
        }
        .ps-xxl-4 {
            padding-left: 1.5rem !important;
        }
        .ps-xxl-5 {
            padding-left: 3rem !important;
        }
        .gap-xxl-0 {
            gap: 0 !important;
        }
        .gap-xxl-1 {
            gap: 0.25rem !important;
        }
        .gap-xxl-2 {
            gap: 0.5rem !important;
        }
        .gap-xxl-3 {
            gap: 1rem !important;
        }
        .gap-xxl-4 {
            gap: 1.5rem !important;
        }
        .gap-xxl-5 {
            gap: 3rem !important;
        }
        .row-gap-xxl-0 {
            row-gap: 0 !important;
        }
        .row-gap-xxl-1 {
            row-gap: 0.25rem !important;
        }
        .row-gap-xxl-2 {
            row-gap: 0.5rem !important;
        }
        .row-gap-xxl-3 {
            row-gap: 1rem !important;
        }
        .row-gap-xxl-4 {
            row-gap: 1.5rem !important;
        }
        .row-gap-xxl-5 {
            row-gap: 3rem !important;
        }
        .column-gap-xxl-0 {
            -moz-column-gap: 0 !important;
            column-gap: 0 !important;
        }
        .column-gap-xxl-1 {
            -moz-column-gap: 0.25rem !important;
            column-gap: 0.25rem !important;
        }
        .column-gap-xxl-2 {
            -moz-column-gap: 0.5rem !important;
            column-gap: 0.5rem !important;
        }
        .column-gap-xxl-3 {
            -moz-column-gap: 1rem !important;
            column-gap: 1rem !important;
        }
        .column-gap-xxl-4 {
            -moz-column-gap: 1.5rem !important;
            column-gap: 1.5rem !important;
        }
        .column-gap-xxl-5 {
            -moz-column-gap: 3rem !important;
            column-gap: 3rem !important;
        }
        .text-xxl-start {
            text-align: left !important;
        }
        .text-xxl-end {
            text-align: right !important;
        }
        .text-xxl-center {
            text-align: center !important;
        }
    }
    @media (min-width: 1200px) {
        .fs-1 {
            font-size: 2.5rem !important;
        }
        .fs-2 {
            font-size: 2rem !important;
        }
        .fs-3 {
            font-size: 1.75rem !important;
        }
        .fs-4 {
            font-size: 1.5rem !important;
        }
    }
    @media print {
        .d-print-inline {
            display: inline !important;
        }
        .d-print-inline-block {
            display: inline-block !important;
        }
        .d-print-block {
            display: block !important;
        }
        .d-print-grid {
            display: grid !important;
        }
        .d-print-inline-grid {
            display: inline-grid !important;
        }
        .d-print-table {
            display: table !important;
        }
        .d-print-table-row {
            display: table-row !important;
        }
        .d-print-table-cell {
            display: table-cell !important;
        }
        .d-print-flex {
            display: flex !important;
        }
        .d-print-inline-flex {
            display: inline-flex !important;
        }
        .d-print-none {
            display: none !important;
        }
    }
}
`, "",{"version":3,"sources":["webpack://./src/rate-calculator/rate-calculator-bs.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAEhB;IACI,kBAAkB;IAClB,oBAAoB;IACpB,oBAAoB;IACpB,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;IACvB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,qBAAqB;IACrB,uBAAuB;IACvB,qBAAqB;IACrB,kBAAkB;IAClB,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,8BAA8B;IAC9B,iCAAiC;IACjC,6BAA6B;IAC7B,2BAA2B;IAC3B,6BAA6B;IAC7B,4BAA4B;IAC5B,6BAA6B;IAC7B,yBAAyB;IACzB,mCAAmC;IACnC,qCAAqC;IACrC,mCAAmC;IACnC,gCAAgC;IAChC,mCAAmC;IACnC,kCAAkC;IAClC,iCAAiC;IACjC,gCAAgC;IAChC,+BAA+B;IAC/B,iCAAiC;IACjC,+BAA+B;IAC/B,4BAA4B;IAC5B,+BAA+B;IAC/B,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;IAC5B,mCAAmC;IACnC,qCAAqC;IACrC,mCAAmC;IACnC,gCAAgC;IAChC,mCAAmC;IACnC,kCAAkC;IAClC,iCAAiC;IACjC,gCAAgC;IAChC,6BAA6B;IAC7B,uBAAuB;IACvB;;;0BAGsB;IACtB;mDAC+C;IAC/C;;;;KAIC;IACD,gDAAgD;IAChD,yBAAyB;IACzB,0BAA0B;IAC1B,0BAA0B;IAC1B,wBAAwB;IACxB,+BAA+B;IAC/B,kBAAkB;IAClB,+BAA+B;IAC/B,yBAAyB;IACzB,gCAAgC;IAChC,4CAA4C;IAC5C,oCAAoC;IACpC,0BAA0B;IAC1B,oCAAoC;IACpC,0CAA0C;IAC1C,mCAAmC;IACnC,yBAAyB;IACzB,mCAAmC;IACnC,2BAA2B;IAC3B,wBAAwB;IACxB,iCAAiC;IACjC,+BAA+B;IAC/B,8BAA8B;IAC9B,sCAAsC;IACtC,wBAAwB;IACxB,6BAA6B;IAC7B,0BAA0B;IAC1B,sBAAsB;IACtB,wBAAwB;IACxB,0BAA0B;IAC1B,mDAAmD;IACnD,4BAA4B;IAC5B,8BAA8B;IAC9B,6BAA6B;IAC7B,2BAA2B;IAC3B,4BAA4B;IAC5B,mDAAmD;IACnD,8BAA8B;IAC9B,kDAAkD;IAClD,2DAA2D;IAC3D,oDAAoD;IACpD,2DAA2D;IAC3D,8BAA8B;IAC9B,6BAA6B;IAC7B,+CAA+C;IAC/C,8BAA8B;IAC9B,qCAAqC;IACrC,gCAAgC;IAChC,uCAAuC;;IAEvC;;;QAGI,sBAAsB;IAC1B;;IAEA;QACI;YACI,uBAAuB;QAC3B;IACJ;;IAEA;QACI,SAAS;QACT,uCAAuC;QACvC,mCAAmC;QACnC,uCAAuC;QACvC,uCAAuC;QACvC,2BAA2B;QAC3B,qCAAqC;QACrC,mCAAmC;QACnC,8BAA8B;QAC9B,6CAA6C;IACjD;;IAEA;QACI,cAAc;QACd,cAAc;QACd,SAAS;QACT,wCAAwC;QACxC,aAAa;IACjB;;IAEA;;;;;;;;;;;;QAYI,aAAa;QACb,qBAAqB;QACrB,gBAAgB;QAChB,gBAAgB;QAChB,8BAA8B;IAClC;;IAEA;;QAEI,iCAAiC;IACrC;IACA;QACI;;YAEI,iBAAiB;QACrB;IACJ;;IAEA;;QAEI,iCAAiC;IACrC;IACA;QACI;;YAEI,eAAe;QACnB;IACJ;;IAEA;;QAEI,+BAA+B;IACnC;IACA;QACI;;YAEI,kBAAkB;QACtB;IACJ;;IAEA;;QAEI,iCAAiC;IACrC;IACA;QACI;;YAEI,iBAAiB;QACrB;IACJ;;IAEA;;QAEI,kBAAkB;IACtB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,yCAAyC;QACzC,iCAAiC;QACjC,YAAY;QACZ,sCAAsC;QACtC,8BAA8B;IAClC;;IAEA;QACI,mBAAmB;QACnB,kBAAkB;QAClB,oBAAoB;IACxB;;IAEA;;QAEI,kBAAkB;IACtB;;IAEA;;;QAGI,aAAa;QACb,mBAAmB;IACvB;;IAEA;;;;QAII,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,qBAAqB;QACrB,cAAc;IAClB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;;QAEI,mBAAmB;IACvB;;IAEA;;QAEI,kBAAkB;IACtB;;IAEA;;QAEI,iBAAiB;QACjB,gCAAgC;QAChC,wCAAwC;IAC5C;;IAEA;;QAEI,kBAAkB;QAClB,iBAAiB;QACjB,cAAc;QACd,wBAAwB;IAC5B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,gEAAgE;QAChE,0BAA0B;IAC9B;IACA;QACI,mDAAmD;IACvD;;IAEA;;QAEI,cAAc;QACd,qBAAqB;IACzB;;IAEA;;;;QAII,qCAAqC;QACrC,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,aAAa;QACb,mBAAmB;QACnB,cAAc;QACd,kBAAkB;IACtB;IACA;QACI,kBAAkB;QAClB,cAAc;QACd,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,2BAA2B;QAC3B,qBAAqB;IACzB;IACA;QACI,cAAc;IAClB;;IAEA;QACI,2BAA2B;QAC3B,kBAAkB;QAClB,wBAAwB;QACxB,sCAAsC;QACtC,sBAAsB;IAC1B;IACA;QACI,UAAU;QACV,cAAc;IAClB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;;QAEI,sBAAsB;IAC1B;;IAEA;QACI,oBAAoB;QACpB,yBAAyB;IAC7B;;IAEA;QACI,mBAAmB;QACnB,sBAAsB;QACtB,gCAAgC;QAChC,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;QACnB,gCAAgC;IACpC;;IAEA;;;;;;QAMI,qBAAqB;QACrB,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,UAAU;IACd;;IAEA;;;;;QAKI,SAAS;QACT,oBAAoB;QACpB,kBAAkB;QAClB,oBAAoB;IACxB;;IAEA;;QAEI,oBAAoB;IACxB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;IACA;QACI,UAAU;IACd;;IAEA;;;;;QAKI,wBAAwB;IAC5B;;IAEA;;;;QAII,0BAA0B;IAC9B;IACA;;;;QAII,eAAe;IACnB;;IAEA;QACI,UAAU;QACV,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,YAAY;QACZ,UAAU;QACV,SAAS;QACT,SAAS;IACb;;IAEA;QACI,WAAW;QACX,WAAW;QACX,UAAU;QACV,qBAAqB;QACrB,iCAAiC;QACjC,oBAAoB;IACxB;IACA;QACI;YACI,iBAAiB;QACrB;IACJ;IACA;QACI,WAAW;IACf;;IAEA;;;;;;;QAOI,UAAU;IACd;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,6BAA6B;QAC7B,oBAAoB;IACxB;;IAEA;;;;;;;KAOC;IACD;QACI,wBAAwB;IAC5B;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,aAAa;QACb,0BAA0B;IAC9B;;IAEA;QACI,aAAa;QACb,0BAA0B;IAC9B;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,iCAAiC;QACjC,gBAAgB;QAChB,gBAAgB;IACpB;IACA;QACI;YACI,eAAe;QACnB;IACJ;;IAEA;QACI,iCAAiC;QACjC,gBAAgB;QAChB,gBAAgB;IACpB;IACA;QACI;YACI,iBAAiB;QACrB;IACJ;;IAEA;QACI,iCAAiC;QACjC,gBAAgB;QAChB,gBAAgB;IACpB;IACA;QACI;YACI,eAAe;QACnB;IACJ;;IAEA;QACI,iCAAiC;QACjC,gBAAgB;QAChB,gBAAgB;IACpB;IACA;QACI;YACI,iBAAiB;QACrB;IACJ;;IAEA;QACI,iCAAiC;QACjC,gBAAgB;QAChB,gBAAgB;IACpB;IACA;QACI;YACI,eAAe;QACnB;IACJ;;IAEA;QACI,iCAAiC;QACjC,gBAAgB;QAChB,gBAAgB;IACpB;IACA;QACI;YACI,iBAAiB;QACrB;IACJ;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,qBAAqB;IACzB;IACA;QACI,oBAAoB;IACxB;;IAEA;QACI,kBAAkB;QAClB,yBAAyB;IAC7B;;IAEA;QACI,mBAAmB;QACnB,kBAAkB;IACtB;IACA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;QACnB,kBAAkB;QAClB,cAAc;IAClB;IACA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,gBAAgB;QAChB,mCAAmC;QACnC,2DAA2D;QAC3D,sCAAsC;QACtC,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,qBAAqB;QACrB,cAAc;IAClB;;IAEA;QACI,kBAAkB;QAClB,gCAAgC;IACpC;;IAEA;;;;;;;QAOI,qBAAqB;QACrB,gBAAgB;QAChB,WAAW;QACX,6CAA6C;QAC7C,4CAA4C;QAC5C,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA;QACI;;YAEI,gBAAgB;QACpB;IACJ;IACA;QACI;;;YAGI,gBAAgB;QACpB;IACJ;IACA;QACI;;;;YAII,gBAAgB;QACpB;IACJ;IACA;QACI;;;;;YAKI,iBAAiB;QACrB;IACJ;IACA;QACI;;;;;;YAMI,iBAAiB;QACrB;IACJ;IACA;QACI,qBAAqB;QACrB,yBAAyB;QACzB,yBAAyB;QACzB,yBAAyB;QACzB,0BAA0B;QAC1B,2BAA2B;IAC/B;;IAEA;QACI,qBAAqB;QACrB,gBAAgB;QAChB,aAAa;QACb,eAAe;QACf,yCAAyC;QACzC,6CAA6C;QAC7C,4CAA4C;IAChD;IACA;QACI,cAAc;QACd,WAAW;QACX,eAAe;QACf,6CAA6C;QAC7C,4CAA4C;QAC5C,8BAA8B;IAClC;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,cAAc;QACd,WAAW;IACf;;IAEA;QACI,cAAc;QACd,WAAW;IACf;;IAEA;QACI,cAAc;QACd,UAAU;IACd;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,UAAU;IACd;;IAEA;QACI,cAAc;QACd,UAAU;IACd;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,WAAW;IACf;;IAEA;QACI,cAAc;QACd,kBAAkB;IACtB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,UAAU;IACd;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,UAAU;IACd;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,UAAU;IACd;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,WAAW;IACf;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;;QAEI,sBAAsB;IAC1B;;IAEA;;QAEI,sBAAsB;IAC1B;;IAEA;;QAEI,qBAAqB;IACzB;;IAEA;;QAEI,qBAAqB;IACzB;;IAEA;;QAEI,mBAAmB;IACvB;;IAEA;;QAEI,mBAAmB;IACvB;;IAEA;;QAEI,qBAAqB;IACzB;;IAEA;;QAEI,qBAAqB;IACzB;;IAEA;;QAEI,mBAAmB;IACvB;;IAEA;;QAEI,mBAAmB;IACvB;;IAEA;QACI;YACI,YAAY;QAChB;QACA;YACI,cAAc;YACd,WAAW;QACf;QACA;YACI,cAAc;YACd,WAAW;QACf;QACA;YACI,cAAc;YACd,UAAU;QACd;QACA;YACI,cAAc;YACd,mBAAmB;QACvB;QACA;YACI,cAAc;YACd,UAAU;QACd;QACA;YACI,cAAc;YACd,UAAU;QACd;QACA;YACI,cAAc;YACd,mBAAmB;QACvB;QACA;YACI,cAAc;YACd,WAAW;QACf;QACA;YACI,cAAc;YACd,kBAAkB;QACtB;QACA;YACI,cAAc;YACd,mBAAmB;QACvB;QACA;YACI,cAAc;YACd,UAAU;QACd;QACA;YACI,cAAc;YACd,mBAAmB;QACvB;QACA;YACI,cAAc;YACd,mBAAmB;QACvB;QACA;YACI,cAAc;YACd,UAAU;QACd;QACA;YACI,cAAc;YACd,mBAAmB;QACvB;QACA;YACI,cAAc;YACd,mBAAmB;QACvB;QACA;YACI,cAAc;YACd,UAAU;QACd;QACA;YACI,cAAc;YACd,mBAAmB;QACvB;QACA;YACI,cAAc;YACd,mBAAmB;QACvB;QACA;YACI,cAAc;YACd,WAAW;QACf;QACA;YACI,cAAc;QAClB;QACA;YACI,wBAAwB;QAC5B;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,gBAAgB;QACpB;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,gBAAgB;QACpB;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,gBAAgB;QACpB;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,yBAAyB;QAC7B;QACA;;YAEI,gBAAgB;QACpB;QACA;;YAEI,gBAAgB;QACpB;QACA;;YAEI,sBAAsB;QAC1B;QACA;;YAEI,sBAAsB;QAC1B;QACA;;YAEI,qBAAqB;QACzB;QACA;;YAEI,qBAAqB;QACzB;QACA;;YAEI,mBAAmB;QACvB;QACA;;YAEI,mBAAmB;QACvB;QACA;;YAEI,qBAAqB;QACzB;QACA;;YAEI,qBAAqB;QACzB;QACA;;YAEI,mBAAmB;QACvB;QACA;;YAEI,mBAAmB;QACvB;IACJ;IACA;QACI;YACI,YAAY;QAChB;QACA;YACI,cAAc;YACd,WAAW;QACf;QACA;YACI,cAAc;YACd,WAAW;QACf;QACA;YACI,cAAc;YACd,UAAU;QACd;QACA;YACI,cAAc;YACd,mBAAmB;QACvB;QACA;YACI,cAAc;YACd,UAAU;QACd;QACA;YACI,cAAc;YACd,UAAU;QACd;QACA;YACI,cAAc;YACd,mBAAmB;QACvB;QACA;YACI,cAAc;YACd,WAAW;QACf;QACA;YACI,cAAc;YACd,kBAAkB;QACtB;QACA;YACI,cAAc;YACd,mBAAmB;QACvB;QACA;YACI,cAAc;YACd,UAAU;QACd;QACA;YACI,cAAc;YACd,mBAAmB;QACvB;QACA;YACI,cAAc;YACd,mBAAmB;QACvB;QACA;YACI,cAAc;YACd,UAAU;QACd;QACA;YACI,cAAc;YACd,mBAAmB;QACvB;QACA;YACI,cAAc;YACd,mBAAmB;QACvB;QACA;YACI,cAAc;YACd,UAAU;QACd;QACA;YACI,cAAc;YACd,mBAAmB;QACvB;QACA;YACI,cAAc;YACd,mBAAmB;QACvB;QACA;YACI,cAAc;YACd,WAAW;QACf;QACA;YACI,cAAc;QAClB;QACA;YACI,wBAAwB;QAC5B;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,gBAAgB;QACpB;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,gBAAgB;QACpB;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,gBAAgB;QACpB;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,yBAAyB;QAC7B;QACA;;YAEI,gBAAgB;QACpB;QACA;;YAEI,gBAAgB;QACpB;QACA;;YAEI,sBAAsB;QAC1B;QACA;;YAEI,sBAAsB;QAC1B;QACA;;YAEI,qBAAqB;QACzB;QACA;;YAEI,qBAAqB;QACzB;QACA;;YAEI,mBAAmB;QACvB;QACA;;YAEI,mBAAmB;QACvB;QACA;;YAEI,qBAAqB;QACzB;QACA;;YAEI,qBAAqB;QACzB;QACA;;YAEI,mBAAmB;QACvB;QACA;;YAEI,mBAAmB;QACvB;IACJ;IACA;QACI;YACI,YAAY;QAChB;QACA;YACI,cAAc;YACd,WAAW;QACf;QACA;YACI,cAAc;YACd,WAAW;QACf;QACA;YACI,cAAc;YACd,UAAU;QACd;QACA;YACI,cAAc;YACd,mBAAmB;QACvB;QACA;YACI,cAAc;YACd,UAAU;QACd;QACA;YACI,cAAc;YACd,UAAU;QACd;QACA;YACI,cAAc;YACd,mBAAmB;QACvB;QACA;YACI,cAAc;YACd,WAAW;QACf;QACA;YACI,cAAc;YACd,kBAAkB;QACtB;QACA;YACI,cAAc;YACd,mBAAmB;QACvB;QACA;YACI,cAAc;YACd,UAAU;QACd;QACA;YACI,cAAc;YACd,mBAAmB;QACvB;QACA;YACI,cAAc;YACd,mBAAmB;QACvB;QACA;YACI,cAAc;YACd,UAAU;QACd;QACA;YACI,cAAc;YACd,mBAAmB;QACvB;QACA;YACI,cAAc;YACd,mBAAmB;QACvB;QACA;YACI,cAAc;YACd,UAAU;QACd;QACA;YACI,cAAc;YACd,mBAAmB;QACvB;QACA;YACI,cAAc;YACd,mBAAmB;QACvB;QACA;YACI,cAAc;YACd,WAAW;QACf;QACA;YACI,cAAc;QAClB;QACA;YACI,wBAAwB;QAC5B;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,gBAAgB;QACpB;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,gBAAgB;QACpB;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,gBAAgB;QACpB;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,yBAAyB;QAC7B;QACA;;YAEI,gBAAgB;QACpB;QACA;;YAEI,gBAAgB;QACpB;QACA;;YAEI,sBAAsB;QAC1B;QACA;;YAEI,sBAAsB;QAC1B;QACA;;YAEI,qBAAqB;QACzB;QACA;;YAEI,qBAAqB;QACzB;QACA;;YAEI,mBAAmB;QACvB;QACA;;YAEI,mBAAmB;QACvB;QACA;;YAEI,qBAAqB;QACzB;QACA;;YAEI,qBAAqB;QACzB;QACA;;YAEI,mBAAmB;QACvB;QACA;;YAEI,mBAAmB;QACvB;IACJ;IACA;QACI;YACI,YAAY;QAChB;QACA;YACI,cAAc;YACd,WAAW;QACf;QACA;YACI,cAAc;YACd,WAAW;QACf;QACA;YACI,cAAc;YACd,UAAU;QACd;QACA;YACI,cAAc;YACd,mBAAmB;QACvB;QACA;YACI,cAAc;YACd,UAAU;QACd;QACA;YACI,cAAc;YACd,UAAU;QACd;QACA;YACI,cAAc;YACd,mBAAmB;QACvB;QACA;YACI,cAAc;YACd,WAAW;QACf;QACA;YACI,cAAc;YACd,kBAAkB;QACtB;QACA;YACI,cAAc;YACd,mBAAmB;QACvB;QACA;YACI,cAAc;YACd,UAAU;QACd;QACA;YACI,cAAc;YACd,mBAAmB;QACvB;QACA;YACI,cAAc;YACd,mBAAmB;QACvB;QACA;YACI,cAAc;YACd,UAAU;QACd;QACA;YACI,cAAc;YACd,mBAAmB;QACvB;QACA;YACI,cAAc;YACd,mBAAmB;QACvB;QACA;YACI,cAAc;YACd,UAAU;QACd;QACA;YACI,cAAc;YACd,mBAAmB;QACvB;QACA;YACI,cAAc;YACd,mBAAmB;QACvB;QACA;YACI,cAAc;YACd,WAAW;QACf;QACA;YACI,cAAc;QAClB;QACA;YACI,wBAAwB;QAC5B;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,gBAAgB;QACpB;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,gBAAgB;QACpB;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,gBAAgB;QACpB;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,yBAAyB;QAC7B;QACA;;YAEI,gBAAgB;QACpB;QACA;;YAEI,gBAAgB;QACpB;QACA;;YAEI,sBAAsB;QAC1B;QACA;;YAEI,sBAAsB;QAC1B;QACA;;YAEI,qBAAqB;QACzB;QACA;;YAEI,qBAAqB;QACzB;QACA;;YAEI,mBAAmB;QACvB;QACA;;YAEI,mBAAmB;QACvB;QACA;;YAEI,qBAAqB;QACzB;QACA;;YAEI,qBAAqB;QACzB;QACA;;YAEI,mBAAmB;QACvB;QACA;;YAEI,mBAAmB;QACvB;IACJ;IACA;QACI;YACI,YAAY;QAChB;QACA;YACI,cAAc;YACd,WAAW;QACf;QACA;YACI,cAAc;YACd,WAAW;QACf;QACA;YACI,cAAc;YACd,UAAU;QACd;QACA;YACI,cAAc;YACd,mBAAmB;QACvB;QACA;YACI,cAAc;YACd,UAAU;QACd;QACA;YACI,cAAc;YACd,UAAU;QACd;QACA;YACI,cAAc;YACd,mBAAmB;QACvB;QACA;YACI,cAAc;YACd,WAAW;QACf;QACA;YACI,cAAc;YACd,kBAAkB;QACtB;QACA;YACI,cAAc;YACd,mBAAmB;QACvB;QACA;YACI,cAAc;YACd,UAAU;QACd;QACA;YACI,cAAc;YACd,mBAAmB;QACvB;QACA;YACI,cAAc;YACd,mBAAmB;QACvB;QACA;YACI,cAAc;YACd,UAAU;QACd;QACA;YACI,cAAc;YACd,mBAAmB;QACvB;QACA;YACI,cAAc;YACd,mBAAmB;QACvB;QACA;YACI,cAAc;YACd,UAAU;QACd;QACA;YACI,cAAc;YACd,mBAAmB;QACvB;QACA;YACI,cAAc;YACd,mBAAmB;QACvB;QACA;YACI,cAAc;YACd,WAAW;QACf;QACA;YACI,cAAc;QAClB;QACA;YACI,wBAAwB;QAC5B;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,gBAAgB;QACpB;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,gBAAgB;QACpB;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,gBAAgB;QACpB;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,yBAAyB;QAC7B;QACA;;YAEI,gBAAgB;QACpB;QACA;;YAEI,gBAAgB;QACpB;QACA;;YAEI,sBAAsB;QAC1B;QACA;;YAEI,sBAAsB;QAC1B;QACA;;YAEI,qBAAqB;QACzB;QACA;;YAEI,qBAAqB;QACzB;QACA;;YAEI,mBAAmB;QACvB;QACA;;YAEI,mBAAmB;QACvB;QACA;;YAEI,qBAAqB;QACzB;QACA;;YAEI,qBAAqB;QACzB;QACA;;YAEI,mBAAmB;QACvB;QACA;;YAEI,mBAAmB;QACvB;IACJ;IACA;QACI,8BAA8B;QAC9B,2BAA2B;QAC3B,+BAA+B;QAC/B,4BAA4B;QAC5B,0CAA0C;QAC1C,gCAAgC;QAChC,+CAA+C;QAC/C,iCAAiC;QACjC,kDAAkD;QAClD,+DAA+D;QAC/D,iDAAiD;QACjD,6DAA6D;QAC7D,gDAAgD;QAChD,8DAA8D;QAC9D,WAAW;QACX,mBAAmB;QACnB,mBAAmB;QACnB,0CAA0C;IAC9C;IACA;QACI,sBAAsB;QACtB;;;SAGC;QACD,oCAAoC;QACpC,2CAA2C;QAC3C;;;;aAIK;IACT;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,sBAAsB;IAC1B;;IAEA;QACI,+DAA+D;IACnE;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,sCAAsC;IAC1C;IACA;QACI,sCAAsC;IAC1C;;IAEA;QACI,sBAAsB;IAC1B;IACA;QACI,mBAAmB;IACvB;;IAEA;QACI,oDAAoD;QACpD,8CAA8C;IAClD;;IAEA;QACI,oDAAoD;QACpD,8CAA8C;IAClD;;IAEA;QACI,oDAAoD;QACpD,8CAA8C;IAClD;;IAEA;QACI,mDAAmD;QACnD,6CAA6C;IACjD;;IAEA;QACI,sBAAsB;QACtB,sBAAsB;QACtB,gCAAgC;QAChC,8BAA8B;QAC9B,8BAA8B;QAC9B,6BAA6B;QAC7B,6BAA6B;QAC7B,4BAA4B;QAC5B,4BAA4B;QAC5B,4BAA4B;QAC5B,0CAA0C;IAC9C;;IAEA;QACI,sBAAsB;QACtB,sBAAsB;QACtB,gCAAgC;QAChC,8BAA8B;QAC9B,8BAA8B;QAC9B,6BAA6B;QAC7B,6BAA6B;QAC7B,4BAA4B;QAC5B,4BAA4B;QAC5B,4BAA4B;QAC5B,0CAA0C;IAC9C;;IAEA;QACI,sBAAsB;QACtB,sBAAsB;QACtB,gCAAgC;QAChC,8BAA8B;QAC9B,8BAA8B;QAC9B,6BAA6B;QAC7B,6BAA6B;QAC7B,4BAA4B;QAC5B,4BAA4B;QAC5B,4BAA4B;QAC5B,0CAA0C;IAC9C;;IAEA;QACI,sBAAsB;QACtB,sBAAsB;QACtB,gCAAgC;QAChC,8BAA8B;QAC9B,8BAA8B;QAC9B,6BAA6B;QAC7B,6BAA6B;QAC7B,4BAA4B;QAC5B,4BAA4B;QAC5B,4BAA4B;QAC5B,0CAA0C;IAC9C;;IAEA;QACI,sBAAsB;QACtB,sBAAsB;QACtB,gCAAgC;QAChC,8BAA8B;QAC9B,8BAA8B;QAC9B,6BAA6B;QAC7B,6BAA6B;QAC7B,4BAA4B;QAC5B,4BAA4B;QAC5B,4BAA4B;QAC5B,0CAA0C;IAC9C;;IAEA;QACI,sBAAsB;QACtB,sBAAsB;QACtB,gCAAgC;QAChC,8BAA8B;QAC9B,8BAA8B;QAC9B,6BAA6B;QAC7B,6BAA6B;QAC7B,4BAA4B;QAC5B,4BAA4B;QAC5B,4BAA4B;QAC5B,0CAA0C;IAC9C;;IAEA;QACI,sBAAsB;QACtB,sBAAsB;QACtB,gCAAgC;QAChC,8BAA8B;QAC9B,8BAA8B;QAC9B,6BAA6B;QAC7B,6BAA6B;QAC7B,4BAA4B;QAC5B,4BAA4B;QAC5B,4BAA4B;QAC5B,0CAA0C;IAC9C;;IAEA;QACI,sBAAsB;QACtB,sBAAsB;QACtB,gCAAgC;QAChC,8BAA8B;QAC9B,8BAA8B;QAC9B,6BAA6B;QAC7B,6BAA6B;QAC7B,4BAA4B;QAC5B,4BAA4B;QAC5B,4BAA4B;QAC5B,0CAA0C;IAC9C;;IAEA;QACI,gBAAgB;QAChB,iCAAiC;IACrC;;IAEA;QACI;YACI,gBAAgB;YAChB,iCAAiC;QACrC;IACJ;IACA;QACI;YACI,gBAAgB;YAChB,iCAAiC;QACrC;IACJ;IACA;QACI;YACI,gBAAgB;YAChB,iCAAiC;QACrC;IACJ;IACA;QACI;YACI,gBAAgB;YAChB,iCAAiC;QACrC;IACJ;IACA;QACI;YACI,gBAAgB;YAChB,iCAAiC;QACrC;IACJ;IACA;QACI,qBAAqB;IACzB;;IAEA;QACI,oDAAoD;QACpD,uDAAuD;QACvD,gBAAgB;QAChB,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,kDAAkD;QAClD,qDAAqD;QACrD,kBAAkB;IACtB;;IAEA;QACI,mDAAmD;QACnD,sDAAsD;QACtD,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;QACnB,kBAAkB;QAClB,gCAAgC;IACpC;;IAEA;QACI,cAAc;QACd,WAAW;QACX,yBAAyB;QACzB,eAAe;QACf,gBAAgB;QAChB,gBAAgB;QAChB,2BAA2B;QAC3B,wBAAwB;QACxB,qBAAqB;QACrB,gBAAgB;QAChB,mCAAmC;QACnC,4BAA4B;QAC5B,2DAA2D;QAC3D,sCAAsC;QACtC;;wCAEgC;IACpC;IACA;QACI;YACI,gBAAgB;QACpB;IACJ;IACA;QACI,gBAAgB;IACpB;IACA;QACI,eAAe;IACnB;IACA;QACI,2BAA2B;QAC3B,mCAAmC;QACnC,qBAAqB;QACrB,UAAU;QACV,kDAAkD;IACtD;IACA;QACI,eAAe;QACf,aAAa;QACb,SAAS;IACb;IACA;QACI,cAAc;QACd,UAAU;IACd;IACA;QACI,gCAAgC;QAChC,UAAU;IACd;IACA;QACI,gCAAgC;QAChC,UAAU;IACd;IACA;QACI,wCAAwC;QACxC,UAAU;IACd;IACA;QACI,yBAAyB;QACzB,0BAA0B;QAC1B,2BAA2B;QAC3B,0BAA0B;QAC1B,2BAA2B;QAC3B,uCAAuC;QACvC,oBAAoB;QACpB,qBAAqB;QACrB,mBAAmB;QACnB,eAAe;QACf,+CAA+C;QAC/C,gBAAgB;QAChB;;;;wCAIgC;QAChC;;;;wCAIgC;IACpC;IACA;QACI,yBAAyB;QACzB,0BAA0B;QAC1B,2BAA2B;QAC3B,0BAA0B;QAC1B,2BAA2B;QAC3B,uCAAuC;QACvC,oBAAoB;QACpB,qBAAqB;QACrB,mBAAmB;QACnB,eAAe;QACf,+CAA+C;QAC/C,gBAAgB;QAChB;;;;wCAIgC;IACpC;IACA;QACI;YACI,wBAAwB;YACxB,gBAAgB;QACpB;QACA;YACI,gBAAgB;QACpB;IACJ;IACA;;;QAGI,wCAAwC;IAC5C;IACA;QACI,wCAAwC;IAC5C;;IAEA;QACI,cAAc;QACd,WAAW;QACX,mBAAmB;QACnB,gBAAgB;QAChB,gBAAgB;QAChB,2BAA2B;QAC3B,6BAA6B;QAC7B,yBAAyB;QACzB,sCAAsC;IAC1C;IACA;QACI,UAAU;IACd;IACA;;QAEI,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,mEAAmE;QACnE,uBAAuB;QACvB,mBAAmB;QACnB,yCAAyC;IAC7C;IACA;QACI,uBAAuB;QACvB,wBAAwB;QACxB,0BAA0B;QAC1B,yBAAyB;IAC7B;IACA;QACI,uBAAuB;QACvB,wBAAwB;QACxB,0BAA0B;QAC1B,yBAAyB;IAC7B;;IAEA;QACI,iEAAiE;QACjE,oBAAoB;QACpB,kBAAkB;QAClB,yCAAyC;IAC7C;IACA;QACI,oBAAoB;QACpB,qBAAqB;QACrB,wBAAwB;QACxB,uBAAuB;IAC3B;IACA;QACI,oBAAoB;QACpB,qBAAqB;QACrB,wBAAwB;QACxB,uBAAuB;IAC3B;;IAEA;QACI,oEAAoE;IACxE;IACA;QACI,mEAAmE;IACvE;IACA;QACI,iEAAiE;IACrE;;IAEA;QACI,WAAW;QACX,gEAAgE;QAChE,iBAAiB;IACrB;IACA;QACI,eAAe;IACnB;IACA;QACI,oBAAoB;QACpB,sCAAsC;IAC1C;IACA;QACI,oBAAoB;QACpB,sCAAsC;IAC1C;IACA;QACI,+DAA+D;IACnE;IACA;QACI,6DAA6D;IACjE;;IAEA;QACI,gEAAwP;QACxP,cAAc;QACd,WAAW;QACX,0CAA0C;QAC1C,eAAe;QACf,gBAAgB;QAChB,gBAAgB;QAChB,2BAA2B;QAC3B,wBAAwB;QACxB,qBAAqB;QACrB,gBAAgB;QAChB,mCAAmC;QACnC;+CACuC;QACvC,4BAA4B;QAC5B,yCAAyC;QACzC,0BAA0B;QAC1B,2DAA2D;QAC3D,sCAAsC;QACtC;;wCAEgC;IACpC;IACA;QACI;YACI,gBAAgB;QACpB;IACJ;IACA;QACI,qBAAqB;QACrB,UAAU;QACV,kDAAkD;IACtD;IACA;;QAEI,sBAAsB;QACtB,sBAAsB;IAC1B;IACA;QACI,wCAAwC;IAC5C;IACA;QACI,kBAAkB;QAClB,uCAAuC;IAC3C;;IAEA;QACI,oBAAoB;QACpB,uBAAuB;QACvB,oBAAoB;QACpB,mBAAmB;QACnB,yCAAyC;IAC7C;;IAEA;QACI,mBAAmB;QACnB,sBAAsB;QACtB,kBAAkB;QAClB,kBAAkB;QAClB,yCAAyC;IAC7C;;IAEA;QACI,gEAAwP;IAC5P;;IAEA;QACI,cAAc;QACd,kBAAkB;QAClB,mBAAmB;QACnB,uBAAuB;IAC3B;IACA;QACI,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,oBAAoB;QACpB,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,YAAY;QACZ,oBAAoB;QACpB,cAAc;IAClB;;IAEA;QACI,qCAAqC;QACrC,cAAc;QACd,UAAU;QACV,WAAW;QACX,kBAAkB;QAClB,mBAAmB;QACnB,wBAAwB;QACxB,qBAAqB;QACrB,gBAAgB;QAChB,yCAAyC;QACzC,+CAA+C;QAC/C,4BAA4B;QAC5B,2BAA2B;QAC3B,wBAAwB;QACxB,2DAA2D;QAC3D,iCAAiC;QACjC,mBAAmB;QACnB,yBAAyB;IAC7B;IACA;QACI,qBAAqB;IACzB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,qBAAqB;QACrB,UAAU;QACV,kDAAkD;IACtD;IACA;QACI,yBAAyB;QACzB,qBAAqB;IACzB;IACA;QACI,iEAAuP;IAC3P;IACA;QACI,iEAA+J;IACnK;IACA;QACI,yBAAyB;QACzB,qBAAqB;QACrB,iEAAiP;IACrP;IACA;QACI,oBAAoB;QACpB,YAAY;QACZ,YAAY;IAChB;IACA;;QAEI,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,mBAAmB;IACvB;IACA;QACI,4DAA2K;QAC3K,UAAU;QACV,mBAAmB;QACnB,0CAA0C;QAC1C,gCAAgC;QAChC,kBAAkB;QAClB,iDAAiD;IACrD;IACA;QACI;YACI,gBAAgB;QACpB;IACJ;IACA;QACI,4DAA6J;IACjK;IACA;QACI,iCAAiC;QACjC,4DAA0J;IAC9J;IACA;QACI,oBAAoB;QACpB,eAAe;IACnB;IACA;QACI,oBAAoB;QACpB,cAAc;IAClB;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,sBAAsB;QACtB,oBAAoB;IACxB;IACA;;QAEI,oBAAoB;QACpB,YAAY;QACZ,aAAa;IACjB;;IAEA;;;QAGI,4DAAiL;IACrL;;IAEA;QACI,WAAW;QACX,cAAc;QACd,UAAU;QACV,wBAAwB;QACxB,qBAAqB;QACrB,gBAAgB;QAChB,6BAA6B;IACjC;IACA;QACI,UAAU;IACd;IACA;QACI;;kDAE0C;IAC9C;IACA;QACI;;kDAE0C;IAC9C;IACA;QACI,SAAS;IACb;IACA;QACI,WAAW;QACX,YAAY;QACZ,oBAAoB;QACpB,wBAAwB;QACxB,gBAAgB;QAChB,yBAAyB;QACzB,SAAS;QACT,mBAAmB;QACnB;;;wCAGgC;QAChC;;;wCAGgC;IACpC;IACA;QACI;YACI,wBAAwB;YACxB,gBAAgB;QACpB;IACJ;IACA;QACI,yBAAyB;IAC7B;IACA;QACI,WAAW;QACX,cAAc;QACd,kBAAkB;QAClB,eAAe;QACf,wCAAwC;QACxC,yBAAyB;QACzB,mBAAmB;IACvB;IACA;QACI,WAAW;QACX,YAAY;QACZ,qBAAqB;QACrB,gBAAgB;QAChB,yBAAyB;QACzB,SAAS;QACT,mBAAmB;QACnB;;;wCAGgC;QAChC;;;wCAGgC;IACpC;IACA;QACI;YACI,qBAAqB;YACrB,gBAAgB;QACpB;IACJ;IACA;QACI,yBAAyB;IAC7B;IACA;QACI,WAAW;QACX,cAAc;QACd,kBAAkB;QAClB,eAAe;QACf,wCAAwC;QACxC,yBAAyB;QACzB,mBAAmB;IACvB;IACA;QACI,oBAAoB;IACxB;IACA;QACI,2CAA2C;IAC/C;IACA;QACI,2CAA2C;IAC/C;;IAEA;QACI,kBAAkB;IACtB;IACA;;;QAGI,uDAAuD;QACvD,2DAA2D;QAC3D,iBAAiB;IACrB;IACA;QACI,kBAAkB;QAClB,MAAM;QACN,OAAO;QACP,UAAU;QACV,YAAY;QACZ,qBAAqB;QACrB,gBAAgB;QAChB,iBAAiB;QACjB,uBAAuB;QACvB,mBAAmB;QACnB,oBAAoB;QACpB,gDAAgD;QAChD,qBAAqB;QACrB;;sCAE8B;IAClC;IACA;QACI;YACI,gBAAgB;QACpB;IACJ;IACA;;QAEI,qBAAqB;IACzB;IACA;;QAEI,kBAAkB;IACtB;IACA;;QAEI,kBAAkB;IACtB;IACA;;QAEI,qBAAqB;QACrB,wBAAwB;IAC5B;IACA;;;;QAII,qBAAqB;QACrB,wBAAwB;IAC5B;IACA;;QAEI,qBAAqB;QACrB,wBAAwB;IAC5B;IACA;QACI,qBAAqB;QACrB,wBAAwB;IAC5B;IACA;QACI,2CAA2C;QAC3C,8DAA8D;IAClE;IACA;;;;QAII,2CAA2C;QAC3C,8DAA8D;IAClE;IACA;QACI,kBAAkB;QAClB,oBAAoB;QACpB,WAAW;QACX,aAAa;QACb,WAAW;QACX,mCAAmC;QACnC,sCAAsC;IAC1C;IACA;;;;QAII,kBAAkB;QAClB,oBAAoB;QACpB,WAAW;QACX,aAAa;QACb,WAAW;QACX,mCAAmC;QACnC,sCAAsC;IAC1C;IACA;QACI,2CAA2C;QAC3C,8DAA8D;IAClE;IACA;QACI,sCAAsC;IAC1C;IACA;;QAEI,cAAc;IAClB;IACA;;QAEI,wCAAwC;IAC5C;;IAEA;QACI,kBAAkB;QAClB,aAAa;QACb,eAAe;QACf,oBAAoB;QACpB,WAAW;IACf;IACA;;;QAGI,kBAAkB;QAClB,cAAc;QACd,SAAS;QACT,YAAY;IAChB;IACA;;;QAGI,UAAU;IACd;IACA;QACI,kBAAkB;QAClB,UAAU;IACd;IACA;QACI,UAAU;IACd;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,yBAAyB;QACzB,eAAe;QACf,gBAAgB;QAChB,gBAAgB;QAChB,2BAA2B;QAC3B,kBAAkB;QAClB,mBAAmB;QACnB,uCAAuC;QACvC,2DAA2D;QAC3D,sCAAsC;IAC1C;;IAEA;;;;QAII,oBAAoB;QACpB,kBAAkB;QAClB,yCAAyC;IAC7C;;IAEA;;;;QAII,uBAAuB;QACvB,mBAAmB;QACnB,yCAAyC;IAC7C;;IAEA;;QAEI,mBAAmB;IACvB;;IAEA;;;;;;;;;;;QAWI,0BAA0B;QAC1B,6BAA6B;IACjC;IACA;;;;;;;;;;;QAWI,0BAA0B;QAC1B,6BAA6B;IACjC;IACA;;;;QAII,8CAA8C;QAC9C,yBAAyB;QACzB,4BAA4B;IAChC;IACA;;QAEI,yBAAyB;QACzB,4BAA4B;IAChC;;IAEA;QACI,aAAa;QACb,WAAW;QACX,mBAAmB;QACnB,kBAAkB;QAClB,iCAAiC;IACrC;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,UAAU;QACV,aAAa;QACb,eAAe;QACf,uBAAuB;QACvB,kBAAkB;QAClB,mBAAmB;QACnB,WAAW;QACX,mCAAmC;QACnC,sCAAsC;IAC1C;;IAEA;;;;QAII,cAAc;IAClB;;IAEA;;QAEI,+CAA+C;QAC/C,oCAAoC;QACpC,yDAA2P;QAC3P,4BAA4B;QAC5B,2DAA2D;QAC3D,gEAAgE;IACpE;IACA;;QAEI,+CAA+C;QAC/C,2DAA2D;IAC/D;;IAEA;;QAEI,oCAAoC;QACpC;qCAC6B;IACjC;;IAEA;;QAEI,+CAA+C;IACnD;IACA;;;;QAII,iEAAmQ;QACnQ,uBAAuB;QACvB;;gCAEwB;QACxB;;2DAEmD;IACvD;IACA;;QAEI,+CAA+C;QAC/C,2DAA2D;IAC/D;;IAEA;;QAEI,yCAAyC;IAC7C;;IAEA;;QAEI,+CAA+C;IACnD;IACA;;QAEI,4CAA4C;IAChD;IACA;;QAEI,2DAA2D;IAC/D;IACA;;QAEI,iCAAiC;IACrC;;IAEA;QACI,kBAAkB;IACtB;;IAEA;;;;;;QAMI,UAAU;IACd;;IAEA;QACI,aAAa;QACb,WAAW;QACX,mBAAmB;QACnB,kBAAkB;QAClB,mCAAmC;IACvC;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,UAAU;QACV,aAAa;QACb,eAAe;QACf,uBAAuB;QACvB,kBAAkB;QAClB,mBAAmB;QACnB,WAAW;QACX,kCAAkC;QAClC,sCAAsC;IAC1C;;IAEA;;;;QAII,cAAc;IAClB;;IAEA;;QAEI,iDAAiD;QACjD,oCAAoC;QACpC,0DAA4U;QAC5U,4BAA4B;QAC5B,2DAA2D;QAC3D,gEAAgE;IACpE;IACA;;QAEI,iDAAiD;QACjD,0DAA0D;IAC9D;;IAEA;;QAEI,oCAAoC;QACpC;qCAC6B;IACjC;;IAEA;;QAEI,iDAAiD;IACrD;IACA;;;;QAII,kEAAoV;QACpV,uBAAuB;QACvB;;gCAEwB;QACxB;;2DAEmD;IACvD;IACA;;QAEI,iDAAiD;QACjD,0DAA0D;IAC9D;;IAEA;;QAEI,yCAAyC;IAC7C;;IAEA;;QAEI,iDAAiD;IACrD;IACA;;QAEI,8CAA8C;IAClD;IACA;;QAEI,0DAA0D;IAC9D;IACA;;QAEI,mCAAmC;IACvC;;IAEA;QACI,kBAAkB;IACtB;;IAEA;;;;;;QAMI,UAAU;IACd;;IAEA;QACI,2BAA2B;QAC3B,4BAA4B;QAC5B,wBAAwB;QACxB,yBAAyB;QACzB,yBAAyB;QACzB,oCAAoC;QACpC,wBAAwB;QACxB,6CAA6C;QAC7C,kCAAkC;QAClC,+CAA+C;QAC/C,wCAAwC;QACxC;0CACkC;QAClC,+BAA+B;QAC/B;qDAC6C;QAC7C,qBAAqB;QACrB,wDAAwD;QACxD,sCAAsC;QACtC,kCAAkC;QAClC,sCAAsC;QACtC,sCAAsC;QACtC,0BAA0B;QAC1B,kBAAkB;QAClB,qBAAqB;QACrB,sBAAsB;QACtB,eAAe;QACf,yBAAyB;QACzB,sBAAsB;QACtB,iBAAiB;QACjB,mEAAmE;QACnE,0CAA0C;QAC1C,kCAAkC;QAClC;;;;wCAIgC;IACpC;IACA;QACI;YACI,gBAAgB;QACpB;IACJ;IACA;QACI,gCAAgC;QAChC,wCAAwC;QACxC,8CAA8C;IAClD;IACA;QACI,0BAA0B;QAC1B,kCAAkC;QAClC,wCAAwC;IAC5C;IACA;QACI,gCAAgC;QAChC,wCAAwC;QACxC,8CAA8C;QAC9C,UAAU;QACV,0CAA0C;IAC9C;IACA;QACI,8CAA8C;QAC9C,UAAU;QACV,0CAA0C;IAC9C;IACA;;;;;QAKI,iCAAiC;QACjC,yCAAyC;QACzC,+CAA+C;IACnD;IACA;;;;;QAKI,0CAA0C;IAC9C;IACA;QACI,0CAA0C;IAC9C;IACA;;;QAGI,mCAAmC;QACnC,oBAAoB;QACpB,2CAA2C;QAC3C,iDAAiD;QACjD,uCAAuC;IAC3C;;IAEA;QACI,oBAAoB;QACpB,oBAAoB;QACpB,8BAA8B;QAC9B,0BAA0B;QAC1B,0BAA0B;QAC1B,oCAAoC;QACpC,uCAAuC;QACvC,2BAA2B;QAC3B,2BAA2B;QAC3B,qCAAqC;QACrC,4DAA4D;QAC5D,6BAA6B;QAC7B,6BAA6B;QAC7B,uCAAuC;IAC3C;;IAEA;QACI,oBAAoB;QACpB,oBAAoB;QACpB,8BAA8B;QAC9B,0BAA0B;QAC1B,0BAA0B;QAC1B,oCAAoC;QACpC,wCAAwC;QACxC,2BAA2B;QAC3B,2BAA2B;QAC3B,qCAAqC;QACrC,4DAA4D;QAC5D,6BAA6B;QAC7B,6BAA6B;QAC7B,uCAAuC;IAC3C;;IAEA;QACI,oBAAoB;QACpB,oBAAoB;QACpB,8BAA8B;QAC9B,0BAA0B;QAC1B,0BAA0B;QAC1B,oCAAoC;QACpC,uCAAuC;QACvC,2BAA2B;QAC3B,2BAA2B;QAC3B,qCAAqC;QACrC,4DAA4D;QAC5D,6BAA6B;QAC7B,6BAA6B;QAC7B,uCAAuC;IAC3C;;IAEA;QACI,oBAAoB;QACpB,oBAAoB;QACpB,8BAA8B;QAC9B,0BAA0B;QAC1B,0BAA0B;QAC1B,oCAAoC;QACpC,uCAAuC;QACvC,2BAA2B;QAC3B,2BAA2B;QAC3B,qCAAqC;QACrC,4DAA4D;QAC5D,6BAA6B;QAC7B,6BAA6B;QAC7B,uCAAuC;IAC3C;;IAEA;QACI,oBAAoB;QACpB,oBAAoB;QACpB,8BAA8B;QAC9B,0BAA0B;QAC1B,0BAA0B;QAC1B,oCAAoC;QACpC,sCAAsC;QACtC,2BAA2B;QAC3B,2BAA2B;QAC3B,qCAAqC;QACrC,4DAA4D;QAC5D,6BAA6B;QAC7B,6BAA6B;QAC7B,uCAAuC;IAC3C;;IAEA;QACI,oBAAoB;QACpB,oBAAoB;QACpB,8BAA8B;QAC9B,0BAA0B;QAC1B,0BAA0B;QAC1B,oCAAoC;QACpC,sCAAsC;QACtC,2BAA2B;QAC3B,2BAA2B;QAC3B,qCAAqC;QACrC,4DAA4D;QAC5D,6BAA6B;QAC7B,6BAA6B;QAC7B,uCAAuC;IAC3C;;IAEA;QACI,oBAAoB;QACpB,oBAAoB;QACpB,8BAA8B;QAC9B,0BAA0B;QAC1B,0BAA0B;QAC1B,oCAAoC;QACpC,wCAAwC;QACxC,2BAA2B;QAC3B,2BAA2B;QAC3B,qCAAqC;QACrC,4DAA4D;QAC5D,6BAA6B;QAC7B,6BAA6B;QAC7B,uCAAuC;IAC3C;;IAEA;QACI,oBAAoB;QACpB,oBAAoB;QACpB,8BAA8B;QAC9B,0BAA0B;QAC1B,0BAA0B;QAC1B,oCAAoC;QACpC,qCAAqC;QACrC,2BAA2B;QAC3B,2BAA2B;QAC3B,qCAAqC;QACrC,4DAA4D;QAC5D,6BAA6B;QAC7B,6BAA6B;QAC7B,uCAAuC;IAC3C;;IAEA;QACI,uBAAuB;QACvB,8BAA8B;QAC9B,0BAA0B;QAC1B,0BAA0B;QAC1B,oCAAoC;QACpC,uCAAuC;QACvC,2BAA2B;QAC3B,2BAA2B;QAC3B,qCAAqC;QACrC,4DAA4D;QAC5D,gCAAgC;QAChC,iCAAiC;QACjC,uCAAuC;QACvC,mBAAmB;IACvB;;IAEA;QACI,uBAAuB;QACvB,8BAA8B;QAC9B,0BAA0B;QAC1B,0BAA0B;QAC1B,oCAAoC;QACpC,wCAAwC;QACxC,2BAA2B;QAC3B,2BAA2B;QAC3B,qCAAqC;QACrC,4DAA4D;QAC5D,gCAAgC;QAChC,iCAAiC;QACjC,uCAAuC;QACvC,mBAAmB;IACvB;;IAEA;QACI,uBAAuB;QACvB,8BAA8B;QAC9B,0BAA0B;QAC1B,0BAA0B;QAC1B,oCAAoC;QACpC,sCAAsC;QACtC,2BAA2B;QAC3B,2BAA2B;QAC3B,qCAAqC;QACrC,4DAA4D;QAC5D,gCAAgC;QAChC,iCAAiC;QACjC,uCAAuC;QACvC,mBAAmB;IACvB;;IAEA;QACI,uBAAuB;QACvB,8BAA8B;QAC9B,0BAA0B;QAC1B,0BAA0B;QAC1B,oCAAoC;QACpC,uCAAuC;QACvC,2BAA2B;QAC3B,2BAA2B;QAC3B,qCAAqC;QACrC,4DAA4D;QAC5D,gCAAgC;QAChC,iCAAiC;QACjC,uCAAuC;QACvC,mBAAmB;IACvB;;IAEA;QACI,uBAAuB;QACvB,8BAA8B;QAC9B,0BAA0B;QAC1B,0BAA0B;QAC1B,oCAAoC;QACpC,sCAAsC;QACtC,2BAA2B;QAC3B,2BAA2B;QAC3B,qCAAqC;QACrC,4DAA4D;QAC5D,gCAAgC;QAChC,iCAAiC;QACjC,uCAAuC;QACvC,mBAAmB;IACvB;;IAEA;QACI,uBAAuB;QACvB,8BAA8B;QAC9B,0BAA0B;QAC1B,0BAA0B;QAC1B,oCAAoC;QACpC,sCAAsC;QACtC,2BAA2B;QAC3B,2BAA2B;QAC3B,qCAAqC;QACrC,4DAA4D;QAC5D,gCAAgC;QAChC,iCAAiC;QACjC,uCAAuC;QACvC,mBAAmB;IACvB;;IAEA;QACI,uBAAuB;QACvB,8BAA8B;QAC9B,0BAA0B;QAC1B,0BAA0B;QAC1B,oCAAoC;QACpC,wCAAwC;QACxC,2BAA2B;QAC3B,2BAA2B;QAC3B,qCAAqC;QACrC,4DAA4D;QAC5D,gCAAgC;QAChC,iCAAiC;QACjC,uCAAuC;QACvC,mBAAmB;IACvB;;IAEA;QACI,uBAAuB;QACvB,8BAA8B;QAC9B,0BAA0B;QAC1B,0BAA0B;QAC1B,oCAAoC;QACpC,qCAAqC;QACrC,2BAA2B;QAC3B,2BAA2B;QAC3B,qCAAqC;QACrC,4DAA4D;QAC5D,gCAAgC;QAChC,iCAAiC;QACjC,uCAAuC;QACvC,mBAAmB;IACvB;;IAEA;QACI,yBAAyB;QACzB,oCAAoC;QACpC,wBAAwB;QACxB,kCAAkC;QAClC,gDAAgD;QAChD,wCAAwC;QACxC,iDAAiD;QACjD,yCAAyC;QACzC,gCAAgC;QAChC,2CAA2C;QAC3C,+BAA+B;QAC/B,uCAAuC;QACvC,0BAA0B;IAC9B;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,gCAAgC;IACpC;;IAEA;;QAEI,0BAA0B;QAC1B,wBAAwB;QACxB,2BAA2B;QAC3B,kDAAkD;IACtD;;IAEA;;QAEI,2BAA2B;QAC3B,0BAA0B;QAC1B,4BAA4B;QAC5B,kDAAkD;IACtD;;IAEA;QACI,gCAAgC;IACpC;IACA;QACI;YACI,gBAAgB;QACpB;IACJ;IACA;QACI,UAAU;IACd;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,SAAS;QACT,gBAAgB;QAChB,6BAA6B;IACjC;IACA;QACI;YACI,gBAAgB;QACpB;IACJ;IACA;QACI,QAAQ;QACR,YAAY;QACZ,4BAA4B;IAChC;IACA;QACI;YACI,gBAAgB;QACpB;IACJ;;IAEA;;;;;;QAMI,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;IACvB;IACA;QACI,qBAAqB;QACrB,oBAAoB;QACpB,uBAAuB;QACvB,WAAW;QACX,uBAAuB;QACvB,qCAAqC;QACrC,gBAAgB;QAChB,oCAAoC;IACxC;IACA;QACI,cAAc;IAClB;;IAEA;QACI,0BAA0B;QAC1B,8BAA8B;QAC9B,0BAA0B;QAC1B,+BAA+B;QAC/B,8BAA8B;QAC9B,6BAA6B;QAC7B,yCAAyC;QACzC,mCAAmC;QACnC,8DAA8D;QAC9D,oDAAoD;QACpD,kDAAkD;QAClD;;SAEC;QACD,4DAA4D;QAC5D,sCAAsC;QACtC,8CAA8C;QAC9C,8CAA8C;QAC9C,oDAAoD;QACpD,kDAAkD;QAClD,qCAAqC;QACrC,qCAAqC;QACrC,2DAA2D;QAC3D,kCAAkC;QAClC,qCAAqC;QACrC,mCAAmC;QACnC,oCAAoC;QACpC,sCAAsC;QACtC,kBAAkB;QAClB,kCAAkC;QAClC,aAAa;QACb,uCAAuC;QACvC,kEAAkE;QAClE,SAAS;QACT,uCAAuC;QACvC,+BAA+B;QAC/B,gBAAgB;QAChB,gBAAgB;QAChB,uCAAuC;QACvC,4BAA4B;QAC5B;2CACmC;QACnC,+CAA+C;IACnD;IACA;QACI,SAAS;QACT,OAAO;QACP,qCAAqC;IACzC;;IAEA;QACI,oBAAoB;IACxB;IACA;QACI,WAAW;QACX,OAAO;IACX;;IAEA;QACI,kBAAkB;IACtB;IACA;QACI,QAAQ;QACR,UAAU;IACd;;IAEA;QACI;YACI,oBAAoB;QACxB;QACA;YACI,WAAW;YACX,OAAO;QACX;QACA;YACI,kBAAkB;QACtB;QACA;YACI,QAAQ;YACR,UAAU;QACd;IACJ;IACA;QACI;YACI,oBAAoB;QACxB;QACA;YACI,WAAW;YACX,OAAO;QACX;QACA;YACI,kBAAkB;QACtB;QACA;YACI,QAAQ;YACR,UAAU;QACd;IACJ;IACA;QACI;YACI,oBAAoB;QACxB;QACA;YACI,WAAW;YACX,OAAO;QACX;QACA;YACI,kBAAkB;QACtB;QACA;YACI,QAAQ;YACR,UAAU;QACd;IACJ;IACA;QACI;YACI,oBAAoB;QACxB;QACA;YACI,WAAW;YACX,OAAO;QACX;QACA;YACI,kBAAkB;QACtB;QACA;YACI,QAAQ;YACR,UAAU;QACd;IACJ;IACA;QACI;YACI,oBAAoB;QACxB;QACA;YACI,WAAW;YACX,OAAO;QACX;QACA;YACI,kBAAkB;QACtB;QACA;YACI,QAAQ;YACR,UAAU;QACd;IACJ;IACA;QACI,SAAS;QACT,YAAY;QACZ,aAAa;QACb,wCAAwC;IAC5C;IACA;QACI,qBAAqB;QACrB,oBAAoB;QACpB,uBAAuB;QACvB,WAAW;QACX,aAAa;QACb,qCAAqC;QACrC,0BAA0B;QAC1B,oCAAoC;IACxC;IACA;QACI,cAAc;IAClB;;IAEA;QACI,MAAM;QACN,WAAW;QACX,UAAU;QACV,aAAa;QACb,sCAAsC;IAC1C;IACA;QACI,qBAAqB;QACrB,oBAAoB;QACpB,uBAAuB;QACvB,WAAW;QACX,mCAAmC;QACnC,eAAe;QACf,sCAAsC;QACtC,wBAAwB;IAC5B;IACA;QACI,cAAc;IAClB;IACA;QACI,iBAAiB;IACrB;;IAEA;QACI,MAAM;QACN,WAAW;QACX,UAAU;QACV,aAAa;QACb,uCAAuC;IAC3C;IACA;QACI,qBAAqB;QACrB,oBAAoB;QACpB,uBAAuB;QACvB,WAAW;IACf;IACA;QACI,aAAa;IACjB;IACA;QACI,qBAAqB;QACrB,qBAAqB;QACrB,uBAAuB;QACvB,WAAW;QACX,mCAAmC;QACnC,yBAAyB;QACzB,sCAAsC;IAC1C;IACA;QACI,cAAc;IAClB;IACA;QACI,iBAAiB;IACrB;;IAEA;QACI,SAAS;QACT,6CAA6C;QAC7C,gBAAgB;QAChB,mDAAmD;QACnD,UAAU;IACd;;IAEA;QACI,cAAc;QACd,WAAW;QACX;6CACqC;QACrC,WAAW;QACX,gBAAgB;QAChB,oCAAoC;QACpC,mBAAmB;QACnB,qBAAqB;QACrB,mBAAmB;QACnB,6BAA6B;QAC7B,SAAS;QACT,uDAAuD;IAC3D;IACA;;QAEI,0CAA0C;QAC1C,kDAAkD;IACtD;IACA;;QAEI,2CAA2C;QAC3C,qBAAqB;QACrB,mDAAmD;IACvD;IACA;;QAEI,6CAA6C;QAC7C,oBAAoB;QACpB,6BAA6B;IACjC;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;QACd;+CACuC;QACvC,gBAAgB;QAChB,mBAAmB;QACnB,sCAAsC;QACtC,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd;6CACqC;QACrC,oCAAoC;IACxC;;IAEA;QACI,4BAA4B;QAC5B,yBAAyB;QACzB,8DAA8D;QAC9D,0BAA0B;QAC1B,iCAAiC;QACjC,oCAAoC;QACpC,4DAA4D;QAC5D,sDAAsD;QACtD,qCAAqC;QACrC,qCAAqC;QACrC,0CAA0C;QAC1C,mCAAmC;IACvC;;IAEA;;QAEI,kBAAkB;QAClB,oBAAoB;QACpB,sBAAsB;IAC1B;IACA;;QAEI,kBAAkB;QAClB,cAAc;IAClB;IACA;;;;;;;;;;;;QAYI,UAAU;IACd;;IAEA;QACI,aAAa;QACb,eAAe;QACf,2BAA2B;IAC/B;IACA;QACI,WAAW;IACf;;IAEA;QACI,sCAAsC;IAC1C;IACA;;QAEI,8CAA8C;IAClD;IACA;;;QAGI,0BAA0B;QAC1B,6BAA6B;IACjC;IACA;;;QAGI,yBAAyB;QACzB,4BAA4B;IAChC;;IAEA;QACI,wBAAwB;QACxB,uBAAuB;IAC3B;IACA;;;QAGI,cAAc;IAClB;IACA;QACI,eAAe;IACnB;;IAEA;;QAEI,uBAAuB;QACvB,sBAAsB;IAC1B;;IAEA;;QAEI,sBAAsB;QACtB,qBAAqB;IACzB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,uBAAuB;IAC3B;IACA;;QAEI,WAAW;IACf;IACA;;QAEI,6CAA6C;IACjD;IACA;;QAEI,6BAA6B;QAC7B,4BAA4B;IAChC;IACA;;QAEI,yBAAyB;QACzB,0BAA0B;IAC9B;;IAEA;QACI,6BAA6B;QAC7B,+BAA+B;QAC/B,2BAA2B;QAC3B,yCAAyC;QACzC,qDAAqD;QACrD,uDAAuD;QACvD,aAAa;QACb,eAAe;QACf,eAAe;QACf,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,kEAAkE;QAClE,uCAAuC;QACvC,2CAA2C;QAC3C,+BAA+B;QAC/B,qBAAqB;QACrB,gBAAgB;QAChB,SAAS;QACT;;;0CAGkC;IACtC;IACA;QACI;YACI,gBAAgB;QACpB;IACJ;IACA;;QAEI,qCAAqC;IACzC;IACA;QACI,UAAU;QACV,kDAAkD;IACtD;IACA;;QAEI,wCAAwC;QACxC,oBAAoB;QACpB,eAAe;IACnB;;IAEA;QACI,kDAAkD;QAClD,kDAAkD;QAClD,oDAAoD;QACpD;yDACiD;QACjD,yDAAyD;QACzD,+CAA+C;QAC/C;oDAC4C;QAC5C;2CACmC;IACvC;IACA;QACI,yDAAyD;QACzD,yDAAyD;QACzD,wDAAwD;QACxD,yDAAyD;IAC7D;IACA;;QAEI,kBAAkB;QAClB,wDAAwD;IAC5D;IACA;;QAEI,2CAA2C;QAC3C,mDAAmD;QACnD,yDAAyD;IAC7D;IACA;QACI,sDAAsD;QACtD,yBAAyB;QACzB,0BAA0B;IAC9B;;IAEA;QACI,qDAAqD;QACrD,sCAAsC;QACtC,sCAAsC;IAC1C;IACA;QACI,gDAAgD;IACpD;IACA;;QAEI,4CAA4C;QAC5C,oDAAoD;IACxD;;IAEA;QACI,4BAA4B;QAC5B,yCAAyC;QACzC,8DAA8D;QAC9D,gCAAgC;IACpC;IACA;QACI,gBAAgB;QAChB,eAAe;QACf,qEAAqE;IACzE;IACA;;QAEI,iCAAiC;IACrC;IACA;;QAEI,gBAAgB;QAChB,gDAAgD;QAChD,iCAAiC;IACrC;;IAEA;;QAEI,cAAc;QACd,kBAAkB;IACtB;;IAEA;;QAEI,aAAa;QACb,YAAY;QACZ,kBAAkB;IACtB;;IAEA;;QAEI,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;IACA;QACI,cAAc;IAClB;;IAEA;QACI,wBAAwB;QACxB,6BAA6B;QAC7B,2DAA2D;QAC3D,gEAAgE;QAChE,mEAAmE;QACnE,+DAA+D;QAC/D,sCAAsC;QACtC,kCAAkC;QAClC,oCAAoC;QACpC,8DAA8D;QAC9D,oEAAoE;QACpE,sCAAsC;QACtC,sCAAsC;QACtC,sCAAsC;QACtC,sCAAsC;QACtC,qEAA2Q;QAC3Q;;;SAGC;QACD,0DAA0D;QAC1D,wCAAwC;QACxC,4DAA4D;QAC5D,kBAAkB;QAClB,aAAa;QACb,eAAe;QACf,mBAAmB;QACnB,8BAA8B;QAC9B,8DAA8D;IAClE;IACA;;;;;;;QAOI,aAAa;QACb,kBAAkB;QAClB,mBAAmB;QACnB,8BAA8B;IAClC;IACA;QACI,6CAA6C;QAC7C,gDAAgD;QAChD,+CAA+C;QAC/C,2CAA2C;QAC3C,mCAAmC;QACnC,qBAAqB;QACrB,mBAAmB;IACvB;IACA;;QAEI,yCAAyC;IAC7C;;IAEA;QACI,0BAA0B;QAC1B,+BAA+B;QAC/B,2BAA2B;QAC3B,2CAA2C;QAC3C,uDAAuD;QACvD,6DAA6D;QAC7D,aAAa;QACb,sBAAsB;QACtB,eAAe;QACf,gBAAgB;QAChB,gBAAgB;IACpB;IACA;;QAEI,oCAAoC;IACxC;IACA;QACI,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;QACnB,sBAAsB;QACtB,6BAA6B;IACjC;IACA;;;QAGI,oCAAoC;IACxC;;IAEA;QACI,gBAAgB;QAChB,YAAY;QACZ,mBAAmB;IACvB;;IAEA;QACI;8CACsC;QACtC,6CAA6C;QAC7C,cAAc;QACd,6BAA6B;QAC7B,6BAA6B;QAC7B;iDACyC;QACzC,qDAAqD;QACrD,+CAA+C;IACnD;IACA;QACI;YACI,gBAAgB;QACpB;IACJ;IACA;QACI,qBAAqB;IACzB;IACA;QACI,qBAAqB;QACrB,UAAU;QACV,sDAAsD;IAC1D;;IAEA;QACI,qBAAqB;QACrB,YAAY;QACZ,aAAa;QACb,sBAAsB;QACtB,kDAAkD;QAClD,4BAA4B;QAC5B,2BAA2B;QAC3B,qBAAqB;IACzB;;IAEA;QACI,yCAAyC;QACzC,gBAAgB;IACpB;;IAEA;QACI;YACI,iBAAiB;YACjB,2BAA2B;QAC/B;QACA;YACI,mBAAmB;QACvB;QACA;YACI,kBAAkB;QACtB;QACA;YACI,kDAAkD;YAClD,iDAAiD;QACrD;QACA;YACI,iBAAiB;QACrB;QACA;YACI,wBAAwB;YACxB,gBAAgB;QACpB;QACA;YACI,aAAa;QACjB;QACA;YACI,gBAAgB;YAChB,aAAa;YACb,YAAY;YACZ,sBAAsB;YACtB,uBAAuB;YACvB,8BAA8B;YAC9B,wCAAwC;YACxC,oBAAoB;YACpB,0BAA0B;YAC1B,gBAAgB;QACpB;QACA;YACI,aAAa;QACjB;QACA;YACI,aAAa;YACb,YAAY;YACZ,UAAU;YACV,mBAAmB;QACvB;IACJ;IACA;QACI;YACI,iBAAiB;YACjB,2BAA2B;QAC/B;QACA;YACI,mBAAmB;QACvB;QACA;YACI,kBAAkB;QACtB;QACA;YACI,kDAAkD;YAClD,iDAAiD;QACrD;QACA;YACI,iBAAiB;QACrB;QACA;YACI,wBAAwB;YACxB,gBAAgB;QACpB;QACA;YACI,aAAa;QACjB;QACA;YACI,gBAAgB;YAChB,aAAa;YACb,YAAY;YACZ,sBAAsB;YACtB,uBAAuB;YACvB,8BAA8B;YAC9B,wCAAwC;YACxC,oBAAoB;YACpB,0BAA0B;YAC1B,gBAAgB;QACpB;QACA;YACI,aAAa;QACjB;QACA;YACI,aAAa;YACb,YAAY;YACZ,UAAU;YACV,mBAAmB;QACvB;IACJ;IACA;QACI;YACI,iBAAiB;YACjB,2BAA2B;QAC/B;QACA;YACI,mBAAmB;QACvB;QACA;YACI,kBAAkB;QACtB;QACA;YACI,kDAAkD;YAClD,iDAAiD;QACrD;QACA;YACI,iBAAiB;QACrB;QACA;YACI,wBAAwB;YACxB,gBAAgB;QACpB;QACA;YACI,aAAa;QACjB;QACA;YACI,gBAAgB;YAChB,aAAa;YACb,YAAY;YACZ,sBAAsB;YACtB,uBAAuB;YACvB,8BAA8B;YAC9B,wCAAwC;YACxC,oBAAoB;YACpB,0BAA0B;YAC1B,gBAAgB;QACpB;QACA;YACI,aAAa;QACjB;QACA;YACI,aAAa;YACb,YAAY;YACZ,UAAU;YACV,mBAAmB;QACvB;IACJ;IACA;QACI;YACI,iBAAiB;YACjB,2BAA2B;QAC/B;QACA;YACI,mBAAmB;QACvB;QACA;YACI,kBAAkB;QACtB;QACA;YACI,kDAAkD;YAClD,iDAAiD;QACrD;QACA;YACI,iBAAiB;QACrB;QACA;YACI,wBAAwB;YACxB,gBAAgB;QACpB;QACA;YACI,aAAa;QACjB;QACA;YACI,gBAAgB;YAChB,aAAa;YACb,YAAY;YACZ,sBAAsB;YACtB,uBAAuB;YACvB,8BAA8B;YAC9B,wCAAwC;YACxC,oBAAoB;YACpB,0BAA0B;YAC1B,gBAAgB;QACpB;QACA;YACI,aAAa;QACjB;QACA;YACI,aAAa;YACb,YAAY;YACZ,UAAU;YACV,mBAAmB;QACvB;IACJ;IACA;QACI;YACI,iBAAiB;YACjB,2BAA2B;QAC/B;QACA;YACI,mBAAmB;QACvB;QACA;YACI,kBAAkB;QACtB;QACA;YACI,kDAAkD;YAClD,iDAAiD;QACrD;QACA;YACI,iBAAiB;QACrB;QACA;YACI,wBAAwB;YACxB,gBAAgB;QACpB;QACA;YACI,aAAa;QACjB;QACA;YACI,gBAAgB;YAChB,aAAa;YACb,YAAY;YACZ,sBAAsB;YACtB,uBAAuB;YACvB,8BAA8B;YAC9B,wCAAwC;YACxC,oBAAoB;YACpB,0BAA0B;YAC1B,gBAAgB;QACpB;QACA;YACI,aAAa;QACjB;QACA;YACI,aAAa;YACb,YAAY;YACZ,UAAU;YACV,mBAAmB;QACvB;IACJ;IACA;QACI,iBAAiB;QACjB,2BAA2B;IAC/B;IACA;QACI,mBAAmB;IACvB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,kDAAkD;QAClD,iDAAiD;IACrD;IACA;QACI,iBAAiB;IACrB;IACA;QACI,wBAAwB;QACxB,gBAAgB;IACpB;IACA;QACI,aAAa;IACjB;IACA;QACI,gBAAgB;QAChB,aAAa;QACb,YAAY;QACZ,sBAAsB;QACtB,uBAAuB;QACvB,8BAA8B;QAC9B,wCAAwC;QACxC,oBAAoB;QACpB,0BAA0B;QAC1B,gBAAgB;IACpB;IACA;QACI,aAAa;IACjB;IACA;QACI,aAAa;QACb,YAAY;QACZ,UAAU;QACV,mBAAmB;IACvB;;IAEA;;QAEI,4CAA4C;QAC5C,kDAAkD;QAClD,qDAAqD;QACrD,8BAA8B;QAC9B,6BAA6B;QAC7B,mCAAmC;QACnC,0DAA0D;QAC1D,qEAA8Q;IAClR;;IAEA;QACI,qEAA8Q;IAClR;;IAEA;QACI,wBAAwB;QACxB,wBAAwB;QACxB,gCAAgC;QAChC,uBAAuB;QACvB,0BAA0B;QAC1B,8CAA8C;QAC9C,0DAA0D;QAC1D,gDAAgD;QAChD,sBAAsB;QACtB;;SAEC;QACD,+BAA+B;QAC/B,6BAA6B;QAC7B,sDAAsD;QACtD,qBAAqB;QACrB,kBAAkB;QAClB,iBAAiB;QACjB,+BAA+B;QAC/B,mCAAmC;QACnC,+BAA+B;QAC/B,kBAAkB;QAClB,aAAa;QACb,sBAAsB;QACtB,YAAY;QACZ,6BAA6B;QAC7B,2BAA2B;QAC3B,qBAAqB;QACrB,mCAAmC;QACnC,2BAA2B;QAC3B,qEAAqE;QACrE,2CAA2C;IAC/C;IACA;QACI,eAAe;QACf,cAAc;IAClB;IACA;QACI,mBAAmB;QACnB,sBAAsB;IAC1B;IACA;QACI,mBAAmB;QACnB,0DAA0D;QAC1D,2DAA2D;IAC/D;IACA;QACI,sBAAsB;QACtB,8DAA8D;QAC9D,6DAA6D;IACjE;IACA;;QAEI,aAAa;IACjB;;IAEA;QACI,cAAc;QACd,wDAAwD;QACxD,2BAA2B;IAC/B;;IAEA;QACI,4CAA4C;QAC5C,iCAAiC;IACrC;;IAEA;QACI,sDAAsD;QACtD,gBAAgB;QAChB,oCAAoC;IACxC;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,oCAAoC;IACxC;;IAEA;QACI,kEAAkE;QAClE,gBAAgB;QAChB,+BAA+B;QAC/B,uCAAuC;QACvC;uCAC+B;IACnC;IACA;QACI;kDAC0C;IAC9C;;IAEA;QACI,kEAAkE;QAClE,+BAA+B;QAC/B,uCAAuC;QACvC;uCAC+B;IACnC;IACA;QACI;8CACsC;IAC1C;;IAEA;QACI,uDAAuD;QACvD,sDAAsD;QACtD,sDAAsD;QACtD,gBAAgB;IACpB;IACA;QACI,mCAAmC;QACnC,sCAAsC;IAC1C;;IAEA;QACI,uDAAuD;QACvD,sDAAsD;IAC1D;;IAEA;QACI,kBAAkB;QAClB,MAAM;QACN,QAAQ;QACR,SAAS;QACT,OAAO;QACP,2CAA2C;QAC3C,iDAAiD;IACrD;;IAEA;;;QAGI,WAAW;IACf;;IAEA;;QAEI,0DAA0D;QAC1D,2DAA2D;IAC/D;;IAEA;;QAEI,8DAA8D;QAC9D,6DAA6D;IACjE;;IAEA;QACI,0CAA0C;IAC9C;IACA;QACI;YACI,aAAa;YACb,mBAAmB;QACvB;QACA;YACI,YAAY;YACZ,gBAAgB;QACpB;QACA;YACI,cAAc;YACd,cAAc;QAClB;QACA;YACI,0BAA0B;YAC1B,6BAA6B;QACjC;QACA;;YAEI,0BAA0B;QAC9B;QACA;;YAEI,6BAA6B;QACjC;QACA;YACI,yBAAyB;YACzB,4BAA4B;QAChC;QACA;;YAEI,yBAAyB;QAC7B;QACA;;YAEI,4BAA4B;QAChC;IACJ;;IAEA;QACI,0CAA0C;QAC1C,oCAAoC;QACpC;;kEAE0D;QAC1D,mDAAmD;QACnD,mDAAmD;QACnD,qDAAqD;QACrD;;SAEC;QACD,qCAAqC;QACrC,kCAAkC;QAClC,8CAA8C;QAC9C,6CAA6C;QAC7C,iEAAyO;QACzO,sCAAsC;QACtC,kDAAkD;QAClD,8DAA8D;QAC9D,wEAAgP;QAChP;oCAC4B;QAC5B,sCAAsC;QACtC,mCAAmC;QACnC,4DAA4D;QAC5D,qDAAqD;IACzD;;IAEA;QACI,kBAAkB;QAClB,aAAa;QACb,mBAAmB;QACnB,WAAW;QACX;6CACqC;QACrC,eAAe;QACf,oCAAoC;QACpC,gBAAgB;QAChB,4CAA4C;QAC5C,SAAS;QACT,gBAAgB;QAChB,qBAAqB;QACrB,0CAA0C;IAC9C;IACA;QACI;YACI,gBAAgB;QACpB;IACJ;IACA;QACI,uCAAuC;QACvC,+CAA+C;QAC/C;4CACoC;IACxC;IACA;QACI,qDAAqD;QACrD,iDAAiD;IACrD;IACA;QACI,cAAc;QACd,yCAAyC;QACzC,0CAA0C;QAC1C,iBAAiB;QACjB,WAAW;QACX,8CAA8C;QAC9C,4BAA4B;QAC5B,mDAAmD;QACnD,mDAAmD;IACvD;IACA;QACI;YACI,gBAAgB;QACpB;IACJ;IACA;QACI,UAAU;IACd;IACA;QACI,UAAU;QACV,UAAU;QACV,oDAAoD;IACxD;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gCAAgC;QAChC,wCAAwC;QACxC;4CACoC;IACxC;IACA;QACI,yDAAyD;QACzD,0DAA0D;IAC9D;IACA;QACI,+DAA+D;QAC/D,gEAAgE;IACpE;IACA;QACI,aAAa;IACjB;IACA;QACI,6DAA6D;QAC7D,4DAA4D;IAChE;IACA;;;QAGI,mEAAmE;QACnE,kEAAkE;IACtE;IACA;QACI,6DAA6D;QAC7D,4DAA4D;IAChE;;IAEA;QACI;8CACsC;IAC1C;;IAEA;QACI,eAAe;QACf,cAAc;QACd,gBAAgB;IACpB;IACA;QACI,aAAa;IACjB;IACA;QACI,gBAAgB;IACpB;IACA;;;;;QAKI,gBAAgB;IACpB;IACA;QACI,gBAAgB;IACpB;;IAEA;QACI,iEAAwS;QACxS,wEAA+S;IACnT;;IAEA;QACI,4BAA4B;QAC5B,4BAA4B;QAC5B,mCAAmC;QACnC,oBAAoB;QACpB,+BAA+B;QAC/B,wDAAwD;QACxD,sCAAsC;QACtC,4DAA4D;QAC5D,aAAa;QACb,eAAe;QACf,sEAAsE;QACtE,iDAAiD;QACjD,yCAAyC;QACzC,gBAAgB;QAChB,yCAAyC;QACzC,iDAAiD;IACrD;;IAEA;QACI,iDAAiD;IACrD;IACA;QACI,WAAW;QACX,kDAAkD;QAClD,yCAAyC;QACzC;wDACgD;IACpD;IACA;QACI,6CAA6C;IACjD;;IAEA;QACI,kCAAkC;QAClC,mCAAmC;QACnC,+BAA+B;QAC/B,2CAA2C;QAC3C,qCAAqC;QACrC,oDAAoD;QACpD,oDAAoD;QACpD,sDAAsD;QACtD,uDAAuD;QACvD,+CAA+C;QAC/C,0DAA0D;QAC1D,uDAAuD;QACvD,gDAAgD;QAChD,wEAAwE;QACxE,kCAAkC;QAClC,kCAAkC;QAClC,4CAA4C;QAC5C,yDAAyD;QACzD,mDAAmD;QACnD,6DAA6D;QAC7D,aAAa;QACb,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,cAAc;QACd,sEAAsE;QACtE,yCAAyC;QACzC,iCAAiC;QACjC,qBAAqB;QACrB,yCAAyC;QACzC;6CACqC;QACrC;;;;wCAIgC;IACpC;IACA;QACI;YACI,gBAAgB;QACpB;IACJ;IACA;QACI,UAAU;QACV,uCAAuC;QACvC,+CAA+C;QAC/C,qDAAqD;IACzD;IACA;QACI,UAAU;QACV,uCAAuC;QACvC,+CAA+C;QAC/C,UAAU;QACV,iDAAiD;IACrD;IACA;;QAEI,UAAU;QACV,wCAAwC;QACxC,gDAAgD;QAChD,sDAAsD;IAC1D;IACA;;QAEI,0CAA0C;QAC1C,oBAAoB;QACpB,kDAAkD;QAClD,wDAAwD;IAC5D;;IAEA;QACI,8CAA8C;IAClD;IACA;QACI,0DAA0D;QAC1D,6DAA6D;IACjE;IACA;QACI,2DAA2D;QAC3D,8DAA8D;IAClE;;IAEA;QACI,iCAAiC;QACjC,kCAAkC;QAClC,kCAAkC;QAClC,yDAAyD;IAC7D;;IAEA;QACI,iCAAiC;QACjC,kCAAkC;QAClC,mCAAmC;QACnC,yDAAyD;IAC7D;;IAEA;QACI,4BAA4B;QAC5B,4BAA4B;QAC5B,4BAA4B;QAC5B,2BAA2B;QAC3B,sBAAsB;QACtB,iDAAiD;QACjD,qBAAqB;QACrB,4DAA4D;QAC5D,oCAAoC;QACpC,wCAAwC;QACxC,cAAc;QACd,4BAA4B;QAC5B,kBAAkB;QAClB,mBAAmB;QACnB,wBAAwB;QACxB,4CAA4C;IAChD;IACA;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;QAClB,SAAS;IACb;;IAEA;QACI,0BAA0B;QAC1B,0BAA0B;QAC1B,0BAA0B;QAC1B,8BAA8B;QAC9B,yBAAyB;QACzB,oCAAoC;QACpC;wCACgC;QAChC,iDAAiD;QACjD,8BAA8B;QAC9B,kBAAkB;QAClB,4DAA4D;QAC5D,4CAA4C;QAC5C,4BAA4B;QAC5B,oCAAoC;QACpC,8BAA8B;QAC9B,4CAA4C;IAChD;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,gBAAgB;QAChB,iCAAiC;IACrC;;IAEA;QACI,mBAAmB;IACvB;IACA;QACI,kBAAkB;QAClB,MAAM;QACN,QAAQ;QACR,UAAU;QACV,qBAAqB;IACzB;;IAEA;QACI,iDAAiD;QACjD,0CAA0C;QAC1C,wDAAwD;QACxD,sDAAsD;IAC1D;;IAEA;QACI,mDAAmD;QACnD,4CAA4C;QAC5C,0DAA0D;QAC1D,wDAAwD;IAC5D;;IAEA;QACI,iDAAiD;QACjD,0CAA0C;QAC1C,wDAAwD;QACxD,sDAAsD;IAC1D;;IAEA;QACI,8CAA8C;QAC9C,uCAAuC;QACvC,qDAAqD;QACrD,mDAAmD;IACvD;;IAEA;QACI,iDAAiD;QACjD,0CAA0C;QAC1C,wDAAwD;QACxD,sDAAsD;IAC1D;;IAEA;QACI,gDAAgD;QAChD,yCAAyC;QACzC,uDAAuD;QACvD,qDAAqD;IACzD;;IAEA;QACI,+CAA+C;QAC/C,wCAAwC;QACxC,sDAAsD;QACtD,oDAAoD;IACxD;;IAEA;QACI,8CAA8C;QAC9C,uCAAuC;QACvC,qDAAqD;QACrD,mDAAmD;IACvD;;IAEA;QACI;YACI,2BAA2B;QAC/B;IACJ;IACA;;QAEI,0BAA0B;QAC1B,gCAAgC;QAChC,wCAAwC;QACxC,oDAAoD;QACpD,oDAAoD;QACpD,6BAA6B;QAC7B,6BAA6B;QAC7B,6CAA6C;QAC7C,aAAa;QACb,iCAAiC;QACjC,gBAAgB;QAChB,uCAAuC;QACvC,uCAAuC;QACvC,+CAA+C;IACnD;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,gBAAgB;QAChB,mCAAmC;QACnC,kBAAkB;QAClB,mBAAmB;QACnB,2CAA2C;QAC3C,6CAA6C;IACjD;IACA;QACI;YACI,gBAAgB;QACpB;IACJ;;IAEA;QACI;;;;;;;;;SASC;QACD,oEAAoE;IACxE;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,kDAAkD;IACtD;IACA;QACI;YACI,eAAe;QACnB;IACJ;;IAEA;QACI,2CAA2C;QAC3C,qCAAqC;QACrC,oDAAoD;QACpD,oDAAoD;QACpD,sDAAsD;QACtD,oCAAoC;QACpC,sCAAsC;QACtC,uDAAuD;QACvD,4DAA4D;QAC5D,sDAAsD;QACtD,yDAAyD;QACzD,wDAAwD;QACxD,yDAAyD;QACzD,8CAA8C;QAC9C,kCAAkC;QAClC,kCAAkC;QAClC,4CAA4C;QAC5C,aAAa;QACb,sBAAsB;QACtB,eAAe;QACf,gBAAgB;QAChB,iDAAiD;IACrD;;IAEA;QACI,qBAAqB;QACrB,sBAAsB;IAC1B;IACA;QACI,oCAAoC;QACpC,0BAA0B;IAC9B;;IAEA;QACI,WAAW;QACX,wCAAwC;QACxC,mBAAmB;IACvB;IACA;;QAEI,UAAU;QACV,8CAA8C;QAC9C,qBAAqB;QACrB,sDAAsD;IAC1D;IACA;QACI,+CAA+C;QAC/C,uDAAuD;IAC3D;;IAEA;QACI,kBAAkB;QAClB,cAAc;QACd;+CACuC;QACvC,iCAAiC;QACjC,qBAAqB;QACrB,yCAAyC;QACzC;6CACqC;IACzC;IACA;QACI,+BAA+B;QAC/B,gCAAgC;IACpC;IACA;QACI,mCAAmC;QACnC,kCAAkC;IACtC;IACA;;QAEI,0CAA0C;QAC1C,oBAAoB;QACpB,kDAAkD;IACtD;IACA;QACI,UAAU;QACV,wCAAwC;QACxC,gDAAgD;QAChD,sDAAsD;IAC1D;IACA;QACI,mBAAmB;IACvB;IACA;QACI,wDAAwD;QACxD,mDAAmD;IACvD;;IAEA;QACI,mBAAmB;IACvB;IACA;QACI,6DAA6D;QAC7D,0BAA0B;IAC9B;IACA;QACI,2DAA2D;QAC3D,4BAA4B;IAChC;IACA;QACI,aAAa;IACjB;IACA;QACI,mDAAmD;QACnD,oBAAoB;IACxB;IACA;QACI,yDAAyD;QACzD,oDAAoD;IACxD;;IAEA;QACI;YACI,mBAAmB;QACvB;QACA;;YAEI,6DAA6D;YAC7D,0BAA0B;QAC9B;QACA;;YAEI,2DAA2D;YAC3D,4BAA4B;QAChC;QACA;YACI,aAAa;QACjB;QACA;YACI,mDAAmD;YACnD,oBAAoB;QACxB;QACA;YACI,yDAAyD;YACzD,oDAAoD;QACxD;IACJ;IACA;QACI;YACI,mBAAmB;QACvB;QACA;;YAEI,6DAA6D;YAC7D,0BAA0B;QAC9B;QACA;;YAEI,2DAA2D;YAC3D,4BAA4B;QAChC;QACA;YACI,aAAa;QACjB;QACA;YACI,mDAAmD;YACnD,oBAAoB;QACxB;QACA;YACI,yDAAyD;YACzD,oDAAoD;QACxD;IACJ;IACA;QACI;YACI,mBAAmB;QACvB;QACA;;YAEI,6DAA6D;YAC7D,0BAA0B;QAC9B;QACA;;YAEI,2DAA2D;YAC3D,4BAA4B;QAChC;QACA;YACI,aAAa;QACjB;QACA;YACI,mDAAmD;YACnD,oBAAoB;QACxB;QACA;YACI,yDAAyD;YACzD,oDAAoD;QACxD;IACJ;IACA;QACI;YACI,mBAAmB;QACvB;QACA;;YAEI,6DAA6D;YAC7D,0BAA0B;QAC9B;QACA;;YAEI,2DAA2D;YAC3D,4BAA4B;QAChC;QACA;YACI,aAAa;QACjB;QACA;YACI,mDAAmD;YACnD,oBAAoB;QACxB;QACA;YACI,yDAAyD;YACzD,oDAAoD;QACxD;IACJ;IACA;QACI;YACI,mBAAmB;QACvB;QACA;;YAEI,6DAA6D;YAC7D,0BAA0B;QAC9B;QACA;;YAEI,2DAA2D;YAC3D,4BAA4B;QAChC;QACA;YACI,aAAa;QACjB;QACA;YACI,mDAAmD;YACnD,oBAAoB;QACxB;QACA;;;YAGI,yDAAyD;YACzD,oDAAoD;QACxD;IACJ;IACA;QACI,gBAAgB;IACpB;IACA;QACI,mDAAmD;IACvD;IACA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sDAAsD;QACtD,+CAA+C;QAC/C,6DAA6D;QAC7D,4DAA4D;QAC5D,gEAAgE;QAChE,6DAA6D;QAC7D,iEAAiE;QACjE,yDAAyD;QACzD,0DAA0D;QAC1D,oEAAoE;IACxE;;IAEA;QACI,wDAAwD;QACxD,iDAAiD;QACjD,+DAA+D;QAC/D,4DAA4D;QAC5D,kEAAkE;QAClE,6DAA6D;QAC7D,mEAAmE;QACnE,2DAA2D;QAC3D,4DAA4D;QAC5D,sEAAsE;IAC1E;;IAEA;QACI,sDAAsD;QACtD,+CAA+C;QAC/C,6DAA6D;QAC7D,4DAA4D;QAC5D,gEAAgE;QAChE,6DAA6D;QAC7D,iEAAiE;QACjE,yDAAyD;QACzD,0DAA0D;QAC1D,oEAAoE;IACxE;;IAEA;QACI,mDAAmD;QACnD,4CAA4C;QAC5C,0DAA0D;QAC1D,4DAA4D;QAC5D,6DAA6D;QAC7D,6DAA6D;QAC7D,8DAA8D;QAC9D,sDAAsD;QACtD,uDAAuD;QACvD,iEAAiE;IACrE;;IAEA;QACI,sDAAsD;QACtD,+CAA+C;QAC/C,6DAA6D;QAC7D,4DAA4D;QAC5D,gEAAgE;QAChE,6DAA6D;QAC7D,iEAAiE;QACjE,yDAAyD;QACzD,0DAA0D;QAC1D,oEAAoE;IACxE;;IAEA;QACI,qDAAqD;QACrD,8CAA8C;QAC9C,4DAA4D;QAC5D,4DAA4D;QAC5D,+DAA+D;QAC/D,6DAA6D;QAC7D,gEAAgE;QAChE,wDAAwD;QACxD,yDAAyD;QACzD,mEAAmE;IACvE;;IAEA;QACI,oDAAoD;QACpD,6CAA6C;QAC7C,2DAA2D;QAC3D,4DAA4D;QAC5D,8DAA8D;QAC9D,6DAA6D;QAC7D,+DAA+D;QAC/D,uDAAuD;QACvD,wDAAwD;QACxD,kEAAkE;IACtE;;IAEA;QACI,mDAAmD;QACnD,4CAA4C;QAC5C,0DAA0D;QAC1D,4DAA4D;QAC5D,6DAA6D;QAC7D,6DAA6D;QAC7D,8DAA8D;QAC9D,sDAAsD;QACtD,uDAAuD;QACvD,iEAAiE;IACrE;;IAEA;QACI,0BAA0B;QAC1B,2DAAoV;QACpV,2BAA2B;QAC3B,kCAAkC;QAClC,mEAAmE;QACnE,+BAA+B;QAC/B,qCAAqC;QACrC,uEAAuE;QACvE,uBAAuB;QACvB,UAAU;QACV,WAAW;QACX,sBAAsB;QACtB,gCAAgC;QAChC,wEAAwE;QACxE,SAAS;QACT,uBAAuB;QACvB,oCAAoC;IACxC;IACA;QACI,gCAAgC;QAChC,qBAAqB;QACrB,0CAA0C;IAC9C;IACA;QACI,UAAU;QACV,4CAA4C;QAC5C,0CAA0C;IAC9C;IACA;;QAEI,oBAAoB;QACpB,yBAAyB;QACzB,sBAAsB;QACtB,iBAAiB;QACjB,6CAA6C;IACjD;;IAEA;QACI,wCAAwC;IAC5C;;IAEA;QACI,wCAAwC;IAC5C;;IAEA;QACI,uBAAuB;QACvB,6BAA6B;QAC7B,4BAA4B;QAC5B,0BAA0B;QAC1B,2BAA2B;QAC3B,8BAA8B;QAC9B,kBAAkB;QAClB,gDAAgD;QAChD,+CAA+C;QAC/C,2DAA2D;QAC3D,iDAAiD;QACjD,2CAA2C;QAC3C,kDAAkD;QAClD,uDAAuD;QACvD,kEAAkE;QAClE,gCAAgC;QAChC,eAAe;QACf,oCAAoC;QACpC,4BAA4B;QAC5B,oBAAoB;QACpB,oCAAoC;QACpC,4BAA4B;QAC5B,uEAAuE;QACvE,sCAAsC;QACtC,4CAA4C;IAChD;IACA;QACI,UAAU;IACd;IACA;QACI,aAAa;IACjB;;IAEA;QACI,uBAAuB;QACvB,kBAAkB;QAClB,+BAA+B;QAC/B,0BAA0B;QAC1B,uBAAuB;QACvB,kBAAkB;QAClB,eAAe;QACf,oBAAoB;IACxB;IACA;QACI,sCAAsC;IAC1C;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,4DAA4D;QAC5D,mCAAmC;QACnC,2CAA2C;QAC3C,4BAA4B;QAC5B;+CACuC;QACvC;;SAEC;QACD;;SAEC;IACL;IACA;QACI,oDAAoD;QACpD,sCAAsC;IAC1C;;IAEA;QACI,kCAAkC;QAClC,qBAAqB;IACzB;;IAEA;QACI,uBAAuB;QACvB,uBAAuB;QACvB,wBAAwB;QACxB,yBAAyB;QACzB,kBAAkB;QAClB,gCAAgC;QAChC,2DAA2D;QAC3D,+CAA+C;QAC/C,oDAAoD;QACpD,8CAA8C;QAC9C;;SAEC;QACD,iCAAiC;QACjC,iCAAiC;QACjC,oCAAoC;QACpC,sDAAsD;QACtD,sDAAsD;QACtD,iCAAiC;QACjC,6BAA6B;QAC7B,sBAAsB;QACtB,sDAAsD;QACtD,sDAAsD;QACtD,eAAe;QACf,MAAM;QACN,OAAO;QACP,+BAA+B;QAC/B,aAAa;QACb,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,gBAAgB;QAChB,UAAU;IACd;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,8BAA8B;QAC9B,oBAAoB;IACxB;IACA;QACI,mCAAmC;QACnC,8BAA8B;IAClC;IACA;QACI;YACI,gBAAgB;QACpB;IACJ;IACA;QACI,eAAe;IACnB;IACA;QACI,sBAAsB;IAC1B;;IAEA;QACI,+CAA+C;IACnD;IACA;QACI,gBAAgB;QAChB,gBAAgB;IACpB;IACA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,mDAAmD;IACvD;;IAEA;QACI,kBAAkB;QAClB,aAAa;QACb,sBAAsB;QACtB,WAAW;QACX,4BAA4B;QAC5B,oBAAoB;QACpB,oCAAoC;QACpC,4BAA4B;QAC5B,uEAAuE;QACvE,4CAA4C;QAC5C,UAAU;IACd;;IAEA;QACI,0BAA0B;QAC1B,sBAAsB;QACtB,0BAA0B;QAC1B,eAAe;QACf,MAAM;QACN,OAAO;QACP,kCAAkC;QAClC,YAAY;QACZ,aAAa;QACb,uCAAuC;IAC3C;IACA;QACI,UAAU;IACd;IACA;QACI,mCAAmC;IACvC;;IAEA;QACI,aAAa;QACb,cAAc;QACd,mBAAmB;QACnB,uCAAuC;QACvC;+CACuC;QACvC,2DAA2D;QAC3D,4DAA4D;IAChE;IACA;QACI;wDACgD;QAChD;;8DAEsD;IAC1D;;IAEA;QACI,gBAAgB;QAChB,8CAA8C;IAClD;;IAEA;QACI,kBAAkB;QAClB,cAAc;QACd,gCAAgC;IACpC;;IAEA;QACI,aAAa;QACb,cAAc;QACd,eAAe;QACf,mBAAmB;QACnB,yBAAyB;QACzB;;SAEC;QACD,2CAA2C;QAC3C;+CACuC;QACvC,+DAA+D;QAC/D,8DAA8D;IAClE;IACA;QACI,8CAA8C;IAClD;;IAEA;QACI;YACI,0BAA0B;YAC1B,2CAA2C;QAC/C;QACA;YACI,gCAAgC;YAChC,kBAAkB;YAClB,iBAAiB;QACrB;QACA;YACI,uBAAuB;QAC3B;IACJ;IACA;QACI;;YAEI,uBAAuB;QAC3B;IACJ;IACA;QACI;YACI,wBAAwB;QAC5B;IACJ;IACA;QACI,YAAY;QACZ,eAAe;QACf,YAAY;QACZ,SAAS;IACb;IACA;QACI,YAAY;QACZ,SAAS;QACT,gBAAgB;IACpB;IACA;;QAEI,gBAAgB;IACpB;IACA;QACI,gBAAgB;IACpB;;IAEA;QACI;YACI,YAAY;YACZ,eAAe;YACf,YAAY;YACZ,SAAS;QACb;QACA;YACI,YAAY;YACZ,SAAS;YACT,gBAAgB;QACpB;QACA;;YAEI,gBAAgB;QACpB;QACA;YACI,gBAAgB;QACpB;IACJ;IACA;QACI;YACI,YAAY;YACZ,eAAe;YACf,YAAY;YACZ,SAAS;QACb;QACA;YACI,YAAY;YACZ,SAAS;YACT,gBAAgB;QACpB;QACA;;YAEI,gBAAgB;QACpB;QACA;YACI,gBAAgB;QACpB;IACJ;IACA;QACI;YACI,YAAY;YACZ,eAAe;YACf,YAAY;YACZ,SAAS;QACb;QACA;YACI,YAAY;YACZ,SAAS;YACT,gBAAgB;QACpB;QACA;;YAEI,gBAAgB;QACpB;QACA;YACI,gBAAgB;QACpB;IACJ;IACA;QACI;YACI,YAAY;YACZ,eAAe;YACf,YAAY;YACZ,SAAS;QACb;QACA;YACI,YAAY;YACZ,SAAS;YACT,gBAAgB;QACpB;QACA;;YAEI,gBAAgB;QACpB;QACA;YACI,gBAAgB;QACpB;IACJ;IACA;QACI;YACI,YAAY;YACZ,eAAe;YACf,YAAY;YACZ,SAAS;QACb;QACA;YACI,YAAY;YACZ,SAAS;YACT,gBAAgB;QACpB;QACA;;YAEI,gBAAgB;QACpB;QACA;YACI,gBAAgB;QACpB;IACJ;IACA;QACI,yBAAyB;QACzB,6BAA6B;QAC7B,8BAA8B;QAC9B,+BAA+B;QAC/B,qBAAqB;QACrB,gCAAgC;QAChC,qCAAqC;QACrC,yCAAyC;QACzC,mDAAmD;QACnD,yBAAyB;QACzB,gCAAgC;QAChC,iCAAiC;QACjC,iCAAiC;QACjC,cAAc;QACd,gCAAgC;QAChC,sCAAsC;QACtC,kBAAkB;QAClB,gBAAgB;QAChB,gBAAgB;QAChB,gBAAgB;QAChB,iBAAiB;QACjB,qBAAqB;QACrB,iBAAiB;QACjB,oBAAoB;QACpB,sBAAsB;QACtB,kBAAkB;QAClB,mBAAmB;QACnB,oBAAoB;QACpB,gBAAgB;QAChB,sCAAsC;QACtC,qBAAqB;QACrB,UAAU;IACd;IACA;QACI,kCAAkC;IACtC;IACA;QACI,cAAc;QACd,oCAAoC;QACpC,sCAAsC;IAC1C;IACA;QACI,kBAAkB;QAClB,WAAW;QACX,yBAAyB;QACzB,mBAAmB;IACvB;;IAEA;;QAEI,iDAAiD;IACrD;IACA;;QAEI,SAAS;QACT;uDAC+C;QAC/C,sCAAsC;IAC1C;;IAEA,qBAAqB;IACrB;;QAEI,+CAA+C;QAC/C,qCAAqC;QACrC,qCAAqC;IACzC;IACA;;QAEI,WAAW;QACX;;uDAE+C;QAC/C,wCAAwC;IAC5C;;IAEA,mBAAmB;IACnB;;QAEI,8CAA8C;IAClD;IACA;;QAEI,YAAY;QACZ;0CACkC;QAClC,yCAAyC;IAC7C;;IAEA,qBAAqB;IACrB;;QAEI,gDAAgD;QAChD,qCAAqC;QACrC,qCAAqC;IACzC;IACA;;QAEI,UAAU;QACV;;0CAEkC;QAClC,uCAAuC;IAC3C;;IAEA,mBAAmB;IACnB;QACI,sCAAsC;QACtC,gEAAgE;QAChE,8BAA8B;QAC9B,kBAAkB;QAClB,sCAAsC;QACtC,8CAA8C;IAClD;;IAEA;QACI,yBAAyB;QACzB,6BAA6B;QAC7B,gCAAgC;QAChC,kCAAkC;QAClC,iDAAiD;QACjD,6DAA6D;QAC7D,sDAAsD;QACtD;;SAEC;QACD,6CAA6C;QAC7C,mCAAmC;QACnC,qCAAqC;QACrC,mCAAmC;QACnC,kCAAkC;QAClC,8CAA8C;QAC9C,iCAAiC;QACjC,iCAAiC;QACjC,6CAA6C;QAC7C,8BAA8B;QAC9B,iCAAiC;QACjC,yDAAyD;QACzD,iCAAiC;QACjC,cAAc;QACd,sCAAsC;QACtC,sCAAsC;QACtC,kBAAkB;QAClB,gBAAgB;QAChB,gBAAgB;QAChB,gBAAgB;QAChB,iBAAiB;QACjB,qBAAqB;QACrB,iBAAiB;QACjB,oBAAoB;QACpB,sBAAsB;QACtB,kBAAkB;QAClB,mBAAmB;QACnB,oBAAoB;QACpB,gBAAgB;QAChB,sCAAsC;QACtC,qBAAqB;QACrB,sCAAsC;QACtC,4BAA4B;QAC5B;0CACkC;QAClC,8CAA8C;IAClD;IACA;QACI,cAAc;QACd,oCAAoC;QACpC,sCAAsC;IAC1C;IACA;;QAEI,kBAAkB;QAClB,cAAc;QACd,WAAW;QACX,yBAAyB;QACzB,mBAAmB;QACnB,eAAe;IACnB;;IAEA;;QAEI;;SAEC;IACL;IACA;;;;QAII;uDAC+C;IACnD;IACA;;QAEI,SAAS;QACT,gDAAgD;IACpD;IACA;;QAEI,sCAAsC;QACtC,sCAAsC;IAC1C;;IAEA,qBAAqB;IACrB;;QAEI;;SAEC;QACD,qCAAqC;QACrC,qCAAqC;IACzC;IACA;;;;QAII;;uDAE+C;IACnD;IACA;;QAEI,OAAO;QACP,kDAAkD;IACtD;IACA;;QAEI,oCAAoC;QACpC,wCAAwC;IAC5C;;IAEA,mBAAmB;IACnB;;QAEI;;SAEC;IACL;IACA;;;;QAII;0CACkC;IACtC;IACA;;QAEI,MAAM;QACN,mDAAmD;IACvD;IACA;;QAEI,mCAAmC;QACnC,yCAAyC;IAC7C;IACA;;QAEI,kBAAkB;QAClB,MAAM;QACN,SAAS;QACT,cAAc;QACd,oCAAoC;QACpC,uDAAuD;QACvD,WAAW;QACX;uCAC+B;IACnC;;IAEA,qBAAqB;IACrB;;QAEI;;SAEC;QACD,qCAAqC;QACrC,qCAAqC;IACzC;IACA;;;;QAII;;0CAEkC;IACtC;IACA;;QAEI,QAAQ;QACR,iDAAiD;IACrD;IACA;;QAEI,qCAAqC;QACrC,uCAAuC;IAC3C;;IAEA,mBAAmB;IACnB;QACI;8CACsC;QACtC,gBAAgB;QAChB,6CAA6C;QAC7C,qCAAqC;QACrC,6CAA6C;QAC7C;0CACkC;QAClC,6DAA6D;QAC7D,8DAA8D;IAClE;IACA;QACI,aAAa;IACjB;;IAEA;QACI;4CACoC;QACpC,mCAAmC;IACvC;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,gBAAgB;IACpB;IACA;QACI,cAAc;QACd,WAAW;QACX,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,aAAa;QACb,WAAW;QACX,WAAW;QACX,mBAAmB;QACnB,mCAAmC;QACnC,2BAA2B;QAC3B,sCAAsC;IAC1C;IACA;QACI;YACI,gBAAgB;QACpB;IACJ;;IAEA;;;QAGI,cAAc;IAClB;;IAEA;;QAEI,2BAA2B;IAC/B;;IAEA;;QAEI,4BAA4B;IAChC;;IAEA;QACI,UAAU;QACV,4BAA4B;QAC5B,eAAe;IACnB;IACA;;;QAGI,UAAU;QACV,UAAU;IACd;IACA;;QAEI,UAAU;QACV,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI;;YAEI,gBAAgB;QACpB;IACJ;;IAEA;;QAEI,kBAAkB;QAClB,MAAM;QACN,SAAS;QACT,UAAU;QACV,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,UAAU;QACV,UAAU;QACV,WAAW;QACX,kBAAkB;QAClB,gBAAgB;QAChB,SAAS;QACT,YAAY;QACZ,8BAA8B;IAClC;IACA;QACI;;YAEI,gBAAgB;QACpB;IACJ;IACA;;;;QAII,WAAW;QACX,qBAAqB;QACrB,UAAU;QACV,YAAY;IAChB;;IAEA;QACI,OAAO;IACX;;IAEA;QACI,QAAQ;IACZ;;IAEA;;QAEI,qBAAqB;QACrB,WAAW;QACX,YAAY;QACZ,4BAA4B;QAC5B,wBAAwB;QACxB,0BAA0B;IAC9B;;IAEA;QACI;4QACoQ;IACxQ;;IAEA;QACI;2QACmQ;IACvQ;;IAEA;QACI,kBAAkB;QAClB,QAAQ;QACR,SAAS;QACT,OAAO;QACP,UAAU;QACV,aAAa;QACb,uBAAuB;QACvB,UAAU;QACV,iBAAiB;QACjB,mBAAmB;QACnB,gBAAgB;IACpB;IACA;QACI,uBAAuB;QACvB,cAAc;QACd,WAAW;QACX,WAAW;QACX,UAAU;QACV,iBAAiB;QACjB,gBAAgB;QAChB,mBAAmB;QACnB,eAAe;QACf,sBAAsB;QACtB,4BAA4B;QAC5B,SAAS;QACT,kCAAkC;QAClC,qCAAqC;QACrC,YAAY;QACZ,6BAA6B;IACjC;IACA;QACI;YACI,gBAAgB;QACpB;IACJ;IACA;QACI,UAAU;IACd;;IAEA;QACI,kBAAkB;QAClB,UAAU;QACV,eAAe;QACf,SAAS;QACT,oBAAoB;QACpB,uBAAuB;QACvB,WAAW;QACX,kBAAkB;IACtB;;IAEA;;QAEI,gCAAgC;IACpC;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,WAAW;IACf;;IAEA;;;;QAII,gCAAgC;IACpC;IACA;;QAEI,sBAAsB;IAC1B;IACA;;QAEI,WAAW;IACf;;IAEA;;QAEI,qBAAqB;QACrB,8BAA8B;QAC9B,gCAAgC;QAChC,gDAAgD;QAChD,kBAAkB;QAClB;4CACoC;IACxC;;IAEA;QACI;YACI,0CAA0C;QAC9C;IACJ;IACA;QACI,wBAAwB;QACxB,yBAAyB;QACzB,qCAAqC;QACrC,iCAAiC;QACjC,mCAAmC;QACnC,2CAA2C;QAC3C,yDAAyD;QACzD,+BAA+B;IACnC;;IAEA;QACI,wBAAwB;QACxB,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;QACI;YACI,mBAAmB;QACvB;QACA;YACI,UAAU;YACV,eAAe;QACnB;IACJ;IACA;QACI,wBAAwB;QACxB,yBAAyB;QACzB,qCAAqC;QACrC,mCAAmC;QACnC,yCAAyC;QACzC,8BAA8B;QAC9B,UAAU;IACd;;IAEA;QACI,wBAAwB;QACxB,yBAAyB;IAC7B;;IAEA;QACI;;YAEI,kCAAkC;QACtC;IACJ;IACA;;;;;;QAMI,2BAA2B;QAC3B,2BAA2B;QAC3B,2BAA2B;QAC3B,8BAA8B;QAC9B,8BAA8B;QAC9B,0CAA0C;QAC1C,oCAAoC;QACpC,mDAAmD;QACnD,+DAA+D;QAC/D,kDAAkD;QAClD,qDAAqD;QACrD,qCAAqC;IACzC;;IAEA;QACI;YACI,eAAe;YACf,SAAS;YACT,mCAAmC;YACnC,aAAa;YACb,sBAAsB;YACtB,eAAe;YACf,gCAAgC;YAChC,kBAAkB;YAClB,wCAAwC;YACxC,4BAA4B;YAC5B,UAAU;YACV,0CAA0C;QAC9C;IACJ;IACA;QACI;YACI,gBAAgB;QACpB;IACJ;IACA;QACI;YACI,MAAM;YACN,OAAO;YACP,gCAAgC;YAChC;gDACoC;YACpC,4BAA4B;QAChC;QACA;YACI,MAAM;YACN,QAAQ;YACR,gCAAgC;YAChC;gDACoC;YACpC,2BAA2B;QAC/B;QACA;YACI,MAAM;YACN,QAAQ;YACR,OAAO;YACP,kCAAkC;YAClC,gBAAgB;YAChB;gDACoC;YACpC,4BAA4B;QAChC;QACA;YACI,QAAQ;YACR,OAAO;YACP,kCAAkC;YAClC,gBAAgB;YAChB;gDACoC;YACpC,2BAA2B;QAC/B;QACA;;YAEI,eAAe;QACnB;QACA;;;YAGI,mBAAmB;QACvB;IACJ;IACA;QACI;YACI,2BAA2B;YAC3B,8BAA8B;YAC9B,wCAAwC;QAC5C;QACA;YACI,aAAa;QACjB;QACA;YACI,aAAa;YACb,YAAY;YACZ,UAAU;YACV,mBAAmB;YACnB,wCAAwC;QAC5C;IACJ;;IAEA;QACI;YACI,eAAe;YACf,SAAS;YACT,mCAAmC;YACnC,aAAa;YACb,sBAAsB;YACtB,eAAe;YACf,gCAAgC;YAChC,kBAAkB;YAClB,wCAAwC;YACxC,4BAA4B;YAC5B,UAAU;YACV,0CAA0C;QAC9C;IACJ;IACA;QACI;YACI,gBAAgB;QACpB;IACJ;IACA;QACI;YACI,MAAM;YACN,OAAO;YACP,gCAAgC;YAChC;gDACoC;YACpC,4BAA4B;QAChC;QACA;YACI,MAAM;YACN,QAAQ;YACR,gCAAgC;YAChC;gDACoC;YACpC,2BAA2B;QAC/B;QACA;YACI,MAAM;YACN,QAAQ;YACR,OAAO;YACP,kCAAkC;YAClC,gBAAgB;YAChB;gDACoC;YACpC,4BAA4B;QAChC;QACA;YACI,QAAQ;YACR,OAAO;YACP,kCAAkC;YAClC,gBAAgB;YAChB;gDACoC;YACpC,2BAA2B;QAC/B;QACA;;YAEI,eAAe;QACnB;QACA;;;YAGI,mBAAmB;QACvB;IACJ;IACA;QACI;YACI,2BAA2B;YAC3B,8BAA8B;YAC9B,wCAAwC;QAC5C;QACA;YACI,aAAa;QACjB;QACA;YACI,aAAa;YACb,YAAY;YACZ,UAAU;YACV,mBAAmB;YACnB,wCAAwC;QAC5C;IACJ;;IAEA;QACI;YACI,eAAe;YACf,SAAS;YACT,mCAAmC;YACnC,aAAa;YACb,sBAAsB;YACtB,eAAe;YACf,gCAAgC;YAChC,kBAAkB;YAClB,wCAAwC;YACxC,4BAA4B;YAC5B,UAAU;YACV,0CAA0C;QAC9C;IACJ;IACA;QACI;YACI,gBAAgB;QACpB;IACJ;IACA;QACI;YACI,MAAM;YACN,OAAO;YACP,gCAAgC;YAChC;gDACoC;YACpC,4BAA4B;QAChC;QACA;YACI,MAAM;YACN,QAAQ;YACR,gCAAgC;YAChC;gDACoC;YACpC,2BAA2B;QAC/B;QACA;YACI,MAAM;YACN,QAAQ;YACR,OAAO;YACP,kCAAkC;YAClC,gBAAgB;YAChB;gDACoC;YACpC,4BAA4B;QAChC;QACA;YACI,QAAQ;YACR,OAAO;YACP,kCAAkC;YAClC,gBAAgB;YAChB;gDACoC;YACpC,2BAA2B;QAC/B;QACA;;YAEI,eAAe;QACnB;QACA;;;YAGI,mBAAmB;QACvB;IACJ;IACA;QACI;YACI,2BAA2B;YAC3B,8BAA8B;YAC9B,wCAAwC;QAC5C;QACA;YACI,aAAa;QACjB;QACA;YACI,aAAa;YACb,YAAY;YACZ,UAAU;YACV,mBAAmB;YACnB,wCAAwC;QAC5C;IACJ;;IAEA;QACI;YACI,eAAe;YACf,SAAS;YACT,mCAAmC;YACnC,aAAa;YACb,sBAAsB;YACtB,eAAe;YACf,gCAAgC;YAChC,kBAAkB;YAClB,wCAAwC;YACxC,4BAA4B;YAC5B,UAAU;YACV,0CAA0C;QAC9C;IACJ;IACA;QACI;YACI,gBAAgB;QACpB;IACJ;IACA;QACI;YACI,MAAM;YACN,OAAO;YACP,gCAAgC;YAChC;gDACoC;YACpC,4BAA4B;QAChC;QACA;YACI,MAAM;YACN,QAAQ;YACR,gCAAgC;YAChC;gDACoC;YACpC,2BAA2B;QAC/B;QACA;YACI,MAAM;YACN,QAAQ;YACR,OAAO;YACP,kCAAkC;YAClC,gBAAgB;YAChB;gDACoC;YACpC,4BAA4B;QAChC;QACA;YACI,QAAQ;YACR,OAAO;YACP,kCAAkC;YAClC,gBAAgB;YAChB;gDACoC;YACpC,2BAA2B;QAC/B;QACA;;YAEI,eAAe;QACnB;QACA;;;YAGI,mBAAmB;QACvB;IACJ;IACA;QACI;YACI,2BAA2B;YAC3B,8BAA8B;YAC9B,wCAAwC;QAC5C;QACA;YACI,aAAa;QACjB;QACA;YACI,aAAa;YACb,YAAY;YACZ,UAAU;YACV,mBAAmB;YACnB,wCAAwC;QAC5C;IACJ;;IAEA;QACI;YACI,eAAe;YACf,SAAS;YACT,mCAAmC;YACnC,aAAa;YACb,sBAAsB;YACtB,eAAe;YACf,gCAAgC;YAChC,kBAAkB;YAClB,wCAAwC;YACxC,4BAA4B;YAC5B,UAAU;YACV,0CAA0C;QAC9C;IACJ;IACA;QACI;YACI,gBAAgB;QACpB;IACJ;IACA;QACI;YACI,MAAM;YACN,OAAO;YACP,gCAAgC;YAChC;gDACoC;YACpC,4BAA4B;QAChC;QACA;YACI,MAAM;YACN,QAAQ;YACR,gCAAgC;YAChC;gDACoC;YACpC,2BAA2B;QAC/B;QACA;YACI,MAAM;YACN,QAAQ;YACR,OAAO;YACP,kCAAkC;YAClC,gBAAgB;YAChB;gDACoC;YACpC,4BAA4B;QAChC;QACA;YACI,QAAQ;YACR,OAAO;YACP,kCAAkC;YAClC,gBAAgB;YAChB;gDACoC;YACpC,2BAA2B;QAC/B;QACA;;YAEI,eAAe;QACnB;QACA;;;YAGI,mBAAmB;QACvB;IACJ;IACA;QACI;YACI,2BAA2B;YAC3B,8BAA8B;YAC9B,wCAAwC;QAC5C;QACA;YACI,aAAa;QACjB;QACA;YACI,aAAa;YACb,YAAY;YACZ,UAAU;YACV,mBAAmB;YACnB,wCAAwC;QAC5C;IACJ;;IAEA;QACI,eAAe;QACf,SAAS;QACT,mCAAmC;QACnC,aAAa;QACb,sBAAsB;QACtB,eAAe;QACf,gCAAgC;QAChC,kBAAkB;QAClB,wCAAwC;QACxC,4BAA4B;QAC5B,UAAU;QACV,0CAA0C;IAC9C;IACA;QACI;YACI,gBAAgB;QACpB;IACJ;IACA;QACI,MAAM;QACN,OAAO;QACP,gCAAgC;QAChC;4CACoC;QACpC,4BAA4B;IAChC;IACA;QACI,MAAM;QACN,QAAQ;QACR,gCAAgC;QAChC;4CACoC;QACpC,2BAA2B;IAC/B;IACA;QACI,MAAM;QACN,QAAQ;QACR,OAAO;QACP,kCAAkC;QAClC,gBAAgB;QAChB;4CACoC;QACpC,4BAA4B;IAChC;IACA;QACI,QAAQ;QACR,OAAO;QACP,kCAAkC;QAClC,gBAAgB;QAChB;4CACoC;QACpC,2BAA2B;IAC/B;IACA;;QAEI,eAAe;IACnB;IACA;;;QAGI,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,MAAM;QACN,OAAO;QACP,aAAa;QACb,YAAY;QACZ,aAAa;QACb,sBAAsB;IAC1B;IACA;QACI,UAAU;IACd;IACA;QACI,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,oEAAoE;IACxE;IACA;QACI;qDAC6C;QAC7C;;2DAEmD;IACvD;;IAEA;QACI,gBAAgB;QAChB,kDAAkD;IACtD;;IAEA;QACI,YAAY;QACZ,oEAAoE;QACpE,gBAAgB;IACpB;;IAEA;QACI,qBAAqB;QACrB,eAAe;QACf,sBAAsB;QACtB,YAAY;QACZ,8BAA8B;QAC9B,YAAY;IAChB;IACA;QACI,qBAAqB;QACrB,WAAW;IACf;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,mDAAmD;IACvD;;IAEA;QACI;YACI,YAAY;QAChB;IACJ;IACA;QACI;;;;;SAKC;QACD;;;;;SAKC;QACD,4BAA4B;QAC5B,oBAAoB;QACpB,8CAA8C;IAClD;;IAEA;QACI;YACI,+BAA+B;YAC/B,uBAAuB;QAC3B;IACJ;IACA;QACI,cAAc;QACd,WAAW;QACX,WAAW;IACf;;IAEA;QACI,sBAAsB;QACtB;;;oBAGY;IAChB;;IAEA;QACI,sBAAsB;QACtB;;;oBAGY;IAChB;;IAEA;QACI,sBAAsB;QACtB;;;oBAGY;IAChB;;IAEA;QACI,sBAAsB;QACtB;;;oBAGY;IAChB;;IAEA;QACI,sBAAsB;QACtB;;;oBAGY;IAChB;;IAEA;QACI,sBAAsB;QACtB;;;oBAGY;IAChB;;IAEA;QACI,sBAAsB;QACtB;;;oBAGY;IAChB;;IAEA;QACI,sBAAsB;QACtB;;;oBAGY;IAChB;;IAEA;QACI;;;oBAGY;QACZ;;;oBAGY;QACZ;;;oBAGY;IAChB;IACA;;QAEI,8DAA8D;QAC9D;;;;;oBAKY;QACZ;;;;;oBAKY;IAChB;;IAEA;QACI;;;oBAGY;QACZ;;;oBAGY;QACZ;;;oBAGY;IAChB;IACA;;QAEI,8DAA8D;QAC9D;;;;;oBAKY;QACZ;;;;;oBAKY;IAChB;;IAEA;QACI;;;oBAGY;QACZ;;;oBAGY;QACZ;;;oBAGY;IAChB;IACA;;QAEI,8DAA8D;QAC9D;;;;;oBAKY;QACZ;;;;;oBAKY;IAChB;;IAEA;QACI,qEAAqE;QACrE;;;oBAGY;QACZ;;;oBAGY;IAChB;IACA;;QAEI,+DAA+D;QAC/D;;;;;oBAKY;QACZ;;;;;oBAKY;IAChB;;IAEA;QACI;;;oBAGY;QACZ;;;oBAGY;QACZ;;;oBAGY;IAChB;IACA;;QAEI,+DAA+D;QAC/D;;;;;oBAKY;QACZ;;;;;oBAKY;IAChB;;IAEA;QACI,uEAAuE;QACvE;;;oBAGY;QACZ;;;oBAGY;IAChB;IACA;;QAEI,8DAA8D;QAC9D;;;;;oBAKY;QACZ;;;;;oBAKY;IAChB;;IAEA;QACI,sEAAsE;QACtE;;;oBAGY;QACZ;;;oBAGY;IAChB;IACA;;QAEI,gEAAgE;QAChE;;;;;oBAKY;QACZ;;;;;oBAKY;IAChB;;IAEA;QACI,qEAAqE;QACrE;;;oBAGY;QACZ;;;oBAGY;IAChB;IACA;;QAEI,6DAA6D;QAC7D;;;;;oBAKY;QACZ;;;;;oBAKY;IAChB;;IAEA;QACI;;;oBAGY;QACZ;;;oBAGY;QACZ;;;oBAGY;IAChB;IACA;;QAEI;;;oBAGY;QACZ;;;oBAGY;QACZ;;;oBAGY;IAChB;;IAEA;QACI,UAAU;QACV;;sCAE8B;IAClC;;IAEA;QACI,oBAAoB;QACpB,aAAa;QACb,mBAAmB;QACnB;;;SAGC;QACD;;;SAGC;QACD,6BAA6B;QAC7B,mCAAmC;QACnC,2BAA2B;IAC/B;IACA;QACI,cAAc;QACd,UAAU;QACV,WAAW;QACX,kBAAkB;QAClB,sCAAsC;IAC1C;IACA;QACI;YACI,gBAAgB;QACpB;IACJ;;IAEA;;QAEI,mEAAmE;IACvE;;IAEA;QACI,kBAAkB;QAClB,WAAW;IACf;IACA;QACI,cAAc;QACd,mCAAmC;QACnC,WAAW;IACf;IACA;QACI,kBAAkB;QAClB,MAAM;QACN,OAAO;QACP,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,eAAe;QACf,MAAM;QACN,QAAQ;QACR,OAAO;QACP,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,QAAQ;QACR,SAAS;QACT,OAAO;QACP,aAAa;IACjB;;IAEA;QACI,wBAAwB;QACxB,gBAAgB;QAChB,MAAM;QACN,aAAa;IACjB;;IAEA;QACI,wBAAwB;QACxB,gBAAgB;QAChB,SAAS;QACT,aAAa;IACjB;;IAEA;QACI;YACI,wBAAwB;YACxB,gBAAgB;YAChB,MAAM;YACN,aAAa;QACjB;QACA;YACI,wBAAwB;YACxB,gBAAgB;YAChB,SAAS;YACT,aAAa;QACjB;IACJ;IACA;QACI;YACI,wBAAwB;YACxB,gBAAgB;YAChB,MAAM;YACN,aAAa;QACjB;QACA;YACI,wBAAwB;YACxB,gBAAgB;YAChB,SAAS;YACT,aAAa;QACjB;IACJ;IACA;QACI;YACI,wBAAwB;YACxB,gBAAgB;YAChB,MAAM;YACN,aAAa;QACjB;QACA;YACI,wBAAwB;YACxB,gBAAgB;YAChB,SAAS;YACT,aAAa;QACjB;IACJ;IACA;QACI;YACI,wBAAwB;YACxB,gBAAgB;YAChB,MAAM;YACN,aAAa;QACjB;QACA;YACI,wBAAwB;YACxB,gBAAgB;YAChB,SAAS;YACT,aAAa;QACjB;IACJ;IACA;QACI;YACI,wBAAwB;YACxB,gBAAgB;YAChB,MAAM;YACN,aAAa;QACjB;QACA;YACI,wBAAwB;YACxB,gBAAgB;YAChB,SAAS;YACT,aAAa;QACjB;IACJ;IACA;QACI,aAAa;QACb,mBAAmB;QACnB,mBAAmB;QACnB,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,cAAc;QACd,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;;QAEI,qBAAqB;QACrB,sBAAsB;QACtB,qBAAqB;QACrB,uBAAuB;QACvB,2BAA2B;QAC3B,iCAAiC;QACjC,8BAA8B;QAC9B,oBAAoB;IACxB;IACA;;QAEI,6BAA6B;IACjC;;IAEA;QACI,kBAAkB;QAClB,MAAM;QACN,QAAQ;QACR,SAAS;QACT,OAAO;QACP,UAAU;QACV,WAAW;IACf;;IAEA;QACI,gBAAgB;QAChB,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;QACI,qBAAqB;QACrB,mBAAmB;QACnB,6BAA6B;QAC7B,eAAe;QACf,8BAA8B;QAC9B,aAAa;IACjB;;IAEA;QACI,mCAAmC;IACvC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,sCAAsC;IAC1C;;IAEA;QACI,mCAAmC;IACvC;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,iCAAiC;QACjC,8BAA8B;IAClC;;IAEA;QACI,+BAA+B;QAC/B,4BAA4B;IAChC;;IAEA;QACI,8BAA8B;QAC9B,2BAA2B;IAC/B;;IAEA;QACI,oCAAoC;QACpC,iCAAiC;IACrC;;IAEA;QACI,8BAA8B;QAC9B,2BAA2B;IAC/B;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,2CAA2C;IAC/C;;IAEA;QACI,8CAA8C;IAClD;;IAEA;QACI,8CAA8C;IAClD;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI;;;SAGC;IACL;;IAEA;QACI;;;SAGC;IACL;;IAEA;QACI;;;SAGC;IACL;;IAEA;QACI;;;SAGC;IACL;;IAEA;QACI;;;SAGC;IACL;;IAEA;QACI;;;SAGC;IACL;;IAEA;QACI;;;SAGC;IACL;;IAEA;QACI;;;SAGC;IACL;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,mCAAmC;QACnC,2BAA2B;IAC/B;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,2CAA2C;IAC/C;;IAEA;QACI,sCAAsC;IAC1C;;IAEA;QACI,sCAAsC;IAC1C;;IAEA;QACI;6CACqC;IACzC;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI;6CACqC;IACzC;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI;6CACqC;IACzC;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI;6CACqC;IACzC;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI;6CACqC;IACzC;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,sBAAsB;QACtB;;;oBAGY;IAChB;;IAEA;QACI,sBAAsB;QACtB;;;oBAGY;IAChB;;IAEA;QACI,sBAAsB;QACtB;;;oBAGY;IAChB;;IAEA;QACI,sBAAsB;QACtB;;;oBAGY;IAChB;;IAEA;QACI,sBAAsB;QACtB;;;oBAGY;IAChB;;IAEA;QACI,sBAAsB;QACtB;;;oBAGY;IAChB;;IAEA;QACI,sBAAsB;QACtB;;;oBAGY;IAChB;;IAEA;QACI,sBAAsB;QACtB;;;oBAGY;IAChB;;IAEA;QACI,sBAAsB;QACtB;;;oBAGY;IAChB;;IAEA;QACI,sBAAsB;QACtB;;;oBAGY;IAChB;;IAEA;QACI,wDAAwD;IAC5D;;IAEA;QACI,0DAA0D;IAC9D;;IAEA;QACI,wDAAwD;IAC5D;;IAEA;QACI,qDAAqD;IACzD;;IAEA;QACI,wDAAwD;IAC5D;;IAEA;QACI,uDAAuD;IAC3D;;IAEA;QACI,sDAAsD;IAC1D;;IAEA;QACI,qDAAqD;IACzD;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,sCAAsC;IAC1C;;IAEA;QACI,yCAAyC;IAC7C;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,sCAAsC;IAC1C;;IAEA;QACI,oCAAoC;IACxC;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,yCAAyC;IAC7C;;IAEA;QACI,wCAAwC;IAC5C;;IAEA;QACI,wCAAwC;IAC5C;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,oCAAoC;IACxC;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,uCAAuC;IAC3C;;IAEA;QACI,sCAAsC;IAC1C;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,0BAA0B;QAC1B,yBAAyB;IAC7B;;IAEA;QACI,gCAAgC;QAChC,+BAA+B;IACnC;;IAEA;QACI,+BAA+B;QAC/B,8BAA8B;IAClC;;IAEA;QACI,6BAA6B;QAC7B,4BAA4B;IAChC;;IAEA;QACI,+BAA+B;QAC/B,8BAA8B;IAClC;;IAEA;QACI,6BAA6B;QAC7B,4BAA4B;IAChC;;IAEA;QACI,6BAA6B;QAC7B,4BAA4B;IAChC;;IAEA;QACI,wBAAwB;QACxB,2BAA2B;IAC/B;;IAEA;QACI,8BAA8B;QAC9B,iCAAiC;IACrC;;IAEA;QACI,6BAA6B;QAC7B,gCAAgC;IACpC;;IAEA;QACI,2BAA2B;QAC3B,8BAA8B;IAClC;;IAEA;QACI,6BAA6B;QAC7B,gCAAgC;IACpC;;IAEA;QACI,2BAA2B;QAC3B,8BAA8B;IAClC;;IAEA;QACI,2BAA2B;QAC3B,8BAA8B;IAClC;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,2BAA2B;QAC3B,0BAA0B;IAC9B;;IAEA;QACI,iCAAiC;QACjC,gCAAgC;IACpC;;IAEA;QACI,gCAAgC;QAChC,+BAA+B;IACnC;;IAEA;QACI,8BAA8B;QAC9B,6BAA6B;IACjC;;IAEA;QACI,gCAAgC;QAChC,+BAA+B;IACnC;;IAEA;QACI,8BAA8B;QAC9B,6BAA6B;IACjC;;IAEA;QACI,yBAAyB;QACzB,4BAA4B;IAChC;;IAEA;QACI,+BAA+B;QAC/B,kCAAkC;IACtC;;IAEA;QACI,8BAA8B;QAC9B,iCAAiC;IACrC;;IAEA;QACI,4BAA4B;QAC5B,+BAA+B;IACnC;;IAEA;QACI,8BAA8B;QAC9B,iCAAiC;IACrC;;IAEA;QACI,4BAA4B;QAC5B,+BAA+B;IACnC;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,6BAA6B;QAC7B,wBAAwB;IAC5B;;IAEA;QACI,mCAAmC;QACnC,8BAA8B;IAClC;;IAEA;QACI,kCAAkC;QAClC,6BAA6B;IACjC;;IAEA;QACI,gCAAgC;QAChC,2BAA2B;IAC/B;;IAEA;QACI,kCAAkC;QAClC,6BAA6B;IACjC;;IAEA;QACI,gCAAgC;QAChC,2BAA2B;IAC/B;;IAEA;QACI,gDAAgD;IACpD;;IAEA;QACI,4CAA4C;IAChD;;IAEA;QACI,4CAA4C;IAChD;;IAEA;QACI,0CAA0C;IAC9C;;IAEA;QACI,4CAA4C;IAChD;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,qCAAqC;IACzC;;IAEA;QACI,wCAAwC;IAC5C;;IAEA;QACI,oCAAoC;IACxC;;IAEA;QACI,oCAAoC;IACxC;;IAEA;QACI,qCAAqC;IACzC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,8BAA8B;IAClC;;IAEA,qBAAqB;IACrB;QACI,gCAAgC;QAChC,iCAAiC;IACrC;;IAEA,mBAAmB;IACnB;QACI,oBAAoB;QACpB,qEAAqE;IACzE;;IAEA;QACI,oBAAoB;QACpB,uEAAuE;IAC3E;;IAEA;QACI,oBAAoB;QACpB,qEAAqE;IACzE;;IAEA;QACI,oBAAoB;QACpB,kEAAkE;IACtE;;IAEA;QACI,oBAAoB;QACpB,qEAAqE;IACzE;;IAEA;QACI,oBAAoB;QACpB,oEAAoE;IACxE;;IAEA;QACI,oBAAoB;QACpB,mEAAmE;IACvE;;IAEA;QACI,oBAAoB;QACpB,kEAAkE;IACtE;;IAEA;QACI,oBAAoB;QACpB,mEAAmE;IACvE;;IAEA;QACI,oBAAoB;QACpB,mEAAmE;IACvE;;IAEA;QACI,oBAAoB;QACpB;;;oBAGY;IAChB;;IAEA;QACI,oBAAoB;QACpB,2CAA2C;IAC/C;;IAEA;QACI,oBAAoB;QACpB,oCAAoC;IACxC;;IAEA;QACI,oBAAoB;QACpB,0CAA0C;IAC9C;;IAEA;QACI,oBAAoB;QACpB,2CAA2C;IAC/C;;IAEA;QACI,oBAAoB;QACpB,0CAA0C;IAC9C;;IAEA;QACI,oBAAoB;QACpB,0CAA0C;IAC9C;;IAEA;QACI,oBAAoB;QACpB,yBAAyB;IAC7B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,iDAAiD;IACrD;;IAEA;QACI,mDAAmD;IACvD;;IAEA;QACI,iDAAiD;IACrD;;IAEA;QACI,8CAA8C;IAClD;;IAEA;QACI,iDAAiD;IACrD;;IAEA;QACI,gDAAgD;IACpD;;IAEA;QACI,+CAA+C;IACnD;;IAEA;QACI,8CAA8C;IAClD;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,yCAAyC;IAC7C;;IAEA;QACI,yCAAyC;IAC7C;;IAEA;QACI,wCAAwC;IAC5C;;IAEA;QACI,wCAAwC;IAC5C;;IAEA;QACI,yCAAyC;IAC7C;;IAEA;QACI,yCAAyC;IAC7C;;IAEA;QACI,8BAA8B;QAC9B;;;oBAGY;QACZ;;;oBAGY;IAChB;;IAEA;QACI,8BAA8B;QAC9B;;;oBAGY;QACZ;;;oBAGY;IAChB;;IAEA;QACI,8BAA8B;QAC9B;;;oBAGY;QACZ;;;oBAGY;IAChB;;IAEA;QACI,8BAA8B;QAC9B;;;oBAGY;QACZ;;;oBAGY;IAChB;;IAEA;QACI,8BAA8B;QAC9B;;;oBAGY;QACZ;;;oBAGY;IAChB;;IAEA;QACI,8BAA8B;QAC9B;;;oBAGY;QACZ;;;oBAGY;IAChB;;IAEA;QACI,8BAA8B;QAC9B;;;oBAGY;QACZ;;;oBAGY;IAChB;;IAEA;QACI,8BAA8B;QAC9B;;;oBAGY;QACZ;;;oBAGY;IAChB;;IAEA;QACI,8BAA8B;QAC9B;;;oBAGY;QACZ;;;oBAGY;IAChB;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,kBAAkB;QAClB;;;oBAGY;IAChB;;IAEA;QACI,kBAAkB;QAClB;;;oBAGY;IAChB;;IAEA;QACI,kBAAkB;QAClB;;;oBAGY;IAChB;;IAEA;QACI,kBAAkB;QAClB;;;oBAGY;IAChB;;IAEA;QACI,kBAAkB;QAClB;;;oBAGY;IAChB;;IAEA;QACI,kBAAkB;QAClB;;;oBAGY;IAChB;;IAEA;QACI,kBAAkB;QAClB;;;oBAGY;IAChB;;IAEA;QACI,kBAAkB;QAClB;;;oBAGY;IAChB;;IAEA;QACI,kBAAkB;QAClB;;;oBAGY;IAChB;;IAEA;QACI,kBAAkB;QAClB;;;oBAGY;IAChB;;IAEA;QACI,kBAAkB;QAClB;;;oBAGY;IAChB;;IAEA;QACI,kBAAkB;QAClB,wCAAwC;IAC5C;;IAEA;QACI,kBAAkB;QAClB;;;oBAGY;IAChB;;IAEA;QACI,kBAAkB;QAClB;;;oBAGY;IAChB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,wDAAwD;IAC5D;;IAEA;QACI,0DAA0D;IAC9D;;IAEA;QACI,wDAAwD;IAC5D;;IAEA;QACI,qDAAqD;IACzD;;IAEA;QACI,wDAAwD;IAC5D;;IAEA;QACI,uDAAuD;IAC3D;;IAEA;QACI,sDAAsD;IAC1D;;IAEA;QACI,qDAAqD;IACzD;;IAEA;QACI,+CAA+C;IACnD;;IAEA;QACI,mCAAmC;QACnC,gCAAgC;QAChC,2BAA2B;IAC/B;;IAEA;QACI,oCAAoC;QACpC,iCAAiC;QACjC,4BAA4B;IAChC;;IAEA;QACI,oCAAoC;QACpC,iCAAiC;QACjC,4BAA4B;IAChC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,iDAAiD;IACrD;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,oDAAoD;IACxD;;IAEA;QACI,iDAAiD;IACrD;;IAEA;QACI,oDAAoD;IACxD;;IAEA;QACI,oDAAoD;IACxD;;IAEA;QACI,qDAAqD;IACzD;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,sDAAsD;IAC1D;;IAEA;QACI,0DAA0D;QAC1D,2DAA2D;IAC/D;;IAEA;QACI,oCAAoC;QACpC,qCAAqC;IACzC;;IAEA;QACI,6DAA6D;QAC7D,8DAA8D;IAClE;;IAEA;QACI,0DAA0D;QAC1D,2DAA2D;IAC/D;;IAEA;QACI,6DAA6D;QAC7D,8DAA8D;IAClE;;IAEA;QACI,6DAA6D;QAC7D,8DAA8D;IAClE;;IAEA;QACI,8DAA8D;QAC9D,+DAA+D;IACnE;;IAEA;QACI,sCAAsC;QACtC,uCAAuC;IAC3C;;IAEA;QACI,+DAA+D;QAC/D,gEAAgE;IACpE;;IAEA;QACI,2DAA2D;QAC3D,8DAA8D;IAClE;;IAEA;QACI,qCAAqC;QACrC,wCAAwC;IAC5C;;IAEA;QACI,8DAA8D;QAC9D,iEAAiE;IACrE;;IAEA;QACI,2DAA2D;QAC3D,8DAA8D;IAClE;;IAEA;QACI,8DAA8D;QAC9D,iEAAiE;IACrE;;IAEA;QACI,8DAA8D;QAC9D,iEAAiE;IACrE;;IAEA;QACI,+DAA+D;QAC/D,kEAAkE;IACtE;;IAEA;QACI,uCAAuC;QACvC,0CAA0C;IAC9C;;IAEA;QACI,gEAAgE;QAChE,mEAAmE;IACvE;;IAEA;QACI,8DAA8D;QAC9D,6DAA6D;IACjE;;IAEA;QACI,wCAAwC;QACxC,uCAAuC;IAC3C;;IAEA;QACI,iEAAiE;QACjE,gEAAgE;IACpE;;IAEA;QACI,8DAA8D;QAC9D,6DAA6D;IACjE;;IAEA;QACI,iEAAiE;QACjE,gEAAgE;IACpE;;IAEA;QACI,iEAAiE;QACjE,gEAAgE;IACpE;;IAEA;QACI,kEAAkE;QAClE,iEAAiE;IACrE;;IAEA;QACI,0CAA0C;QAC1C,yCAAyC;IAC7C;;IAEA;QACI,mEAAmE;QACnE,kEAAkE;IACtE;;IAEA;QACI,6DAA6D;QAC7D,0DAA0D;IAC9D;;IAEA;QACI,uCAAuC;QACvC,oCAAoC;IACxC;;IAEA;QACI,gEAAgE;QAChE,6DAA6D;IACjE;;IAEA;QACI,6DAA6D;QAC7D,0DAA0D;IAC9D;;IAEA;QACI,gEAAgE;QAChE,6DAA6D;IACjE;;IAEA;QACI,gEAAgE;QAChE,6DAA6D;IACjE;;IAEA;QACI,iEAAiE;QACjE,8DAA8D;IAClE;;IAEA;QACI,yCAAyC;QACzC,sCAAsC;IAC1C;;IAEA;QACI,kEAAkE;QAClE,+DAA+D;IACnE;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI;YACI,sBAAsB;QAC1B;QACA;YACI,uBAAuB;QAC3B;QACA;YACI,sBAAsB;QAC1B;QACA;YACI,iCAAiC;YACjC,8BAA8B;QAClC;QACA;YACI,+BAA+B;YAC/B,4BAA4B;QAChC;QACA;YACI,8BAA8B;YAC9B,2BAA2B;QAC/B;QACA;YACI,oCAAoC;YACpC,iCAAiC;QACrC;QACA;YACI,8BAA8B;YAC9B,2BAA2B;QAC/B;QACA;YACI,0BAA0B;QAC9B;QACA;YACI,gCAAgC;QACpC;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,wBAAwB;QAC5B;QACA;YACI,+BAA+B;QACnC;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,6BAA6B;QACjC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,wBAAwB;QAC5B;QACA;YACI,+BAA+B;QACnC;QACA;YACI,wBAAwB;QAC5B;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,8BAA8B;QAClC;QACA;YACI,iCAAiC;QACrC;QACA;YACI,sCAAsC;QAC1C;QACA;YACI,yCAAyC;QAC7C;QACA;YACI,uBAAuB;QAC3B;QACA;YACI,uBAAuB;QAC3B;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,0BAA0B;QAC9B;QACA;YACI,4BAA4B;QAChC;QACA;YACI,kCAAkC;QACtC;QACA;YACI,sCAAsC;QAC1C;QACA;YACI,oCAAoC;QACxC;QACA;YACI,kCAAkC;QACtC;QACA;YACI,yCAAyC;QAC7C;QACA;YACI,wCAAwC;QAC5C;QACA;YACI,wCAAwC;QAC5C;QACA;YACI,kCAAkC;QACtC;QACA;YACI,gCAAgC;QACpC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,gCAAgC;QACpC;QACA;YACI,+BAA+B;QACnC;QACA;YACI,oCAAoC;QACxC;QACA;YACI,kCAAkC;QACtC;QACA;YACI,gCAAgC;QACpC;QACA;YACI,uCAAuC;QAC3C;QACA;YACI,sCAAsC;QAC1C;QACA;YACI,iCAAiC;QACrC;QACA;YACI,2BAA2B;QAC/B;QACA;YACI,iCAAiC;QACrC;QACA;YACI,+BAA+B;QACnC;QACA;YACI,6BAA6B;QACjC;QACA;YACI,+BAA+B;QACnC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,oBAAoB;QACxB;QACA;YACI,mBAAmB;QACvB;QACA;YACI,mBAAmB;QACvB;QACA;YACI,mBAAmB;QACvB;QACA;YACI,mBAAmB;QACvB;QACA;YACI,mBAAmB;QACvB;QACA;YACI,mBAAmB;QACvB;QACA;YACI,mBAAmB;QACvB;QACA;YACI,oBAAoB;QACxB;QACA;YACI,0BAA0B;QAC9B;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,uBAAuB;QAC3B;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,uBAAuB;QAC3B;QACA;YACI,uBAAuB;QAC3B;QACA;YACI,0BAA0B;YAC1B,yBAAyB;QAC7B;QACA;YACI,gCAAgC;YAChC,+BAA+B;QACnC;QACA;YACI,+BAA+B;YAC/B,8BAA8B;QAClC;QACA;YACI,6BAA6B;YAC7B,4BAA4B;QAChC;QACA;YACI,+BAA+B;YAC/B,8BAA8B;QAClC;QACA;YACI,6BAA6B;YAC7B,4BAA4B;QAChC;QACA;YACI,6BAA6B;YAC7B,4BAA4B;QAChC;QACA;YACI,wBAAwB;YACxB,2BAA2B;QAC/B;QACA;YACI,8BAA8B;YAC9B,iCAAiC;QACrC;QACA;YACI,6BAA6B;YAC7B,gCAAgC;QACpC;QACA;YACI,2BAA2B;YAC3B,8BAA8B;QAClC;QACA;YACI,6BAA6B;YAC7B,gCAAgC;QACpC;QACA;YACI,2BAA2B;YAC3B,8BAA8B;QAClC;QACA;YACI,2BAA2B;YAC3B,8BAA8B;QAClC;QACA;YACI,wBAAwB;QAC5B;QACA;YACI,8BAA8B;QAClC;QACA;YACI,6BAA6B;QACjC;QACA;YACI,2BAA2B;QAC/B;QACA;YACI,6BAA6B;QACjC;QACA;YACI,2BAA2B;QAC/B;QACA;YACI,2BAA2B;QAC/B;QACA;YACI,0BAA0B;QAC9B;QACA;YACI,gCAAgC;QACpC;QACA;YACI,+BAA+B;QACnC;QACA;YACI,6BAA6B;QACjC;QACA;YACI,+BAA+B;QACnC;QACA;YACI,6BAA6B;QACjC;QACA;YACI,6BAA6B;QACjC;QACA;YACI,2BAA2B;QAC/B;QACA;YACI,iCAAiC;QACrC;QACA;YACI,gCAAgC;QACpC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,gCAAgC;QACpC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,+BAA+B;QACnC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,4BAA4B;QAChC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,4BAA4B;QAChC;QACA;YACI,4BAA4B;QAChC;QACA;YACI,qBAAqB;QACzB;QACA;YACI,2BAA2B;QAC/B;QACA;YACI,0BAA0B;QAC9B;QACA;YACI,wBAAwB;QAC5B;QACA;YACI,0BAA0B;QAC9B;QACA;YACI,wBAAwB;QAC5B;QACA;YACI,2BAA2B;YAC3B,0BAA0B;QAC9B;QACA;YACI,iCAAiC;YACjC,gCAAgC;QACpC;QACA;YACI,gCAAgC;YAChC,+BAA+B;QACnC;QACA;YACI,8BAA8B;YAC9B,6BAA6B;QACjC;QACA;YACI,gCAAgC;YAChC,+BAA+B;QACnC;QACA;YACI,8BAA8B;YAC9B,6BAA6B;QACjC;QACA;YACI,yBAAyB;YACzB,4BAA4B;QAChC;QACA;YACI,+BAA+B;YAC/B,kCAAkC;QACtC;QACA;YACI,8BAA8B;YAC9B,iCAAiC;QACrC;QACA;YACI,4BAA4B;YAC5B,+BAA+B;QACnC;QACA;YACI,8BAA8B;YAC9B,iCAAiC;QACrC;QACA;YACI,4BAA4B;YAC5B,+BAA+B;QACnC;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,+BAA+B;QACnC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,4BAA4B;QAChC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,4BAA4B;QAChC;QACA;YACI,2BAA2B;QAC/B;QACA;YACI,iCAAiC;QACrC;QACA;YACI,gCAAgC;QACpC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,gCAAgC;QACpC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,4BAA4B;QAChC;QACA;YACI,kCAAkC;QACtC;QACA;YACI,iCAAiC;QACrC;QACA;YACI,+BAA+B;QACnC;QACA;YACI,iCAAiC;QACrC;QACA;YACI,+BAA+B;QACnC;QACA;YACI,0BAA0B;QAC9B;QACA;YACI,gCAAgC;QACpC;QACA;YACI,+BAA+B;QACnC;QACA;YACI,6BAA6B;QACjC;QACA;YACI,+BAA+B;QACnC;QACA;YACI,6BAA6B;QACjC;QACA;YACI,iBAAiB;QACrB;QACA;YACI,uBAAuB;QAC3B;QACA;YACI,sBAAsB;QAC1B;QACA;YACI,oBAAoB;QACxB;QACA;YACI,sBAAsB;QAC1B;QACA;YACI,oBAAoB;QACxB;QACA;YACI,qBAAqB;QACzB;QACA;YACI,2BAA2B;QAC/B;QACA;YACI,0BAA0B;QAC9B;QACA;YACI,wBAAwB;QAC5B;QACA;YACI,0BAA0B;QAC9B;QACA;YACI,wBAAwB;QAC5B;QACA;YACI,6BAA6B;YAC7B,wBAAwB;QAC5B;QACA;YACI,mCAAmC;YACnC,8BAA8B;QAClC;QACA;YACI,kCAAkC;YAClC,6BAA6B;QACjC;QACA;YACI,gCAAgC;YAChC,2BAA2B;QAC/B;QACA;YACI,kCAAkC;YAClC,6BAA6B;QACjC;QACA;YACI,gCAAgC;YAChC,2BAA2B;QAC/B;QACA;YACI,2BAA2B;QAC/B;QACA;YACI,4BAA4B;QAChC;QACA;YACI,6BAA6B;QACjC;IACJ;IACA;QACI;YACI,sBAAsB;QAC1B;QACA;YACI,uBAAuB;QAC3B;QACA;YACI,sBAAsB;QAC1B;QACA;YACI,iCAAiC;YACjC,8BAA8B;QAClC;QACA;YACI,+BAA+B;YAC/B,4BAA4B;QAChC;QACA;YACI,8BAA8B;YAC9B,2BAA2B;QAC/B;QACA;YACI,oCAAoC;YACpC,iCAAiC;QACrC;QACA;YACI,8BAA8B;YAC9B,2BAA2B;QAC/B;QACA;YACI,0BAA0B;QAC9B;QACA;YACI,gCAAgC;QACpC;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,wBAAwB;QAC5B;QACA;YACI,+BAA+B;QACnC;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,6BAA6B;QACjC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,wBAAwB;QAC5B;QACA;YACI,+BAA+B;QACnC;QACA;YACI,wBAAwB;QAC5B;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,8BAA8B;QAClC;QACA;YACI,iCAAiC;QACrC;QACA;YACI,sCAAsC;QAC1C;QACA;YACI,yCAAyC;QAC7C;QACA;YACI,uBAAuB;QAC3B;QACA;YACI,uBAAuB;QAC3B;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,0BAA0B;QAC9B;QACA;YACI,4BAA4B;QAChC;QACA;YACI,kCAAkC;QACtC;QACA;YACI,sCAAsC;QAC1C;QACA;YACI,oCAAoC;QACxC;QACA;YACI,kCAAkC;QACtC;QACA;YACI,yCAAyC;QAC7C;QACA;YACI,wCAAwC;QAC5C;QACA;YACI,wCAAwC;QAC5C;QACA;YACI,kCAAkC;QACtC;QACA;YACI,gCAAgC;QACpC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,gCAAgC;QACpC;QACA;YACI,+BAA+B;QACnC;QACA;YACI,oCAAoC;QACxC;QACA;YACI,kCAAkC;QACtC;QACA;YACI,gCAAgC;QACpC;QACA;YACI,uCAAuC;QAC3C;QACA;YACI,sCAAsC;QAC1C;QACA;YACI,iCAAiC;QACrC;QACA;YACI,2BAA2B;QAC/B;QACA;YACI,iCAAiC;QACrC;QACA;YACI,+BAA+B;QACnC;QACA;YACI,6BAA6B;QACjC;QACA;YACI,+BAA+B;QACnC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,oBAAoB;QACxB;QACA;YACI,mBAAmB;QACvB;QACA;YACI,mBAAmB;QACvB;QACA;YACI,mBAAmB;QACvB;QACA;YACI,mBAAmB;QACvB;QACA;YACI,mBAAmB;QACvB;QACA;YACI,mBAAmB;QACvB;QACA;YACI,mBAAmB;QACvB;QACA;YACI,oBAAoB;QACxB;QACA;YACI,0BAA0B;QAC9B;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,uBAAuB;QAC3B;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,uBAAuB;QAC3B;QACA;YACI,uBAAuB;QAC3B;QACA;YACI,0BAA0B;YAC1B,yBAAyB;QAC7B;QACA;YACI,gCAAgC;YAChC,+BAA+B;QACnC;QACA;YACI,+BAA+B;YAC/B,8BAA8B;QAClC;QACA;YACI,6BAA6B;YAC7B,4BAA4B;QAChC;QACA;YACI,+BAA+B;YAC/B,8BAA8B;QAClC;QACA;YACI,6BAA6B;YAC7B,4BAA4B;QAChC;QACA;YACI,6BAA6B;YAC7B,4BAA4B;QAChC;QACA;YACI,wBAAwB;YACxB,2BAA2B;QAC/B;QACA;YACI,8BAA8B;YAC9B,iCAAiC;QACrC;QACA;YACI,6BAA6B;YAC7B,gCAAgC;QACpC;QACA;YACI,2BAA2B;YAC3B,8BAA8B;QAClC;QACA;YACI,6BAA6B;YAC7B,gCAAgC;QACpC;QACA;YACI,2BAA2B;YAC3B,8BAA8B;QAClC;QACA;YACI,2BAA2B;YAC3B,8BAA8B;QAClC;QACA;YACI,wBAAwB;QAC5B;QACA;YACI,8BAA8B;QAClC;QACA;YACI,6BAA6B;QACjC;QACA;YACI,2BAA2B;QAC/B;QACA;YACI,6BAA6B;QACjC;QACA;YACI,2BAA2B;QAC/B;QACA;YACI,2BAA2B;QAC/B;QACA;YACI,0BAA0B;QAC9B;QACA;YACI,gCAAgC;QACpC;QACA;YACI,+BAA+B;QACnC;QACA;YACI,6BAA6B;QACjC;QACA;YACI,+BAA+B;QACnC;QACA;YACI,6BAA6B;QACjC;QACA;YACI,6BAA6B;QACjC;QACA;YACI,2BAA2B;QAC/B;QACA;YACI,iCAAiC;QACrC;QACA;YACI,gCAAgC;QACpC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,gCAAgC;QACpC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,+BAA+B;QACnC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,4BAA4B;QAChC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,4BAA4B;QAChC;QACA;YACI,4BAA4B;QAChC;QACA;YACI,qBAAqB;QACzB;QACA;YACI,2BAA2B;QAC/B;QACA;YACI,0BAA0B;QAC9B;QACA;YACI,wBAAwB;QAC5B;QACA;YACI,0BAA0B;QAC9B;QACA;YACI,wBAAwB;QAC5B;QACA;YACI,2BAA2B;YAC3B,0BAA0B;QAC9B;QACA;YACI,iCAAiC;YACjC,gCAAgC;QACpC;QACA;YACI,gCAAgC;YAChC,+BAA+B;QACnC;QACA;YACI,8BAA8B;YAC9B,6BAA6B;QACjC;QACA;YACI,gCAAgC;YAChC,+BAA+B;QACnC;QACA;YACI,8BAA8B;YAC9B,6BAA6B;QACjC;QACA;YACI,yBAAyB;YACzB,4BAA4B;QAChC;QACA;YACI,+BAA+B;YAC/B,kCAAkC;QACtC;QACA;YACI,8BAA8B;YAC9B,iCAAiC;QACrC;QACA;YACI,4BAA4B;YAC5B,+BAA+B;QACnC;QACA;YACI,8BAA8B;YAC9B,iCAAiC;QACrC;QACA;YACI,4BAA4B;YAC5B,+BAA+B;QACnC;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,+BAA+B;QACnC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,4BAA4B;QAChC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,4BAA4B;QAChC;QACA;YACI,2BAA2B;QAC/B;QACA;YACI,iCAAiC;QACrC;QACA;YACI,gCAAgC;QACpC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,gCAAgC;QACpC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,4BAA4B;QAChC;QACA;YACI,kCAAkC;QACtC;QACA;YACI,iCAAiC;QACrC;QACA;YACI,+BAA+B;QACnC;QACA;YACI,iCAAiC;QACrC;QACA;YACI,+BAA+B;QACnC;QACA;YACI,0BAA0B;QAC9B;QACA;YACI,gCAAgC;QACpC;QACA;YACI,+BAA+B;QACnC;QACA;YACI,6BAA6B;QACjC;QACA;YACI,+BAA+B;QACnC;QACA;YACI,6BAA6B;QACjC;QACA;YACI,iBAAiB;QACrB;QACA;YACI,uBAAuB;QAC3B;QACA;YACI,sBAAsB;QAC1B;QACA;YACI,oBAAoB;QACxB;QACA;YACI,sBAAsB;QAC1B;QACA;YACI,oBAAoB;QACxB;QACA;YACI,qBAAqB;QACzB;QACA;YACI,2BAA2B;QAC/B;QACA;YACI,0BAA0B;QAC9B;QACA;YACI,wBAAwB;QAC5B;QACA;YACI,0BAA0B;QAC9B;QACA;YACI,wBAAwB;QAC5B;QACA;YACI,6BAA6B;YAC7B,wBAAwB;QAC5B;QACA;YACI,mCAAmC;YACnC,8BAA8B;QAClC;QACA;YACI,kCAAkC;YAClC,6BAA6B;QACjC;QACA;YACI,gCAAgC;YAChC,2BAA2B;QAC/B;QACA;YACI,kCAAkC;YAClC,6BAA6B;QACjC;QACA;YACI,gCAAgC;YAChC,2BAA2B;QAC/B;QACA;YACI,2BAA2B;QAC/B;QACA;YACI,4BAA4B;QAChC;QACA;YACI,6BAA6B;QACjC;IACJ;IACA;QACI;YACI,sBAAsB;QAC1B;QACA;YACI,uBAAuB;QAC3B;QACA;YACI,sBAAsB;QAC1B;QACA;YACI,iCAAiC;YACjC,8BAA8B;QAClC;QACA;YACI,+BAA+B;YAC/B,4BAA4B;QAChC;QACA;YACI,8BAA8B;YAC9B,2BAA2B;QAC/B;QACA;YACI,oCAAoC;YACpC,iCAAiC;QACrC;QACA;YACI,8BAA8B;YAC9B,2BAA2B;QAC/B;QACA;YACI,0BAA0B;QAC9B;QACA;YACI,gCAAgC;QACpC;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,wBAAwB;QAC5B;QACA;YACI,+BAA+B;QACnC;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,6BAA6B;QACjC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,wBAAwB;QAC5B;QACA;YACI,+BAA+B;QACnC;QACA;YACI,wBAAwB;QAC5B;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,8BAA8B;QAClC;QACA;YACI,iCAAiC;QACrC;QACA;YACI,sCAAsC;QAC1C;QACA;YACI,yCAAyC;QAC7C;QACA;YACI,uBAAuB;QAC3B;QACA;YACI,uBAAuB;QAC3B;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,0BAA0B;QAC9B;QACA;YACI,4BAA4B;QAChC;QACA;YACI,kCAAkC;QACtC;QACA;YACI,sCAAsC;QAC1C;QACA;YACI,oCAAoC;QACxC;QACA;YACI,kCAAkC;QACtC;QACA;YACI,yCAAyC;QAC7C;QACA;YACI,wCAAwC;QAC5C;QACA;YACI,wCAAwC;QAC5C;QACA;YACI,kCAAkC;QACtC;QACA;YACI,gCAAgC;QACpC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,gCAAgC;QACpC;QACA;YACI,+BAA+B;QACnC;QACA;YACI,oCAAoC;QACxC;QACA;YACI,kCAAkC;QACtC;QACA;YACI,gCAAgC;QACpC;QACA;YACI,uCAAuC;QAC3C;QACA;YACI,sCAAsC;QAC1C;QACA;YACI,iCAAiC;QACrC;QACA;YACI,2BAA2B;QAC/B;QACA;YACI,iCAAiC;QACrC;QACA;YACI,+BAA+B;QACnC;QACA;YACI,6BAA6B;QACjC;QACA;YACI,+BAA+B;QACnC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,oBAAoB;QACxB;QACA;YACI,mBAAmB;QACvB;QACA;YACI,mBAAmB;QACvB;QACA;YACI,mBAAmB;QACvB;QACA;YACI,mBAAmB;QACvB;QACA;YACI,mBAAmB;QACvB;QACA;YACI,mBAAmB;QACvB;QACA;YACI,mBAAmB;QACvB;QACA;YACI,oBAAoB;QACxB;QACA;YACI,0BAA0B;QAC9B;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,uBAAuB;QAC3B;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,uBAAuB;QAC3B;QACA;YACI,uBAAuB;QAC3B;QACA;YACI,0BAA0B;YAC1B,yBAAyB;QAC7B;QACA;YACI,gCAAgC;YAChC,+BAA+B;QACnC;QACA;YACI,+BAA+B;YAC/B,8BAA8B;QAClC;QACA;YACI,6BAA6B;YAC7B,4BAA4B;QAChC;QACA;YACI,+BAA+B;YAC/B,8BAA8B;QAClC;QACA;YACI,6BAA6B;YAC7B,4BAA4B;QAChC;QACA;YACI,6BAA6B;YAC7B,4BAA4B;QAChC;QACA;YACI,wBAAwB;YACxB,2BAA2B;QAC/B;QACA;YACI,8BAA8B;YAC9B,iCAAiC;QACrC;QACA;YACI,6BAA6B;YAC7B,gCAAgC;QACpC;QACA;YACI,2BAA2B;YAC3B,8BAA8B;QAClC;QACA;YACI,6BAA6B;YAC7B,gCAAgC;QACpC;QACA;YACI,2BAA2B;YAC3B,8BAA8B;QAClC;QACA;YACI,2BAA2B;YAC3B,8BAA8B;QAClC;QACA;YACI,wBAAwB;QAC5B;QACA;YACI,8BAA8B;QAClC;QACA;YACI,6BAA6B;QACjC;QACA;YACI,2BAA2B;QAC/B;QACA;YACI,6BAA6B;QACjC;QACA;YACI,2BAA2B;QAC/B;QACA;YACI,2BAA2B;QAC/B;QACA;YACI,0BAA0B;QAC9B;QACA;YACI,gCAAgC;QACpC;QACA;YACI,+BAA+B;QACnC;QACA;YACI,6BAA6B;QACjC;QACA;YACI,+BAA+B;QACnC;QACA;YACI,6BAA6B;QACjC;QACA;YACI,6BAA6B;QACjC;QACA;YACI,2BAA2B;QAC/B;QACA;YACI,iCAAiC;QACrC;QACA;YACI,gCAAgC;QACpC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,gCAAgC;QACpC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,+BAA+B;QACnC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,4BAA4B;QAChC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,4BAA4B;QAChC;QACA;YACI,4BAA4B;QAChC;QACA;YACI,qBAAqB;QACzB;QACA;YACI,2BAA2B;QAC/B;QACA;YACI,0BAA0B;QAC9B;QACA;YACI,wBAAwB;QAC5B;QACA;YACI,0BAA0B;QAC9B;QACA;YACI,wBAAwB;QAC5B;QACA;YACI,2BAA2B;YAC3B,0BAA0B;QAC9B;QACA;YACI,iCAAiC;YACjC,gCAAgC;QACpC;QACA;YACI,gCAAgC;YAChC,+BAA+B;QACnC;QACA;YACI,8BAA8B;YAC9B,6BAA6B;QACjC;QACA;YACI,gCAAgC;YAChC,+BAA+B;QACnC;QACA;YACI,8BAA8B;YAC9B,6BAA6B;QACjC;QACA;YACI,yBAAyB;YACzB,4BAA4B;QAChC;QACA;YACI,+BAA+B;YAC/B,kCAAkC;QACtC;QACA;YACI,8BAA8B;YAC9B,iCAAiC;QACrC;QACA;YACI,4BAA4B;YAC5B,+BAA+B;QACnC;QACA;YACI,8BAA8B;YAC9B,iCAAiC;QACrC;QACA;YACI,4BAA4B;YAC5B,+BAA+B;QACnC;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,+BAA+B;QACnC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,4BAA4B;QAChC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,4BAA4B;QAChC;QACA;YACI,2BAA2B;QAC/B;QACA;YACI,iCAAiC;QACrC;QACA;YACI,gCAAgC;QACpC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,gCAAgC;QACpC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,4BAA4B;QAChC;QACA;YACI,kCAAkC;QACtC;QACA;YACI,iCAAiC;QACrC;QACA;YACI,+BAA+B;QACnC;QACA;YACI,iCAAiC;QACrC;QACA;YACI,+BAA+B;QACnC;QACA;YACI,0BAA0B;QAC9B;QACA;YACI,gCAAgC;QACpC;QACA;YACI,+BAA+B;QACnC;QACA;YACI,6BAA6B;QACjC;QACA;YACI,+BAA+B;QACnC;QACA;YACI,6BAA6B;QACjC;QACA;YACI,iBAAiB;QACrB;QACA;YACI,uBAAuB;QAC3B;QACA;YACI,sBAAsB;QAC1B;QACA;YACI,oBAAoB;QACxB;QACA;YACI,sBAAsB;QAC1B;QACA;YACI,oBAAoB;QACxB;QACA;YACI,qBAAqB;QACzB;QACA;YACI,2BAA2B;QAC/B;QACA;YACI,0BAA0B;QAC9B;QACA;YACI,wBAAwB;QAC5B;QACA;YACI,0BAA0B;QAC9B;QACA;YACI,wBAAwB;QAC5B;QACA;YACI,6BAA6B;YAC7B,wBAAwB;QAC5B;QACA;YACI,mCAAmC;YACnC,8BAA8B;QAClC;QACA;YACI,kCAAkC;YAClC,6BAA6B;QACjC;QACA;YACI,gCAAgC;YAChC,2BAA2B;QAC/B;QACA;YACI,kCAAkC;YAClC,6BAA6B;QACjC;QACA;YACI,gCAAgC;YAChC,2BAA2B;QAC/B;QACA;YACI,2BAA2B;QAC/B;QACA;YACI,4BAA4B;QAChC;QACA;YACI,6BAA6B;QACjC;IACJ;IACA;QACI;YACI,sBAAsB;QAC1B;QACA;YACI,uBAAuB;QAC3B;QACA;YACI,sBAAsB;QAC1B;QACA;YACI,iCAAiC;YACjC,8BAA8B;QAClC;QACA;YACI,+BAA+B;YAC/B,4BAA4B;QAChC;QACA;YACI,8BAA8B;YAC9B,2BAA2B;QAC/B;QACA;YACI,oCAAoC;YACpC,iCAAiC;QACrC;QACA;YACI,8BAA8B;YAC9B,2BAA2B;QAC/B;QACA;YACI,0BAA0B;QAC9B;QACA;YACI,gCAAgC;QACpC;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,wBAAwB;QAC5B;QACA;YACI,+BAA+B;QACnC;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,6BAA6B;QACjC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,wBAAwB;QAC5B;QACA;YACI,+BAA+B;QACnC;QACA;YACI,wBAAwB;QAC5B;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,8BAA8B;QAClC;QACA;YACI,iCAAiC;QACrC;QACA;YACI,sCAAsC;QAC1C;QACA;YACI,yCAAyC;QAC7C;QACA;YACI,uBAAuB;QAC3B;QACA;YACI,uBAAuB;QAC3B;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,0BAA0B;QAC9B;QACA;YACI,4BAA4B;QAChC;QACA;YACI,kCAAkC;QACtC;QACA;YACI,sCAAsC;QAC1C;QACA;YACI,oCAAoC;QACxC;QACA;YACI,kCAAkC;QACtC;QACA;YACI,yCAAyC;QAC7C;QACA;YACI,wCAAwC;QAC5C;QACA;YACI,wCAAwC;QAC5C;QACA;YACI,kCAAkC;QACtC;QACA;YACI,gCAAgC;QACpC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,gCAAgC;QACpC;QACA;YACI,+BAA+B;QACnC;QACA;YACI,oCAAoC;QACxC;QACA;YACI,kCAAkC;QACtC;QACA;YACI,gCAAgC;QACpC;QACA;YACI,uCAAuC;QAC3C;QACA;YACI,sCAAsC;QAC1C;QACA;YACI,iCAAiC;QACrC;QACA;YACI,2BAA2B;QAC/B;QACA;YACI,iCAAiC;QACrC;QACA;YACI,+BAA+B;QACnC;QACA;YACI,6BAA6B;QACjC;QACA;YACI,+BAA+B;QACnC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,oBAAoB;QACxB;QACA;YACI,mBAAmB;QACvB;QACA;YACI,mBAAmB;QACvB;QACA;YACI,mBAAmB;QACvB;QACA;YACI,mBAAmB;QACvB;QACA;YACI,mBAAmB;QACvB;QACA;YACI,mBAAmB;QACvB;QACA;YACI,mBAAmB;QACvB;QACA;YACI,oBAAoB;QACxB;QACA;YACI,0BAA0B;QAC9B;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,uBAAuB;QAC3B;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,uBAAuB;QAC3B;QACA;YACI,uBAAuB;QAC3B;QACA;YACI,0BAA0B;YAC1B,yBAAyB;QAC7B;QACA;YACI,gCAAgC;YAChC,+BAA+B;QACnC;QACA;YACI,+BAA+B;YAC/B,8BAA8B;QAClC;QACA;YACI,6BAA6B;YAC7B,4BAA4B;QAChC;QACA;YACI,+BAA+B;YAC/B,8BAA8B;QAClC;QACA;YACI,6BAA6B;YAC7B,4BAA4B;QAChC;QACA;YACI,6BAA6B;YAC7B,4BAA4B;QAChC;QACA;YACI,wBAAwB;YACxB,2BAA2B;QAC/B;QACA;YACI,8BAA8B;YAC9B,iCAAiC;QACrC;QACA;YACI,6BAA6B;YAC7B,gCAAgC;QACpC;QACA;YACI,2BAA2B;YAC3B,8BAA8B;QAClC;QACA;YACI,6BAA6B;YAC7B,gCAAgC;QACpC;QACA;YACI,2BAA2B;YAC3B,8BAA8B;QAClC;QACA;YACI,2BAA2B;YAC3B,8BAA8B;QAClC;QACA;YACI,wBAAwB;QAC5B;QACA;YACI,8BAA8B;QAClC;QACA;YACI,6BAA6B;QACjC;QACA;YACI,2BAA2B;QAC/B;QACA;YACI,6BAA6B;QACjC;QACA;YACI,2BAA2B;QAC/B;QACA;YACI,2BAA2B;QAC/B;QACA;YACI,0BAA0B;QAC9B;QACA;YACI,gCAAgC;QACpC;QACA;YACI,+BAA+B;QACnC;QACA;YACI,6BAA6B;QACjC;QACA;YACI,+BAA+B;QACnC;QACA;YACI,6BAA6B;QACjC;QACA;YACI,6BAA6B;QACjC;QACA;YACI,2BAA2B;QAC/B;QACA;YACI,iCAAiC;QACrC;QACA;YACI,gCAAgC;QACpC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,gCAAgC;QACpC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,+BAA+B;QACnC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,4BAA4B;QAChC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,4BAA4B;QAChC;QACA;YACI,4BAA4B;QAChC;QACA;YACI,qBAAqB;QACzB;QACA;YACI,2BAA2B;QAC/B;QACA;YACI,0BAA0B;QAC9B;QACA;YACI,wBAAwB;QAC5B;QACA;YACI,0BAA0B;QAC9B;QACA;YACI,wBAAwB;QAC5B;QACA;YACI,2BAA2B;YAC3B,0BAA0B;QAC9B;QACA;YACI,iCAAiC;YACjC,gCAAgC;QACpC;QACA;YACI,gCAAgC;YAChC,+BAA+B;QACnC;QACA;YACI,8BAA8B;YAC9B,6BAA6B;QACjC;QACA;YACI,gCAAgC;YAChC,+BAA+B;QACnC;QACA;YACI,8BAA8B;YAC9B,6BAA6B;QACjC;QACA;YACI,yBAAyB;YACzB,4BAA4B;QAChC;QACA;YACI,+BAA+B;YAC/B,kCAAkC;QACtC;QACA;YACI,8BAA8B;YAC9B,iCAAiC;QACrC;QACA;YACI,4BAA4B;YAC5B,+BAA+B;QACnC;QACA;YACI,8BAA8B;YAC9B,iCAAiC;QACrC;QACA;YACI,4BAA4B;YAC5B,+BAA+B;QACnC;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,+BAA+B;QACnC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,4BAA4B;QAChC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,4BAA4B;QAChC;QACA;YACI,2BAA2B;QAC/B;QACA;YACI,iCAAiC;QACrC;QACA;YACI,gCAAgC;QACpC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,gCAAgC;QACpC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,4BAA4B;QAChC;QACA;YACI,kCAAkC;QACtC;QACA;YACI,iCAAiC;QACrC;QACA;YACI,+BAA+B;QACnC;QACA;YACI,iCAAiC;QACrC;QACA;YACI,+BAA+B;QACnC;QACA;YACI,0BAA0B;QAC9B;QACA;YACI,gCAAgC;QACpC;QACA;YACI,+BAA+B;QACnC;QACA;YACI,6BAA6B;QACjC;QACA;YACI,+BAA+B;QACnC;QACA;YACI,6BAA6B;QACjC;QACA;YACI,iBAAiB;QACrB;QACA;YACI,uBAAuB;QAC3B;QACA;YACI,sBAAsB;QAC1B;QACA;YACI,oBAAoB;QACxB;QACA;YACI,sBAAsB;QAC1B;QACA;YACI,oBAAoB;QACxB;QACA;YACI,qBAAqB;QACzB;QACA;YACI,2BAA2B;QAC/B;QACA;YACI,0BAA0B;QAC9B;QACA;YACI,wBAAwB;QAC5B;QACA;YACI,0BAA0B;QAC9B;QACA;YACI,wBAAwB;QAC5B;QACA;YACI,6BAA6B;YAC7B,wBAAwB;QAC5B;QACA;YACI,mCAAmC;YACnC,8BAA8B;QAClC;QACA;YACI,kCAAkC;YAClC,6BAA6B;QACjC;QACA;YACI,gCAAgC;YAChC,2BAA2B;QAC/B;QACA;YACI,kCAAkC;YAClC,6BAA6B;QACjC;QACA;YACI,gCAAgC;YAChC,2BAA2B;QAC/B;QACA;YACI,2BAA2B;QAC/B;QACA;YACI,4BAA4B;QAChC;QACA;YACI,6BAA6B;QACjC;IACJ;IACA;QACI;YACI,sBAAsB;QAC1B;QACA;YACI,uBAAuB;QAC3B;QACA;YACI,sBAAsB;QAC1B;QACA;YACI,iCAAiC;YACjC,8BAA8B;QAClC;QACA;YACI,+BAA+B;YAC/B,4BAA4B;QAChC;QACA;YACI,8BAA8B;YAC9B,2BAA2B;QAC/B;QACA;YACI,oCAAoC;YACpC,iCAAiC;QACrC;QACA;YACI,8BAA8B;YAC9B,2BAA2B;QAC/B;QACA;YACI,0BAA0B;QAC9B;QACA;YACI,gCAAgC;QACpC;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,wBAAwB;QAC5B;QACA;YACI,+BAA+B;QACnC;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,6BAA6B;QACjC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,wBAAwB;QAC5B;QACA;YACI,+BAA+B;QACnC;QACA;YACI,wBAAwB;QAC5B;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,8BAA8B;QAClC;QACA;YACI,iCAAiC;QACrC;QACA;YACI,sCAAsC;QAC1C;QACA;YACI,yCAAyC;QAC7C;QACA;YACI,uBAAuB;QAC3B;QACA;YACI,uBAAuB;QAC3B;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,0BAA0B;QAC9B;QACA;YACI,4BAA4B;QAChC;QACA;YACI,kCAAkC;QACtC;QACA;YACI,sCAAsC;QAC1C;QACA;YACI,oCAAoC;QACxC;QACA;YACI,kCAAkC;QACtC;QACA;YACI,yCAAyC;QAC7C;QACA;YACI,wCAAwC;QAC5C;QACA;YACI,wCAAwC;QAC5C;QACA;YACI,kCAAkC;QACtC;QACA;YACI,gCAAgC;QACpC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,gCAAgC;QACpC;QACA;YACI,+BAA+B;QACnC;QACA;YACI,oCAAoC;QACxC;QACA;YACI,kCAAkC;QACtC;QACA;YACI,gCAAgC;QACpC;QACA;YACI,uCAAuC;QAC3C;QACA;YACI,sCAAsC;QAC1C;QACA;YACI,iCAAiC;QACrC;QACA;YACI,2BAA2B;QAC/B;QACA;YACI,iCAAiC;QACrC;QACA;YACI,+BAA+B;QACnC;QACA;YACI,6BAA6B;QACjC;QACA;YACI,+BAA+B;QACnC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,oBAAoB;QACxB;QACA;YACI,mBAAmB;QACvB;QACA;YACI,mBAAmB;QACvB;QACA;YACI,mBAAmB;QACvB;QACA;YACI,mBAAmB;QACvB;QACA;YACI,mBAAmB;QACvB;QACA;YACI,mBAAmB;QACvB;QACA;YACI,mBAAmB;QACvB;QACA;YACI,oBAAoB;QACxB;QACA;YACI,0BAA0B;QAC9B;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,uBAAuB;QAC3B;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,uBAAuB;QAC3B;QACA;YACI,uBAAuB;QAC3B;QACA;YACI,0BAA0B;YAC1B,yBAAyB;QAC7B;QACA;YACI,gCAAgC;YAChC,+BAA+B;QACnC;QACA;YACI,+BAA+B;YAC/B,8BAA8B;QAClC;QACA;YACI,6BAA6B;YAC7B,4BAA4B;QAChC;QACA;YACI,+BAA+B;YAC/B,8BAA8B;QAClC;QACA;YACI,6BAA6B;YAC7B,4BAA4B;QAChC;QACA;YACI,6BAA6B;YAC7B,4BAA4B;QAChC;QACA;YACI,wBAAwB;YACxB,2BAA2B;QAC/B;QACA;YACI,8BAA8B;YAC9B,iCAAiC;QACrC;QACA;YACI,6BAA6B;YAC7B,gCAAgC;QACpC;QACA;YACI,2BAA2B;YAC3B,8BAA8B;QAClC;QACA;YACI,6BAA6B;YAC7B,gCAAgC;QACpC;QACA;YACI,2BAA2B;YAC3B,8BAA8B;QAClC;QACA;YACI,2BAA2B;YAC3B,8BAA8B;QAClC;QACA;YACI,wBAAwB;QAC5B;QACA;YACI,8BAA8B;QAClC;QACA;YACI,6BAA6B;QACjC;QACA;YACI,2BAA2B;QAC/B;QACA;YACI,6BAA6B;QACjC;QACA;YACI,2BAA2B;QAC/B;QACA;YACI,2BAA2B;QAC/B;QACA;YACI,0BAA0B;QAC9B;QACA;YACI,gCAAgC;QACpC;QACA;YACI,+BAA+B;QACnC;QACA;YACI,6BAA6B;QACjC;QACA;YACI,+BAA+B;QACnC;QACA;YACI,6BAA6B;QACjC;QACA;YACI,6BAA6B;QACjC;QACA;YACI,2BAA2B;QAC/B;QACA;YACI,iCAAiC;QACrC;QACA;YACI,gCAAgC;QACpC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,gCAAgC;QACpC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,+BAA+B;QACnC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,4BAA4B;QAChC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,4BAA4B;QAChC;QACA;YACI,4BAA4B;QAChC;QACA;YACI,qBAAqB;QACzB;QACA;YACI,2BAA2B;QAC/B;QACA;YACI,0BAA0B;QAC9B;QACA;YACI,wBAAwB;QAC5B;QACA;YACI,0BAA0B;QAC9B;QACA;YACI,wBAAwB;QAC5B;QACA;YACI,2BAA2B;YAC3B,0BAA0B;QAC9B;QACA;YACI,iCAAiC;YACjC,gCAAgC;QACpC;QACA;YACI,gCAAgC;YAChC,+BAA+B;QACnC;QACA;YACI,8BAA8B;YAC9B,6BAA6B;QACjC;QACA;YACI,gCAAgC;YAChC,+BAA+B;QACnC;QACA;YACI,8BAA8B;YAC9B,6BAA6B;QACjC;QACA;YACI,yBAAyB;YACzB,4BAA4B;QAChC;QACA;YACI,+BAA+B;YAC/B,kCAAkC;QACtC;QACA;YACI,8BAA8B;YAC9B,iCAAiC;QACrC;QACA;YACI,4BAA4B;YAC5B,+BAA+B;QACnC;QACA;YACI,8BAA8B;YAC9B,iCAAiC;QACrC;QACA;YACI,4BAA4B;YAC5B,+BAA+B;QACnC;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,+BAA+B;QACnC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,4BAA4B;QAChC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,4BAA4B;QAChC;QACA;YACI,2BAA2B;QAC/B;QACA;YACI,iCAAiC;QACrC;QACA;YACI,gCAAgC;QACpC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,gCAAgC;QACpC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,4BAA4B;QAChC;QACA;YACI,kCAAkC;QACtC;QACA;YACI,iCAAiC;QACrC;QACA;YACI,+BAA+B;QACnC;QACA;YACI,iCAAiC;QACrC;QACA;YACI,+BAA+B;QACnC;QACA;YACI,0BAA0B;QAC9B;QACA;YACI,gCAAgC;QACpC;QACA;YACI,+BAA+B;QACnC;QACA;YACI,6BAA6B;QACjC;QACA;YACI,+BAA+B;QACnC;QACA;YACI,6BAA6B;QACjC;QACA;YACI,iBAAiB;QACrB;QACA;YACI,uBAAuB;QAC3B;QACA;YACI,sBAAsB;QAC1B;QACA;YACI,oBAAoB;QACxB;QACA;YACI,sBAAsB;QAC1B;QACA;YACI,oBAAoB;QACxB;QACA;YACI,qBAAqB;QACzB;QACA;YACI,2BAA2B;QAC/B;QACA;YACI,0BAA0B;QAC9B;QACA;YACI,wBAAwB;QAC5B;QACA;YACI,0BAA0B;QAC9B;QACA;YACI,wBAAwB;QAC5B;QACA;YACI,6BAA6B;YAC7B,wBAAwB;QAC5B;QACA;YACI,mCAAmC;YACnC,8BAA8B;QAClC;QACA;YACI,kCAAkC;YAClC,6BAA6B;QACjC;QACA;YACI,gCAAgC;YAChC,2BAA2B;QAC/B;QACA;YACI,kCAAkC;YAClC,6BAA6B;QACjC;QACA;YACI,gCAAgC;YAChC,2BAA2B;QAC/B;QACA;YACI,2BAA2B;QAC/B;QACA;YACI,4BAA4B;QAChC;QACA;YACI,6BAA6B;QACjC;IACJ;IACA;QACI;YACI,4BAA4B;QAChC;QACA;YACI,0BAA0B;QAC9B;QACA;YACI,6BAA6B;QACjC;QACA;YACI,4BAA4B;QAChC;IACJ;IACA;QACI;YACI,0BAA0B;QAC9B;QACA;YACI,gCAAgC;QACpC;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,wBAAwB;QAC5B;QACA;YACI,+BAA+B;QACnC;QACA;YACI,yBAAyB;QAC7B;QACA;YACI,6BAA6B;QACjC;QACA;YACI,8BAA8B;QAClC;QACA;YACI,wBAAwB;QAC5B;QACA;YACI,+BAA+B;QACnC;QACA;YACI,wBAAwB;QAC5B;IACJ;AACJ","sourcesContent":["@charset \"UTF-8\";\n\n.rate-calculator {\n    --bs-blue: #0d6efd;\n    --bs-indigo: #6610f2;\n    --bs-purple: #6f42c1;\n    --bs-pink: #d63384;\n    --bs-red: #dc3545;\n    --bs-orange: #fd7e14;\n    --bs-yellow: #ffc107;\n    --bs-green: #198754;\n    --bs-teal: #20c997;\n    --bs-cyan: #0dcaf0;\n    --bs-black: #000;\n    --bs-white: #fff;\n    --bs-gray: #6c757d;\n    --bs-gray-dark: #343a40;\n    --bs-gray-100: #f8f9fa;\n    --bs-gray-200: #e9ecef;\n    --bs-gray-300: #dee2e6;\n    --bs-gray-400: #ced4da;\n    --bs-gray-500: #adb5bd;\n    --bs-gray-600: #6c757d;\n    --bs-gray-700: #495057;\n    --bs-gray-800: #343a40;\n    --bs-gray-900: #212529;\n    --bs-primary: #0d6efd;\n    --bs-secondary: #6c757d;\n    --bs-success: #198754;\n    --bs-info: #0dcaf0;\n    --bs-warning: #ffc107;\n    --bs-danger: #dc3545;\n    --bs-light: #f8f9fa;\n    --bs-dark: #212529;\n    --bs-primary-rgb: 13, 110, 253;\n    --bs-secondary-rgb: 108, 117, 125;\n    --bs-success-rgb: 25, 135, 84;\n    --bs-info-rgb: 13, 202, 240;\n    --bs-warning-rgb: 255, 193, 7;\n    --bs-danger-rgb: 220, 53, 69;\n    --bs-light-rgb: 248, 249, 250;\n    --bs-dark-rgb: 33, 37, 41;\n    --bs-primary-text-emphasis: #052c65;\n    --bs-secondary-text-emphasis: #2b2f32;\n    --bs-success-text-emphasis: #0a3622;\n    --bs-info-text-emphasis: #055160;\n    --bs-warning-text-emphasis: #664d03;\n    --bs-danger-text-emphasis: #58151c;\n    --bs-light-text-emphasis: #495057;\n    --bs-dark-text-emphasis: #495057;\n    --bs-primary-bg-subtle: #cfe2ff;\n    --bs-secondary-bg-subtle: #e2e3e5;\n    --bs-success-bg-subtle: #d1e7dd;\n    --bs-info-bg-subtle: #cff4fc;\n    --bs-warning-bg-subtle: #fff3cd;\n    --bs-danger-bg-subtle: #f8d7da;\n    --bs-light-bg-subtle: #fcfcfd;\n    --bs-dark-bg-subtle: #ced4da;\n    --bs-primary-border-subtle: #9ec5fe;\n    --bs-secondary-border-subtle: #c4c8cb;\n    --bs-success-border-subtle: #a3cfbb;\n    --bs-info-border-subtle: #9eeaf9;\n    --bs-warning-border-subtle: #ffe69c;\n    --bs-danger-border-subtle: #f1aeb5;\n    --bs-light-border-subtle: #e9ecef;\n    --bs-dark-border-subtle: #adb5bd;\n    --bs-white-rgb: 255, 255, 255;\n    --bs-black-rgb: 0, 0, 0;\n    --bs-font-sans-serif: system-ui, -apple-system, 'Segoe UI', Roboto,\n        'Helvetica Neue', 'Noto Sans', 'Liberation Sans', Arial, sans-serif,\n        'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',\n        'Noto Color Emoji';\n    --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas,\n        'Liberation Mono', 'Courier New', monospace;\n    --bs-gradient: linear-gradient(\n        180deg,\n        rgba(255, 255, 255, 0.15),\n        rgba(255, 255, 255, 0)\n    );\n    --bs-body-font-family: var(--bs-font-sans-serif);\n    --bs-body-font-size: 1rem;\n    --bs-body-font-weight: 400;\n    --bs-body-line-height: 1.5;\n    --bs-body-color: #212529;\n    --bs-body-color-rgb: 33, 37, 41;\n    --bs-body-bg: #fff;\n    --bs-body-bg-rgb: 255, 255, 255;\n    --bs-emphasis-color: #000;\n    --bs-emphasis-color-rgb: 0, 0, 0;\n    --bs-secondary-color: rgba(33, 37, 41, 0.75);\n    --bs-secondary-color-rgb: 33, 37, 41;\n    --bs-secondary-bg: #e9ecef;\n    --bs-secondary-bg-rgb: 233, 236, 239;\n    --bs-tertiary-color: rgba(33, 37, 41, 0.5);\n    --bs-tertiary-color-rgb: 33, 37, 41;\n    --bs-tertiary-bg: #f8f9fa;\n    --bs-tertiary-bg-rgb: 248, 249, 250;\n    --bs-heading-color: inherit;\n    --bs-link-color: #0d6efd;\n    --bs-link-color-rgb: 13, 110, 253;\n    --bs-link-decoration: underline;\n    --bs-link-hover-color: #0a58ca;\n    --bs-link-hover-color-rgb: 10, 88, 202;\n    --bs-code-color: #d63384;\n    --bs-highlight-color: #212529;\n    --bs-highlight-bg: #fff3cd;\n    --bs-border-width: 1px;\n    --bs-border-style: solid;\n    --bs-border-color: #dee2e6;\n    --bs-border-color-translucent: rgba(0, 0, 0, 0.175);\n    --bs-border-radius: 0.375rem;\n    --bs-border-radius-sm: 0.25rem;\n    --bs-border-radius-lg: 0.5rem;\n    --bs-border-radius-xl: 1rem;\n    --bs-border-radius-xxl: 2rem;\n    --bs-border-radius-2xl: var(--bs-border-radius-xxl);\n    --bs-border-radius-pill: 50rem;\n    --bs-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\n    --bs-box-shadow-sm: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);\n    --bs-box-shadow-lg: 0 1rem 3rem rgba(0, 0, 0, 0.175);\n    --bs-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);\n    --bs-focus-ring-width: 0.25rem;\n    --bs-focus-ring-opacity: 0.25;\n    --bs-focus-ring-color: rgba(13, 110, 253, 0.25);\n    --bs-form-valid-color: #198754;\n    --bs-form-valid-border-color: #198754;\n    --bs-form-invalid-color: #dc3545;\n    --bs-form-invalid-border-color: #dc3545;\n\n    *,\n    *::before,\n    *::after {\n        box-sizing: border-box;\n    }\n\n    @media (prefers-reduced-motion: no-preference) {\n        :root {\n            scroll-behavior: smooth;\n        }\n    }\n\n    body {\n        margin: 0;\n        font-family: var(--bs-body-font-family);\n        font-size: var(--bs-body-font-size);\n        font-weight: var(--bs-body-font-weight);\n        line-height: var(--bs-body-line-height);\n        color: var(--bs-body-color);\n        text-align: var(--bs-body-text-align);\n        background-color: var(--bs-body-bg);\n        -webkit-text-size-adjust: 100%;\n        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n    }\n\n    hr {\n        margin: 1rem 0;\n        color: inherit;\n        border: 0;\n        border-top: var(--bs-border-width) solid;\n        opacity: 0.25;\n    }\n\n    h6,\n    .h6,\n    h5,\n    .h5,\n    h4,\n    .h4,\n    h3,\n    .h3,\n    h2,\n    .h2,\n    h1,\n    .h1 {\n        margin-top: 0;\n        margin-bottom: 0.5rem;\n        font-weight: 500;\n        line-height: 1.2;\n        color: var(--bs-heading-color);\n    }\n\n    h1,\n    .h1 {\n        font-size: calc(1.375rem + 1.5vw);\n    }\n    @media (min-width: 1200px) {\n        h1,\n        .h1 {\n            font-size: 2.5rem;\n        }\n    }\n\n    h2,\n    .h2 {\n        font-size: calc(1.325rem + 0.9vw);\n    }\n    @media (min-width: 1200px) {\n        h2,\n        .h2 {\n            font-size: 2rem;\n        }\n    }\n\n    h3,\n    .h3 {\n        font-size: calc(1.3rem + 0.6vw);\n    }\n    @media (min-width: 1200px) {\n        h3,\n        .h3 {\n            font-size: 1.75rem;\n        }\n    }\n\n    h4,\n    .h4 {\n        font-size: calc(1.275rem + 0.3vw);\n    }\n    @media (min-width: 1200px) {\n        h4,\n        .h4 {\n            font-size: 1.5rem;\n        }\n    }\n\n    h5,\n    .h5 {\n        font-size: 1.25rem;\n    }\n\n    h6,\n    .h6 {\n        font-size: 1rem;\n    }\n\n    p {\n        margin-top: 0;\n        margin-bottom: 1rem;\n    }\n\n    abbr[title] {\n        -webkit-text-decoration: underline dotted;\n        text-decoration: underline dotted;\n        cursor: help;\n        -webkit-text-decoration-skip-ink: none;\n        text-decoration-skip-ink: none;\n    }\n\n    address {\n        margin-bottom: 1rem;\n        font-style: normal;\n        line-height: inherit;\n    }\n\n    ol,\n    ul {\n        padding-left: 2rem;\n    }\n\n    ol,\n    ul,\n    dl {\n        margin-top: 0;\n        margin-bottom: 1rem;\n    }\n\n    ol ol,\n    ul ul,\n    ol ul,\n    ul ol {\n        margin-bottom: 0;\n    }\n\n    dt {\n        font-weight: 700;\n    }\n\n    dd {\n        margin-bottom: 0.5rem;\n        margin-left: 0;\n    }\n\n    blockquote {\n        margin: 0 0 1rem;\n    }\n\n    b,\n    strong {\n        font-weight: bolder;\n    }\n\n    small,\n    .small {\n        font-size: 0.875em;\n    }\n\n    mark,\n    .mark {\n        padding: 0.1875em;\n        color: var(--bs-highlight-color);\n        background-color: var(--bs-highlight-bg);\n    }\n\n    sub,\n    sup {\n        position: relative;\n        font-size: 0.75em;\n        line-height: 0;\n        vertical-align: baseline;\n    }\n\n    sub {\n        bottom: -0.25em;\n    }\n\n    sup {\n        top: -0.5em;\n    }\n\n    a {\n        color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));\n        text-decoration: underline;\n    }\n    a:hover {\n        --bs-link-color-rgb: var(--bs-link-hover-color-rgb);\n    }\n\n    a:not([href]):not([class]),\n    a:not([href]):not([class]):hover {\n        color: inherit;\n        text-decoration: none;\n    }\n\n    pre,\n    code,\n    kbd,\n    samp {\n        font-family: var(--bs-font-monospace);\n        font-size: 1em;\n    }\n\n    pre {\n        display: block;\n        margin-top: 0;\n        margin-bottom: 1rem;\n        overflow: auto;\n        font-size: 0.875em;\n    }\n    pre code {\n        font-size: inherit;\n        color: inherit;\n        word-break: normal;\n    }\n\n    code {\n        font-size: 0.875em;\n        color: var(--bs-code-color);\n        word-wrap: break-word;\n    }\n    a > code {\n        color: inherit;\n    }\n\n    kbd {\n        padding: 0.1875rem 0.375rem;\n        font-size: 0.875em;\n        color: var(--bs-body-bg);\n        background-color: var(--bs-body-color);\n        border-radius: 0.25rem;\n    }\n    kbd kbd {\n        padding: 0;\n        font-size: 1em;\n    }\n\n    figure {\n        margin: 0 0 1rem;\n    }\n\n    img,\n    svg {\n        vertical-align: middle;\n    }\n\n    table {\n        caption-side: bottom;\n        border-collapse: collapse;\n    }\n\n    caption {\n        padding-top: 0.5rem;\n        padding-bottom: 0.5rem;\n        color: var(--bs-secondary-color);\n        text-align: left;\n    }\n\n    th {\n        text-align: inherit;\n        text-align: -webkit-match-parent;\n    }\n\n    thead,\n    tbody,\n    tfoot,\n    tr,\n    td,\n    th {\n        border-color: inherit;\n        border-style: solid;\n        border-width: 0;\n    }\n\n    label {\n        display: inline-block;\n    }\n\n    button {\n        border-radius: 0;\n    }\n\n    button:focus:not(:focus-visible) {\n        outline: 0;\n    }\n\n    input,\n    button,\n    select,\n    optgroup,\n    textarea {\n        margin: 0;\n        font-family: inherit;\n        font-size: inherit;\n        line-height: inherit;\n    }\n\n    button,\n    select {\n        text-transform: none;\n    }\n\n    [role='button'] {\n        cursor: pointer;\n    }\n\n    select {\n        word-wrap: normal;\n    }\n    select:disabled {\n        opacity: 1;\n    }\n\n    [list]:not([type='date']):not([type='datetime-local']):not(\n            [type='month']\n        ):not([type='week']):not(\n            [type='time']\n        )::-webkit-calendar-picker-indicator {\n        display: none !important;\n    }\n\n    button,\n    [type='button'],\n    [type='reset'],\n    [type='submit'] {\n        -webkit-appearance: button;\n    }\n    button:not(:disabled),\n    [type='button']:not(:disabled),\n    [type='reset']:not(:disabled),\n    [type='submit']:not(:disabled) {\n        cursor: pointer;\n    }\n\n    ::-moz-focus-inner {\n        padding: 0;\n        border-style: none;\n    }\n\n    textarea {\n        resize: vertical;\n    }\n\n    fieldset {\n        min-width: 0;\n        padding: 0;\n        margin: 0;\n        border: 0;\n    }\n\n    legend {\n        float: left;\n        width: 100%;\n        padding: 0;\n        margin-bottom: 0.5rem;\n        font-size: calc(1.275rem + 0.3vw);\n        line-height: inherit;\n    }\n    @media (min-width: 1200px) {\n        legend {\n            font-size: 1.5rem;\n        }\n    }\n    legend + * {\n        clear: left;\n    }\n\n    ::-webkit-datetime-edit-fields-wrapper,\n    ::-webkit-datetime-edit-text,\n    ::-webkit-datetime-edit-minute,\n    ::-webkit-datetime-edit-hour-field,\n    ::-webkit-datetime-edit-day-field,\n    ::-webkit-datetime-edit-month-field,\n    ::-webkit-datetime-edit-year-field {\n        padding: 0;\n    }\n\n    ::-webkit-inner-spin-button {\n        height: auto;\n    }\n\n    [type='search'] {\n        -webkit-appearance: textfield;\n        outline-offset: -2px;\n    }\n\n    /* rtl:raw:\n    [type=\"tel\"],\n    [type=\"url\"],\n    [type=\"email\"],\n    [type=\"number\"] {\n    direction: ltr;\n    }\n    */\n    ::-webkit-search-decoration {\n        -webkit-appearance: none;\n    }\n\n    ::-webkit-color-swatch-wrapper {\n        padding: 0;\n    }\n\n    ::-webkit-file-upload-button {\n        font: inherit;\n        -webkit-appearance: button;\n    }\n\n    ::file-selector-button {\n        font: inherit;\n        -webkit-appearance: button;\n    }\n\n    output {\n        display: inline-block;\n    }\n\n    iframe {\n        border: 0;\n    }\n\n    summary {\n        display: list-item;\n        cursor: pointer;\n    }\n\n    progress {\n        vertical-align: baseline;\n    }\n\n    [hidden] {\n        display: none !important;\n    }\n\n    .lead {\n        font-size: 1.25rem;\n        font-weight: 300;\n    }\n\n    .display-1 {\n        font-size: calc(1.625rem + 4.5vw);\n        font-weight: 300;\n        line-height: 1.2;\n    }\n    @media (min-width: 1200px) {\n        .display-1 {\n            font-size: 5rem;\n        }\n    }\n\n    .display-2 {\n        font-size: calc(1.575rem + 3.9vw);\n        font-weight: 300;\n        line-height: 1.2;\n    }\n    @media (min-width: 1200px) {\n        .display-2 {\n            font-size: 4.5rem;\n        }\n    }\n\n    .display-3 {\n        font-size: calc(1.525rem + 3.3vw);\n        font-weight: 300;\n        line-height: 1.2;\n    }\n    @media (min-width: 1200px) {\n        .display-3 {\n            font-size: 4rem;\n        }\n    }\n\n    .display-4 {\n        font-size: calc(1.475rem + 2.7vw);\n        font-weight: 300;\n        line-height: 1.2;\n    }\n    @media (min-width: 1200px) {\n        .display-4 {\n            font-size: 3.5rem;\n        }\n    }\n\n    .display-5 {\n        font-size: calc(1.425rem + 2.1vw);\n        font-weight: 300;\n        line-height: 1.2;\n    }\n    @media (min-width: 1200px) {\n        .display-5 {\n            font-size: 3rem;\n        }\n    }\n\n    .display-6 {\n        font-size: calc(1.375rem + 1.5vw);\n        font-weight: 300;\n        line-height: 1.2;\n    }\n    @media (min-width: 1200px) {\n        .display-6 {\n            font-size: 2.5rem;\n        }\n    }\n\n    .list-unstyled {\n        padding-left: 0;\n        list-style: none;\n    }\n\n    .list-inline {\n        padding-left: 0;\n        list-style: none;\n    }\n\n    .list-inline-item {\n        display: inline-block;\n    }\n    .list-inline-item:not(:last-child) {\n        margin-right: 0.5rem;\n    }\n\n    .initialism {\n        font-size: 0.875em;\n        text-transform: uppercase;\n    }\n\n    .blockquote {\n        margin-bottom: 1rem;\n        font-size: 1.25rem;\n    }\n    .blockquote > :last-child {\n        margin-bottom: 0;\n    }\n\n    .blockquote-footer {\n        margin-top: -1rem;\n        margin-bottom: 1rem;\n        font-size: 0.875em;\n        color: #6c757d;\n    }\n    .blockquote-footer::before {\n        content: '— ';\n    }\n\n    .img-fluid {\n        max-width: 100%;\n        height: auto;\n    }\n\n    .img-thumbnail {\n        padding: 0.25rem;\n        background-color: var(--bs-body-bg);\n        border: var(--bs-border-width) solid var(--bs-border-color);\n        border-radius: var(--bs-border-radius);\n        max-width: 100%;\n        height: auto;\n    }\n\n    .figure {\n        display: inline-block;\n    }\n\n    .figure-img {\n        margin-bottom: 0.5rem;\n        line-height: 1;\n    }\n\n    .figure-caption {\n        font-size: 0.875em;\n        color: var(--bs-secondary-color);\n    }\n\n    .container,\n    .container-fluid,\n    .container-xxl,\n    .container-xl,\n    .container-lg,\n    .container-md,\n    .container-sm {\n        --bs-gutter-x: 1.5rem;\n        --bs-gutter-y: 0;\n        width: 100%;\n        padding-right: calc(var(--bs-gutter-x) * 0.5);\n        padding-left: calc(var(--bs-gutter-x) * 0.5);\n        margin-right: auto;\n        margin-left: auto;\n    }\n\n    @media (min-width: 576px) {\n        .container-sm,\n        .container {\n            max-width: 540px;\n        }\n    }\n    @media (min-width: 768px) {\n        .container-md,\n        .container-sm,\n        .container {\n            max-width: 720px;\n        }\n    }\n    @media (min-width: 992px) {\n        .container-lg,\n        .container-md,\n        .container-sm,\n        .container {\n            max-width: 960px;\n        }\n    }\n    @media (min-width: 1200px) {\n        .container-xl,\n        .container-lg,\n        .container-md,\n        .container-sm,\n        .container {\n            max-width: 1140px;\n        }\n    }\n    @media (min-width: 1400px) {\n        .container-xxl,\n        .container-xl,\n        .container-lg,\n        .container-md,\n        .container-sm,\n        .container {\n            max-width: 1320px;\n        }\n    }\n    :root {\n        --bs-breakpoint-xs: 0;\n        --bs-breakpoint-sm: 576px;\n        --bs-breakpoint-md: 768px;\n        --bs-breakpoint-lg: 992px;\n        --bs-breakpoint-xl: 1200px;\n        --bs-breakpoint-xxl: 1400px;\n    }\n\n    .row {\n        --bs-gutter-x: 1.5rem;\n        --bs-gutter-y: 0;\n        display: flex;\n        flex-wrap: wrap;\n        margin-top: calc(-1 * var(--bs-gutter-y));\n        margin-right: calc(-0.5 * var(--bs-gutter-x));\n        margin-left: calc(-0.5 * var(--bs-gutter-x));\n    }\n    .row > * {\n        flex-shrink: 0;\n        width: 100%;\n        max-width: 100%;\n        padding-right: calc(var(--bs-gutter-x) * 0.5);\n        padding-left: calc(var(--bs-gutter-x) * 0.5);\n        margin-top: var(--bs-gutter-y);\n    }\n\n    .col {\n        flex: 1 0 0%;\n    }\n\n    .row-cols-auto > * {\n        flex: 0 0 auto;\n        width: auto;\n    }\n\n    .row-cols-1 > * {\n        flex: 0 0 auto;\n        width: 100%;\n    }\n\n    .row-cols-2 > * {\n        flex: 0 0 auto;\n        width: 50%;\n    }\n\n    .row-cols-3 > * {\n        flex: 0 0 auto;\n        width: 33.33333333%;\n    }\n\n    .row-cols-4 > * {\n        flex: 0 0 auto;\n        width: 25%;\n    }\n\n    .row-cols-5 > * {\n        flex: 0 0 auto;\n        width: 20%;\n    }\n\n    .row-cols-6 > * {\n        flex: 0 0 auto;\n        width: 16.66666667%;\n    }\n\n    .col-auto {\n        flex: 0 0 auto;\n        width: auto;\n    }\n\n    .col-1 {\n        flex: 0 0 auto;\n        width: 8.33333333%;\n    }\n\n    .col-2 {\n        flex: 0 0 auto;\n        width: 16.66666667%;\n    }\n\n    .col-3 {\n        flex: 0 0 auto;\n        width: 25%;\n    }\n\n    .col-4 {\n        flex: 0 0 auto;\n        width: 33.33333333%;\n    }\n\n    .col-5 {\n        flex: 0 0 auto;\n        width: 41.66666667%;\n    }\n\n    .col-6 {\n        flex: 0 0 auto;\n        width: 50%;\n    }\n\n    .col-7 {\n        flex: 0 0 auto;\n        width: 58.33333333%;\n    }\n\n    .col-8 {\n        flex: 0 0 auto;\n        width: 66.66666667%;\n    }\n\n    .col-9 {\n        flex: 0 0 auto;\n        width: 75%;\n    }\n\n    .col-10 {\n        flex: 0 0 auto;\n        width: 83.33333333%;\n    }\n\n    .col-11 {\n        flex: 0 0 auto;\n        width: 91.66666667%;\n    }\n\n    .col-12 {\n        flex: 0 0 auto;\n        width: 100%;\n    }\n\n    .offset-1 {\n        margin-left: 8.33333333%;\n    }\n\n    .offset-2 {\n        margin-left: 16.66666667%;\n    }\n\n    .offset-3 {\n        margin-left: 25%;\n    }\n\n    .offset-4 {\n        margin-left: 33.33333333%;\n    }\n\n    .offset-5 {\n        margin-left: 41.66666667%;\n    }\n\n    .offset-6 {\n        margin-left: 50%;\n    }\n\n    .offset-7 {\n        margin-left: 58.33333333%;\n    }\n\n    .offset-8 {\n        margin-left: 66.66666667%;\n    }\n\n    .offset-9 {\n        margin-left: 75%;\n    }\n\n    .offset-10 {\n        margin-left: 83.33333333%;\n    }\n\n    .offset-11 {\n        margin-left: 91.66666667%;\n    }\n\n    .g-0,\n    .gx-0 {\n        --bs-gutter-x: 0;\n    }\n\n    .g-0,\n    .gy-0 {\n        --bs-gutter-y: 0;\n    }\n\n    .g-1,\n    .gx-1 {\n        --bs-gutter-x: 0.25rem;\n    }\n\n    .g-1,\n    .gy-1 {\n        --bs-gutter-y: 0.25rem;\n    }\n\n    .g-2,\n    .gx-2 {\n        --bs-gutter-x: 0.5rem;\n    }\n\n    .g-2,\n    .gy-2 {\n        --bs-gutter-y: 0.5rem;\n    }\n\n    .g-3,\n    .gx-3 {\n        --bs-gutter-x: 1rem;\n    }\n\n    .g-3,\n    .gy-3 {\n        --bs-gutter-y: 1rem;\n    }\n\n    .g-4,\n    .gx-4 {\n        --bs-gutter-x: 1.5rem;\n    }\n\n    .g-4,\n    .gy-4 {\n        --bs-gutter-y: 1.5rem;\n    }\n\n    .g-5,\n    .gx-5 {\n        --bs-gutter-x: 3rem;\n    }\n\n    .g-5,\n    .gy-5 {\n        --bs-gutter-y: 3rem;\n    }\n\n    @media (min-width: 576px) {\n        .col-sm {\n            flex: 1 0 0%;\n        }\n        .row-cols-sm-auto > * {\n            flex: 0 0 auto;\n            width: auto;\n        }\n        .row-cols-sm-1 > * {\n            flex: 0 0 auto;\n            width: 100%;\n        }\n        .row-cols-sm-2 > * {\n            flex: 0 0 auto;\n            width: 50%;\n        }\n        .row-cols-sm-3 > * {\n            flex: 0 0 auto;\n            width: 33.33333333%;\n        }\n        .row-cols-sm-4 > * {\n            flex: 0 0 auto;\n            width: 25%;\n        }\n        .row-cols-sm-5 > * {\n            flex: 0 0 auto;\n            width: 20%;\n        }\n        .row-cols-sm-6 > * {\n            flex: 0 0 auto;\n            width: 16.66666667%;\n        }\n        .col-sm-auto {\n            flex: 0 0 auto;\n            width: auto;\n        }\n        .col-sm-1 {\n            flex: 0 0 auto;\n            width: 8.33333333%;\n        }\n        .col-sm-2 {\n            flex: 0 0 auto;\n            width: 16.66666667%;\n        }\n        .col-sm-3 {\n            flex: 0 0 auto;\n            width: 25%;\n        }\n        .col-sm-4 {\n            flex: 0 0 auto;\n            width: 33.33333333%;\n        }\n        .col-sm-5 {\n            flex: 0 0 auto;\n            width: 41.66666667%;\n        }\n        .col-sm-6 {\n            flex: 0 0 auto;\n            width: 50%;\n        }\n        .col-sm-7 {\n            flex: 0 0 auto;\n            width: 58.33333333%;\n        }\n        .col-sm-8 {\n            flex: 0 0 auto;\n            width: 66.66666667%;\n        }\n        .col-sm-9 {\n            flex: 0 0 auto;\n            width: 75%;\n        }\n        .col-sm-10 {\n            flex: 0 0 auto;\n            width: 83.33333333%;\n        }\n        .col-sm-11 {\n            flex: 0 0 auto;\n            width: 91.66666667%;\n        }\n        .col-sm-12 {\n            flex: 0 0 auto;\n            width: 100%;\n        }\n        .offset-sm-0 {\n            margin-left: 0;\n        }\n        .offset-sm-1 {\n            margin-left: 8.33333333%;\n        }\n        .offset-sm-2 {\n            margin-left: 16.66666667%;\n        }\n        .offset-sm-3 {\n            margin-left: 25%;\n        }\n        .offset-sm-4 {\n            margin-left: 33.33333333%;\n        }\n        .offset-sm-5 {\n            margin-left: 41.66666667%;\n        }\n        .offset-sm-6 {\n            margin-left: 50%;\n        }\n        .offset-sm-7 {\n            margin-left: 58.33333333%;\n        }\n        .offset-sm-8 {\n            margin-left: 66.66666667%;\n        }\n        .offset-sm-9 {\n            margin-left: 75%;\n        }\n        .offset-sm-10 {\n            margin-left: 83.33333333%;\n        }\n        .offset-sm-11 {\n            margin-left: 91.66666667%;\n        }\n        .g-sm-0,\n        .gx-sm-0 {\n            --bs-gutter-x: 0;\n        }\n        .g-sm-0,\n        .gy-sm-0 {\n            --bs-gutter-y: 0;\n        }\n        .g-sm-1,\n        .gx-sm-1 {\n            --bs-gutter-x: 0.25rem;\n        }\n        .g-sm-1,\n        .gy-sm-1 {\n            --bs-gutter-y: 0.25rem;\n        }\n        .g-sm-2,\n        .gx-sm-2 {\n            --bs-gutter-x: 0.5rem;\n        }\n        .g-sm-2,\n        .gy-sm-2 {\n            --bs-gutter-y: 0.5rem;\n        }\n        .g-sm-3,\n        .gx-sm-3 {\n            --bs-gutter-x: 1rem;\n        }\n        .g-sm-3,\n        .gy-sm-3 {\n            --bs-gutter-y: 1rem;\n        }\n        .g-sm-4,\n        .gx-sm-4 {\n            --bs-gutter-x: 1.5rem;\n        }\n        .g-sm-4,\n        .gy-sm-4 {\n            --bs-gutter-y: 1.5rem;\n        }\n        .g-sm-5,\n        .gx-sm-5 {\n            --bs-gutter-x: 3rem;\n        }\n        .g-sm-5,\n        .gy-sm-5 {\n            --bs-gutter-y: 3rem;\n        }\n    }\n    @media (min-width: 768px) {\n        .col-md {\n            flex: 1 0 0%;\n        }\n        .row-cols-md-auto > * {\n            flex: 0 0 auto;\n            width: auto;\n        }\n        .row-cols-md-1 > * {\n            flex: 0 0 auto;\n            width: 100%;\n        }\n        .row-cols-md-2 > * {\n            flex: 0 0 auto;\n            width: 50%;\n        }\n        .row-cols-md-3 > * {\n            flex: 0 0 auto;\n            width: 33.33333333%;\n        }\n        .row-cols-md-4 > * {\n            flex: 0 0 auto;\n            width: 25%;\n        }\n        .row-cols-md-5 > * {\n            flex: 0 0 auto;\n            width: 20%;\n        }\n        .row-cols-md-6 > * {\n            flex: 0 0 auto;\n            width: 16.66666667%;\n        }\n        .col-md-auto {\n            flex: 0 0 auto;\n            width: auto;\n        }\n        .col-md-1 {\n            flex: 0 0 auto;\n            width: 8.33333333%;\n        }\n        .col-md-2 {\n            flex: 0 0 auto;\n            width: 16.66666667%;\n        }\n        .col-md-3 {\n            flex: 0 0 auto;\n            width: 25%;\n        }\n        .col-md-4 {\n            flex: 0 0 auto;\n            width: 33.33333333%;\n        }\n        .col-md-5 {\n            flex: 0 0 auto;\n            width: 41.66666667%;\n        }\n        .col-md-6 {\n            flex: 0 0 auto;\n            width: 50%;\n        }\n        .col-md-7 {\n            flex: 0 0 auto;\n            width: 58.33333333%;\n        }\n        .col-md-8 {\n            flex: 0 0 auto;\n            width: 66.66666667%;\n        }\n        .col-md-9 {\n            flex: 0 0 auto;\n            width: 75%;\n        }\n        .col-md-10 {\n            flex: 0 0 auto;\n            width: 83.33333333%;\n        }\n        .col-md-11 {\n            flex: 0 0 auto;\n            width: 91.66666667%;\n        }\n        .col-md-12 {\n            flex: 0 0 auto;\n            width: 100%;\n        }\n        .offset-md-0 {\n            margin-left: 0;\n        }\n        .offset-md-1 {\n            margin-left: 8.33333333%;\n        }\n        .offset-md-2 {\n            margin-left: 16.66666667%;\n        }\n        .offset-md-3 {\n            margin-left: 25%;\n        }\n        .offset-md-4 {\n            margin-left: 33.33333333%;\n        }\n        .offset-md-5 {\n            margin-left: 41.66666667%;\n        }\n        .offset-md-6 {\n            margin-left: 50%;\n        }\n        .offset-md-7 {\n            margin-left: 58.33333333%;\n        }\n        .offset-md-8 {\n            margin-left: 66.66666667%;\n        }\n        .offset-md-9 {\n            margin-left: 75%;\n        }\n        .offset-md-10 {\n            margin-left: 83.33333333%;\n        }\n        .offset-md-11 {\n            margin-left: 91.66666667%;\n        }\n        .g-md-0,\n        .gx-md-0 {\n            --bs-gutter-x: 0;\n        }\n        .g-md-0,\n        .gy-md-0 {\n            --bs-gutter-y: 0;\n        }\n        .g-md-1,\n        .gx-md-1 {\n            --bs-gutter-x: 0.25rem;\n        }\n        .g-md-1,\n        .gy-md-1 {\n            --bs-gutter-y: 0.25rem;\n        }\n        .g-md-2,\n        .gx-md-2 {\n            --bs-gutter-x: 0.5rem;\n        }\n        .g-md-2,\n        .gy-md-2 {\n            --bs-gutter-y: 0.5rem;\n        }\n        .g-md-3,\n        .gx-md-3 {\n            --bs-gutter-x: 1rem;\n        }\n        .g-md-3,\n        .gy-md-3 {\n            --bs-gutter-y: 1rem;\n        }\n        .g-md-4,\n        .gx-md-4 {\n            --bs-gutter-x: 1.5rem;\n        }\n        .g-md-4,\n        .gy-md-4 {\n            --bs-gutter-y: 1.5rem;\n        }\n        .g-md-5,\n        .gx-md-5 {\n            --bs-gutter-x: 3rem;\n        }\n        .g-md-5,\n        .gy-md-5 {\n            --bs-gutter-y: 3rem;\n        }\n    }\n    @media (min-width: 992px) {\n        .col-lg {\n            flex: 1 0 0%;\n        }\n        .row-cols-lg-auto > * {\n            flex: 0 0 auto;\n            width: auto;\n        }\n        .row-cols-lg-1 > * {\n            flex: 0 0 auto;\n            width: 100%;\n        }\n        .row-cols-lg-2 > * {\n            flex: 0 0 auto;\n            width: 50%;\n        }\n        .row-cols-lg-3 > * {\n            flex: 0 0 auto;\n            width: 33.33333333%;\n        }\n        .row-cols-lg-4 > * {\n            flex: 0 0 auto;\n            width: 25%;\n        }\n        .row-cols-lg-5 > * {\n            flex: 0 0 auto;\n            width: 20%;\n        }\n        .row-cols-lg-6 > * {\n            flex: 0 0 auto;\n            width: 16.66666667%;\n        }\n        .col-lg-auto {\n            flex: 0 0 auto;\n            width: auto;\n        }\n        .col-lg-1 {\n            flex: 0 0 auto;\n            width: 8.33333333%;\n        }\n        .col-lg-2 {\n            flex: 0 0 auto;\n            width: 16.66666667%;\n        }\n        .col-lg-3 {\n            flex: 0 0 auto;\n            width: 25%;\n        }\n        .col-lg-4 {\n            flex: 0 0 auto;\n            width: 33.33333333%;\n        }\n        .col-lg-5 {\n            flex: 0 0 auto;\n            width: 41.66666667%;\n        }\n        .col-lg-6 {\n            flex: 0 0 auto;\n            width: 50%;\n        }\n        .col-lg-7 {\n            flex: 0 0 auto;\n            width: 58.33333333%;\n        }\n        .col-lg-8 {\n            flex: 0 0 auto;\n            width: 66.66666667%;\n        }\n        .col-lg-9 {\n            flex: 0 0 auto;\n            width: 75%;\n        }\n        .col-lg-10 {\n            flex: 0 0 auto;\n            width: 83.33333333%;\n        }\n        .col-lg-11 {\n            flex: 0 0 auto;\n            width: 91.66666667%;\n        }\n        .col-lg-12 {\n            flex: 0 0 auto;\n            width: 100%;\n        }\n        .offset-lg-0 {\n            margin-left: 0;\n        }\n        .offset-lg-1 {\n            margin-left: 8.33333333%;\n        }\n        .offset-lg-2 {\n            margin-left: 16.66666667%;\n        }\n        .offset-lg-3 {\n            margin-left: 25%;\n        }\n        .offset-lg-4 {\n            margin-left: 33.33333333%;\n        }\n        .offset-lg-5 {\n            margin-left: 41.66666667%;\n        }\n        .offset-lg-6 {\n            margin-left: 50%;\n        }\n        .offset-lg-7 {\n            margin-left: 58.33333333%;\n        }\n        .offset-lg-8 {\n            margin-left: 66.66666667%;\n        }\n        .offset-lg-9 {\n            margin-left: 75%;\n        }\n        .offset-lg-10 {\n            margin-left: 83.33333333%;\n        }\n        .offset-lg-11 {\n            margin-left: 91.66666667%;\n        }\n        .g-lg-0,\n        .gx-lg-0 {\n            --bs-gutter-x: 0;\n        }\n        .g-lg-0,\n        .gy-lg-0 {\n            --bs-gutter-y: 0;\n        }\n        .g-lg-1,\n        .gx-lg-1 {\n            --bs-gutter-x: 0.25rem;\n        }\n        .g-lg-1,\n        .gy-lg-1 {\n            --bs-gutter-y: 0.25rem;\n        }\n        .g-lg-2,\n        .gx-lg-2 {\n            --bs-gutter-x: 0.5rem;\n        }\n        .g-lg-2,\n        .gy-lg-2 {\n            --bs-gutter-y: 0.5rem;\n        }\n        .g-lg-3,\n        .gx-lg-3 {\n            --bs-gutter-x: 1rem;\n        }\n        .g-lg-3,\n        .gy-lg-3 {\n            --bs-gutter-y: 1rem;\n        }\n        .g-lg-4,\n        .gx-lg-4 {\n            --bs-gutter-x: 1.5rem;\n        }\n        .g-lg-4,\n        .gy-lg-4 {\n            --bs-gutter-y: 1.5rem;\n        }\n        .g-lg-5,\n        .gx-lg-5 {\n            --bs-gutter-x: 3rem;\n        }\n        .g-lg-5,\n        .gy-lg-5 {\n            --bs-gutter-y: 3rem;\n        }\n    }\n    @media (min-width: 1200px) {\n        .col-xl {\n            flex: 1 0 0%;\n        }\n        .row-cols-xl-auto > * {\n            flex: 0 0 auto;\n            width: auto;\n        }\n        .row-cols-xl-1 > * {\n            flex: 0 0 auto;\n            width: 100%;\n        }\n        .row-cols-xl-2 > * {\n            flex: 0 0 auto;\n            width: 50%;\n        }\n        .row-cols-xl-3 > * {\n            flex: 0 0 auto;\n            width: 33.33333333%;\n        }\n        .row-cols-xl-4 > * {\n            flex: 0 0 auto;\n            width: 25%;\n        }\n        .row-cols-xl-5 > * {\n            flex: 0 0 auto;\n            width: 20%;\n        }\n        .row-cols-xl-6 > * {\n            flex: 0 0 auto;\n            width: 16.66666667%;\n        }\n        .col-xl-auto {\n            flex: 0 0 auto;\n            width: auto;\n        }\n        .col-xl-1 {\n            flex: 0 0 auto;\n            width: 8.33333333%;\n        }\n        .col-xl-2 {\n            flex: 0 0 auto;\n            width: 16.66666667%;\n        }\n        .col-xl-3 {\n            flex: 0 0 auto;\n            width: 25%;\n        }\n        .col-xl-4 {\n            flex: 0 0 auto;\n            width: 33.33333333%;\n        }\n        .col-xl-5 {\n            flex: 0 0 auto;\n            width: 41.66666667%;\n        }\n        .col-xl-6 {\n            flex: 0 0 auto;\n            width: 50%;\n        }\n        .col-xl-7 {\n            flex: 0 0 auto;\n            width: 58.33333333%;\n        }\n        .col-xl-8 {\n            flex: 0 0 auto;\n            width: 66.66666667%;\n        }\n        .col-xl-9 {\n            flex: 0 0 auto;\n            width: 75%;\n        }\n        .col-xl-10 {\n            flex: 0 0 auto;\n            width: 83.33333333%;\n        }\n        .col-xl-11 {\n            flex: 0 0 auto;\n            width: 91.66666667%;\n        }\n        .col-xl-12 {\n            flex: 0 0 auto;\n            width: 100%;\n        }\n        .offset-xl-0 {\n            margin-left: 0;\n        }\n        .offset-xl-1 {\n            margin-left: 8.33333333%;\n        }\n        .offset-xl-2 {\n            margin-left: 16.66666667%;\n        }\n        .offset-xl-3 {\n            margin-left: 25%;\n        }\n        .offset-xl-4 {\n            margin-left: 33.33333333%;\n        }\n        .offset-xl-5 {\n            margin-left: 41.66666667%;\n        }\n        .offset-xl-6 {\n            margin-left: 50%;\n        }\n        .offset-xl-7 {\n            margin-left: 58.33333333%;\n        }\n        .offset-xl-8 {\n            margin-left: 66.66666667%;\n        }\n        .offset-xl-9 {\n            margin-left: 75%;\n        }\n        .offset-xl-10 {\n            margin-left: 83.33333333%;\n        }\n        .offset-xl-11 {\n            margin-left: 91.66666667%;\n        }\n        .g-xl-0,\n        .gx-xl-0 {\n            --bs-gutter-x: 0;\n        }\n        .g-xl-0,\n        .gy-xl-0 {\n            --bs-gutter-y: 0;\n        }\n        .g-xl-1,\n        .gx-xl-1 {\n            --bs-gutter-x: 0.25rem;\n        }\n        .g-xl-1,\n        .gy-xl-1 {\n            --bs-gutter-y: 0.25rem;\n        }\n        .g-xl-2,\n        .gx-xl-2 {\n            --bs-gutter-x: 0.5rem;\n        }\n        .g-xl-2,\n        .gy-xl-2 {\n            --bs-gutter-y: 0.5rem;\n        }\n        .g-xl-3,\n        .gx-xl-3 {\n            --bs-gutter-x: 1rem;\n        }\n        .g-xl-3,\n        .gy-xl-3 {\n            --bs-gutter-y: 1rem;\n        }\n        .g-xl-4,\n        .gx-xl-4 {\n            --bs-gutter-x: 1.5rem;\n        }\n        .g-xl-4,\n        .gy-xl-4 {\n            --bs-gutter-y: 1.5rem;\n        }\n        .g-xl-5,\n        .gx-xl-5 {\n            --bs-gutter-x: 3rem;\n        }\n        .g-xl-5,\n        .gy-xl-5 {\n            --bs-gutter-y: 3rem;\n        }\n    }\n    @media (min-width: 1400px) {\n        .col-xxl {\n            flex: 1 0 0%;\n        }\n        .row-cols-xxl-auto > * {\n            flex: 0 0 auto;\n            width: auto;\n        }\n        .row-cols-xxl-1 > * {\n            flex: 0 0 auto;\n            width: 100%;\n        }\n        .row-cols-xxl-2 > * {\n            flex: 0 0 auto;\n            width: 50%;\n        }\n        .row-cols-xxl-3 > * {\n            flex: 0 0 auto;\n            width: 33.33333333%;\n        }\n        .row-cols-xxl-4 > * {\n            flex: 0 0 auto;\n            width: 25%;\n        }\n        .row-cols-xxl-5 > * {\n            flex: 0 0 auto;\n            width: 20%;\n        }\n        .row-cols-xxl-6 > * {\n            flex: 0 0 auto;\n            width: 16.66666667%;\n        }\n        .col-xxl-auto {\n            flex: 0 0 auto;\n            width: auto;\n        }\n        .col-xxl-1 {\n            flex: 0 0 auto;\n            width: 8.33333333%;\n        }\n        .col-xxl-2 {\n            flex: 0 0 auto;\n            width: 16.66666667%;\n        }\n        .col-xxl-3 {\n            flex: 0 0 auto;\n            width: 25%;\n        }\n        .col-xxl-4 {\n            flex: 0 0 auto;\n            width: 33.33333333%;\n        }\n        .col-xxl-5 {\n            flex: 0 0 auto;\n            width: 41.66666667%;\n        }\n        .col-xxl-6 {\n            flex: 0 0 auto;\n            width: 50%;\n        }\n        .col-xxl-7 {\n            flex: 0 0 auto;\n            width: 58.33333333%;\n        }\n        .col-xxl-8 {\n            flex: 0 0 auto;\n            width: 66.66666667%;\n        }\n        .col-xxl-9 {\n            flex: 0 0 auto;\n            width: 75%;\n        }\n        .col-xxl-10 {\n            flex: 0 0 auto;\n            width: 83.33333333%;\n        }\n        .col-xxl-11 {\n            flex: 0 0 auto;\n            width: 91.66666667%;\n        }\n        .col-xxl-12 {\n            flex: 0 0 auto;\n            width: 100%;\n        }\n        .offset-xxl-0 {\n            margin-left: 0;\n        }\n        .offset-xxl-1 {\n            margin-left: 8.33333333%;\n        }\n        .offset-xxl-2 {\n            margin-left: 16.66666667%;\n        }\n        .offset-xxl-3 {\n            margin-left: 25%;\n        }\n        .offset-xxl-4 {\n            margin-left: 33.33333333%;\n        }\n        .offset-xxl-5 {\n            margin-left: 41.66666667%;\n        }\n        .offset-xxl-6 {\n            margin-left: 50%;\n        }\n        .offset-xxl-7 {\n            margin-left: 58.33333333%;\n        }\n        .offset-xxl-8 {\n            margin-left: 66.66666667%;\n        }\n        .offset-xxl-9 {\n            margin-left: 75%;\n        }\n        .offset-xxl-10 {\n            margin-left: 83.33333333%;\n        }\n        .offset-xxl-11 {\n            margin-left: 91.66666667%;\n        }\n        .g-xxl-0,\n        .gx-xxl-0 {\n            --bs-gutter-x: 0;\n        }\n        .g-xxl-0,\n        .gy-xxl-0 {\n            --bs-gutter-y: 0;\n        }\n        .g-xxl-1,\n        .gx-xxl-1 {\n            --bs-gutter-x: 0.25rem;\n        }\n        .g-xxl-1,\n        .gy-xxl-1 {\n            --bs-gutter-y: 0.25rem;\n        }\n        .g-xxl-2,\n        .gx-xxl-2 {\n            --bs-gutter-x: 0.5rem;\n        }\n        .g-xxl-2,\n        .gy-xxl-2 {\n            --bs-gutter-y: 0.5rem;\n        }\n        .g-xxl-3,\n        .gx-xxl-3 {\n            --bs-gutter-x: 1rem;\n        }\n        .g-xxl-3,\n        .gy-xxl-3 {\n            --bs-gutter-y: 1rem;\n        }\n        .g-xxl-4,\n        .gx-xxl-4 {\n            --bs-gutter-x: 1.5rem;\n        }\n        .g-xxl-4,\n        .gy-xxl-4 {\n            --bs-gutter-y: 1.5rem;\n        }\n        .g-xxl-5,\n        .gx-xxl-5 {\n            --bs-gutter-x: 3rem;\n        }\n        .g-xxl-5,\n        .gy-xxl-5 {\n            --bs-gutter-y: 3rem;\n        }\n    }\n    .table {\n        --bs-table-color-type: initial;\n        --bs-table-bg-type: initial;\n        --bs-table-color-state: initial;\n        --bs-table-bg-state: initial;\n        --bs-table-color: var(--bs-emphasis-color);\n        --bs-table-bg: var(--bs-body-bg);\n        --bs-table-border-color: var(--bs-border-color);\n        --bs-table-accent-bg: transparent;\n        --bs-table-striped-color: var(--bs-emphasis-color);\n        --bs-table-striped-bg: rgba(var(--bs-emphasis-color-rgb), 0.05);\n        --bs-table-active-color: var(--bs-emphasis-color);\n        --bs-table-active-bg: rgba(var(--bs-emphasis-color-rgb), 0.1);\n        --bs-table-hover-color: var(--bs-emphasis-color);\n        --bs-table-hover-bg: rgba(var(--bs-emphasis-color-rgb), 0.075);\n        width: 100%;\n        margin-bottom: 1rem;\n        vertical-align: top;\n        border-color: var(--bs-table-border-color);\n    }\n    .table > :not(caption) > * > * {\n        padding: 0.5rem 0.5rem;\n        color: var(\n            --bs-table-color-state,\n            var(--bs-table-color-type, var(--bs-table-color))\n        );\n        background-color: var(--bs-table-bg);\n        border-bottom-width: var(--bs-border-width);\n        box-shadow: inset 0 0 0 9999px\n            var(\n                --bs-table-bg-state,\n                var(--bs-table-bg-type, var(--bs-table-accent-bg))\n            );\n    }\n    .table > tbody {\n        vertical-align: inherit;\n    }\n    .table > thead {\n        vertical-align: bottom;\n    }\n\n    .table-group-divider {\n        border-top: calc(var(--bs-border-width) * 2) solid currentcolor;\n    }\n\n    .caption-top {\n        caption-side: top;\n    }\n\n    .table-sm > :not(caption) > * > * {\n        padding: 0.25rem 0.25rem;\n    }\n\n    .table-bordered > :not(caption) > * {\n        border-width: var(--bs-border-width) 0;\n    }\n    .table-bordered > :not(caption) > * > * {\n        border-width: 0 var(--bs-border-width);\n    }\n\n    .table-borderless > :not(caption) > * > * {\n        border-bottom-width: 0;\n    }\n    .table-borderless > :not(:first-child) {\n        border-top-width: 0;\n    }\n\n    .table-striped > tbody > tr:nth-of-type(odd) > * {\n        --bs-table-color-type: var(--bs-table-striped-color);\n        --bs-table-bg-type: var(--bs-table-striped-bg);\n    }\n\n    .table-striped-columns > :not(caption) > tr > :nth-child(even) {\n        --bs-table-color-type: var(--bs-table-striped-color);\n        --bs-table-bg-type: var(--bs-table-striped-bg);\n    }\n\n    .table-active {\n        --bs-table-color-state: var(--bs-table-active-color);\n        --bs-table-bg-state: var(--bs-table-active-bg);\n    }\n\n    .table-hover > tbody > tr:hover > * {\n        --bs-table-color-state: var(--bs-table-hover-color);\n        --bs-table-bg-state: var(--bs-table-hover-bg);\n    }\n\n    .table-primary {\n        --bs-table-color: #000;\n        --bs-table-bg: #cfe2ff;\n        --bs-table-border-color: #a6b5cc;\n        --bs-table-striped-bg: #c5d7f2;\n        --bs-table-striped-color: #000;\n        --bs-table-active-bg: #bacbe6;\n        --bs-table-active-color: #000;\n        --bs-table-hover-bg: #bfd1ec;\n        --bs-table-hover-color: #000;\n        color: var(--bs-table-color);\n        border-color: var(--bs-table-border-color);\n    }\n\n    .table-secondary {\n        --bs-table-color: #000;\n        --bs-table-bg: #e2e3e5;\n        --bs-table-border-color: #b5b6b7;\n        --bs-table-striped-bg: #d7d8da;\n        --bs-table-striped-color: #000;\n        --bs-table-active-bg: #cbccce;\n        --bs-table-active-color: #000;\n        --bs-table-hover-bg: #d1d2d4;\n        --bs-table-hover-color: #000;\n        color: var(--bs-table-color);\n        border-color: var(--bs-table-border-color);\n    }\n\n    .table-success {\n        --bs-table-color: #000;\n        --bs-table-bg: #d1e7dd;\n        --bs-table-border-color: #a7b9b1;\n        --bs-table-striped-bg: #c7dbd2;\n        --bs-table-striped-color: #000;\n        --bs-table-active-bg: #bcd0c7;\n        --bs-table-active-color: #000;\n        --bs-table-hover-bg: #c1d6cc;\n        --bs-table-hover-color: #000;\n        color: var(--bs-table-color);\n        border-color: var(--bs-table-border-color);\n    }\n\n    .table-info {\n        --bs-table-color: #000;\n        --bs-table-bg: #cff4fc;\n        --bs-table-border-color: #a6c3ca;\n        --bs-table-striped-bg: #c5e8ef;\n        --bs-table-striped-color: #000;\n        --bs-table-active-bg: #badce3;\n        --bs-table-active-color: #000;\n        --bs-table-hover-bg: #bfe2e9;\n        --bs-table-hover-color: #000;\n        color: var(--bs-table-color);\n        border-color: var(--bs-table-border-color);\n    }\n\n    .table-warning {\n        --bs-table-color: #000;\n        --bs-table-bg: #fff3cd;\n        --bs-table-border-color: #ccc2a4;\n        --bs-table-striped-bg: #f2e7c3;\n        --bs-table-striped-color: #000;\n        --bs-table-active-bg: #e6dbb9;\n        --bs-table-active-color: #000;\n        --bs-table-hover-bg: #ece1be;\n        --bs-table-hover-color: #000;\n        color: var(--bs-table-color);\n        border-color: var(--bs-table-border-color);\n    }\n\n    .table-danger {\n        --bs-table-color: #000;\n        --bs-table-bg: #f8d7da;\n        --bs-table-border-color: #c6acae;\n        --bs-table-striped-bg: #eccccf;\n        --bs-table-striped-color: #000;\n        --bs-table-active-bg: #dfc2c4;\n        --bs-table-active-color: #000;\n        --bs-table-hover-bg: #e5c7ca;\n        --bs-table-hover-color: #000;\n        color: var(--bs-table-color);\n        border-color: var(--bs-table-border-color);\n    }\n\n    .table-light {\n        --bs-table-color: #000;\n        --bs-table-bg: #f8f9fa;\n        --bs-table-border-color: #c6c7c8;\n        --bs-table-striped-bg: #ecedee;\n        --bs-table-striped-color: #000;\n        --bs-table-active-bg: #dfe0e1;\n        --bs-table-active-color: #000;\n        --bs-table-hover-bg: #e5e6e7;\n        --bs-table-hover-color: #000;\n        color: var(--bs-table-color);\n        border-color: var(--bs-table-border-color);\n    }\n\n    .table-dark {\n        --bs-table-color: #fff;\n        --bs-table-bg: #212529;\n        --bs-table-border-color: #4d5154;\n        --bs-table-striped-bg: #2c3034;\n        --bs-table-striped-color: #fff;\n        --bs-table-active-bg: #373b3e;\n        --bs-table-active-color: #fff;\n        --bs-table-hover-bg: #323539;\n        --bs-table-hover-color: #fff;\n        color: var(--bs-table-color);\n        border-color: var(--bs-table-border-color);\n    }\n\n    .table-responsive {\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch;\n    }\n\n    @media (max-width: 575.98px) {\n        .table-responsive-sm {\n            overflow-x: auto;\n            -webkit-overflow-scrolling: touch;\n        }\n    }\n    @media (max-width: 767.98px) {\n        .table-responsive-md {\n            overflow-x: auto;\n            -webkit-overflow-scrolling: touch;\n        }\n    }\n    @media (max-width: 991.98px) {\n        .table-responsive-lg {\n            overflow-x: auto;\n            -webkit-overflow-scrolling: touch;\n        }\n    }\n    @media (max-width: 1199.98px) {\n        .table-responsive-xl {\n            overflow-x: auto;\n            -webkit-overflow-scrolling: touch;\n        }\n    }\n    @media (max-width: 1399.98px) {\n        .table-responsive-xxl {\n            overflow-x: auto;\n            -webkit-overflow-scrolling: touch;\n        }\n    }\n    .form-label {\n        margin-bottom: 0.5rem;\n    }\n\n    .col-form-label {\n        padding-top: calc(0.375rem + var(--bs-border-width));\n        padding-bottom: calc(0.375rem + var(--bs-border-width));\n        margin-bottom: 0;\n        font-size: inherit;\n        line-height: 1.5;\n    }\n\n    .col-form-label-lg {\n        padding-top: calc(0.5rem + var(--bs-border-width));\n        padding-bottom: calc(0.5rem + var(--bs-border-width));\n        font-size: 1.25rem;\n    }\n\n    .col-form-label-sm {\n        padding-top: calc(0.25rem + var(--bs-border-width));\n        padding-bottom: calc(0.25rem + var(--bs-border-width));\n        font-size: 0.875rem;\n    }\n\n    .form-text {\n        margin-top: 0.25rem;\n        font-size: 0.875em;\n        color: var(--bs-secondary-color);\n    }\n\n    .form-control {\n        display: block;\n        width: 100%;\n        padding: 0.375rem 0.75rem;\n        font-size: 1rem;\n        font-weight: 400;\n        line-height: 1.5;\n        color: var(--bs-body-color);\n        -webkit-appearance: none;\n        -moz-appearance: none;\n        appearance: none;\n        background-color: var(--bs-body-bg);\n        background-clip: padding-box;\n        border: var(--bs-border-width) solid var(--bs-border-color);\n        border-radius: var(--bs-border-radius);\n        transition:\n            border-color 0.15s ease-in-out,\n            box-shadow 0.15s ease-in-out;\n    }\n    @media (prefers-reduced-motion: reduce) {\n        .form-control {\n            transition: none;\n        }\n    }\n    .form-control[type='file'] {\n        overflow: hidden;\n    }\n    .form-control[type='file']:not(:disabled):not([readonly]) {\n        cursor: pointer;\n    }\n    .form-control:focus {\n        color: var(--bs-body-color);\n        background-color: var(--bs-body-bg);\n        border-color: #86b7fe;\n        outline: 0;\n        box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n    }\n    .form-control::-webkit-date-and-time-value {\n        min-width: 85px;\n        height: 1.5em;\n        margin: 0;\n    }\n    .form-control::-webkit-datetime-edit {\n        display: block;\n        padding: 0;\n    }\n    .form-control::-moz-placeholder {\n        color: var(--bs-secondary-color);\n        opacity: 1;\n    }\n    .form-control::placeholder {\n        color: var(--bs-secondary-color);\n        opacity: 1;\n    }\n    .form-control:disabled {\n        background-color: var(--bs-secondary-bg);\n        opacity: 1;\n    }\n    .form-control::-webkit-file-upload-button {\n        padding: 0.375rem 0.75rem;\n        margin: -0.375rem -0.75rem;\n        -webkit-margin-end: 0.75rem;\n        margin-inline-end: 0.75rem;\n        color: var(--bs-body-color);\n        background-color: var(--bs-tertiary-bg);\n        pointer-events: none;\n        border-color: inherit;\n        border-style: solid;\n        border-width: 0;\n        border-inline-end-width: var(--bs-border-width);\n        border-radius: 0;\n        -webkit-transition:\n            color 0.15s ease-in-out,\n            background-color 0.15s ease-in-out,\n            border-color 0.15s ease-in-out,\n            box-shadow 0.15s ease-in-out;\n        transition:\n            color 0.15s ease-in-out,\n            background-color 0.15s ease-in-out,\n            border-color 0.15s ease-in-out,\n            box-shadow 0.15s ease-in-out;\n    }\n    .form-control::file-selector-button {\n        padding: 0.375rem 0.75rem;\n        margin: -0.375rem -0.75rem;\n        -webkit-margin-end: 0.75rem;\n        margin-inline-end: 0.75rem;\n        color: var(--bs-body-color);\n        background-color: var(--bs-tertiary-bg);\n        pointer-events: none;\n        border-color: inherit;\n        border-style: solid;\n        border-width: 0;\n        border-inline-end-width: var(--bs-border-width);\n        border-radius: 0;\n        transition:\n            color 0.15s ease-in-out,\n            background-color 0.15s ease-in-out,\n            border-color 0.15s ease-in-out,\n            box-shadow 0.15s ease-in-out;\n    }\n    @media (prefers-reduced-motion: reduce) {\n        .form-control::-webkit-file-upload-button {\n            -webkit-transition: none;\n            transition: none;\n        }\n        .form-control::file-selector-button {\n            transition: none;\n        }\n    }\n    .form-control:hover:not(:disabled):not(\n            [readonly]\n        )::-webkit-file-upload-button {\n        background-color: var(--bs-secondary-bg);\n    }\n    .form-control:hover:not(:disabled):not([readonly])::file-selector-button {\n        background-color: var(--bs-secondary-bg);\n    }\n\n    .form-control-plaintext {\n        display: block;\n        width: 100%;\n        padding: 0.375rem 0;\n        margin-bottom: 0;\n        line-height: 1.5;\n        color: var(--bs-body-color);\n        background-color: transparent;\n        border: solid transparent;\n        border-width: var(--bs-border-width) 0;\n    }\n    .form-control-plaintext:focus {\n        outline: 0;\n    }\n    .form-control-plaintext.form-control-sm,\n    .form-control-plaintext.form-control-lg {\n        padding-right: 0;\n        padding-left: 0;\n    }\n\n    .form-control-sm {\n        min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));\n        padding: 0.25rem 0.5rem;\n        font-size: 0.875rem;\n        border-radius: var(--bs-border-radius-sm);\n    }\n    .form-control-sm::-webkit-file-upload-button {\n        padding: 0.25rem 0.5rem;\n        margin: -0.25rem -0.5rem;\n        -webkit-margin-end: 0.5rem;\n        margin-inline-end: 0.5rem;\n    }\n    .form-control-sm::file-selector-button {\n        padding: 0.25rem 0.5rem;\n        margin: -0.25rem -0.5rem;\n        -webkit-margin-end: 0.5rem;\n        margin-inline-end: 0.5rem;\n    }\n\n    .form-control-lg {\n        min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));\n        padding: 0.5rem 1rem;\n        font-size: 1.25rem;\n        border-radius: var(--bs-border-radius-lg);\n    }\n    .form-control-lg::-webkit-file-upload-button {\n        padding: 0.5rem 1rem;\n        margin: -0.5rem -1rem;\n        -webkit-margin-end: 1rem;\n        margin-inline-end: 1rem;\n    }\n    .form-control-lg::file-selector-button {\n        padding: 0.5rem 1rem;\n        margin: -0.5rem -1rem;\n        -webkit-margin-end: 1rem;\n        margin-inline-end: 1rem;\n    }\n\n    textarea.form-control {\n        min-height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2));\n    }\n    textarea.form-control-sm {\n        min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));\n    }\n    textarea.form-control-lg {\n        min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));\n    }\n\n    .form-control-color {\n        width: 3rem;\n        height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2));\n        padding: 0.375rem;\n    }\n    .form-control-color:not(:disabled):not([readonly]) {\n        cursor: pointer;\n    }\n    .form-control-color::-moz-color-swatch {\n        border: 0 !important;\n        border-radius: var(--bs-border-radius);\n    }\n    .form-control-color::-webkit-color-swatch {\n        border: 0 !important;\n        border-radius: var(--bs-border-radius);\n    }\n    .form-control-color.form-control-sm {\n        height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));\n    }\n    .form-control-color.form-control-lg {\n        height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));\n    }\n\n    .form-select {\n        --bs-form-select-bg-img: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\");\n        display: block;\n        width: 100%;\n        padding: 0.375rem 2.25rem 0.375rem 0.75rem;\n        font-size: 1rem;\n        font-weight: 400;\n        line-height: 1.5;\n        color: var(--bs-body-color);\n        -webkit-appearance: none;\n        -moz-appearance: none;\n        appearance: none;\n        background-color: var(--bs-body-bg);\n        background-image: var(--bs-form-select-bg-img),\n            var(--bs-form-select-bg-icon, none);\n        background-repeat: no-repeat;\n        background-position: right 0.75rem center;\n        background-size: 16px 12px;\n        border: var(--bs-border-width) solid var(--bs-border-color);\n        border-radius: var(--bs-border-radius);\n        transition:\n            border-color 0.15s ease-in-out,\n            box-shadow 0.15s ease-in-out;\n    }\n    @media (prefers-reduced-motion: reduce) {\n        .form-select {\n            transition: none;\n        }\n    }\n    .form-select:focus {\n        border-color: #86b7fe;\n        outline: 0;\n        box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n    }\n    .form-select[multiple],\n    .form-select[size]:not([size='1']) {\n        padding-right: 0.75rem;\n        background-image: none;\n    }\n    .form-select:disabled {\n        background-color: var(--bs-secondary-bg);\n    }\n    .form-select:-moz-focusring {\n        color: transparent;\n        text-shadow: 0 0 0 var(--bs-body-color);\n    }\n\n    .form-select-sm {\n        padding-top: 0.25rem;\n        padding-bottom: 0.25rem;\n        padding-left: 0.5rem;\n        font-size: 0.875rem;\n        border-radius: var(--bs-border-radius-sm);\n    }\n\n    .form-select-lg {\n        padding-top: 0.5rem;\n        padding-bottom: 0.5rem;\n        padding-left: 1rem;\n        font-size: 1.25rem;\n        border-radius: var(--bs-border-radius-lg);\n    }\n\n    [data-bs-theme='dark'] .form-select {\n        --bs-form-select-bg-img: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23dee2e6' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\");\n    }\n\n    .form-check {\n        display: block;\n        min-height: 1.5rem;\n        padding-left: 1.5em;\n        margin-bottom: 0.125rem;\n    }\n    .form-check .form-check-input {\n        float: left;\n        margin-left: -1.5em;\n    }\n\n    .form-check-reverse {\n        padding-right: 1.5em;\n        padding-left: 0;\n        text-align: right;\n    }\n    .form-check-reverse .form-check-input {\n        float: right;\n        margin-right: -1.5em;\n        margin-left: 0;\n    }\n\n    .form-check-input {\n        --bs-form-check-bg: var(--bs-body-bg);\n        flex-shrink: 0;\n        width: 1em;\n        height: 1em;\n        margin-top: 0.25em;\n        vertical-align: top;\n        -webkit-appearance: none;\n        -moz-appearance: none;\n        appearance: none;\n        background-color: var(--bs-form-check-bg);\n        background-image: var(--bs-form-check-bg-image);\n        background-repeat: no-repeat;\n        background-position: center;\n        background-size: contain;\n        border: var(--bs-border-width) solid var(--bs-border-color);\n        -webkit-print-color-adjust: exact;\n        color-adjust: exact;\n        print-color-adjust: exact;\n    }\n    .form-check-input[type='checkbox'] {\n        border-radius: 0.25em;\n    }\n    .form-check-input[type='radio'] {\n        border-radius: 50%;\n    }\n    .form-check-input:active {\n        filter: brightness(90%);\n    }\n    .form-check-input:focus {\n        border-color: #86b7fe;\n        outline: 0;\n        box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n    }\n    .form-check-input:checked {\n        background-color: #0d6efd;\n        border-color: #0d6efd;\n    }\n    .form-check-input:checked[type='checkbox'] {\n        --bs-form-check-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/%3e%3c/svg%3e\");\n    }\n    .form-check-input:checked[type='radio'] {\n        --bs-form-check-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2' fill='%23fff'/%3e%3c/svg%3e\");\n    }\n    .form-check-input[type='checkbox']:indeterminate {\n        background-color: #0d6efd;\n        border-color: #0d6efd;\n        --bs-form-check-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/%3e%3c/svg%3e\");\n    }\n    .form-check-input:disabled {\n        pointer-events: none;\n        filter: none;\n        opacity: 0.5;\n    }\n    .form-check-input[disabled] ~ .form-check-label,\n    .form-check-input:disabled ~ .form-check-label {\n        cursor: default;\n        opacity: 0.5;\n    }\n\n    .form-switch {\n        padding-left: 2.5em;\n    }\n    .form-switch .form-check-input {\n        --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%280, 0, 0, 0.25%29'/%3e%3c/svg%3e\");\n        width: 2em;\n        margin-left: -2.5em;\n        background-image: var(--bs-form-switch-bg);\n        background-position: left center;\n        border-radius: 2em;\n        transition: background-position 0.15s ease-in-out;\n    }\n    @media (prefers-reduced-motion: reduce) {\n        .form-switch .form-check-input {\n            transition: none;\n        }\n    }\n    .form-switch .form-check-input:focus {\n        --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%2386b7fe'/%3e%3c/svg%3e\");\n    }\n    .form-switch .form-check-input:checked {\n        background-position: right center;\n        --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\");\n    }\n    .form-switch.form-check-reverse {\n        padding-right: 2.5em;\n        padding-left: 0;\n    }\n    .form-switch.form-check-reverse .form-check-input {\n        margin-right: -2.5em;\n        margin-left: 0;\n    }\n\n    .form-check-inline {\n        display: inline-block;\n        margin-right: 1rem;\n    }\n\n    .btn-check {\n        position: absolute;\n        clip: rect(0, 0, 0, 0);\n        pointer-events: none;\n    }\n    .btn-check[disabled] + .btn,\n    .btn-check:disabled + .btn {\n        pointer-events: none;\n        filter: none;\n        opacity: 0.65;\n    }\n\n    [data-bs-theme='dark']\n        .form-switch\n        .form-check-input:not(:checked):not(:focus) {\n        --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%28255, 255, 255, 0.25%29'/%3e%3c/svg%3e\");\n    }\n\n    .form-range {\n        width: 100%;\n        height: 1.5rem;\n        padding: 0;\n        -webkit-appearance: none;\n        -moz-appearance: none;\n        appearance: none;\n        background-color: transparent;\n    }\n    .form-range:focus {\n        outline: 0;\n    }\n    .form-range:focus::-webkit-slider-thumb {\n        box-shadow:\n            0 0 0 1px #fff,\n            0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n    }\n    .form-range:focus::-moz-range-thumb {\n        box-shadow:\n            0 0 0 1px #fff,\n            0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n    }\n    .form-range::-moz-focus-outer {\n        border: 0;\n    }\n    .form-range::-webkit-slider-thumb {\n        width: 1rem;\n        height: 1rem;\n        margin-top: -0.25rem;\n        -webkit-appearance: none;\n        appearance: none;\n        background-color: #0d6efd;\n        border: 0;\n        border-radius: 1rem;\n        -webkit-transition:\n            background-color 0.15s ease-in-out,\n            border-color 0.15s ease-in-out,\n            box-shadow 0.15s ease-in-out;\n        transition:\n            background-color 0.15s ease-in-out,\n            border-color 0.15s ease-in-out,\n            box-shadow 0.15s ease-in-out;\n    }\n    @media (prefers-reduced-motion: reduce) {\n        .form-range::-webkit-slider-thumb {\n            -webkit-transition: none;\n            transition: none;\n        }\n    }\n    .form-range::-webkit-slider-thumb:active {\n        background-color: #b6d4fe;\n    }\n    .form-range::-webkit-slider-runnable-track {\n        width: 100%;\n        height: 0.5rem;\n        color: transparent;\n        cursor: pointer;\n        background-color: var(--bs-secondary-bg);\n        border-color: transparent;\n        border-radius: 1rem;\n    }\n    .form-range::-moz-range-thumb {\n        width: 1rem;\n        height: 1rem;\n        -moz-appearance: none;\n        appearance: none;\n        background-color: #0d6efd;\n        border: 0;\n        border-radius: 1rem;\n        -moz-transition:\n            background-color 0.15s ease-in-out,\n            border-color 0.15s ease-in-out,\n            box-shadow 0.15s ease-in-out;\n        transition:\n            background-color 0.15s ease-in-out,\n            border-color 0.15s ease-in-out,\n            box-shadow 0.15s ease-in-out;\n    }\n    @media (prefers-reduced-motion: reduce) {\n        .form-range::-moz-range-thumb {\n            -moz-transition: none;\n            transition: none;\n        }\n    }\n    .form-range::-moz-range-thumb:active {\n        background-color: #b6d4fe;\n    }\n    .form-range::-moz-range-track {\n        width: 100%;\n        height: 0.5rem;\n        color: transparent;\n        cursor: pointer;\n        background-color: var(--bs-secondary-bg);\n        border-color: transparent;\n        border-radius: 1rem;\n    }\n    .form-range:disabled {\n        pointer-events: none;\n    }\n    .form-range:disabled::-webkit-slider-thumb {\n        background-color: var(--bs-secondary-color);\n    }\n    .form-range:disabled::-moz-range-thumb {\n        background-color: var(--bs-secondary-color);\n    }\n\n    .form-floating {\n        position: relative;\n    }\n    .form-floating > .form-control,\n    .form-floating > .form-control-plaintext,\n    .form-floating > .form-select {\n        height: calc(3.5rem + calc(var(--bs-border-width) * 2));\n        min-height: calc(3.5rem + calc(var(--bs-border-width) * 2));\n        line-height: 1.25;\n    }\n    .form-floating > label {\n        position: absolute;\n        top: 0;\n        left: 0;\n        z-index: 2;\n        height: 100%;\n        padding: 1rem 0.75rem;\n        overflow: hidden;\n        text-align: start;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        pointer-events: none;\n        border: var(--bs-border-width) solid transparent;\n        transform-origin: 0 0;\n        transition:\n            opacity 0.1s ease-in-out,\n            transform 0.1s ease-in-out;\n    }\n    @media (prefers-reduced-motion: reduce) {\n        .form-floating > label {\n            transition: none;\n        }\n    }\n    .form-floating > .form-control,\n    .form-floating > .form-control-plaintext {\n        padding: 1rem 0.75rem;\n    }\n    .form-floating > .form-control::-moz-placeholder,\n    .form-floating > .form-control-plaintext::-moz-placeholder {\n        color: transparent;\n    }\n    .form-floating > .form-control::placeholder,\n    .form-floating > .form-control-plaintext::placeholder {\n        color: transparent;\n    }\n    .form-floating > .form-control:not(:-moz-placeholder-shown),\n    .form-floating > .form-control-plaintext:not(:-moz-placeholder-shown) {\n        padding-top: 1.625rem;\n        padding-bottom: 0.625rem;\n    }\n    .form-floating > .form-control:focus,\n    .form-floating > .form-control:not(:placeholder-shown),\n    .form-floating > .form-control-plaintext:focus,\n    .form-floating > .form-control-plaintext:not(:placeholder-shown) {\n        padding-top: 1.625rem;\n        padding-bottom: 0.625rem;\n    }\n    .form-floating > .form-control:-webkit-autofill,\n    .form-floating > .form-control-plaintext:-webkit-autofill {\n        padding-top: 1.625rem;\n        padding-bottom: 0.625rem;\n    }\n    .form-floating > .form-select {\n        padding-top: 1.625rem;\n        padding-bottom: 0.625rem;\n    }\n    .form-floating > .form-control:not(:-moz-placeholder-shown) ~ label {\n        color: rgba(var(--bs-body-color-rgb), 0.65);\n        transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n    }\n    .form-floating > .form-control:focus ~ label,\n    .form-floating > .form-control:not(:placeholder-shown) ~ label,\n    .form-floating > .form-control-plaintext ~ label,\n    .form-floating > .form-select ~ label {\n        color: rgba(var(--bs-body-color-rgb), 0.65);\n        transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n    }\n    .form-floating > .form-control:not(:-moz-placeholder-shown) ~ label::after {\n        position: absolute;\n        inset: 1rem 0.375rem;\n        z-index: -1;\n        height: 1.5em;\n        content: '';\n        background-color: var(--bs-body-bg);\n        border-radius: var(--bs-border-radius);\n    }\n    .form-floating > .form-control:focus ~ label::after,\n    .form-floating > .form-control:not(:placeholder-shown) ~ label::after,\n    .form-floating > .form-control-plaintext ~ label::after,\n    .form-floating > .form-select ~ label::after {\n        position: absolute;\n        inset: 1rem 0.375rem;\n        z-index: -1;\n        height: 1.5em;\n        content: '';\n        background-color: var(--bs-body-bg);\n        border-radius: var(--bs-border-radius);\n    }\n    .form-floating > .form-control:-webkit-autofill ~ label {\n        color: rgba(var(--bs-body-color-rgb), 0.65);\n        transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n    }\n    .form-floating > .form-control-plaintext ~ label {\n        border-width: var(--bs-border-width) 0;\n    }\n    .form-floating > :disabled ~ label,\n    .form-floating > .form-control:disabled ~ label {\n        color: #6c757d;\n    }\n    .form-floating > :disabled ~ label::after,\n    .form-floating > .form-control:disabled ~ label::after {\n        background-color: var(--bs-secondary-bg);\n    }\n\n    .input-group {\n        position: relative;\n        display: flex;\n        flex-wrap: wrap;\n        align-items: stretch;\n        width: 100%;\n    }\n    .input-group > .form-control,\n    .input-group > .form-select,\n    .input-group > .form-floating {\n        position: relative;\n        flex: 1 1 auto;\n        width: 1%;\n        min-width: 0;\n    }\n    .input-group > .form-control:focus,\n    .input-group > .form-select:focus,\n    .input-group > .form-floating:focus-within {\n        z-index: 5;\n    }\n    .input-group .btn {\n        position: relative;\n        z-index: 2;\n    }\n    .input-group .btn:focus {\n        z-index: 5;\n    }\n\n    .input-group-text {\n        display: flex;\n        align-items: center;\n        padding: 0.375rem 0.75rem;\n        font-size: 1rem;\n        font-weight: 400;\n        line-height: 1.5;\n        color: var(--bs-body-color);\n        text-align: center;\n        white-space: nowrap;\n        background-color: var(--bs-tertiary-bg);\n        border: var(--bs-border-width) solid var(--bs-border-color);\n        border-radius: var(--bs-border-radius);\n    }\n\n    .input-group-lg > .form-control,\n    .input-group-lg > .form-select,\n    .input-group-lg > .input-group-text,\n    .input-group-lg > .btn {\n        padding: 0.5rem 1rem;\n        font-size: 1.25rem;\n        border-radius: var(--bs-border-radius-lg);\n    }\n\n    .input-group-sm > .form-control,\n    .input-group-sm > .form-select,\n    .input-group-sm > .input-group-text,\n    .input-group-sm > .btn {\n        padding: 0.25rem 0.5rem;\n        font-size: 0.875rem;\n        border-radius: var(--bs-border-radius-sm);\n    }\n\n    .input-group-lg > .form-select,\n    .input-group-sm > .form-select {\n        padding-right: 3rem;\n    }\n\n    .input-group:not(.has-validation)\n        > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(\n            .form-floating\n        ),\n    .input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n + 3),\n    .input-group:not(.has-validation)\n        > .form-floating:not(:last-child)\n        > .form-control,\n    .input-group:not(.has-validation)\n        > .form-floating:not(:last-child)\n        > .form-select {\n        border-top-right-radius: 0;\n        border-bottom-right-radius: 0;\n    }\n    .input-group.has-validation\n        > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(\n            .form-floating\n        ),\n    .input-group.has-validation > .dropdown-toggle:nth-last-child(n + 4),\n    .input-group.has-validation\n        > .form-floating:nth-last-child(n + 3)\n        > .form-control,\n    .input-group.has-validation\n        > .form-floating:nth-last-child(n + 3)\n        > .form-select {\n        border-top-right-radius: 0;\n        border-bottom-right-radius: 0;\n    }\n    .input-group\n        > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(\n            .valid-feedback\n        ):not(.invalid-tooltip):not(.invalid-feedback) {\n        margin-left: calc(var(--bs-border-width) * -1);\n        border-top-left-radius: 0;\n        border-bottom-left-radius: 0;\n    }\n    .input-group > .form-floating:not(:first-child) > .form-control,\n    .input-group > .form-floating:not(:first-child) > .form-select {\n        border-top-left-radius: 0;\n        border-bottom-left-radius: 0;\n    }\n\n    .valid-feedback {\n        display: none;\n        width: 100%;\n        margin-top: 0.25rem;\n        font-size: 0.875em;\n        color: var(--bs-form-valid-color);\n    }\n\n    .valid-tooltip {\n        position: absolute;\n        top: 100%;\n        z-index: 5;\n        display: none;\n        max-width: 100%;\n        padding: 0.25rem 0.5rem;\n        margin-top: 0.1rem;\n        font-size: 0.875rem;\n        color: #fff;\n        background-color: var(--bs-success);\n        border-radius: var(--bs-border-radius);\n    }\n\n    .was-validated :valid ~ .valid-feedback,\n    .was-validated :valid ~ .valid-tooltip,\n    .is-valid ~ .valid-feedback,\n    .is-valid ~ .valid-tooltip {\n        display: block;\n    }\n\n    .was-validated .form-control:valid,\n    .form-control.is-valid {\n        border-color: var(--bs-form-valid-border-color);\n        padding-right: calc(1.5em + 0.75rem);\n        background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23198754' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");\n        background-repeat: no-repeat;\n        background-position: right calc(0.375em + 0.1875rem) center;\n        background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n    }\n    .was-validated .form-control:valid:focus,\n    .form-control.is-valid:focus {\n        border-color: var(--bs-form-valid-border-color);\n        box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);\n    }\n\n    .was-validated textarea.form-control:valid,\n    textarea.form-control.is-valid {\n        padding-right: calc(1.5em + 0.75rem);\n        background-position: top calc(0.375em + 0.1875rem) right\n            calc(0.375em + 0.1875rem);\n    }\n\n    .was-validated .form-select:valid,\n    .form-select.is-valid {\n        border-color: var(--bs-form-valid-border-color);\n    }\n    .was-validated .form-select:valid:not([multiple]):not([size]),\n    .was-validated .form-select:valid:not([multiple])[size='1'],\n    .form-select.is-valid:not([multiple]):not([size]),\n    .form-select.is-valid:not([multiple])[size='1'] {\n        --bs-form-select-bg-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23198754' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");\n        padding-right: 4.125rem;\n        background-position:\n            right 0.75rem center,\n            center right 2.25rem;\n        background-size:\n            16px 12px,\n            calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n    }\n    .was-validated .form-select:valid:focus,\n    .form-select.is-valid:focus {\n        border-color: var(--bs-form-valid-border-color);\n        box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);\n    }\n\n    .was-validated .form-control-color:valid,\n    .form-control-color.is-valid {\n        width: calc(3rem + calc(1.5em + 0.75rem));\n    }\n\n    .was-validated .form-check-input:valid,\n    .form-check-input.is-valid {\n        border-color: var(--bs-form-valid-border-color);\n    }\n    .was-validated .form-check-input:valid:checked,\n    .form-check-input.is-valid:checked {\n        background-color: var(--bs-form-valid-color);\n    }\n    .was-validated .form-check-input:valid:focus,\n    .form-check-input.is-valid:focus {\n        box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);\n    }\n    .was-validated .form-check-input:valid ~ .form-check-label,\n    .form-check-input.is-valid ~ .form-check-label {\n        color: var(--bs-form-valid-color);\n    }\n\n    .form-check-inline .form-check-input ~ .valid-feedback {\n        margin-left: 0.5em;\n    }\n\n    .was-validated .input-group > .form-control:not(:focus):valid,\n    .input-group > .form-control:not(:focus).is-valid,\n    .was-validated .input-group > .form-select:not(:focus):valid,\n    .input-group > .form-select:not(:focus).is-valid,\n    .was-validated .input-group > .form-floating:not(:focus-within):valid,\n    .input-group > .form-floating:not(:focus-within).is-valid {\n        z-index: 3;\n    }\n\n    .invalid-feedback {\n        display: none;\n        width: 100%;\n        margin-top: 0.25rem;\n        font-size: 0.875em;\n        color: var(--bs-form-invalid-color);\n    }\n\n    .invalid-tooltip {\n        position: absolute;\n        top: 100%;\n        z-index: 5;\n        display: none;\n        max-width: 100%;\n        padding: 0.25rem 0.5rem;\n        margin-top: 0.1rem;\n        font-size: 0.875rem;\n        color: #fff;\n        background-color: var(--bs-danger);\n        border-radius: var(--bs-border-radius);\n    }\n\n    .was-validated :invalid ~ .invalid-feedback,\n    .was-validated :invalid ~ .invalid-tooltip,\n    .is-invalid ~ .invalid-feedback,\n    .is-invalid ~ .invalid-tooltip {\n        display: block;\n    }\n\n    .was-validated .form-control:invalid,\n    .form-control.is-invalid {\n        border-color: var(--bs-form-invalid-border-color);\n        padding-right: calc(1.5em + 0.75rem);\n        background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e\");\n        background-repeat: no-repeat;\n        background-position: right calc(0.375em + 0.1875rem) center;\n        background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n    }\n    .was-validated .form-control:invalid:focus,\n    .form-control.is-invalid:focus {\n        border-color: var(--bs-form-invalid-border-color);\n        box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);\n    }\n\n    .was-validated textarea.form-control:invalid,\n    textarea.form-control.is-invalid {\n        padding-right: calc(1.5em + 0.75rem);\n        background-position: top calc(0.375em + 0.1875rem) right\n            calc(0.375em + 0.1875rem);\n    }\n\n    .was-validated .form-select:invalid,\n    .form-select.is-invalid {\n        border-color: var(--bs-form-invalid-border-color);\n    }\n    .was-validated .form-select:invalid:not([multiple]):not([size]),\n    .was-validated .form-select:invalid:not([multiple])[size='1'],\n    .form-select.is-invalid:not([multiple]):not([size]),\n    .form-select.is-invalid:not([multiple])[size='1'] {\n        --bs-form-select-bg-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e\");\n        padding-right: 4.125rem;\n        background-position:\n            right 0.75rem center,\n            center right 2.25rem;\n        background-size:\n            16px 12px,\n            calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n    }\n    .was-validated .form-select:invalid:focus,\n    .form-select.is-invalid:focus {\n        border-color: var(--bs-form-invalid-border-color);\n        box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);\n    }\n\n    .was-validated .form-control-color:invalid,\n    .form-control-color.is-invalid {\n        width: calc(3rem + calc(1.5em + 0.75rem));\n    }\n\n    .was-validated .form-check-input:invalid,\n    .form-check-input.is-invalid {\n        border-color: var(--bs-form-invalid-border-color);\n    }\n    .was-validated .form-check-input:invalid:checked,\n    .form-check-input.is-invalid:checked {\n        background-color: var(--bs-form-invalid-color);\n    }\n    .was-validated .form-check-input:invalid:focus,\n    .form-check-input.is-invalid:focus {\n        box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);\n    }\n    .was-validated .form-check-input:invalid ~ .form-check-label,\n    .form-check-input.is-invalid ~ .form-check-label {\n        color: var(--bs-form-invalid-color);\n    }\n\n    .form-check-inline .form-check-input ~ .invalid-feedback {\n        margin-left: 0.5em;\n    }\n\n    .was-validated .input-group > .form-control:not(:focus):invalid,\n    .input-group > .form-control:not(:focus).is-invalid,\n    .was-validated .input-group > .form-select:not(:focus):invalid,\n    .input-group > .form-select:not(:focus).is-invalid,\n    .was-validated .input-group > .form-floating:not(:focus-within):invalid,\n    .input-group > .form-floating:not(:focus-within).is-invalid {\n        z-index: 4;\n    }\n\n    .btn {\n        --bs-btn-padding-x: 0.75rem;\n        --bs-btn-padding-y: 0.375rem;\n        --bs-btn-font-size: 1rem;\n        --bs-btn-font-weight: 400;\n        --bs-btn-line-height: 1.5;\n        --bs-btn-color: var(--bs-body-color);\n        --bs-btn-bg: transparent;\n        --bs-btn-border-width: var(--bs-border-width);\n        --bs-btn-border-color: transparent;\n        --bs-btn-border-radius: var(--bs-border-radius);\n        --bs-btn-hover-border-color: transparent;\n        --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15),\n            0 1px 1px rgba(0, 0, 0, 0.075);\n        --bs-btn-disabled-opacity: 0.65;\n        --bs-btn-focus-box-shadow: 0 0 0 0.25rem\n            rgba(var(--bs-btn-focus-shadow-rgb), 0.5);\n        display: inline-block;\n        padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);\n        font-family: var(--bs-btn-font-family);\n        font-size: var(--bs-btn-font-size);\n        font-weight: var(--bs-btn-font-weight);\n        line-height: var(--bs-btn-line-height);\n        color: var(--bs-btn-color);\n        text-align: center;\n        text-decoration: none;\n        vertical-align: middle;\n        cursor: pointer;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        user-select: none;\n        border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);\n        border-radius: var(--bs-btn-border-radius);\n        background-color: var(--bs-btn-bg);\n        transition:\n            color 0.15s ease-in-out,\n            background-color 0.15s ease-in-out,\n            border-color 0.15s ease-in-out,\n            box-shadow 0.15s ease-in-out;\n    }\n    @media (prefers-reduced-motion: reduce) {\n        .btn {\n            transition: none;\n        }\n    }\n    .btn:hover {\n        color: var(--bs-btn-hover-color);\n        background-color: var(--bs-btn-hover-bg);\n        border-color: var(--bs-btn-hover-border-color);\n    }\n    .btn-check + .btn:hover {\n        color: var(--bs-btn-color);\n        background-color: var(--bs-btn-bg);\n        border-color: var(--bs-btn-border-color);\n    }\n    .btn:focus-visible {\n        color: var(--bs-btn-hover-color);\n        background-color: var(--bs-btn-hover-bg);\n        border-color: var(--bs-btn-hover-border-color);\n        outline: 0;\n        box-shadow: var(--bs-btn-focus-box-shadow);\n    }\n    .btn-check:focus-visible + .btn {\n        border-color: var(--bs-btn-hover-border-color);\n        outline: 0;\n        box-shadow: var(--bs-btn-focus-box-shadow);\n    }\n    .btn-check:checked + .btn,\n    :not(.btn-check) + .btn:active,\n    .btn:first-child:active,\n    .btn.active,\n    .btn.show {\n        color: var(--bs-btn-active-color);\n        background-color: var(--bs-btn-active-bg);\n        border-color: var(--bs-btn-active-border-color);\n    }\n    .btn-check:checked + .btn:focus-visible,\n    :not(.btn-check) + .btn:active:focus-visible,\n    .btn:first-child:active:focus-visible,\n    .btn.active:focus-visible,\n    .btn.show:focus-visible {\n        box-shadow: var(--bs-btn-focus-box-shadow);\n    }\n    .btn-check:checked:focus-visible + .btn {\n        box-shadow: var(--bs-btn-focus-box-shadow);\n    }\n    .btn:disabled,\n    .btn.disabled,\n    fieldset:disabled .btn {\n        color: var(--bs-btn-disabled-color);\n        pointer-events: none;\n        background-color: var(--bs-btn-disabled-bg);\n        border-color: var(--bs-btn-disabled-border-color);\n        opacity: var(--bs-btn-disabled-opacity);\n    }\n\n    .btn-primary {\n        --bs-btn-color: #fff;\n        --bs-btn-bg: #0d6efd;\n        --bs-btn-border-color: #0d6efd;\n        --bs-btn-hover-color: #fff;\n        --bs-btn-hover-bg: #0b5ed7;\n        --bs-btn-hover-border-color: #0a58ca;\n        --bs-btn-focus-shadow-rgb: 49, 132, 253;\n        --bs-btn-active-color: #fff;\n        --bs-btn-active-bg: #0a58ca;\n        --bs-btn-active-border-color: #0a53be;\n        --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n        --bs-btn-disabled-color: #fff;\n        --bs-btn-disabled-bg: #0d6efd;\n        --bs-btn-disabled-border-color: #0d6efd;\n    }\n\n    .btn-secondary {\n        --bs-btn-color: #fff;\n        --bs-btn-bg: #6c757d;\n        --bs-btn-border-color: #6c757d;\n        --bs-btn-hover-color: #fff;\n        --bs-btn-hover-bg: #5c636a;\n        --bs-btn-hover-border-color: #565e64;\n        --bs-btn-focus-shadow-rgb: 130, 138, 145;\n        --bs-btn-active-color: #fff;\n        --bs-btn-active-bg: #565e64;\n        --bs-btn-active-border-color: #51585e;\n        --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n        --bs-btn-disabled-color: #fff;\n        --bs-btn-disabled-bg: #6c757d;\n        --bs-btn-disabled-border-color: #6c757d;\n    }\n\n    .btn-success {\n        --bs-btn-color: #fff;\n        --bs-btn-bg: #198754;\n        --bs-btn-border-color: #198754;\n        --bs-btn-hover-color: #fff;\n        --bs-btn-hover-bg: #157347;\n        --bs-btn-hover-border-color: #146c43;\n        --bs-btn-focus-shadow-rgb: 60, 153, 110;\n        --bs-btn-active-color: #fff;\n        --bs-btn-active-bg: #146c43;\n        --bs-btn-active-border-color: #13653f;\n        --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n        --bs-btn-disabled-color: #fff;\n        --bs-btn-disabled-bg: #198754;\n        --bs-btn-disabled-border-color: #198754;\n    }\n\n    .btn-info {\n        --bs-btn-color: #000;\n        --bs-btn-bg: #0dcaf0;\n        --bs-btn-border-color: #0dcaf0;\n        --bs-btn-hover-color: #000;\n        --bs-btn-hover-bg: #31d2f2;\n        --bs-btn-hover-border-color: #25cff2;\n        --bs-btn-focus-shadow-rgb: 11, 172, 204;\n        --bs-btn-active-color: #000;\n        --bs-btn-active-bg: #3dd5f3;\n        --bs-btn-active-border-color: #25cff2;\n        --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n        --bs-btn-disabled-color: #000;\n        --bs-btn-disabled-bg: #0dcaf0;\n        --bs-btn-disabled-border-color: #0dcaf0;\n    }\n\n    .btn-warning {\n        --bs-btn-color: #000;\n        --bs-btn-bg: #ffc107;\n        --bs-btn-border-color: #ffc107;\n        --bs-btn-hover-color: #000;\n        --bs-btn-hover-bg: #ffca2c;\n        --bs-btn-hover-border-color: #ffc720;\n        --bs-btn-focus-shadow-rgb: 217, 164, 6;\n        --bs-btn-active-color: #000;\n        --bs-btn-active-bg: #ffcd39;\n        --bs-btn-active-border-color: #ffc720;\n        --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n        --bs-btn-disabled-color: #000;\n        --bs-btn-disabled-bg: #ffc107;\n        --bs-btn-disabled-border-color: #ffc107;\n    }\n\n    .btn-danger {\n        --bs-btn-color: #fff;\n        --bs-btn-bg: #dc3545;\n        --bs-btn-border-color: #dc3545;\n        --bs-btn-hover-color: #fff;\n        --bs-btn-hover-bg: #bb2d3b;\n        --bs-btn-hover-border-color: #b02a37;\n        --bs-btn-focus-shadow-rgb: 225, 83, 97;\n        --bs-btn-active-color: #fff;\n        --bs-btn-active-bg: #b02a37;\n        --bs-btn-active-border-color: #a52834;\n        --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n        --bs-btn-disabled-color: #fff;\n        --bs-btn-disabled-bg: #dc3545;\n        --bs-btn-disabled-border-color: #dc3545;\n    }\n\n    .btn-light {\n        --bs-btn-color: #000;\n        --bs-btn-bg: #f8f9fa;\n        --bs-btn-border-color: #f8f9fa;\n        --bs-btn-hover-color: #000;\n        --bs-btn-hover-bg: #d3d4d5;\n        --bs-btn-hover-border-color: #c6c7c8;\n        --bs-btn-focus-shadow-rgb: 211, 212, 213;\n        --bs-btn-active-color: #000;\n        --bs-btn-active-bg: #c6c7c8;\n        --bs-btn-active-border-color: #babbbc;\n        --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n        --bs-btn-disabled-color: #000;\n        --bs-btn-disabled-bg: #f8f9fa;\n        --bs-btn-disabled-border-color: #f8f9fa;\n    }\n\n    .btn-dark {\n        --bs-btn-color: #fff;\n        --bs-btn-bg: #212529;\n        --bs-btn-border-color: #212529;\n        --bs-btn-hover-color: #fff;\n        --bs-btn-hover-bg: #424649;\n        --bs-btn-hover-border-color: #373b3e;\n        --bs-btn-focus-shadow-rgb: 66, 70, 73;\n        --bs-btn-active-color: #fff;\n        --bs-btn-active-bg: #4d5154;\n        --bs-btn-active-border-color: #373b3e;\n        --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n        --bs-btn-disabled-color: #fff;\n        --bs-btn-disabled-bg: #212529;\n        --bs-btn-disabled-border-color: #212529;\n    }\n\n    .btn-outline-primary {\n        --bs-btn-color: #0d6efd;\n        --bs-btn-border-color: #0d6efd;\n        --bs-btn-hover-color: #fff;\n        --bs-btn-hover-bg: #0d6efd;\n        --bs-btn-hover-border-color: #0d6efd;\n        --bs-btn-focus-shadow-rgb: 13, 110, 253;\n        --bs-btn-active-color: #fff;\n        --bs-btn-active-bg: #0d6efd;\n        --bs-btn-active-border-color: #0d6efd;\n        --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n        --bs-btn-disabled-color: #0d6efd;\n        --bs-btn-disabled-bg: transparent;\n        --bs-btn-disabled-border-color: #0d6efd;\n        --bs-gradient: none;\n    }\n\n    .btn-outline-secondary {\n        --bs-btn-color: #6c757d;\n        --bs-btn-border-color: #6c757d;\n        --bs-btn-hover-color: #fff;\n        --bs-btn-hover-bg: #6c757d;\n        --bs-btn-hover-border-color: #6c757d;\n        --bs-btn-focus-shadow-rgb: 108, 117, 125;\n        --bs-btn-active-color: #fff;\n        --bs-btn-active-bg: #6c757d;\n        --bs-btn-active-border-color: #6c757d;\n        --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n        --bs-btn-disabled-color: #6c757d;\n        --bs-btn-disabled-bg: transparent;\n        --bs-btn-disabled-border-color: #6c757d;\n        --bs-gradient: none;\n    }\n\n    .btn-outline-success {\n        --bs-btn-color: #198754;\n        --bs-btn-border-color: #198754;\n        --bs-btn-hover-color: #fff;\n        --bs-btn-hover-bg: #198754;\n        --bs-btn-hover-border-color: #198754;\n        --bs-btn-focus-shadow-rgb: 25, 135, 84;\n        --bs-btn-active-color: #fff;\n        --bs-btn-active-bg: #198754;\n        --bs-btn-active-border-color: #198754;\n        --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n        --bs-btn-disabled-color: #198754;\n        --bs-btn-disabled-bg: transparent;\n        --bs-btn-disabled-border-color: #198754;\n        --bs-gradient: none;\n    }\n\n    .btn-outline-info {\n        --bs-btn-color: #0dcaf0;\n        --bs-btn-border-color: #0dcaf0;\n        --bs-btn-hover-color: #000;\n        --bs-btn-hover-bg: #0dcaf0;\n        --bs-btn-hover-border-color: #0dcaf0;\n        --bs-btn-focus-shadow-rgb: 13, 202, 240;\n        --bs-btn-active-color: #000;\n        --bs-btn-active-bg: #0dcaf0;\n        --bs-btn-active-border-color: #0dcaf0;\n        --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n        --bs-btn-disabled-color: #0dcaf0;\n        --bs-btn-disabled-bg: transparent;\n        --bs-btn-disabled-border-color: #0dcaf0;\n        --bs-gradient: none;\n    }\n\n    .btn-outline-warning {\n        --bs-btn-color: #ffc107;\n        --bs-btn-border-color: #ffc107;\n        --bs-btn-hover-color: #000;\n        --bs-btn-hover-bg: #ffc107;\n        --bs-btn-hover-border-color: #ffc107;\n        --bs-btn-focus-shadow-rgb: 255, 193, 7;\n        --bs-btn-active-color: #000;\n        --bs-btn-active-bg: #ffc107;\n        --bs-btn-active-border-color: #ffc107;\n        --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n        --bs-btn-disabled-color: #ffc107;\n        --bs-btn-disabled-bg: transparent;\n        --bs-btn-disabled-border-color: #ffc107;\n        --bs-gradient: none;\n    }\n\n    .btn-outline-danger {\n        --bs-btn-color: #dc3545;\n        --bs-btn-border-color: #dc3545;\n        --bs-btn-hover-color: #fff;\n        --bs-btn-hover-bg: #dc3545;\n        --bs-btn-hover-border-color: #dc3545;\n        --bs-btn-focus-shadow-rgb: 220, 53, 69;\n        --bs-btn-active-color: #fff;\n        --bs-btn-active-bg: #dc3545;\n        --bs-btn-active-border-color: #dc3545;\n        --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n        --bs-btn-disabled-color: #dc3545;\n        --bs-btn-disabled-bg: transparent;\n        --bs-btn-disabled-border-color: #dc3545;\n        --bs-gradient: none;\n    }\n\n    .btn-outline-light {\n        --bs-btn-color: #f8f9fa;\n        --bs-btn-border-color: #f8f9fa;\n        --bs-btn-hover-color: #000;\n        --bs-btn-hover-bg: #f8f9fa;\n        --bs-btn-hover-border-color: #f8f9fa;\n        --bs-btn-focus-shadow-rgb: 248, 249, 250;\n        --bs-btn-active-color: #000;\n        --bs-btn-active-bg: #f8f9fa;\n        --bs-btn-active-border-color: #f8f9fa;\n        --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n        --bs-btn-disabled-color: #f8f9fa;\n        --bs-btn-disabled-bg: transparent;\n        --bs-btn-disabled-border-color: #f8f9fa;\n        --bs-gradient: none;\n    }\n\n    .btn-outline-dark {\n        --bs-btn-color: #212529;\n        --bs-btn-border-color: #212529;\n        --bs-btn-hover-color: #fff;\n        --bs-btn-hover-bg: #212529;\n        --bs-btn-hover-border-color: #212529;\n        --bs-btn-focus-shadow-rgb: 33, 37, 41;\n        --bs-btn-active-color: #fff;\n        --bs-btn-active-bg: #212529;\n        --bs-btn-active-border-color: #212529;\n        --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n        --bs-btn-disabled-color: #212529;\n        --bs-btn-disabled-bg: transparent;\n        --bs-btn-disabled-border-color: #212529;\n        --bs-gradient: none;\n    }\n\n    .btn-link {\n        --bs-btn-font-weight: 400;\n        --bs-btn-color: var(--bs-link-color);\n        --bs-btn-bg: transparent;\n        --bs-btn-border-color: transparent;\n        --bs-btn-hover-color: var(--bs-link-hover-color);\n        --bs-btn-hover-border-color: transparent;\n        --bs-btn-active-color: var(--bs-link-hover-color);\n        --bs-btn-active-border-color: transparent;\n        --bs-btn-disabled-color: #6c757d;\n        --bs-btn-disabled-border-color: transparent;\n        --bs-btn-box-shadow: 0 0 0 #000;\n        --bs-btn-focus-shadow-rgb: 49, 132, 253;\n        text-decoration: underline;\n    }\n    .btn-link:focus-visible {\n        color: var(--bs-btn-color);\n    }\n    .btn-link:hover {\n        color: var(--bs-btn-hover-color);\n    }\n\n    .btn-lg,\n    .btn-group-lg > .btn {\n        --bs-btn-padding-y: 0.5rem;\n        --bs-btn-padding-x: 1rem;\n        --bs-btn-font-size: 1.25rem;\n        --bs-btn-border-radius: var(--bs-border-radius-lg);\n    }\n\n    .btn-sm,\n    .btn-group-sm > .btn {\n        --bs-btn-padding-y: 0.25rem;\n        --bs-btn-padding-x: 0.5rem;\n        --bs-btn-font-size: 0.875rem;\n        --bs-btn-border-radius: var(--bs-border-radius-sm);\n    }\n\n    .fade {\n        transition: opacity 0.15s linear;\n    }\n    @media (prefers-reduced-motion: reduce) {\n        .fade {\n            transition: none;\n        }\n    }\n    .fade:not(.show) {\n        opacity: 0;\n    }\n\n    .collapse:not(.show) {\n        display: none;\n    }\n\n    .collapsing {\n        height: 0;\n        overflow: hidden;\n        transition: height 0.35s ease;\n    }\n    @media (prefers-reduced-motion: reduce) {\n        .collapsing {\n            transition: none;\n        }\n    }\n    .collapsing.collapse-horizontal {\n        width: 0;\n        height: auto;\n        transition: width 0.35s ease;\n    }\n    @media (prefers-reduced-motion: reduce) {\n        .collapsing.collapse-horizontal {\n            transition: none;\n        }\n    }\n\n    .dropup,\n    .dropend,\n    .dropdown,\n    .dropstart,\n    .dropup-center,\n    .dropdown-center {\n        position: relative;\n    }\n\n    .dropdown-toggle {\n        white-space: nowrap;\n    }\n    .dropdown-toggle::after {\n        display: inline-block;\n        margin-left: 0.255em;\n        vertical-align: 0.255em;\n        content: '';\n        border-top: 0.3em solid;\n        border-right: 0.3em solid transparent;\n        border-bottom: 0;\n        border-left: 0.3em solid transparent;\n    }\n    .dropdown-toggle:empty::after {\n        margin-left: 0;\n    }\n\n    .dropdown-menu {\n        --bs-dropdown-zindex: 1000;\n        --bs-dropdown-min-width: 10rem;\n        --bs-dropdown-padding-x: 0;\n        --bs-dropdown-padding-y: 0.5rem;\n        --bs-dropdown-spacer: 0.125rem;\n        --bs-dropdown-font-size: 1rem;\n        --bs-dropdown-color: var(--bs-body-color);\n        --bs-dropdown-bg: var(--bs-body-bg);\n        --bs-dropdown-border-color: var(--bs-border-color-translucent);\n        --bs-dropdown-border-radius: var(--bs-border-radius);\n        --bs-dropdown-border-width: var(--bs-border-width);\n        --bs-dropdown-inner-border-radius: calc(\n            var(--bs-border-radius) - var(--bs-border-width)\n        );\n        --bs-dropdown-divider-bg: var(--bs-border-color-translucent);\n        --bs-dropdown-divider-margin-y: 0.5rem;\n        --bs-dropdown-box-shadow: var(--bs-box-shadow);\n        --bs-dropdown-link-color: var(--bs-body-color);\n        --bs-dropdown-link-hover-color: var(--bs-body-color);\n        --bs-dropdown-link-hover-bg: var(--bs-tertiary-bg);\n        --bs-dropdown-link-active-color: #fff;\n        --bs-dropdown-link-active-bg: #0d6efd;\n        --bs-dropdown-link-disabled-color: var(--bs-tertiary-color);\n        --bs-dropdown-item-padding-x: 1rem;\n        --bs-dropdown-item-padding-y: 0.25rem;\n        --bs-dropdown-header-color: #6c757d;\n        --bs-dropdown-header-padding-x: 1rem;\n        --bs-dropdown-header-padding-y: 0.5rem;\n        position: absolute;\n        z-index: var(--bs-dropdown-zindex);\n        display: none;\n        min-width: var(--bs-dropdown-min-width);\n        padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);\n        margin: 0;\n        font-size: var(--bs-dropdown-font-size);\n        color: var(--bs-dropdown-color);\n        text-align: left;\n        list-style: none;\n        background-color: var(--bs-dropdown-bg);\n        background-clip: padding-box;\n        border: var(--bs-dropdown-border-width) solid\n            var(--bs-dropdown-border-color);\n        border-radius: var(--bs-dropdown-border-radius);\n    }\n    .dropdown-menu[data-bs-popper] {\n        top: 100%;\n        left: 0;\n        margin-top: var(--bs-dropdown-spacer);\n    }\n\n    .dropdown-menu-start {\n        --bs-position: start;\n    }\n    .dropdown-menu-start[data-bs-popper] {\n        right: auto;\n        left: 0;\n    }\n\n    .dropdown-menu-end {\n        --bs-position: end;\n    }\n    .dropdown-menu-end[data-bs-popper] {\n        right: 0;\n        left: auto;\n    }\n\n    @media (min-width: 576px) {\n        .dropdown-menu-sm-start {\n            --bs-position: start;\n        }\n        .dropdown-menu-sm-start[data-bs-popper] {\n            right: auto;\n            left: 0;\n        }\n        .dropdown-menu-sm-end {\n            --bs-position: end;\n        }\n        .dropdown-menu-sm-end[data-bs-popper] {\n            right: 0;\n            left: auto;\n        }\n    }\n    @media (min-width: 768px) {\n        .dropdown-menu-md-start {\n            --bs-position: start;\n        }\n        .dropdown-menu-md-start[data-bs-popper] {\n            right: auto;\n            left: 0;\n        }\n        .dropdown-menu-md-end {\n            --bs-position: end;\n        }\n        .dropdown-menu-md-end[data-bs-popper] {\n            right: 0;\n            left: auto;\n        }\n    }\n    @media (min-width: 992px) {\n        .dropdown-menu-lg-start {\n            --bs-position: start;\n        }\n        .dropdown-menu-lg-start[data-bs-popper] {\n            right: auto;\n            left: 0;\n        }\n        .dropdown-menu-lg-end {\n            --bs-position: end;\n        }\n        .dropdown-menu-lg-end[data-bs-popper] {\n            right: 0;\n            left: auto;\n        }\n    }\n    @media (min-width: 1200px) {\n        .dropdown-menu-xl-start {\n            --bs-position: start;\n        }\n        .dropdown-menu-xl-start[data-bs-popper] {\n            right: auto;\n            left: 0;\n        }\n        .dropdown-menu-xl-end {\n            --bs-position: end;\n        }\n        .dropdown-menu-xl-end[data-bs-popper] {\n            right: 0;\n            left: auto;\n        }\n    }\n    @media (min-width: 1400px) {\n        .dropdown-menu-xxl-start {\n            --bs-position: start;\n        }\n        .dropdown-menu-xxl-start[data-bs-popper] {\n            right: auto;\n            left: 0;\n        }\n        .dropdown-menu-xxl-end {\n            --bs-position: end;\n        }\n        .dropdown-menu-xxl-end[data-bs-popper] {\n            right: 0;\n            left: auto;\n        }\n    }\n    .dropup .dropdown-menu[data-bs-popper] {\n        top: auto;\n        bottom: 100%;\n        margin-top: 0;\n        margin-bottom: var(--bs-dropdown-spacer);\n    }\n    .dropup .dropdown-toggle::after {\n        display: inline-block;\n        margin-left: 0.255em;\n        vertical-align: 0.255em;\n        content: '';\n        border-top: 0;\n        border-right: 0.3em solid transparent;\n        border-bottom: 0.3em solid;\n        border-left: 0.3em solid transparent;\n    }\n    .dropup .dropdown-toggle:empty::after {\n        margin-left: 0;\n    }\n\n    .dropend .dropdown-menu[data-bs-popper] {\n        top: 0;\n        right: auto;\n        left: 100%;\n        margin-top: 0;\n        margin-left: var(--bs-dropdown-spacer);\n    }\n    .dropend .dropdown-toggle::after {\n        display: inline-block;\n        margin-left: 0.255em;\n        vertical-align: 0.255em;\n        content: '';\n        border-top: 0.3em solid transparent;\n        border-right: 0;\n        border-bottom: 0.3em solid transparent;\n        border-left: 0.3em solid;\n    }\n    .dropend .dropdown-toggle:empty::after {\n        margin-left: 0;\n    }\n    .dropend .dropdown-toggle::after {\n        vertical-align: 0;\n    }\n\n    .dropstart .dropdown-menu[data-bs-popper] {\n        top: 0;\n        right: 100%;\n        left: auto;\n        margin-top: 0;\n        margin-right: var(--bs-dropdown-spacer);\n    }\n    .dropstart .dropdown-toggle::after {\n        display: inline-block;\n        margin-left: 0.255em;\n        vertical-align: 0.255em;\n        content: '';\n    }\n    .dropstart .dropdown-toggle::after {\n        display: none;\n    }\n    .dropstart .dropdown-toggle::before {\n        display: inline-block;\n        margin-right: 0.255em;\n        vertical-align: 0.255em;\n        content: '';\n        border-top: 0.3em solid transparent;\n        border-right: 0.3em solid;\n        border-bottom: 0.3em solid transparent;\n    }\n    .dropstart .dropdown-toggle:empty::after {\n        margin-left: 0;\n    }\n    .dropstart .dropdown-toggle::before {\n        vertical-align: 0;\n    }\n\n    .dropdown-divider {\n        height: 0;\n        margin: var(--bs-dropdown-divider-margin-y) 0;\n        overflow: hidden;\n        border-top: 1px solid var(--bs-dropdown-divider-bg);\n        opacity: 1;\n    }\n\n    .dropdown-item {\n        display: block;\n        width: 100%;\n        padding: var(--bs-dropdown-item-padding-y)\n            var(--bs-dropdown-item-padding-x);\n        clear: both;\n        font-weight: 400;\n        color: var(--bs-dropdown-link-color);\n        text-align: inherit;\n        text-decoration: none;\n        white-space: nowrap;\n        background-color: transparent;\n        border: 0;\n        border-radius: var(--bs-dropdown-item-border-radius, 0);\n    }\n    .dropdown-item:hover,\n    .dropdown-item:focus {\n        color: var(--bs-dropdown-link-hover-color);\n        background-color: var(--bs-dropdown-link-hover-bg);\n    }\n    .dropdown-item.active,\n    .dropdown-item:active {\n        color: var(--bs-dropdown-link-active-color);\n        text-decoration: none;\n        background-color: var(--bs-dropdown-link-active-bg);\n    }\n    .dropdown-item.disabled,\n    .dropdown-item:disabled {\n        color: var(--bs-dropdown-link-disabled-color);\n        pointer-events: none;\n        background-color: transparent;\n    }\n\n    .dropdown-menu.show {\n        display: block;\n    }\n\n    .dropdown-header {\n        display: block;\n        padding: var(--bs-dropdown-header-padding-y)\n            var(--bs-dropdown-header-padding-x);\n        margin-bottom: 0;\n        font-size: 0.875rem;\n        color: var(--bs-dropdown-header-color);\n        white-space: nowrap;\n    }\n\n    .dropdown-item-text {\n        display: block;\n        padding: var(--bs-dropdown-item-padding-y)\n            var(--bs-dropdown-item-padding-x);\n        color: var(--bs-dropdown-link-color);\n    }\n\n    .dropdown-menu-dark {\n        --bs-dropdown-color: #dee2e6;\n        --bs-dropdown-bg: #343a40;\n        --bs-dropdown-border-color: var(--bs-border-color-translucent);\n        --bs-dropdown-box-shadow: ;\n        --bs-dropdown-link-color: #dee2e6;\n        --bs-dropdown-link-hover-color: #fff;\n        --bs-dropdown-divider-bg: var(--bs-border-color-translucent);\n        --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);\n        --bs-dropdown-link-active-color: #fff;\n        --bs-dropdown-link-active-bg: #0d6efd;\n        --bs-dropdown-link-disabled-color: #adb5bd;\n        --bs-dropdown-header-color: #adb5bd;\n    }\n\n    .btn-group,\n    .btn-group-vertical {\n        position: relative;\n        display: inline-flex;\n        vertical-align: middle;\n    }\n    .btn-group > .btn,\n    .btn-group-vertical > .btn {\n        position: relative;\n        flex: 1 1 auto;\n    }\n    .btn-group > .btn-check:checked + .btn,\n    .btn-group > .btn-check:focus + .btn,\n    .btn-group > .btn:hover,\n    .btn-group > .btn:focus,\n    .btn-group > .btn:active,\n    .btn-group > .btn.active,\n    .btn-group-vertical > .btn-check:checked + .btn,\n    .btn-group-vertical > .btn-check:focus + .btn,\n    .btn-group-vertical > .btn:hover,\n    .btn-group-vertical > .btn:focus,\n    .btn-group-vertical > .btn:active,\n    .btn-group-vertical > .btn.active {\n        z-index: 1;\n    }\n\n    .btn-toolbar {\n        display: flex;\n        flex-wrap: wrap;\n        justify-content: flex-start;\n    }\n    .btn-toolbar .input-group {\n        width: auto;\n    }\n\n    .btn-group {\n        border-radius: var(--bs-border-radius);\n    }\n    .btn-group > :not(.btn-check:first-child) + .btn,\n    .btn-group > .btn-group:not(:first-child) {\n        margin-left: calc(var(--bs-border-width) * -1);\n    }\n    .btn-group > .btn:not(:last-child):not(.dropdown-toggle),\n    .btn-group > .btn.dropdown-toggle-split:first-child,\n    .btn-group > .btn-group:not(:last-child) > .btn {\n        border-top-right-radius: 0;\n        border-bottom-right-radius: 0;\n    }\n    .btn-group > .btn:nth-child(n + 3),\n    .btn-group > :not(.btn-check) + .btn,\n    .btn-group > .btn-group:not(:first-child) > .btn {\n        border-top-left-radius: 0;\n        border-bottom-left-radius: 0;\n    }\n\n    .dropdown-toggle-split {\n        padding-right: 0.5625rem;\n        padding-left: 0.5625rem;\n    }\n    .dropdown-toggle-split::after,\n    .dropup .dropdown-toggle-split::after,\n    .dropend .dropdown-toggle-split::after {\n        margin-left: 0;\n    }\n    .dropstart .dropdown-toggle-split::before {\n        margin-right: 0;\n    }\n\n    .btn-sm + .dropdown-toggle-split,\n    .btn-group-sm > .btn + .dropdown-toggle-split {\n        padding-right: 0.375rem;\n        padding-left: 0.375rem;\n    }\n\n    .btn-lg + .dropdown-toggle-split,\n    .btn-group-lg > .btn + .dropdown-toggle-split {\n        padding-right: 0.75rem;\n        padding-left: 0.75rem;\n    }\n\n    .btn-group-vertical {\n        flex-direction: column;\n        align-items: flex-start;\n        justify-content: center;\n    }\n    .btn-group-vertical > .btn,\n    .btn-group-vertical > .btn-group {\n        width: 100%;\n    }\n    .btn-group-vertical > .btn:not(:first-child),\n    .btn-group-vertical > .btn-group:not(:first-child) {\n        margin-top: calc(var(--bs-border-width) * -1);\n    }\n    .btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),\n    .btn-group-vertical > .btn-group:not(:last-child) > .btn {\n        border-bottom-right-radius: 0;\n        border-bottom-left-radius: 0;\n    }\n    .btn-group-vertical > .btn ~ .btn,\n    .btn-group-vertical > .btn-group:not(:first-child) > .btn {\n        border-top-left-radius: 0;\n        border-top-right-radius: 0;\n    }\n\n    .nav {\n        --bs-nav-link-padding-x: 1rem;\n        --bs-nav-link-padding-y: 0.5rem;\n        --bs-nav-link-font-weight: ;\n        --bs-nav-link-color: var(--bs-link-color);\n        --bs-nav-link-hover-color: var(--bs-link-hover-color);\n        --bs-nav-link-disabled-color: var(--bs-secondary-color);\n        display: flex;\n        flex-wrap: wrap;\n        padding-left: 0;\n        margin-bottom: 0;\n        list-style: none;\n    }\n\n    .nav-link {\n        display: block;\n        padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);\n        font-size: var(--bs-nav-link-font-size);\n        font-weight: var(--bs-nav-link-font-weight);\n        color: var(--bs-nav-link-color);\n        text-decoration: none;\n        background: none;\n        border: 0;\n        transition:\n            color 0.15s ease-in-out,\n            background-color 0.15s ease-in-out,\n            border-color 0.15s ease-in-out;\n    }\n    @media (prefers-reduced-motion: reduce) {\n        .nav-link {\n            transition: none;\n        }\n    }\n    .nav-link:hover,\n    .nav-link:focus {\n        color: var(--bs-nav-link-hover-color);\n    }\n    .nav-link:focus-visible {\n        outline: 0;\n        box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n    }\n    .nav-link.disabled,\n    .nav-link:disabled {\n        color: var(--bs-nav-link-disabled-color);\n        pointer-events: none;\n        cursor: default;\n    }\n\n    .nav-tabs {\n        --bs-nav-tabs-border-width: var(--bs-border-width);\n        --bs-nav-tabs-border-color: var(--bs-border-color);\n        --bs-nav-tabs-border-radius: var(--bs-border-radius);\n        --bs-nav-tabs-link-hover-border-color: var(--bs-secondary-bg)\n            var(--bs-secondary-bg) var(--bs-border-color);\n        --bs-nav-tabs-link-active-color: var(--bs-emphasis-color);\n        --bs-nav-tabs-link-active-bg: var(--bs-body-bg);\n        --bs-nav-tabs-link-active-border-color: var(--bs-border-color)\n            var(--bs-border-color) var(--bs-body-bg);\n        border-bottom: var(--bs-nav-tabs-border-width) solid\n            var(--bs-nav-tabs-border-color);\n    }\n    .nav-tabs .nav-link {\n        margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));\n        border: var(--bs-nav-tabs-border-width) solid transparent;\n        border-top-left-radius: var(--bs-nav-tabs-border-radius);\n        border-top-right-radius: var(--bs-nav-tabs-border-radius);\n    }\n    .nav-tabs .nav-link:hover,\n    .nav-tabs .nav-link:focus {\n        isolation: isolate;\n        border-color: var(--bs-nav-tabs-link-hover-border-color);\n    }\n    .nav-tabs .nav-link.active,\n    .nav-tabs .nav-item.show .nav-link {\n        color: var(--bs-nav-tabs-link-active-color);\n        background-color: var(--bs-nav-tabs-link-active-bg);\n        border-color: var(--bs-nav-tabs-link-active-border-color);\n    }\n    .nav-tabs .dropdown-menu {\n        margin-top: calc(-1 * var(--bs-nav-tabs-border-width));\n        border-top-left-radius: 0;\n        border-top-right-radius: 0;\n    }\n\n    .nav-pills {\n        --bs-nav-pills-border-radius: var(--bs-border-radius);\n        --bs-nav-pills-link-active-color: #fff;\n        --bs-nav-pills-link-active-bg: #0d6efd;\n    }\n    .nav-pills .nav-link {\n        border-radius: var(--bs-nav-pills-border-radius);\n    }\n    .nav-pills .nav-link.active,\n    .nav-pills .show > .nav-link {\n        color: var(--bs-nav-pills-link-active-color);\n        background-color: var(--bs-nav-pills-link-active-bg);\n    }\n\n    .nav-underline {\n        --bs-nav-underline-gap: 1rem;\n        --bs-nav-underline-border-width: 0.125rem;\n        --bs-nav-underline-link-active-color: var(--bs-emphasis-color);\n        gap: var(--bs-nav-underline-gap);\n    }\n    .nav-underline .nav-link {\n        padding-right: 0;\n        padding-left: 0;\n        border-bottom: var(--bs-nav-underline-border-width) solid transparent;\n    }\n    .nav-underline .nav-link:hover,\n    .nav-underline .nav-link:focus {\n        border-bottom-color: currentcolor;\n    }\n    .nav-underline .nav-link.active,\n    .nav-underline .show > .nav-link {\n        font-weight: 700;\n        color: var(--bs-nav-underline-link-active-color);\n        border-bottom-color: currentcolor;\n    }\n\n    .nav-fill > .nav-link,\n    .nav-fill .nav-item {\n        flex: 1 1 auto;\n        text-align: center;\n    }\n\n    .nav-justified > .nav-link,\n    .nav-justified .nav-item {\n        flex-basis: 0;\n        flex-grow: 1;\n        text-align: center;\n    }\n\n    .nav-fill .nav-item .nav-link,\n    .nav-justified .nav-item .nav-link {\n        width: 100%;\n    }\n\n    .tab-content > .tab-pane {\n        display: none;\n    }\n    .tab-content > .active {\n        display: block;\n    }\n\n    .navbar {\n        --bs-navbar-padding-x: 0;\n        --bs-navbar-padding-y: 0.5rem;\n        --bs-navbar-color: rgba(var(--bs-emphasis-color-rgb), 0.65);\n        --bs-navbar-hover-color: rgba(var(--bs-emphasis-color-rgb), 0.8);\n        --bs-navbar-disabled-color: rgba(var(--bs-emphasis-color-rgb), 0.3);\n        --bs-navbar-active-color: rgba(var(--bs-emphasis-color-rgb), 1);\n        --bs-navbar-brand-padding-y: 0.3125rem;\n        --bs-navbar-brand-margin-end: 1rem;\n        --bs-navbar-brand-font-size: 1.25rem;\n        --bs-navbar-brand-color: rgba(var(--bs-emphasis-color-rgb), 1);\n        --bs-navbar-brand-hover-color: rgba(var(--bs-emphasis-color-rgb), 1);\n        --bs-navbar-nav-link-padding-x: 0.5rem;\n        --bs-navbar-toggler-padding-y: 0.25rem;\n        --bs-navbar-toggler-padding-x: 0.75rem;\n        --bs-navbar-toggler-font-size: 1.25rem;\n        --bs-navbar-toggler-icon-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%2833, 37, 41, 0.75%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n        --bs-navbar-toggler-border-color: rgba(\n            var(--bs-emphasis-color-rgb),\n            0.15\n        );\n        --bs-navbar-toggler-border-radius: var(--bs-border-radius);\n        --bs-navbar-toggler-focus-width: 0.25rem;\n        --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;\n        position: relative;\n        display: flex;\n        flex-wrap: wrap;\n        align-items: center;\n        justify-content: space-between;\n        padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);\n    }\n    .navbar > .container,\n    .navbar > .container-fluid,\n    .navbar > .container-sm,\n    .navbar > .container-md,\n    .navbar > .container-lg,\n    .navbar > .container-xl,\n    .navbar > .container-xxl {\n        display: flex;\n        flex-wrap: inherit;\n        align-items: center;\n        justify-content: space-between;\n    }\n    .navbar-brand {\n        padding-top: var(--bs-navbar-brand-padding-y);\n        padding-bottom: var(--bs-navbar-brand-padding-y);\n        margin-right: var(--bs-navbar-brand-margin-end);\n        font-size: var(--bs-navbar-brand-font-size);\n        color: var(--bs-navbar-brand-color);\n        text-decoration: none;\n        white-space: nowrap;\n    }\n    .navbar-brand:hover,\n    .navbar-brand:focus {\n        color: var(--bs-navbar-brand-hover-color);\n    }\n\n    .navbar-nav {\n        --bs-nav-link-padding-x: 0;\n        --bs-nav-link-padding-y: 0.5rem;\n        --bs-nav-link-font-weight: ;\n        --bs-nav-link-color: var(--bs-navbar-color);\n        --bs-nav-link-hover-color: var(--bs-navbar-hover-color);\n        --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);\n        display: flex;\n        flex-direction: column;\n        padding-left: 0;\n        margin-bottom: 0;\n        list-style: none;\n    }\n    .navbar-nav .nav-link.active,\n    .navbar-nav .nav-link.show {\n        color: var(--bs-navbar-active-color);\n    }\n    .navbar-nav .dropdown-menu {\n        position: static;\n    }\n\n    .navbar-text {\n        padding-top: 0.5rem;\n        padding-bottom: 0.5rem;\n        color: var(--bs-navbar-color);\n    }\n    .navbar-text a,\n    .navbar-text a:hover,\n    .navbar-text a:focus {\n        color: var(--bs-navbar-active-color);\n    }\n\n    .navbar-collapse {\n        flex-basis: 100%;\n        flex-grow: 1;\n        align-items: center;\n    }\n\n    .navbar-toggler {\n        padding: var(--bs-navbar-toggler-padding-y)\n            var(--bs-navbar-toggler-padding-x);\n        font-size: var(--bs-navbar-toggler-font-size);\n        line-height: 1;\n        color: var(--bs-navbar-color);\n        background-color: transparent;\n        border: var(--bs-border-width) solid\n            var(--bs-navbar-toggler-border-color);\n        border-radius: var(--bs-navbar-toggler-border-radius);\n        transition: var(--bs-navbar-toggler-transition);\n    }\n    @media (prefers-reduced-motion: reduce) {\n        .navbar-toggler {\n            transition: none;\n        }\n    }\n    .navbar-toggler:hover {\n        text-decoration: none;\n    }\n    .navbar-toggler:focus {\n        text-decoration: none;\n        outline: 0;\n        box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);\n    }\n\n    .navbar-toggler-icon {\n        display: inline-block;\n        width: 1.5em;\n        height: 1.5em;\n        vertical-align: middle;\n        background-image: var(--bs-navbar-toggler-icon-bg);\n        background-repeat: no-repeat;\n        background-position: center;\n        background-size: 100%;\n    }\n\n    .navbar-nav-scroll {\n        max-height: var(--bs-scroll-height, 75vh);\n        overflow-y: auto;\n    }\n\n    @media (min-width: 576px) {\n        .navbar-expand-sm {\n            flex-wrap: nowrap;\n            justify-content: flex-start;\n        }\n        .navbar-expand-sm .navbar-nav {\n            flex-direction: row;\n        }\n        .navbar-expand-sm .navbar-nav .dropdown-menu {\n            position: absolute;\n        }\n        .navbar-expand-sm .navbar-nav .nav-link {\n            padding-right: var(--bs-navbar-nav-link-padding-x);\n            padding-left: var(--bs-navbar-nav-link-padding-x);\n        }\n        .navbar-expand-sm .navbar-nav-scroll {\n            overflow: visible;\n        }\n        .navbar-expand-sm .navbar-collapse {\n            display: flex !important;\n            flex-basis: auto;\n        }\n        .navbar-expand-sm .navbar-toggler {\n            display: none;\n        }\n        .navbar-expand-sm .offcanvas {\n            position: static;\n            z-index: auto;\n            flex-grow: 1;\n            width: auto !important;\n            height: auto !important;\n            visibility: visible !important;\n            background-color: transparent !important;\n            border: 0 !important;\n            transform: none !important;\n            transition: none;\n        }\n        .navbar-expand-sm .offcanvas .offcanvas-header {\n            display: none;\n        }\n        .navbar-expand-sm .offcanvas .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n        }\n    }\n    @media (min-width: 768px) {\n        .navbar-expand-md {\n            flex-wrap: nowrap;\n            justify-content: flex-start;\n        }\n        .navbar-expand-md .navbar-nav {\n            flex-direction: row;\n        }\n        .navbar-expand-md .navbar-nav .dropdown-menu {\n            position: absolute;\n        }\n        .navbar-expand-md .navbar-nav .nav-link {\n            padding-right: var(--bs-navbar-nav-link-padding-x);\n            padding-left: var(--bs-navbar-nav-link-padding-x);\n        }\n        .navbar-expand-md .navbar-nav-scroll {\n            overflow: visible;\n        }\n        .navbar-expand-md .navbar-collapse {\n            display: flex !important;\n            flex-basis: auto;\n        }\n        .navbar-expand-md .navbar-toggler {\n            display: none;\n        }\n        .navbar-expand-md .offcanvas {\n            position: static;\n            z-index: auto;\n            flex-grow: 1;\n            width: auto !important;\n            height: auto !important;\n            visibility: visible !important;\n            background-color: transparent !important;\n            border: 0 !important;\n            transform: none !important;\n            transition: none;\n        }\n        .navbar-expand-md .offcanvas .offcanvas-header {\n            display: none;\n        }\n        .navbar-expand-md .offcanvas .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n        }\n    }\n    @media (min-width: 992px) {\n        .navbar-expand-lg {\n            flex-wrap: nowrap;\n            justify-content: flex-start;\n        }\n        .navbar-expand-lg .navbar-nav {\n            flex-direction: row;\n        }\n        .navbar-expand-lg .navbar-nav .dropdown-menu {\n            position: absolute;\n        }\n        .navbar-expand-lg .navbar-nav .nav-link {\n            padding-right: var(--bs-navbar-nav-link-padding-x);\n            padding-left: var(--bs-navbar-nav-link-padding-x);\n        }\n        .navbar-expand-lg .navbar-nav-scroll {\n            overflow: visible;\n        }\n        .navbar-expand-lg .navbar-collapse {\n            display: flex !important;\n            flex-basis: auto;\n        }\n        .navbar-expand-lg .navbar-toggler {\n            display: none;\n        }\n        .navbar-expand-lg .offcanvas {\n            position: static;\n            z-index: auto;\n            flex-grow: 1;\n            width: auto !important;\n            height: auto !important;\n            visibility: visible !important;\n            background-color: transparent !important;\n            border: 0 !important;\n            transform: none !important;\n            transition: none;\n        }\n        .navbar-expand-lg .offcanvas .offcanvas-header {\n            display: none;\n        }\n        .navbar-expand-lg .offcanvas .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n        }\n    }\n    @media (min-width: 1200px) {\n        .navbar-expand-xl {\n            flex-wrap: nowrap;\n            justify-content: flex-start;\n        }\n        .navbar-expand-xl .navbar-nav {\n            flex-direction: row;\n        }\n        .navbar-expand-xl .navbar-nav .dropdown-menu {\n            position: absolute;\n        }\n        .navbar-expand-xl .navbar-nav .nav-link {\n            padding-right: var(--bs-navbar-nav-link-padding-x);\n            padding-left: var(--bs-navbar-nav-link-padding-x);\n        }\n        .navbar-expand-xl .navbar-nav-scroll {\n            overflow: visible;\n        }\n        .navbar-expand-xl .navbar-collapse {\n            display: flex !important;\n            flex-basis: auto;\n        }\n        .navbar-expand-xl .navbar-toggler {\n            display: none;\n        }\n        .navbar-expand-xl .offcanvas {\n            position: static;\n            z-index: auto;\n            flex-grow: 1;\n            width: auto !important;\n            height: auto !important;\n            visibility: visible !important;\n            background-color: transparent !important;\n            border: 0 !important;\n            transform: none !important;\n            transition: none;\n        }\n        .navbar-expand-xl .offcanvas .offcanvas-header {\n            display: none;\n        }\n        .navbar-expand-xl .offcanvas .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n        }\n    }\n    @media (min-width: 1400px) {\n        .navbar-expand-xxl {\n            flex-wrap: nowrap;\n            justify-content: flex-start;\n        }\n        .navbar-expand-xxl .navbar-nav {\n            flex-direction: row;\n        }\n        .navbar-expand-xxl .navbar-nav .dropdown-menu {\n            position: absolute;\n        }\n        .navbar-expand-xxl .navbar-nav .nav-link {\n            padding-right: var(--bs-navbar-nav-link-padding-x);\n            padding-left: var(--bs-navbar-nav-link-padding-x);\n        }\n        .navbar-expand-xxl .navbar-nav-scroll {\n            overflow: visible;\n        }\n        .navbar-expand-xxl .navbar-collapse {\n            display: flex !important;\n            flex-basis: auto;\n        }\n        .navbar-expand-xxl .navbar-toggler {\n            display: none;\n        }\n        .navbar-expand-xxl .offcanvas {\n            position: static;\n            z-index: auto;\n            flex-grow: 1;\n            width: auto !important;\n            height: auto !important;\n            visibility: visible !important;\n            background-color: transparent !important;\n            border: 0 !important;\n            transform: none !important;\n            transition: none;\n        }\n        .navbar-expand-xxl .offcanvas .offcanvas-header {\n            display: none;\n        }\n        .navbar-expand-xxl .offcanvas .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n        }\n    }\n    .navbar-expand {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n    }\n    .navbar-expand .navbar-nav {\n        flex-direction: row;\n    }\n    .navbar-expand .navbar-nav .dropdown-menu {\n        position: absolute;\n    }\n    .navbar-expand .navbar-nav .nav-link {\n        padding-right: var(--bs-navbar-nav-link-padding-x);\n        padding-left: var(--bs-navbar-nav-link-padding-x);\n    }\n    .navbar-expand .navbar-nav-scroll {\n        overflow: visible;\n    }\n    .navbar-expand .navbar-collapse {\n        display: flex !important;\n        flex-basis: auto;\n    }\n    .navbar-expand .navbar-toggler {\n        display: none;\n    }\n    .navbar-expand .offcanvas {\n        position: static;\n        z-index: auto;\n        flex-grow: 1;\n        width: auto !important;\n        height: auto !important;\n        visibility: visible !important;\n        background-color: transparent !important;\n        border: 0 !important;\n        transform: none !important;\n        transition: none;\n    }\n    .navbar-expand .offcanvas .offcanvas-header {\n        display: none;\n    }\n    .navbar-expand .offcanvas .offcanvas-body {\n        display: flex;\n        flex-grow: 0;\n        padding: 0;\n        overflow-y: visible;\n    }\n\n    .navbar-dark,\n    .navbar[data-bs-theme='dark'] {\n        --bs-navbar-color: rgba(255, 255, 255, 0.55);\n        --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);\n        --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);\n        --bs-navbar-active-color: #fff;\n        --bs-navbar-brand-color: #fff;\n        --bs-navbar-brand-hover-color: #fff;\n        --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);\n        --bs-navbar-toggler-icon-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n    }\n\n    [data-bs-theme='dark'] .navbar-toggler-icon {\n        --bs-navbar-toggler-icon-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n    }\n\n    .card {\n        --bs-card-spacer-y: 1rem;\n        --bs-card-spacer-x: 1rem;\n        --bs-card-title-spacer-y: 0.5rem;\n        --bs-card-title-color: ;\n        --bs-card-subtitle-color: ;\n        --bs-card-border-width: var(--bs-border-width);\n        --bs-card-border-color: var(--bs-border-color-translucent);\n        --bs-card-border-radius: var(--bs-border-radius);\n        --bs-card-box-shadow: ;\n        --bs-card-inner-border-radius: calc(\n            var(--bs-border-radius) - (var(--bs-border-width))\n        );\n        --bs-card-cap-padding-y: 0.5rem;\n        --bs-card-cap-padding-x: 1rem;\n        --bs-card-cap-bg: rgba(var(--bs-body-color-rgb), 0.03);\n        --bs-card-cap-color: ;\n        --bs-card-height: ;\n        --bs-card-color: ;\n        --bs-card-bg: var(--bs-body-bg);\n        --bs-card-img-overlay-padding: 1rem;\n        --bs-card-group-margin: 0.75rem;\n        position: relative;\n        display: flex;\n        flex-direction: column;\n        min-width: 0;\n        height: var(--bs-card-height);\n        color: var(--bs-body-color);\n        word-wrap: break-word;\n        background-color: var(--bs-card-bg);\n        background-clip: border-box;\n        border: var(--bs-card-border-width) solid var(--bs-card-border-color);\n        border-radius: var(--bs-card-border-radius);\n    }\n    .card > hr {\n        margin-right: 0;\n        margin-left: 0;\n    }\n    .card > .list-group {\n        border-top: inherit;\n        border-bottom: inherit;\n    }\n    .card > .list-group:first-child {\n        border-top-width: 0;\n        border-top-left-radius: var(--bs-card-inner-border-radius);\n        border-top-right-radius: var(--bs-card-inner-border-radius);\n    }\n    .card > .list-group:last-child {\n        border-bottom-width: 0;\n        border-bottom-right-radius: var(--bs-card-inner-border-radius);\n        border-bottom-left-radius: var(--bs-card-inner-border-radius);\n    }\n    .card > .card-header + .list-group,\n    .card > .list-group + .card-footer {\n        border-top: 0;\n    }\n\n    .card-body {\n        flex: 1 1 auto;\n        padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);\n        color: var(--bs-card-color);\n    }\n\n    .card-title {\n        margin-bottom: var(--bs-card-title-spacer-y);\n        color: var(--bs-card-title-color);\n    }\n\n    .card-subtitle {\n        margin-top: calc(-0.5 * var(--bs-card-title-spacer-y));\n        margin-bottom: 0;\n        color: var(--bs-card-subtitle-color);\n    }\n\n    .card-text:last-child {\n        margin-bottom: 0;\n    }\n\n    .card-link + .card-link {\n        margin-left: var(--bs-card-spacer-x);\n    }\n\n    .card-header {\n        padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);\n        margin-bottom: 0;\n        color: var(--bs-card-cap-color);\n        background-color: var(--bs-card-cap-bg);\n        border-bottom: var(--bs-card-border-width) solid\n            var(--bs-card-border-color);\n    }\n    .card-header:first-child {\n        border-radius: var(--bs-card-inner-border-radius)\n            var(--bs-card-inner-border-radius) 0 0;\n    }\n\n    .card-footer {\n        padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);\n        color: var(--bs-card-cap-color);\n        background-color: var(--bs-card-cap-bg);\n        border-top: var(--bs-card-border-width) solid\n            var(--bs-card-border-color);\n    }\n    .card-footer:last-child {\n        border-radius: 0 0 var(--bs-card-inner-border-radius)\n            var(--bs-card-inner-border-radius);\n    }\n\n    .card-header-tabs {\n        margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));\n        margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));\n        margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));\n        border-bottom: 0;\n    }\n    .card-header-tabs .nav-link.active {\n        background-color: var(--bs-card-bg);\n        border-bottom-color: var(--bs-card-bg);\n    }\n\n    .card-header-pills {\n        margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));\n        margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));\n    }\n\n    .card-img-overlay {\n        position: absolute;\n        top: 0;\n        right: 0;\n        bottom: 0;\n        left: 0;\n        padding: var(--bs-card-img-overlay-padding);\n        border-radius: var(--bs-card-inner-border-radius);\n    }\n\n    .card-img,\n    .card-img-top,\n    .card-img-bottom {\n        width: 100%;\n    }\n\n    .card-img,\n    .card-img-top {\n        border-top-left-radius: var(--bs-card-inner-border-radius);\n        border-top-right-radius: var(--bs-card-inner-border-radius);\n    }\n\n    .card-img,\n    .card-img-bottom {\n        border-bottom-right-radius: var(--bs-card-inner-border-radius);\n        border-bottom-left-radius: var(--bs-card-inner-border-radius);\n    }\n\n    .card-group > .card {\n        margin-bottom: var(--bs-card-group-margin);\n    }\n    @media (min-width: 576px) {\n        .card-group {\n            display: flex;\n            flex-flow: row wrap;\n        }\n        .card-group > .card {\n            flex: 1 0 0%;\n            margin-bottom: 0;\n        }\n        .card-group > .card + .card {\n            margin-left: 0;\n            border-left: 0;\n        }\n        .card-group > .card:not(:last-child) {\n            border-top-right-radius: 0;\n            border-bottom-right-radius: 0;\n        }\n        .card-group > .card:not(:last-child) .card-img-top,\n        .card-group > .card:not(:last-child) .card-header {\n            border-top-right-radius: 0;\n        }\n        .card-group > .card:not(:last-child) .card-img-bottom,\n        .card-group > .card:not(:last-child) .card-footer {\n            border-bottom-right-radius: 0;\n        }\n        .card-group > .card:not(:first-child) {\n            border-top-left-radius: 0;\n            border-bottom-left-radius: 0;\n        }\n        .card-group > .card:not(:first-child) .card-img-top,\n        .card-group > .card:not(:first-child) .card-header {\n            border-top-left-radius: 0;\n        }\n        .card-group > .card:not(:first-child) .card-img-bottom,\n        .card-group > .card:not(:first-child) .card-footer {\n            border-bottom-left-radius: 0;\n        }\n    }\n\n    .accordion {\n        --bs-accordion-color: var(--bs-body-color);\n        --bs-accordion-bg: var(--bs-body-bg);\n        --bs-accordion-transition: color 0.15s ease-in-out,\n            background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,\n            box-shadow 0.15s ease-in-out, border-radius 0.15s ease;\n        --bs-accordion-border-color: var(--bs-border-color);\n        --bs-accordion-border-width: var(--bs-border-width);\n        --bs-accordion-border-radius: var(--bs-border-radius);\n        --bs-accordion-inner-border-radius: calc(\n            var(--bs-border-radius) - (var(--bs-border-width))\n        );\n        --bs-accordion-btn-padding-x: 1.25rem;\n        --bs-accordion-btn-padding-y: 1rem;\n        --bs-accordion-btn-color: var(--bs-body-color);\n        --bs-accordion-btn-bg: var(--bs-accordion-bg);\n        --bs-accordion-btn-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='%23212529' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M2 5L8 11L14 5'/%3e%3c/svg%3e\");\n        --bs-accordion-btn-icon-width: 1.25rem;\n        --bs-accordion-btn-icon-transform: rotate(-180deg);\n        --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;\n        --bs-accordion-btn-active-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='%23052c65' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M2 5L8 11L14 5'/%3e%3c/svg%3e\");\n        --bs-accordion-btn-focus-box-shadow: 0 0 0 0.25rem\n            rgba(13, 110, 253, 0.25);\n        --bs-accordion-body-padding-x: 1.25rem;\n        --bs-accordion-body-padding-y: 1rem;\n        --bs-accordion-active-color: var(--bs-primary-text-emphasis);\n        --bs-accordion-active-bg: var(--bs-primary-bg-subtle);\n    }\n\n    .accordion-button {\n        position: relative;\n        display: flex;\n        align-items: center;\n        width: 100%;\n        padding: var(--bs-accordion-btn-padding-y)\n            var(--bs-accordion-btn-padding-x);\n        font-size: 1rem;\n        color: var(--bs-accordion-btn-color);\n        text-align: left;\n        background-color: var(--bs-accordion-btn-bg);\n        border: 0;\n        border-radius: 0;\n        overflow-anchor: none;\n        transition: var(--bs-accordion-transition);\n    }\n    @media (prefers-reduced-motion: reduce) {\n        .accordion-button {\n            transition: none;\n        }\n    }\n    .accordion-button:not(.collapsed) {\n        color: var(--bs-accordion-active-color);\n        background-color: var(--bs-accordion-active-bg);\n        box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0\n            var(--bs-accordion-border-color);\n    }\n    .accordion-button:not(.collapsed)::after {\n        background-image: var(--bs-accordion-btn-active-icon);\n        transform: var(--bs-accordion-btn-icon-transform);\n    }\n    .accordion-button::after {\n        flex-shrink: 0;\n        width: var(--bs-accordion-btn-icon-width);\n        height: var(--bs-accordion-btn-icon-width);\n        margin-left: auto;\n        content: '';\n        background-image: var(--bs-accordion-btn-icon);\n        background-repeat: no-repeat;\n        background-size: var(--bs-accordion-btn-icon-width);\n        transition: var(--bs-accordion-btn-icon-transition);\n    }\n    @media (prefers-reduced-motion: reduce) {\n        .accordion-button::after {\n            transition: none;\n        }\n    }\n    .accordion-button:hover {\n        z-index: 2;\n    }\n    .accordion-button:focus {\n        z-index: 3;\n        outline: 0;\n        box-shadow: var(--bs-accordion-btn-focus-box-shadow);\n    }\n\n    .accordion-header {\n        margin-bottom: 0;\n    }\n\n    .accordion-item {\n        color: var(--bs-accordion-color);\n        background-color: var(--bs-accordion-bg);\n        border: var(--bs-accordion-border-width) solid\n            var(--bs-accordion-border-color);\n    }\n    .accordion-item:first-of-type {\n        border-top-left-radius: var(--bs-accordion-border-radius);\n        border-top-right-radius: var(--bs-accordion-border-radius);\n    }\n    .accordion-item:first-of-type > .accordion-header .accordion-button {\n        border-top-left-radius: var(--bs-accordion-inner-border-radius);\n        border-top-right-radius: var(--bs-accordion-inner-border-radius);\n    }\n    .accordion-item:not(:first-of-type) {\n        border-top: 0;\n    }\n    .accordion-item:last-of-type {\n        border-bottom-right-radius: var(--bs-accordion-border-radius);\n        border-bottom-left-radius: var(--bs-accordion-border-radius);\n    }\n    .accordion-item:last-of-type\n        > .accordion-header\n        .accordion-button.collapsed {\n        border-bottom-right-radius: var(--bs-accordion-inner-border-radius);\n        border-bottom-left-radius: var(--bs-accordion-inner-border-radius);\n    }\n    .accordion-item:last-of-type > .accordion-collapse {\n        border-bottom-right-radius: var(--bs-accordion-border-radius);\n        border-bottom-left-radius: var(--bs-accordion-border-radius);\n    }\n\n    .accordion-body {\n        padding: var(--bs-accordion-body-padding-y)\n            var(--bs-accordion-body-padding-x);\n    }\n\n    .accordion-flush > .accordion-item {\n        border-right: 0;\n        border-left: 0;\n        border-radius: 0;\n    }\n    .accordion-flush > .accordion-item:first-child {\n        border-top: 0;\n    }\n    .accordion-flush > .accordion-item:last-child {\n        border-bottom: 0;\n    }\n    .accordion-flush > .accordion-item > .accordion-header .accordion-button,\n    .accordion-flush\n        > .accordion-item\n        > .accordion-header\n        .accordion-button.collapsed {\n        border-radius: 0;\n    }\n    .accordion-flush > .accordion-item > .accordion-collapse {\n        border-radius: 0;\n    }\n\n    [data-bs-theme='dark'] .accordion-button::after {\n        --bs-accordion-btn-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%236ea8fe'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n        --bs-accordion-btn-active-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%236ea8fe'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n    }\n\n    .breadcrumb {\n        --bs-breadcrumb-padding-x: 0;\n        --bs-breadcrumb-padding-y: 0;\n        --bs-breadcrumb-margin-bottom: 1rem;\n        --bs-breadcrumb-bg: ;\n        --bs-breadcrumb-border-radius: ;\n        --bs-breadcrumb-divider-color: var(--bs-secondary-color);\n        --bs-breadcrumb-item-padding-x: 0.5rem;\n        --bs-breadcrumb-item-active-color: var(--bs-secondary-color);\n        display: flex;\n        flex-wrap: wrap;\n        padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);\n        margin-bottom: var(--bs-breadcrumb-margin-bottom);\n        font-size: var(--bs-breadcrumb-font-size);\n        list-style: none;\n        background-color: var(--bs-breadcrumb-bg);\n        border-radius: var(--bs-breadcrumb-border-radius);\n    }\n\n    .breadcrumb-item + .breadcrumb-item {\n        padding-left: var(--bs-breadcrumb-item-padding-x);\n    }\n    .breadcrumb-item + .breadcrumb-item::before {\n        float: left;\n        padding-right: var(--bs-breadcrumb-item-padding-x);\n        color: var(--bs-breadcrumb-divider-color);\n        content: var(--bs-breadcrumb-divider, '/')\n            /* rtl: var(--bs-breadcrumb-divider, \"/\") */;\n    }\n    .breadcrumb-item.active {\n        color: var(--bs-breadcrumb-item-active-color);\n    }\n\n    .pagination {\n        --bs-pagination-padding-x: 0.75rem;\n        --bs-pagination-padding-y: 0.375rem;\n        --bs-pagination-font-size: 1rem;\n        --bs-pagination-color: var(--bs-link-color);\n        --bs-pagination-bg: var(--bs-body-bg);\n        --bs-pagination-border-width: var(--bs-border-width);\n        --bs-pagination-border-color: var(--bs-border-color);\n        --bs-pagination-border-radius: var(--bs-border-radius);\n        --bs-pagination-hover-color: var(--bs-link-hover-color);\n        --bs-pagination-hover-bg: var(--bs-tertiary-bg);\n        --bs-pagination-hover-border-color: var(--bs-border-color);\n        --bs-pagination-focus-color: var(--bs-link-hover-color);\n        --bs-pagination-focus-bg: var(--bs-secondary-bg);\n        --bs-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n        --bs-pagination-active-color: #fff;\n        --bs-pagination-active-bg: #0d6efd;\n        --bs-pagination-active-border-color: #0d6efd;\n        --bs-pagination-disabled-color: var(--bs-secondary-color);\n        --bs-pagination-disabled-bg: var(--bs-secondary-bg);\n        --bs-pagination-disabled-border-color: var(--bs-border-color);\n        display: flex;\n        padding-left: 0;\n        list-style: none;\n    }\n\n    .page-link {\n        position: relative;\n        display: block;\n        padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);\n        font-size: var(--bs-pagination-font-size);\n        color: var(--bs-pagination-color);\n        text-decoration: none;\n        background-color: var(--bs-pagination-bg);\n        border: var(--bs-pagination-border-width) solid\n            var(--bs-pagination-border-color);\n        transition:\n            color 0.15s ease-in-out,\n            background-color 0.15s ease-in-out,\n            border-color 0.15s ease-in-out,\n            box-shadow 0.15s ease-in-out;\n    }\n    @media (prefers-reduced-motion: reduce) {\n        .page-link {\n            transition: none;\n        }\n    }\n    .page-link:hover {\n        z-index: 2;\n        color: var(--bs-pagination-hover-color);\n        background-color: var(--bs-pagination-hover-bg);\n        border-color: var(--bs-pagination-hover-border-color);\n    }\n    .page-link:focus {\n        z-index: 3;\n        color: var(--bs-pagination-focus-color);\n        background-color: var(--bs-pagination-focus-bg);\n        outline: 0;\n        box-shadow: var(--bs-pagination-focus-box-shadow);\n    }\n    .page-link.active,\n    .active > .page-link {\n        z-index: 3;\n        color: var(--bs-pagination-active-color);\n        background-color: var(--bs-pagination-active-bg);\n        border-color: var(--bs-pagination-active-border-color);\n    }\n    .page-link.disabled,\n    .disabled > .page-link {\n        color: var(--bs-pagination-disabled-color);\n        pointer-events: none;\n        background-color: var(--bs-pagination-disabled-bg);\n        border-color: var(--bs-pagination-disabled-border-color);\n    }\n\n    .page-item:not(:first-child) .page-link {\n        margin-left: calc(var(--bs-border-width) * -1);\n    }\n    .page-item:first-child .page-link {\n        border-top-left-radius: var(--bs-pagination-border-radius);\n        border-bottom-left-radius: var(--bs-pagination-border-radius);\n    }\n    .page-item:last-child .page-link {\n        border-top-right-radius: var(--bs-pagination-border-radius);\n        border-bottom-right-radius: var(--bs-pagination-border-radius);\n    }\n\n    .pagination-lg {\n        --bs-pagination-padding-x: 1.5rem;\n        --bs-pagination-padding-y: 0.75rem;\n        --bs-pagination-font-size: 1.25rem;\n        --bs-pagination-border-radius: var(--bs-border-radius-lg);\n    }\n\n    .pagination-sm {\n        --bs-pagination-padding-x: 0.5rem;\n        --bs-pagination-padding-y: 0.25rem;\n        --bs-pagination-font-size: 0.875rem;\n        --bs-pagination-border-radius: var(--bs-border-radius-sm);\n    }\n\n    .badge {\n        --bs-badge-padding-x: 0.65em;\n        --bs-badge-padding-y: 0.35em;\n        --bs-badge-font-size: 0.75em;\n        --bs-badge-font-weight: 700;\n        --bs-badge-color: #fff;\n        --bs-badge-border-radius: var(--bs-border-radius);\n        display: inline-block;\n        padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);\n        font-size: var(--bs-badge-font-size);\n        font-weight: var(--bs-badge-font-weight);\n        line-height: 1;\n        color: var(--bs-badge-color);\n        text-align: center;\n        white-space: nowrap;\n        vertical-align: baseline;\n        border-radius: var(--bs-badge-border-radius);\n    }\n    .badge:empty {\n        display: none;\n    }\n\n    .btn .badge {\n        position: relative;\n        top: -1px;\n    }\n\n    .alert {\n        --bs-alert-bg: transparent;\n        --bs-alert-padding-x: 1rem;\n        --bs-alert-padding-y: 1rem;\n        --bs-alert-margin-bottom: 1rem;\n        --bs-alert-color: inherit;\n        --bs-alert-border-color: transparent;\n        --bs-alert-border: var(--bs-border-width) solid\n            var(--bs-alert-border-color);\n        --bs-alert-border-radius: var(--bs-border-radius);\n        --bs-alert-link-color: inherit;\n        position: relative;\n        padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);\n        margin-bottom: var(--bs-alert-margin-bottom);\n        color: var(--bs-alert-color);\n        background-color: var(--bs-alert-bg);\n        border: var(--bs-alert-border);\n        border-radius: var(--bs-alert-border-radius);\n    }\n\n    .alert-heading {\n        color: inherit;\n    }\n\n    .alert-link {\n        font-weight: 700;\n        color: var(--bs-alert-link-color);\n    }\n\n    .alert-dismissible {\n        padding-right: 3rem;\n    }\n    .alert-dismissible .btn-close {\n        position: absolute;\n        top: 0;\n        right: 0;\n        z-index: 2;\n        padding: 1.25rem 1rem;\n    }\n\n    .alert-primary {\n        --bs-alert-color: var(--bs-primary-text-emphasis);\n        --bs-alert-bg: var(--bs-primary-bg-subtle);\n        --bs-alert-border-color: var(--bs-primary-border-subtle);\n        --bs-alert-link-color: var(--bs-primary-text-emphasis);\n    }\n\n    .alert-secondary {\n        --bs-alert-color: var(--bs-secondary-text-emphasis);\n        --bs-alert-bg: var(--bs-secondary-bg-subtle);\n        --bs-alert-border-color: var(--bs-secondary-border-subtle);\n        --bs-alert-link-color: var(--bs-secondary-text-emphasis);\n    }\n\n    .alert-success {\n        --bs-alert-color: var(--bs-success-text-emphasis);\n        --bs-alert-bg: var(--bs-success-bg-subtle);\n        --bs-alert-border-color: var(--bs-success-border-subtle);\n        --bs-alert-link-color: var(--bs-success-text-emphasis);\n    }\n\n    .alert-info {\n        --bs-alert-color: var(--bs-info-text-emphasis);\n        --bs-alert-bg: var(--bs-info-bg-subtle);\n        --bs-alert-border-color: var(--bs-info-border-subtle);\n        --bs-alert-link-color: var(--bs-info-text-emphasis);\n    }\n\n    .alert-warning {\n        --bs-alert-color: var(--bs-warning-text-emphasis);\n        --bs-alert-bg: var(--bs-warning-bg-subtle);\n        --bs-alert-border-color: var(--bs-warning-border-subtle);\n        --bs-alert-link-color: var(--bs-warning-text-emphasis);\n    }\n\n    .alert-danger {\n        --bs-alert-color: var(--bs-danger-text-emphasis);\n        --bs-alert-bg: var(--bs-danger-bg-subtle);\n        --bs-alert-border-color: var(--bs-danger-border-subtle);\n        --bs-alert-link-color: var(--bs-danger-text-emphasis);\n    }\n\n    .alert-light {\n        --bs-alert-color: var(--bs-light-text-emphasis);\n        --bs-alert-bg: var(--bs-light-bg-subtle);\n        --bs-alert-border-color: var(--bs-light-border-subtle);\n        --bs-alert-link-color: var(--bs-light-text-emphasis);\n    }\n\n    .alert-dark {\n        --bs-alert-color: var(--bs-dark-text-emphasis);\n        --bs-alert-bg: var(--bs-dark-bg-subtle);\n        --bs-alert-border-color: var(--bs-dark-border-subtle);\n        --bs-alert-link-color: var(--bs-dark-text-emphasis);\n    }\n\n    @keyframes progress-bar-stripes {\n        0% {\n            background-position-x: 1rem;\n        }\n    }\n    .progress,\n    .progress-stacked {\n        --bs-progress-height: 1rem;\n        --bs-progress-font-size: 0.75rem;\n        --bs-progress-bg: var(--bs-secondary-bg);\n        --bs-progress-border-radius: var(--bs-border-radius);\n        --bs-progress-box-shadow: var(--bs-box-shadow-inset);\n        --bs-progress-bar-color: #fff;\n        --bs-progress-bar-bg: #0d6efd;\n        --bs-progress-bar-transition: width 0.6s ease;\n        display: flex;\n        height: var(--bs-progress-height);\n        overflow: hidden;\n        font-size: var(--bs-progress-font-size);\n        background-color: var(--bs-progress-bg);\n        border-radius: var(--bs-progress-border-radius);\n    }\n\n    .progress-bar {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        overflow: hidden;\n        color: var(--bs-progress-bar-color);\n        text-align: center;\n        white-space: nowrap;\n        background-color: var(--bs-progress-bar-bg);\n        transition: var(--bs-progress-bar-transition);\n    }\n    @media (prefers-reduced-motion: reduce) {\n        .progress-bar {\n            transition: none;\n        }\n    }\n\n    .progress-bar-striped {\n        background-image: linear-gradient(\n            45deg,\n            rgba(255, 255, 255, 0.15) 25%,\n            transparent 25%,\n            transparent 50%,\n            rgba(255, 255, 255, 0.15) 50%,\n            rgba(255, 255, 255, 0.15) 75%,\n            transparent 75%,\n            transparent\n        );\n        background-size: var(--bs-progress-height) var(--bs-progress-height);\n    }\n\n    .progress-stacked > .progress {\n        overflow: visible;\n    }\n\n    .progress-stacked > .progress > .progress-bar {\n        width: 100%;\n    }\n\n    .progress-bar-animated {\n        animation: 1s linear infinite progress-bar-stripes;\n    }\n    @media (prefers-reduced-motion: reduce) {\n        .progress-bar-animated {\n            animation: none;\n        }\n    }\n\n    .list-group {\n        --bs-list-group-color: var(--bs-body-color);\n        --bs-list-group-bg: var(--bs-body-bg);\n        --bs-list-group-border-color: var(--bs-border-color);\n        --bs-list-group-border-width: var(--bs-border-width);\n        --bs-list-group-border-radius: var(--bs-border-radius);\n        --bs-list-group-item-padding-x: 1rem;\n        --bs-list-group-item-padding-y: 0.5rem;\n        --bs-list-group-action-color: var(--bs-secondary-color);\n        --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n        --bs-list-group-action-hover-bg: var(--bs-tertiary-bg);\n        --bs-list-group-action-active-color: var(--bs-body-color);\n        --bs-list-group-action-active-bg: var(--bs-secondary-bg);\n        --bs-list-group-disabled-color: var(--bs-secondary-color);\n        --bs-list-group-disabled-bg: var(--bs-body-bg);\n        --bs-list-group-active-color: #fff;\n        --bs-list-group-active-bg: #0d6efd;\n        --bs-list-group-active-border-color: #0d6efd;\n        display: flex;\n        flex-direction: column;\n        padding-left: 0;\n        margin-bottom: 0;\n        border-radius: var(--bs-list-group-border-radius);\n    }\n\n    .list-group-numbered {\n        list-style-type: none;\n        counter-reset: section;\n    }\n    .list-group-numbered > .list-group-item::before {\n        content: counters(section, '.') '. ';\n        counter-increment: section;\n    }\n\n    .list-group-item-action {\n        width: 100%;\n        color: var(--bs-list-group-action-color);\n        text-align: inherit;\n    }\n    .list-group-item-action:hover,\n    .list-group-item-action:focus {\n        z-index: 1;\n        color: var(--bs-list-group-action-hover-color);\n        text-decoration: none;\n        background-color: var(--bs-list-group-action-hover-bg);\n    }\n    .list-group-item-action:active {\n        color: var(--bs-list-group-action-active-color);\n        background-color: var(--bs-list-group-action-active-bg);\n    }\n\n    .list-group-item {\n        position: relative;\n        display: block;\n        padding: var(--bs-list-group-item-padding-y)\n            var(--bs-list-group-item-padding-x);\n        color: var(--bs-list-group-color);\n        text-decoration: none;\n        background-color: var(--bs-list-group-bg);\n        border: var(--bs-list-group-border-width) solid\n            var(--bs-list-group-border-color);\n    }\n    .list-group-item:first-child {\n        border-top-left-radius: inherit;\n        border-top-right-radius: inherit;\n    }\n    .list-group-item:last-child {\n        border-bottom-right-radius: inherit;\n        border-bottom-left-radius: inherit;\n    }\n    .list-group-item.disabled,\n    .list-group-item:disabled {\n        color: var(--bs-list-group-disabled-color);\n        pointer-events: none;\n        background-color: var(--bs-list-group-disabled-bg);\n    }\n    .list-group-item.active {\n        z-index: 2;\n        color: var(--bs-list-group-active-color);\n        background-color: var(--bs-list-group-active-bg);\n        border-color: var(--bs-list-group-active-border-color);\n    }\n    .list-group-item + .list-group-item {\n        border-top-width: 0;\n    }\n    .list-group-item + .list-group-item.active {\n        margin-top: calc(-1 * var(--bs-list-group-border-width));\n        border-top-width: var(--bs-list-group-border-width);\n    }\n\n    .list-group-horizontal {\n        flex-direction: row;\n    }\n    .list-group-horizontal > .list-group-item:first-child:not(:last-child) {\n        border-bottom-left-radius: var(--bs-list-group-border-radius);\n        border-top-right-radius: 0;\n    }\n    .list-group-horizontal > .list-group-item:last-child:not(:first-child) {\n        border-top-right-radius: var(--bs-list-group-border-radius);\n        border-bottom-left-radius: 0;\n    }\n    .list-group-horizontal > .list-group-item.active {\n        margin-top: 0;\n    }\n    .list-group-horizontal > .list-group-item + .list-group-item {\n        border-top-width: var(--bs-list-group-border-width);\n        border-left-width: 0;\n    }\n    .list-group-horizontal > .list-group-item + .list-group-item.active {\n        margin-left: calc(-1 * var(--bs-list-group-border-width));\n        border-left-width: var(--bs-list-group-border-width);\n    }\n\n    @media (min-width: 576px) {\n        .list-group-horizontal-sm {\n            flex-direction: row;\n        }\n        .list-group-horizontal-sm\n            > .list-group-item:first-child:not(:last-child) {\n            border-bottom-left-radius: var(--bs-list-group-border-radius);\n            border-top-right-radius: 0;\n        }\n        .list-group-horizontal-sm\n            > .list-group-item:last-child:not(:first-child) {\n            border-top-right-radius: var(--bs-list-group-border-radius);\n            border-bottom-left-radius: 0;\n        }\n        .list-group-horizontal-sm > .list-group-item.active {\n            margin-top: 0;\n        }\n        .list-group-horizontal-sm > .list-group-item + .list-group-item {\n            border-top-width: var(--bs-list-group-border-width);\n            border-left-width: 0;\n        }\n        .list-group-horizontal-sm > .list-group-item + .list-group-item.active {\n            margin-left: calc(-1 * var(--bs-list-group-border-width));\n            border-left-width: var(--bs-list-group-border-width);\n        }\n    }\n    @media (min-width: 768px) {\n        .list-group-horizontal-md {\n            flex-direction: row;\n        }\n        .list-group-horizontal-md\n            > .list-group-item:first-child:not(:last-child) {\n            border-bottom-left-radius: var(--bs-list-group-border-radius);\n            border-top-right-radius: 0;\n        }\n        .list-group-horizontal-md\n            > .list-group-item:last-child:not(:first-child) {\n            border-top-right-radius: var(--bs-list-group-border-radius);\n            border-bottom-left-radius: 0;\n        }\n        .list-group-horizontal-md > .list-group-item.active {\n            margin-top: 0;\n        }\n        .list-group-horizontal-md > .list-group-item + .list-group-item {\n            border-top-width: var(--bs-list-group-border-width);\n            border-left-width: 0;\n        }\n        .list-group-horizontal-md > .list-group-item + .list-group-item.active {\n            margin-left: calc(-1 * var(--bs-list-group-border-width));\n            border-left-width: var(--bs-list-group-border-width);\n        }\n    }\n    @media (min-width: 992px) {\n        .list-group-horizontal-lg {\n            flex-direction: row;\n        }\n        .list-group-horizontal-lg\n            > .list-group-item:first-child:not(:last-child) {\n            border-bottom-left-radius: var(--bs-list-group-border-radius);\n            border-top-right-radius: 0;\n        }\n        .list-group-horizontal-lg\n            > .list-group-item:last-child:not(:first-child) {\n            border-top-right-radius: var(--bs-list-group-border-radius);\n            border-bottom-left-radius: 0;\n        }\n        .list-group-horizontal-lg > .list-group-item.active {\n            margin-top: 0;\n        }\n        .list-group-horizontal-lg > .list-group-item + .list-group-item {\n            border-top-width: var(--bs-list-group-border-width);\n            border-left-width: 0;\n        }\n        .list-group-horizontal-lg > .list-group-item + .list-group-item.active {\n            margin-left: calc(-1 * var(--bs-list-group-border-width));\n            border-left-width: var(--bs-list-group-border-width);\n        }\n    }\n    @media (min-width: 1200px) {\n        .list-group-horizontal-xl {\n            flex-direction: row;\n        }\n        .list-group-horizontal-xl\n            > .list-group-item:first-child:not(:last-child) {\n            border-bottom-left-radius: var(--bs-list-group-border-radius);\n            border-top-right-radius: 0;\n        }\n        .list-group-horizontal-xl\n            > .list-group-item:last-child:not(:first-child) {\n            border-top-right-radius: var(--bs-list-group-border-radius);\n            border-bottom-left-radius: 0;\n        }\n        .list-group-horizontal-xl > .list-group-item.active {\n            margin-top: 0;\n        }\n        .list-group-horizontal-xl > .list-group-item + .list-group-item {\n            border-top-width: var(--bs-list-group-border-width);\n            border-left-width: 0;\n        }\n        .list-group-horizontal-xl > .list-group-item + .list-group-item.active {\n            margin-left: calc(-1 * var(--bs-list-group-border-width));\n            border-left-width: var(--bs-list-group-border-width);\n        }\n    }\n    @media (min-width: 1400px) {\n        .list-group-horizontal-xxl {\n            flex-direction: row;\n        }\n        .list-group-horizontal-xxl\n            > .list-group-item:first-child:not(:last-child) {\n            border-bottom-left-radius: var(--bs-list-group-border-radius);\n            border-top-right-radius: 0;\n        }\n        .list-group-horizontal-xxl\n            > .list-group-item:last-child:not(:first-child) {\n            border-top-right-radius: var(--bs-list-group-border-radius);\n            border-bottom-left-radius: 0;\n        }\n        .list-group-horizontal-xxl > .list-group-item.active {\n            margin-top: 0;\n        }\n        .list-group-horizontal-xxl > .list-group-item + .list-group-item {\n            border-top-width: var(--bs-list-group-border-width);\n            border-left-width: 0;\n        }\n        .list-group-horizontal-xxl\n            > .list-group-item\n            + .list-group-item.active {\n            margin-left: calc(-1 * var(--bs-list-group-border-width));\n            border-left-width: var(--bs-list-group-border-width);\n        }\n    }\n    .list-group-flush {\n        border-radius: 0;\n    }\n    .list-group-flush > .list-group-item {\n        border-width: 0 0 var(--bs-list-group-border-width);\n    }\n    .list-group-flush > .list-group-item:last-child {\n        border-bottom-width: 0;\n    }\n\n    .list-group-item-primary {\n        --bs-list-group-color: var(--bs-primary-text-emphasis);\n        --bs-list-group-bg: var(--bs-primary-bg-subtle);\n        --bs-list-group-border-color: var(--bs-primary-border-subtle);\n        --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n        --bs-list-group-action-hover-bg: var(--bs-primary-border-subtle);\n        --bs-list-group-action-active-color: var(--bs-emphasis-color);\n        --bs-list-group-action-active-bg: var(--bs-primary-border-subtle);\n        --bs-list-group-active-color: var(--bs-primary-bg-subtle);\n        --bs-list-group-active-bg: var(--bs-primary-text-emphasis);\n        --bs-list-group-active-border-color: var(--bs-primary-text-emphasis);\n    }\n\n    .list-group-item-secondary {\n        --bs-list-group-color: var(--bs-secondary-text-emphasis);\n        --bs-list-group-bg: var(--bs-secondary-bg-subtle);\n        --bs-list-group-border-color: var(--bs-secondary-border-subtle);\n        --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n        --bs-list-group-action-hover-bg: var(--bs-secondary-border-subtle);\n        --bs-list-group-action-active-color: var(--bs-emphasis-color);\n        --bs-list-group-action-active-bg: var(--bs-secondary-border-subtle);\n        --bs-list-group-active-color: var(--bs-secondary-bg-subtle);\n        --bs-list-group-active-bg: var(--bs-secondary-text-emphasis);\n        --bs-list-group-active-border-color: var(--bs-secondary-text-emphasis);\n    }\n\n    .list-group-item-success {\n        --bs-list-group-color: var(--bs-success-text-emphasis);\n        --bs-list-group-bg: var(--bs-success-bg-subtle);\n        --bs-list-group-border-color: var(--bs-success-border-subtle);\n        --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n        --bs-list-group-action-hover-bg: var(--bs-success-border-subtle);\n        --bs-list-group-action-active-color: var(--bs-emphasis-color);\n        --bs-list-group-action-active-bg: var(--bs-success-border-subtle);\n        --bs-list-group-active-color: var(--bs-success-bg-subtle);\n        --bs-list-group-active-bg: var(--bs-success-text-emphasis);\n        --bs-list-group-active-border-color: var(--bs-success-text-emphasis);\n    }\n\n    .list-group-item-info {\n        --bs-list-group-color: var(--bs-info-text-emphasis);\n        --bs-list-group-bg: var(--bs-info-bg-subtle);\n        --bs-list-group-border-color: var(--bs-info-border-subtle);\n        --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n        --bs-list-group-action-hover-bg: var(--bs-info-border-subtle);\n        --bs-list-group-action-active-color: var(--bs-emphasis-color);\n        --bs-list-group-action-active-bg: var(--bs-info-border-subtle);\n        --bs-list-group-active-color: var(--bs-info-bg-subtle);\n        --bs-list-group-active-bg: var(--bs-info-text-emphasis);\n        --bs-list-group-active-border-color: var(--bs-info-text-emphasis);\n    }\n\n    .list-group-item-warning {\n        --bs-list-group-color: var(--bs-warning-text-emphasis);\n        --bs-list-group-bg: var(--bs-warning-bg-subtle);\n        --bs-list-group-border-color: var(--bs-warning-border-subtle);\n        --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n        --bs-list-group-action-hover-bg: var(--bs-warning-border-subtle);\n        --bs-list-group-action-active-color: var(--bs-emphasis-color);\n        --bs-list-group-action-active-bg: var(--bs-warning-border-subtle);\n        --bs-list-group-active-color: var(--bs-warning-bg-subtle);\n        --bs-list-group-active-bg: var(--bs-warning-text-emphasis);\n        --bs-list-group-active-border-color: var(--bs-warning-text-emphasis);\n    }\n\n    .list-group-item-danger {\n        --bs-list-group-color: var(--bs-danger-text-emphasis);\n        --bs-list-group-bg: var(--bs-danger-bg-subtle);\n        --bs-list-group-border-color: var(--bs-danger-border-subtle);\n        --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n        --bs-list-group-action-hover-bg: var(--bs-danger-border-subtle);\n        --bs-list-group-action-active-color: var(--bs-emphasis-color);\n        --bs-list-group-action-active-bg: var(--bs-danger-border-subtle);\n        --bs-list-group-active-color: var(--bs-danger-bg-subtle);\n        --bs-list-group-active-bg: var(--bs-danger-text-emphasis);\n        --bs-list-group-active-border-color: var(--bs-danger-text-emphasis);\n    }\n\n    .list-group-item-light {\n        --bs-list-group-color: var(--bs-light-text-emphasis);\n        --bs-list-group-bg: var(--bs-light-bg-subtle);\n        --bs-list-group-border-color: var(--bs-light-border-subtle);\n        --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n        --bs-list-group-action-hover-bg: var(--bs-light-border-subtle);\n        --bs-list-group-action-active-color: var(--bs-emphasis-color);\n        --bs-list-group-action-active-bg: var(--bs-light-border-subtle);\n        --bs-list-group-active-color: var(--bs-light-bg-subtle);\n        --bs-list-group-active-bg: var(--bs-light-text-emphasis);\n        --bs-list-group-active-border-color: var(--bs-light-text-emphasis);\n    }\n\n    .list-group-item-dark {\n        --bs-list-group-color: var(--bs-dark-text-emphasis);\n        --bs-list-group-bg: var(--bs-dark-bg-subtle);\n        --bs-list-group-border-color: var(--bs-dark-border-subtle);\n        --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n        --bs-list-group-action-hover-bg: var(--bs-dark-border-subtle);\n        --bs-list-group-action-active-color: var(--bs-emphasis-color);\n        --bs-list-group-action-active-bg: var(--bs-dark-border-subtle);\n        --bs-list-group-active-color: var(--bs-dark-bg-subtle);\n        --bs-list-group-active-bg: var(--bs-dark-text-emphasis);\n        --bs-list-group-active-border-color: var(--bs-dark-text-emphasis);\n    }\n\n    .btn-close {\n        --bs-btn-close-color: #000;\n        --bs-btn-close-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23000'%3e%3cpath d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/%3e%3c/svg%3e\");\n        --bs-btn-close-opacity: 0.5;\n        --bs-btn-close-hover-opacity: 0.75;\n        --bs-btn-close-focus-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n        --bs-btn-close-focus-opacity: 1;\n        --bs-btn-close-disabled-opacity: 0.25;\n        --bs-btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);\n        box-sizing: content-box;\n        width: 1em;\n        height: 1em;\n        padding: 0.25em 0.25em;\n        color: var(--bs-btn-close-color);\n        background: transparent var(--bs-btn-close-bg) center/1em auto no-repeat;\n        border: 0;\n        border-radius: 0.375rem;\n        opacity: var(--bs-btn-close-opacity);\n    }\n    .btn-close:hover {\n        color: var(--bs-btn-close-color);\n        text-decoration: none;\n        opacity: var(--bs-btn-close-hover-opacity);\n    }\n    .btn-close:focus {\n        outline: 0;\n        box-shadow: var(--bs-btn-close-focus-shadow);\n        opacity: var(--bs-btn-close-focus-opacity);\n    }\n    .btn-close:disabled,\n    .btn-close.disabled {\n        pointer-events: none;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        user-select: none;\n        opacity: var(--bs-btn-close-disabled-opacity);\n    }\n\n    .btn-close-white {\n        filter: var(--bs-btn-close-white-filter);\n    }\n\n    [data-bs-theme='dark'] .btn-close {\n        filter: var(--bs-btn-close-white-filter);\n    }\n\n    .toast {\n        --bs-toast-zindex: 1090;\n        --bs-toast-padding-x: 0.75rem;\n        --bs-toast-padding-y: 0.5rem;\n        --bs-toast-spacing: 1.5rem;\n        --bs-toast-max-width: 350px;\n        --bs-toast-font-size: 0.875rem;\n        --bs-toast-color: ;\n        --bs-toast-bg: rgba(var(--bs-body-bg-rgb), 0.85);\n        --bs-toast-border-width: var(--bs-border-width);\n        --bs-toast-border-color: var(--bs-border-color-translucent);\n        --bs-toast-border-radius: var(--bs-border-radius);\n        --bs-toast-box-shadow: var(--bs-box-shadow);\n        --bs-toast-header-color: var(--bs-secondary-color);\n        --bs-toast-header-bg: rgba(var(--bs-body-bg-rgb), 0.85);\n        --bs-toast-header-border-color: var(--bs-border-color-translucent);\n        width: var(--bs-toast-max-width);\n        max-width: 100%;\n        font-size: var(--bs-toast-font-size);\n        color: var(--bs-toast-color);\n        pointer-events: auto;\n        background-color: var(--bs-toast-bg);\n        background-clip: padding-box;\n        border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);\n        box-shadow: var(--bs-toast-box-shadow);\n        border-radius: var(--bs-toast-border-radius);\n    }\n    .toast.showing {\n        opacity: 0;\n    }\n    .toast:not(.show) {\n        display: none;\n    }\n\n    .toast-container {\n        --bs-toast-zindex: 1090;\n        position: absolute;\n        z-index: var(--bs-toast-zindex);\n        width: -webkit-max-content;\n        width: -moz-max-content;\n        width: max-content;\n        max-width: 100%;\n        pointer-events: none;\n    }\n    .toast-container > :not(:last-child) {\n        margin-bottom: var(--bs-toast-spacing);\n    }\n\n    .toast-header {\n        display: flex;\n        align-items: center;\n        padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);\n        color: var(--bs-toast-header-color);\n        background-color: var(--bs-toast-header-bg);\n        background-clip: padding-box;\n        border-bottom: var(--bs-toast-border-width) solid\n            var(--bs-toast-header-border-color);\n        border-top-left-radius: calc(\n            var(--bs-toast-border-radius) - var(--bs-toast-border-width)\n        );\n        border-top-right-radius: calc(\n            var(--bs-toast-border-radius) - var(--bs-toast-border-width)\n        );\n    }\n    .toast-header .btn-close {\n        margin-right: calc(-0.5 * var(--bs-toast-padding-x));\n        margin-left: var(--bs-toast-padding-x);\n    }\n\n    .toast-body {\n        padding: var(--bs-toast-padding-x);\n        word-wrap: break-word;\n    }\n\n    .modal {\n        --bs-modal-zindex: 1055;\n        --bs-modal-width: 500px;\n        --bs-modal-padding: 1rem;\n        --bs-modal-margin: 0.5rem;\n        --bs-modal-color: ;\n        --bs-modal-bg: var(--bs-body-bg);\n        --bs-modal-border-color: var(--bs-border-color-translucent);\n        --bs-modal-border-width: var(--bs-border-width);\n        --bs-modal-border-radius: var(--bs-border-radius-lg);\n        --bs-modal-box-shadow: var(--bs-box-shadow-sm);\n        --bs-modal-inner-border-radius: calc(\n            var(--bs-border-radius-lg) - (var(--bs-border-width))\n        );\n        --bs-modal-header-padding-x: 1rem;\n        --bs-modal-header-padding-y: 1rem;\n        --bs-modal-header-padding: 1rem 1rem;\n        --bs-modal-header-border-color: var(--bs-border-color);\n        --bs-modal-header-border-width: var(--bs-border-width);\n        --bs-modal-title-line-height: 1.5;\n        --bs-modal-footer-gap: 0.5rem;\n        --bs-modal-footer-bg: ;\n        --bs-modal-footer-border-color: var(--bs-border-color);\n        --bs-modal-footer-border-width: var(--bs-border-width);\n        position: fixed;\n        top: 0;\n        left: 0;\n        z-index: var(--bs-modal-zindex);\n        display: none;\n        width: 100%;\n        height: 100%;\n        overflow-x: hidden;\n        overflow-y: auto;\n        outline: 0;\n    }\n\n    .modal-dialog {\n        position: relative;\n        width: auto;\n        margin: var(--bs-modal-margin);\n        pointer-events: none;\n    }\n    .modal.fade .modal-dialog {\n        transition: transform 0.3s ease-out;\n        transform: translate(0, -50px);\n    }\n    @media (prefers-reduced-motion: reduce) {\n        .modal.fade .modal-dialog {\n            transition: none;\n        }\n    }\n    .modal.show .modal-dialog {\n        transform: none;\n    }\n    .modal.modal-static .modal-dialog {\n        transform: scale(1.02);\n    }\n\n    .modal-dialog-scrollable {\n        height: calc(100% - var(--bs-modal-margin) * 2);\n    }\n    .modal-dialog-scrollable .modal-content {\n        max-height: 100%;\n        overflow: hidden;\n    }\n    .modal-dialog-scrollable .modal-body {\n        overflow-y: auto;\n    }\n\n    .modal-dialog-centered {\n        display: flex;\n        align-items: center;\n        min-height: calc(100% - var(--bs-modal-margin) * 2);\n    }\n\n    .modal-content {\n        position: relative;\n        display: flex;\n        flex-direction: column;\n        width: 100%;\n        color: var(--bs-modal-color);\n        pointer-events: auto;\n        background-color: var(--bs-modal-bg);\n        background-clip: padding-box;\n        border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);\n        border-radius: var(--bs-modal-border-radius);\n        outline: 0;\n    }\n\n    .modal-backdrop {\n        --bs-backdrop-zindex: 1050;\n        --bs-backdrop-bg: #000;\n        --bs-backdrop-opacity: 0.5;\n        position: fixed;\n        top: 0;\n        left: 0;\n        z-index: var(--bs-backdrop-zindex);\n        width: 100vw;\n        height: 100vh;\n        background-color: var(--bs-backdrop-bg);\n    }\n    .modal-backdrop.fade {\n        opacity: 0;\n    }\n    .modal-backdrop.show {\n        opacity: var(--bs-backdrop-opacity);\n    }\n\n    .modal-header {\n        display: flex;\n        flex-shrink: 0;\n        align-items: center;\n        padding: var(--bs-modal-header-padding);\n        border-bottom: var(--bs-modal-header-border-width) solid\n            var(--bs-modal-header-border-color);\n        border-top-left-radius: var(--bs-modal-inner-border-radius);\n        border-top-right-radius: var(--bs-modal-inner-border-radius);\n    }\n    .modal-header .btn-close {\n        padding: calc(var(--bs-modal-header-padding-y) * 0.5)\n            calc(var(--bs-modal-header-padding-x) * 0.5);\n        margin: calc(-0.5 * var(--bs-modal-header-padding-y))\n            calc(-0.5 * var(--bs-modal-header-padding-x))\n            calc(-0.5 * var(--bs-modal-header-padding-y)) auto;\n    }\n\n    .modal-title {\n        margin-bottom: 0;\n        line-height: var(--bs-modal-title-line-height);\n    }\n\n    .modal-body {\n        position: relative;\n        flex: 1 1 auto;\n        padding: var(--bs-modal-padding);\n    }\n\n    .modal-footer {\n        display: flex;\n        flex-shrink: 0;\n        flex-wrap: wrap;\n        align-items: center;\n        justify-content: flex-end;\n        padding: calc(\n            var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5\n        );\n        background-color: var(--bs-modal-footer-bg);\n        border-top: var(--bs-modal-footer-border-width) solid\n            var(--bs-modal-footer-border-color);\n        border-bottom-right-radius: var(--bs-modal-inner-border-radius);\n        border-bottom-left-radius: var(--bs-modal-inner-border-radius);\n    }\n    .modal-footer > * {\n        margin: calc(var(--bs-modal-footer-gap) * 0.5);\n    }\n\n    @media (min-width: 576px) {\n        .modal {\n            --bs-modal-margin: 1.75rem;\n            --bs-modal-box-shadow: var(--bs-box-shadow);\n        }\n        .modal-dialog {\n            max-width: var(--bs-modal-width);\n            margin-right: auto;\n            margin-left: auto;\n        }\n        .modal-sm {\n            --bs-modal-width: 300px;\n        }\n    }\n    @media (min-width: 992px) {\n        .modal-lg,\n        .modal-xl {\n            --bs-modal-width: 800px;\n        }\n    }\n    @media (min-width: 1200px) {\n        .modal-xl {\n            --bs-modal-width: 1140px;\n        }\n    }\n    .modal-fullscreen {\n        width: 100vw;\n        max-width: none;\n        height: 100%;\n        margin: 0;\n    }\n    .modal-fullscreen .modal-content {\n        height: 100%;\n        border: 0;\n        border-radius: 0;\n    }\n    .modal-fullscreen .modal-header,\n    .modal-fullscreen .modal-footer {\n        border-radius: 0;\n    }\n    .modal-fullscreen .modal-body {\n        overflow-y: auto;\n    }\n\n    @media (max-width: 575.98px) {\n        .modal-fullscreen-sm-down {\n            width: 100vw;\n            max-width: none;\n            height: 100%;\n            margin: 0;\n        }\n        .modal-fullscreen-sm-down .modal-content {\n            height: 100%;\n            border: 0;\n            border-radius: 0;\n        }\n        .modal-fullscreen-sm-down .modal-header,\n        .modal-fullscreen-sm-down .modal-footer {\n            border-radius: 0;\n        }\n        .modal-fullscreen-sm-down .modal-body {\n            overflow-y: auto;\n        }\n    }\n    @media (max-width: 767.98px) {\n        .modal-fullscreen-md-down {\n            width: 100vw;\n            max-width: none;\n            height: 100%;\n            margin: 0;\n        }\n        .modal-fullscreen-md-down .modal-content {\n            height: 100%;\n            border: 0;\n            border-radius: 0;\n        }\n        .modal-fullscreen-md-down .modal-header,\n        .modal-fullscreen-md-down .modal-footer {\n            border-radius: 0;\n        }\n        .modal-fullscreen-md-down .modal-body {\n            overflow-y: auto;\n        }\n    }\n    @media (max-width: 991.98px) {\n        .modal-fullscreen-lg-down {\n            width: 100vw;\n            max-width: none;\n            height: 100%;\n            margin: 0;\n        }\n        .modal-fullscreen-lg-down .modal-content {\n            height: 100%;\n            border: 0;\n            border-radius: 0;\n        }\n        .modal-fullscreen-lg-down .modal-header,\n        .modal-fullscreen-lg-down .modal-footer {\n            border-radius: 0;\n        }\n        .modal-fullscreen-lg-down .modal-body {\n            overflow-y: auto;\n        }\n    }\n    @media (max-width: 1199.98px) {\n        .modal-fullscreen-xl-down {\n            width: 100vw;\n            max-width: none;\n            height: 100%;\n            margin: 0;\n        }\n        .modal-fullscreen-xl-down .modal-content {\n            height: 100%;\n            border: 0;\n            border-radius: 0;\n        }\n        .modal-fullscreen-xl-down .modal-header,\n        .modal-fullscreen-xl-down .modal-footer {\n            border-radius: 0;\n        }\n        .modal-fullscreen-xl-down .modal-body {\n            overflow-y: auto;\n        }\n    }\n    @media (max-width: 1399.98px) {\n        .modal-fullscreen-xxl-down {\n            width: 100vw;\n            max-width: none;\n            height: 100%;\n            margin: 0;\n        }\n        .modal-fullscreen-xxl-down .modal-content {\n            height: 100%;\n            border: 0;\n            border-radius: 0;\n        }\n        .modal-fullscreen-xxl-down .modal-header,\n        .modal-fullscreen-xxl-down .modal-footer {\n            border-radius: 0;\n        }\n        .modal-fullscreen-xxl-down .modal-body {\n            overflow-y: auto;\n        }\n    }\n    .tooltip {\n        --bs-tooltip-zindex: 1080;\n        --bs-tooltip-max-width: 200px;\n        --bs-tooltip-padding-x: 0.5rem;\n        --bs-tooltip-padding-y: 0.25rem;\n        --bs-tooltip-margin: ;\n        --bs-tooltip-font-size: 0.875rem;\n        --bs-tooltip-color: var(--bs-body-bg);\n        --bs-tooltip-bg: var(--bs-emphasis-color);\n        --bs-tooltip-border-radius: var(--bs-border-radius);\n        --bs-tooltip-opacity: 0.9;\n        --bs-tooltip-arrow-width: 0.8rem;\n        --bs-tooltip-arrow-height: 0.4rem;\n        z-index: var(--bs-tooltip-zindex);\n        display: block;\n        margin: var(--bs-tooltip-margin);\n        font-family: var(--bs-font-sans-serif);\n        font-style: normal;\n        font-weight: 400;\n        line-height: 1.5;\n        text-align: left;\n        text-align: start;\n        text-decoration: none;\n        text-shadow: none;\n        text-transform: none;\n        letter-spacing: normal;\n        word-break: normal;\n        white-space: normal;\n        word-spacing: normal;\n        line-break: auto;\n        font-size: var(--bs-tooltip-font-size);\n        word-wrap: break-word;\n        opacity: 0;\n    }\n    .tooltip.show {\n        opacity: var(--bs-tooltip-opacity);\n    }\n    .tooltip .tooltip-arrow {\n        display: block;\n        width: var(--bs-tooltip-arrow-width);\n        height: var(--bs-tooltip-arrow-height);\n    }\n    .tooltip .tooltip-arrow::before {\n        position: absolute;\n        content: '';\n        border-color: transparent;\n        border-style: solid;\n    }\n\n    .bs-tooltip-top .tooltip-arrow,\n    .bs-tooltip-auto[data-popper-placement^='top'] .tooltip-arrow {\n        bottom: calc(-1 * var(--bs-tooltip-arrow-height));\n    }\n    .bs-tooltip-top .tooltip-arrow::before,\n    .bs-tooltip-auto[data-popper-placement^='top'] .tooltip-arrow::before {\n        top: -1px;\n        border-width: var(--bs-tooltip-arrow-height)\n            calc(var(--bs-tooltip-arrow-width) * 0.5) 0;\n        border-top-color: var(--bs-tooltip-bg);\n    }\n\n    /* rtl:begin:ignore */\n    .bs-tooltip-end .tooltip-arrow,\n    .bs-tooltip-auto[data-popper-placement^='right'] .tooltip-arrow {\n        left: calc(-1 * var(--bs-tooltip-arrow-height));\n        width: var(--bs-tooltip-arrow-height);\n        height: var(--bs-tooltip-arrow-width);\n    }\n    .bs-tooltip-end .tooltip-arrow::before,\n    .bs-tooltip-auto[data-popper-placement^='right'] .tooltip-arrow::before {\n        right: -1px;\n        border-width: calc(var(--bs-tooltip-arrow-width) * 0.5)\n            var(--bs-tooltip-arrow-height)\n            calc(var(--bs-tooltip-arrow-width) * 0.5) 0;\n        border-right-color: var(--bs-tooltip-bg);\n    }\n\n    /* rtl:end:ignore */\n    .bs-tooltip-bottom .tooltip-arrow,\n    .bs-tooltip-auto[data-popper-placement^='bottom'] .tooltip-arrow {\n        top: calc(-1 * var(--bs-tooltip-arrow-height));\n    }\n    .bs-tooltip-bottom .tooltip-arrow::before,\n    .bs-tooltip-auto[data-popper-placement^='bottom'] .tooltip-arrow::before {\n        bottom: -1px;\n        border-width: 0 calc(var(--bs-tooltip-arrow-width) * 0.5)\n            var(--bs-tooltip-arrow-height);\n        border-bottom-color: var(--bs-tooltip-bg);\n    }\n\n    /* rtl:begin:ignore */\n    .bs-tooltip-start .tooltip-arrow,\n    .bs-tooltip-auto[data-popper-placement^='left'] .tooltip-arrow {\n        right: calc(-1 * var(--bs-tooltip-arrow-height));\n        width: var(--bs-tooltip-arrow-height);\n        height: var(--bs-tooltip-arrow-width);\n    }\n    .bs-tooltip-start .tooltip-arrow::before,\n    .bs-tooltip-auto[data-popper-placement^='left'] .tooltip-arrow::before {\n        left: -1px;\n        border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) 0\n            calc(var(--bs-tooltip-arrow-width) * 0.5)\n            var(--bs-tooltip-arrow-height);\n        border-left-color: var(--bs-tooltip-bg);\n    }\n\n    /* rtl:end:ignore */\n    .tooltip-inner {\n        max-width: var(--bs-tooltip-max-width);\n        padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);\n        color: var(--bs-tooltip-color);\n        text-align: center;\n        background-color: var(--bs-tooltip-bg);\n        border-radius: var(--bs-tooltip-border-radius);\n    }\n\n    .popover {\n        --bs-popover-zindex: 1070;\n        --bs-popover-max-width: 276px;\n        --bs-popover-font-size: 0.875rem;\n        --bs-popover-bg: var(--bs-body-bg);\n        --bs-popover-border-width: var(--bs-border-width);\n        --bs-popover-border-color: var(--bs-border-color-translucent);\n        --bs-popover-border-radius: var(--bs-border-radius-lg);\n        --bs-popover-inner-border-radius: calc(\n            var(--bs-border-radius-lg) - var(--bs-border-width)\n        );\n        --bs-popover-box-shadow: var(--bs-box-shadow);\n        --bs-popover-header-padding-x: 1rem;\n        --bs-popover-header-padding-y: 0.5rem;\n        --bs-popover-header-font-size: 1rem;\n        --bs-popover-header-color: inherit;\n        --bs-popover-header-bg: var(--bs-secondary-bg);\n        --bs-popover-body-padding-x: 1rem;\n        --bs-popover-body-padding-y: 1rem;\n        --bs-popover-body-color: var(--bs-body-color);\n        --bs-popover-arrow-width: 1rem;\n        --bs-popover-arrow-height: 0.5rem;\n        --bs-popover-arrow-border: var(--bs-popover-border-color);\n        z-index: var(--bs-popover-zindex);\n        display: block;\n        max-width: var(--bs-popover-max-width);\n        font-family: var(--bs-font-sans-serif);\n        font-style: normal;\n        font-weight: 400;\n        line-height: 1.5;\n        text-align: left;\n        text-align: start;\n        text-decoration: none;\n        text-shadow: none;\n        text-transform: none;\n        letter-spacing: normal;\n        word-break: normal;\n        white-space: normal;\n        word-spacing: normal;\n        line-break: auto;\n        font-size: var(--bs-popover-font-size);\n        word-wrap: break-word;\n        background-color: var(--bs-popover-bg);\n        background-clip: padding-box;\n        border: var(--bs-popover-border-width) solid\n            var(--bs-popover-border-color);\n        border-radius: var(--bs-popover-border-radius);\n    }\n    .popover .popover-arrow {\n        display: block;\n        width: var(--bs-popover-arrow-width);\n        height: var(--bs-popover-arrow-height);\n    }\n    .popover .popover-arrow::before,\n    .popover .popover-arrow::after {\n        position: absolute;\n        display: block;\n        content: '';\n        border-color: transparent;\n        border-style: solid;\n        border-width: 0;\n    }\n\n    .bs-popover-top > .popover-arrow,\n    .bs-popover-auto[data-popper-placement^='top'] > .popover-arrow {\n        bottom: calc(\n            -1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width)\n        );\n    }\n    .bs-popover-top > .popover-arrow::before,\n    .bs-popover-auto[data-popper-placement^='top'] > .popover-arrow::before,\n    .bs-popover-top > .popover-arrow::after,\n    .bs-popover-auto[data-popper-placement^='top'] > .popover-arrow::after {\n        border-width: var(--bs-popover-arrow-height)\n            calc(var(--bs-popover-arrow-width) * 0.5) 0;\n    }\n    .bs-popover-top > .popover-arrow::before,\n    .bs-popover-auto[data-popper-placement^='top'] > .popover-arrow::before {\n        bottom: 0;\n        border-top-color: var(--bs-popover-arrow-border);\n    }\n    .bs-popover-top > .popover-arrow::after,\n    .bs-popover-auto[data-popper-placement^='top'] > .popover-arrow::after {\n        bottom: var(--bs-popover-border-width);\n        border-top-color: var(--bs-popover-bg);\n    }\n\n    /* rtl:begin:ignore */\n    .bs-popover-end > .popover-arrow,\n    .bs-popover-auto[data-popper-placement^='right'] > .popover-arrow {\n        left: calc(\n            -1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width)\n        );\n        width: var(--bs-popover-arrow-height);\n        height: var(--bs-popover-arrow-width);\n    }\n    .bs-popover-end > .popover-arrow::before,\n    .bs-popover-auto[data-popper-placement^='right'] > .popover-arrow::before,\n    .bs-popover-end > .popover-arrow::after,\n    .bs-popover-auto[data-popper-placement^='right'] > .popover-arrow::after {\n        border-width: calc(var(--bs-popover-arrow-width) * 0.5)\n            var(--bs-popover-arrow-height)\n            calc(var(--bs-popover-arrow-width) * 0.5) 0;\n    }\n    .bs-popover-end > .popover-arrow::before,\n    .bs-popover-auto[data-popper-placement^='right'] > .popover-arrow::before {\n        left: 0;\n        border-right-color: var(--bs-popover-arrow-border);\n    }\n    .bs-popover-end > .popover-arrow::after,\n    .bs-popover-auto[data-popper-placement^='right'] > .popover-arrow::after {\n        left: var(--bs-popover-border-width);\n        border-right-color: var(--bs-popover-bg);\n    }\n\n    /* rtl:end:ignore */\n    .bs-popover-bottom > .popover-arrow,\n    .bs-popover-auto[data-popper-placement^='bottom'] > .popover-arrow {\n        top: calc(\n            -1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width)\n        );\n    }\n    .bs-popover-bottom > .popover-arrow::before,\n    .bs-popover-auto[data-popper-placement^='bottom'] > .popover-arrow::before,\n    .bs-popover-bottom > .popover-arrow::after,\n    .bs-popover-auto[data-popper-placement^='bottom'] > .popover-arrow::after {\n        border-width: 0 calc(var(--bs-popover-arrow-width) * 0.5)\n            var(--bs-popover-arrow-height);\n    }\n    .bs-popover-bottom > .popover-arrow::before,\n    .bs-popover-auto[data-popper-placement^='bottom'] > .popover-arrow::before {\n        top: 0;\n        border-bottom-color: var(--bs-popover-arrow-border);\n    }\n    .bs-popover-bottom > .popover-arrow::after,\n    .bs-popover-auto[data-popper-placement^='bottom'] > .popover-arrow::after {\n        top: var(--bs-popover-border-width);\n        border-bottom-color: var(--bs-popover-bg);\n    }\n    .bs-popover-bottom .popover-header::before,\n    .bs-popover-auto[data-popper-placement^='bottom'] .popover-header::before {\n        position: absolute;\n        top: 0;\n        left: 50%;\n        display: block;\n        width: var(--bs-popover-arrow-width);\n        margin-left: calc(-0.5 * var(--bs-popover-arrow-width));\n        content: '';\n        border-bottom: var(--bs-popover-border-width) solid\n            var(--bs-popover-header-bg);\n    }\n\n    /* rtl:begin:ignore */\n    .bs-popover-start > .popover-arrow,\n    .bs-popover-auto[data-popper-placement^='left'] > .popover-arrow {\n        right: calc(\n            -1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width)\n        );\n        width: var(--bs-popover-arrow-height);\n        height: var(--bs-popover-arrow-width);\n    }\n    .bs-popover-start > .popover-arrow::before,\n    .bs-popover-auto[data-popper-placement^='left'] > .popover-arrow::before,\n    .bs-popover-start > .popover-arrow::after,\n    .bs-popover-auto[data-popper-placement^='left'] > .popover-arrow::after {\n        border-width: calc(var(--bs-popover-arrow-width) * 0.5) 0\n            calc(var(--bs-popover-arrow-width) * 0.5)\n            var(--bs-popover-arrow-height);\n    }\n    .bs-popover-start > .popover-arrow::before,\n    .bs-popover-auto[data-popper-placement^='left'] > .popover-arrow::before {\n        right: 0;\n        border-left-color: var(--bs-popover-arrow-border);\n    }\n    .bs-popover-start > .popover-arrow::after,\n    .bs-popover-auto[data-popper-placement^='left'] > .popover-arrow::after {\n        right: var(--bs-popover-border-width);\n        border-left-color: var(--bs-popover-bg);\n    }\n\n    /* rtl:end:ignore */\n    .popover-header {\n        padding: var(--bs-popover-header-padding-y)\n            var(--bs-popover-header-padding-x);\n        margin-bottom: 0;\n        font-size: var(--bs-popover-header-font-size);\n        color: var(--bs-popover-header-color);\n        background-color: var(--bs-popover-header-bg);\n        border-bottom: var(--bs-popover-border-width) solid\n            var(--bs-popover-border-color);\n        border-top-left-radius: var(--bs-popover-inner-border-radius);\n        border-top-right-radius: var(--bs-popover-inner-border-radius);\n    }\n    .popover-header:empty {\n        display: none;\n    }\n\n    .popover-body {\n        padding: var(--bs-popover-body-padding-y)\n            var(--bs-popover-body-padding-x);\n        color: var(--bs-popover-body-color);\n    }\n\n    .carousel {\n        position: relative;\n    }\n\n    .carousel.pointer-event {\n        touch-action: pan-y;\n    }\n\n    .carousel-inner {\n        position: relative;\n        width: 100%;\n        overflow: hidden;\n    }\n    .carousel-inner::after {\n        display: block;\n        clear: both;\n        content: '';\n    }\n\n    .carousel-item {\n        position: relative;\n        display: none;\n        float: left;\n        width: 100%;\n        margin-right: -100%;\n        -webkit-backface-visibility: hidden;\n        backface-visibility: hidden;\n        transition: transform 0.6s ease-in-out;\n    }\n    @media (prefers-reduced-motion: reduce) {\n        .carousel-item {\n            transition: none;\n        }\n    }\n\n    .carousel-item.active,\n    .carousel-item-next,\n    .carousel-item-prev {\n        display: block;\n    }\n\n    .carousel-item-next:not(.carousel-item-start),\n    .active.carousel-item-end {\n        transform: translateX(100%);\n    }\n\n    .carousel-item-prev:not(.carousel-item-end),\n    .active.carousel-item-start {\n        transform: translateX(-100%);\n    }\n\n    .carousel-fade .carousel-item {\n        opacity: 0;\n        transition-property: opacity;\n        transform: none;\n    }\n    .carousel-fade .carousel-item.active,\n    .carousel-fade .carousel-item-next.carousel-item-start,\n    .carousel-fade .carousel-item-prev.carousel-item-end {\n        z-index: 1;\n        opacity: 1;\n    }\n    .carousel-fade .active.carousel-item-start,\n    .carousel-fade .active.carousel-item-end {\n        z-index: 0;\n        opacity: 0;\n        transition: opacity 0s 0.6s;\n    }\n    @media (prefers-reduced-motion: reduce) {\n        .carousel-fade .active.carousel-item-start,\n        .carousel-fade .active.carousel-item-end {\n            transition: none;\n        }\n    }\n\n    .carousel-control-prev,\n    .carousel-control-next {\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        z-index: 1;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        width: 15%;\n        padding: 0;\n        color: #fff;\n        text-align: center;\n        background: none;\n        border: 0;\n        opacity: 0.5;\n        transition: opacity 0.15s ease;\n    }\n    @media (prefers-reduced-motion: reduce) {\n        .carousel-control-prev,\n        .carousel-control-next {\n            transition: none;\n        }\n    }\n    .carousel-control-prev:hover,\n    .carousel-control-prev:focus,\n    .carousel-control-next:hover,\n    .carousel-control-next:focus {\n        color: #fff;\n        text-decoration: none;\n        outline: 0;\n        opacity: 0.9;\n    }\n\n    .carousel-control-prev {\n        left: 0;\n    }\n\n    .carousel-control-next {\n        right: 0;\n    }\n\n    .carousel-control-prev-icon,\n    .carousel-control-next-icon {\n        display: inline-block;\n        width: 2rem;\n        height: 2rem;\n        background-repeat: no-repeat;\n        background-position: 50%;\n        background-size: 100% 100%;\n    }\n\n    .carousel-control-prev-icon {\n        background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e\")\n            /*rtl:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\")*/;\n    }\n\n    .carousel-control-next-icon {\n        background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\")\n            /*rtl:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e\")*/;\n    }\n\n    .carousel-indicators {\n        position: absolute;\n        right: 0;\n        bottom: 0;\n        left: 0;\n        z-index: 2;\n        display: flex;\n        justify-content: center;\n        padding: 0;\n        margin-right: 15%;\n        margin-bottom: 1rem;\n        margin-left: 15%;\n    }\n    .carousel-indicators [data-bs-target] {\n        box-sizing: content-box;\n        flex: 0 1 auto;\n        width: 30px;\n        height: 3px;\n        padding: 0;\n        margin-right: 3px;\n        margin-left: 3px;\n        text-indent: -999px;\n        cursor: pointer;\n        background-color: #fff;\n        background-clip: padding-box;\n        border: 0;\n        border-top: 10px solid transparent;\n        border-bottom: 10px solid transparent;\n        opacity: 0.5;\n        transition: opacity 0.6s ease;\n    }\n    @media (prefers-reduced-motion: reduce) {\n        .carousel-indicators [data-bs-target] {\n            transition: none;\n        }\n    }\n    .carousel-indicators .active {\n        opacity: 1;\n    }\n\n    .carousel-caption {\n        position: absolute;\n        right: 15%;\n        bottom: 1.25rem;\n        left: 15%;\n        padding-top: 1.25rem;\n        padding-bottom: 1.25rem;\n        color: #fff;\n        text-align: center;\n    }\n\n    .carousel-dark .carousel-control-prev-icon,\n    .carousel-dark .carousel-control-next-icon {\n        filter: invert(1) grayscale(100);\n    }\n    .carousel-dark .carousel-indicators [data-bs-target] {\n        background-color: #000;\n    }\n    .carousel-dark .carousel-caption {\n        color: #000;\n    }\n\n    [data-bs-theme='dark'] .carousel .carousel-control-prev-icon,\n    [data-bs-theme='dark'] .carousel .carousel-control-next-icon,\n    [data-bs-theme='dark'].carousel .carousel-control-prev-icon,\n    [data-bs-theme='dark'].carousel .carousel-control-next-icon {\n        filter: invert(1) grayscale(100);\n    }\n    [data-bs-theme='dark'] .carousel .carousel-indicators [data-bs-target],\n    [data-bs-theme='dark'].carousel .carousel-indicators [data-bs-target] {\n        background-color: #000;\n    }\n    [data-bs-theme='dark'] .carousel .carousel-caption,\n    [data-bs-theme='dark'].carousel .carousel-caption {\n        color: #000;\n    }\n\n    .spinner-grow,\n    .spinner-border {\n        display: inline-block;\n        width: var(--bs-spinner-width);\n        height: var(--bs-spinner-height);\n        vertical-align: var(--bs-spinner-vertical-align);\n        border-radius: 50%;\n        animation: var(--bs-spinner-animation-speed) linear infinite\n            var(--bs-spinner-animation-name);\n    }\n\n    @keyframes spinner-border {\n        to {\n            transform: rotate(360deg) /* rtl:ignore */;\n        }\n    }\n    .spinner-border {\n        --bs-spinner-width: 2rem;\n        --bs-spinner-height: 2rem;\n        --bs-spinner-vertical-align: -0.125em;\n        --bs-spinner-border-width: 0.25em;\n        --bs-spinner-animation-speed: 0.75s;\n        --bs-spinner-animation-name: spinner-border;\n        border: var(--bs-spinner-border-width) solid currentcolor;\n        border-right-color: transparent;\n    }\n\n    .spinner-border-sm {\n        --bs-spinner-width: 1rem;\n        --bs-spinner-height: 1rem;\n        --bs-spinner-border-width: 0.2em;\n    }\n\n    @keyframes spinner-grow {\n        0% {\n            transform: scale(0);\n        }\n        50% {\n            opacity: 1;\n            transform: none;\n        }\n    }\n    .spinner-grow {\n        --bs-spinner-width: 2rem;\n        --bs-spinner-height: 2rem;\n        --bs-spinner-vertical-align: -0.125em;\n        --bs-spinner-animation-speed: 0.75s;\n        --bs-spinner-animation-name: spinner-grow;\n        background-color: currentcolor;\n        opacity: 0;\n    }\n\n    .spinner-grow-sm {\n        --bs-spinner-width: 1rem;\n        --bs-spinner-height: 1rem;\n    }\n\n    @media (prefers-reduced-motion: reduce) {\n        .spinner-border,\n        .spinner-grow {\n            --bs-spinner-animation-speed: 1.5s;\n        }\n    }\n    .offcanvas,\n    .offcanvas-xxl,\n    .offcanvas-xl,\n    .offcanvas-lg,\n    .offcanvas-md,\n    .offcanvas-sm {\n        --bs-offcanvas-zindex: 1045;\n        --bs-offcanvas-width: 400px;\n        --bs-offcanvas-height: 30vh;\n        --bs-offcanvas-padding-x: 1rem;\n        --bs-offcanvas-padding-y: 1rem;\n        --bs-offcanvas-color: var(--bs-body-color);\n        --bs-offcanvas-bg: var(--bs-body-bg);\n        --bs-offcanvas-border-width: var(--bs-border-width);\n        --bs-offcanvas-border-color: var(--bs-border-color-translucent);\n        --bs-offcanvas-box-shadow: var(--bs-box-shadow-sm);\n        --bs-offcanvas-transition: transform 0.3s ease-in-out;\n        --bs-offcanvas-title-line-height: 1.5;\n    }\n\n    @media (max-width: 575.98px) {\n        .offcanvas-sm {\n            position: fixed;\n            bottom: 0;\n            z-index: var(--bs-offcanvas-zindex);\n            display: flex;\n            flex-direction: column;\n            max-width: 100%;\n            color: var(--bs-offcanvas-color);\n            visibility: hidden;\n            background-color: var(--bs-offcanvas-bg);\n            background-clip: padding-box;\n            outline: 0;\n            transition: var(--bs-offcanvas-transition);\n        }\n    }\n    @media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {\n        .offcanvas-sm {\n            transition: none;\n        }\n    }\n    @media (max-width: 575.98px) {\n        .offcanvas-sm.offcanvas-start {\n            top: 0;\n            left: 0;\n            width: var(--bs-offcanvas-width);\n            border-right: var(--bs-offcanvas-border-width) solid\n                var(--bs-offcanvas-border-color);\n            transform: translateX(-100%);\n        }\n        .offcanvas-sm.offcanvas-end {\n            top: 0;\n            right: 0;\n            width: var(--bs-offcanvas-width);\n            border-left: var(--bs-offcanvas-border-width) solid\n                var(--bs-offcanvas-border-color);\n            transform: translateX(100%);\n        }\n        .offcanvas-sm.offcanvas-top {\n            top: 0;\n            right: 0;\n            left: 0;\n            height: var(--bs-offcanvas-height);\n            max-height: 100%;\n            border-bottom: var(--bs-offcanvas-border-width) solid\n                var(--bs-offcanvas-border-color);\n            transform: translateY(-100%);\n        }\n        .offcanvas-sm.offcanvas-bottom {\n            right: 0;\n            left: 0;\n            height: var(--bs-offcanvas-height);\n            max-height: 100%;\n            border-top: var(--bs-offcanvas-border-width) solid\n                var(--bs-offcanvas-border-color);\n            transform: translateY(100%);\n        }\n        .offcanvas-sm.showing,\n        .offcanvas-sm.show:not(.hiding) {\n            transform: none;\n        }\n        .offcanvas-sm.showing,\n        .offcanvas-sm.hiding,\n        .offcanvas-sm.show {\n            visibility: visible;\n        }\n    }\n    @media (min-width: 576px) {\n        .offcanvas-sm {\n            --bs-offcanvas-height: auto;\n            --bs-offcanvas-border-width: 0;\n            background-color: transparent !important;\n        }\n        .offcanvas-sm .offcanvas-header {\n            display: none;\n        }\n        .offcanvas-sm .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n            background-color: transparent !important;\n        }\n    }\n\n    @media (max-width: 767.98px) {\n        .offcanvas-md {\n            position: fixed;\n            bottom: 0;\n            z-index: var(--bs-offcanvas-zindex);\n            display: flex;\n            flex-direction: column;\n            max-width: 100%;\n            color: var(--bs-offcanvas-color);\n            visibility: hidden;\n            background-color: var(--bs-offcanvas-bg);\n            background-clip: padding-box;\n            outline: 0;\n            transition: var(--bs-offcanvas-transition);\n        }\n    }\n    @media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {\n        .offcanvas-md {\n            transition: none;\n        }\n    }\n    @media (max-width: 767.98px) {\n        .offcanvas-md.offcanvas-start {\n            top: 0;\n            left: 0;\n            width: var(--bs-offcanvas-width);\n            border-right: var(--bs-offcanvas-border-width) solid\n                var(--bs-offcanvas-border-color);\n            transform: translateX(-100%);\n        }\n        .offcanvas-md.offcanvas-end {\n            top: 0;\n            right: 0;\n            width: var(--bs-offcanvas-width);\n            border-left: var(--bs-offcanvas-border-width) solid\n                var(--bs-offcanvas-border-color);\n            transform: translateX(100%);\n        }\n        .offcanvas-md.offcanvas-top {\n            top: 0;\n            right: 0;\n            left: 0;\n            height: var(--bs-offcanvas-height);\n            max-height: 100%;\n            border-bottom: var(--bs-offcanvas-border-width) solid\n                var(--bs-offcanvas-border-color);\n            transform: translateY(-100%);\n        }\n        .offcanvas-md.offcanvas-bottom {\n            right: 0;\n            left: 0;\n            height: var(--bs-offcanvas-height);\n            max-height: 100%;\n            border-top: var(--bs-offcanvas-border-width) solid\n                var(--bs-offcanvas-border-color);\n            transform: translateY(100%);\n        }\n        .offcanvas-md.showing,\n        .offcanvas-md.show:not(.hiding) {\n            transform: none;\n        }\n        .offcanvas-md.showing,\n        .offcanvas-md.hiding,\n        .offcanvas-md.show {\n            visibility: visible;\n        }\n    }\n    @media (min-width: 768px) {\n        .offcanvas-md {\n            --bs-offcanvas-height: auto;\n            --bs-offcanvas-border-width: 0;\n            background-color: transparent !important;\n        }\n        .offcanvas-md .offcanvas-header {\n            display: none;\n        }\n        .offcanvas-md .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n            background-color: transparent !important;\n        }\n    }\n\n    @media (max-width: 991.98px) {\n        .offcanvas-lg {\n            position: fixed;\n            bottom: 0;\n            z-index: var(--bs-offcanvas-zindex);\n            display: flex;\n            flex-direction: column;\n            max-width: 100%;\n            color: var(--bs-offcanvas-color);\n            visibility: hidden;\n            background-color: var(--bs-offcanvas-bg);\n            background-clip: padding-box;\n            outline: 0;\n            transition: var(--bs-offcanvas-transition);\n        }\n    }\n    @media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {\n        .offcanvas-lg {\n            transition: none;\n        }\n    }\n    @media (max-width: 991.98px) {\n        .offcanvas-lg.offcanvas-start {\n            top: 0;\n            left: 0;\n            width: var(--bs-offcanvas-width);\n            border-right: var(--bs-offcanvas-border-width) solid\n                var(--bs-offcanvas-border-color);\n            transform: translateX(-100%);\n        }\n        .offcanvas-lg.offcanvas-end {\n            top: 0;\n            right: 0;\n            width: var(--bs-offcanvas-width);\n            border-left: var(--bs-offcanvas-border-width) solid\n                var(--bs-offcanvas-border-color);\n            transform: translateX(100%);\n        }\n        .offcanvas-lg.offcanvas-top {\n            top: 0;\n            right: 0;\n            left: 0;\n            height: var(--bs-offcanvas-height);\n            max-height: 100%;\n            border-bottom: var(--bs-offcanvas-border-width) solid\n                var(--bs-offcanvas-border-color);\n            transform: translateY(-100%);\n        }\n        .offcanvas-lg.offcanvas-bottom {\n            right: 0;\n            left: 0;\n            height: var(--bs-offcanvas-height);\n            max-height: 100%;\n            border-top: var(--bs-offcanvas-border-width) solid\n                var(--bs-offcanvas-border-color);\n            transform: translateY(100%);\n        }\n        .offcanvas-lg.showing,\n        .offcanvas-lg.show:not(.hiding) {\n            transform: none;\n        }\n        .offcanvas-lg.showing,\n        .offcanvas-lg.hiding,\n        .offcanvas-lg.show {\n            visibility: visible;\n        }\n    }\n    @media (min-width: 992px) {\n        .offcanvas-lg {\n            --bs-offcanvas-height: auto;\n            --bs-offcanvas-border-width: 0;\n            background-color: transparent !important;\n        }\n        .offcanvas-lg .offcanvas-header {\n            display: none;\n        }\n        .offcanvas-lg .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n            background-color: transparent !important;\n        }\n    }\n\n    @media (max-width: 1199.98px) {\n        .offcanvas-xl {\n            position: fixed;\n            bottom: 0;\n            z-index: var(--bs-offcanvas-zindex);\n            display: flex;\n            flex-direction: column;\n            max-width: 100%;\n            color: var(--bs-offcanvas-color);\n            visibility: hidden;\n            background-color: var(--bs-offcanvas-bg);\n            background-clip: padding-box;\n            outline: 0;\n            transition: var(--bs-offcanvas-transition);\n        }\n    }\n    @media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {\n        .offcanvas-xl {\n            transition: none;\n        }\n    }\n    @media (max-width: 1199.98px) {\n        .offcanvas-xl.offcanvas-start {\n            top: 0;\n            left: 0;\n            width: var(--bs-offcanvas-width);\n            border-right: var(--bs-offcanvas-border-width) solid\n                var(--bs-offcanvas-border-color);\n            transform: translateX(-100%);\n        }\n        .offcanvas-xl.offcanvas-end {\n            top: 0;\n            right: 0;\n            width: var(--bs-offcanvas-width);\n            border-left: var(--bs-offcanvas-border-width) solid\n                var(--bs-offcanvas-border-color);\n            transform: translateX(100%);\n        }\n        .offcanvas-xl.offcanvas-top {\n            top: 0;\n            right: 0;\n            left: 0;\n            height: var(--bs-offcanvas-height);\n            max-height: 100%;\n            border-bottom: var(--bs-offcanvas-border-width) solid\n                var(--bs-offcanvas-border-color);\n            transform: translateY(-100%);\n        }\n        .offcanvas-xl.offcanvas-bottom {\n            right: 0;\n            left: 0;\n            height: var(--bs-offcanvas-height);\n            max-height: 100%;\n            border-top: var(--bs-offcanvas-border-width) solid\n                var(--bs-offcanvas-border-color);\n            transform: translateY(100%);\n        }\n        .offcanvas-xl.showing,\n        .offcanvas-xl.show:not(.hiding) {\n            transform: none;\n        }\n        .offcanvas-xl.showing,\n        .offcanvas-xl.hiding,\n        .offcanvas-xl.show {\n            visibility: visible;\n        }\n    }\n    @media (min-width: 1200px) {\n        .offcanvas-xl {\n            --bs-offcanvas-height: auto;\n            --bs-offcanvas-border-width: 0;\n            background-color: transparent !important;\n        }\n        .offcanvas-xl .offcanvas-header {\n            display: none;\n        }\n        .offcanvas-xl .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n            background-color: transparent !important;\n        }\n    }\n\n    @media (max-width: 1399.98px) {\n        .offcanvas-xxl {\n            position: fixed;\n            bottom: 0;\n            z-index: var(--bs-offcanvas-zindex);\n            display: flex;\n            flex-direction: column;\n            max-width: 100%;\n            color: var(--bs-offcanvas-color);\n            visibility: hidden;\n            background-color: var(--bs-offcanvas-bg);\n            background-clip: padding-box;\n            outline: 0;\n            transition: var(--bs-offcanvas-transition);\n        }\n    }\n    @media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {\n        .offcanvas-xxl {\n            transition: none;\n        }\n    }\n    @media (max-width: 1399.98px) {\n        .offcanvas-xxl.offcanvas-start {\n            top: 0;\n            left: 0;\n            width: var(--bs-offcanvas-width);\n            border-right: var(--bs-offcanvas-border-width) solid\n                var(--bs-offcanvas-border-color);\n            transform: translateX(-100%);\n        }\n        .offcanvas-xxl.offcanvas-end {\n            top: 0;\n            right: 0;\n            width: var(--bs-offcanvas-width);\n            border-left: var(--bs-offcanvas-border-width) solid\n                var(--bs-offcanvas-border-color);\n            transform: translateX(100%);\n        }\n        .offcanvas-xxl.offcanvas-top {\n            top: 0;\n            right: 0;\n            left: 0;\n            height: var(--bs-offcanvas-height);\n            max-height: 100%;\n            border-bottom: var(--bs-offcanvas-border-width) solid\n                var(--bs-offcanvas-border-color);\n            transform: translateY(-100%);\n        }\n        .offcanvas-xxl.offcanvas-bottom {\n            right: 0;\n            left: 0;\n            height: var(--bs-offcanvas-height);\n            max-height: 100%;\n            border-top: var(--bs-offcanvas-border-width) solid\n                var(--bs-offcanvas-border-color);\n            transform: translateY(100%);\n        }\n        .offcanvas-xxl.showing,\n        .offcanvas-xxl.show:not(.hiding) {\n            transform: none;\n        }\n        .offcanvas-xxl.showing,\n        .offcanvas-xxl.hiding,\n        .offcanvas-xxl.show {\n            visibility: visible;\n        }\n    }\n    @media (min-width: 1400px) {\n        .offcanvas-xxl {\n            --bs-offcanvas-height: auto;\n            --bs-offcanvas-border-width: 0;\n            background-color: transparent !important;\n        }\n        .offcanvas-xxl .offcanvas-header {\n            display: none;\n        }\n        .offcanvas-xxl .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n            background-color: transparent !important;\n        }\n    }\n\n    .offcanvas {\n        position: fixed;\n        bottom: 0;\n        z-index: var(--bs-offcanvas-zindex);\n        display: flex;\n        flex-direction: column;\n        max-width: 100%;\n        color: var(--bs-offcanvas-color);\n        visibility: hidden;\n        background-color: var(--bs-offcanvas-bg);\n        background-clip: padding-box;\n        outline: 0;\n        transition: var(--bs-offcanvas-transition);\n    }\n    @media (prefers-reduced-motion: reduce) {\n        .offcanvas {\n            transition: none;\n        }\n    }\n    .offcanvas.offcanvas-start {\n        top: 0;\n        left: 0;\n        width: var(--bs-offcanvas-width);\n        border-right: var(--bs-offcanvas-border-width) solid\n            var(--bs-offcanvas-border-color);\n        transform: translateX(-100%);\n    }\n    .offcanvas.offcanvas-end {\n        top: 0;\n        right: 0;\n        width: var(--bs-offcanvas-width);\n        border-left: var(--bs-offcanvas-border-width) solid\n            var(--bs-offcanvas-border-color);\n        transform: translateX(100%);\n    }\n    .offcanvas.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--bs-offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--bs-offcanvas-border-width) solid\n            var(--bs-offcanvas-border-color);\n        transform: translateY(-100%);\n    }\n    .offcanvas.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--bs-offcanvas-height);\n        max-height: 100%;\n        border-top: var(--bs-offcanvas-border-width) solid\n            var(--bs-offcanvas-border-color);\n        transform: translateY(100%);\n    }\n    .offcanvas.showing,\n    .offcanvas.show:not(.hiding) {\n        transform: none;\n    }\n    .offcanvas.showing,\n    .offcanvas.hiding,\n    .offcanvas.show {\n        visibility: visible;\n    }\n\n    .offcanvas-backdrop {\n        position: fixed;\n        top: 0;\n        left: 0;\n        z-index: 1040;\n        width: 100vw;\n        height: 100vh;\n        background-color: #000;\n    }\n    .offcanvas-backdrop.fade {\n        opacity: 0;\n    }\n    .offcanvas-backdrop.show {\n        opacity: 0.5;\n    }\n\n    .offcanvas-header {\n        display: flex;\n        align-items: center;\n        padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);\n    }\n    .offcanvas-header .btn-close {\n        padding: calc(var(--bs-offcanvas-padding-y) * 0.5)\n            calc(var(--bs-offcanvas-padding-x) * 0.5);\n        margin: calc(-0.5 * var(--bs-offcanvas-padding-y))\n            calc(-0.5 * var(--bs-offcanvas-padding-x))\n            calc(-0.5 * var(--bs-offcanvas-padding-y)) auto;\n    }\n\n    .offcanvas-title {\n        margin-bottom: 0;\n        line-height: var(--bs-offcanvas-title-line-height);\n    }\n\n    .offcanvas-body {\n        flex-grow: 1;\n        padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);\n        overflow-y: auto;\n    }\n\n    .placeholder {\n        display: inline-block;\n        min-height: 1em;\n        vertical-align: middle;\n        cursor: wait;\n        background-color: currentcolor;\n        opacity: 0.5;\n    }\n    .placeholder.btn::before {\n        display: inline-block;\n        content: '';\n    }\n\n    .placeholder-xs {\n        min-height: 0.6em;\n    }\n\n    .placeholder-sm {\n        min-height: 0.8em;\n    }\n\n    .placeholder-lg {\n        min-height: 1.2em;\n    }\n\n    .placeholder-glow .placeholder {\n        animation: placeholder-glow 2s ease-in-out infinite;\n    }\n\n    @keyframes placeholder-glow {\n        50% {\n            opacity: 0.2;\n        }\n    }\n    .placeholder-wave {\n        -webkit-mask-image: linear-gradient(\n            130deg,\n            #000 55%,\n            rgba(0, 0, 0, 0.8) 75%,\n            #000 95%\n        );\n        mask-image: linear-gradient(\n            130deg,\n            #000 55%,\n            rgba(0, 0, 0, 0.8) 75%,\n            #000 95%\n        );\n        -webkit-mask-size: 200% 100%;\n        mask-size: 200% 100%;\n        animation: placeholder-wave 2s linear infinite;\n    }\n\n    @keyframes placeholder-wave {\n        100% {\n            -webkit-mask-position: -200% 0%;\n            mask-position: -200% 0%;\n        }\n    }\n    .clearfix::after {\n        display: block;\n        clear: both;\n        content: '';\n    }\n\n    .text-bg-primary {\n        color: #fff !important;\n        background-color: RGBA(\n            var(--bs-primary-rgb),\n            var(--bs-bg-opacity, 1)\n        ) !important;\n    }\n\n    .text-bg-secondary {\n        color: #fff !important;\n        background-color: RGBA(\n            var(--bs-secondary-rgb),\n            var(--bs-bg-opacity, 1)\n        ) !important;\n    }\n\n    .text-bg-success {\n        color: #fff !important;\n        background-color: RGBA(\n            var(--bs-success-rgb),\n            var(--bs-bg-opacity, 1)\n        ) !important;\n    }\n\n    .text-bg-info {\n        color: #000 !important;\n        background-color: RGBA(\n            var(--bs-info-rgb),\n            var(--bs-bg-opacity, 1)\n        ) !important;\n    }\n\n    .text-bg-warning {\n        color: #000 !important;\n        background-color: RGBA(\n            var(--bs-warning-rgb),\n            var(--bs-bg-opacity, 1)\n        ) !important;\n    }\n\n    .text-bg-danger {\n        color: #fff !important;\n        background-color: RGBA(\n            var(--bs-danger-rgb),\n            var(--bs-bg-opacity, 1)\n        ) !important;\n    }\n\n    .text-bg-light {\n        color: #000 !important;\n        background-color: RGBA(\n            var(--bs-light-rgb),\n            var(--bs-bg-opacity, 1)\n        ) !important;\n    }\n\n    .text-bg-dark {\n        color: #fff !important;\n        background-color: RGBA(\n            var(--bs-dark-rgb),\n            var(--bs-bg-opacity, 1)\n        ) !important;\n    }\n\n    .link-primary {\n        color: RGBA(\n            var(--bs-primary-rgb),\n            var(--bs-link-opacity, 1)\n        ) !important;\n        -webkit-text-decoration-color: RGBA(\n            var(--bs-primary-rgb),\n            var(--bs-link-underline-opacity, 1)\n        ) !important;\n        text-decoration-color: RGBA(\n            var(--bs-primary-rgb),\n            var(--bs-link-underline-opacity, 1)\n        ) !important;\n    }\n    .link-primary:hover,\n    .link-primary:focus {\n        color: RGBA(10, 88, 202, var(--bs-link-opacity, 1)) !important;\n        -webkit-text-decoration-color: RGBA(\n            10,\n            88,\n            202,\n            var(--bs-link-underline-opacity, 1)\n        ) !important;\n        text-decoration-color: RGBA(\n            10,\n            88,\n            202,\n            var(--bs-link-underline-opacity, 1)\n        ) !important;\n    }\n\n    .link-secondary {\n        color: RGBA(\n            var(--bs-secondary-rgb),\n            var(--bs-link-opacity, 1)\n        ) !important;\n        -webkit-text-decoration-color: RGBA(\n            var(--bs-secondary-rgb),\n            var(--bs-link-underline-opacity, 1)\n        ) !important;\n        text-decoration-color: RGBA(\n            var(--bs-secondary-rgb),\n            var(--bs-link-underline-opacity, 1)\n        ) !important;\n    }\n    .link-secondary:hover,\n    .link-secondary:focus {\n        color: RGBA(86, 94, 100, var(--bs-link-opacity, 1)) !important;\n        -webkit-text-decoration-color: RGBA(\n            86,\n            94,\n            100,\n            var(--bs-link-underline-opacity, 1)\n        ) !important;\n        text-decoration-color: RGBA(\n            86,\n            94,\n            100,\n            var(--bs-link-underline-opacity, 1)\n        ) !important;\n    }\n\n    .link-success {\n        color: RGBA(\n            var(--bs-success-rgb),\n            var(--bs-link-opacity, 1)\n        ) !important;\n        -webkit-text-decoration-color: RGBA(\n            var(--bs-success-rgb),\n            var(--bs-link-underline-opacity, 1)\n        ) !important;\n        text-decoration-color: RGBA(\n            var(--bs-success-rgb),\n            var(--bs-link-underline-opacity, 1)\n        ) !important;\n    }\n    .link-success:hover,\n    .link-success:focus {\n        color: RGBA(20, 108, 67, var(--bs-link-opacity, 1)) !important;\n        -webkit-text-decoration-color: RGBA(\n            20,\n            108,\n            67,\n            var(--bs-link-underline-opacity, 1)\n        ) !important;\n        text-decoration-color: RGBA(\n            20,\n            108,\n            67,\n            var(--bs-link-underline-opacity, 1)\n        ) !important;\n    }\n\n    .link-info {\n        color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;\n        -webkit-text-decoration-color: RGBA(\n            var(--bs-info-rgb),\n            var(--bs-link-underline-opacity, 1)\n        ) !important;\n        text-decoration-color: RGBA(\n            var(--bs-info-rgb),\n            var(--bs-link-underline-opacity, 1)\n        ) !important;\n    }\n    .link-info:hover,\n    .link-info:focus {\n        color: RGBA(61, 213, 243, var(--bs-link-opacity, 1)) !important;\n        -webkit-text-decoration-color: RGBA(\n            61,\n            213,\n            243,\n            var(--bs-link-underline-opacity, 1)\n        ) !important;\n        text-decoration-color: RGBA(\n            61,\n            213,\n            243,\n            var(--bs-link-underline-opacity, 1)\n        ) !important;\n    }\n\n    .link-warning {\n        color: RGBA(\n            var(--bs-warning-rgb),\n            var(--bs-link-opacity, 1)\n        ) !important;\n        -webkit-text-decoration-color: RGBA(\n            var(--bs-warning-rgb),\n            var(--bs-link-underline-opacity, 1)\n        ) !important;\n        text-decoration-color: RGBA(\n            var(--bs-warning-rgb),\n            var(--bs-link-underline-opacity, 1)\n        ) !important;\n    }\n    .link-warning:hover,\n    .link-warning:focus {\n        color: RGBA(255, 205, 57, var(--bs-link-opacity, 1)) !important;\n        -webkit-text-decoration-color: RGBA(\n            255,\n            205,\n            57,\n            var(--bs-link-underline-opacity, 1)\n        ) !important;\n        text-decoration-color: RGBA(\n            255,\n            205,\n            57,\n            var(--bs-link-underline-opacity, 1)\n        ) !important;\n    }\n\n    .link-danger {\n        color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;\n        -webkit-text-decoration-color: RGBA(\n            var(--bs-danger-rgb),\n            var(--bs-link-underline-opacity, 1)\n        ) !important;\n        text-decoration-color: RGBA(\n            var(--bs-danger-rgb),\n            var(--bs-link-underline-opacity, 1)\n        ) !important;\n    }\n    .link-danger:hover,\n    .link-danger:focus {\n        color: RGBA(176, 42, 55, var(--bs-link-opacity, 1)) !important;\n        -webkit-text-decoration-color: RGBA(\n            176,\n            42,\n            55,\n            var(--bs-link-underline-opacity, 1)\n        ) !important;\n        text-decoration-color: RGBA(\n            176,\n            42,\n            55,\n            var(--bs-link-underline-opacity, 1)\n        ) !important;\n    }\n\n    .link-light {\n        color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;\n        -webkit-text-decoration-color: RGBA(\n            var(--bs-light-rgb),\n            var(--bs-link-underline-opacity, 1)\n        ) !important;\n        text-decoration-color: RGBA(\n            var(--bs-light-rgb),\n            var(--bs-link-underline-opacity, 1)\n        ) !important;\n    }\n    .link-light:hover,\n    .link-light:focus {\n        color: RGBA(249, 250, 251, var(--bs-link-opacity, 1)) !important;\n        -webkit-text-decoration-color: RGBA(\n            249,\n            250,\n            251,\n            var(--bs-link-underline-opacity, 1)\n        ) !important;\n        text-decoration-color: RGBA(\n            249,\n            250,\n            251,\n            var(--bs-link-underline-opacity, 1)\n        ) !important;\n    }\n\n    .link-dark {\n        color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;\n        -webkit-text-decoration-color: RGBA(\n            var(--bs-dark-rgb),\n            var(--bs-link-underline-opacity, 1)\n        ) !important;\n        text-decoration-color: RGBA(\n            var(--bs-dark-rgb),\n            var(--bs-link-underline-opacity, 1)\n        ) !important;\n    }\n    .link-dark:hover,\n    .link-dark:focus {\n        color: RGBA(26, 30, 33, var(--bs-link-opacity, 1)) !important;\n        -webkit-text-decoration-color: RGBA(\n            26,\n            30,\n            33,\n            var(--bs-link-underline-opacity, 1)\n        ) !important;\n        text-decoration-color: RGBA(\n            26,\n            30,\n            33,\n            var(--bs-link-underline-opacity, 1)\n        ) !important;\n    }\n\n    .link-body-emphasis {\n        color: RGBA(\n            var(--bs-emphasis-color-rgb),\n            var(--bs-link-opacity, 1)\n        ) !important;\n        -webkit-text-decoration-color: RGBA(\n            var(--bs-emphasis-color-rgb),\n            var(--bs-link-underline-opacity, 1)\n        ) !important;\n        text-decoration-color: RGBA(\n            var(--bs-emphasis-color-rgb),\n            var(--bs-link-underline-opacity, 1)\n        ) !important;\n    }\n    .link-body-emphasis:hover,\n    .link-body-emphasis:focus {\n        color: RGBA(\n            var(--bs-emphasis-color-rgb),\n            var(--bs-link-opacity, 0.75)\n        ) !important;\n        -webkit-text-decoration-color: RGBA(\n            var(--bs-emphasis-color-rgb),\n            var(--bs-link-underline-opacity, 0.75)\n        ) !important;\n        text-decoration-color: RGBA(\n            var(--bs-emphasis-color-rgb),\n            var(--bs-link-underline-opacity, 0.75)\n        ) !important;\n    }\n\n    .focus-ring:focus {\n        outline: 0;\n        box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0)\n            var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width)\n            var(--bs-focus-ring-color);\n    }\n\n    .icon-link {\n        display: inline-flex;\n        gap: 0.375rem;\n        align-items: center;\n        -webkit-text-decoration-color: rgba(\n            var(--bs-link-color-rgb),\n            var(--bs-link-opacity, 0.5)\n        );\n        text-decoration-color: rgba(\n            var(--bs-link-color-rgb),\n            var(--bs-link-opacity, 0.5)\n        );\n        text-underline-offset: 0.25em;\n        -webkit-backface-visibility: hidden;\n        backface-visibility: hidden;\n    }\n    .icon-link > .bi {\n        flex-shrink: 0;\n        width: 1em;\n        height: 1em;\n        fill: currentcolor;\n        transition: 0.2s ease-in-out transform;\n    }\n    @media (prefers-reduced-motion: reduce) {\n        .icon-link > .bi {\n            transition: none;\n        }\n    }\n\n    .icon-link-hover:hover > .bi,\n    .icon-link-hover:focus-visible > .bi {\n        transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0));\n    }\n\n    .ratio {\n        position: relative;\n        width: 100%;\n    }\n    .ratio::before {\n        display: block;\n        padding-top: var(--bs-aspect-ratio);\n        content: '';\n    }\n    .ratio > * {\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n    }\n\n    .ratio-1x1 {\n        --bs-aspect-ratio: 100%;\n    }\n\n    .ratio-4x3 {\n        --bs-aspect-ratio: 75%;\n    }\n\n    .ratio-16x9 {\n        --bs-aspect-ratio: 56.25%;\n    }\n\n    .ratio-21x9 {\n        --bs-aspect-ratio: 42.8571428571%;\n    }\n\n    .fixed-top {\n        position: fixed;\n        top: 0;\n        right: 0;\n        left: 0;\n        z-index: 1030;\n    }\n\n    .fixed-bottom {\n        position: fixed;\n        right: 0;\n        bottom: 0;\n        left: 0;\n        z-index: 1030;\n    }\n\n    .sticky-top {\n        position: -webkit-sticky;\n        position: sticky;\n        top: 0;\n        z-index: 1020;\n    }\n\n    .sticky-bottom {\n        position: -webkit-sticky;\n        position: sticky;\n        bottom: 0;\n        z-index: 1020;\n    }\n\n    @media (min-width: 576px) {\n        .sticky-sm-top {\n            position: -webkit-sticky;\n            position: sticky;\n            top: 0;\n            z-index: 1020;\n        }\n        .sticky-sm-bottom {\n            position: -webkit-sticky;\n            position: sticky;\n            bottom: 0;\n            z-index: 1020;\n        }\n    }\n    @media (min-width: 768px) {\n        .sticky-md-top {\n            position: -webkit-sticky;\n            position: sticky;\n            top: 0;\n            z-index: 1020;\n        }\n        .sticky-md-bottom {\n            position: -webkit-sticky;\n            position: sticky;\n            bottom: 0;\n            z-index: 1020;\n        }\n    }\n    @media (min-width: 992px) {\n        .sticky-lg-top {\n            position: -webkit-sticky;\n            position: sticky;\n            top: 0;\n            z-index: 1020;\n        }\n        .sticky-lg-bottom {\n            position: -webkit-sticky;\n            position: sticky;\n            bottom: 0;\n            z-index: 1020;\n        }\n    }\n    @media (min-width: 1200px) {\n        .sticky-xl-top {\n            position: -webkit-sticky;\n            position: sticky;\n            top: 0;\n            z-index: 1020;\n        }\n        .sticky-xl-bottom {\n            position: -webkit-sticky;\n            position: sticky;\n            bottom: 0;\n            z-index: 1020;\n        }\n    }\n    @media (min-width: 1400px) {\n        .sticky-xxl-top {\n            position: -webkit-sticky;\n            position: sticky;\n            top: 0;\n            z-index: 1020;\n        }\n        .sticky-xxl-bottom {\n            position: -webkit-sticky;\n            position: sticky;\n            bottom: 0;\n            z-index: 1020;\n        }\n    }\n    .hstack {\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        align-self: stretch;\n    }\n\n    .vstack {\n        display: flex;\n        flex: 1 1 auto;\n        flex-direction: column;\n        align-self: stretch;\n    }\n\n    .visually-hidden,\n    .visually-hidden-focusable:not(:focus):not(:focus-within) {\n        width: 1px !important;\n        height: 1px !important;\n        padding: 0 !important;\n        margin: -1px !important;\n        overflow: hidden !important;\n        clip: rect(0, 0, 0, 0) !important;\n        white-space: nowrap !important;\n        border: 0 !important;\n    }\n    .visually-hidden:not(caption),\n    .visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {\n        position: absolute !important;\n    }\n\n    .stretched-link::after {\n        position: absolute;\n        top: 0;\n        right: 0;\n        bottom: 0;\n        left: 0;\n        z-index: 1;\n        content: '';\n    }\n\n    .text-truncate {\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n    }\n\n    .vr {\n        display: inline-block;\n        align-self: stretch;\n        width: var(--bs-border-width);\n        min-height: 1em;\n        background-color: currentcolor;\n        opacity: 0.25;\n    }\n\n    .align-baseline {\n        vertical-align: baseline !important;\n    }\n\n    .align-top {\n        vertical-align: top !important;\n    }\n\n    .align-middle {\n        vertical-align: middle !important;\n    }\n\n    .align-bottom {\n        vertical-align: bottom !important;\n    }\n\n    .align-text-bottom {\n        vertical-align: text-bottom !important;\n    }\n\n    .align-text-top {\n        vertical-align: text-top !important;\n    }\n\n    .float-start {\n        float: left !important;\n    }\n\n    .float-end {\n        float: right !important;\n    }\n\n    .float-none {\n        float: none !important;\n    }\n\n    .object-fit-contain {\n        -o-object-fit: contain !important;\n        object-fit: contain !important;\n    }\n\n    .object-fit-cover {\n        -o-object-fit: cover !important;\n        object-fit: cover !important;\n    }\n\n    .object-fit-fill {\n        -o-object-fit: fill !important;\n        object-fit: fill !important;\n    }\n\n    .object-fit-scale {\n        -o-object-fit: scale-down !important;\n        object-fit: scale-down !important;\n    }\n\n    .object-fit-none {\n        -o-object-fit: none !important;\n        object-fit: none !important;\n    }\n\n    .opacity-0 {\n        opacity: 0 !important;\n    }\n\n    .opacity-25 {\n        opacity: 0.25 !important;\n    }\n\n    .opacity-50 {\n        opacity: 0.5 !important;\n    }\n\n    .opacity-75 {\n        opacity: 0.75 !important;\n    }\n\n    .opacity-100 {\n        opacity: 1 !important;\n    }\n\n    .overflow-auto {\n        overflow: auto !important;\n    }\n\n    .overflow-hidden {\n        overflow: hidden !important;\n    }\n\n    .overflow-visible {\n        overflow: visible !important;\n    }\n\n    .overflow-scroll {\n        overflow: scroll !important;\n    }\n\n    .overflow-x-auto {\n        overflow-x: auto !important;\n    }\n\n    .overflow-x-hidden {\n        overflow-x: hidden !important;\n    }\n\n    .overflow-x-visible {\n        overflow-x: visible !important;\n    }\n\n    .overflow-x-scroll {\n        overflow-x: scroll !important;\n    }\n\n    .overflow-y-auto {\n        overflow-y: auto !important;\n    }\n\n    .overflow-y-hidden {\n        overflow-y: hidden !important;\n    }\n\n    .overflow-y-visible {\n        overflow-y: visible !important;\n    }\n\n    .overflow-y-scroll {\n        overflow-y: scroll !important;\n    }\n\n    .d-inline {\n        display: inline !important;\n    }\n\n    .d-inline-block {\n        display: inline-block !important;\n    }\n\n    .d-block {\n        display: block !important;\n    }\n\n    .d-grid {\n        display: grid !important;\n    }\n\n    .d-inline-grid {\n        display: inline-grid !important;\n    }\n\n    .d-table {\n        display: table !important;\n    }\n\n    .d-table-row {\n        display: table-row !important;\n    }\n\n    .d-table-cell {\n        display: table-cell !important;\n    }\n\n    .d-flex {\n        display: flex !important;\n    }\n\n    .d-inline-flex {\n        display: inline-flex !important;\n    }\n\n    .d-none {\n        display: none !important;\n    }\n\n    .shadow {\n        box-shadow: var(--bs-box-shadow) !important;\n    }\n\n    .shadow-sm {\n        box-shadow: var(--bs-box-shadow-sm) !important;\n    }\n\n    .shadow-lg {\n        box-shadow: var(--bs-box-shadow-lg) !important;\n    }\n\n    .shadow-none {\n        box-shadow: none !important;\n    }\n\n    .focus-ring-primary {\n        --bs-focus-ring-color: rgba(\n            var(--bs-primary-rgb),\n            var(--bs-focus-ring-opacity)\n        );\n    }\n\n    .focus-ring-secondary {\n        --bs-focus-ring-color: rgba(\n            var(--bs-secondary-rgb),\n            var(--bs-focus-ring-opacity)\n        );\n    }\n\n    .focus-ring-success {\n        --bs-focus-ring-color: rgba(\n            var(--bs-success-rgb),\n            var(--bs-focus-ring-opacity)\n        );\n    }\n\n    .focus-ring-info {\n        --bs-focus-ring-color: rgba(\n            var(--bs-info-rgb),\n            var(--bs-focus-ring-opacity)\n        );\n    }\n\n    .focus-ring-warning {\n        --bs-focus-ring-color: rgba(\n            var(--bs-warning-rgb),\n            var(--bs-focus-ring-opacity)\n        );\n    }\n\n    .focus-ring-danger {\n        --bs-focus-ring-color: rgba(\n            var(--bs-danger-rgb),\n            var(--bs-focus-ring-opacity)\n        );\n    }\n\n    .focus-ring-light {\n        --bs-focus-ring-color: rgba(\n            var(--bs-light-rgb),\n            var(--bs-focus-ring-opacity)\n        );\n    }\n\n    .focus-ring-dark {\n        --bs-focus-ring-color: rgba(\n            var(--bs-dark-rgb),\n            var(--bs-focus-ring-opacity)\n        );\n    }\n\n    .position-static {\n        position: static !important;\n    }\n\n    .position-relative {\n        position: relative !important;\n    }\n\n    .position-absolute {\n        position: absolute !important;\n    }\n\n    .position-fixed {\n        position: fixed !important;\n    }\n\n    .position-sticky {\n        position: -webkit-sticky !important;\n        position: sticky !important;\n    }\n\n    .top-0 {\n        top: 0 !important;\n    }\n\n    .top-50 {\n        top: 50% !important;\n    }\n\n    .top-100 {\n        top: 100% !important;\n    }\n\n    .bottom-0 {\n        bottom: 0 !important;\n    }\n\n    .bottom-50 {\n        bottom: 50% !important;\n    }\n\n    .bottom-100 {\n        bottom: 100% !important;\n    }\n\n    .start-0 {\n        left: 0 !important;\n    }\n\n    .start-50 {\n        left: 50% !important;\n    }\n\n    .start-100 {\n        left: 100% !important;\n    }\n\n    .end-0 {\n        right: 0 !important;\n    }\n\n    .end-50 {\n        right: 50% !important;\n    }\n\n    .end-100 {\n        right: 100% !important;\n    }\n\n    .translate-middle {\n        transform: translate(-50%, -50%) !important;\n    }\n\n    .translate-middle-x {\n        transform: translateX(-50%) !important;\n    }\n\n    .translate-middle-y {\n        transform: translateY(-50%) !important;\n    }\n\n    .border {\n        border: var(--bs-border-width) var(--bs-border-style)\n            var(--bs-border-color) !important;\n    }\n\n    .border-0 {\n        border: 0 !important;\n    }\n\n    .border-top {\n        border-top: var(--bs-border-width) var(--bs-border-style)\n            var(--bs-border-color) !important;\n    }\n\n    .border-top-0 {\n        border-top: 0 !important;\n    }\n\n    .border-end {\n        border-right: var(--bs-border-width) var(--bs-border-style)\n            var(--bs-border-color) !important;\n    }\n\n    .border-end-0 {\n        border-right: 0 !important;\n    }\n\n    .border-bottom {\n        border-bottom: var(--bs-border-width) var(--bs-border-style)\n            var(--bs-border-color) !important;\n    }\n\n    .border-bottom-0 {\n        border-bottom: 0 !important;\n    }\n\n    .border-start {\n        border-left: var(--bs-border-width) var(--bs-border-style)\n            var(--bs-border-color) !important;\n    }\n\n    .border-start-0 {\n        border-left: 0 !important;\n    }\n\n    .border-primary {\n        --bs-border-opacity: 1;\n        border-color: rgba(\n            var(--bs-primary-rgb),\n            var(--bs-border-opacity)\n        ) !important;\n    }\n\n    .border-secondary {\n        --bs-border-opacity: 1;\n        border-color: rgba(\n            var(--bs-secondary-rgb),\n            var(--bs-border-opacity)\n        ) !important;\n    }\n\n    .border-success {\n        --bs-border-opacity: 1;\n        border-color: rgba(\n            var(--bs-success-rgb),\n            var(--bs-border-opacity)\n        ) !important;\n    }\n\n    .border-info {\n        --bs-border-opacity: 1;\n        border-color: rgba(\n            var(--bs-info-rgb),\n            var(--bs-border-opacity)\n        ) !important;\n    }\n\n    .border-warning {\n        --bs-border-opacity: 1;\n        border-color: rgba(\n            var(--bs-warning-rgb),\n            var(--bs-border-opacity)\n        ) !important;\n    }\n\n    .border-danger {\n        --bs-border-opacity: 1;\n        border-color: rgba(\n            var(--bs-danger-rgb),\n            var(--bs-border-opacity)\n        ) !important;\n    }\n\n    .border-light {\n        --bs-border-opacity: 1;\n        border-color: rgba(\n            var(--bs-light-rgb),\n            var(--bs-border-opacity)\n        ) !important;\n    }\n\n    .border-dark {\n        --bs-border-opacity: 1;\n        border-color: rgba(\n            var(--bs-dark-rgb),\n            var(--bs-border-opacity)\n        ) !important;\n    }\n\n    .border-black {\n        --bs-border-opacity: 1;\n        border-color: rgba(\n            var(--bs-black-rgb),\n            var(--bs-border-opacity)\n        ) !important;\n    }\n\n    .border-white {\n        --bs-border-opacity: 1;\n        border-color: rgba(\n            var(--bs-white-rgb),\n            var(--bs-border-opacity)\n        ) !important;\n    }\n\n    .border-primary-subtle {\n        border-color: var(--bs-primary-border-subtle) !important;\n    }\n\n    .border-secondary-subtle {\n        border-color: var(--bs-secondary-border-subtle) !important;\n    }\n\n    .border-success-subtle {\n        border-color: var(--bs-success-border-subtle) !important;\n    }\n\n    .border-info-subtle {\n        border-color: var(--bs-info-border-subtle) !important;\n    }\n\n    .border-warning-subtle {\n        border-color: var(--bs-warning-border-subtle) !important;\n    }\n\n    .border-danger-subtle {\n        border-color: var(--bs-danger-border-subtle) !important;\n    }\n\n    .border-light-subtle {\n        border-color: var(--bs-light-border-subtle) !important;\n    }\n\n    .border-dark-subtle {\n        border-color: var(--bs-dark-border-subtle) !important;\n    }\n\n    .border-1 {\n        border-width: 1px !important;\n    }\n\n    .border-2 {\n        border-width: 2px !important;\n    }\n\n    .border-3 {\n        border-width: 3px !important;\n    }\n\n    .border-4 {\n        border-width: 4px !important;\n    }\n\n    .border-5 {\n        border-width: 5px !important;\n    }\n\n    .border-opacity-10 {\n        --bs-border-opacity: 0.1;\n    }\n\n    .border-opacity-25 {\n        --bs-border-opacity: 0.25;\n    }\n\n    .border-opacity-50 {\n        --bs-border-opacity: 0.5;\n    }\n\n    .border-opacity-75 {\n        --bs-border-opacity: 0.75;\n    }\n\n    .border-opacity-100 {\n        --bs-border-opacity: 1;\n    }\n\n    .w-25 {\n        width: 25% !important;\n    }\n\n    .w-50 {\n        width: 50% !important;\n    }\n\n    .w-75 {\n        width: 75% !important;\n    }\n\n    .w-100 {\n        width: 100% !important;\n    }\n\n    .w-auto {\n        width: auto !important;\n    }\n\n    .mw-100 {\n        max-width: 100% !important;\n    }\n\n    .vw-100 {\n        width: 100vw !important;\n    }\n\n    .min-vw-100 {\n        min-width: 100vw !important;\n    }\n\n    .h-25 {\n        height: 25% !important;\n    }\n\n    .h-50 {\n        height: 50% !important;\n    }\n\n    .h-75 {\n        height: 75% !important;\n    }\n\n    .h-100 {\n        height: 100% !important;\n    }\n\n    .h-auto {\n        height: auto !important;\n    }\n\n    .mh-100 {\n        max-height: 100% !important;\n    }\n\n    .vh-100 {\n        height: 100vh !important;\n    }\n\n    .min-vh-100 {\n        min-height: 100vh !important;\n    }\n\n    .flex-fill {\n        flex: 1 1 auto !important;\n    }\n\n    .flex-row {\n        flex-direction: row !important;\n    }\n\n    .flex-column {\n        flex-direction: column !important;\n    }\n\n    .flex-row-reverse {\n        flex-direction: row-reverse !important;\n    }\n\n    .flex-column-reverse {\n        flex-direction: column-reverse !important;\n    }\n\n    .flex-grow-0 {\n        flex-grow: 0 !important;\n    }\n\n    .flex-grow-1 {\n        flex-grow: 1 !important;\n    }\n\n    .flex-shrink-0 {\n        flex-shrink: 0 !important;\n    }\n\n    .flex-shrink-1 {\n        flex-shrink: 1 !important;\n    }\n\n    .flex-wrap {\n        flex-wrap: wrap !important;\n    }\n\n    .flex-nowrap {\n        flex-wrap: nowrap !important;\n    }\n\n    .flex-wrap-reverse {\n        flex-wrap: wrap-reverse !important;\n    }\n\n    .justify-content-start {\n        justify-content: flex-start !important;\n    }\n\n    .justify-content-end {\n        justify-content: flex-end !important;\n    }\n\n    .justify-content-center {\n        justify-content: center !important;\n    }\n\n    .justify-content-between {\n        justify-content: space-between !important;\n    }\n\n    .justify-content-around {\n        justify-content: space-around !important;\n    }\n\n    .justify-content-evenly {\n        justify-content: space-evenly !important;\n    }\n\n    .align-items-start {\n        align-items: flex-start !important;\n    }\n\n    .align-items-end {\n        align-items: flex-end !important;\n    }\n\n    .align-items-center {\n        align-items: center !important;\n    }\n\n    .align-items-baseline {\n        align-items: baseline !important;\n    }\n\n    .align-items-stretch {\n        align-items: stretch !important;\n    }\n\n    .align-content-start {\n        align-content: flex-start !important;\n    }\n\n    .align-content-end {\n        align-content: flex-end !important;\n    }\n\n    .align-content-center {\n        align-content: center !important;\n    }\n\n    .align-content-between {\n        align-content: space-between !important;\n    }\n\n    .align-content-around {\n        align-content: space-around !important;\n    }\n\n    .align-content-stretch {\n        align-content: stretch !important;\n    }\n\n    .align-self-auto {\n        align-self: auto !important;\n    }\n\n    .align-self-start {\n        align-self: flex-start !important;\n    }\n\n    .align-self-end {\n        align-self: flex-end !important;\n    }\n\n    .align-self-center {\n        align-self: center !important;\n    }\n\n    .align-self-baseline {\n        align-self: baseline !important;\n    }\n\n    .align-self-stretch {\n        align-self: stretch !important;\n    }\n\n    .order-first {\n        order: -1 !important;\n    }\n\n    .order-0 {\n        order: 0 !important;\n    }\n\n    .order-1 {\n        order: 1 !important;\n    }\n\n    .order-2 {\n        order: 2 !important;\n    }\n\n    .order-3 {\n        order: 3 !important;\n    }\n\n    .order-4 {\n        order: 4 !important;\n    }\n\n    .order-5 {\n        order: 5 !important;\n    }\n\n    .order-last {\n        order: 6 !important;\n    }\n\n    .m-0 {\n        margin: 0 !important;\n    }\n\n    .m-1 {\n        margin: 0.25rem !important;\n    }\n\n    .m-2 {\n        margin: 0.5rem !important;\n    }\n\n    .m-3 {\n        margin: 1rem !important;\n    }\n\n    .m-4 {\n        margin: 1.5rem !important;\n    }\n\n    .m-5 {\n        margin: 3rem !important;\n    }\n\n    .m-auto {\n        margin: auto !important;\n    }\n\n    .mx-0 {\n        margin-right: 0 !important;\n        margin-left: 0 !important;\n    }\n\n    .mx-1 {\n        margin-right: 0.25rem !important;\n        margin-left: 0.25rem !important;\n    }\n\n    .mx-2 {\n        margin-right: 0.5rem !important;\n        margin-left: 0.5rem !important;\n    }\n\n    .mx-3 {\n        margin-right: 1rem !important;\n        margin-left: 1rem !important;\n    }\n\n    .mx-4 {\n        margin-right: 1.5rem !important;\n        margin-left: 1.5rem !important;\n    }\n\n    .mx-5 {\n        margin-right: 3rem !important;\n        margin-left: 3rem !important;\n    }\n\n    .mx-auto {\n        margin-right: auto !important;\n        margin-left: auto !important;\n    }\n\n    .my-0 {\n        margin-top: 0 !important;\n        margin-bottom: 0 !important;\n    }\n\n    .my-1 {\n        margin-top: 0.25rem !important;\n        margin-bottom: 0.25rem !important;\n    }\n\n    .my-2 {\n        margin-top: 0.5rem !important;\n        margin-bottom: 0.5rem !important;\n    }\n\n    .my-3 {\n        margin-top: 1rem !important;\n        margin-bottom: 1rem !important;\n    }\n\n    .my-4 {\n        margin-top: 1.5rem !important;\n        margin-bottom: 1.5rem !important;\n    }\n\n    .my-5 {\n        margin-top: 3rem !important;\n        margin-bottom: 3rem !important;\n    }\n\n    .my-auto {\n        margin-top: auto !important;\n        margin-bottom: auto !important;\n    }\n\n    .mt-0 {\n        margin-top: 0 !important;\n    }\n\n    .mt-1 {\n        margin-top: 0.25rem !important;\n    }\n\n    .mt-2 {\n        margin-top: 0.5rem !important;\n    }\n\n    .mt-3 {\n        margin-top: 1rem !important;\n    }\n\n    .mt-4 {\n        margin-top: 1.5rem !important;\n    }\n\n    .mt-5 {\n        margin-top: 3rem !important;\n    }\n\n    .mt-auto {\n        margin-top: auto !important;\n    }\n\n    .me-0 {\n        margin-right: 0 !important;\n    }\n\n    .me-1 {\n        margin-right: 0.25rem !important;\n    }\n\n    .me-2 {\n        margin-right: 0.5rem !important;\n    }\n\n    .me-3 {\n        margin-right: 1rem !important;\n    }\n\n    .me-4 {\n        margin-right: 1.5rem !important;\n    }\n\n    .me-5 {\n        margin-right: 3rem !important;\n    }\n\n    .me-auto {\n        margin-right: auto !important;\n    }\n\n    .mb-0 {\n        margin-bottom: 0 !important;\n    }\n\n    .mb-1 {\n        margin-bottom: 0.25rem !important;\n    }\n\n    .mb-2 {\n        margin-bottom: 0.5rem !important;\n    }\n\n    .mb-3 {\n        margin-bottom: 1rem !important;\n    }\n\n    .mb-4 {\n        margin-bottom: 1.5rem !important;\n    }\n\n    .mb-5 {\n        margin-bottom: 3rem !important;\n    }\n\n    .mb-auto {\n        margin-bottom: auto !important;\n    }\n\n    .ms-0 {\n        margin-left: 0 !important;\n    }\n\n    .ms-1 {\n        margin-left: 0.25rem !important;\n    }\n\n    .ms-2 {\n        margin-left: 0.5rem !important;\n    }\n\n    .ms-3 {\n        margin-left: 1rem !important;\n    }\n\n    .ms-4 {\n        margin-left: 1.5rem !important;\n    }\n\n    .ms-5 {\n        margin-left: 3rem !important;\n    }\n\n    .ms-auto {\n        margin-left: auto !important;\n    }\n\n    .p-0 {\n        padding: 0 !important;\n    }\n\n    .p-1 {\n        padding: 0.25rem !important;\n    }\n\n    .p-2 {\n        padding: 0.5rem !important;\n    }\n\n    .p-3 {\n        padding: 1rem !important;\n    }\n\n    .p-4 {\n        padding: 1.5rem !important;\n    }\n\n    .p-5 {\n        padding: 3rem !important;\n    }\n\n    .px-0 {\n        padding-right: 0 !important;\n        padding-left: 0 !important;\n    }\n\n    .px-1 {\n        padding-right: 0.25rem !important;\n        padding-left: 0.25rem !important;\n    }\n\n    .px-2 {\n        padding-right: 0.5rem !important;\n        padding-left: 0.5rem !important;\n    }\n\n    .px-3 {\n        padding-right: 1rem !important;\n        padding-left: 1rem !important;\n    }\n\n    .px-4 {\n        padding-right: 1.5rem !important;\n        padding-left: 1.5rem !important;\n    }\n\n    .px-5 {\n        padding-right: 3rem !important;\n        padding-left: 3rem !important;\n    }\n\n    .py-0 {\n        padding-top: 0 !important;\n        padding-bottom: 0 !important;\n    }\n\n    .py-1 {\n        padding-top: 0.25rem !important;\n        padding-bottom: 0.25rem !important;\n    }\n\n    .py-2 {\n        padding-top: 0.5rem !important;\n        padding-bottom: 0.5rem !important;\n    }\n\n    .py-3 {\n        padding-top: 1rem !important;\n        padding-bottom: 1rem !important;\n    }\n\n    .py-4 {\n        padding-top: 1.5rem !important;\n        padding-bottom: 1.5rem !important;\n    }\n\n    .py-5 {\n        padding-top: 3rem !important;\n        padding-bottom: 3rem !important;\n    }\n\n    .pt-0 {\n        padding-top: 0 !important;\n    }\n\n    .pt-1 {\n        padding-top: 0.25rem !important;\n    }\n\n    .pt-2 {\n        padding-top: 0.5rem !important;\n    }\n\n    .pt-3 {\n        padding-top: 1rem !important;\n    }\n\n    .pt-4 {\n        padding-top: 1.5rem !important;\n    }\n\n    .pt-5 {\n        padding-top: 3rem !important;\n    }\n\n    .pe-0 {\n        padding-right: 0 !important;\n    }\n\n    .pe-1 {\n        padding-right: 0.25rem !important;\n    }\n\n    .pe-2 {\n        padding-right: 0.5rem !important;\n    }\n\n    .pe-3 {\n        padding-right: 1rem !important;\n    }\n\n    .pe-4 {\n        padding-right: 1.5rem !important;\n    }\n\n    .pe-5 {\n        padding-right: 3rem !important;\n    }\n\n    .pb-0 {\n        padding-bottom: 0 !important;\n    }\n\n    .pb-1 {\n        padding-bottom: 0.25rem !important;\n    }\n\n    .pb-2 {\n        padding-bottom: 0.5rem !important;\n    }\n\n    .pb-3 {\n        padding-bottom: 1rem !important;\n    }\n\n    .pb-4 {\n        padding-bottom: 1.5rem !important;\n    }\n\n    .pb-5 {\n        padding-bottom: 3rem !important;\n    }\n\n    .ps-0 {\n        padding-left: 0 !important;\n    }\n\n    .ps-1 {\n        padding-left: 0.25rem !important;\n    }\n\n    .ps-2 {\n        padding-left: 0.5rem !important;\n    }\n\n    .ps-3 {\n        padding-left: 1rem !important;\n    }\n\n    .ps-4 {\n        padding-left: 1.5rem !important;\n    }\n\n    .ps-5 {\n        padding-left: 3rem !important;\n    }\n\n    .gap-0 {\n        gap: 0 !important;\n    }\n\n    .gap-1 {\n        gap: 0.25rem !important;\n    }\n\n    .gap-2 {\n        gap: 0.5rem !important;\n    }\n\n    .gap-3 {\n        gap: 1rem !important;\n    }\n\n    .gap-4 {\n        gap: 1.5rem !important;\n    }\n\n    .gap-5 {\n        gap: 3rem !important;\n    }\n\n    .row-gap-0 {\n        row-gap: 0 !important;\n    }\n\n    .row-gap-1 {\n        row-gap: 0.25rem !important;\n    }\n\n    .row-gap-2 {\n        row-gap: 0.5rem !important;\n    }\n\n    .row-gap-3 {\n        row-gap: 1rem !important;\n    }\n\n    .row-gap-4 {\n        row-gap: 1.5rem !important;\n    }\n\n    .row-gap-5 {\n        row-gap: 3rem !important;\n    }\n\n    .column-gap-0 {\n        -moz-column-gap: 0 !important;\n        column-gap: 0 !important;\n    }\n\n    .column-gap-1 {\n        -moz-column-gap: 0.25rem !important;\n        column-gap: 0.25rem !important;\n    }\n\n    .column-gap-2 {\n        -moz-column-gap: 0.5rem !important;\n        column-gap: 0.5rem !important;\n    }\n\n    .column-gap-3 {\n        -moz-column-gap: 1rem !important;\n        column-gap: 1rem !important;\n    }\n\n    .column-gap-4 {\n        -moz-column-gap: 1.5rem !important;\n        column-gap: 1.5rem !important;\n    }\n\n    .column-gap-5 {\n        -moz-column-gap: 3rem !important;\n        column-gap: 3rem !important;\n    }\n\n    .font-monospace {\n        font-family: var(--bs-font-monospace) !important;\n    }\n\n    .fs-1 {\n        font-size: calc(1.375rem + 1.5vw) !important;\n    }\n\n    .fs-2 {\n        font-size: calc(1.325rem + 0.9vw) !important;\n    }\n\n    .fs-3 {\n        font-size: calc(1.3rem + 0.6vw) !important;\n    }\n\n    .fs-4 {\n        font-size: calc(1.275rem + 0.3vw) !important;\n    }\n\n    .fs-5 {\n        font-size: 1.25rem !important;\n    }\n\n    .fs-6 {\n        font-size: 1rem !important;\n    }\n\n    .fst-italic {\n        font-style: italic !important;\n    }\n\n    .fst-normal {\n        font-style: normal !important;\n    }\n\n    .fw-lighter {\n        font-weight: lighter !important;\n    }\n\n    .fw-light {\n        font-weight: 300 !important;\n    }\n\n    .fw-normal {\n        font-weight: 400 !important;\n    }\n\n    .fw-medium {\n        font-weight: 500 !important;\n    }\n\n    .fw-semibold {\n        font-weight: 600 !important;\n    }\n\n    .fw-bold {\n        font-weight: 700 !important;\n    }\n\n    .fw-bolder {\n        font-weight: bolder !important;\n    }\n\n    .lh-1 {\n        line-height: 1 !important;\n    }\n\n    .lh-sm {\n        line-height: 1.25 !important;\n    }\n\n    .lh-base {\n        line-height: 1.5 !important;\n    }\n\n    .lh-lg {\n        line-height: 2 !important;\n    }\n\n    .text-start {\n        text-align: left !important;\n    }\n\n    .text-end {\n        text-align: right !important;\n    }\n\n    .text-center {\n        text-align: center !important;\n    }\n\n    .text-decoration-none {\n        text-decoration: none !important;\n    }\n\n    .text-decoration-underline {\n        text-decoration: underline !important;\n    }\n\n    .text-decoration-line-through {\n        text-decoration: line-through !important;\n    }\n\n    .text-lowercase {\n        text-transform: lowercase !important;\n    }\n\n    .text-uppercase {\n        text-transform: uppercase !important;\n    }\n\n    .text-capitalize {\n        text-transform: capitalize !important;\n    }\n\n    .text-wrap {\n        white-space: normal !important;\n    }\n\n    .text-nowrap {\n        white-space: nowrap !important;\n    }\n\n    /* rtl:begin:remove */\n    .text-break {\n        word-wrap: break-word !important;\n        word-break: break-word !important;\n    }\n\n    /* rtl:end:remove */\n    .text-primary {\n        --bs-text-opacity: 1;\n        color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;\n    }\n\n    .text-secondary {\n        --bs-text-opacity: 1;\n        color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;\n    }\n\n    .text-success {\n        --bs-text-opacity: 1;\n        color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;\n    }\n\n    .text-info {\n        --bs-text-opacity: 1;\n        color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;\n    }\n\n    .text-warning {\n        --bs-text-opacity: 1;\n        color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;\n    }\n\n    .text-danger {\n        --bs-text-opacity: 1;\n        color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;\n    }\n\n    .text-light {\n        --bs-text-opacity: 1;\n        color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;\n    }\n\n    .text-dark {\n        --bs-text-opacity: 1;\n        color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;\n    }\n\n    .text-black {\n        --bs-text-opacity: 1;\n        color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;\n    }\n\n    .text-white {\n        --bs-text-opacity: 1;\n        color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;\n    }\n\n    .text-body {\n        --bs-text-opacity: 1;\n        color: rgba(\n            var(--bs-body-color-rgb),\n            var(--bs-text-opacity)\n        ) !important;\n    }\n\n    .text-muted {\n        --bs-text-opacity: 1;\n        color: var(--bs-secondary-color) !important;\n    }\n\n    .text-black-50 {\n        --bs-text-opacity: 1;\n        color: rgba(0, 0, 0, 0.5) !important;\n    }\n\n    .text-white-50 {\n        --bs-text-opacity: 1;\n        color: rgba(255, 255, 255, 0.5) !important;\n    }\n\n    .text-body-secondary {\n        --bs-text-opacity: 1;\n        color: var(--bs-secondary-color) !important;\n    }\n\n    .text-body-tertiary {\n        --bs-text-opacity: 1;\n        color: var(--bs-tertiary-color) !important;\n    }\n\n    .text-body-emphasis {\n        --bs-text-opacity: 1;\n        color: var(--bs-emphasis-color) !important;\n    }\n\n    .text-reset {\n        --bs-text-opacity: 1;\n        color: inherit !important;\n    }\n\n    .text-opacity-25 {\n        --bs-text-opacity: 0.25;\n    }\n\n    .text-opacity-50 {\n        --bs-text-opacity: 0.5;\n    }\n\n    .text-opacity-75 {\n        --bs-text-opacity: 0.75;\n    }\n\n    .text-opacity-100 {\n        --bs-text-opacity: 1;\n    }\n\n    .text-primary-emphasis {\n        color: var(--bs-primary-text-emphasis) !important;\n    }\n\n    .text-secondary-emphasis {\n        color: var(--bs-secondary-text-emphasis) !important;\n    }\n\n    .text-success-emphasis {\n        color: var(--bs-success-text-emphasis) !important;\n    }\n\n    .text-info-emphasis {\n        color: var(--bs-info-text-emphasis) !important;\n    }\n\n    .text-warning-emphasis {\n        color: var(--bs-warning-text-emphasis) !important;\n    }\n\n    .text-danger-emphasis {\n        color: var(--bs-danger-text-emphasis) !important;\n    }\n\n    .text-light-emphasis {\n        color: var(--bs-light-text-emphasis) !important;\n    }\n\n    .text-dark-emphasis {\n        color: var(--bs-dark-text-emphasis) !important;\n    }\n\n    .link-opacity-10 {\n        --bs-link-opacity: 0.1;\n    }\n\n    .link-opacity-10-hover:hover {\n        --bs-link-opacity: 0.1;\n    }\n\n    .link-opacity-25 {\n        --bs-link-opacity: 0.25;\n    }\n\n    .link-opacity-25-hover:hover {\n        --bs-link-opacity: 0.25;\n    }\n\n    .link-opacity-50 {\n        --bs-link-opacity: 0.5;\n    }\n\n    .link-opacity-50-hover:hover {\n        --bs-link-opacity: 0.5;\n    }\n\n    .link-opacity-75 {\n        --bs-link-opacity: 0.75;\n    }\n\n    .link-opacity-75-hover:hover {\n        --bs-link-opacity: 0.75;\n    }\n\n    .link-opacity-100 {\n        --bs-link-opacity: 1;\n    }\n\n    .link-opacity-100-hover:hover {\n        --bs-link-opacity: 1;\n    }\n\n    .link-offset-1 {\n        text-underline-offset: 0.125em !important;\n    }\n\n    .link-offset-1-hover:hover {\n        text-underline-offset: 0.125em !important;\n    }\n\n    .link-offset-2 {\n        text-underline-offset: 0.25em !important;\n    }\n\n    .link-offset-2-hover:hover {\n        text-underline-offset: 0.25em !important;\n    }\n\n    .link-offset-3 {\n        text-underline-offset: 0.375em !important;\n    }\n\n    .link-offset-3-hover:hover {\n        text-underline-offset: 0.375em !important;\n    }\n\n    .link-underline-primary {\n        --bs-link-underline-opacity: 1;\n        -webkit-text-decoration-color: rgba(\n            var(--bs-primary-rgb),\n            var(--bs-link-underline-opacity)\n        ) !important;\n        text-decoration-color: rgba(\n            var(--bs-primary-rgb),\n            var(--bs-link-underline-opacity)\n        ) !important;\n    }\n\n    .link-underline-secondary {\n        --bs-link-underline-opacity: 1;\n        -webkit-text-decoration-color: rgba(\n            var(--bs-secondary-rgb),\n            var(--bs-link-underline-opacity)\n        ) !important;\n        text-decoration-color: rgba(\n            var(--bs-secondary-rgb),\n            var(--bs-link-underline-opacity)\n        ) !important;\n    }\n\n    .link-underline-success {\n        --bs-link-underline-opacity: 1;\n        -webkit-text-decoration-color: rgba(\n            var(--bs-success-rgb),\n            var(--bs-link-underline-opacity)\n        ) !important;\n        text-decoration-color: rgba(\n            var(--bs-success-rgb),\n            var(--bs-link-underline-opacity)\n        ) !important;\n    }\n\n    .link-underline-info {\n        --bs-link-underline-opacity: 1;\n        -webkit-text-decoration-color: rgba(\n            var(--bs-info-rgb),\n            var(--bs-link-underline-opacity)\n        ) !important;\n        text-decoration-color: rgba(\n            var(--bs-info-rgb),\n            var(--bs-link-underline-opacity)\n        ) !important;\n    }\n\n    .link-underline-warning {\n        --bs-link-underline-opacity: 1;\n        -webkit-text-decoration-color: rgba(\n            var(--bs-warning-rgb),\n            var(--bs-link-underline-opacity)\n        ) !important;\n        text-decoration-color: rgba(\n            var(--bs-warning-rgb),\n            var(--bs-link-underline-opacity)\n        ) !important;\n    }\n\n    .link-underline-danger {\n        --bs-link-underline-opacity: 1;\n        -webkit-text-decoration-color: rgba(\n            var(--bs-danger-rgb),\n            var(--bs-link-underline-opacity)\n        ) !important;\n        text-decoration-color: rgba(\n            var(--bs-danger-rgb),\n            var(--bs-link-underline-opacity)\n        ) !important;\n    }\n\n    .link-underline-light {\n        --bs-link-underline-opacity: 1;\n        -webkit-text-decoration-color: rgba(\n            var(--bs-light-rgb),\n            var(--bs-link-underline-opacity)\n        ) !important;\n        text-decoration-color: rgba(\n            var(--bs-light-rgb),\n            var(--bs-link-underline-opacity)\n        ) !important;\n    }\n\n    .link-underline-dark {\n        --bs-link-underline-opacity: 1;\n        -webkit-text-decoration-color: rgba(\n            var(--bs-dark-rgb),\n            var(--bs-link-underline-opacity)\n        ) !important;\n        text-decoration-color: rgba(\n            var(--bs-dark-rgb),\n            var(--bs-link-underline-opacity)\n        ) !important;\n    }\n\n    .link-underline {\n        --bs-link-underline-opacity: 1;\n        -webkit-text-decoration-color: rgba(\n            var(--bs-link-color-rgb),\n            var(--bs-link-underline-opacity, 1)\n        ) !important;\n        text-decoration-color: rgba(\n            var(--bs-link-color-rgb),\n            var(--bs-link-underline-opacity, 1)\n        ) !important;\n    }\n\n    .link-underline-opacity-0 {\n        --bs-link-underline-opacity: 0;\n    }\n\n    .link-underline-opacity-0-hover:hover {\n        --bs-link-underline-opacity: 0;\n    }\n\n    .link-underline-opacity-10 {\n        --bs-link-underline-opacity: 0.1;\n    }\n\n    .link-underline-opacity-10-hover:hover {\n        --bs-link-underline-opacity: 0.1;\n    }\n\n    .link-underline-opacity-25 {\n        --bs-link-underline-opacity: 0.25;\n    }\n\n    .link-underline-opacity-25-hover:hover {\n        --bs-link-underline-opacity: 0.25;\n    }\n\n    .link-underline-opacity-50 {\n        --bs-link-underline-opacity: 0.5;\n    }\n\n    .link-underline-opacity-50-hover:hover {\n        --bs-link-underline-opacity: 0.5;\n    }\n\n    .link-underline-opacity-75 {\n        --bs-link-underline-opacity: 0.75;\n    }\n\n    .link-underline-opacity-75-hover:hover {\n        --bs-link-underline-opacity: 0.75;\n    }\n\n    .link-underline-opacity-100 {\n        --bs-link-underline-opacity: 1;\n    }\n\n    .link-underline-opacity-100-hover:hover {\n        --bs-link-underline-opacity: 1;\n    }\n\n    .bg-primary {\n        --bs-bg-opacity: 1;\n        background-color: rgba(\n            var(--bs-primary-rgb),\n            var(--bs-bg-opacity)\n        ) !important;\n    }\n\n    .bg-secondary {\n        --bs-bg-opacity: 1;\n        background-color: rgba(\n            var(--bs-secondary-rgb),\n            var(--bs-bg-opacity)\n        ) !important;\n    }\n\n    .bg-success {\n        --bs-bg-opacity: 1;\n        background-color: rgba(\n            var(--bs-success-rgb),\n            var(--bs-bg-opacity)\n        ) !important;\n    }\n\n    .bg-info {\n        --bs-bg-opacity: 1;\n        background-color: rgba(\n            var(--bs-info-rgb),\n            var(--bs-bg-opacity)\n        ) !important;\n    }\n\n    .bg-warning {\n        --bs-bg-opacity: 1;\n        background-color: rgba(\n            var(--bs-warning-rgb),\n            var(--bs-bg-opacity)\n        ) !important;\n    }\n\n    .bg-danger {\n        --bs-bg-opacity: 1;\n        background-color: rgba(\n            var(--bs-danger-rgb),\n            var(--bs-bg-opacity)\n        ) !important;\n    }\n\n    .bg-light {\n        --bs-bg-opacity: 1;\n        background-color: rgba(\n            var(--bs-light-rgb),\n            var(--bs-bg-opacity)\n        ) !important;\n    }\n\n    .bg-dark {\n        --bs-bg-opacity: 1;\n        background-color: rgba(\n            var(--bs-dark-rgb),\n            var(--bs-bg-opacity)\n        ) !important;\n    }\n\n    .bg-black {\n        --bs-bg-opacity: 1;\n        background-color: rgba(\n            var(--bs-black-rgb),\n            var(--bs-bg-opacity)\n        ) !important;\n    }\n\n    .bg-white {\n        --bs-bg-opacity: 1;\n        background-color: rgba(\n            var(--bs-white-rgb),\n            var(--bs-bg-opacity)\n        ) !important;\n    }\n\n    .bg-body {\n        --bs-bg-opacity: 1;\n        background-color: rgba(\n            var(--bs-body-bg-rgb),\n            var(--bs-bg-opacity)\n        ) !important;\n    }\n\n    .bg-transparent {\n        --bs-bg-opacity: 1;\n        background-color: transparent !important;\n    }\n\n    .bg-body-secondary {\n        --bs-bg-opacity: 1;\n        background-color: rgba(\n            var(--bs-secondary-bg-rgb),\n            var(--bs-bg-opacity)\n        ) !important;\n    }\n\n    .bg-body-tertiary {\n        --bs-bg-opacity: 1;\n        background-color: rgba(\n            var(--bs-tertiary-bg-rgb),\n            var(--bs-bg-opacity)\n        ) !important;\n    }\n\n    .bg-opacity-10 {\n        --bs-bg-opacity: 0.1;\n    }\n\n    .bg-opacity-25 {\n        --bs-bg-opacity: 0.25;\n    }\n\n    .bg-opacity-50 {\n        --bs-bg-opacity: 0.5;\n    }\n\n    .bg-opacity-75 {\n        --bs-bg-opacity: 0.75;\n    }\n\n    .bg-opacity-100 {\n        --bs-bg-opacity: 1;\n    }\n\n    .bg-primary-subtle {\n        background-color: var(--bs-primary-bg-subtle) !important;\n    }\n\n    .bg-secondary-subtle {\n        background-color: var(--bs-secondary-bg-subtle) !important;\n    }\n\n    .bg-success-subtle {\n        background-color: var(--bs-success-bg-subtle) !important;\n    }\n\n    .bg-info-subtle {\n        background-color: var(--bs-info-bg-subtle) !important;\n    }\n\n    .bg-warning-subtle {\n        background-color: var(--bs-warning-bg-subtle) !important;\n    }\n\n    .bg-danger-subtle {\n        background-color: var(--bs-danger-bg-subtle) !important;\n    }\n\n    .bg-light-subtle {\n        background-color: var(--bs-light-bg-subtle) !important;\n    }\n\n    .bg-dark-subtle {\n        background-color: var(--bs-dark-bg-subtle) !important;\n    }\n\n    .bg-gradient {\n        background-image: var(--bs-gradient) !important;\n    }\n\n    .user-select-all {\n        -webkit-user-select: all !important;\n        -moz-user-select: all !important;\n        user-select: all !important;\n    }\n\n    .user-select-auto {\n        -webkit-user-select: auto !important;\n        -moz-user-select: auto !important;\n        user-select: auto !important;\n    }\n\n    .user-select-none {\n        -webkit-user-select: none !important;\n        -moz-user-select: none !important;\n        user-select: none !important;\n    }\n\n    .pe-none {\n        pointer-events: none !important;\n    }\n\n    .pe-auto {\n        pointer-events: auto !important;\n    }\n\n    .rounded {\n        border-radius: var(--bs-border-radius) !important;\n    }\n\n    .rounded-0 {\n        border-radius: 0 !important;\n    }\n\n    .rounded-1 {\n        border-radius: var(--bs-border-radius-sm) !important;\n    }\n\n    .rounded-2 {\n        border-radius: var(--bs-border-radius) !important;\n    }\n\n    .rounded-3 {\n        border-radius: var(--bs-border-radius-lg) !important;\n    }\n\n    .rounded-4 {\n        border-radius: var(--bs-border-radius-xl) !important;\n    }\n\n    .rounded-5 {\n        border-radius: var(--bs-border-radius-xxl) !important;\n    }\n\n    .rounded-circle {\n        border-radius: 50% !important;\n    }\n\n    .rounded-pill {\n        border-radius: var(--bs-border-radius-pill) !important;\n    }\n\n    .rounded-top {\n        border-top-left-radius: var(--bs-border-radius) !important;\n        border-top-right-radius: var(--bs-border-radius) !important;\n    }\n\n    .rounded-top-0 {\n        border-top-left-radius: 0 !important;\n        border-top-right-radius: 0 !important;\n    }\n\n    .rounded-top-1 {\n        border-top-left-radius: var(--bs-border-radius-sm) !important;\n        border-top-right-radius: var(--bs-border-radius-sm) !important;\n    }\n\n    .rounded-top-2 {\n        border-top-left-radius: var(--bs-border-radius) !important;\n        border-top-right-radius: var(--bs-border-radius) !important;\n    }\n\n    .rounded-top-3 {\n        border-top-left-radius: var(--bs-border-radius-lg) !important;\n        border-top-right-radius: var(--bs-border-radius-lg) !important;\n    }\n\n    .rounded-top-4 {\n        border-top-left-radius: var(--bs-border-radius-xl) !important;\n        border-top-right-radius: var(--bs-border-radius-xl) !important;\n    }\n\n    .rounded-top-5 {\n        border-top-left-radius: var(--bs-border-radius-xxl) !important;\n        border-top-right-radius: var(--bs-border-radius-xxl) !important;\n    }\n\n    .rounded-top-circle {\n        border-top-left-radius: 50% !important;\n        border-top-right-radius: 50% !important;\n    }\n\n    .rounded-top-pill {\n        border-top-left-radius: var(--bs-border-radius-pill) !important;\n        border-top-right-radius: var(--bs-border-radius-pill) !important;\n    }\n\n    .rounded-end {\n        border-top-right-radius: var(--bs-border-radius) !important;\n        border-bottom-right-radius: var(--bs-border-radius) !important;\n    }\n\n    .rounded-end-0 {\n        border-top-right-radius: 0 !important;\n        border-bottom-right-radius: 0 !important;\n    }\n\n    .rounded-end-1 {\n        border-top-right-radius: var(--bs-border-radius-sm) !important;\n        border-bottom-right-radius: var(--bs-border-radius-sm) !important;\n    }\n\n    .rounded-end-2 {\n        border-top-right-radius: var(--bs-border-radius) !important;\n        border-bottom-right-radius: var(--bs-border-radius) !important;\n    }\n\n    .rounded-end-3 {\n        border-top-right-radius: var(--bs-border-radius-lg) !important;\n        border-bottom-right-radius: var(--bs-border-radius-lg) !important;\n    }\n\n    .rounded-end-4 {\n        border-top-right-radius: var(--bs-border-radius-xl) !important;\n        border-bottom-right-radius: var(--bs-border-radius-xl) !important;\n    }\n\n    .rounded-end-5 {\n        border-top-right-radius: var(--bs-border-radius-xxl) !important;\n        border-bottom-right-radius: var(--bs-border-radius-xxl) !important;\n    }\n\n    .rounded-end-circle {\n        border-top-right-radius: 50% !important;\n        border-bottom-right-radius: 50% !important;\n    }\n\n    .rounded-end-pill {\n        border-top-right-radius: var(--bs-border-radius-pill) !important;\n        border-bottom-right-radius: var(--bs-border-radius-pill) !important;\n    }\n\n    .rounded-bottom {\n        border-bottom-right-radius: var(--bs-border-radius) !important;\n        border-bottom-left-radius: var(--bs-border-radius) !important;\n    }\n\n    .rounded-bottom-0 {\n        border-bottom-right-radius: 0 !important;\n        border-bottom-left-radius: 0 !important;\n    }\n\n    .rounded-bottom-1 {\n        border-bottom-right-radius: var(--bs-border-radius-sm) !important;\n        border-bottom-left-radius: var(--bs-border-radius-sm) !important;\n    }\n\n    .rounded-bottom-2 {\n        border-bottom-right-radius: var(--bs-border-radius) !important;\n        border-bottom-left-radius: var(--bs-border-radius) !important;\n    }\n\n    .rounded-bottom-3 {\n        border-bottom-right-radius: var(--bs-border-radius-lg) !important;\n        border-bottom-left-radius: var(--bs-border-radius-lg) !important;\n    }\n\n    .rounded-bottom-4 {\n        border-bottom-right-radius: var(--bs-border-radius-xl) !important;\n        border-bottom-left-radius: var(--bs-border-radius-xl) !important;\n    }\n\n    .rounded-bottom-5 {\n        border-bottom-right-radius: var(--bs-border-radius-xxl) !important;\n        border-bottom-left-radius: var(--bs-border-radius-xxl) !important;\n    }\n\n    .rounded-bottom-circle {\n        border-bottom-right-radius: 50% !important;\n        border-bottom-left-radius: 50% !important;\n    }\n\n    .rounded-bottom-pill {\n        border-bottom-right-radius: var(--bs-border-radius-pill) !important;\n        border-bottom-left-radius: var(--bs-border-radius-pill) !important;\n    }\n\n    .rounded-start {\n        border-bottom-left-radius: var(--bs-border-radius) !important;\n        border-top-left-radius: var(--bs-border-radius) !important;\n    }\n\n    .rounded-start-0 {\n        border-bottom-left-radius: 0 !important;\n        border-top-left-radius: 0 !important;\n    }\n\n    .rounded-start-1 {\n        border-bottom-left-radius: var(--bs-border-radius-sm) !important;\n        border-top-left-radius: var(--bs-border-radius-sm) !important;\n    }\n\n    .rounded-start-2 {\n        border-bottom-left-radius: var(--bs-border-radius) !important;\n        border-top-left-radius: var(--bs-border-radius) !important;\n    }\n\n    .rounded-start-3 {\n        border-bottom-left-radius: var(--bs-border-radius-lg) !important;\n        border-top-left-radius: var(--bs-border-radius-lg) !important;\n    }\n\n    .rounded-start-4 {\n        border-bottom-left-radius: var(--bs-border-radius-xl) !important;\n        border-top-left-radius: var(--bs-border-radius-xl) !important;\n    }\n\n    .rounded-start-5 {\n        border-bottom-left-radius: var(--bs-border-radius-xxl) !important;\n        border-top-left-radius: var(--bs-border-radius-xxl) !important;\n    }\n\n    .rounded-start-circle {\n        border-bottom-left-radius: 50% !important;\n        border-top-left-radius: 50% !important;\n    }\n\n    .rounded-start-pill {\n        border-bottom-left-radius: var(--bs-border-radius-pill) !important;\n        border-top-left-radius: var(--bs-border-radius-pill) !important;\n    }\n\n    .visible {\n        visibility: visible !important;\n    }\n\n    .invisible {\n        visibility: hidden !important;\n    }\n\n    .z-n1 {\n        z-index: -1 !important;\n    }\n\n    .z-0 {\n        z-index: 0 !important;\n    }\n\n    .z-1 {\n        z-index: 1 !important;\n    }\n\n    .z-2 {\n        z-index: 2 !important;\n    }\n\n    .z-3 {\n        z-index: 3 !important;\n    }\n\n    @media (min-width: 576px) {\n        .float-sm-start {\n            float: left !important;\n        }\n        .float-sm-end {\n            float: right !important;\n        }\n        .float-sm-none {\n            float: none !important;\n        }\n        .object-fit-sm-contain {\n            -o-object-fit: contain !important;\n            object-fit: contain !important;\n        }\n        .object-fit-sm-cover {\n            -o-object-fit: cover !important;\n            object-fit: cover !important;\n        }\n        .object-fit-sm-fill {\n            -o-object-fit: fill !important;\n            object-fit: fill !important;\n        }\n        .object-fit-sm-scale {\n            -o-object-fit: scale-down !important;\n            object-fit: scale-down !important;\n        }\n        .object-fit-sm-none {\n            -o-object-fit: none !important;\n            object-fit: none !important;\n        }\n        .d-sm-inline {\n            display: inline !important;\n        }\n        .d-sm-inline-block {\n            display: inline-block !important;\n        }\n        .d-sm-block {\n            display: block !important;\n        }\n        .d-sm-grid {\n            display: grid !important;\n        }\n        .d-sm-inline-grid {\n            display: inline-grid !important;\n        }\n        .d-sm-table {\n            display: table !important;\n        }\n        .d-sm-table-row {\n            display: table-row !important;\n        }\n        .d-sm-table-cell {\n            display: table-cell !important;\n        }\n        .d-sm-flex {\n            display: flex !important;\n        }\n        .d-sm-inline-flex {\n            display: inline-flex !important;\n        }\n        .d-sm-none {\n            display: none !important;\n        }\n        .flex-sm-fill {\n            flex: 1 1 auto !important;\n        }\n        .flex-sm-row {\n            flex-direction: row !important;\n        }\n        .flex-sm-column {\n            flex-direction: column !important;\n        }\n        .flex-sm-row-reverse {\n            flex-direction: row-reverse !important;\n        }\n        .flex-sm-column-reverse {\n            flex-direction: column-reverse !important;\n        }\n        .flex-sm-grow-0 {\n            flex-grow: 0 !important;\n        }\n        .flex-sm-grow-1 {\n            flex-grow: 1 !important;\n        }\n        .flex-sm-shrink-0 {\n            flex-shrink: 0 !important;\n        }\n        .flex-sm-shrink-1 {\n            flex-shrink: 1 !important;\n        }\n        .flex-sm-wrap {\n            flex-wrap: wrap !important;\n        }\n        .flex-sm-nowrap {\n            flex-wrap: nowrap !important;\n        }\n        .flex-sm-wrap-reverse {\n            flex-wrap: wrap-reverse !important;\n        }\n        .justify-content-sm-start {\n            justify-content: flex-start !important;\n        }\n        .justify-content-sm-end {\n            justify-content: flex-end !important;\n        }\n        .justify-content-sm-center {\n            justify-content: center !important;\n        }\n        .justify-content-sm-between {\n            justify-content: space-between !important;\n        }\n        .justify-content-sm-around {\n            justify-content: space-around !important;\n        }\n        .justify-content-sm-evenly {\n            justify-content: space-evenly !important;\n        }\n        .align-items-sm-start {\n            align-items: flex-start !important;\n        }\n        .align-items-sm-end {\n            align-items: flex-end !important;\n        }\n        .align-items-sm-center {\n            align-items: center !important;\n        }\n        .align-items-sm-baseline {\n            align-items: baseline !important;\n        }\n        .align-items-sm-stretch {\n            align-items: stretch !important;\n        }\n        .align-content-sm-start {\n            align-content: flex-start !important;\n        }\n        .align-content-sm-end {\n            align-content: flex-end !important;\n        }\n        .align-content-sm-center {\n            align-content: center !important;\n        }\n        .align-content-sm-between {\n            align-content: space-between !important;\n        }\n        .align-content-sm-around {\n            align-content: space-around !important;\n        }\n        .align-content-sm-stretch {\n            align-content: stretch !important;\n        }\n        .align-self-sm-auto {\n            align-self: auto !important;\n        }\n        .align-self-sm-start {\n            align-self: flex-start !important;\n        }\n        .align-self-sm-end {\n            align-self: flex-end !important;\n        }\n        .align-self-sm-center {\n            align-self: center !important;\n        }\n        .align-self-sm-baseline {\n            align-self: baseline !important;\n        }\n        .align-self-sm-stretch {\n            align-self: stretch !important;\n        }\n        .order-sm-first {\n            order: -1 !important;\n        }\n        .order-sm-0 {\n            order: 0 !important;\n        }\n        .order-sm-1 {\n            order: 1 !important;\n        }\n        .order-sm-2 {\n            order: 2 !important;\n        }\n        .order-sm-3 {\n            order: 3 !important;\n        }\n        .order-sm-4 {\n            order: 4 !important;\n        }\n        .order-sm-5 {\n            order: 5 !important;\n        }\n        .order-sm-last {\n            order: 6 !important;\n        }\n        .m-sm-0 {\n            margin: 0 !important;\n        }\n        .m-sm-1 {\n            margin: 0.25rem !important;\n        }\n        .m-sm-2 {\n            margin: 0.5rem !important;\n        }\n        .m-sm-3 {\n            margin: 1rem !important;\n        }\n        .m-sm-4 {\n            margin: 1.5rem !important;\n        }\n        .m-sm-5 {\n            margin: 3rem !important;\n        }\n        .m-sm-auto {\n            margin: auto !important;\n        }\n        .mx-sm-0 {\n            margin-right: 0 !important;\n            margin-left: 0 !important;\n        }\n        .mx-sm-1 {\n            margin-right: 0.25rem !important;\n            margin-left: 0.25rem !important;\n        }\n        .mx-sm-2 {\n            margin-right: 0.5rem !important;\n            margin-left: 0.5rem !important;\n        }\n        .mx-sm-3 {\n            margin-right: 1rem !important;\n            margin-left: 1rem !important;\n        }\n        .mx-sm-4 {\n            margin-right: 1.5rem !important;\n            margin-left: 1.5rem !important;\n        }\n        .mx-sm-5 {\n            margin-right: 3rem !important;\n            margin-left: 3rem !important;\n        }\n        .mx-sm-auto {\n            margin-right: auto !important;\n            margin-left: auto !important;\n        }\n        .my-sm-0 {\n            margin-top: 0 !important;\n            margin-bottom: 0 !important;\n        }\n        .my-sm-1 {\n            margin-top: 0.25rem !important;\n            margin-bottom: 0.25rem !important;\n        }\n        .my-sm-2 {\n            margin-top: 0.5rem !important;\n            margin-bottom: 0.5rem !important;\n        }\n        .my-sm-3 {\n            margin-top: 1rem !important;\n            margin-bottom: 1rem !important;\n        }\n        .my-sm-4 {\n            margin-top: 1.5rem !important;\n            margin-bottom: 1.5rem !important;\n        }\n        .my-sm-5 {\n            margin-top: 3rem !important;\n            margin-bottom: 3rem !important;\n        }\n        .my-sm-auto {\n            margin-top: auto !important;\n            margin-bottom: auto !important;\n        }\n        .mt-sm-0 {\n            margin-top: 0 !important;\n        }\n        .mt-sm-1 {\n            margin-top: 0.25rem !important;\n        }\n        .mt-sm-2 {\n            margin-top: 0.5rem !important;\n        }\n        .mt-sm-3 {\n            margin-top: 1rem !important;\n        }\n        .mt-sm-4 {\n            margin-top: 1.5rem !important;\n        }\n        .mt-sm-5 {\n            margin-top: 3rem !important;\n        }\n        .mt-sm-auto {\n            margin-top: auto !important;\n        }\n        .me-sm-0 {\n            margin-right: 0 !important;\n        }\n        .me-sm-1 {\n            margin-right: 0.25rem !important;\n        }\n        .me-sm-2 {\n            margin-right: 0.5rem !important;\n        }\n        .me-sm-3 {\n            margin-right: 1rem !important;\n        }\n        .me-sm-4 {\n            margin-right: 1.5rem !important;\n        }\n        .me-sm-5 {\n            margin-right: 3rem !important;\n        }\n        .me-sm-auto {\n            margin-right: auto !important;\n        }\n        .mb-sm-0 {\n            margin-bottom: 0 !important;\n        }\n        .mb-sm-1 {\n            margin-bottom: 0.25rem !important;\n        }\n        .mb-sm-2 {\n            margin-bottom: 0.5rem !important;\n        }\n        .mb-sm-3 {\n            margin-bottom: 1rem !important;\n        }\n        .mb-sm-4 {\n            margin-bottom: 1.5rem !important;\n        }\n        .mb-sm-5 {\n            margin-bottom: 3rem !important;\n        }\n        .mb-sm-auto {\n            margin-bottom: auto !important;\n        }\n        .ms-sm-0 {\n            margin-left: 0 !important;\n        }\n        .ms-sm-1 {\n            margin-left: 0.25rem !important;\n        }\n        .ms-sm-2 {\n            margin-left: 0.5rem !important;\n        }\n        .ms-sm-3 {\n            margin-left: 1rem !important;\n        }\n        .ms-sm-4 {\n            margin-left: 1.5rem !important;\n        }\n        .ms-sm-5 {\n            margin-left: 3rem !important;\n        }\n        .ms-sm-auto {\n            margin-left: auto !important;\n        }\n        .p-sm-0 {\n            padding: 0 !important;\n        }\n        .p-sm-1 {\n            padding: 0.25rem !important;\n        }\n        .p-sm-2 {\n            padding: 0.5rem !important;\n        }\n        .p-sm-3 {\n            padding: 1rem !important;\n        }\n        .p-sm-4 {\n            padding: 1.5rem !important;\n        }\n        .p-sm-5 {\n            padding: 3rem !important;\n        }\n        .px-sm-0 {\n            padding-right: 0 !important;\n            padding-left: 0 !important;\n        }\n        .px-sm-1 {\n            padding-right: 0.25rem !important;\n            padding-left: 0.25rem !important;\n        }\n        .px-sm-2 {\n            padding-right: 0.5rem !important;\n            padding-left: 0.5rem !important;\n        }\n        .px-sm-3 {\n            padding-right: 1rem !important;\n            padding-left: 1rem !important;\n        }\n        .px-sm-4 {\n            padding-right: 1.5rem !important;\n            padding-left: 1.5rem !important;\n        }\n        .px-sm-5 {\n            padding-right: 3rem !important;\n            padding-left: 3rem !important;\n        }\n        .py-sm-0 {\n            padding-top: 0 !important;\n            padding-bottom: 0 !important;\n        }\n        .py-sm-1 {\n            padding-top: 0.25rem !important;\n            padding-bottom: 0.25rem !important;\n        }\n        .py-sm-2 {\n            padding-top: 0.5rem !important;\n            padding-bottom: 0.5rem !important;\n        }\n        .py-sm-3 {\n            padding-top: 1rem !important;\n            padding-bottom: 1rem !important;\n        }\n        .py-sm-4 {\n            padding-top: 1.5rem !important;\n            padding-bottom: 1.5rem !important;\n        }\n        .py-sm-5 {\n            padding-top: 3rem !important;\n            padding-bottom: 3rem !important;\n        }\n        .pt-sm-0 {\n            padding-top: 0 !important;\n        }\n        .pt-sm-1 {\n            padding-top: 0.25rem !important;\n        }\n        .pt-sm-2 {\n            padding-top: 0.5rem !important;\n        }\n        .pt-sm-3 {\n            padding-top: 1rem !important;\n        }\n        .pt-sm-4 {\n            padding-top: 1.5rem !important;\n        }\n        .pt-sm-5 {\n            padding-top: 3rem !important;\n        }\n        .pe-sm-0 {\n            padding-right: 0 !important;\n        }\n        .pe-sm-1 {\n            padding-right: 0.25rem !important;\n        }\n        .pe-sm-2 {\n            padding-right: 0.5rem !important;\n        }\n        .pe-sm-3 {\n            padding-right: 1rem !important;\n        }\n        .pe-sm-4 {\n            padding-right: 1.5rem !important;\n        }\n        .pe-sm-5 {\n            padding-right: 3rem !important;\n        }\n        .pb-sm-0 {\n            padding-bottom: 0 !important;\n        }\n        .pb-sm-1 {\n            padding-bottom: 0.25rem !important;\n        }\n        .pb-sm-2 {\n            padding-bottom: 0.5rem !important;\n        }\n        .pb-sm-3 {\n            padding-bottom: 1rem !important;\n        }\n        .pb-sm-4 {\n            padding-bottom: 1.5rem !important;\n        }\n        .pb-sm-5 {\n            padding-bottom: 3rem !important;\n        }\n        .ps-sm-0 {\n            padding-left: 0 !important;\n        }\n        .ps-sm-1 {\n            padding-left: 0.25rem !important;\n        }\n        .ps-sm-2 {\n            padding-left: 0.5rem !important;\n        }\n        .ps-sm-3 {\n            padding-left: 1rem !important;\n        }\n        .ps-sm-4 {\n            padding-left: 1.5rem !important;\n        }\n        .ps-sm-5 {\n            padding-left: 3rem !important;\n        }\n        .gap-sm-0 {\n            gap: 0 !important;\n        }\n        .gap-sm-1 {\n            gap: 0.25rem !important;\n        }\n        .gap-sm-2 {\n            gap: 0.5rem !important;\n        }\n        .gap-sm-3 {\n            gap: 1rem !important;\n        }\n        .gap-sm-4 {\n            gap: 1.5rem !important;\n        }\n        .gap-sm-5 {\n            gap: 3rem !important;\n        }\n        .row-gap-sm-0 {\n            row-gap: 0 !important;\n        }\n        .row-gap-sm-1 {\n            row-gap: 0.25rem !important;\n        }\n        .row-gap-sm-2 {\n            row-gap: 0.5rem !important;\n        }\n        .row-gap-sm-3 {\n            row-gap: 1rem !important;\n        }\n        .row-gap-sm-4 {\n            row-gap: 1.5rem !important;\n        }\n        .row-gap-sm-5 {\n            row-gap: 3rem !important;\n        }\n        .column-gap-sm-0 {\n            -moz-column-gap: 0 !important;\n            column-gap: 0 !important;\n        }\n        .column-gap-sm-1 {\n            -moz-column-gap: 0.25rem !important;\n            column-gap: 0.25rem !important;\n        }\n        .column-gap-sm-2 {\n            -moz-column-gap: 0.5rem !important;\n            column-gap: 0.5rem !important;\n        }\n        .column-gap-sm-3 {\n            -moz-column-gap: 1rem !important;\n            column-gap: 1rem !important;\n        }\n        .column-gap-sm-4 {\n            -moz-column-gap: 1.5rem !important;\n            column-gap: 1.5rem !important;\n        }\n        .column-gap-sm-5 {\n            -moz-column-gap: 3rem !important;\n            column-gap: 3rem !important;\n        }\n        .text-sm-start {\n            text-align: left !important;\n        }\n        .text-sm-end {\n            text-align: right !important;\n        }\n        .text-sm-center {\n            text-align: center !important;\n        }\n    }\n    @media (min-width: 768px) {\n        .float-md-start {\n            float: left !important;\n        }\n        .float-md-end {\n            float: right !important;\n        }\n        .float-md-none {\n            float: none !important;\n        }\n        .object-fit-md-contain {\n            -o-object-fit: contain !important;\n            object-fit: contain !important;\n        }\n        .object-fit-md-cover {\n            -o-object-fit: cover !important;\n            object-fit: cover !important;\n        }\n        .object-fit-md-fill {\n            -o-object-fit: fill !important;\n            object-fit: fill !important;\n        }\n        .object-fit-md-scale {\n            -o-object-fit: scale-down !important;\n            object-fit: scale-down !important;\n        }\n        .object-fit-md-none {\n            -o-object-fit: none !important;\n            object-fit: none !important;\n        }\n        .d-md-inline {\n            display: inline !important;\n        }\n        .d-md-inline-block {\n            display: inline-block !important;\n        }\n        .d-md-block {\n            display: block !important;\n        }\n        .d-md-grid {\n            display: grid !important;\n        }\n        .d-md-inline-grid {\n            display: inline-grid !important;\n        }\n        .d-md-table {\n            display: table !important;\n        }\n        .d-md-table-row {\n            display: table-row !important;\n        }\n        .d-md-table-cell {\n            display: table-cell !important;\n        }\n        .d-md-flex {\n            display: flex !important;\n        }\n        .d-md-inline-flex {\n            display: inline-flex !important;\n        }\n        .d-md-none {\n            display: none !important;\n        }\n        .flex-md-fill {\n            flex: 1 1 auto !important;\n        }\n        .flex-md-row {\n            flex-direction: row !important;\n        }\n        .flex-md-column {\n            flex-direction: column !important;\n        }\n        .flex-md-row-reverse {\n            flex-direction: row-reverse !important;\n        }\n        .flex-md-column-reverse {\n            flex-direction: column-reverse !important;\n        }\n        .flex-md-grow-0 {\n            flex-grow: 0 !important;\n        }\n        .flex-md-grow-1 {\n            flex-grow: 1 !important;\n        }\n        .flex-md-shrink-0 {\n            flex-shrink: 0 !important;\n        }\n        .flex-md-shrink-1 {\n            flex-shrink: 1 !important;\n        }\n        .flex-md-wrap {\n            flex-wrap: wrap !important;\n        }\n        .flex-md-nowrap {\n            flex-wrap: nowrap !important;\n        }\n        .flex-md-wrap-reverse {\n            flex-wrap: wrap-reverse !important;\n        }\n        .justify-content-md-start {\n            justify-content: flex-start !important;\n        }\n        .justify-content-md-end {\n            justify-content: flex-end !important;\n        }\n        .justify-content-md-center {\n            justify-content: center !important;\n        }\n        .justify-content-md-between {\n            justify-content: space-between !important;\n        }\n        .justify-content-md-around {\n            justify-content: space-around !important;\n        }\n        .justify-content-md-evenly {\n            justify-content: space-evenly !important;\n        }\n        .align-items-md-start {\n            align-items: flex-start !important;\n        }\n        .align-items-md-end {\n            align-items: flex-end !important;\n        }\n        .align-items-md-center {\n            align-items: center !important;\n        }\n        .align-items-md-baseline {\n            align-items: baseline !important;\n        }\n        .align-items-md-stretch {\n            align-items: stretch !important;\n        }\n        .align-content-md-start {\n            align-content: flex-start !important;\n        }\n        .align-content-md-end {\n            align-content: flex-end !important;\n        }\n        .align-content-md-center {\n            align-content: center !important;\n        }\n        .align-content-md-between {\n            align-content: space-between !important;\n        }\n        .align-content-md-around {\n            align-content: space-around !important;\n        }\n        .align-content-md-stretch {\n            align-content: stretch !important;\n        }\n        .align-self-md-auto {\n            align-self: auto !important;\n        }\n        .align-self-md-start {\n            align-self: flex-start !important;\n        }\n        .align-self-md-end {\n            align-self: flex-end !important;\n        }\n        .align-self-md-center {\n            align-self: center !important;\n        }\n        .align-self-md-baseline {\n            align-self: baseline !important;\n        }\n        .align-self-md-stretch {\n            align-self: stretch !important;\n        }\n        .order-md-first {\n            order: -1 !important;\n        }\n        .order-md-0 {\n            order: 0 !important;\n        }\n        .order-md-1 {\n            order: 1 !important;\n        }\n        .order-md-2 {\n            order: 2 !important;\n        }\n        .order-md-3 {\n            order: 3 !important;\n        }\n        .order-md-4 {\n            order: 4 !important;\n        }\n        .order-md-5 {\n            order: 5 !important;\n        }\n        .order-md-last {\n            order: 6 !important;\n        }\n        .m-md-0 {\n            margin: 0 !important;\n        }\n        .m-md-1 {\n            margin: 0.25rem !important;\n        }\n        .m-md-2 {\n            margin: 0.5rem !important;\n        }\n        .m-md-3 {\n            margin: 1rem !important;\n        }\n        .m-md-4 {\n            margin: 1.5rem !important;\n        }\n        .m-md-5 {\n            margin: 3rem !important;\n        }\n        .m-md-auto {\n            margin: auto !important;\n        }\n        .mx-md-0 {\n            margin-right: 0 !important;\n            margin-left: 0 !important;\n        }\n        .mx-md-1 {\n            margin-right: 0.25rem !important;\n            margin-left: 0.25rem !important;\n        }\n        .mx-md-2 {\n            margin-right: 0.5rem !important;\n            margin-left: 0.5rem !important;\n        }\n        .mx-md-3 {\n            margin-right: 1rem !important;\n            margin-left: 1rem !important;\n        }\n        .mx-md-4 {\n            margin-right: 1.5rem !important;\n            margin-left: 1.5rem !important;\n        }\n        .mx-md-5 {\n            margin-right: 3rem !important;\n            margin-left: 3rem !important;\n        }\n        .mx-md-auto {\n            margin-right: auto !important;\n            margin-left: auto !important;\n        }\n        .my-md-0 {\n            margin-top: 0 !important;\n            margin-bottom: 0 !important;\n        }\n        .my-md-1 {\n            margin-top: 0.25rem !important;\n            margin-bottom: 0.25rem !important;\n        }\n        .my-md-2 {\n            margin-top: 0.5rem !important;\n            margin-bottom: 0.5rem !important;\n        }\n        .my-md-3 {\n            margin-top: 1rem !important;\n            margin-bottom: 1rem !important;\n        }\n        .my-md-4 {\n            margin-top: 1.5rem !important;\n            margin-bottom: 1.5rem !important;\n        }\n        .my-md-5 {\n            margin-top: 3rem !important;\n            margin-bottom: 3rem !important;\n        }\n        .my-md-auto {\n            margin-top: auto !important;\n            margin-bottom: auto !important;\n        }\n        .mt-md-0 {\n            margin-top: 0 !important;\n        }\n        .mt-md-1 {\n            margin-top: 0.25rem !important;\n        }\n        .mt-md-2 {\n            margin-top: 0.5rem !important;\n        }\n        .mt-md-3 {\n            margin-top: 1rem !important;\n        }\n        .mt-md-4 {\n            margin-top: 1.5rem !important;\n        }\n        .mt-md-5 {\n            margin-top: 3rem !important;\n        }\n        .mt-md-auto {\n            margin-top: auto !important;\n        }\n        .me-md-0 {\n            margin-right: 0 !important;\n        }\n        .me-md-1 {\n            margin-right: 0.25rem !important;\n        }\n        .me-md-2 {\n            margin-right: 0.5rem !important;\n        }\n        .me-md-3 {\n            margin-right: 1rem !important;\n        }\n        .me-md-4 {\n            margin-right: 1.5rem !important;\n        }\n        .me-md-5 {\n            margin-right: 3rem !important;\n        }\n        .me-md-auto {\n            margin-right: auto !important;\n        }\n        .mb-md-0 {\n            margin-bottom: 0 !important;\n        }\n        .mb-md-1 {\n            margin-bottom: 0.25rem !important;\n        }\n        .mb-md-2 {\n            margin-bottom: 0.5rem !important;\n        }\n        .mb-md-3 {\n            margin-bottom: 1rem !important;\n        }\n        .mb-md-4 {\n            margin-bottom: 1.5rem !important;\n        }\n        .mb-md-5 {\n            margin-bottom: 3rem !important;\n        }\n        .mb-md-auto {\n            margin-bottom: auto !important;\n        }\n        .ms-md-0 {\n            margin-left: 0 !important;\n        }\n        .ms-md-1 {\n            margin-left: 0.25rem !important;\n        }\n        .ms-md-2 {\n            margin-left: 0.5rem !important;\n        }\n        .ms-md-3 {\n            margin-left: 1rem !important;\n        }\n        .ms-md-4 {\n            margin-left: 1.5rem !important;\n        }\n        .ms-md-5 {\n            margin-left: 3rem !important;\n        }\n        .ms-md-auto {\n            margin-left: auto !important;\n        }\n        .p-md-0 {\n            padding: 0 !important;\n        }\n        .p-md-1 {\n            padding: 0.25rem !important;\n        }\n        .p-md-2 {\n            padding: 0.5rem !important;\n        }\n        .p-md-3 {\n            padding: 1rem !important;\n        }\n        .p-md-4 {\n            padding: 1.5rem !important;\n        }\n        .p-md-5 {\n            padding: 3rem !important;\n        }\n        .px-md-0 {\n            padding-right: 0 !important;\n            padding-left: 0 !important;\n        }\n        .px-md-1 {\n            padding-right: 0.25rem !important;\n            padding-left: 0.25rem !important;\n        }\n        .px-md-2 {\n            padding-right: 0.5rem !important;\n            padding-left: 0.5rem !important;\n        }\n        .px-md-3 {\n            padding-right: 1rem !important;\n            padding-left: 1rem !important;\n        }\n        .px-md-4 {\n            padding-right: 1.5rem !important;\n            padding-left: 1.5rem !important;\n        }\n        .px-md-5 {\n            padding-right: 3rem !important;\n            padding-left: 3rem !important;\n        }\n        .py-md-0 {\n            padding-top: 0 !important;\n            padding-bottom: 0 !important;\n        }\n        .py-md-1 {\n            padding-top: 0.25rem !important;\n            padding-bottom: 0.25rem !important;\n        }\n        .py-md-2 {\n            padding-top: 0.5rem !important;\n            padding-bottom: 0.5rem !important;\n        }\n        .py-md-3 {\n            padding-top: 1rem !important;\n            padding-bottom: 1rem !important;\n        }\n        .py-md-4 {\n            padding-top: 1.5rem !important;\n            padding-bottom: 1.5rem !important;\n        }\n        .py-md-5 {\n            padding-top: 3rem !important;\n            padding-bottom: 3rem !important;\n        }\n        .pt-md-0 {\n            padding-top: 0 !important;\n        }\n        .pt-md-1 {\n            padding-top: 0.25rem !important;\n        }\n        .pt-md-2 {\n            padding-top: 0.5rem !important;\n        }\n        .pt-md-3 {\n            padding-top: 1rem !important;\n        }\n        .pt-md-4 {\n            padding-top: 1.5rem !important;\n        }\n        .pt-md-5 {\n            padding-top: 3rem !important;\n        }\n        .pe-md-0 {\n            padding-right: 0 !important;\n        }\n        .pe-md-1 {\n            padding-right: 0.25rem !important;\n        }\n        .pe-md-2 {\n            padding-right: 0.5rem !important;\n        }\n        .pe-md-3 {\n            padding-right: 1rem !important;\n        }\n        .pe-md-4 {\n            padding-right: 1.5rem !important;\n        }\n        .pe-md-5 {\n            padding-right: 3rem !important;\n        }\n        .pb-md-0 {\n            padding-bottom: 0 !important;\n        }\n        .pb-md-1 {\n            padding-bottom: 0.25rem !important;\n        }\n        .pb-md-2 {\n            padding-bottom: 0.5rem !important;\n        }\n        .pb-md-3 {\n            padding-bottom: 1rem !important;\n        }\n        .pb-md-4 {\n            padding-bottom: 1.5rem !important;\n        }\n        .pb-md-5 {\n            padding-bottom: 3rem !important;\n        }\n        .ps-md-0 {\n            padding-left: 0 !important;\n        }\n        .ps-md-1 {\n            padding-left: 0.25rem !important;\n        }\n        .ps-md-2 {\n            padding-left: 0.5rem !important;\n        }\n        .ps-md-3 {\n            padding-left: 1rem !important;\n        }\n        .ps-md-4 {\n            padding-left: 1.5rem !important;\n        }\n        .ps-md-5 {\n            padding-left: 3rem !important;\n        }\n        .gap-md-0 {\n            gap: 0 !important;\n        }\n        .gap-md-1 {\n            gap: 0.25rem !important;\n        }\n        .gap-md-2 {\n            gap: 0.5rem !important;\n        }\n        .gap-md-3 {\n            gap: 1rem !important;\n        }\n        .gap-md-4 {\n            gap: 1.5rem !important;\n        }\n        .gap-md-5 {\n            gap: 3rem !important;\n        }\n        .row-gap-md-0 {\n            row-gap: 0 !important;\n        }\n        .row-gap-md-1 {\n            row-gap: 0.25rem !important;\n        }\n        .row-gap-md-2 {\n            row-gap: 0.5rem !important;\n        }\n        .row-gap-md-3 {\n            row-gap: 1rem !important;\n        }\n        .row-gap-md-4 {\n            row-gap: 1.5rem !important;\n        }\n        .row-gap-md-5 {\n            row-gap: 3rem !important;\n        }\n        .column-gap-md-0 {\n            -moz-column-gap: 0 !important;\n            column-gap: 0 !important;\n        }\n        .column-gap-md-1 {\n            -moz-column-gap: 0.25rem !important;\n            column-gap: 0.25rem !important;\n        }\n        .column-gap-md-2 {\n            -moz-column-gap: 0.5rem !important;\n            column-gap: 0.5rem !important;\n        }\n        .column-gap-md-3 {\n            -moz-column-gap: 1rem !important;\n            column-gap: 1rem !important;\n        }\n        .column-gap-md-4 {\n            -moz-column-gap: 1.5rem !important;\n            column-gap: 1.5rem !important;\n        }\n        .column-gap-md-5 {\n            -moz-column-gap: 3rem !important;\n            column-gap: 3rem !important;\n        }\n        .text-md-start {\n            text-align: left !important;\n        }\n        .text-md-end {\n            text-align: right !important;\n        }\n        .text-md-center {\n            text-align: center !important;\n        }\n    }\n    @media (min-width: 992px) {\n        .float-lg-start {\n            float: left !important;\n        }\n        .float-lg-end {\n            float: right !important;\n        }\n        .float-lg-none {\n            float: none !important;\n        }\n        .object-fit-lg-contain {\n            -o-object-fit: contain !important;\n            object-fit: contain !important;\n        }\n        .object-fit-lg-cover {\n            -o-object-fit: cover !important;\n            object-fit: cover !important;\n        }\n        .object-fit-lg-fill {\n            -o-object-fit: fill !important;\n            object-fit: fill !important;\n        }\n        .object-fit-lg-scale {\n            -o-object-fit: scale-down !important;\n            object-fit: scale-down !important;\n        }\n        .object-fit-lg-none {\n            -o-object-fit: none !important;\n            object-fit: none !important;\n        }\n        .d-lg-inline {\n            display: inline !important;\n        }\n        .d-lg-inline-block {\n            display: inline-block !important;\n        }\n        .d-lg-block {\n            display: block !important;\n        }\n        .d-lg-grid {\n            display: grid !important;\n        }\n        .d-lg-inline-grid {\n            display: inline-grid !important;\n        }\n        .d-lg-table {\n            display: table !important;\n        }\n        .d-lg-table-row {\n            display: table-row !important;\n        }\n        .d-lg-table-cell {\n            display: table-cell !important;\n        }\n        .d-lg-flex {\n            display: flex !important;\n        }\n        .d-lg-inline-flex {\n            display: inline-flex !important;\n        }\n        .d-lg-none {\n            display: none !important;\n        }\n        .flex-lg-fill {\n            flex: 1 1 auto !important;\n        }\n        .flex-lg-row {\n            flex-direction: row !important;\n        }\n        .flex-lg-column {\n            flex-direction: column !important;\n        }\n        .flex-lg-row-reverse {\n            flex-direction: row-reverse !important;\n        }\n        .flex-lg-column-reverse {\n            flex-direction: column-reverse !important;\n        }\n        .flex-lg-grow-0 {\n            flex-grow: 0 !important;\n        }\n        .flex-lg-grow-1 {\n            flex-grow: 1 !important;\n        }\n        .flex-lg-shrink-0 {\n            flex-shrink: 0 !important;\n        }\n        .flex-lg-shrink-1 {\n            flex-shrink: 1 !important;\n        }\n        .flex-lg-wrap {\n            flex-wrap: wrap !important;\n        }\n        .flex-lg-nowrap {\n            flex-wrap: nowrap !important;\n        }\n        .flex-lg-wrap-reverse {\n            flex-wrap: wrap-reverse !important;\n        }\n        .justify-content-lg-start {\n            justify-content: flex-start !important;\n        }\n        .justify-content-lg-end {\n            justify-content: flex-end !important;\n        }\n        .justify-content-lg-center {\n            justify-content: center !important;\n        }\n        .justify-content-lg-between {\n            justify-content: space-between !important;\n        }\n        .justify-content-lg-around {\n            justify-content: space-around !important;\n        }\n        .justify-content-lg-evenly {\n            justify-content: space-evenly !important;\n        }\n        .align-items-lg-start {\n            align-items: flex-start !important;\n        }\n        .align-items-lg-end {\n            align-items: flex-end !important;\n        }\n        .align-items-lg-center {\n            align-items: center !important;\n        }\n        .align-items-lg-baseline {\n            align-items: baseline !important;\n        }\n        .align-items-lg-stretch {\n            align-items: stretch !important;\n        }\n        .align-content-lg-start {\n            align-content: flex-start !important;\n        }\n        .align-content-lg-end {\n            align-content: flex-end !important;\n        }\n        .align-content-lg-center {\n            align-content: center !important;\n        }\n        .align-content-lg-between {\n            align-content: space-between !important;\n        }\n        .align-content-lg-around {\n            align-content: space-around !important;\n        }\n        .align-content-lg-stretch {\n            align-content: stretch !important;\n        }\n        .align-self-lg-auto {\n            align-self: auto !important;\n        }\n        .align-self-lg-start {\n            align-self: flex-start !important;\n        }\n        .align-self-lg-end {\n            align-self: flex-end !important;\n        }\n        .align-self-lg-center {\n            align-self: center !important;\n        }\n        .align-self-lg-baseline {\n            align-self: baseline !important;\n        }\n        .align-self-lg-stretch {\n            align-self: stretch !important;\n        }\n        .order-lg-first {\n            order: -1 !important;\n        }\n        .order-lg-0 {\n            order: 0 !important;\n        }\n        .order-lg-1 {\n            order: 1 !important;\n        }\n        .order-lg-2 {\n            order: 2 !important;\n        }\n        .order-lg-3 {\n            order: 3 !important;\n        }\n        .order-lg-4 {\n            order: 4 !important;\n        }\n        .order-lg-5 {\n            order: 5 !important;\n        }\n        .order-lg-last {\n            order: 6 !important;\n        }\n        .m-lg-0 {\n            margin: 0 !important;\n        }\n        .m-lg-1 {\n            margin: 0.25rem !important;\n        }\n        .m-lg-2 {\n            margin: 0.5rem !important;\n        }\n        .m-lg-3 {\n            margin: 1rem !important;\n        }\n        .m-lg-4 {\n            margin: 1.5rem !important;\n        }\n        .m-lg-5 {\n            margin: 3rem !important;\n        }\n        .m-lg-auto {\n            margin: auto !important;\n        }\n        .mx-lg-0 {\n            margin-right: 0 !important;\n            margin-left: 0 !important;\n        }\n        .mx-lg-1 {\n            margin-right: 0.25rem !important;\n            margin-left: 0.25rem !important;\n        }\n        .mx-lg-2 {\n            margin-right: 0.5rem !important;\n            margin-left: 0.5rem !important;\n        }\n        .mx-lg-3 {\n            margin-right: 1rem !important;\n            margin-left: 1rem !important;\n        }\n        .mx-lg-4 {\n            margin-right: 1.5rem !important;\n            margin-left: 1.5rem !important;\n        }\n        .mx-lg-5 {\n            margin-right: 3rem !important;\n            margin-left: 3rem !important;\n        }\n        .mx-lg-auto {\n            margin-right: auto !important;\n            margin-left: auto !important;\n        }\n        .my-lg-0 {\n            margin-top: 0 !important;\n            margin-bottom: 0 !important;\n        }\n        .my-lg-1 {\n            margin-top: 0.25rem !important;\n            margin-bottom: 0.25rem !important;\n        }\n        .my-lg-2 {\n            margin-top: 0.5rem !important;\n            margin-bottom: 0.5rem !important;\n        }\n        .my-lg-3 {\n            margin-top: 1rem !important;\n            margin-bottom: 1rem !important;\n        }\n        .my-lg-4 {\n            margin-top: 1.5rem !important;\n            margin-bottom: 1.5rem !important;\n        }\n        .my-lg-5 {\n            margin-top: 3rem !important;\n            margin-bottom: 3rem !important;\n        }\n        .my-lg-auto {\n            margin-top: auto !important;\n            margin-bottom: auto !important;\n        }\n        .mt-lg-0 {\n            margin-top: 0 !important;\n        }\n        .mt-lg-1 {\n            margin-top: 0.25rem !important;\n        }\n        .mt-lg-2 {\n            margin-top: 0.5rem !important;\n        }\n        .mt-lg-3 {\n            margin-top: 1rem !important;\n        }\n        .mt-lg-4 {\n            margin-top: 1.5rem !important;\n        }\n        .mt-lg-5 {\n            margin-top: 3rem !important;\n        }\n        .mt-lg-auto {\n            margin-top: auto !important;\n        }\n        .me-lg-0 {\n            margin-right: 0 !important;\n        }\n        .me-lg-1 {\n            margin-right: 0.25rem !important;\n        }\n        .me-lg-2 {\n            margin-right: 0.5rem !important;\n        }\n        .me-lg-3 {\n            margin-right: 1rem !important;\n        }\n        .me-lg-4 {\n            margin-right: 1.5rem !important;\n        }\n        .me-lg-5 {\n            margin-right: 3rem !important;\n        }\n        .me-lg-auto {\n            margin-right: auto !important;\n        }\n        .mb-lg-0 {\n            margin-bottom: 0 !important;\n        }\n        .mb-lg-1 {\n            margin-bottom: 0.25rem !important;\n        }\n        .mb-lg-2 {\n            margin-bottom: 0.5rem !important;\n        }\n        .mb-lg-3 {\n            margin-bottom: 1rem !important;\n        }\n        .mb-lg-4 {\n            margin-bottom: 1.5rem !important;\n        }\n        .mb-lg-5 {\n            margin-bottom: 3rem !important;\n        }\n        .mb-lg-auto {\n            margin-bottom: auto !important;\n        }\n        .ms-lg-0 {\n            margin-left: 0 !important;\n        }\n        .ms-lg-1 {\n            margin-left: 0.25rem !important;\n        }\n        .ms-lg-2 {\n            margin-left: 0.5rem !important;\n        }\n        .ms-lg-3 {\n            margin-left: 1rem !important;\n        }\n        .ms-lg-4 {\n            margin-left: 1.5rem !important;\n        }\n        .ms-lg-5 {\n            margin-left: 3rem !important;\n        }\n        .ms-lg-auto {\n            margin-left: auto !important;\n        }\n        .p-lg-0 {\n            padding: 0 !important;\n        }\n        .p-lg-1 {\n            padding: 0.25rem !important;\n        }\n        .p-lg-2 {\n            padding: 0.5rem !important;\n        }\n        .p-lg-3 {\n            padding: 1rem !important;\n        }\n        .p-lg-4 {\n            padding: 1.5rem !important;\n        }\n        .p-lg-5 {\n            padding: 3rem !important;\n        }\n        .px-lg-0 {\n            padding-right: 0 !important;\n            padding-left: 0 !important;\n        }\n        .px-lg-1 {\n            padding-right: 0.25rem !important;\n            padding-left: 0.25rem !important;\n        }\n        .px-lg-2 {\n            padding-right: 0.5rem !important;\n            padding-left: 0.5rem !important;\n        }\n        .px-lg-3 {\n            padding-right: 1rem !important;\n            padding-left: 1rem !important;\n        }\n        .px-lg-4 {\n            padding-right: 1.5rem !important;\n            padding-left: 1.5rem !important;\n        }\n        .px-lg-5 {\n            padding-right: 3rem !important;\n            padding-left: 3rem !important;\n        }\n        .py-lg-0 {\n            padding-top: 0 !important;\n            padding-bottom: 0 !important;\n        }\n        .py-lg-1 {\n            padding-top: 0.25rem !important;\n            padding-bottom: 0.25rem !important;\n        }\n        .py-lg-2 {\n            padding-top: 0.5rem !important;\n            padding-bottom: 0.5rem !important;\n        }\n        .py-lg-3 {\n            padding-top: 1rem !important;\n            padding-bottom: 1rem !important;\n        }\n        .py-lg-4 {\n            padding-top: 1.5rem !important;\n            padding-bottom: 1.5rem !important;\n        }\n        .py-lg-5 {\n            padding-top: 3rem !important;\n            padding-bottom: 3rem !important;\n        }\n        .pt-lg-0 {\n            padding-top: 0 !important;\n        }\n        .pt-lg-1 {\n            padding-top: 0.25rem !important;\n        }\n        .pt-lg-2 {\n            padding-top: 0.5rem !important;\n        }\n        .pt-lg-3 {\n            padding-top: 1rem !important;\n        }\n        .pt-lg-4 {\n            padding-top: 1.5rem !important;\n        }\n        .pt-lg-5 {\n            padding-top: 3rem !important;\n        }\n        .pe-lg-0 {\n            padding-right: 0 !important;\n        }\n        .pe-lg-1 {\n            padding-right: 0.25rem !important;\n        }\n        .pe-lg-2 {\n            padding-right: 0.5rem !important;\n        }\n        .pe-lg-3 {\n            padding-right: 1rem !important;\n        }\n        .pe-lg-4 {\n            padding-right: 1.5rem !important;\n        }\n        .pe-lg-5 {\n            padding-right: 3rem !important;\n        }\n        .pb-lg-0 {\n            padding-bottom: 0 !important;\n        }\n        .pb-lg-1 {\n            padding-bottom: 0.25rem !important;\n        }\n        .pb-lg-2 {\n            padding-bottom: 0.5rem !important;\n        }\n        .pb-lg-3 {\n            padding-bottom: 1rem !important;\n        }\n        .pb-lg-4 {\n            padding-bottom: 1.5rem !important;\n        }\n        .pb-lg-5 {\n            padding-bottom: 3rem !important;\n        }\n        .ps-lg-0 {\n            padding-left: 0 !important;\n        }\n        .ps-lg-1 {\n            padding-left: 0.25rem !important;\n        }\n        .ps-lg-2 {\n            padding-left: 0.5rem !important;\n        }\n        .ps-lg-3 {\n            padding-left: 1rem !important;\n        }\n        .ps-lg-4 {\n            padding-left: 1.5rem !important;\n        }\n        .ps-lg-5 {\n            padding-left: 3rem !important;\n        }\n        .gap-lg-0 {\n            gap: 0 !important;\n        }\n        .gap-lg-1 {\n            gap: 0.25rem !important;\n        }\n        .gap-lg-2 {\n            gap: 0.5rem !important;\n        }\n        .gap-lg-3 {\n            gap: 1rem !important;\n        }\n        .gap-lg-4 {\n            gap: 1.5rem !important;\n        }\n        .gap-lg-5 {\n            gap: 3rem !important;\n        }\n        .row-gap-lg-0 {\n            row-gap: 0 !important;\n        }\n        .row-gap-lg-1 {\n            row-gap: 0.25rem !important;\n        }\n        .row-gap-lg-2 {\n            row-gap: 0.5rem !important;\n        }\n        .row-gap-lg-3 {\n            row-gap: 1rem !important;\n        }\n        .row-gap-lg-4 {\n            row-gap: 1.5rem !important;\n        }\n        .row-gap-lg-5 {\n            row-gap: 3rem !important;\n        }\n        .column-gap-lg-0 {\n            -moz-column-gap: 0 !important;\n            column-gap: 0 !important;\n        }\n        .column-gap-lg-1 {\n            -moz-column-gap: 0.25rem !important;\n            column-gap: 0.25rem !important;\n        }\n        .column-gap-lg-2 {\n            -moz-column-gap: 0.5rem !important;\n            column-gap: 0.5rem !important;\n        }\n        .column-gap-lg-3 {\n            -moz-column-gap: 1rem !important;\n            column-gap: 1rem !important;\n        }\n        .column-gap-lg-4 {\n            -moz-column-gap: 1.5rem !important;\n            column-gap: 1.5rem !important;\n        }\n        .column-gap-lg-5 {\n            -moz-column-gap: 3rem !important;\n            column-gap: 3rem !important;\n        }\n        .text-lg-start {\n            text-align: left !important;\n        }\n        .text-lg-end {\n            text-align: right !important;\n        }\n        .text-lg-center {\n            text-align: center !important;\n        }\n    }\n    @media (min-width: 1200px) {\n        .float-xl-start {\n            float: left !important;\n        }\n        .float-xl-end {\n            float: right !important;\n        }\n        .float-xl-none {\n            float: none !important;\n        }\n        .object-fit-xl-contain {\n            -o-object-fit: contain !important;\n            object-fit: contain !important;\n        }\n        .object-fit-xl-cover {\n            -o-object-fit: cover !important;\n            object-fit: cover !important;\n        }\n        .object-fit-xl-fill {\n            -o-object-fit: fill !important;\n            object-fit: fill !important;\n        }\n        .object-fit-xl-scale {\n            -o-object-fit: scale-down !important;\n            object-fit: scale-down !important;\n        }\n        .object-fit-xl-none {\n            -o-object-fit: none !important;\n            object-fit: none !important;\n        }\n        .d-xl-inline {\n            display: inline !important;\n        }\n        .d-xl-inline-block {\n            display: inline-block !important;\n        }\n        .d-xl-block {\n            display: block !important;\n        }\n        .d-xl-grid {\n            display: grid !important;\n        }\n        .d-xl-inline-grid {\n            display: inline-grid !important;\n        }\n        .d-xl-table {\n            display: table !important;\n        }\n        .d-xl-table-row {\n            display: table-row !important;\n        }\n        .d-xl-table-cell {\n            display: table-cell !important;\n        }\n        .d-xl-flex {\n            display: flex !important;\n        }\n        .d-xl-inline-flex {\n            display: inline-flex !important;\n        }\n        .d-xl-none {\n            display: none !important;\n        }\n        .flex-xl-fill {\n            flex: 1 1 auto !important;\n        }\n        .flex-xl-row {\n            flex-direction: row !important;\n        }\n        .flex-xl-column {\n            flex-direction: column !important;\n        }\n        .flex-xl-row-reverse {\n            flex-direction: row-reverse !important;\n        }\n        .flex-xl-column-reverse {\n            flex-direction: column-reverse !important;\n        }\n        .flex-xl-grow-0 {\n            flex-grow: 0 !important;\n        }\n        .flex-xl-grow-1 {\n            flex-grow: 1 !important;\n        }\n        .flex-xl-shrink-0 {\n            flex-shrink: 0 !important;\n        }\n        .flex-xl-shrink-1 {\n            flex-shrink: 1 !important;\n        }\n        .flex-xl-wrap {\n            flex-wrap: wrap !important;\n        }\n        .flex-xl-nowrap {\n            flex-wrap: nowrap !important;\n        }\n        .flex-xl-wrap-reverse {\n            flex-wrap: wrap-reverse !important;\n        }\n        .justify-content-xl-start {\n            justify-content: flex-start !important;\n        }\n        .justify-content-xl-end {\n            justify-content: flex-end !important;\n        }\n        .justify-content-xl-center {\n            justify-content: center !important;\n        }\n        .justify-content-xl-between {\n            justify-content: space-between !important;\n        }\n        .justify-content-xl-around {\n            justify-content: space-around !important;\n        }\n        .justify-content-xl-evenly {\n            justify-content: space-evenly !important;\n        }\n        .align-items-xl-start {\n            align-items: flex-start !important;\n        }\n        .align-items-xl-end {\n            align-items: flex-end !important;\n        }\n        .align-items-xl-center {\n            align-items: center !important;\n        }\n        .align-items-xl-baseline {\n            align-items: baseline !important;\n        }\n        .align-items-xl-stretch {\n            align-items: stretch !important;\n        }\n        .align-content-xl-start {\n            align-content: flex-start !important;\n        }\n        .align-content-xl-end {\n            align-content: flex-end !important;\n        }\n        .align-content-xl-center {\n            align-content: center !important;\n        }\n        .align-content-xl-between {\n            align-content: space-between !important;\n        }\n        .align-content-xl-around {\n            align-content: space-around !important;\n        }\n        .align-content-xl-stretch {\n            align-content: stretch !important;\n        }\n        .align-self-xl-auto {\n            align-self: auto !important;\n        }\n        .align-self-xl-start {\n            align-self: flex-start !important;\n        }\n        .align-self-xl-end {\n            align-self: flex-end !important;\n        }\n        .align-self-xl-center {\n            align-self: center !important;\n        }\n        .align-self-xl-baseline {\n            align-self: baseline !important;\n        }\n        .align-self-xl-stretch {\n            align-self: stretch !important;\n        }\n        .order-xl-first {\n            order: -1 !important;\n        }\n        .order-xl-0 {\n            order: 0 !important;\n        }\n        .order-xl-1 {\n            order: 1 !important;\n        }\n        .order-xl-2 {\n            order: 2 !important;\n        }\n        .order-xl-3 {\n            order: 3 !important;\n        }\n        .order-xl-4 {\n            order: 4 !important;\n        }\n        .order-xl-5 {\n            order: 5 !important;\n        }\n        .order-xl-last {\n            order: 6 !important;\n        }\n        .m-xl-0 {\n            margin: 0 !important;\n        }\n        .m-xl-1 {\n            margin: 0.25rem !important;\n        }\n        .m-xl-2 {\n            margin: 0.5rem !important;\n        }\n        .m-xl-3 {\n            margin: 1rem !important;\n        }\n        .m-xl-4 {\n            margin: 1.5rem !important;\n        }\n        .m-xl-5 {\n            margin: 3rem !important;\n        }\n        .m-xl-auto {\n            margin: auto !important;\n        }\n        .mx-xl-0 {\n            margin-right: 0 !important;\n            margin-left: 0 !important;\n        }\n        .mx-xl-1 {\n            margin-right: 0.25rem !important;\n            margin-left: 0.25rem !important;\n        }\n        .mx-xl-2 {\n            margin-right: 0.5rem !important;\n            margin-left: 0.5rem !important;\n        }\n        .mx-xl-3 {\n            margin-right: 1rem !important;\n            margin-left: 1rem !important;\n        }\n        .mx-xl-4 {\n            margin-right: 1.5rem !important;\n            margin-left: 1.5rem !important;\n        }\n        .mx-xl-5 {\n            margin-right: 3rem !important;\n            margin-left: 3rem !important;\n        }\n        .mx-xl-auto {\n            margin-right: auto !important;\n            margin-left: auto !important;\n        }\n        .my-xl-0 {\n            margin-top: 0 !important;\n            margin-bottom: 0 !important;\n        }\n        .my-xl-1 {\n            margin-top: 0.25rem !important;\n            margin-bottom: 0.25rem !important;\n        }\n        .my-xl-2 {\n            margin-top: 0.5rem !important;\n            margin-bottom: 0.5rem !important;\n        }\n        .my-xl-3 {\n            margin-top: 1rem !important;\n            margin-bottom: 1rem !important;\n        }\n        .my-xl-4 {\n            margin-top: 1.5rem !important;\n            margin-bottom: 1.5rem !important;\n        }\n        .my-xl-5 {\n            margin-top: 3rem !important;\n            margin-bottom: 3rem !important;\n        }\n        .my-xl-auto {\n            margin-top: auto !important;\n            margin-bottom: auto !important;\n        }\n        .mt-xl-0 {\n            margin-top: 0 !important;\n        }\n        .mt-xl-1 {\n            margin-top: 0.25rem !important;\n        }\n        .mt-xl-2 {\n            margin-top: 0.5rem !important;\n        }\n        .mt-xl-3 {\n            margin-top: 1rem !important;\n        }\n        .mt-xl-4 {\n            margin-top: 1.5rem !important;\n        }\n        .mt-xl-5 {\n            margin-top: 3rem !important;\n        }\n        .mt-xl-auto {\n            margin-top: auto !important;\n        }\n        .me-xl-0 {\n            margin-right: 0 !important;\n        }\n        .me-xl-1 {\n            margin-right: 0.25rem !important;\n        }\n        .me-xl-2 {\n            margin-right: 0.5rem !important;\n        }\n        .me-xl-3 {\n            margin-right: 1rem !important;\n        }\n        .me-xl-4 {\n            margin-right: 1.5rem !important;\n        }\n        .me-xl-5 {\n            margin-right: 3rem !important;\n        }\n        .me-xl-auto {\n            margin-right: auto !important;\n        }\n        .mb-xl-0 {\n            margin-bottom: 0 !important;\n        }\n        .mb-xl-1 {\n            margin-bottom: 0.25rem !important;\n        }\n        .mb-xl-2 {\n            margin-bottom: 0.5rem !important;\n        }\n        .mb-xl-3 {\n            margin-bottom: 1rem !important;\n        }\n        .mb-xl-4 {\n            margin-bottom: 1.5rem !important;\n        }\n        .mb-xl-5 {\n            margin-bottom: 3rem !important;\n        }\n        .mb-xl-auto {\n            margin-bottom: auto !important;\n        }\n        .ms-xl-0 {\n            margin-left: 0 !important;\n        }\n        .ms-xl-1 {\n            margin-left: 0.25rem !important;\n        }\n        .ms-xl-2 {\n            margin-left: 0.5rem !important;\n        }\n        .ms-xl-3 {\n            margin-left: 1rem !important;\n        }\n        .ms-xl-4 {\n            margin-left: 1.5rem !important;\n        }\n        .ms-xl-5 {\n            margin-left: 3rem !important;\n        }\n        .ms-xl-auto {\n            margin-left: auto !important;\n        }\n        .p-xl-0 {\n            padding: 0 !important;\n        }\n        .p-xl-1 {\n            padding: 0.25rem !important;\n        }\n        .p-xl-2 {\n            padding: 0.5rem !important;\n        }\n        .p-xl-3 {\n            padding: 1rem !important;\n        }\n        .p-xl-4 {\n            padding: 1.5rem !important;\n        }\n        .p-xl-5 {\n            padding: 3rem !important;\n        }\n        .px-xl-0 {\n            padding-right: 0 !important;\n            padding-left: 0 !important;\n        }\n        .px-xl-1 {\n            padding-right: 0.25rem !important;\n            padding-left: 0.25rem !important;\n        }\n        .px-xl-2 {\n            padding-right: 0.5rem !important;\n            padding-left: 0.5rem !important;\n        }\n        .px-xl-3 {\n            padding-right: 1rem !important;\n            padding-left: 1rem !important;\n        }\n        .px-xl-4 {\n            padding-right: 1.5rem !important;\n            padding-left: 1.5rem !important;\n        }\n        .px-xl-5 {\n            padding-right: 3rem !important;\n            padding-left: 3rem !important;\n        }\n        .py-xl-0 {\n            padding-top: 0 !important;\n            padding-bottom: 0 !important;\n        }\n        .py-xl-1 {\n            padding-top: 0.25rem !important;\n            padding-bottom: 0.25rem !important;\n        }\n        .py-xl-2 {\n            padding-top: 0.5rem !important;\n            padding-bottom: 0.5rem !important;\n        }\n        .py-xl-3 {\n            padding-top: 1rem !important;\n            padding-bottom: 1rem !important;\n        }\n        .py-xl-4 {\n            padding-top: 1.5rem !important;\n            padding-bottom: 1.5rem !important;\n        }\n        .py-xl-5 {\n            padding-top: 3rem !important;\n            padding-bottom: 3rem !important;\n        }\n        .pt-xl-0 {\n            padding-top: 0 !important;\n        }\n        .pt-xl-1 {\n            padding-top: 0.25rem !important;\n        }\n        .pt-xl-2 {\n            padding-top: 0.5rem !important;\n        }\n        .pt-xl-3 {\n            padding-top: 1rem !important;\n        }\n        .pt-xl-4 {\n            padding-top: 1.5rem !important;\n        }\n        .pt-xl-5 {\n            padding-top: 3rem !important;\n        }\n        .pe-xl-0 {\n            padding-right: 0 !important;\n        }\n        .pe-xl-1 {\n            padding-right: 0.25rem !important;\n        }\n        .pe-xl-2 {\n            padding-right: 0.5rem !important;\n        }\n        .pe-xl-3 {\n            padding-right: 1rem !important;\n        }\n        .pe-xl-4 {\n            padding-right: 1.5rem !important;\n        }\n        .pe-xl-5 {\n            padding-right: 3rem !important;\n        }\n        .pb-xl-0 {\n            padding-bottom: 0 !important;\n        }\n        .pb-xl-1 {\n            padding-bottom: 0.25rem !important;\n        }\n        .pb-xl-2 {\n            padding-bottom: 0.5rem !important;\n        }\n        .pb-xl-3 {\n            padding-bottom: 1rem !important;\n        }\n        .pb-xl-4 {\n            padding-bottom: 1.5rem !important;\n        }\n        .pb-xl-5 {\n            padding-bottom: 3rem !important;\n        }\n        .ps-xl-0 {\n            padding-left: 0 !important;\n        }\n        .ps-xl-1 {\n            padding-left: 0.25rem !important;\n        }\n        .ps-xl-2 {\n            padding-left: 0.5rem !important;\n        }\n        .ps-xl-3 {\n            padding-left: 1rem !important;\n        }\n        .ps-xl-4 {\n            padding-left: 1.5rem !important;\n        }\n        .ps-xl-5 {\n            padding-left: 3rem !important;\n        }\n        .gap-xl-0 {\n            gap: 0 !important;\n        }\n        .gap-xl-1 {\n            gap: 0.25rem !important;\n        }\n        .gap-xl-2 {\n            gap: 0.5rem !important;\n        }\n        .gap-xl-3 {\n            gap: 1rem !important;\n        }\n        .gap-xl-4 {\n            gap: 1.5rem !important;\n        }\n        .gap-xl-5 {\n            gap: 3rem !important;\n        }\n        .row-gap-xl-0 {\n            row-gap: 0 !important;\n        }\n        .row-gap-xl-1 {\n            row-gap: 0.25rem !important;\n        }\n        .row-gap-xl-2 {\n            row-gap: 0.5rem !important;\n        }\n        .row-gap-xl-3 {\n            row-gap: 1rem !important;\n        }\n        .row-gap-xl-4 {\n            row-gap: 1.5rem !important;\n        }\n        .row-gap-xl-5 {\n            row-gap: 3rem !important;\n        }\n        .column-gap-xl-0 {\n            -moz-column-gap: 0 !important;\n            column-gap: 0 !important;\n        }\n        .column-gap-xl-1 {\n            -moz-column-gap: 0.25rem !important;\n            column-gap: 0.25rem !important;\n        }\n        .column-gap-xl-2 {\n            -moz-column-gap: 0.5rem !important;\n            column-gap: 0.5rem !important;\n        }\n        .column-gap-xl-3 {\n            -moz-column-gap: 1rem !important;\n            column-gap: 1rem !important;\n        }\n        .column-gap-xl-4 {\n            -moz-column-gap: 1.5rem !important;\n            column-gap: 1.5rem !important;\n        }\n        .column-gap-xl-5 {\n            -moz-column-gap: 3rem !important;\n            column-gap: 3rem !important;\n        }\n        .text-xl-start {\n            text-align: left !important;\n        }\n        .text-xl-end {\n            text-align: right !important;\n        }\n        .text-xl-center {\n            text-align: center !important;\n        }\n    }\n    @media (min-width: 1400px) {\n        .float-xxl-start {\n            float: left !important;\n        }\n        .float-xxl-end {\n            float: right !important;\n        }\n        .float-xxl-none {\n            float: none !important;\n        }\n        .object-fit-xxl-contain {\n            -o-object-fit: contain !important;\n            object-fit: contain !important;\n        }\n        .object-fit-xxl-cover {\n            -o-object-fit: cover !important;\n            object-fit: cover !important;\n        }\n        .object-fit-xxl-fill {\n            -o-object-fit: fill !important;\n            object-fit: fill !important;\n        }\n        .object-fit-xxl-scale {\n            -o-object-fit: scale-down !important;\n            object-fit: scale-down !important;\n        }\n        .object-fit-xxl-none {\n            -o-object-fit: none !important;\n            object-fit: none !important;\n        }\n        .d-xxl-inline {\n            display: inline !important;\n        }\n        .d-xxl-inline-block {\n            display: inline-block !important;\n        }\n        .d-xxl-block {\n            display: block !important;\n        }\n        .d-xxl-grid {\n            display: grid !important;\n        }\n        .d-xxl-inline-grid {\n            display: inline-grid !important;\n        }\n        .d-xxl-table {\n            display: table !important;\n        }\n        .d-xxl-table-row {\n            display: table-row !important;\n        }\n        .d-xxl-table-cell {\n            display: table-cell !important;\n        }\n        .d-xxl-flex {\n            display: flex !important;\n        }\n        .d-xxl-inline-flex {\n            display: inline-flex !important;\n        }\n        .d-xxl-none {\n            display: none !important;\n        }\n        .flex-xxl-fill {\n            flex: 1 1 auto !important;\n        }\n        .flex-xxl-row {\n            flex-direction: row !important;\n        }\n        .flex-xxl-column {\n            flex-direction: column !important;\n        }\n        .flex-xxl-row-reverse {\n            flex-direction: row-reverse !important;\n        }\n        .flex-xxl-column-reverse {\n            flex-direction: column-reverse !important;\n        }\n        .flex-xxl-grow-0 {\n            flex-grow: 0 !important;\n        }\n        .flex-xxl-grow-1 {\n            flex-grow: 1 !important;\n        }\n        .flex-xxl-shrink-0 {\n            flex-shrink: 0 !important;\n        }\n        .flex-xxl-shrink-1 {\n            flex-shrink: 1 !important;\n        }\n        .flex-xxl-wrap {\n            flex-wrap: wrap !important;\n        }\n        .flex-xxl-nowrap {\n            flex-wrap: nowrap !important;\n        }\n        .flex-xxl-wrap-reverse {\n            flex-wrap: wrap-reverse !important;\n        }\n        .justify-content-xxl-start {\n            justify-content: flex-start !important;\n        }\n        .justify-content-xxl-end {\n            justify-content: flex-end !important;\n        }\n        .justify-content-xxl-center {\n            justify-content: center !important;\n        }\n        .justify-content-xxl-between {\n            justify-content: space-between !important;\n        }\n        .justify-content-xxl-around {\n            justify-content: space-around !important;\n        }\n        .justify-content-xxl-evenly {\n            justify-content: space-evenly !important;\n        }\n        .align-items-xxl-start {\n            align-items: flex-start !important;\n        }\n        .align-items-xxl-end {\n            align-items: flex-end !important;\n        }\n        .align-items-xxl-center {\n            align-items: center !important;\n        }\n        .align-items-xxl-baseline {\n            align-items: baseline !important;\n        }\n        .align-items-xxl-stretch {\n            align-items: stretch !important;\n        }\n        .align-content-xxl-start {\n            align-content: flex-start !important;\n        }\n        .align-content-xxl-end {\n            align-content: flex-end !important;\n        }\n        .align-content-xxl-center {\n            align-content: center !important;\n        }\n        .align-content-xxl-between {\n            align-content: space-between !important;\n        }\n        .align-content-xxl-around {\n            align-content: space-around !important;\n        }\n        .align-content-xxl-stretch {\n            align-content: stretch !important;\n        }\n        .align-self-xxl-auto {\n            align-self: auto !important;\n        }\n        .align-self-xxl-start {\n            align-self: flex-start !important;\n        }\n        .align-self-xxl-end {\n            align-self: flex-end !important;\n        }\n        .align-self-xxl-center {\n            align-self: center !important;\n        }\n        .align-self-xxl-baseline {\n            align-self: baseline !important;\n        }\n        .align-self-xxl-stretch {\n            align-self: stretch !important;\n        }\n        .order-xxl-first {\n            order: -1 !important;\n        }\n        .order-xxl-0 {\n            order: 0 !important;\n        }\n        .order-xxl-1 {\n            order: 1 !important;\n        }\n        .order-xxl-2 {\n            order: 2 !important;\n        }\n        .order-xxl-3 {\n            order: 3 !important;\n        }\n        .order-xxl-4 {\n            order: 4 !important;\n        }\n        .order-xxl-5 {\n            order: 5 !important;\n        }\n        .order-xxl-last {\n            order: 6 !important;\n        }\n        .m-xxl-0 {\n            margin: 0 !important;\n        }\n        .m-xxl-1 {\n            margin: 0.25rem !important;\n        }\n        .m-xxl-2 {\n            margin: 0.5rem !important;\n        }\n        .m-xxl-3 {\n            margin: 1rem !important;\n        }\n        .m-xxl-4 {\n            margin: 1.5rem !important;\n        }\n        .m-xxl-5 {\n            margin: 3rem !important;\n        }\n        .m-xxl-auto {\n            margin: auto !important;\n        }\n        .mx-xxl-0 {\n            margin-right: 0 !important;\n            margin-left: 0 !important;\n        }\n        .mx-xxl-1 {\n            margin-right: 0.25rem !important;\n            margin-left: 0.25rem !important;\n        }\n        .mx-xxl-2 {\n            margin-right: 0.5rem !important;\n            margin-left: 0.5rem !important;\n        }\n        .mx-xxl-3 {\n            margin-right: 1rem !important;\n            margin-left: 1rem !important;\n        }\n        .mx-xxl-4 {\n            margin-right: 1.5rem !important;\n            margin-left: 1.5rem !important;\n        }\n        .mx-xxl-5 {\n            margin-right: 3rem !important;\n            margin-left: 3rem !important;\n        }\n        .mx-xxl-auto {\n            margin-right: auto !important;\n            margin-left: auto !important;\n        }\n        .my-xxl-0 {\n            margin-top: 0 !important;\n            margin-bottom: 0 !important;\n        }\n        .my-xxl-1 {\n            margin-top: 0.25rem !important;\n            margin-bottom: 0.25rem !important;\n        }\n        .my-xxl-2 {\n            margin-top: 0.5rem !important;\n            margin-bottom: 0.5rem !important;\n        }\n        .my-xxl-3 {\n            margin-top: 1rem !important;\n            margin-bottom: 1rem !important;\n        }\n        .my-xxl-4 {\n            margin-top: 1.5rem !important;\n            margin-bottom: 1.5rem !important;\n        }\n        .my-xxl-5 {\n            margin-top: 3rem !important;\n            margin-bottom: 3rem !important;\n        }\n        .my-xxl-auto {\n            margin-top: auto !important;\n            margin-bottom: auto !important;\n        }\n        .mt-xxl-0 {\n            margin-top: 0 !important;\n        }\n        .mt-xxl-1 {\n            margin-top: 0.25rem !important;\n        }\n        .mt-xxl-2 {\n            margin-top: 0.5rem !important;\n        }\n        .mt-xxl-3 {\n            margin-top: 1rem !important;\n        }\n        .mt-xxl-4 {\n            margin-top: 1.5rem !important;\n        }\n        .mt-xxl-5 {\n            margin-top: 3rem !important;\n        }\n        .mt-xxl-auto {\n            margin-top: auto !important;\n        }\n        .me-xxl-0 {\n            margin-right: 0 !important;\n        }\n        .me-xxl-1 {\n            margin-right: 0.25rem !important;\n        }\n        .me-xxl-2 {\n            margin-right: 0.5rem !important;\n        }\n        .me-xxl-3 {\n            margin-right: 1rem !important;\n        }\n        .me-xxl-4 {\n            margin-right: 1.5rem !important;\n        }\n        .me-xxl-5 {\n            margin-right: 3rem !important;\n        }\n        .me-xxl-auto {\n            margin-right: auto !important;\n        }\n        .mb-xxl-0 {\n            margin-bottom: 0 !important;\n        }\n        .mb-xxl-1 {\n            margin-bottom: 0.25rem !important;\n        }\n        .mb-xxl-2 {\n            margin-bottom: 0.5rem !important;\n        }\n        .mb-xxl-3 {\n            margin-bottom: 1rem !important;\n        }\n        .mb-xxl-4 {\n            margin-bottom: 1.5rem !important;\n        }\n        .mb-xxl-5 {\n            margin-bottom: 3rem !important;\n        }\n        .mb-xxl-auto {\n            margin-bottom: auto !important;\n        }\n        .ms-xxl-0 {\n            margin-left: 0 !important;\n        }\n        .ms-xxl-1 {\n            margin-left: 0.25rem !important;\n        }\n        .ms-xxl-2 {\n            margin-left: 0.5rem !important;\n        }\n        .ms-xxl-3 {\n            margin-left: 1rem !important;\n        }\n        .ms-xxl-4 {\n            margin-left: 1.5rem !important;\n        }\n        .ms-xxl-5 {\n            margin-left: 3rem !important;\n        }\n        .ms-xxl-auto {\n            margin-left: auto !important;\n        }\n        .p-xxl-0 {\n            padding: 0 !important;\n        }\n        .p-xxl-1 {\n            padding: 0.25rem !important;\n        }\n        .p-xxl-2 {\n            padding: 0.5rem !important;\n        }\n        .p-xxl-3 {\n            padding: 1rem !important;\n        }\n        .p-xxl-4 {\n            padding: 1.5rem !important;\n        }\n        .p-xxl-5 {\n            padding: 3rem !important;\n        }\n        .px-xxl-0 {\n            padding-right: 0 !important;\n            padding-left: 0 !important;\n        }\n        .px-xxl-1 {\n            padding-right: 0.25rem !important;\n            padding-left: 0.25rem !important;\n        }\n        .px-xxl-2 {\n            padding-right: 0.5rem !important;\n            padding-left: 0.5rem !important;\n        }\n        .px-xxl-3 {\n            padding-right: 1rem !important;\n            padding-left: 1rem !important;\n        }\n        .px-xxl-4 {\n            padding-right: 1.5rem !important;\n            padding-left: 1.5rem !important;\n        }\n        .px-xxl-5 {\n            padding-right: 3rem !important;\n            padding-left: 3rem !important;\n        }\n        .py-xxl-0 {\n            padding-top: 0 !important;\n            padding-bottom: 0 !important;\n        }\n        .py-xxl-1 {\n            padding-top: 0.25rem !important;\n            padding-bottom: 0.25rem !important;\n        }\n        .py-xxl-2 {\n            padding-top: 0.5rem !important;\n            padding-bottom: 0.5rem !important;\n        }\n        .py-xxl-3 {\n            padding-top: 1rem !important;\n            padding-bottom: 1rem !important;\n        }\n        .py-xxl-4 {\n            padding-top: 1.5rem !important;\n            padding-bottom: 1.5rem !important;\n        }\n        .py-xxl-5 {\n            padding-top: 3rem !important;\n            padding-bottom: 3rem !important;\n        }\n        .pt-xxl-0 {\n            padding-top: 0 !important;\n        }\n        .pt-xxl-1 {\n            padding-top: 0.25rem !important;\n        }\n        .pt-xxl-2 {\n            padding-top: 0.5rem !important;\n        }\n        .pt-xxl-3 {\n            padding-top: 1rem !important;\n        }\n        .pt-xxl-4 {\n            padding-top: 1.5rem !important;\n        }\n        .pt-xxl-5 {\n            padding-top: 3rem !important;\n        }\n        .pe-xxl-0 {\n            padding-right: 0 !important;\n        }\n        .pe-xxl-1 {\n            padding-right: 0.25rem !important;\n        }\n        .pe-xxl-2 {\n            padding-right: 0.5rem !important;\n        }\n        .pe-xxl-3 {\n            padding-right: 1rem !important;\n        }\n        .pe-xxl-4 {\n            padding-right: 1.5rem !important;\n        }\n        .pe-xxl-5 {\n            padding-right: 3rem !important;\n        }\n        .pb-xxl-0 {\n            padding-bottom: 0 !important;\n        }\n        .pb-xxl-1 {\n            padding-bottom: 0.25rem !important;\n        }\n        .pb-xxl-2 {\n            padding-bottom: 0.5rem !important;\n        }\n        .pb-xxl-3 {\n            padding-bottom: 1rem !important;\n        }\n        .pb-xxl-4 {\n            padding-bottom: 1.5rem !important;\n        }\n        .pb-xxl-5 {\n            padding-bottom: 3rem !important;\n        }\n        .ps-xxl-0 {\n            padding-left: 0 !important;\n        }\n        .ps-xxl-1 {\n            padding-left: 0.25rem !important;\n        }\n        .ps-xxl-2 {\n            padding-left: 0.5rem !important;\n        }\n        .ps-xxl-3 {\n            padding-left: 1rem !important;\n        }\n        .ps-xxl-4 {\n            padding-left: 1.5rem !important;\n        }\n        .ps-xxl-5 {\n            padding-left: 3rem !important;\n        }\n        .gap-xxl-0 {\n            gap: 0 !important;\n        }\n        .gap-xxl-1 {\n            gap: 0.25rem !important;\n        }\n        .gap-xxl-2 {\n            gap: 0.5rem !important;\n        }\n        .gap-xxl-3 {\n            gap: 1rem !important;\n        }\n        .gap-xxl-4 {\n            gap: 1.5rem !important;\n        }\n        .gap-xxl-5 {\n            gap: 3rem !important;\n        }\n        .row-gap-xxl-0 {\n            row-gap: 0 !important;\n        }\n        .row-gap-xxl-1 {\n            row-gap: 0.25rem !important;\n        }\n        .row-gap-xxl-2 {\n            row-gap: 0.5rem !important;\n        }\n        .row-gap-xxl-3 {\n            row-gap: 1rem !important;\n        }\n        .row-gap-xxl-4 {\n            row-gap: 1.5rem !important;\n        }\n        .row-gap-xxl-5 {\n            row-gap: 3rem !important;\n        }\n        .column-gap-xxl-0 {\n            -moz-column-gap: 0 !important;\n            column-gap: 0 !important;\n        }\n        .column-gap-xxl-1 {\n            -moz-column-gap: 0.25rem !important;\n            column-gap: 0.25rem !important;\n        }\n        .column-gap-xxl-2 {\n            -moz-column-gap: 0.5rem !important;\n            column-gap: 0.5rem !important;\n        }\n        .column-gap-xxl-3 {\n            -moz-column-gap: 1rem !important;\n            column-gap: 1rem !important;\n        }\n        .column-gap-xxl-4 {\n            -moz-column-gap: 1.5rem !important;\n            column-gap: 1.5rem !important;\n        }\n        .column-gap-xxl-5 {\n            -moz-column-gap: 3rem !important;\n            column-gap: 3rem !important;\n        }\n        .text-xxl-start {\n            text-align: left !important;\n        }\n        .text-xxl-end {\n            text-align: right !important;\n        }\n        .text-xxl-center {\n            text-align: center !important;\n        }\n    }\n    @media (min-width: 1200px) {\n        .fs-1 {\n            font-size: 2.5rem !important;\n        }\n        .fs-2 {\n            font-size: 2rem !important;\n        }\n        .fs-3 {\n            font-size: 1.75rem !important;\n        }\n        .fs-4 {\n            font-size: 1.5rem !important;\n        }\n    }\n    @media print {\n        .d-print-inline {\n            display: inline !important;\n        }\n        .d-print-inline-block {\n            display: inline-block !important;\n        }\n        .d-print-block {\n            display: block !important;\n        }\n        .d-print-grid {\n            display: grid !important;\n        }\n        .d-print-inline-grid {\n            display: inline-grid !important;\n        }\n        .d-print-table {\n            display: table !important;\n        }\n        .d-print-table-row {\n            display: table-row !important;\n        }\n        .d-print-table-cell {\n            display: table-cell !important;\n        }\n        .d-print-flex {\n            display: flex !important;\n        }\n        .d-print-inline-flex {\n            display: inline-flex !important;\n        }\n        .d-print-none {\n            display: none !important;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
